webpackJsonp([32],{

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(486);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(1292);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),

/***/ 1238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(316);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(311);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(313);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(314);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(315);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1289);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(1278);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _context;

          this.removeCss = (_context = this.context).insertCss.apply(_context, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.removeCss) {
            setTimeout(this.removeCss, 0);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),

/***/ 1239:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(87)) === 'object' && __webpack_require__(87)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 1241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_locale__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          to = _this$props.to,
          locale = _this$props.locale;


      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (event.defaultPrevented === true) {
        return;
      }

      event.preventDefault();

      if (to) {
        __WEBPACK_IMPORTED_MODULE_3_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_4__helpers_locale__["h" /* toLocalized */](to, locale));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          locale = _props.locale,
          children = _props.children,
          elementRef = _props.elementRef,
          shouldSetNoIndex = _props.shouldSetNoIndex,
          dispatch = _props.dispatch,
          props = _objectWithoutProperties(_props, ['to', 'locale', 'children', 'elementRef', 'shouldSetNoIndex', 'dispatch']);

      var title = typeof children === 'string' ? children : '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({
          title: title,
          href: __WEBPACK_IMPORTED_MODULE_4__helpers_locale__["h" /* toLocalized */](to, locale)
        }, props, {
          ref: elementRef,
          onClick: this.handleClick
        }),
        children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.defaultProps = {
  shouldSetNoIndex: false,
  onClick: null,
  children: '',
  elementRef: undefined,
  dispatch: undefined,
  to: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (_ref2) {
  var locale = _ref2.globals.locale;
  return { locale: locale };
})(Link));

/***/ }),

/***/ 1242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withTranslate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var withTranslate = function withTranslate(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */]((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.t = function (string) {
        var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

        if (!string) {
          return '';
        }

        return _this.props.intl.formatMessage({ id: string }, values);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { t: this.t }));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withTranslate(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2));
};

/***/ }),

/***/ 1243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__payment__ = __webpack_require__(308);
var _business, _advert;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ADVERT_CLICK = 'clickAddAdButton_';
// const SERVICE = 'service';
var TARIFF_PLAN = 'tariffplan';
var SERVICE = 'service';
var TARIFF_PLAN_BUSINESS = 'tariffplan_business';
var SERVICE_BUSINESS = 'service_business';
var C2C_SLOT = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_SLOT,
    C2C_SINGLE = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_SINGLE,
    C2C_TURBO = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_TURBO,
    C2C_FAST = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_FAST;


var EVENTS = {
  MOBILE: {
    sendMessageToOwner: { event: 'sendlOwnerMessage_button' },
    registrationSuccess: { event: 'successRegistration' },
    adSent0: { event: 'clickAddAdButton_Free' },
    adSent1: { event: 'clickAddAdButton_109' },
    adSent2: { event: 'clickAddAdButton_199' },
    adSent3: { event: 'clickAddAdButton_299' },
    // Page types
    pageMain: { pageType: 'mainpage' },
    pageAdCard: { pageType: 'Ad_card' },
    pageDealer: { pageType: 'Dealer_Page' },
    pageSearch: { pageType: 'catalog' },
    pageAddAdvMainInfo: { pageType: 'Step 1' },
    pageAddAdvContactsPhoto: { pageType: 'Step 2' },
    pageAddAdvSellCar: { pageType: 'Step 3' },

    //
    pageDealers: { pageType: 'Dealers_Page' },
    pageProfile: { pageType: 'Profile_Page' },
    pageGeo: { pageType: 'Geo_Page' },
    pageFilters: { pageType: 'Filters_Page' },
    pageFavorites: { pageType: 'Favorites_Page' }
  },
  // Adverts
  AddCarNumberButton: { event: 'Add__NumberButton' },
  AddChooseBrand: { event: 'Add__ChooseBrand' },
  AddPhotoAdded: { event: 'Add__PhotoAdded' },
  AddPhotoDeleted: { event: 'Add__PhotoDeleted' },
  AddPhotoSort: { event: 'Add__PhotoSort' },
  AddSubmit: { event: 'Add__Submit' },
  AddSubmitFinal: { event: 'Add__SubmitFinall' },
  AddClearWarningMessageAndSubmit: { event: 'Add__SubmitAfterError' },
  AddSubmitForm: { event: 'Add__SubmitForm' },
  AddNextButtonCommon: { event: 'Add__NextButtonAll' },
  AddCommonPublishButton: { event: 'Add__PublishButtonAll' },
  // AddNextButton1: { event: 'Add__NextButton-1' },
  // AddNextButton2: { event: 'Add__NextButton-2' },
  // AddNextButton3: { event: 'Add__NextButton-3' },
  // AddNextButton4: { event: 'Add__NextButton-4' },

  AddCarBrandGroup: { event: 'AddCarBrandGroup' },
  freeAdSent: { event: 'freeAdSent' },
  turboAdvert: { event: ADVERT_CLICK + '333_Turbo' },
  fastAdvert: { event: ADVERT_CLICK + '198_Quick' },
  freeAll: { event: ADVERT_CLICK + '555_All' },
  freeUp: { event: ADVERT_CLICK + '105_Autopromotion' },
  freeVip: { event: ADVERT_CLICK + '225_VIP' },
  freeCol: { event: ADVERT_CLICK + '75_Colour' },
  freeTop: { event: ADVERT_CLICK + '150_TOP' },
  freeUpVipCol: { event: ADVERT_CLICK + '405_Auto+VIP+Colour' },
  freeUpVip: { event: ADVERT_CLICK + '330_Auto+VIP' },
  freeUpCol: { event: ADVERT_CLICK + '180_Auto+Colour' },
  freeUpTop: { event: ADVERT_CLICK + '150_Auto+Top' },
  freeUpTopCol: { event: ADVERT_CLICK + '225_Auto+Top+Colour' },
  freeVipVolTop: { event: ADVERT_CLICK + '450_VIP+Colour+Top' },
  freeVipCol: { event: ADVERT_CLICK + '300_Vip+Colour' },
  freeVipTop: { event: ADVERT_CLICK + '375_Vip+Top' },
  freeVipTopUp: { event: ADVERT_CLICK + '480_Vip+Top+Auto' },
  freeColTop: { event: ADVERT_CLICK + '225_Colour+Top' },
  //
  addToFavorites: { event: 'likeCar_button' },
  sellCarButtonClick: { event: 'sellCarr_Button' },
  seeReviews: { event: 'see_review_Button' },
  showPhoneClick: { event: 'showPhone_button' },
  sendTestDriveForm: { event: 'sendTestDrive_Form' },
  dealerSiteRedirect: { event: 'goDealerSite_Button' },
  showAllDealerAdverts: { event: 'showAllDealerCars_Button' },
  successLogin: { event: 'successRegistration' },
  callOwner: { event: 'callOwner_button' },
  searchButtonClick: { event: 'pressSearchButton' },
  paidAdSent: { event: 'paidAdSent' },
  advert: (_advert = {
    'balance-refill': { event: 'balance_refil' }
  }, _defineProperty(_advert, C2C_SLOT, { event: TARIFF_PLAN + '/4/' }), _defineProperty(_advert, 'sp-slot', { event: TARIFF_PLAN + '/25/' }), _defineProperty(_advert, C2C_SINGLE, { event: TARIFF_PLAN + '/31/' }), _defineProperty(_advert, 'update', { event: SERVICE + '/1/' }), _defineProperty(_advert, 'vip', { event: SERVICE + '/2/' }), _defineProperty(_advert, 'top', { event: SERVICE + '/4/' }), _defineProperty(_advert, 'color', { event: SERVICE + '/3/' }), _defineProperty(_advert, C2C_TURBO, { event: TARIFF_PLAN + '/6/' }), _defineProperty(_advert, C2C_FAST, { event: TARIFF_PLAN + '/5/' }), _defineProperty(_advert, 'b2c', { event: TARIFF_PLAN_BUSINESS + '/2/' }), _defineProperty(_advert, 'business', (_business = {}, _defineProperty(_business, C2C_SINGLE, { event: TARIFF_PLAN_BUSINESS + '/31/' }), _defineProperty(_business, 'b2c', { event: TARIFF_PLAN_BUSINESS + '/2/' }), _defineProperty(_business, 'update', { event: SERVICE_BUSINESS + '/1/' }), _defineProperty(_business, 'vip', { event: SERVICE_BUSINESS + '/2/' }), _defineProperty(_business, 'top', { event: SERVICE_BUSINESS + '/4/' }), _defineProperty(_business, 'color', { event: SERVICE_BUSINESS + '/3/' }), _defineProperty(_business, C2C_FAST, { event: TARIFF_PLAN_BUSINESS + '/5/' }), _defineProperty(_business, C2C_TURBO, { event: TARIFF_PLAN_BUSINESS + '/6/' }), _defineProperty(_business, 'spareparts-500', { event: TARIFF_PLAN_BUSINESS + '/7/' }), _defineProperty(_business, 'spareparts-1000', { event: TARIFF_PLAN_BUSINESS + '/8/' }), _defineProperty(_business, 'spareparts-2000', { event: TARIFF_PLAN_BUSINESS + '/9/' }), _defineProperty(_business, 'spareparts-3000', { event: TARIFF_PLAN_BUSINESS + '/10/' }), _defineProperty(_business, 'spareparts-unlim', { event: TARIFF_PLAN_BUSINESS + '/11/' }), _defineProperty(_business, 'spareparts-batch-update-20', { event: TARIFF_PLAN_BUSINESS + '/18/' }), _defineProperty(_business, 'spareparts-batch-update-35', { event: TARIFF_PLAN_BUSINESS + '/19/' }), _defineProperty(_business, 'spareparts-batch-update-70', { event: TARIFF_PLAN_BUSINESS + '/20/' }), _defineProperty(_business, 'spareparts-batch-update-100', { event: TARIFF_PLAN_BUSINESS + '/21/' }), _defineProperty(_business, 'spareparts-batch-update-150', { event: TARIFF_PLAN_BUSINESS + '/22/' }), _defineProperty(_business, 'spareparts-batch-update-200', { event: TARIFF_PLAN_BUSINESS + '/23/' }), _defineProperty(_business, 'spareparts-batch-update-400', { event: TARIFF_PLAN_BUSINESS + '/24/' }), _business)), _defineProperty(_advert, 'dealership', {
    'spareparts-500': { event: TARIFF_PLAN + '/7/' },
    'spareparts-1000': { event: TARIFF_PLAN + '/8/' },
    'spareparts-2000': { event: TARIFF_PLAN + '/9/' },
    'spareparts-3000': { event: TARIFF_PLAN + '/10/' },
    'spareparts-unlim': { event: TARIFF_PLAN + '/11/' },
    'spareparts-batch-update-20': { event: TARIFF_PLAN + '/18/' },
    'spareparts-batch-update-35': { event: TARIFF_PLAN + '/19/' },
    'spareparts-batch-update-70': { event: TARIFF_PLAN + '/20/' },
    'spareparts-batch-update-100': { event: TARIFF_PLAN + '/21/' },
    'spareparts-batch-update-150': { event: TARIFF_PLAN + '/22/' },
    'spareparts-batch-update-200': { event: TARIFF_PLAN + '/23/' },
    'spareparts-batch-update-400': { event: TARIFF_PLAN + '/24/' }
  }), _advert),
  leasing: {
    'data-lens-event': { event: 'leasingRequestClick' },
    'page-view': { event: 'leasingPageView' },

    // Automoney
    'automoney-monthly-calculation-show-form-click': {
      event: 'automoney-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'automoney-monthly-calculation-form-sumbit': {
      event: 'automoney-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'automoney-monthly-consultation-form-sumbit': {
      event: 'automoney-LeasingMonthly-Consultation-Form-Submit'
    },
    'automoney-questions-form-sumbit': { event: 'automoney-leasingMonthly-questions-Form-Submit' },
    'automoney-lead-create-success': { event: 'automoney-lead-created-success' },
    'automoney-lead-create-fail': { event: 'automoney-lead-create-fail' },
    'automoney-monthly-calculation-show-form-click-advertcard': {
      event: 'automoney-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'automoney-monthly-calculation-form-sumbit-advertcard': {
      event: 'automoney-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'automoney-monthly-consultation-form-sumbit-advertcard': {
      event: 'automoney-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    'automoney-lead-create-success-advertcard': {
      event: 'automoney-myauto-lead-create-success-advertCard'
    },
    'automoney-lead-create-fail-advertcard': {
      event: 'automoney-myauto-lead-create-fail-advertCard'
    },

    // Microcredit
    'microcredit-consultation-show-form-click': {
      event: 'microcredit-Consultation-Show-Form-Click'
    },
    'microcredit-consultation-form-sumbit': { event: 'microcredit-Consultation-Form-Submit' },
    'microcredit-lead-create-success': { event: 'microcredit-lead-created-success' },
    'microcredit-lead-create-fail': { event: 'microcredit-lead-create-fail' },

    'microcredit-consultation-show-form-click-advertcard': {
      event: 'microcredit-Consultation-Show-Form-Click-advertCard'
    },
    'microcredit-consultation-form-sumbit-advertcard': {
      event: 'microcredit-Consultation-Form-Submit-advertCard'
    },
    'microcredit-lead-create-success-advertcard': {
      event: 'microcredit-lead-created-success-advertCard'
    },
    'microcredit-lead-create-fail-advertcard': { event: 'microcredit-lead-create-fail-advertCard' },

    // Creditmarket
    'creditmarket-consultation-show-form-click': {
      event: 'creditmarket-Consultation-Show-Form-Click'
    },
    'creditmarket-consultation-form-sumbit': { event: 'creditmarket-Consultation-Form-Submit' },
    'creditmarket-lead-create-success': { event: 'creditmarket-lead-created-success' },
    'creditmarket-lead-create-fail': { event: 'creditmarket-lead-create-fail' },

    'creditmarket-consultation-show-form-click-advertcard': {
      event: 'creditmarket-Consultation-Show-Form-Click-advertCard'
    },
    'creditmarket-consultation-form-sumbit-advertcard': {
      event: 'creditmarket-Consultation-Form-Submit-advertCard'
    },
    'creditmarket-lead-create-success-advertcard': {
      event: 'creditmarket-lead-created-success-advertCard'
    },
    'creditmarket-lead-create-fail-advertcard': {
      event: 'creditmarket-lead-create-fail-advertCard'
    },
    'creditmarket-questions-form-sumbit': {
      event: 'creditmarket-leasingMonthly-questions-Form-Submit'
    },

    // MyAuto
    'monthly-calculation-show-form-click': { event: 'leasingMonthly-Calculation-Show-Form-Click' },
    'monthly-calculation-form-sumbit': { event: 'leasingMonthly-Calculation-Form-Sumbit' },
    'monthly-consultation-form-sumbit': { event: 'leasingMonthly-Consultation-Form-Submit' },
    'questions-form-sumbit': { event: 'leasingMonthly-questions-Form-Submit' },
    'lead-create-success-questions': { event: 'lead-create-success-questions' },
    'lead-create-fail-questions': { event: 'lead-create-fail-questions' },
    'lead-create-success': { event: 'lead-create-success' },
    'lead-create-fail': { event: 'lead-create-fail' },
    'monthly-calculation-show-form-click-advertcard': {
      event: 'leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'monthly-calculation-form-sumbit-advertcard': {
      event: 'leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'monthly-consultation-form-sumbit-advertcard': {
      event: 'leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'questions-form-sumbit-advertcard': { event: `leasingMonthly-questions-Form-Submit-advertCard` },
    'lead-create-success-advertcard': { event: 'lead-create-success-advertCard' },
    'lead-create-fail-advertcard': { event: 'lead-create-fail-advertCard' },
    'lead-create-success-advertcard-sidebar': { event: 'lead-create-success-advertCard-sidebar' },
    'lead-create-fail-advertcard-sidebar': { event: 'lead-create-fail-advertCard-sidebar' },

    // Hapai
    'hapai-monthly-calculation-show-form-click': {
      event: 'hapai-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'hapai-monthly-calculation-form-sumbit': {
      event: 'hapai-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'hapai-monthly-consultation-form-sumbit': {
      event: 'hapai-LeasingMonthly-Consultation-Form-Submit'
    },
    'hapai-questions-form-sumbit': { event: 'hapai-leasingMonthly-questions-Form-Submit' },
    'hapai-lead-create-success': { event: 'hapai-lead-created-success' },
    'hapai-lead-create-success-questions': { event: 'hapai-lead-create-success-questions' },
    'hapai-lead-create-fail-questions': { event: 'hapai-lead-create-fail-questions' },
    'hapai-lead-create-fail': { event: 'hapai-lead-create-fail' },
    'hapai-monthly-calculation-show-form-click-advertcard': {
      event: 'hapai-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'hapai-monthly-calculation-form-sumbit-advertcard': {
      event: 'hapai-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'hapai-monthly-consultation-form-sumbit-advertcard': {
      event: 'hapai-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'hapai-questions-form-sumbit-advertcard': { event: `hapai-leasingMonthly-questions-Form-Submit-advertCard` },
    'hapai-lead-create-success-advertcard': { event: 'hapai-lead-create-success-advertCard' },
    'hapai-lead-create-fail-advertcard': { event: 'hapai-lead-create-fail-advertCard' },
    'hapai-lead-create-success-advertcard-sidebar': {
      event: 'hapai-lead-create-success-advertCard-sidebar'
    },
    'hapai-lead-create-fail-advertcard-sidebar': {
      event: 'hapai-lead-create-fail-advertCard-sidebar'
    },

    // Ulf24
    'ulf24-monthly-calculation-show-form-click': {
      event: 'ulf24-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'ulf24-monthly-calculation-form-sumbit': {
      event: 'ulf24-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'ulf24-monthly-consultation-form-sumbit': {
      event: 'ulf24-LeasingMonthly-Consultation-Form-Submit'
    },
    'ulf24-questions-form-sumbit': { event: 'ulf24-leasingMonthly-questions-Form-Submit' },
    'ulf24-lead-create-success': { event: 'ulf24-lead-created-success' },
    'ulf24-lead-create-fail': { event: 'ulf24-lead-create-fail' },
    'ulf24-monthly-calculation-show-form-click-advertcard': {
      event: 'ulf24-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'ulf24-monthly-calculation-form-sumbit-advertcard': {
      event: 'ulf24-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'ulf24-monthly-consultation-form-sumbit-advertcard': {
      event: 'ulf24-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'ulf24-questions-form-sumbit-advertcard': { event: `ulf24-leasingMonthly-questions-Form-Submit-advertCard` },
    'ulf24-lead-create-success-advertcard': {
      event: 'ulf24-myauto-lead-create-success-advertCard'
    },
    'ulf24-lead-create-fail-advertcard': { event: 'ulf24-myauto-lead-create-fail-advertCard' },

    'ulf24-monthly-consultation-form-sumbit-advertcard-sidebar': {
      event: 'ulf24-leasingMonthly-Consultation-Form-Submit-advertCard-sidebar'
    },
    'ulf24-lead-create-success-advertcard-sidebar': {
      event: 'ulf24-lead-create-success-advertCard-sidebar'
    },
    'ulf24-lead-create-fail-advertcard-sidebar': {
      event: 'ulf24-lead-create-fail-advertCard-sidebar'
    },

    // Other events
    online: {
      'Popup-Used-Click': { event: 'leasingOnline-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingOnline-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingOnline-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingOnline-Sidebar-New-Click' },
      LinkUnderThePrice: { event: 'leasingOnline_LinkUnderThePrice' }
    },
    consultation: {
      'Popup-Used-Click': { event: 'leasingConsultation-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingConsultation-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingConsultation-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingConsultation-Sidebar-New-Click' },
      'Hapai-Popup-Used-Click': { event: 'hapai-leasingConsultation-Popup-Used-Click' },
      'Hapai-Popup-New-Click': { event: 'hapai-leasingConsultation-Popup-New-Click' },
      'Hapai-Sidebar-Used-Click': { event: 'hapai-leasingConsultation-Sidebar-Used-Click' },
      'Hapai-Sidebar-New-Click': { event: 'hapai-leasingConsultation-Sidebar-New-Click' },
      'Ulf24-Popup-Used-Click': { event: 'ulf24-leasingConsultation-Popup-Used-Click' },
      'Ulf24-Popup-New-Click': { event: 'ulf24-leasingConsultation-Popup-New-Click' },
      'Ulf24-Sidebar-Used-Click': { event: 'ulf24-leasingConsultation-Sidebar-Used-Click' },
      'Ulf24-Sidebar-New-Click': { event: 'ulf24-leasingConsultation-Sidebar-New-Click' }
    },

    codeVerification: {
      'Popup-Used-Click': { event: 'leasingOnlineCodeVerification-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingOnlineCodeVerification-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingOnlineCodeVerification-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingOnlineCodeVerification-Sidebar-New-Click' }
    }
  },

  NAVIGATION_LINK: {
    'headerNavigation/avto/avtosalony/': { event: 'avtosalony_nav_legkovye' },
    'headerNavigation/avtosalony/': { event: 'avtosalony_nav_avtosalony' },
    'headerNavigation/avtosalony/avtosalony/avto/': { event: 'avtosalony_nav_avtosalony_avto' },
    'subHeader/avtosalony/': { event: 'avtosalony_sub-nav_avtosalony' }
  },

  DEALERS: {
    showNubmer: { event: 'avtosalony_listing_show-nubmer' },
    testDrive: { event: 'avtosalony_listing_test-drive' },
    tradeIn: { event: 'avtosalony_listing_trade-in' },

    formTestDrive: { event: 'avtosalony_listing_form_test-drive' },
    formTradeIn: { event: 'avtosalony_listing_form_trade-in' }
  },

  DEALER_ADV: {
    showNubmer: { event: 'avtosalony_car_show-number' },
    tradeIn: { event: 'avtosalony_car_trade-in' },
    testDrive: { event: 'avtosalony_car_testDrive' },
    callback: { event: 'avtosalony_car_callback' },

    formTradeIn: { event: 'avtosalony_car_form_trade-in' },
    formTestDrive: { event: 'avtosalony_car_form_testDrive' },
    formCallback: { event: 'avtosalony_car_form_callback' }
  },

  DEALER_CARD: {
    showNubmer: { event: 'avtosalony_card_show-number' },
    goToSite: { event: 'avtosalony_card_site' },

    tradeIn: { event: 'avtosalony_card_trade-in' },
    testDrive: { event: 'avtosalony_card_test-drive' },

    formTradeIn: { event: 'avtosalony_card_form_trade-in' },
    formTestDrive: { event: 'avtosalony_card_form_test-drive' }
  }
};

/***/ }),

/***/ 1244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_components_App__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var withFetch = function withFetch(WrappedComponent) {
  var Component = function Component(props) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_1_shared_components_App__["a" /* ContextConsumer */], {}, void 0, function (_ref) {
      var fetch = _ref.fetch;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, props, { fetch: fetch }));
    });
  };
  Component.displayName = 'withFetch(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')';

  return Component;
};

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1309);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./UIStyle.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./UIStyle.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1356)();
}

/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "583766ba.svg";

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__ = __webpack_require__(1261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Helpers

var withInjectLocations = function withInjectLocations() {
  for (var _len = arguments.length, locationTypes = Array(_len), _key = 0; _key < _len; _key++) {
    locationTypes[_key] = arguments[_key];
  }

  return function (item) {
    return _extends({}, item, {
      injectLocations: locationTypes
    });
  };
};

//

var avto = [{
  title: 'Объявления',
  route: '/avto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
},
// {
//   title: 'Каталог',
//   route: '/avto/catalog',
// },
{
  title: 'Автосалоны',
  route: '/avtosalony/',
  slug: '/avtosalony/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var moto = [{
  title: 'Мотоциклы',
  route: '/mototsikl/',
  slug: '/mototsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Скутеры',
  route: '/skuter/',
  slug: '/skuter/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Картинг',
  route: '/karting/',
  slug: '/karting/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Квадроциклы',
  route: '/kvadrotsikl/',
  slug: '/kvadrotsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мопеды',
  route: '/moped/',
  slug: '/moped/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Багги',
  route: '/baggi/',
  slug: '/baggi/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Трициклы',
  route: '/tritsikl/',
  slug: '/tritsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var truck = [{
  title: 'Грузовики',
  route: '/gruzovye/',
  slug: '/gruzovye/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Автобусы',
  route: '/avtobus/',
  slug: '/avtobus/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Прицепы',
  route: '/pritsepy/',
  slug: '/pritsepy/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Водный транспорт',
  route: '/vodnyi-transport/',
  slug: '/vodnyi-transport/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Спецтехника',
  route: '/spetstehnika/',
  slug: '/spetstehnika/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var AVTOSALONS_LINKS = [{
  title: 'Авто',
  route: '/avtosalony/',
  slug: '/avtosalony/avto/'
}, {
  title: 'Мото',
  route: '/avtosalony/mototsikl/',
  slug: '/avtosalony/mototsikl/'
}, {
  title: 'Автобусы',
  route: '/avtosalony/avtobus/',
  slug: '/avtosalony/avtobus/'
}, {
  title: 'Грузовики',
  route: '/avtosalony/gruzovye/',
  slug: '/avtosalony/gruzovye/'
}, {
  title: 'Водный транспорт',
  route: '/avtosalony/vodnyi-transport/',
  slug: '/avtosalony/vodnyi-transport/'
}, {
  title: 'Спецтехника',
  route: '/avtosalony/spetstehnika/',
  slug: '/avtosalony/spetstehnika/'
}, {
  title: 'Прицепы',
  route: '/avtosalony/pritsepy/',
  slug: '/avtosalony/pritsepy/'
}];

var FIRMS_TAGS_LINKS = [{
  title: 'СТО',
  route: '/katalog-kompaniy/sto/',
  slug: '/katalog-kompaniy/sto/'
}, {
  title: 'Авторазборка',
  route: '/katalog-kompaniy/avtorazborka/',
  slug: '/katalog-kompaniy/avtorazborka//'
}, {
  title: 'Автовыкуп',
  route: '/katalog-kompaniy/avtovykup/',
  slug: '/katalog-kompaniy/avtovykup/'
}, {
  title: 'Запчасти',
  route: '/katalog-kompaniy/zapchasti/',
  slug: '/katalog-kompaniy/zapchasti/'
}, {
  title: 'Автотовары',
  route: '/katalog-kompaniy/avtotovary/',
  slug: '/katalog-kompaniy/avtotovary/'
}, {
  title: 'ТСЦ',
  route: '/katalog-kompaniy/teritorialni-servisni-centri/',
  slug: '/katalog-kompaniy/teritorialni-servisni-centri/'
}];

var HEADER = [{
  title: 'Легковые',
  route: '/avto/',
  name: 'avto',
  items: [{
    title: 'C пробегом',
    route: '/avto/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }, {
    title: 'Новые',
    route: '/avto/novye/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  },
  // {
  //   title: 'Каталог',
  //   route: '/avto/catalog',
  // },
  {
    title: 'Автосалоны',
    route: '/avtosalony/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }, {
    title: 'Лизинг авто',
    route: '/leasing/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }],
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мото',
  route: '/moto/',
  items: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Коммерческие',
  route: '/commercial/',
  items: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  // {
  //   title: 'Спецтехника',
  //   route: '/spetstehnika/',
  //   items: [
  //     {
  //       title: 'Автокран',
  //       route: '/avtokran',
  //     },
  //     {
  //       title: 'Бульдозеры',
  //       route: '/buldozer',
  //     },
  //     {
  //       title: 'Автопогрузчики',
  //       route: '/avtopogruzchik',
  //     },
  //     {
  //       title: 'Эскаваторы',
  //       route: '/ekskavator',
  //     },
  //     {
  //       title: 'Самопогрузчики',
  //       route: '/samopogruzchik',
  //     },
  //     {
  //       title: 'Коммунальная',
  //       route: '/kommunalnaya',
  //     },
  //     {
  //       title: 'Cтроительная техника',
  //       route: '/stroitelnaya',
  //     },
  //   ],
  // },
}, {
  title: 'Запчасти',
  route: '/zapchasti/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY],
  items: [
    // {
    //   title: 'Запчасти',
    //   route: '/zapchasti/',
    //   injectLocations: [LOCATION_TYPES.CITY],
    // },
    // {
    //   title: 'Новые',
    //   route: '/zapchasti?isNew=1',
    // },
    // {
    //   title: 'Б/y',
    //   route: '/zapchasti?isUsed=1',
    // },
    // {
    //   title: 'Каталог компаний',
    //   route: '/katalog-kompaniy/',
    //   injectLocations: [LOCATION_TYPES.CITY],
    // },
  ]
}, {
  title: 'Автосалоны',
  route: '/avtosalony/',
  items: AVTOSALONS_LINKS
}, {
  title: 'Каталог',
  route: '/katalog-kompaniy/sto/',
  items: FIRMS_TAGS_LINKS,
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
},
// {
//   title: 'Журнал',
//   route: '/zhurnal/',
//   items: [
//     {
//       title: 'Видео',
//       route: '/zhurnal/video/',
//     },
//     {
//       title: 'Новости',
//       route: '/zhurnal/',
//     },
//     {
//       title: 'Акции',
//       route: '/zhurnal/aktsii/',
//     },
//     {
//       title: 'Статьи',
//       route: '/zhurnal/stati/',
//     },
//     {
//       title: 'Тест-драйвы',
//       route: '/zhurnal/test-draiv/',
//     },
//     {
//       title: 'Обзоры',
//       route: '/zhurnal/obzory/',
//     },
//   ],
// },
{
  title: 'Сервисы',
  route: '/service/ocenka-avto/',
  items: [{
    title: 'Оценка стоимости авто',
    route: '/service/ocenka-avto/'
  }, {
    title: 'Пригон авто',
    route: '/service/prygon-avto/'
  }, {
    title: 'Страховка',
    route: '/insurance/orders/'
  }, {
    title: 'Подписки на поиск',
    route: '/service/search-subscriptions/'
  }]
}];

var FOOTER = [
//

{
  title: 'Разместить рекламу',
  route: '/advertising/'
}, {
  title: 'Бизнесу',
  route: '/biznes-paket/'
}, {
  title: 'Автосалонам',
  route: '/for-dealers/'
}, {
  title: 'Запчасти',
  route: '/info-zapchasti/'
}, {
  title: 'Автосервисам',
  route: '/for-services/'
}, {
  title: 'Помощь',
  route: '/help/'
}, {
  title: 'Частным лицам',
  route: '/for-privates/'
}];

var SPARES_LINKS = [{
  title: 'Авто',
  route: '/zapchasti/',
  slug: '/zapchasti/avto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мото',
  route: '/zapchasti/moto/',
  slug: '/zapchasti/moto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Автобусы',
  route: '/zapchasti/avtobus/',
  slug: '/zapchasti/avtobus/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Грузовики',
  route: '/zapchasti/gruzovye/',
  slug: '/zapchasti/gruzovye/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Водный транспорт',
  route: '/zapchasti/vodnyi-transport/',
  slug: '/zapchasti/vodnyi-transport/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Спецтехника',
  route: '/zapchasti/spetstehnika/',
  slug: '/zapchasti/spetstehnika/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Прицепы',
  route: '/zapchasti/pritsepy/',
  slug: '/zapchasti/pritsepy/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var PROFILE = [{
  title: 'Мои объявления',
  route: '/my/'
}, {
  title: 'Сообщения',
  route: '/dialogs/'
}, {
  title: 'Баланс',
  route: '/billing/'
}, {
  title: 'Избранное',
  route: '/favorites/'
},
// {
//   title: 'Мои поиски',
//   route: '/my-searches',
// },
{
  title: 'Страховка',
  route: '/insurance/orders/'
}, {
  title: 'Подписки на поиск',
  route: '/service/search-subscriptions/'
}, {
  title: 'Настройки',
  route: '/profile/'
}];

var SEARCH = {
  avto: avto,
  //
  moto: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  mototsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  skuter: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  karting: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  kvadrotsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  tritsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  moped: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  baggi: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  snegohod: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  //
  gruzovye: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  avtobus: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  pritsepy: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  spetstehnika: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  'vodnyi-transport': truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY))
};

var SPARES = [
  // {
  //   title: 'Запчасти',
  //   route: '/zapchasti/',
  // },
  // {
  //   title: 'Новые',
  //   route: '/zapchasti?isNew=1',
  // },
  // {
  //   title: 'Б/y',
  //   route: '/zapchasti?isUsed=1',
  // },
  // {
  //   title: 'Каталог компаний',
  //   route: '/katalog-kompaniy/',
  // },
];

var LINKS = {
  HEADER: HEADER,
  FOOTER: FOOTER,
  PROFILE: PROFILE,
  SEARCH: SEARCH,
  SPARES: SPARES,
  AVTOSALONS_LINKS: AVTOSALONS_LINKS,
  FIRMS_TAGS_LINKS: FIRMS_TAGS_LINKS,
  SPARES_LINKS: SPARES_LINKS,
  moto: moto
};

/* harmony default export */ __webpack_exports__["a"] = (LINKS);

/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Loader_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var _ref = _jsx('i', {
  className: 'fa fa-2x fa-spinner fa-spin'
});

function Loader(props) {
  var isLoading = props.isLoading,
      children = props.children,
      isHidden = props.isHidden,
      className = props.className,
      loaderElement = props.loaderElement,
      defaultClassName = props.defaultClassName;


  if (isHidden) {
    return null;
  }

  return isLoading ? _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a.root, className)
  }, void 0, loaderElement || _ref) : _jsx('div', {
    className: defaultClassName
  }, void 0, children);
}

Loader.defaultProps = {
  isLoading: false,
  isHidden: false,
  children: '',
  className: '',
  defaultClassName: '',
  loaderElement: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a)(Loader));

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Append the element into the DOM on mount. We'll render
      // into the modal container element (see the HTML tab).
      var modalRoot = document.getElementById('modal');
      modalRoot.appendChild(this.el);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove the element from the DOM when we unmount
      var modalRoot = document.getElementById('modal');
      modalRoot.removeChild(this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      // Use a portal to render the children into the element
      return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      // A DOM element
      this.el);
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),

/***/ 1251:
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCustomParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = paramsToSeoData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_modules__ = __webpack_require__(103);
/* eslint-disable no-param-reassign */



var avaliableKeyFields = ['make', 'model', 'city', 'generation', 'gearbox', 'engine', 'body', 'drive',
// 'driveSelected',
'isNew', 'year',
// 'makeTranslate',
'country',
// 'location'
'transport', 'transportType', 'transporttype'];

/**
 * Make pathes to compare and find needed function.
 * Like: body_engine_isnew
 * @param {object} inputParams 
 * @param {object} seoData 
 * @returns {object}
 */
function findSeoPath(inputParams, seoData) {
  var inputKeys = avaliableKeyFields.filter(function (k) {
    return inputParams[k] !== null && inputParams[k] !== undefined && inputParams[k] !== '';
  });

  var pathInput = inputKeys.sort().join('_').toLowerCase();

  var seoDataKeys = Object.keys(seoData || {});

  for (var i = 0, l = seoDataKeys.length; i < l; i += 1) {
    var path = seoDataKeys[i].split('_').sort().join('_');
    var pathLc = path.toLowerCase();
    var func = seoData[pathLc] || seoData[path];
    if (path === pathInput && func) {
      return { path: path, func: func };
    }
  }
  return {};
}

function getCustomParams(data, t) {
  var city = data.city,
      country = data.country,
      engine = data.engine,
      gearbox = data.gearbox;


  var locale = t('locale');
  var buy = t('Купить');
  var newTxt = t('Новый');

  var newTxtLCase = newTxt.toLowerCase();
  var buyLCase = buy.toLowerCase();

  var inCity = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][city] ? ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][city][locale].genitive) : __WEBPACK_IMPORTED_MODULE_1_shared_modules__["c" /* buildInGenitiveCityHeader */](t(city) || city) || '';

  var fromCountry = country && country.is_country ? country.from[locale] : '';
  var countryTitle = country && country.is_country ? t(country.title) : '';

  var customEngineAlt = engine;
  var customEngine = engine;
  var customEngineShort = engine;
  var customGearbox = gearbox;
  var customGearboxLCase = gearbox && gearbox.toLowerCase();

  if (engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale]) {
    customEngineAlt = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle;
    customEngine = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title;
    customEngineShort = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].short;
  }

  if (gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale]) {
    customGearbox = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title;
    customGearboxLCase = customGearbox.toLowerCase();
  }
  var makeLocale = 'test'; // make[`${t('locale')}_title`] ? make[`${t('locale')}_title`] : make.title;

  return {
    buy: buy,
    newTxt: newTxt,
    newTxtLCase: newTxtLCase,
    buyLCase: buyLCase,

    customEngineShort: customEngineShort,
    customEngineAlt: customEngineAlt,
    customEngine: customEngine,

    customGearbox: customGearbox,
    customGearboxLCase: customGearboxLCase,

    inCity: (inCity || '').trim(),
    fromCountry: (fromCountry || '').trim(),
    country: countryTitle,
    locale: locale,
    t: t,
    makeLocale: makeLocale
  };
}

/**
 * Parse input params and retrurn Object with 
 * @param {object} data 
 * @param {object} pathes 
 * @param {funciton} t 
 * @returns {object} { head: 'text for H1', title: 'text for eta Title', ... }
 */
function paramsToSeoData(data, pathes, t) {
  try {
    var locale = t('locale');
    var isNew = !!data.isNew;
    if (data.transportCategoryTitleOrigin) {
      var subCategory = data.transportCategoryTitleOrigin;
      var subCategoryObject = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["a" /* crutch */](isNew)[subCategory] || {};

      if (subCategoryObject[locale]) {
        var obj = subCategoryObject[locale];
        data.subCategory = subCategory || '';
        data.subCategoryHeader = obj.transportHeader || '';
        data.subCategoryPluralGenitive = obj.pluralGenitiveTransport || '';
        data.subCategoryPlural = obj.pluralTransport || '';
      }
    }

    if (data.transportTitleOrigin) {
      var transport = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["a" /* crutch */](isNew)[data.transportTitleOrigin] || {};

      if (transport[locale]) {
        var _obj = transport[locale];
        data.category = data.transportTitleOrigin || '';
        data.categoryPluralGenitive = _obj.pluralGenitive || '';
        data.categoryPlural = _obj.plural || '';
      }
    }

    data.transportType = data.subCategoryHeader || data.category;
    data.transportTypePlural = data.subCategoryPlural || data.categoryPlural;
    data.transportTypePluralGenitive = data.subCategoryPluralGenitive || data.categoryPluralGenitive;

    var _findSeoPath = findSeoPath(data, pathes),
        path = _findSeoPath.path,
        func = _findSeoPath.func;

    // ...
    // Here can be added some additional SEO searching by API or something else.
    // We have `path` (brand_model_...) and can use it.
    // ...


    if (path) {
      var customParams = getCustomParams(data, t);
      var res = func(data, customParams);
      var lc = customParams.locale;

      return {
        title: res['title_' + lc] || res.title,
        description: res['description_' + lc] || res.description,
        header: res['header_' + lc] || res.header
      };
    }
    return {};
  } catch (err) {}
  return {};
}

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NOTIFICATION_TYPES = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  INFO: 'INFO'
};

/* harmony default export */ __webpack_exports__["a"] = (NOTIFICATION_TYPES);

/***/ }),

/***/ 1254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/avto/templates.js
var avtoPathesHead = {
  city: function city(data, p) {
    return {
      header: p.buy + ' \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity,

      title: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.t(data.city) + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u044B\u043D\u043A\u0435',
      title_uk: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.t(data.city) + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u043D\u043A\u0443',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0443 \u0430\u0432\u0442\u043E \uD83D\uDE97 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u044B',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0443 \u0430\u0432\u0442\u043E \uD83D\uDE97 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.inCity + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456'
    };
  },

  make: function make(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C. \u0426\u0435\u043D\u0430 \u0430\u0432\u0442\u043E, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C. \u0426\u0456\u043D\u0430 \u0430\u0432\u0442\u043E, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043D\u0430 \u0430\u0432\u0442\u043E \u0431\u0430\u0437\u0430\u0440\u0435. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E \u043C\u043E\u0434\u0435\u043B\u0438. \u0412\u0435\u0441\u044C \u043C\u043E\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u0440\u044F\u0434 ' + data.make + ' \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0421\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E \u0431\u0430\u0437\u0430\u0440\u0456. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u044E \u043C\u043E\u0434\u0435\u043B\u0456. \u0412\u0435\u0441\u044C \u043C\u043E\u0434\u0435\u043B\u044C\u043D\u0438\u0439 \u0440\u044F\u0434 ' + data.make + ' \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0437\u0456 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  country: function country(data, p) {
    return {
      header: p.buy + ' \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.fromCountry,

      title: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.fromCountry + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u044B\u043D\u043A\u0435',
      title_uk: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.fromCountry + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u043D\u043A\u0443',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0443 \u0430\u0432\u0442\u043E \u0432 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u0431\u0443 \u0432 ' + p.country + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u044B',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0443 \u0430\u0432\u0442\u043E \u0432 ' + p.country + '. \u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E \u0431\u0443 \u0432 ' + p.country + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456'
    };
  },

  engine: function engine(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.engine).toLowerCase() + ' ' + p.t('автомобиль') + ' \u0431\u0443'
    };
  },

  body: function body(data, p) {
    return {
      title: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      header: p.buy + ' ' + p.t(data.body) + ' \u0431\u0443 ' + p.t('в Украине'),

      description: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  gearbox: function gearbox(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.customGearbox + ' \u0431\u0443' };
  },

  year: function year(data, p) {
    return {
      title: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  // --- //

  gearboxCity: function gearboxCity(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.customGearbox.toLowerCase() + ' \u0431\u0443 ' + p.t(data.city) };
  },

  cityEngine: function cityEngine(data, p) {
    return { header: p.t(data.engine) + ' \u0430\u0432\u0442\u043E \u0431\u0443 ' + p.buyLCase + ' ' + p.inCity };
  },

  makeModel: function makeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' \u0431\u0443. \u0426\u0435\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' \u0431\u0443. \u0426\u0456\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B ' + data.make + ' ' + data.model + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u044B\u043D\u043A\u0435. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u043E\u0431\u0437\u043E\u0440 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u0438 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0441\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u0438\u043D\u043A\u0443. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u043E\u0433\u043B\u044F\u0434 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u0457 \u0456 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeCity: function makeCity(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' \u0431\u0443 ' + p.t(data.city) + '. \u0426\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' \u0431\u0443 ' + p.t(data.city) + '. \u0426\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C ' + p.inCity + '. \u0426\u0435\u043D\u044B \u043D\u0430 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u044B, \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 \u043C\u0430\u0440\u043A\u0438 \u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C ' + p.inCity + '. \u0426\u0456\u043D\u0438 \u043D\u0430 \u0441\u0442\u0430\u0440\u0456 \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0438, \u0444\u043E\u0442\u043E, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0456 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u044E \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 \u043C\u0430\u0440\u043A\u0438 \u0434\u0438\u0432\u0456\u0442\u044C\u0441\u044F \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0437\u0456 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeCountry: function makeCountry(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' \u0431\u0443 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0426\u0435\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' \u0431\u0443 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0426\u0456\u043D\u0430 \u0430\u0432\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u043D\u044B\u0445 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0443. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u043E\u0431\u0437\u043E\u0440 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C ' + data.make + ' \u0431\u0443 ' + p.fromCountry + '. \u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043F\u0440\u0438\u0432\u0435\u0437\u0435\u043D\u0456 ' + p.fromCountry + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0441\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u043E\u0433\u043B\u044F\u0434 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0456 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u0457 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  cityYear: function cityYear(data, p) {
    return {
      title: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyYear: function bodyYear(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430',
      header_uk: p.buy + ' ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443',

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + p.t('в Украине'),
      title: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // Купить кроссовер в Украине

  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body).toLowerCase() + ' \u0431\u0443 ' + p.inCity,
      title: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // Купить кроссовер бу в Киеве

  gearboxIsnew: function gearboxIsnew(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.customGearbox };
  },
  // Купить авто Механика

  makeBody: function makeBody(data, p) {
    return {
      header: data.make + ' ' + p.t(data.body) + ' \u0431\u0443 ' + p.buyLCase + ' ' + p.t('в Украине'),
      title: p.t(data.body) + ' ' + data.make + ' \u0431\u0443 ' + p.buyLCase + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.make + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0445 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.make + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0445 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // BMW Кросовер бу купить в Украине

  makeEngine: function makeEngine(data, p) {
    return { header: data.make + ' ' + p.t(data.engine).toLowerCase() + ' \u0431\u0443' };
  },
  // BMW дизель бу

  makeGearbox: function makeGearbox(data, p) {
    return {
      header: data.make + ' ' + p.customGearboxLCase + ' \u0431\u0443 ' + p.buyLCase + ' ' + p.t('в Украине')
    };
  },
  // BMW механика бу купить в Украине

  bodyIsnewMake: function bodyIsnewMake(data, p) {
    return {
      title: p.newTxt + ' ' + p.t(data.body) + ' ' + data.make + ' ' + p.buyLCase + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      header: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + data.make,

      description: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyIsnewYear: function bodyIsnewYear(data, p) {
    return {
      header: p.newTxt + ' ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430',
      header_uk: p.newTxt + ' ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443',

      title: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeGearboxIsnew: function makeGearboxIsnew(data, p) {
    return {
      header: data.make + ' ' + p.customGearboxLCase + ' ' + p.buyLCase + ' ' + p.t('в Украине')
    };
  },
  // BMW механика купить в Украине

  gearboxIsnewCity: function gearboxIsnewCity(data, p) {
    return { header: p.buy + ' \u0430\u0432\u0442\u043E ' + p.t(data.gearbox) + ' ' + p.inCity };
  },
  // Купить авто Механика в Киеве

  makeGearboxCity: function makeGearboxCity(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + p.t(data.gearbox).toLowerCase() + ' \u0431\u0443 ' + p.t(data.city)
    };
  },
  // Купить BMW Механика бу в Киеве

  engineMakeModel: function engineMakeModel(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.customEngineShort + ' \u0431\u0443',

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить BMW X6 дизель бу

  makeModelCity: function makeModelCity(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u044B\u043D\u043A\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0431\u0443 ' + p.inCity + '. \u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u0438\u043D\u043A\u0443 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 ' + p.inCity + '. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B ' + data.make + ' ' + data.model + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043D\u0430 \u0430\u0432\u0442\u043E \u0440\u044B\u043D\u043A\u0435 \u0433. ' + p.t(data.city) + '. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E, \u043E\u0431\u0437\u043E\u0440 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u043C\u043E\u0434\u0435\u043B\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 ' + p.inCity + '. \u0421\u0442\u0430\u0440\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C\u043D\u043E\u043C\u0443 \u0440\u0438\u043D\u043A\u0443 \u043C. ' + p.t(data.city) + '. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E, \u043E\u0433\u043B\u044F\u0434 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0456 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0456\u0457 \u043C\u043E\u0434\u0435\u043B\u0456 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  makeModelYear: function makeModelYear(data, p) {
    return {
      header: '',
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  gearboxMakeModel: function gearboxMakeModel(data, p) {
    return {
      // header: '',
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  bodyMakeModel: function bodyMakeModel(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body) + ' ' + data.make + ' ' + data.model,
      title: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.t('в Украине') + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить Кросовер BMW X6 бу

  bodyCityIsnew: function bodyCityIsnew(data, p) {
    return {
      header: p.newTxt + ' ' + p.t(data.body) + ' ' + p.buyLCase + ' ' + p.inCity,
      title: p.newTxt + ' ' + p.t(data.body) + ' ' + p.buyLCase + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' \u043A\u0443\u043F\u0438\u0442\u044C ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // Купить Кросовер в Киеве

  bodyCityMake: function bodyCityMake(data, p) {
    return {
      header: data.make + ' ' + p.t(data.body).toLowerCase() + ' \u0431\u0443 ' + p.t(data.city),
      title: p.buy + ' \u0431\u0443 ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 ' + p.t(data.body) + ' ' + data.make + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 ' + p.t(data.body) + ' ' + data.make + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  // BMW Кроссовер бу в Киеве

  bodyCityYear: function bodyCityYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  cityEngineYear: function cityEngineYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0431\u0443 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0431\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyCityIsnewMake: function bodyCityIsnewMake(data, p) {
    return {
      header: p.newTxt + ' ' + data.make + ' ' + p.t(data.body) + ' ' + p.inCity,
      title: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.make + ' ' + p.inCity + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  bodyCityMakeModel: function bodyCityMakeModel(data, p) {
    return {
      header: p.buy + ' ' + p.t(data.body).toLowerCase() + ' ' + data.make + ' ' + data.model + ' \u0431\u0443 ' + p.t(data.city),

      title: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.inCity + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 ' + p.inCity + '. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C ' + p.inCity + '. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  countryMakeModel: function countryMakeModel(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' \u0431\u0443',

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u043D\u044B\u0439 ' + p.fromCountry + '. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0440\u0430\u0441\u0442\u0430\u043C\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u0438 \u043D\u0435\u0440\u0430\u0441\u0442\u0430\u043C\u043E\u0436\u0435\u043D\u043D\u044B\u0439. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u0438\u0439 ' + p.fromCountry + '. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0440\u043E\u0437\u043C\u0438\u0442\u043D\u0435\u043D\u0438\u0439 \u0456 \u043D\u0435\u0440\u043E\u0437\u043C\u0438\u0442\u043D\u0435\u043D\u0438\u0439. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  makeModelEngineCity: function makeModelEngineCity(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.customEngineShort + ' \u0431\u0443 ' + p.inCity,
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 ' + p.inCity + '. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C ' + p.inCity + '. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить BMW X6 дизель бу в Киеве

  cityGearboxMakeModel: function cityGearboxMakeModel(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + p.customGearbox.toLowerCase() + ' \u0431\u0443 ' + p.t(data.city),
      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B ' + p.inCity + ', \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 ' + p.inCity + ', \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },
  // Купить BMW X6 Механика бу в Киеве

  cityGearboxIsnewMake: function cityGearboxIsnewMake(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + p.customGearbox + ' ' + p.inCity
    };
  },
  // Купить BMW Механика в Киеве

  cityMakeModelYear: function cityMakeModelYear(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 ' + p.inCity,

      title: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B ' + p.inCity + ', \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 ' + p.inCity + '. \u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 ' + p.inCity + ', \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E'
    };
  },

  makeModelEngineCityYear: function makeModelEngineCityYear(data, p) {
    return {
      header: p.buy + ' ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0431\u0443 ' + p.inCity
    };
  },

  //
  bodyCityIsnewYear: function bodyCityIsnewYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + p.t(data.body) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043E\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + p.t(data.body) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  isnewYear: function isnewYear(data, p) {
    return {
      title: '\u041D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityIsnewYear: function cityIsnewYear(data, p) {
    return {
      title: '\u041D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 ' + data.year + ' \u0433\u043E\u0434\u0430 \u043A\u0443\u043F\u0438\u0442\u044C \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 ' + data.year + ' \u0440\u043E\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0448\u0438\u043D. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430. \u0415\u0449\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0435 \u0430\u0432\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0448\u0438\u043D. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430. \u0429\u0435 \u0431\u0456\u043B\u044C\u0448\u0435 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0438\u0433\u0456\u0434\u043D\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityIsnewMakeModelYear: function cityIsnewMakeModelYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B ' + p.inCity + ', \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 ' + p.inCity + ', \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  gearboxIsnewMakeModel: function gearboxIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityGearboxIsnewMakeModel: function cityGearboxIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ', \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.customGearbox + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u0441\u0430\u043B\u043E\u043D\u0430\u0445 ' + p.t(data.city) + ', \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  engineIsnewMakeModel: function engineIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityEngineIsnewMakeModel: function cityEngineIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u043E\u0432. \u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.engine) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0456\u0432. \u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  bodyIsnewMakeModel: function bodyIsnewMakeModel(data, p) {
    return {
      header: p.buy + ' ' + p.newTxtLCase + ' ' + p.t(data.body) + ' ' + data.make + ' ' + data.model,
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0438\u043D\u044B. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0423\u043A\u0440\u0430\u0457\u043D\u0438. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  bodyCityIsnewMakeModel: function bodyCityIsnewMakeModel(data, p) {
    return {
      header: p.newTxt + ' ' + p.t(data.body) + ' ' + data.make + ' ' + data.model + ' ' + p.inCity,
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0433\u043E\u0440\u043E\u0434\u0430 ' + p.t(data.city) + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 ' + data.make + ' ' + data.model + ' ' + p.t(data.body) + ' \u0432 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u043C\u0456\u0441\u0442\u0430 ' + p.t(data.city) + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  countryIsnewMakeModel: function countryIsnewMakeModel(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u043D\u044B\u0439 ' + p.fromCountry + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043B\u0443\u0447\u0448\u0435\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' ' + p.fromCountry + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + data.make + ' ' + data.model + ' \u043F\u0440\u0438\u0433\u043D\u0430\u043D\u0438\u0439 ' + p.fromCountry + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043A\u0440\u0430\u0449\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },
  cityEngineIsnewYear: function cityEngineIsnewYear(data, p) {
    return {
      title: '\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 ' + p.t(data.engine) + ' \u0430\u0432\u0442\u043E ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043D\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0433\u043E\u0434\u0430 \u0441 \u0441\u0430\u043B\u043E\u043D\u0430 ' + p.inCity + '. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043C\u0430\u0440\u043E\u043A \u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043E\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 ' + p.t(data.engine) + ' \u0430\u0432\u0442\u043E ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 \u043D\u043E\u0432\u0438\u0445 \u0430\u0432\u0442\u043E ' + p.t(data.engine) + ' ' + data.year + ' \u0440\u043E\u043A\u0443 \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 ' + p.inCity + '. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043C\u0430\u0440\u043E\u043A \u0456 \u043C\u043E\u0434\u0435\u043B\u0435\u0439. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E \u0432 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  }
};

/* harmony default export */ var templates_defaultExport = (avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/avto/index.js
var _AVTO;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// To more readable code, try to use keys in alphabet order " { ab_bc_de: abBcDe }"
// body country city drive engine gearbox generation isNew location make makeTranslate model year
var AVTO = (_AVTO = {
  city: templates_defaultExport.city,
  // city: tpl.city,
  make: templates_defaultExport.make,
  country: templates_defaultExport.country,
  body: templates_defaultExport.body,
  engine: templates_defaultExport.engine,
  gearbox: templates_defaultExport.gearbox,
  year: templates_defaultExport.year,

  // 2
  make_model: templates_defaultExport.makeModel,
  country_make: templates_defaultExport.makeCountry,
  city_make: templates_defaultExport.makeCity,
  body_isnew: templates_defaultExport.bodyIsnew,
  body_city: templates_defaultExport.bodyCity,
  gearbox_isnew: templates_defaultExport.gearboxIsnew,
  city_gearbox: templates_defaultExport.gearboxCity,
  city_year: templates_defaultExport.cityYear,
  body_year: templates_defaultExport.bodyYear,

  city_engine: templates_defaultExport.cityEngine,
  body_make: templates_defaultExport.makeBody,
  engine_make: templates_defaultExport.makeEngine,
  gearbox_make: templates_defaultExport.makeGearbox,
  isnew_year: templates_defaultExport.isnewYear,
  city_isnew: templates_defaultExport.cityIsnew,

  // 3
  gearbox_isnew_make: templates_defaultExport.makeGearboxIsnew,
  city_gearbox_isnew: templates_defaultExport.gearboxIsnewCity,
  city_gearbox_make: templates_defaultExport.makeGearboxCity,
  engine_make_model: templates_defaultExport.engineMakeModel,
  body_make_model: templates_defaultExport.bodyMakeModel,
  body_isnew_make: templates_defaultExport.bodyIsnewMake,
  body_isnew_year: templates_defaultExport.bodyIsnewYear,
  country_make_model: templates_defaultExport.countryMakeModel,
  body_city_isnew: templates_defaultExport.bodyCityIsnew,
  body_city_make: templates_defaultExport.bodyCityMake,
  body_city_year: templates_defaultExport.bodyCityYear,
  city_engine_year: templates_defaultExport.cityEngineYear,
  make_model_year: templates_defaultExport.makeModelYear,
  city_make_model: templates_defaultExport.makeModelCity,
  gearbox_make_model: templates_defaultExport.gearboxMakeModel,
  city_isnew_year: templates_defaultExport.cityIsnewYear,

  // 4
  city_gearbox_isnew_make: templates_defaultExport.cityGearboxIsnewMake,
  city_engine_make_model: templates_defaultExport.makeModelEngineCity,
  city_gearbox_make_model: templates_defaultExport.cityGearboxMakeModel,
  body_city_make_model: templates_defaultExport.bodyCityMakeModel,
  body_city_isnew_make: templates_defaultExport.bodyCityIsnewMake,
  city_make_model_year: templates_defaultExport.cityMakeModelYear,
  body_isnew_make_model: templates_defaultExport.bodyIsnewMakeModel,

  // 5
  city_engine_make_model_year: templates_defaultExport.makeModelEngineCityYear,
  body_city_isnew_make_model: templates_defaultExport.bodyCityIsnewMakeModel,

  body_city_isnew_year: templates_defaultExport.bodyCityIsnewYear,
  city_engine_isnew_year: templates_defaultExport.cityEngineIsnewYear
}, _defineProperty(_AVTO, 'isnew_year', templates_defaultExport.isnewYear), _defineProperty(_AVTO, 'city_isnew_year', templates_defaultExport.cityIsnewYear), _defineProperty(_AVTO, 'city_isnew', templates_defaultExport.cityIsnew), _defineProperty(_AVTO, 'isnew_make_model_year', templates_defaultExport.isnewMakeModelYear), _defineProperty(_AVTO, 'city_isnew_make_model_year', templates_defaultExport.cityIsnewMakeModelYear), _defineProperty(_AVTO, 'gearbox_isnew_make_model', templates_defaultExport.gearboxIsnewMakeModel), _defineProperty(_AVTO, 'city_gearbox_isnew_make_model', templates_defaultExport.cityGearboxIsnewMakeModel), _defineProperty(_AVTO, 'engine_isnew_make_model', templates_defaultExport.engineIsnewMakeModel), _defineProperty(_AVTO, 'city_engine_isnew_make_model', templates_defaultExport.cityEngineIsnewMakeModel), _defineProperty(_AVTO, 'country_isnew_make_model', templates_defaultExport.countryIsnewMakeModel), _AVTO);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moto/templates.js
var templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0431\u0443 " + p.inCity,

      title: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0430 " + p.t(data.city) + ". \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u043E\u0439 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0438 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0430 " + p.t(data.city) + ". \u041F\u0440\u043E\u0434\u0430\u0436 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0430\u043D\u043E\u0457 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0431\u0443 " + p.inCity + ". \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u043E\u0439 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B. \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u044B",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0431\u0443 " + p.inCity + ". \u041F\u0440\u043E\u0434\u0430\u0436 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0430\u043D\u043E\u0457 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456"
    };
  }
};

/* harmony default export */ var moto_templates_defaultExport = (templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moto/index.js


var MOTO = {
  city: moto_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/mototsikl/templates.js
/* harmony default export */ var mototsikl_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },

  make: function make(data, p) {
    return {
      header: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B " + data.make,
      header_uk: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 " + data.make,

      title: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },

  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/mototsikl/index.js


var MOTOTSIKL = {
  city: mototsikl_templates_defaultExport.city,
  body: mototsikl_templates_defaultExport.body,

  make: mototsikl_templates_defaultExport.make,

  make_model: mototsikl_templates_defaultExport.makeModel,
  city_make: mototsikl_templates_defaultExport.cityMake,
  city_isnew: mototsikl_templates_defaultExport.cityIsnew,
  isnew_make: mototsikl_templates_defaultExport.makeIsnew,
  body_make: mototsikl_templates_defaultExport.makeBody,
  body_isnew: mototsikl_templates_defaultExport.bodyIsnew,
  body_city: mototsikl_templates_defaultExport.bodyCity,

  city_make_model: mototsikl_templates_defaultExport.makeModelCity,
  isnew_make_model: mototsikl_templates_defaultExport.makeModelIsnew,
  city_isnew_make: mototsikl_templates_defaultExport.makeCityIsnew,
  body_make_model: mototsikl_templates_defaultExport.makeModelBody,
  make_model_year: mototsikl_templates_defaultExport.makeModelYear,
  body_isnew_make: mototsikl_templates_defaultExport.isnewMakeBody,
  body_city_make: mototsikl_templates_defaultExport.makeCityBody,
  body_city_isnew: mototsikl_templates_defaultExport.isnewBodyCity,

  isnew_make_model_year: mototsikl_templates_defaultExport.isnewMakeModelYear,
  city_isnew_make_model: mototsikl_templates_defaultExport.isnewMakeModelCity,
  body_isnew_make_model: mototsikl_templates_defaultExport.isnewMakeModelBody,
  body_city_make_model: mototsikl_templates_defaultExport.makeModelCityBody,
  body_city_isnew_make: mototsikl_templates_defaultExport.isnewMakeCityBody,

  body_city_isnew_make_model: mototsikl_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/skuter/templates.js
var skuter_templates_avtoPathesHead = {
  make: function make(data, p) {
    return {
      header: "\u0421\u043A\u0443\u0442\u0435\u0440\u044B " + data.make,
      header_uk: "\u0421\u043A\u0443\u0442\u0435\u0440\u0438 " + data.make,

      title: "\u0421\u043A\u0443\u0442\u0435\u0440\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0421\u043A\u0443\u0442\u0435\u0440\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 \u0431\u0443"
    };
  },

  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0441\u043A\u0443\u0442\u0435\u0440\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0441\u043A\u0443\u0442\u0435\u0440\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440"
    };
  },
  cityBody: function cityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 \u0431\u0443 " + p.inCity
    };
  },

  cityMakeModel: function cityMakeModel(data, p) {
    return {
      header: p.buy + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  cityIsnewMake: function cityIsnewMake(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make
    };
  },
  cityMakeBody: function cityMakeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  cityIsnewBody: function cityIsnewBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var skuter_templates_defaultExport = (skuter_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/skuter/index.js


var SKUTER = {
  make: skuter_templates_defaultExport.make,
  body: skuter_templates_defaultExport.body,

  city_make: skuter_templates_defaultExport.makeCity,
  make_model: skuter_templates_defaultExport.makeModel,
  city_isnew: skuter_templates_defaultExport.cityIsnew,
  isnew_make: skuter_templates_defaultExport.makeIsnew,
  body_make: skuter_templates_defaultExport.makeBody,
  body_isnew: skuter_templates_defaultExport.bodyIsnew,
  body_city: skuter_templates_defaultExport.cityBody,

  city_make_model: skuter_templates_defaultExport.cityMakeModel,
  isnew_make_model: skuter_templates_defaultExport.makeModelIsnew,
  city_isnew_make: skuter_templates_defaultExport.cityIsnewMake,
  body_make_model: skuter_templates_defaultExport.makeModelBody,
  make_model_year: skuter_templates_defaultExport.makeModelYear,
  body_isnew_make: skuter_templates_defaultExport.isnewMakeBody,
  body_city_make: skuter_templates_defaultExport.cityMakeBody,
  body_city_isnew: skuter_templates_defaultExport.cityIsnewBody,

  isnew_make_model_year: skuter_templates_defaultExport.isnewMakeModelYear,
  city_isnew_make_model: skuter_templates_defaultExport.isnewMakeModelCity,
  body_isnew_make_model: skuter_templates_defaultExport.isnewMakeModelBody,
  body_city_make_model: skuter_templates_defaultExport.makeModelCityBody,
  body_city_isnew_make: skuter_templates_defaultExport.isnewMakeCityBody,

  body_city_isnew_make_model: skuter_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moped/templates.js
var moped_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u043F\u0435\u0434\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u043F\u0435\u0434\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u041C\u043E\u043F\u0435\u0434\u044B " + data.make,
      header_uk: "\u041C\u043E\u043F\u0435\u0434\u0438 " + data.make,

      title: "\u041C\u043E\u043F\u0435\u0434\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041C\u043E\u043F\u0435\u0434\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043C\u043E\u043F\u0435\u0434\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043C\u043E\u043F\u0435\u0434\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 \u0431\u0443 " + p.inCity
    };
  },

  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var moped_templates_defaultExport = (moped_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/moped/index.js


var MOPED = {
    city: moped_templates_defaultExport.city,
    make: moped_templates_defaultExport.make,
    body: moped_templates_defaultExport.body,

    make_model: moped_templates_defaultExport.makeModel,
    city_make: moped_templates_defaultExport.makeCity,
    city_isnew: moped_templates_defaultExport.cityIsnew,
    isnew_make: moped_templates_defaultExport.makeIsnew,
    body_make: moped_templates_defaultExport.makeBody,
    body_isnew: moped_templates_defaultExport.bodyIsnew,
    body_city: moped_templates_defaultExport.bodyCity,

    make_model_year: moped_templates_defaultExport.makeModelYear,
    city_make_model: moped_templates_defaultExport.makeModelCity,
    isnew_make_model: moped_templates_defaultExport.makeModelIsnew,
    city_isnew_make: moped_templates_defaultExport.makeCityIsnew,
    body_make_model: moped_templates_defaultExport.makeModelBody,
    body_isnew_make: moped_templates_defaultExport.isnewMakeBody,
    body_city_make: moped_templates_defaultExport.makeCityBody,
    body_city_isnew: moped_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: moped_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: moped_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: moped_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: moped_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: moped_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: moped_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/kvadrotsikl/templates.js
var kvadrotsikl_templates_avtoPathesHead = {
  make: function make(data, p) {
    return {
      header: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B " + data.make,
      header_uk: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 " + data.make,

      title: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var kvadrotsikl_templates_defaultExport = (kvadrotsikl_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/kvadrotsikl/index.js


var KVADROTSIKL = {
    make: kvadrotsikl_templates_defaultExport.make,
    city: kvadrotsikl_templates_defaultExport.city,
    body: kvadrotsikl_templates_defaultExport.body,

    city_make: kvadrotsikl_templates_defaultExport.makeCity,
    make_model: kvadrotsikl_templates_defaultExport.makeModel,
    city_isnew: kvadrotsikl_templates_defaultExport.cityIsnew,
    isnew_make: kvadrotsikl_templates_defaultExport.makeIsnew,
    body_make: kvadrotsikl_templates_defaultExport.makeBody,
    body_isnew: kvadrotsikl_templates_defaultExport.bodyIsnew,
    body_city: kvadrotsikl_templates_defaultExport.bodyCity,

    city_make_model: kvadrotsikl_templates_defaultExport.makeModelCity,
    isnew_make_model: kvadrotsikl_templates_defaultExport.makeModelIsnew,
    city_isnew_make: kvadrotsikl_templates_defaultExport.makeCityIsnew,
    body_make_model: kvadrotsikl_templates_defaultExport.makeModelBody,
    make_model_year: kvadrotsikl_templates_defaultExport.makeModelYear,
    body_isnew_make: kvadrotsikl_templates_defaultExport.isnewMakeBody,
    body_city_make: kvadrotsikl_templates_defaultExport.makeCityBody,
    body_city_isnew: kvadrotsikl_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: kvadrotsikl_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: kvadrotsikl_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: kvadrotsikl_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: kvadrotsikl_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: kvadrotsikl_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: kvadrotsikl_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/baggi/templates.js
var baggi_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0431\u0430\u0433\u0433\u0438 \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0431\u0430\u0433\u0433\u0456 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u0411\u0430\u0433\u0433\u0438 " + data.make,
      header_uk: "\u0411\u0430\u0433\u0433\u0456 " + data.make,

      title: "\u0411\u0430\u0433\u0433\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0411\u0430\u0433\u0433\u0456 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u0431\u0430\u0433\u0433\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u0431\u0430\u0433\u0433\u0456, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 \u0431\u0443"
    };
  },

  makeModel: function makeModel(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0431\u0430\u0433\u0433\u0438 \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0431\u0430\u0433\u0433\u0456 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0438 " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0431\u0430\u0433\u0433\u0456 " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var baggi_templates_defaultExport = (baggi_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/baggi/index.js


var BAGGI = {
    city: baggi_templates_defaultExport.city,
    make: baggi_templates_defaultExport.make,
    body: baggi_templates_defaultExport.body,

    make_model: baggi_templates_defaultExport.makeModel,
    city_make: baggi_templates_defaultExport.makeCity,
    city_isnew: baggi_templates_defaultExport.cityIsnew,
    isnew_make: baggi_templates_defaultExport.makeIsnew,
    body_make: baggi_templates_defaultExport.makeBody,
    body_isnew: baggi_templates_defaultExport.bodyIsnew,
    body_city: baggi_templates_defaultExport.bodyCity,

    city_make_model: baggi_templates_defaultExport.makeModelCity,
    isnew_make_model: baggi_templates_defaultExport.makeModelIsnew,
    city_isnew_make: baggi_templates_defaultExport.makeCityIsnew,
    body_make_model: baggi_templates_defaultExport.makeModelBody,
    make_model_year: baggi_templates_defaultExport.makeModelYear,
    body_isnew_make: baggi_templates_defaultExport.isnewMakeBody,
    body_city_make: baggi_templates_defaultExport.makeCityBody,
    body_city_isnew: baggi_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: baggi_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: baggi_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: baggi_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: baggi_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: baggi_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: baggi_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/tritsikl/templates.js
var tritsikl_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0412\u044B\u0433\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u0412\u0438\u0433\u0456\u0434\u043D\u0430 \u0446\u0456\u043D\u0430"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u044B " + data.make,
      header_uk: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u0438 " + data.make,

      title: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u044B " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0422\u0440\u0438\u0446\u0438\u043A\u043B\u0438 " + data.makeTranslit + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u044B, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0438 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0438, \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440"
    };
  },
  body: function body(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443"
    };
  },

  makeCity: function makeCity(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModel: function makeModel(data, p) {
    return {
      header: p.buy + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041F\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u043D\u044B\u0435 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u044B \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0436\u0438\u0432\u0430\u043D\u0456 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0438 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C"
    };
  },
  cityIsnew: function cityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeIsnew: function makeIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeBody: function makeBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443"
    };
  },
  bodyIsnew: function bodyIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B"
    };
  },
  bodyCity: function bodyCity(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B \u0431\u0443 " + p.inCity
    };
  },

  makeModelCity: function makeModelCity(data, p) {
    return {
      header: p.buy + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439 " + p.inCity + ". \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B, \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0444\u043E\u0442\u043E",
      description_uk: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u0440\u0438\u0446\u0438\u043A\u043B\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 " + p.t(data.city) + ". \u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C " + p.inCity + ". \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438, \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u0444\u043E\u0442\u043E"
    };
  },
  makeModelIsnew: function makeModelIsnew(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u043D\u0435\u0434\u043E\u0440\u043E\u0433\u043E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeCityIsnew: function makeCityIsnew(data, p) {
    return {
      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  makeModelBody: function makeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443"
    };
  },
  makeModelYear: function makeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430 \u0431\u0443",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443 \u0431\u0443"
    };
  },
  isnewMakeBody: function isnewMakeBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make
    };
  },
  makeCityBody: function makeCityBody(data, p) {
    return {
      header: p.buy + " " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " \u0431\u0443 " + p.inCity
    };
  },
  isnewBodyCity: function isnewBodyCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + p.inCity
    };
  },

  isnewMakeModelYear: function isnewMakeModelYear(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0433\u043E\u0434\u0430",
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u0440\u043E\u043A\u0443",

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u044B\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + data.year + " \u043D\u043E\u0432\u0438\u0439 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelCity: function isnewMakeModelCity(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,

      title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u044B\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439. \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u044B \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u0432",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u043D\u043E\u0432\u0438\u0439 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u044C. \u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0446\u0456\u043D\u0438 \u0432 \u043C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430\u0445 \u0456 \u0432\u0456\u0434 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0456\u0432"
    };
  },
  isnewMakeModelBody: function isnewMakeModelBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  },
  makeModelCityBody: function makeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " \u0431\u0443 " + p.inCity
    };
  },
  isnewMakeCityBody: function isnewMakeCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + p.inCity
    };
  },

  isnewMakeModelCityBody: function isnewMakeModelCityBody(data, p) {
    return {
      header: "\u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 " + p.t(data.body).toLowerCase() + " \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model + " " + p.inCity
    };
  }
};

/* harmony default export */ var tritsikl_templates_defaultExport = (tritsikl_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/search/tritsikl/index.js


var TRITSIKL = {
    city: tritsikl_templates_defaultExport.city,
    make: tritsikl_templates_defaultExport.make,
    body: tritsikl_templates_defaultExport.body,

    city_make: tritsikl_templates_defaultExport.makeCity,
    make_model: tritsikl_templates_defaultExport.makeModel,
    city_isnew: tritsikl_templates_defaultExport.cityIsnew,
    isnew_make: tritsikl_templates_defaultExport.makeIsnew,
    body_make: tritsikl_templates_defaultExport.makeBody,
    body_isnew: tritsikl_templates_defaultExport.bodyIsnew,
    body_city: tritsikl_templates_defaultExport.bodyCity,

    city_make_model: tritsikl_templates_defaultExport.makeModelCity,
    isnew_make_model: tritsikl_templates_defaultExport.makeModelIsnew,
    city_isnew_make: tritsikl_templates_defaultExport.makeCityIsnew,
    body_make_model: tritsikl_templates_defaultExport.makeModelBody,
    make_model_year: tritsikl_templates_defaultExport.makeModelYear,
    body_isnew_make: tritsikl_templates_defaultExport.isnewMakeBody,
    body_city_make: tritsikl_templates_defaultExport.makeCityBody,
    body_city_isnew: tritsikl_templates_defaultExport.isnewBodyCity,

    isnew_make_model_year: tritsikl_templates_defaultExport.isnewMakeModelYear,
    city_isnew_make_model: tritsikl_templates_defaultExport.isnewMakeModelCity,
    body_isnew_make_model: tritsikl_templates_defaultExport.isnewMakeModelBody,
    body_city_make_model: tritsikl_templates_defaultExport.makeModelCityBody,
    body_city_isnew_make: tritsikl_templates_defaultExport.isnewMakeCityBody,

    body_city_isnew_make_model: tritsikl_templates_defaultExport.isnewMakeModelCityBody
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avto/templates.js
var avto_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u044B, \u0446\u0435\u043D\u044B, \u0430\u043A\u0446\u0438\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E \u0438\u0437 \u0441\u0430\u043B\u043E\u043D\u0430 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432, \u0441\u043A\u0438\u0434\u043A\u0438 \u043D\u0430 \u043D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0430 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city),
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u0423\u0441\u0456 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0438, \u0446\u0456\u043D\u0438, \u0430\u043A\u0446\u0456\u0457 \u043D\u0430 \u0430\u0432\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432, \u0437\u043D\u0438\u0436\u043A\u0438 \u043D\u0430 \u043D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0443 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city)
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + data.make + " " + p.inCity + ". \u0426\u0435\u043D\u044B, \u0430\u043A\u0446\u0438\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E \u0438\u0437 \u0441\u0430\u043B\u043E\u043D\u0430 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432 " + data.make + " \u043D\u0430 \u043D\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + data.make + " " + p.inCity,
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + data.make + " " + p.inCity + ". \u0426\u0456\u043D\u0438, \u0430\u043A\u0446\u0456\u0457 \u043D\u0430 \u0430\u0432\u0442\u043E \u0437 \u0441\u0430\u043B\u043E\u043D\u0443 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432 " + data.make + " \u043D\u0430 \u043D\u043E\u0432\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var avto_templates_defaultExport = (avto_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avto/index.js


var avto_AVTO = {
  city: avto_templates_defaultExport.city,
  city_make: avto_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/gruzovye/templates.js
var gruzovye_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0433\u0440\u0443\u0437\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 " + p.t(data.city) + ". \u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0438 \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0433\u0440\u0443\u0437\u043E\u0432\u044B\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 " + p.t(data.city),
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0438\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 " + p.t(data.city) + ". \u0423\u0441\u0456 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0456 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0438 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0438\u0445 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 " + p.t(data.city)
    };
  }
};

/* harmony default export */ var gruzovye_templates_defaultExport = (gruzovye_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/gruzovye/index.js


var GRUZOVYE = {
  city: gruzovye_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avtobus/templates.js
var avtobus_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.t(data.city) + ". \u0412\u0441\u0435 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0431\u0443\u0441\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u043E\u0432. \u0411\u0443\u0441 \u0441 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0435\u0439. \u0417\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0431\u0443\u0441\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.t(data.city),
      title_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.t(data.city) + ". \u0423\u0441\u0456 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0431\u0443\u0441\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0456\u0432. \u0411\u0443\u0441 \u0437 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0454\u044E. \u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432 \u0431\u0443\u0441\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0410\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.t(data.city)
    };
  }
};

/* harmony default export */ var avtobus_templates_defaultExport = (avtobus_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/avtobus/index.js


var AVTOBUS = {
  city: avtobus_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/vodnyi-transport/templates.js
var vodnyi_transport_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u0430\u043B\u043E\u043D\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + p.inCity,
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u0441\u0430\u043B\u043E\u043D\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + p.inCity
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + data.make + " " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + data.make + " \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 " + data.make + " " + p.inCity,
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + data.make + " " + p.inCity + ". \u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + data.make + " \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0432\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var vodnyi_transport_templates_defaultExport = (vodnyi_transport_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/vodnyi-transport/index.js


var VODNYI_TRANSPORT = {
  city: vodnyi_transport_templates_defaultExport.city,
  city_make: vodnyi_transport_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/mototsikl/templates.js
var mototsikl_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u041C\u0430\u0433\u0430\u0437\u0438\u043D\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u043E\u0432, \u0441\u043A\u0443\u0442\u0435\u0440\u043E\u0432, \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u0446\u0435\u043D\u044B \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0441 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0435\u0439 \u043E\u0442 \u0441\u0430\u043B\u043E\u043D\u0430 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043C\u043E\u0442\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u044B " + p.t(data.city),
      title_uk: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u041C\u0430\u0433\u0430\u0437\u0438\u043D\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B\u0456\u0432, \u0441\u043A\u0443\u0442\u0435\u0440\u0456\u0432, \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u0446\u0456\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0437 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0454\u044E \u0432\u0456\u0434 \u0441\u0430\u043B\u043E\u043D\u0443 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043C\u043E\u0442\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u041C\u043E\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0438 " + p.t(data.city)
    };
  }
};

/* harmony default export */ var avtosalony_mototsikl_templates_defaultExport = (mototsikl_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/mototsikl/index.js


var mototsikl_MOTOTSIKL = {
  city: avtosalony_mototsikl_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/pritsepy/templates.js
var pritsepy_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u0434\u0438\u043B\u0435\u0440\u044B \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city) + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u0438\u0446\u0435\u043F\u044B. \u0410\u043A\u0446\u0438\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0434\u0438\u043B\u0435\u0440\u043E\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city),
      title_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u0434\u0438\u043B\u0435\u0440\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city) + ". \u041A\u0440\u0430\u0449\u0456 \u0446\u0456\u043D\u0438 \u043D\u0430 \u043F\u0440\u0438\u0447\u0435\u043F\u0438. \u0410\u043A\u0446\u0456\u0457 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city)
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0434\u0438\u043B\u0435\u0440\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + data.make + " " + p.inCity + ". \u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0435 \u0434\u0438\u043B\u0435\u0440\u044B \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + data.make + " " + p.inCity,
      title_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + data.make + " " + p.inCity + ". \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0456 \u0434\u0438\u043B\u0435\u0440\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0438 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var pritsepy_templates_defaultExport = (pritsepy_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/pritsepy/index.js

// body country city drive engine gearbox generation isNew location make makeTranslate model year

var PRITSEPY = {
  city: pritsepy_templates_defaultExport.city,
  city_make: pritsepy_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/spetstehnika/templates.js
var spetstehnika_templates_avtoPathesHead = {
  city: function city(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u0434\u0438\u043B\u0435\u0440\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + p.t(data.city),
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + p.t(data.city)
    };
  },
  cityMake: function cityMake(data, p) {
    return {
      title: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043E\u0442 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u043E\u0432 - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      description: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + data.make + " " + p.inCity + ". \u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0443 " + data.make + " \u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0445 \u0434\u0438\u043B\u0435\u0440\u043E\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0430 \u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440",
      header: "\u0414\u0438\u043B\u0435\u0440\u044B \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0438 " + data.make + " " + p.inCity,
      title_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0432\u0456\u0434 \u0430\u0432\u0442\u043E\u0434\u0438\u043B\u0435\u0440\u0456\u0432 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      description_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + data.make + " " + p.inCity + ". \u041A\u0440\u0430\u0449\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0430 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0443 " + data.make + " \u0432\u0456\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u0434\u0438\u043B\u0435\u0440\u0456\u0432 \u2705 \u0430\u0434\u0440\u0435\u0441\u0438 \u0456 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439 \u260E\uFE0F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      header_uk: "\u0414\u0438\u043B\u0435\u0440\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0438 " + data.make + " " + p.inCity
    };
  }
};

/* harmony default export */ var spetstehnika_templates_defaultExport = (spetstehnika_templates_avtoPathesHead);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/spetstehnika/index.js


var SPETSTEHNIKA = {
  city: spetstehnika_templates_defaultExport.city,
  city_make: spetstehnika_templates_defaultExport.cityMake
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates.js
/* harmony default export */ var zapchasti_avto_templates_defaultExport = ({
  transport: function transport() {
    return {
      title: 'Автозапчасти Украина. Купить запчасти на авто бу и новые. Продажа запчастей для автомобилей иномарок - Автобазар',
      title_uk: 'Автозапчастини Україна. Купити запчастини на авто бу і нові. Продаж запчастин для автомобілів іномарок - Автобазар',

      description: 'Купить автозапчасти в Украине: новые и бу запчасти на авто. Электронный каталог автомобильных запчастей на машины иномарки. Заказ и продажа запчастей на автомобили круглосуточно 24/7 по интернету на сайте Автобазар.',
      description_uk: 'Купити автозапчастини в Україні: нові та бу запчастини на авто. Електронний каталог автомобільних запчастин на іномарки. Заказ та продаж запчастин на автомобілі цілодобово 24/7 по інтернету на сайті Автобазар',

      header: 'Автозапчасти в Украине',
      header_uk: 'Автозапчастини в Україні'
    };
  },

  make: function make(data) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.makeTranslate + ': \u043A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.makeTranslate + ': \u043A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439 ' + data.makeTranslate + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2B50 \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0456\u0432 ' + data.makeTranslate + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2B50 \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0456 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0456',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456'
    };
  },

  make_model: function make_model(data) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 ' + data.makeTranslate + ' ' + data.modelTranslate + ': \u043A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F  ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 ' + data.makeTranslate + ' ' + data.modelTranslate + ': \u043A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.makeTranslate + ' ' + data.modelTranslate + ' \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2B50 \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.makeTranslate + ' ' + data.modelTranslate + ' \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2B50 \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0456 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0456',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456'
    };
  },

  city: function city(data, p) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E \u043A\u0443\u043F\u0438\u0442\u044C ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E \u043A\u0443\u043F\u0438\u0442\u0438 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E ' + p.inCity + ' \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440 \u2705 \u0423\u0434\u043E\u0431\u043D\u044B\u0439 \u043F\u043E\u0438\u0441\u043A \u043F\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u043C \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u0412\u0430\u043C \u0431\u044B\u0441\u0442\u0440\u043E \u0438 \u043B\u0435\u0433\u043A\u043E \u043A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E \u043F\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0439 \u0446\u0435\u043D\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E ' + p.inCity + ' \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440 \u2705 \u0417\u0440\u0443\u0447\u043D\u0438\u0439 \u043F\u043E\u0448\u0443\u043A \u043F\u043E \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0435 \u0412\u0430\u043C \u0448\u0432\u0438\u0434\u043A\u043E \u0456 \u043B\u0435\u0433\u043A\u043E \u043A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E \u0437\u0430 \u0432\u0438\u0433\u0456\u0434\u043D\u043E\u044E \u0446\u0456\u043D\u043E\u044E',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043B\u0435\u0433\u043A\u043E\u0432\u044B\u0435 \u0430\u0432\u0442\u043E ' + p.inCity,
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u041B\u0435\u0433\u043A\u043E\u0432\u0456 \u0430\u0432\u0442\u043E ' + p.inCity
    };
  },

  city_make: function city_make(data, p) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + p.inCity + '. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0434\u043B\u044F ' + data.make + ' ' + p.inCity + ' \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + p.inCity + '. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0434\u043B\u044F ' + data.make + ' ' + p.inCity + ' \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + p.inCity,
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + p.inCity
    };
  },

  city_make_model: function city_make_model(data, p) {
    return {
      title: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 ' + p.inCity + ' - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity + '. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity + '. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F ' + data.make + ' ' + data.model + ' \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      header: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity,
      header_uk: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 ' + data.make + ' ' + data.model + ' ' + p.inCity
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_mahovik.js
/* harmony default export */ var templates_dvigatel_mahovik_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u041C\u0430\u0445\u043E\u0432\u0438\u043A " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043C\u0430\u0445\u043E\u0432\u0438\u043A " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_patrubki.js
/* harmony default export */ var templates_dvigatel_patrubki_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u041F\u0430\u0442\u0440\u0443\u0431\u043A\u0438 " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043F\u0430\u0442\u0440\u0443\u0431\u043E\u043A \u0434\u043B\u044F " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_dvigatel_klapan-egr.js
/* harmony default export */ var templates_dvigatel_klapan_egr_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u041A\u043B\u0430\u043F\u0430\u043D EGR \u0434\u043B\u044F " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u043A\u043B\u0430\u043F\u0430\u043D EGR \u0434\u043B\u044F " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_elektrika-i-elektronika_datchik-abs.js
/* harmony default export */ var templates_elektrika_i_elektronika_datchik_abs_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u0414\u0430\u0442\u0447\u0438\u043A ABS " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0434\u0430\u0442\u0447\u0438\u043A ABS " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/templates_elektrika-i-elektronika_datchik.js
/* harmony default export */ var templates_elektrika_i_elektronika_datchik_defaultExport = ({
  make: function make(data) {
    return {
      header: "\u0414\u0430\u0442\u0447\u0438\u043A\u0438 \u0434\u043B\u044F " + data.make,
      header_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0434\u0430\u0442\u0447\u0438\u043A\u0438 \u0434\u043B\u044F " + data.make
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avto/index.js







var AUTO = {
  transport: zapchasti_avto_templates_defaultExport.transport,
  make: zapchasti_avto_templates_defaultExport.make,
  make_model: zapchasti_avto_templates_defaultExport.make_model,

  city: zapchasti_avto_templates_defaultExport.city,
  city_make: zapchasti_avto_templates_defaultExport.city_make,
  city_make_model: zapchasti_avto_templates_defaultExport.city_make_model
};

var AVTO_DVIGATEL_MAHOVIK = {
  make: templates_dvigatel_mahovik_defaultExport.make
};

var AVTO_DVIGATEL_PATRUBKI = {
  make: templates_dvigatel_patrubki_defaultExport.make
};

var AVTO_DVIGATEL_KLAPANI__EGR = {
  make: templates_dvigatel_klapan_egr_defaultExport.make
};

var AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI = {
  make: templates_elektrika_i_elektronika_datchik_defaultExport.make
};

var AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS = {
  make: templates_elektrika_i_elektronika_datchik_abs_defaultExport.make
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avtobus/templates.js
/* harmony default export */ var zapchasti_avtobus_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u044B \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 \u043E\u0442 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432, \u0430\u0432\u0442\u043E\u0440\u0430\u0437\u0431\u043E\u0440\u043E\u043A \u0438 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043B\u0438\u0446",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0456\u0432 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 \u0432\u0456\u0434 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0438\u0445 \u0456\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432, \u0430\u0432\u0442\u043E\u0440\u0430\u0437\u0431\u043E\u0440\u043E\u043A \u0456 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043E\u0441\u0456\u0431",

      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441 " + p.inCity
    };
  },

  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u044B " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435",
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u0438 " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/avtobus/index.js


var avtobus_AVTOBUS = {
  city: zapchasti_avtobus_templates_defaultExport.city,
  make_model: zapchasti_avtobus_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/gruzovye/templates.js
/* harmony default export */ var zapchasti_gruzovye_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043A \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0430\u043C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 \u043E\u0442 \u043F\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u044B\u043C \u0446\u0435\u043D\u0430\u043C",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0430\u0432\u0442\u043E\u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + p.inCity + " \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043E \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 \u0432\u0456\u0434 \u0437\u0430 \u0432\u0438\u0433\u0456\u0434\u043D\u0438\u043C\u0438 \u0446\u0456\u043D\u0430\u043C\u0438",

      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + p.inCity,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + p.inCity
    };
  },

  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u043E\u0432 " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043E\u043A " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/gruzovye/index.js


var gruzovye_GRUZOVYE = {
  city: zapchasti_gruzovye_templates_defaultExport.city,
  make_model: zapchasti_gruzovye_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moto/templates.js
/* harmony default export */ var zapchasti_moto_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0443 " + p.inCity + ". \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0443 " + p.inCity + ". \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E",

      header: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 " + p.t(data.city),
      header_uk: "\u041C\u043E\u0442\u043E\u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 " + p.t(data.city)
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moto/index.js


var moto_MOTO = {
  city: zapchasti_moto_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/skuter/templates.js
/* harmony default export */ var zapchasti_skuter_templates_defaultExport = ({
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440  " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0441\u043A\u0443\u0442\u0435\u0440 " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/skuter/index.js


var skuter_SKUTER = {
  make: zapchasti_skuter_templates_defaultExport.make,
  make_model: zapchasti_skuter_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/mototsikl/templates.js
/* harmony default export */ var zapchasti_mototsikl_templates_defaultExport = ({
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u0442\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/mototsikl/index.js


var zapchasti_mototsikl_MOTOTSIKL = {
  make: zapchasti_mototsikl_templates_defaultExport.make,
  make_model: zapchasti_mototsikl_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/kvadrotsikl/templates.js
/* harmony default export */ var zapchasti_kvadrotsikl_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity + ". \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u043E\u0432 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + p.inCity + ". \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B\u0456\u0432 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E"
    };
  },
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043A\u0432\u0430\u0434\u0440\u043E\u0446\u0438\u043A\u043B " + data.make + " " + data.model
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/kvadrotsikl/index.js


var kvadrotsikl_KVADROTSIKL = {
  city: zapchasti_kvadrotsikl_templates_defaultExport.city,
  make: zapchasti_kvadrotsikl_templates_defaultExport.make,
  make_model: zapchasti_kvadrotsikl_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moped/templates.js
/* harmony default export */ var zapchasti_moped_templates_defaultExport = ({
  make: function make(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make
    };
  },
  make_model: function make_model(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model,

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u044B " + data.make + " " + data.model + " \u043A\u0443\u043F\u0438\u0442\u044C \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435 \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434\u0438 " + data.make + " " + data.model + " \u043A\u0443\u043F\u0438\u0442\u0438 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456 \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043C\u043E\u043F\u0435\u0434\u043E\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0444\u043E\u0442\u043E, \u0446\u0435\u043D\u0430\u043C\u0438",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u043C\u043E\u043F\u0435\u0434 " + data.make + " " + data.model + " \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043C\u043E\u043F\u0435\u0434\u0456\u0432 " + data.make + " " + data.model + " \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0444\u043E\u0442\u043E, \u0446\u0456\u043D\u0430\u043C\u0438"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/moped/index.js


var moped_MOPED = {
  make: zapchasti_moped_templates_defaultExport.make,
  make_model: zapchasti_moped_templates_defaultExport.make_model
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/spetstehnika/templates.js
/* harmony default export */ var zapchasti_spetstehnika_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 " + p.t(data.city),
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 " + p.t(data.city),

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0441\u043F\u0435\u0446\u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0438\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/spetstehnika/index.js


var spetstehnika_SPETSTEHNIKA = {
  city: zapchasti_spetstehnika_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/pritsepy/templates.js
/* harmony default export */ var zapchasti_pritsepy_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 " + p.t(data.city),
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 " + p.t(data.city),

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u0430 " + p.inCity + ". \u0412 \u043F\u0440\u043E\u0434\u0430\u0436\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F \u043B\u0435\u0433\u043A\u043E\u0432\u044B\u0445 \u043F\u0440\u0438\u0446\u0435\u043F\u043E\u0432 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0435. \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0430 " + p.inCity + ". \u0423 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0434\u043B\u044F \u043B\u0435\u0433\u043A\u043E\u0432\u0438\u0445 \u043F\u0440\u0438\u0447\u0435\u043F\u0456\u0432 \u0431\u0443 \u0456 \u043D\u043E\u0432\u0456. \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440 \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/pritsepy/index.js


var pritsepy_PRITSEPY = {
  city: zapchasti_pritsepy_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/tritsikl/templates.js
/* harmony default export */ var zapchasti_tritsikl_templates_defaultExport = ({
    makeModel: function makeModel(data) {
        return {
            header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model,
            header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0442\u0440\u0438\u0446\u0438\u043A\u043B " + data.make + " " + data.model
        };
    }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/tritsikl/index.js


var tritsikl_TRITSIKL = {
    make_model: zapchasti_tritsikl_templates_defaultExport.makeModel
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/vodnyi-transport/templates.js
/* harmony default export */ var zapchasti_vodnyi_transport_templates_defaultExport = ({
  city: function city(data, p) {
    return {
      header: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.t(data.city),
      header_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.t(data.city),

      title: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u043A\u0443\u043F\u0438\u0442\u044C " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",
      title_uk: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u043A\u0443\u043F\u0438\u0442\u0438 " + p.inCity + " - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440",

      description: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.inCity + ". \u0411\u043E\u043B\u044C\u0448\u043E\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0441\u0443\u0434\u043E\u0432\u044B\u0445 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0435\u0439 \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0441 \u0446\u0435\u043D\u0430\u043C\u0438 \u0438 \u0444\u043E\u0442\u043E. \u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u043E\u0442 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0438\u043B\u043B\u0435\u0440\u043E\u0432 \u0438 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043B\u0438\u0446",
      description_uk: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0430 \u0432\u043E\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 " + p.inCity + ". \u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0441\u0443\u0434\u043D\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D \u0431\u0443 \u0442\u0430 \u043D\u043E\u0432\u0438\u0445 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440. \u041E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F \u0437 \u0446\u0456\u043D\u0430\u043C\u0438 \u0456 \u0444\u043E\u0442\u043E. \u041F\u0440\u043E\u0434\u0430\u0436 \u0432\u0456\u0434 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0438\u0445 \u0434\u0438\u043B\u043B\u0435\u0440\u0456\u0432 \u0456 \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0445 \u043E\u0441\u0456\u0431"
    };
  }
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/zapchasti/vodnyi-transport/index.js


var vodnyi_transport_VODNYI_TRANSPORT = {
  city: zapchasti_vodnyi_transport_templates_defaultExport.city
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/commercial/gruzovye/templates.js
var upperCaseFirst = function upperCaseFirst(str) {
  var safeStr = str || '';
  return safeStr.charAt(0).toUpperCase() + safeStr.substr(1);
};

var templates_path = {
  transporttype: function transporttype(data) {
    return {
      header: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.transportTypePluralGenitive + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.transportTypePluralGenitive + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456',

      title: upperCaseFirst(data.transportTypePlural) + ': \u043A\u0443\u043F\u0438\u0442\u044C ' + data.transportTitle + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: upperCaseFirst(data.transportTypePlural) + ': \u043A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTitle + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.transportTitle + ' \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0439 \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0438 \u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTitle + ' \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u043D\u043E\u0432\u0438\u0439 \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0442\u0430 \u0432\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  make_transporttype: function make_transporttype(data) {
    return {
      header: upperCaseFirst(data.transportTypePlural) + ' ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435',
      header_uk: upperCaseFirst(data.transportTypePlural) + ' ' + data.make + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456',

      title: upperCaseFirst(data.transportTitle) + ' ' + data.makeTranslit + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435, \u043A\u0443\u043F\u0438\u0442\u044C ' + data.transportTypePlural + ' ' + data.make + ' \u0431\u0443 \u0438\u043B\u0438 \u043D\u043E\u0432\u044B\u0435 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: upperCaseFirst(data.transportTitle) + ' ' + data.makeTranslit + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456, \u043A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTypePlural + ' ' + data.make + ' \u0431\u0443 \u0430\u0431\u043E \u043D\u043E\u0432\u0456 - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.transportTypePlural + ' ' + data.make + ' \u043D\u043E\u0432\u044B\u0435 \u0438\u043B\u0438 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u2B50 \u0426\u0435\u043D\u044B \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0438 \u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u0432\u044B\u0431\u043E\u0440 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.transportTypePlural + ' ' + data.make + ' \u043D\u043E\u0432\u0456 \u0430\u0431\u043E \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u2B50 \u0426\u0456\u043D\u0438 \u043D\u0430 ' + data.transportTypePlural + ', \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438, \u0444\u043E\u0442\u043E \u0442\u0430 \u0432\u0435\u043B\u0438\u043A\u0438\u0439 \u0432\u0438\u0431\u0456\u0440 \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443 \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440'
    };
  },

  make_model_transporttype: function make_model_transporttype(data) {
    return {
      header: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.make + ' ' + data.model,
      header_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.make + ' ' + data.model,

      title: '\u041F\u0440\u043E\u0434\u0430\u0436\u0430 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u0431\u0443 \u0438 \u043D\u043E\u0432\u044B\u0445: \u043A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435. \u0426\u0435\u043D\u0430 \u043D\u0430 \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0438, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',
      title_uk: '\u041F\u0440\u043E\u0434\u0430\u0436 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u0431\u0443 \u0442\u0430 \u043D\u043E\u0432\u0438\u0445: \u043A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456. \u0426\u0456\u043D\u0430 \u043D\u0430 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0438, \u0444\u043E\u0442\u043E - \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440',

      description: '\u041A\u0443\u043F\u0438\u0442\u044C ' + data.make + ' ' + data.model + ' \u043D\u043E\u0432\u044B\u0435 \u0438 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \uD83D\uDE8C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435 \u2B50 \u0423\u0434\u043E\u0431\u043D\u044B\u0439 \u043F\u043E\u0438\u0441\u043A \u043F\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F\u043C \u043F\u043E\u043C\u043E\u0436\u0435\u0442 \u0412\u0430\u043C \u043A\u0443\u043F\u0438\u0442\u044C \u0433\u0440\u0443\u0437\u043E\u0432\u0438\u043A\u0438 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u043F\u043E \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0439 \u0446\u0435\u043D\u0435 \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0435',
      description_uk: '\u041A\u0443\u043F\u0438\u0442\u0438 ' + data.make + ' ' + data.model + ' \u043D\u043E\u0432\u0456 \u0442\u0430 \u0437 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \uD83D\uDE8C \u0432 \u0423\u043A\u0440\u0430\u0457\u043D\u0456 \u2B50 \u0417\u0440\u0443\u0447\u043D\u0438\u0439 \u043F\u043E\u0448\u0443\u043A \u043F\u043E \u043E\u0433\u043E\u043B\u043E\u0448\u0435\u043D\u043D\u044F\u0445 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0435 \u0412\u0430\u043C \u043A\u0443\u043F\u0438\u0442\u0438 \u0432\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0438 ' + data.makeTranslit + ' ' + data.modelTranslit + ' \u0437\u0430 \u0432\u0438\u0433\u0456\u0434\u043D\u043E\u044E \u0446\u0456\u043D\u043E\u044E \u043D\u0430 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u0456'
    };
  }
};

/* harmony default export */ var commercial_gruzovye_templates_defaultExport = (templates_path);
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/commercial/gruzovye/index.js


var COMMERCIAL_GRUZOVYE = {
  transporttype: commercial_gruzovye_templates_defaultExport.transporttype,
  make_transporttype: commercial_gruzovye_templates_defaultExport.make_transporttype,
  make_model_transporttype: commercial_gruzovye_templates_defaultExport.make_model_transporttype
};
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/seoTemplates/index.js








































/* harmony default export */ var seoTemplates_defaultExport = ({
  AVTO: AVTO,
  MOTO: MOTO,
  MOTOTSIKL: MOTOTSIKL,
  SKUTER: SKUTER,
  KVADROTSIKL: KVADROTSIKL,
  MOPED: MOPED,
  BAGGI: BAGGI,
  TRITSIKL: TRITSIKL,

  AVTOSALONY_AVTO: avto_AVTO,
  AVTOSALONY_GRUZOVYE: GRUZOVYE,
  AVTOSALONY_AVTOBUS: AVTOBUS,
  AVTOSALONY_VODNYI_TRANSPORT: VODNYI_TRANSPORT,
  AVTOSALONY_MOTOTSIKL: mototsikl_MOTOTSIKL,
  AVTOSALONY_PRITSEPY: PRITSEPY,
  AVTOSALONY_SPETSTEHNIKA: SPETSTEHNIKA,

  ZAPCHASTI_AVTO: AUTO,
  ZAPCHASTI_MOTO: moto_MOTO,
  ZAPCHASTI_AVTOBUS: avtobus_AVTOBUS,
  ZAPCHASTI_PRITSEPY: pritsepy_PRITSEPY,
  ZAPCHASTI_GRUZOVYE: gruzovye_GRUZOVYE,
  ZAPCHASTI_TRITSIKL: tritsikl_TRITSIKL,
  ZAPCHASTI_SPETSTEHNIKA: spetstehnika_SPETSTEHNIKA,
  ZAPCHASTI_VODNYI_TRANSPORT: vodnyi_transport_VODNYI_TRANSPORT,

  ZAPCHASTI_AVTO_DVIGATEL_MAHOVIK: AVTO_DVIGATEL_MAHOVIK,

  ZAPCHASTI_AVTO_DVIGATEL_PATRUBKI: AVTO_DVIGATEL_PATRUBKI,
  ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI: AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI,
  ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS: AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS,
  ZAPCHASTI_AVTO_DVIGATEL_KLAPANI__EGR: AVTO_DVIGATEL_KLAPANI__EGR,

  ZAPCHASTI_SKUTER: skuter_SKUTER,
  ZAPCHASTI_MOTOTSIKL: zapchasti_mototsikl_MOTOTSIKL,
  ZAPCHASTI_KVADROTSIKL: kvadrotsikl_KVADROTSIKL,
  ZAPCHASTI_MOPED: moped_MOPED,

  COMMERCIAL_GRUZOVYE: COMMERCIAL_GRUZOVYE
});
// CONCATENATED MODULE: ./src/shared/helpers/seoTextFinder/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return seoTextFinder_getSeoDataByParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__seoDataFinder__ = __webpack_require__(1252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable no-param-reassign */



/* import { AVTO } from './seoTemplates/search/avto';
import { AVTOSALONY } from './avtosalony'; */

var avaliableTransports = {
  легковые: 'AVTO',
  'водный транспорт': 'VODNYI_TRANSPORT',
  автобусы: 'AVTOBUS',
  грузовые: 'GRUZOVYE',
  мотоциклы: 'MOTOTSIKL',
  прицепы: 'PRITSEPY',
  спецтехника: 'SPETSTEHNIKA',

  мототранспорт: 'MOTO',
  грузовики: 'GRUZOVYE',

  // UK
  легкові: 'AVTO',
  'водний транспорт': 'VODNYI_TRANSPORT',
  автобуси: 'AVTOBUS',
  вантажні: 'GRUZOVYE',
  мотоцикли: 'MOTOTSIKL',
  причепи: 'PRITSEPY',
  спецтехніка: 'SPETSTEHNIKA',

  avto: 'AVTO',
  moto: 'MOTO',

  'vodnyi-transport': 'VODNYI_TRANSPORT',
  avtobus: 'AVTOBUS',
  gruzovye: 'GRUZOVYE',
  mototsikl: 'MOTOTSIKL',
  pritsepy: 'PRITSEPY',
  spetstehnika: 'SPETSTEHNIKA',

  kvadrotsikl: 'KVADROTSIKL',
  квадроцикл: 'KVADROTSIKL',

  moped: 'MOPED',
  мопед: 'MOPED',

  skuter: 'SKUTER',
  скутер: 'SKUTER',

  baggi: 'BAGGI',
  багги: 'BAGGI',
  баггі: 'BAGGI',

  трицикл: 'TRITSIKL',
  tritsikl: 'TRITSIKL'
};

var avaliableCategories = {
  avtosalony: 'AVTOSALONY',
  zapchasti: 'ZAPCHASTI',
  commercial: 'COMMERCIAL'
};

var avaliablePartTypes = {
  маховик: 'MAHOVIK',
  // патрубок: 'PATRUBOK',
  патрубки: 'PATRUBKI',
  датчики: 'DATCHIKI',
  'датчик abs': 'DATCHIKI__ABS',
  'клапан egr': 'KLAPANI__EGR'
};

var avaliableRubrics = {
  двигатель: 'DVIGATEL',
  Двигун: 'DVIGATEL',
  'электрика и электроника': 'ELEKTRIKA__I__ELEKTRONIKA'
};

// ZAPCHASTI_AVTO_DVIGATEL_PATRUBOK,
// ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI,
// ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS,
// ZAPCHASTI_AVTO_DVIGATEL_KLAPAN__EGR,

function getTransport(params) {
  // const key = params.transport ? params.transport.toLowerCase() : '';
  var key = params.transport ? params.transport.toLowerCase() : params.transportType ? params.transportType.toLowerCase() : '';
  if (!key || !avaliableTransports[key]) return avaliableTransports.avto;
  return avaliableTransports[key];
}

function getRubric(params) {
  var key = params.rubric ? params.rubric.toLowerCase().replace('-', '__') : '';
  if (!key || !avaliableRubrics[key]) return '';
  return avaliableRubrics[key];
}

function getPartType(params) {
  var key = params.partType ? params.partType.toLowerCase().replace('-', '__') : '';
  var keyUk = params.partTypeUk ? params.partTypeUk.toLowerCase().replace('-', '__') : '';
  if (!key || !avaliablePartTypes[key.toLowerCase()]) return '';
  return avaliablePartTypes[keyUk] || avaliablePartTypes[key];
}

function makePath(params, category) {
  var transportKey = getTransport(params);
  if (!category) return transportKey;

  var partType = getPartType(params);
  var rubric = getRubric(params);
  var path = avaliableCategories[category] + '_' + transportKey;
  return '' + path + (rubric ? '_' + rubric : '') + (partType ? '_' + partType : '');
}

/**
 * Get SEO texts by input params.
 * @param {object} params 
 * @param {object} path 
 * @param {function} t 
 * @returns {object} {header: 'h1 text', title: 'meta tag title', description: 'meta tag '}
 */
var seoTextFinder_getSeoDataByParams = function getSeoDataByParams(params, t, category) {
  var city = '';
  if (_typeof(params.city) === 'object' && params.city.is_city) {
    city = params.city.title || '';
  } else if (params.location && typeof params.location === 'string' && params.location !== (params.country && params.country.title)) {
    city = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][params.location] ? params.location : '';
  }

  var path = makePath(params, category);
  var seoDataLinks = seoTemplates_defaultExport[path];

  if (!seoDataLinks) {
    return {};
  }

  // console.log(params);
  var paramsToSeo = _extends({}, params, { city: city });
  return __WEBPACK_IMPORTED_MODULE_2__seoDataFinder__["b" /* paramsToSeoData */](paramsToSeo, seoDataLinks, t);
};

/***/ }),

/***/ 1255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var RegexpInput = function (_React$Component) {
  _inherits(RegexpInput, _React$Component);

  function RegexpInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RegexpInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegexpInput.__proto__ || Object.getPrototypeOf(RegexpInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          pattern = _this$props.pattern,
          onChange = _this$props.onChange;


      if (value.match(pattern) || value === '') {
        onChange(value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RegexpInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          inputRef = _props.inputRef,
          type = _props.type,
          props = _objectWithoutProperties(_props, ['onChange', 'inputRef', 'type']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ type: type, onChange: this.handleChange, ref: inputRef }, props));
    }
  }]);

  return RegexpInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RegexpInput.defaultProps = {
  pattern: '',
  value: undefined,
  inputRef: undefined,
  onChange: function onChange() {},
  type: 'text'
};


/* harmony default export */ __webpack_exports__["a"] = (RegexpInput);

/***/ }),

/***/ 1256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var isClient = true;

function ModalContainer(props) {
  var children = props.children,
      onClose = props.onClose,
      isOpen = props.isOpen,
      modalCN = props.modalCN;

  if (!isClient) return null;
  return isOpen && _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Modal__["a" /* default */], {}, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.root
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.background,
    onClick: onClose
  }), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.content, modalCN || __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.contentParams)
  }, void 0, children)));
}

ModalContainer.defaultProps = {
  isOpen: false,
  modalCN: '',
  onClose: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a)(ModalContainer));

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

module.exports = ["dvigatel","kuzov","otoplenie-i-konditsionirovanie","pritsepnoe-oborudovanie","razborka","rulevoe-upravlenie","salon","toplivnaya-sistema","tormoznaya-sistema","hodovaya"]

/***/ }),

/***/ 1258:
/***/ (function(module, exports) {

module.exports = ["dopolnitelnoe-oborudovanie","optika-steklo-zerkala","ochistiteli-stekla-i-far","sistema-bezopasnosti","sistema-ohlazhdeniya","transmissiya","filtry","shiny-diski","elektrika-i-elektronika"]

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var withBalance = function withBalance(forceUpdate) {
  return function (WrappedComponent) {
    var _class, _temp;

    var Component = (_temp = _class = function (_React$Component) {
      _inherits(Component, _React$Component);

      function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
      }

      _createClass(Component, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (forceUpdate || this.props.balance === null) {
            this.props.fetchBalance();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              __ = _props.fetchBalance,
              props = _objectWithoutProperties(_props, ['fetchBalance']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
        }
      }]);

      return Component;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withBalance(' + __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
      balance: null
    }, _temp);

    var mapStateToProps = function mapStateToProps(_ref) {
      var user = _ref.user;
      return {
        balance: user.balance.amount,
        isFetching: user.balance.isFetching
      };
    };
    var mapDispatchToProps = {
      fetchBalance: __WEBPACK_IMPORTED_MODULE_3_shared_actions_user__["g" /* fetchBalance */]
    };

    return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(Component);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withBalance);

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(319);
var TAG = __webpack_require__(86)('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),

/***/ 1261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CITY: 'city',
  COUNTRY: 'country'
});

/***/ }),

/***/ 1262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_routes__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__NavigationLink_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var NavigationLink = function (_React$Component) {
  _inherits(NavigationLink, _React$Component);

  function NavigationLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavigationLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavigationLink.__proto__ || Object.getPrototypeOf(NavigationLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          link = _this$props.link,
          eventPrefix = _this$props.eventPrefix,
          onClick = _this$props.onClick;

      onClick(e);
      if (!eventPrefix) return;

      var route = link.slug || link.route;
      var pattern = new RegExp('[/]{2,}', 'g');
      var slug = ('' + eventPrefix + route).replace(pattern, '/');
      var event = __WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].NAVIGATION_LINK[slug];
      if (event) _this.props.setDataLayer(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavigationLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          including = _props.including,
          locationType = _props.locationType,
          currentRoute = _props.currentRoute,
          link = _props.link,
          className = _props.className,
          activeClassName = _props.activeClassName,
          t = _props.t;
      var route = link.route,
          injectLocations = link.injectLocations,
          title = link.title,
          _link$count = link.count,
          count = _link$count === undefined ? '' : _link$count;


      var isActive = false;
      if (currentRoute) {
        isActive = including ? currentRoute.includes(((link.slug || link.route) + '/').replace(/\/\//g, '/')) : currentRoute === ((link.slug || link.route) + '/').replace(/\/\//g, '/');
      }

      return isActive ? _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(className, activeClassName)
      }, void 0, t(title), count && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a.count
      }, void 0, ' ', count)) : _jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_Link_Link__["a" /* default */], {
        onClick: this.handleClick,
        to: location && injectLocations && injectLocations.includes(locationType) && __WEBPACK_IMPORTED_MODULE_8_shared_helpers_routes__["b" /* isValidLeasingLocationRoute */](route, location.slug) ? __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__["d" /* injectLocationIntoHref */](route, location.slug) : route,
        className: className
      }, void 0, t(title), count && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a.count
      }, void 0, ' ', count));
    }
  }]);

  return NavigationLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavigationLink.defaultProps = {
  currentRoute: null,
  location: null,
  shouldCalculateActiveState: true,
  including: false,
  className: '',
  activeClassName: '',
  onClick: function onClick() {},
  eventPrefix: ''
};


var mapStateToProps = function mapStateToProps(_ref2) {
  var globals = _ref2.globals;
  return {
    location: globals.location,
    locationType: __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json___default.a.find(function (city) {
      return city.slug === (globals.location && globals.location.slug);
    }) ? __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__["a" /* default */].COUNTRY : __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__["a" /* default */].CITY
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDataLayer: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_13_shared_hocs_withTranslate__["a" /* withTranslate */](NavigationLink))));

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4c77a327.svg";

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1375);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1267:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='iso-8859-1'?%3E %3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='792.033px' height='792.033px' viewBox='0 0 792.033 792.033' style='enable-background:new 0 0 792.033 792.033;' xml:space='preserve'%3E %3Cg%3E %3Cg id='_x38_'%3E %3Cg%3E %3Cpath d='M617.858,370.896L221.513,9.705c-13.006-12.94-34.099-12.94-47.105,0c-13.006,12.939-13.006,33.934,0,46.874 l372.447,339.438L174.441,735.454c-13.006,12.94-13.006,33.935,0,46.874s34.099,12.939,47.104,0l396.346-361.191 c6.932-6.898,9.904-16.043,9.441-25.087C627.763,386.972,624.792,377.828,617.858,370.896z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/UI/InputText/InputText.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UIStyle_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var InputText = function InputText(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      inputParams = _objectWithoutProperties(_ref, ['changeHandler', 'name']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({
    className: __WEBPACK_IMPORTED_MODULE_3__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    }
  }, inputParams));
};

/* harmony default export */ var InputText_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__UIStyle_css__)(InputText));
// CONCATENATED MODULE: ./src/shared/components/UI/InputBirthday/InputBirthday.js
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UIStyle_css__);
var InputBirthday__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputBirthday__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var InputBirthday = function InputBirthday(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      mask = _ref.mask,
      placeholder = _ref.placeholder,
      inputParams = InputBirthday__objectWithoutProperties(_ref, ['changeHandler', 'name', 'mask', 'placeholder']);

  return InputBirthday___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, InputBirthday__extends({
    className: __WEBPACK_IMPORTED_MODULE_4__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    },
    placeholder: placeholder,
    mask: mask,
    maskChar: ' '
  }, inputParams));
};

InputBirthday.defaultProps = {
  value: '',
  mask: '99/99/9999',
  placeholder: '01/01/1990'
};

/* harmony default export */ var InputBirthday_defaultExport = (InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__UIStyle_css__)(InputBirthday));
// CONCATENATED MODULE: ./src/shared/components/UI/ContactButton/ContactButton.js
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ContactButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactButton_css__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var isMobile = "desktop" === 'mobile';

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041D\u0435\u0442 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u0432'
});

var ShowedContacts = function ShowedContacts(_ref) {
  var phones = _ref.phones;
  return _jsx('div', {
    className: isMobile ? null : __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.showedContainerDesktop
  }, void 0, phones.length ? phones.map(function (phone) {
    var nPhone = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["j" /* phoneNormalize */](phone);
    return _jsx('a', {
      href: 'tel:' + nPhone,
      className: isMobile ? __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.showedPhoneMobile : null
    }, phone, nPhone);
  }) : _ref2);
};

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u0435\u043B\u0435\u0444\u043E\u043D'
});

var HidedContacts = function HidedContacts(_ref3) {
  var clickHandler = _ref3.clickHandler;
  return _jsx('button', {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hided, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hidedMobile, isMobile)),
    onClick: clickHandler
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hidedContent
  }, void 0, _ref4, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hiddenPhone
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.Plus
  }, void 0, '+'), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.Dots
  }, void 0, '\u2022\u2022\u2022 \u2022\u2022 \u2022\u2022\u2022 \u2022\u2022 \u2022\u2022'))));
};

var ContactButton = function (_React$Component) {
  _inherits(ContactButton, _React$Component);

  function ContactButton() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = ContactButton.__proto__ || Object.getPrototypeOf(ContactButton)).call.apply(_ref5, [this].concat(args))), _this), _this.state = {
      isShowed: false,
      phones: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactButton, [{
    key: 'onClick',
    value: function onClick(e) {
      var _this2 = this;

      this.props.loadPhones(function (phones) {
        _this2.setState({ isShowed: true, phones: phones });
      });
      this.props.clickHandler(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var phonesState = this.props.phones.length ? this.props.phones : this.state.phones;
      var phones = phonesState.map(function (phone) {
        return phone.number ? phone.number : phone;
      });
      return _jsx(ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, this.state.isShowed ? _jsx(ShowedContacts, {
        phones: phones
      }) : _jsx(HidedContacts, {
        clickHandler: function clickHandler(e) {
          return _this3.onClick(e);
        }
      }));
    }
  }]);

  return ContactButton;
}(ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContactButton.defaultProps = {
  phones: [],
  clickHandler: function clickHandler() {},
  loadPhones: function loadPhones(cb) {
    return cb([]);
  }
};


ShowedContacts.defaultProps = {
  phones: []
};

HidedContacts.defaultProps = {
  clickHandler: function clickHandler() {}
};

/* harmony default export */ var ContactButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a)(ContactButton));
// CONCATENATED MODULE: ./src/shared/components/UI/InputPhoneNumber/InputPhoneNumber.js
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(479);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__);
var InputPhoneNumber__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputPhoneNumber__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var InputPhoneNumber = function InputPhoneNumber(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      mask = _ref.mask,
      placeholder = _ref.placeholder,
      inputParams = InputPhoneNumber__objectWithoutProperties(_ref, ['changeHandler', 'name', 'mask', 'placeholder']);

  return InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, InputPhoneNumber__extends({
    className: InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    }
  }, inputParams, {
    placeholder: placeholder,
    mask: mask,
    maskChar: ' ',
    type: 'tel'
  }));
};

InputPhoneNumber.defaultProps = {
  value: '',
  mask: '+3\\8 \\099 999 99 99',
  placeholder: '+38 (0**) *** ** **'
};

/* harmony default export */ var InputPhoneNumber_defaultExport = (InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__)(InputPhoneNumber));
// CONCATENATED MODULE: ./src/shared/components/UI/CheckBox/CheckBox.js
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CheckBox_css__);
var CheckBox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CheckBox__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function CheckBox__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var CheckBox = function CheckBox(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      text = _ref.text,
      inputParams = CheckBox__objectWithoutProperties(_ref, ['changeHandler', 'name', 'text']);

  return CheckBox__jsx('label', {
    className: __WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default.a.checkbox
  }, void 0, CheckBox___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', CheckBox__extends({ type: 'checkbox', name: name, onChange: changeHandler }, inputParams)), ' ', CheckBox__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
    id: text
  }));
};

CheckBox.defaultProps = {
  changeHandler: function changeHandler() {}
};

/* harmony default export */ var CheckBox_defaultExport = (CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default.a)(CheckBox));
// CONCATENATED MODULE: ./src/shared/components/UI/TagButton/TagButton.js
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagButton_css__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TagButton_css__);
var TagButton__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TagButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function TagButton__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TagButton__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var TagButton = function TagButton(_ref) {
  var _cx;

  var title = _ref.title,
      clickHandler = _ref.clickHandler,
      Icon = _ref.Icon,
      disabled = _ref.disabled,
      className = _ref.className,
      inputParams = TagButton__objectWithoutProperties(_ref, ['title', 'clickHandler', 'Icon', 'disabled', 'className']);

  return TagButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    TagButton__extends({
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a((_cx = {}, TagButton__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a.tag, true), TagButton__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a.disabled, disabled), TagButton__defineProperty(_cx, className, !!className), _cx)),
      onClick: function onClick(e) {
        clickHandler(e, title);
      }
    }, inputParams),
    Icon ? TagButton__jsx(Icon, {}) : null,
    title
  );
};

TagButton.defaultProps = {
  disabled: false,
  className: '',
  Icon: null,
  clickHandler: function clickHandler() {}
};

/* harmony default export */ var TagButton_defaultExport = (TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a)(TagButton));
// CONCATENATED MODULE: ./src/shared/components/UI/Select/Select.js
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Select___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(477);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_css__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Select_css__);
var Select__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function Select__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var SelectWrapper = function SelectWrapper(params) {
  return Select__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Select_css___default.a.root, Select__defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Select_css___default.a['theme-' + params.theme], params.theme && __WEBPACK_IMPORTED_MODULE_4__Select_css___default.a['theme-' + params.theme]))
  }, void 0, Select___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], params));
};

/* harmony default export */ var Select_defaultExport = (Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Select_css___default.a)(SelectWrapper));
// CONCATENATED MODULE: ./src/shared/components/UI/NumberInputWithSelect/SelectInput/SelectInput.js
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_css__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelectInput_css__);
var SelectInput__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SelectInput__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SelectInput__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelectInput__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SelectInput__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




 // eslint-disable-line css-modules/no-unused-class

var DEFAULT_SELECT_VALUE = 'default';
var stringOrNumberPropType = SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]);

var SelectInput__ref2 = SelectInput__jsx('i', {
  className: 'fa fa-angle-down'
});

var SelectInput = function (_React$Component) {
  SelectInput__inherits(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this, _ret;

    SelectInput__classCallCheck(this, SelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SelectInput__possibleConstructorReturn(this, (_ref = SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name,
          options = _this$props.options;

      var selectedOption = options[e.target.selectedIndex];

      onChange(name, selectedOption);
    }, _temp), SelectInput__possibleConstructorReturn(_this, _ret);
  }

  SelectInput__createClass(SelectInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          disabled = _props.disabled,
          titleKey = _props.titleKey;

      var selected = options.find(function (option) {
        return option.val === value;
      });

      return SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.root
      }, void 0, SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.selectContainer
      }, void 0, SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.hint
      }, void 0, selected && (selected[titleKey] || selected.title) || '', SelectInput__ref2), SelectInput__jsx('select', {
        disabled: disabled,
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.select,
        onChange: this.handleSelectChange,
        value: value || DEFAULT_SELECT_VALUE
      }, void 0, options.map(function (item) {
        return SelectInput__jsx('option', {
          value: item.val || DEFAULT_SELECT_VALUE
        }, item.val + item.title, item[titleKey] || item.title);
      }))));
    }
  }]);

  return SelectInput;
}(SelectInput___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SelectInput.defaultProps = {
  options: [],
  onChange: function onChange() {},
  value: null,
  name: null,
  disabled: false,
  titleKey: 'title'
};


/* harmony default export */ var SelectInput_defaultExport = (SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a)(SelectInput));
// CONCATENATED MODULE: ./src/shared/components/UI/NumberInputWithSelect/NumberInputWithSelect.js
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_DecimalInput_DecimalInput__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css__);
var NumberInputWithSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var NumberInputWithSelect__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NumberInputWithSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NumberInputWithSelect__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function NumberInputWithSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function NumberInputWithSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NumberInputWithSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NumberInputWithSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var NumberInputWithSelect_NumberInputWithSelect = function (_React$Component) {
  NumberInputWithSelect__inherits(NumberInputWithSelect, _React$Component);

  function NumberInputWithSelect() {
    var _ref;

    var _temp, _this, _ret;

    NumberInputWithSelect__classCallCheck(this, NumberInputWithSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = NumberInputWithSelect__possibleConstructorReturn(this, (_ref = NumberInputWithSelect.__proto__ || Object.getPrototypeOf(NumberInputWithSelect)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectChange = function (name, optionInfo) {
      var val = optionInfo.val,
          option = NumberInputWithSelect__objectWithoutProperties(optionInfo, ['val']);

      _this.props.onUnitsChange(option);
    }, _temp), NumberInputWithSelect__possibleConstructorReturn(_this, _ret);
  }

  NumberInputWithSelect__createClass(NumberInputWithSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          placeholder = _props.placeholder,
          unitsSwitchValue = _props.unitsSwitchValue,
          className = _props.className,
          error = _props.error,
          errorClassName = _props.errorClassName,
          onChange = _props.onChange,
          required = _props.required,
          decimal = _props.decimal,
          disabled = _props.disabled,
          Icon = _props.Icon,
          titleKey = _props.titleKey,
          theme = _props.theme,
          type = _props.type;

      var value = this.props.value || '';
      var unitsSwitchOptions = this.props.unitsSwitchOptions.filter(function (x) {
        return x;
      });

      var inputProps = {
        value: value,
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.input,
        placeholder: placeholder,
        onChange: onChange,
        disabled: disabled,
        type: type
      };

      return NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.root, className, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a['theme-' + theme], theme && __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a['theme-' + theme]))
      }, void 0, title && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.title, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.required, required))
      }, void 0, title), NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.inline, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.hasIcon, !!Icon))
      }, void 0, !!Icon && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.icon
      }, void 0, NumberInputWithSelect__jsx(Icon, {})), decimal ? NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_components_DecimalInput_DecimalInput__["a" /* default */], inputProps) : NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__["a" /* default */], NumberInputWithSelect__extends({ inputMode: 'numeric' }, inputProps))), unitsSwitchOptions && unitsSwitchOptions.length > 0 && NumberInputWithSelect__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.switch
      }, void 0, NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.switchDivider
      }), unitsSwitchOptions.length === 1 && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.singleOptionLabel
      }, void 0, unitsSwitchOptions[0][titleKey] || unitsSwitchOptions[0].title || ''), unitsSwitchOptions.length > 1 && NumberInputWithSelect__jsx(SelectInput_defaultExport, {
        options: unitsSwitchOptions.map(function (option) {
          return NumberInputWithSelect__extends({}, option, { val: option.id });
        }),
        onChange: this.handleSelectChange,
        value: unitsSwitchValue && unitsSwitchValue.id,
        titleKey: titleKey
      })), error && NumberInputWithSelect__jsx('p', {
        className: errorClassName
      }, void 0, error));
    }
  }]);

  return NumberInputWithSelect;
}(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NumberInputWithSelect_NumberInputWithSelect.defaultProps = {
  title: null,
  className: '',
  errorClassName: '',
  placeholder: '',
  unitsSwitchOptions: [],
  onChange: function onChange() {},
  onUnitsChange: function onUnitsChange() {},
  value: null,
  unitsSwitchValue: null,
  error: null,
  required: false,
  decimal: false,
  disabled: false,
  Icon: null,
  titleKey: 'title',
  theme: '',
  type: 'text'
};


/* harmony default export */ var NumberInputWithSelect_defaultExport = (NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a)(NumberInputWithSelect_NumberInputWithSelect));
// CONCATENATED MODULE: ./src/shared/components/UI/InputPriceWithCurrencies/InputPriceWithCurrencies.js
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_searchForm__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UIStyle_css__);
var InputPriceWithCurrencies__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputPriceWithCurrencies__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










// import { MoneyIcon } from 'shared/components/Icons';



var sluggifiedCurrency = __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default.a.map(function (item) {
  return InputPriceWithCurrencies__extends({}, item, { id: item.slug });
});

var InputPriceWithCurrencies_InputPriceWithCurrencies = function InputPriceWithCurrencies(_ref) {
  var currency = _ref.currency,
      actions = _ref.actions,
      onChange = _ref.onChange,
      inputParams = InputPriceWithCurrencies__objectWithoutProperties(_ref, ['currency', 'actions', 'onChange']);

  return InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NumberInputWithSelect_defaultExport, InputPriceWithCurrencies__extends({}, inputParams, {
    // Icon={MoneyIcon}
    unitsSwitchOptions: sluggifiedCurrency,
    unitsSwitchValue: currency,
    onUnitsChange: function onUnitsChange(e) {
      actions.set.currency(e);
      onChange(inputParams.value);
    },
    onChange: onChange,
    titleKey: 'symbol'
  }));
};

InputPriceWithCurrencies_InputPriceWithCurrencies.defaultProps = {
  currency: sluggifiedCurrency[0],
  onChange: function onChange() {}
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var formState = _ref2.searchForm.selected;
  return {
    currency: formState.currency
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: {
      set: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */]({
        currency: __WEBPACK_IMPORTED_MODULE_6_shared_actions_searchForm__["m" /* selectedActions */].set.currency
      }, dispatch)
    }
  };
};

/* harmony default export */ var InputPriceWithCurrencies_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__UIStyle_css__)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(InputPriceWithCurrencies_InputPriceWithCurrencies)));
// CONCATENATED MODULE: ./src/shared/components/UI/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_Button__ = __webpack_require__(1287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_Button__["a"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return InputText_defaultExport; });
/* unused concated harmony import InputBirthday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return InputBirthday_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return ContactButton_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return InputPhoneNumber_defaultExport; });
/* unused concated harmony import CheckBox */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return CheckBox_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return TagButton_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return Select_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return NumberInputWithSelect_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return InputPriceWithCurrencies_defaultExport; });












/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_withBalance__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import p24Img from './payment-4.svg';
// import billImg from './receipt.svg';


var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0433\u0440\u043D'
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0411\u0430\u043B\u0430\u043D\u0441'
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0433\u0440\u043D'
});

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C'
});

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0438 \u043E\u043F\u043B\u0430\u0442\u0435 \u0443\u0441\u043B\u0443\u0433 \u0438\u043B\u0438 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438'
});

var _ref7 = _jsx('a', {
  href: '/public-contract/',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430'
}));

var PaymentModal = function (_React$Component) {
  _inherits(PaymentModal, _React$Component);

  function PaymentModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaymentModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentModal.__proto__ || Object.getPrototypeOf(PaymentModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedItem: _this.props.items[0],
      balanceRefillMode: false,
      isChecked: true
    }, _this.handleItemChosen = function (selectedItem) {
      _this.setState({ selectedItem: selectedItem });
      _this.props.agreeHandler(selectedItem);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaymentModal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          balance = _props.balance,
          isFetching = _props.isFetching;


      if (prevProps.isFetching && !isFetching) {
        var selectedItem = this.state.selectedItem;
        var _props2 = this.props,
            amount = _props2.amount,
            items = _props2.items,
            balanceRefillMode = _props2.balanceRefillMode;

        var isBalanceEnough = amount <= balance;
        var isPayingForService = !isBalanceEnough || balanceRefillMode;
        var newSelectedItem = isPayingForService ? items.find(function (item) {
          return item.slug !== __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE;
        }) : selectedItem;

        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedItem: newSelectedItem,
          balanceRefillMode: isPayingForService
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var intl = this.props.intl;
      var _props3 = this.props,
          amount = _props3.amount,
          closeHandler = _props3.closeHandler,
          title = _props3.title,
          isLoading = _props3.isLoading,
          items = _props3.items,
          balance = _props3.balance,
          isFetching = _props3.isFetching;
      var _state = this.state,
          balanceRefillMode = _state.balanceRefillMode,
          isChecked = _state.isChecked;

      var isMobile = "desktop" === 'mobile';

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.root
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.bg,
        onClick: closeHandler
      }), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.container
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.column
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Loader_Loader__["a" /* default */], {
        isLoading: isFetching,
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.loader
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.columnWrapper
      }, void 0, _jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.h3
      }, void 0, title && _jsx('span', {}, void 0, title, ' - '), amount, ' ', _ref2), !isFetching && balance > 0 && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.balance
      }, void 0, _ref3, ':', ' ', _jsx('b', {}, void 0, balance, ' ', _ref4)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.list
      }, void 0, items.map(function (item) {
        var shouldDisable = !item.isBalanceRefillOption && balanceRefillMode || item.isBalanceRefillOption && !balanceRefillMode;
        // || (item.slug === PAYMENT_METHODS.INVOICE && !this.props.balanceRefillMode);
        if (_this2.props.disableBalance) {
          shouldDisable = item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE && _this2.props.disableBalance || item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].INVOICE && !_this2.props.balanceRefillMode;
        }
        if (item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].FONDY_P24) shouldDisable = true;
        // todo delete this functionality when privat24 will working
        return shouldDisable ? null : _jsx('button', {
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.payment, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.disabled, isLoading)),
          onClick: function onClick() {
            return _this2.handleItemChosen(item);
          },
          disabled: isLoading || !isChecked
        }, item.slug, _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.paymentContents
        }, void 0, _jsx('img', {
          src: item.imgSrc,
          width: 60,
          alt: ''
        }), _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.paymentTitle
        }, void 0, intl.formatMessage({ id: item.title }))));
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.actions
      }, void 0, _jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.button,
        onClick: closeHandler
      }, void 0, _ref5)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.contractOffer
      }, void 0, _jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.checkbox, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.disabled, isChecked), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.mobile, isMobile)),
        onClick: function onClick() {
          return _this2.setState({ isChecked: !isChecked });
        }
      }, void 0, _jsx('input', {
        type: 'checkbox',
        defaultChecked: isChecked
      })), _ref6, ' ', _ref7))))));
    }
  }]);

  return PaymentModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PaymentModal.defaultProps = {
  balance: null,
  items: [{
    title: 'Оплатить с личного счёта',
    imgSrc: __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default.a,
    slug: __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE,
    isBalanceRefillOption: false
  }, {
    title: 'Оплатить картой',
    imgSrc: __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default.a,
    slug: __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].MONO,
    isBalanceRefillOption: true
  }],
  isLoading: false,
  balanceRefillMode: false,
  disableBalance: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_5_shared_hocs_withBalance__["a" /* default */](true)(PaymentModal))));

/***/ }),

/***/ 1270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DesktopButtonMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DesktopButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DesktopRightSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannersBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sticky__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_modules_googletag_contentRollAdsense__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lazyload__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BannerAll_css__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












var MARGIN_TOP = 63;
var MARGIN_BOTTOM = 100;

var distanceFromBottom = 0;

var _ref2 = _jsx('div', {});

var DesktopButtonMark = function DesktopButtonMark() {
  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -68,
    disableCompensation: true
  }, void 0, function (_ref) {
    var distance = _ref.distanceFromBottom;

    distanceFromBottom = Number(distance);
    return _ref2;
  }));
};

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_modules_googletag_contentRollAdsense__["a" /* ContentRollAdsense */], {});

var DesktopButton = __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a)(function () {
  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -68,
    disableCompensation: true
  }, void 0, function (_ref3) {
    var distance = _ref3.distanceFromBottom;

    distanceFromBottom = Number(distance);
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.advertContainerButoon,
      id: 'div-gpt-ad-desktop_button-all'
    }, void 0, _ref4);
  }));
}); /* data.children */

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
}));

var _ref7 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref8 = _jsx('div', {
  id: 'height-div-gpt-ad-1510224251147-0'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
})));

var _ref10 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref11 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
}));

var DesktopRightSidebar = __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a)(function (data) {
  if (data.scrollNo) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref5), data && data.children || '', _ref6);
  } else if (data.fixedSecondBanner) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      id: 'height-div-gpt-ad-1510239331518-1'
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref7), data && data.children || ''), _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.homeSideBar
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
      topOffset: -MARGIN_TOP,
      disableCompensation: true
    }, void 0, function (props) {
      var style = props.style,
          bottomDistance = props.distanceFromBottom;

      var customStyle = _extends({}, style, { top: MARGIN_TOP + 'px' });

      if (+bottomDistance < MARGIN_BOTTOM) {
        customStyle = _extends({}, style, { top: bottomDistance - 20 });
      }
      return _jsx('div', {
        style: customStyle
      }, void 0, _ref8);
    })));
  }

  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -MARGIN_TOP,
    disableCompensation: true
  }, void 0, function (_ref9) {
    var _ref9$style = _ref9.style,
        style = _ref9$style === undefined ? { transform: 'translateZ(0)' } : _ref9$style,
        distanceFromTop = _ref9.distanceFromTop,
        distanceFromBottomValue = _ref9.distanceFromBottom;

    var padding = 35;
    var scroll = MARGIN_TOP;
    var scrollTwo = 0;
    var bodyABIdBlockHeight = 0;
    var blockHeight = 0;
    var blockHeightAbove600 = false;
    var bodyABIdBlockHeightAbove = false;
    var doNotScroll = 0;

    var bannerBlock1 = 0;
    var bannerBlock2 = 0;

    if (true) {
      var heightDivDptAd1510239331518 = window.document.getElementById('height-div-gpt-ad-1510239331518-1') || {};
      var heightDivGptAd15102242511470 = window.document.getElementById('height-div-gpt-ad-1510224251147-0') || {};
      var bodyABIdBlock = window.document.getElementById('bodyABIdBlock') || {};
      bodyABIdBlockHeight = Number(bodyABIdBlock.clientHeight);
      blockHeight = Number(heightDivDptAd1510239331518.clientHeight);
      scroll = Number('-' + heightDivDptAd1510239331518.clientHeight) || MARGIN_TOP;
      scrollTwo = Number('-' + heightDivGptAd15102242511470.clientHeight) || 0;
      blockHeightAbove600 = blockHeight > 600;
      bodyABIdBlockHeightAbove = bodyABIdBlockHeight > Math.abs(distanceFromTop) + Math.abs(scrollTwo) + padding + 20 + 35;

      bannerBlock1 = Number(heightDivDptAd1510239331518.clientHeight) || 0;
      bannerBlock2 = Number(heightDivGptAd15102242511470.clientHeight) || 0;

      doNotScroll = bodyABIdBlockHeight - 130 < bannerBlock1 + bannerBlock2;
    }

    if (distanceFromBottomValue - padding - bannerBlock2 < 0) {
      scroll += distanceFromBottomValue - padding - bannerBlock2 + 35;
    } else if (!bodyABIdBlockHeightAbove) {
      scroll += bodyABIdBlockHeight - Math.abs(distanceFromTop) - Math.abs(scrollTwo) - padding - 20;
    } else if (blockHeightAbove600) {
      if (distanceFromBottom + scrollTwo + padding < 100) {
        if (distanceFromBottom + scrollTwo - MARGIN_TOP > scroll) {
          scroll = distanceFromBottom + scrollTwo;
        } else {
          scroll += padding;
        }
      } else {
        scroll = MARGIN_TOP;
      }
    } else {
      scroll = distanceFromTop;
    }

    var fun = function fun() {
      var obj = {};
      if (!blockHeightAbove600 && distanceFromTop < Number('-' + blockHeight)) {
        obj.position = 'fixed';
        obj.top = Math.abs(distanceFromTop - MARGIN_TOP) + 'px';
      }
      return obj;
    };

    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      style: doNotScroll ? {} : _extends({}, style, { top: scroll + 'px' })
    }, void 0, _jsx('div', {
      id: 'height-div-gpt-ad-1510239331518-1'
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref10), data && data.children || ''), _jsx('div', {
      style: fun(),
      id: 'height-div-gpt-ad-1510224251147-0'
    }, void 0, _ref11)));
  }));
});

var BannersBuffer = __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](function (_ref12) {
  var globals = _ref12.globals;
  return {
    bannerNotErr: globals.banner && globals.banner.bannerNotErr
  };
})(function () {
  function BannersBuffer(props) {
    var bannerNotErr = props.bannerNotErr;

    return _jsx('div', {
      style: { display: 'none' }
    }, void 0, Object.keys(bannerNotErr).map(function (a) {
      return _jsx('div', {
        id: a
      }, a, '.');
    }));
  }

  BannersBuffer.defaultProps = {
    bannerNotErr: {}
  };
  return BannersBuffer;
}());

/***/ }),

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return posted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createdDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shortCreatedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFullDate; });
/* unused harmony export getShotDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__ = __webpack_require__(190);



var posted = function posted(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';

  if (__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](__WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__["default"](new Date(time)), 'yyyy-MM-dd') === __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](__WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__["default"](new Date()), 'yyyy-MM-dd')) {
    return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'H:mm');
  }
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'MMMM d, yyyy', locale);
};

var createdDate = function createdDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'MMMM d, yyyy', locale);
};

var shortCreatedDate = function shortCreatedDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'dd.MM', locale);
};

var getFullDate = function getFullDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'H:mm, MMMM d, yyyy', locale);
};

var getShotDate = function getShotDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'dd-MM-yyyy', locale);
};

/***/ }),

/***/ 1272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserThing; });
/* unused harmony export formatPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return verifyYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getYearsOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getParamByKey; });
/* unused harmony export rewriteMinMaxYear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return correctionYears; });
/* unused harmony export getActiveAdvsCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isSlotAvailable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_arrays__ = __webpack_require__(104);



var getUserName = function getUserName(_ref) {
  var _ref$first_name = _ref.first_name,
      firstName = _ref$first_name === undefined ? null : _ref$first_name,
      _ref$last_name = _ref.last_name,
      lastName = _ref$last_name === undefined ? null : _ref$last_name;
  return firstName || lastName ? [firstName, lastName].filter(function (i) {
    return !!i;
  }).join(' ') : null;
};

var getUserThing = function getUserThing(_ref2) {
  var email = _ref2.email,
      _ref2$phones = _ref2.phones,
      phones = _ref2$phones === undefined ? [] : _ref2$phones,
      name = _ref2.name;

  var verifiedPhones = phones.filter(function (phone) {
    return phone.is_verified;
  });
  var emailAndPhones = verifiedPhones.length > 0 ? '' + verifiedPhones[0].number : email;
  return name || emailAndPhones;
};

var formatPhone = function formatPhone(phone) {
  var numberPhone = phone.replace(/[+\s_()]/g, '');
  return '380' + numberPhone.slice(-9);
};

var verifyYear = function verifyYear(year) {
  return year && (year < 1900 || year > +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy')));
};

var getYearsOptions = function getYearsOptions() {
  var YEAR_FROM = 1901;
  var YEAR_TO = new Date().getFullYear();
  var YEARS = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_arrays__["c" /* getRange */](YEAR_FROM, YEAR_TO);

  return YEARS.map(function (year) {
    return { title: year, val: year };
  }).reverse();
};

var getParamByKey = function getParamByKey(arr, key) {
  if (arr && arr.length) return arr[0][key];
  return null;
};

var rewriteMinMaxYear = function rewriteMinMaxYear(year) {
  if (!year) return year;else if (+year < 1900) return 1900;else if (+year > +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy'))) return +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy'));
  return +year;
};

var correctionYears = function correctionYears(formState) {
  var yearTo = formState.yearTo,
      yearFrom = formState.yearFrom;


  yearTo = rewriteMinMaxYear(yearTo);
  yearFrom = rewriteMinMaxYear(yearFrom);

  if (yearTo && yearFrom && yearTo < yearFrom) return { yearTo: yearFrom, yearFrom: yearTo };
  return { yearTo: yearTo, yearFrom: yearFrom };
};

/**
 * Get count of activated adverts
 * @returns {Number}
 */
var getActiveAdvsCount = function getActiveAdvsCount(user) {
  if (!user || !user.id) return 0;
  var activeKeys = Object.keys(user.active_adverts);
  var count = activeKeys.reduce(function (acc, value) {
    return acc + user.active_adverts[value];
  }, 0);
  return count;
};

/**
 * Get count of activated adverts
 * @returns {Boolean}
 */
var isSlotAvailable = function isSlotAvailable(user) {
  if (getActiveAdvsCount(user) === 0) return true;
  return !!user.tariff && user.tariff.slots_limit > getActiveAdvsCount(user);
};

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(1285);

/***/ }),

/***/ 1274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getFieldFromRootOrCharacteristics; });
/* unused harmony export getNumberOrTitleFromRootOrCharacteristics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCapacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getMileageText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return constructModification; });
/* unused harmony export getModification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return carPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return carPriceBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getPriceBySlug; });
/* unused harmony export getCurrencyTitleBySlug */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getSymbolTitleBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getPriceValueBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getPriceWithCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isLocationCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertMlToKm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getMileageString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCapacityUnitTitleById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCountryById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdvertStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdvertOgImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getTransportInfoFiltered; });
/* unused harmony export getIconsByFieldName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getTechnicalsSpecifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__arrays__ = __webpack_require__(104);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












var getFieldFromRootOrCharacteristics = function getFieldFromRootOrCharacteristics(key, advert) {
  if (!advert || !key) {
    return null;
  }

  var characteristics = advert.characteristics || {};
  if (advert[key] && advert[key].title && advert[key].id) {
    return advert[key];
  } else if (characteristics[key] && characteristics[key].title && characteristics[key].id) {
    return characteristics[key];
  }

  return null;
};

var getNumberOrTitleFromRootOrCharacteristics = function getNumberOrTitleFromRootOrCharacteristics(key, advert) {
  var result = getFieldFromRootOrCharacteristics(key, advert);

  if (result && result.number) {
    return result.number;
  } else if (result && result.title) return result.title;

  return result;
};

var getPower = function getPower(advert, t) {
  var powerUnit = __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json___default.a.find(function (item) {
    return item.id === advert.power_unit;
  });
  var power = getNumberOrTitleFromRootOrCharacteristics('power', advert);

  return power ? '(' + power + ' ' + (powerUnit && t(powerUnit.title)) + ')' : '';
};

/**
 * @param advert {object}
 * @param key {string} - one of ['capacity', 'capacity_body', 'capacity_bucket']
 * @param t {function}
 * @returns {string}
 */
var getCapacity = function getCapacity(advert, t) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'capacity';

  var capacityUnit = __WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json___default.a.find(function (item) {
    return item.id === advert.capacity_unit;
  });
  var capacity = getNumberOrTitleFromRootOrCharacteristics(key, advert);

  return capacity && capacityUnit ? '' + capacity + t(capacityUnit.title) : '';
};

var getMileageText = function getMileageText(advert, t) {
  var mileage = advert.mileage,
      mileageUnitId = advert.mileage_unit,
      isNew = advert.is_new;

  var mileageUnit = __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json___default.a.find(function (item) {
    return item.id === mileageUnitId;
  });

  var mileageText = mileage > 0 ? mileage + ' ' + t(__WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](mileageUnit)) : null;
  if (isNew) {
    mileageText = t('новый');
  }

  return mileageText;
};

var constructModification = function constructModification(advert, t) {
  var gearbox = getFieldFromRootOrCharacteristics('gearbox', advert);
  var power = getPower(advert, t);
  var capacity = getCapacity(advert, t);

  return __WEBPACK_IMPORTED_MODULE_9__arrays__["a" /* cleanArray */]([capacity, __WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](gearbox).toLowerCase(), power]).join(' ').trim();
};

var getModification = function getModification(advert, t) {
  if (advert.modification && advert.modification.id) {
    return advert.modification.title || '';
  }

  return constructModification(advert, t);
};

var carPrice = function carPrice(price, currency) {
  var priceString = __WEBPACK_IMPORTED_MODULE_8__common__["k" /* numberWithSpaces */](price);
  var currencyTitle = currency.symbol || currency.title;

  return priceString + ' ' + currencyTitle;
};

var carPriceBySlug = function carPriceBySlug(prices, currency) {
  if (!currency || !prices) {
    return '';
  }

  var price = prices.find(function (item) {
    return item.currency === currency.slug;
  });
  if (!price) {
    return '';
  }

  return carPrice(price.value, currency);
};

var getPriceBySlug = function getPriceBySlug(prices, slug) {
  var getNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!slug || !prices) {
    return '';
  }

  var currency = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (c) {
    return c.slug === slug;
  });
  var price = prices.find(function (item) {
    return item.currency === currency.slug;
  });
  if (!price) {
    return '';
  }
  if (getNumber) return price.value;
  return carPrice(price.value, currency);
};

var getCurrencyTitleBySlug = function getCurrencyTitleBySlug(slug) {
  var currentCurrencyObj = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (item) {
    return item.slug === slug;
  });

  var _ref = currentCurrencyObj || {},
      title = _ref.title;

  return title;
};

var getSymbolTitleBySlug = function getSymbolTitleBySlug(slug) {
  var currentCurrencyObj = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (item) {
    return item.slug === slug;
  });

  var _ref2 = currentCurrencyObj || {},
      symbol = _ref2.symbol;

  return symbol;
};

var getPriceValueBySlug = function getPriceValueBySlug(prices, slug) {
  var currentPriceObj = prices.find(function (price) {
    return price.currency === slug;
  });

  return currentPriceObj ? currentPriceObj.value : null;
};

var getPriceWithCurrency = function getPriceWithCurrency(prices, slug) {
  var value = getPriceValueBySlug(prices, slug);
  var currency = getCurrencyTitleBySlug(slug);

  if (typeof value !== 'number' || !currency) {
    return null;
  }

  return slug === 'usd' ? currency + ' ' + __WEBPACK_IMPORTED_MODULE_8__common__["k" /* numberWithSpaces */](value) : __WEBPACK_IMPORTED_MODULE_8__common__["k" /* numberWithSpaces */](value) + ' ' + currency;
};

var isLocationCountry = function isLocationCountry(location) {
  if (!location || !location.id) {
    return null;
  }

  return !!__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json___default.a.find(function (country) {
    return country.id === location.id;
  });
};

var convertMlToKm = function convertMlToKm(car) {
  if (car.mileage_unit === 0) {
    return car.mileage;
  } else if (car.mileage_unit === 1) {
    return car.mileage * 1.61;
  }
};

var getMileageString = function getMileageString(mileage, mileageUnitId) {
  if (!mileage || typeof mileageUnitId !== 'number') {
    return null;
  }

  var mileageUnitTitle = __WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json___default.a.find(function (unit) {
    return unit.id === mileageUnitId;
  }));

  return mileage + ' ' + mileageUnitTitle.replace(/[.]/g, '');
};

var getCapacityUnitTitleById = function getCapacityUnitTitleById(unitId) {
  return __WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json___default.a.find(function (unit) {
    return unit.id === unitId;
  }));
};

var getCountryById = function getCountryById(id) {
  return __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json___default.a.find(function (item) {
    return item.id === id;
  });
};

var translateTitle = function translateTitle(item, intl) {
  return item.title ? _extends({}, item, { title: intl.formatMessage({ id: item.title }) }) : item;
};

var getAdvertStatuses = function getAdvertStatuses(advert, intl) {
  return [].concat(_toConsumableArray([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json___default.a), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json___default.a), [{ title: 'авто не в Украине', id: 'abroad' }]).filter(function (status) {
    return advert[status.id];
  }).map(function (item) {
    return translateTitle(item, intl);
  })), _toConsumableArray(advert.is_not_cleared ? [] : [{ id: '__is_not_cleared', title: '' + intl.formatMessage({ id: 'растаможен' }) }]), _toConsumableArray(advert.driven_from && advert.driven_from.id && !!getCountryById(advert.driven_from.id) ? [{
    title: '\u0430\u0432\u0442\u043E ' + getCountryById(advert.driven_from.id).from[intl.locale],
    id: 'driven_from'
  }] : []));
};

var getAdvertOgImage = function getAdvertOgImage(advert) {
  return advert && advert.photos && advert.photos.length > 0 && advert.photos[0] && advert.photos[0].image ? advert.photos[0].image : undefined;
};

var getTechnicalsSpecification = function getTechnicalsSpecification(advert, item, t) {
  switch (item) {
    case 'engine':
      return getFieldFromRootOrCharacteristics('engine', advert);
    case 'mileage':
      return {
        slug: item,
        id: 999,
        title: getMileageText(advert, t)
      };
    case 'gearbox':
      return getFieldFromRootOrCharacteristics('gearbox', advert);
    case 'drive':
      return getFieldFromRootOrCharacteristics('drive', advert);
    case 'year':
      return {
        slug: item,
        id: 888,
        title: advert.year
      };
    case 'location':
      return {
        slug: item,
        id: 777,
        title: advert.location.title
      };
    default:
      return {
        slug: '',
        id: 0,
        title: ''
      };
  }
};

var getTransportInfoFiltered = function getTransportInfoFiltered() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'avto';

  var types = {
    avto: ['location', 'year', 'modification', 'mileage', 'body', 'color', 'engine', 'gearbox', 'drive', 'vin']
  };
  return types[type] ? types[type] : [];
};

var getIconsByFieldName = function getIconsByFieldName() {
  return {
    mileage: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["o" /* SpeedIcon */],
    gearbox: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["h" /* GearboxIcon */],
    year: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["b" /* CalendarIcon */],
    engine: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["f" /* EngineIcon */],
    drive: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["d" /* ChassisIcon */],
    location: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["l" /* LocationIcon */],
    color: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["e" /* ColorIcon */],
    vin: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["s" /* VinIcon */]
  };
};

var getTechnicalsSpecifications = function getTechnicalsSpecifications(advert, items, t) {
  var icons = getIconsByFieldName();
  return items.map(function (slug) {
    var params = getTechnicalsSpecification(advert, slug, t);
    return _extends({
      icon: icons[slug] || null
    }, params);
  }).filter(function (item) {
    return item && item.title;
  });
};

/***/ }),

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function ModalWrapper(props) {
  return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, props.show && _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
    modalCN: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.modal,
    onClose: props.toggleModal,
    isOpen: props.show
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.rootModal
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.rootModalContainer
  }, void 0, props.children, _jsx('i', {
    className: 'fa fa-times ' + __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.closeBtnIcon,
    onClick: props.toggleModal
  })))));
}

ModalWrapper.defaultProps = {
  children: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a)(ModalWrapper));

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */

function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          var handlerOptions = null;
          var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

          if (isTouchEvent && passiveEventSupport) {
            handlerOptions = {
              passive: !_this.props.preventDefault
            };
          }

          document.addEventListener(eventName, handlersMap[_this._uid], handlerOptions);
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn);
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */

    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);

/***/ }),

/***/ 1277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/leasing/myAutoCalculate.js
/**
 * Формула коэффициента аннуитета:
 * К = (i * (1 + i)^n) / ((1+i)^n-1)
 * где i – процентная ставка за месяц, результат деления годовой ставки на 12;
 * n – срок кредита в месяцах.
 */
function getAnnuityFactor(rate, term) {
  var i = rate / 12 / 100;
  var n = term;
  return i * Math.pow(1 + i, n) / (Math.pow(1 + i, n) - 1);
}

/**
   * Месячный платеж по аннуитету
   * sum * annuityFactor
   */
function getAnnuityMonthPayment(sum, rate, term) {
  var factor = getAnnuityFactor(rate, term);
  return sum * factor;
}
// getAnnuityMonthPayment
// этот надо вызывать
// sum - цена тачки минус аванс
// rate - до 10 лет 40%, до 17 - 45%, иначе - 49%
// ß - 84

function getAnnuityRate(year) {
  var currentYear = new Date().getFullYear();
  var diff = currentYear - year;
  if (diff <= 17) return 45;
  if (diff <= 10) return 40;
  return 49;
}
// CONCATENATED MODULE: ./src/shared/helpers/leasing/utils.js
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCleanDeviceId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return execPostRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLeasingParms; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getCapacity;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLeasingArgumentsByAdv;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateExchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMonthlyPrice; });
/* unused harmony export calculateMonthlyPayment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateMonthlyPaymentV2; });
/* unused harmony export isHapaiLeasing */
/* unused harmony export isAutoMoneyLeasing */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isUlfLeasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isUlf24Leasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getMothlyPaymentFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return userFormValidation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_regexp__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_google__ = __webpack_require__(499);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



// import API from 'shared/constants/api';







var isClient = true;
var HOST = process.env.HOST || process.env.WEBSITE_HOSTNAME;

/**
 *
 * @param {String} deviceId
 * @returns
 */
var getCleanDeviceId = function getCleanDeviceId(deviceId) {
  return deviceId.replace(/^"(.*)"$/, '$1');
};

/**
 *
 * @param {String} path
 * @param {Object} body
 * @param {Function} fetch
 * @param {Object} headers
 * @param {String} action
 * @returns
 */
var execPostRequest = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path, body, fetch) {
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var action = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'addlead';
    var result, gtoken, data, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            result = null;
            // const headers = { 'Content-Type': 'application/json', addHeaders }; // 'x-access-key': X_ACCESS_KEY_VRF

            _context.prev = 1;

            if (!action) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6_shared_helpers_google__["a" /* getGoogleCaptchaToken */](action);

          case 5:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;

          case 8:
            _context.t0 = '';

          case 9:
            gtoken = _context.t0;
            data = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', headers: headers, gtoken: gtoken },
              body: JSON.stringify(body)
            };
            _context.next = 13;
            return fetch(path, data);

          case 13:
            response = _context.sent;
            _context.next = 16;
            return response.json();

          case 16:
            result = _context.sent;
            _context.next = 21;
            break;

          case 19:
            _context.prev = 19;
            _context.t1 = _context['catch'](1);

          case 21:
            return _context.abrupt('return', result);

          case 22:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 19]]);
  }));

  return function execPostRequest(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// TODO; MOVE METHODS TO MyCredits !!!

var getLeasingParms = function getLeasingParms(advert) {
  var finUp = advert.fin_up_verification;

  if (finUp && finUp.payload && finUp.payload.monthlyPayment) {
    return finUp.payload;
  }
  return null;
};

function getFeatures(options) {
  if (!Array.isArray(options) || !options.length) return [];
  var features = [];
  for (var i = 0, l = options.length; i < l; i += 1) {
    var _options$i = options[i],
        title = _options$i.title,
        parents = _options$i.parents;

    if (__WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["d" /* FEATURES */][title]) {
      features.push(__WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["d" /* FEATURES */][title]);
    } else if (parents[1] && __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["d" /* FEATURES */][parents[1].title + '-' + title]) {
      features.push(__WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["d" /* FEATURES */][parents[1].title + '-' + title]);
    }
  }
  return features;
}

function getCapacity(adv) {
  var cpcty = adv.characteristics.capacity ? adv.characteristics.capacity.number : adv.capacity;
  var capacity = cpcty / 100 > 0.1 ? cpcty : cpcty * 1000;
  return capacity;
}

function getGeo(adv) {
  var obl = adv.location && adv.location.parents && adv.location.parents.pop();
  var geo = obl && obl.title + ', ' + adv.location.title || (adv.location && adv.location.title ? adv.location.title : adv.location);
  return geo;
}

function getLeasingArgumentsByAdv(adv) {
  var generation = adv.modification.generation && adv.modification.generation.title;
  var geo = getGeo(adv);
  var photos = (adv.photos || []).map(function (photo) {
    return photo.image;
  }) || [];
  var name = adv.author && adv.author.first_name && adv.author.first_name || '';
  var phones = adv.agency && Array.isArray(adv.agency.phones) && adv.agency.phones.map(function (phone) {
    return phone.number;
  }) || [];

  var params = {
    localId: '' + adv.id,
    brand: adv.make.slug || adv.make_title,
    model: adv.model.slug || adv.model_title,
    generation: generation,
    year: adv.year,
    engineType: adv.engine && __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["c" /* ENGINES_CONVERTER */][adv.engine.slug],
    transmission: adv.gearbox && __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["e" /* GEARBOX_CONVERTER */][adv.gearbox.slug],
    engineVolumeMl: getCapacity(adv),
    mileageKm: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["d" /* convertMlToKm */](adv) * 1000,
    description: adv.description,
    features: getFeatures(adv.options),
    geo: geo,
    photos: photos,
    wheelDrive: adv.drive && __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["g" /* WHELL_DRIVE */][adv.drive.slug],
    contact: {
      name: name,
      phones: phones
    }
  };

  var path = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_urls__["g" /* generateUrl */](adv);
  var host = isClient && location && location.host || HOST || 'avtobazar.ua';
  var url = 'https://' + host + path;
  var options = {
    sum: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["n" /* getPriceValueBySlug */](adv.price, 'usd'),
    url: url,
    currency: 'USD'
  };
  return { params: params, options: options };
}

// export const calculateExchange = (prices, value, currency) => {
//   const isUsdCurrent = prices.find(data => data.exchange_rate === 1 && data.currency === 'usd');
//   const isUsdCurrent = prices.find(data => data.exchange_rate === 1 && data.currency === 'eur');

//   const ukExchangeRate = prices.find(
//     exchangeItem =>
//       isUsdCurrent ? exchangeItem.currency === 'uah' : exchangeItem.currency === 'usd',
//   ).exchange_rate;

//   let result = 0;
//   if (currency === 'usd') result = isUsdCurrent ? value / ukExchangeRate : value * ukExchangeRate;
//   else result = isUsdCurrent ? value * ukExchangeRate : value / ukExchangeRate;

//   return parseInt(result, 10);
// };

var calculateExchange = function calculateExchange(prices, value, toCurrency) {
  var fromCurrency = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'usd';

  var toCurr = prices.find(function (data) {
    return data.currency === toCurrency;
  });
  var fromCurr = prices.find(function (data) {
    return data.currency === fromCurrency;
  });

  if (toCurrency.exchange_rate === 1) {
    return parseInt(toCurr.exchange_rate * value, 10);
  }
  if (fromCurrency.exchange_rate === 1) {
    return parseInt(value / fromCurr.exchange_rate, 10);
  }
  return parseInt(value / fromCurr.exchange_rate * toCurr.exchange_rate, 10);
};

/**
 *
 * @param {Object} advert
 * @param {Number} monthly
 * @param {String} currencySlug
 * @param {String} formated
 * @returns
 */
var getMonthlyPrice = function getMonthlyPrice(advert, monthly) {
  var currencySlug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'uah';
  var formated = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!advert || !monthly) return 0;
  var prices = [];

  if (Array.isArray(advert.prices)) prices = advert.prices;else if (Array.isArray(advert.price)) prices = advert.price;

  var result = calculateExchange(prices, monthly, currencySlug);

  return formated ? __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["k" /* numberWithSpaces */](result) : result;
};

var calculateMonthlyPayment = function calculateMonthlyPayment(advert) {
  var TERM = 84;
  var PREPAID = 0.3;

  var year = advert.year;


  var price = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_advert__["c" /* getPrice */](advert.price || advert.prices, ['usd']);
  var sum = price - price * PREPAID;
  var rate = getAnnuityRate(year);
  var monthly = getAnnuityMonthPayment(sum, rate, TERM);
  // console.log(`PRICE: ${price}, SUN: ${sum}, RATE: ${rate}, TERM: ${TERM} RESULT : ${monthly}`);

  return monthly;
};

var calculateMonthlyPaymentV2 = function calculateMonthlyPaymentV2(data) {
  var year = data.year,
      term = data.term,
      price = data.price,
      prepaid = data.prepaid,
      comission = data.comission,
      rate = data.rate;

  var sum = price - (prepaid - comission);
  var monthly = getAnnuityMonthPayment(sum, rate || getAnnuityRate(year), term || 84);

  return Math.round(monthly);
};

var isHapaiLeasing = function isHapaiLeasing(lp) {
  return lp && lp.extendedParams && lp.extendedParams.hapai;
};
var isAutoMoneyLeasing = function isAutoMoneyLeasing(lp) {
  return false;
}; // lp && lp.isAutoMoneyCalculated;
var isUlfLeasing = function isUlfLeasing(lp) {
  return lp && lp.isUlfCalculated;
};
var isUlf24Leasing = function isUlf24Leasing(lp) {
  return lp && lp.isUlf24Calculated;
};

var getMothlyPaymentFormatted = function getMothlyPaymentFormatted(lp) {
  return lp && lp.extendedParams && (lp.extendedParams.hapai && lp.extendedParams.hapai.monthlyPaymentUAHFormatted || lp.extendedParams.monthlyPaymentUAHFormatted);
};

var userFormValidation = function userFormValidation(data) {
  var phoneToTest = '';
  var tempPhone = data.phone.replace(/\s/g, '');
  if (tempPhone.charAt(0) !== '+') {
    phoneToTest = '+' + tempPhone;
  } else {
    phoneToTest = tempPhone;
  }

  if (!__WEBPACK_IMPORTED_MODULE_5_shared_constants_regexp__["b" /* default */].phone.test(phoneToTest) || phoneToTest.charAt(4) === '0' || phoneToTest.length !== 13) {
    return 'Некорректный номер мобильного телефона';
  }

  if (!__WEBPACK_IMPORTED_MODULE_5_shared_constants_regexp__["b" /* default */].name.test(data.userName)) {
    return 'Некорректное имя';
  }
  return '';
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(250)))

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1260);
var ITERATOR = __webpack_require__(86)('iterator');
var Iterators = __webpack_require__(187);
module.exports = __webpack_require__(30).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CircleTimer_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref2 = _jsx('circle', {
  fill: 'rgba(255, 217, 6, 0.2)',
  stroke: 'rgba(255, 217, 6, 0.2)',
  strokeWidth: '2',
  cx: '50%',
  cy: '50%',
  r: '50'
});

var CircleTimer = function (_React$Component) {
  _inherits(CircleTimer, _React$Component);

  function CircleTimer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CircleTimer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CircleTimer.__proto__ || Object.getPrototypeOf(CircleTimer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      formatedTime: '0:00',
      iId: 0,
      time: 0
    }, _this.componentDidMount = function () {
      _this.setState({
        time: _this.props.time,
        formatedTime: _this.formatTime(_this.props.time)
      });
      _this.startTimer();
    }, _this.componentWillUnmount = function () {
      _this.stopTimer();
    }, _this.formatTime = function (time) {
      var minutes = Math.floor(time / 60);
      var seconds = time % 60;
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return minutes + ':' + seconds;
    }, _this.startTimer = function () {
      var self = _this;
      var _this$props = _this.props,
          time = _this$props.time,
          repeat = _this$props.repeat,
          timeUp = _this$props.timeUp;


      var callCallback = function callCallback() {
        setTimeout(timeUp);
      };

      var iId = setInterval(function () {
        if (self.state.time < 1) {
          if (!repeat) {
            try {
              self.stopTimer();
              callCallback();
            } catch (err) {}
          } else {
            self.state.time = time;
          }
        } else {
          self.state.time -= 1;
        }

        var formatedTime = self.formatTime(self.state.time);
        self.setState({ formatedTime: formatedTime });
      }, 1000);
      self.setState({ iId: iId });
    }, _this.stopTimer = function () {
      clearInterval(_this.state.iId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CircleTimer, [{
    key: 'render',
    value: function render() {
      var seconds = this.props.time + 's';
      var animationFill = this.props.repeat ? 'remove' : 'freeze';
      return _jsx('svg', {
        className: 'circle-chart',
        viewBox: '0 0 110 110',
        width: '120',
        height: '120',
        xmlns: 'http://www.w3.org/2000/svg'
      }, void 0, _ref2, _jsx('circle', {
        className: __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a.circleTimerProgress,
        stroke: '#FFD906',
        strokeWidth: '2',
        strokeDasharray: '0,314',
        strokeDashoffset: '314',
        strokeLinecap: 'round',
        fill: 'none',
        cx: '50%',
        cy: '50%',
        r: '50'
      }, void 0, _jsx('animate', {
        attributeName: 'stroke-dasharray',
        dur: seconds,
        begin: '0',
        values: '0,314;314,0',
        fill: animationFill
      })), _jsx('g', {}, void 0, _jsx('text', {
        className: __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a.circleTimerText,
        x: '50%',
        y: '50%',
        alignmentBaseline: 'central',
        textAnchor: 'middle'
      }, void 0, this.state.formatedTime)));
    }
  }]);

  return CircleTimer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CircleTimer.defaultProps = {
  time: 300,
  repeat: false,
  timeUp: function timeUp() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a)(CircleTimer));

/***/ }),

/***/ 1281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_regexp__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NumberInput = function (_React$Component) {
  _inherits(NumberInput, _React$Component);

  function NumberInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.setInputRef = function (inputRef) {
      _this.inputRef = inputRef;
    }, _this.updateSelection = function () {
      var length = _this.inputRef.value.length;


      setTimeout(function () {
        if (_this.inputRef && _this.inputRef.setSelectionRange && _this.inputRef.type === 'text') {
          _this.inputRef.setSelectionRange(length, length);
        }
      }, 0);
    }, _this.handleChange = function (value) {
      return _this.props.onChange(value.replace(/\s/g, ''));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumberInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.inputRef && this.props.autoFocus) {
        this.inputRef.focus();
        this.updateSelection();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.updateSelection();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          separateThousands = _props.separateThousands,
          props = _objectWithoutProperties(_props, ['value', 'separateThousands']);

      var safeValue = value || '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_components_RegexpInput_RegexpInput__["a" /* default */], _extends({}, props, {
        pattern: __WEBPACK_IMPORTED_MODULE_4_shared_constants_regexp__["c" /* numberWithSpacesRegexp */],
        value: separateThousands ? __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["k" /* numberWithSpaces */](safeValue) : safeValue,
        onChange: this.handleChange,
        inputRef: this.setInputRef
      }));
    }
  }]);

  return NumberInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NumberInput.defaultProps = {
  onChange: function onChange() {},
  value: '',
  autoFocus: false,
  separateThousands: true
};
/* harmony default export */ __webpack_exports__["a"] = (NumberInput);

/***/ }),

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/ChooseLanguageDialog/ChooseLanguageDialog.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_CircleTimer_CircleTimer__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import { FormattedMessage } from 'react-intl';














var cookieKey = 'chlc';

var ChooseLanguageDialog = function (_React$Component) {
  _inherits(ChooseLanguageDialog, _React$Component);

  function ChooseLanguageDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChooseLanguageDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChooseLanguageDialog.__proto__ || Object.getPrototypeOf(ChooseLanguageDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModal: true
    }, _this.onChoose = function (lang) {
      __WEBPACK_IMPORTED_MODULE_3_js_cookie__["set"](cookieKey, lang);
      var redirectUrl = __WEBPACK_IMPORTED_MODULE_10_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location.pathname, lang);
      _this.props.changeLocation(redirectUrl);
      __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].push(redirectUrl);
      window.location.reload();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChooseLanguageDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var locale = this.props.intl.locale;


      var pathname = __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location && __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location.pathname;
      var lng = __WEBPACK_IMPORTED_MODULE_3_js_cookie__["get"](cookieKey);
      if (locale === 'uk' || lng || pathname !== '/') return null;

      var time = 10;

      return _jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: function toggleModal() {},
        show: this.state.showModal
      }, void 0, _jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.title
      }, void 0, '\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043C\u043E\u0432\u043D\u0443 \u0432\u0435\u0440\u0441\u0456\u044E \u0441\u0430\u0439\u0442\u0443'), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.text
      }, void 0, '\u042F\u043A\u0449\u043E \u0432\u0438 \u043D\u0435 \u0437\u0440\u043E\u0431\u0438\u0442\u0435 \u0432\u0438\u0431\u0456\u0440, \u0412\u0430\u0441 \u0431\u0443\u0434\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430 \u0432\u0435\u0440\u0441\u0456\u044E \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u043E\u044E \u043C\u043E\u0432\u043E\u044E \u0447\u0435\u0440\u0435\u0437 10 \u0441\u0435\u043A\u0443\u043D\u0434\u2026'), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.timer + ' container-center'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_CircleTimer_CircleTimer__["a" /* default */], {
        time: time,
        timeUp: function timeUp() {
          _this2.onChoose('uk');
        }
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.buttons
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_UI__["a" /* Button */], {
        type: 'button',
        userTranslate: false,
        text: '\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438\u0441\u044C \u043D\u0430 \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0456\u0439',
        onClick: function onClick() {
          return _this2.onChoose('uk');
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_UI__["a" /* Button */], {
        type: 'button',
        userTranslate: false,
        text: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0443',
        theme: 'DisabledStyle',
        onClick: function onClick() {
          return _this2.onChoose('ru');
        }
      })));
    }
  }]);

  return ChooseLanguageDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeLocation: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["r" /* setLocation */], dispatch)
  };
};
/* harmony default export */ var ChooseLanguageDialog_defaultExport = (__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */](null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](ChooseLanguageDialog))));
// CONCATENATED MODULE: ./src/shared/components/Logo/Logo.js
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Logo_css__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Logo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Logo_css__);
var Logo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












function Logo(props) {
  var t = props.t;

  var logo = t('locale') === 'uk' ? __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg___default.a : __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg___default.a;
  return Logo__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_7__Logo_css___default.a.brandLogo,
    to: '/'
  }, void 0, Logo__jsx('img', {
    src: logo,
    width: '155',
    height: '36',
    style: { display: 'block' },
    title: t('Купить и продать авто в Украине на Автобазар'),
    alt: t('Покупка и продажа авто в Украине на Автобазар')
  }));
}

Logo.defaultProps = {};


/* harmony default export */ var Logo_defaultExport = (Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Logo_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](Logo)));
// CONCATENATED MODULE: ./src/shared/helpers/abtesting.js
// import { experimentDebugger, emitter } from '@marvelapp/react-ab-test';

var setToDataLayer = function setToDataLayer() {
  window.dataLayer.push(arguments);
};

// const implementExperiment = (experimentName, value) => {
//   console.log(`Experiment: ${experimentName}, Set value ${value}`);
//   emitter.setActiveVariant(experimentName, value);
// };

// export const initOptimizeExperiment = (
//   experimentName,
//   variants = ['0', '1'],
//   defaultVariant = '0',
// ) => {
//   if (process.env.BROWSER && window.App && window.App.optimize && !window.App.optimize.debug) {
//     const experiment = window.App.optimize.experiments.find(e => e.name === experimentName);
//     if (experiment && experiment.id) {
//       setTimeout(() => {
//         setToDataLayer('event', 'optimize.callback', {
//           name: experiment.id,
//           callback: value => {
//             implementExperiment(experimentName, value);
//           },
//         });
//       }, 1);
//     }
//   } else {
//     experimentDebugger.enable();
//   }

//   emitter.defineVariants(experimentName, variants);
//   emitter.setActiveVariant(experimentName, defaultVariant);
// };

var initOptimizeExperiment = function initOptimizeExperiment(experimentName) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (true && window.App && window.App.optimize && !window.App.optimize.debug) {
    var experiment = window.App.optimize.experiments.find(function (e) {
      return e.name === experimentName;
    });
    if (experiment && experiment.id) {
      setTimeout(function () {
        setToDataLayer('event', 'optimize.callback', {
          name: experiment.id,
          callback: callback
        });
      }, 1);
    }
  } else {
    callback('0');
  }
};
// CONCATENATED MODULE: ./src/desktop/components/Navigation/NavigationItem/NavigationItem.js
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css__);
var NavigationItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function NavigationItem(props) {
  var isActive = props.isActive;

  var _props$item = props.item,
      childItems = _props$item.items,
      item = _objectWithoutProperties(_props$item, ['items']);

  return NavigationItem__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.active, isActive))
  }, void 0, NavigationItem__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.link,
    link: item,
    eventPrefix: props.eventPrefix
  }), childItems && childItems.length > 0 && NavigationItem__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.dropdown
  }, void 0, childItems.map(function (child) {
    return NavigationItem__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.dLink,
      link: child,
      eventPrefix: '' + props.eventPrefix + item.route
    }, child.title);
  })));
}

NavigationItem.defaultProps = {
  isActive: false,
  eventPrefix: ''
};


/* harmony default export */ var NavigationItem_defaultExport = (NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a)(NavigationItem));
// CONCATENATED MODULE: ./src/desktop/components/Navigation/ProfileButton/ProfileButton.js
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ProfileButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_users__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css__);
var ProfileButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











var ProfileButton__ref = ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u044B\u0439\u0442\u0438'
});

function ProfileButton(props) {
  var user = props.user;

  var buttonTitle = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_users__["d" /* getUserThing */](user);
  var avatar = user.avatar;
  var avatarImg = avatar && avatar.replace('http:', 'https:');
  return ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.root
  }, void 0, ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.link,
    to: '/my/'
  }, void 0, avatarImg && ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.avatarContainer
  }, void 0, ProfileButton__jsx('img', {
    alt: '',
    src: avatarImg,
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.avatar
  })), ProfileButton__jsx('div', {
    title: buttonTitle,
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.btnTitle
  }, void 0, buttonTitle)), ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdown
  }, void 0, ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownList
  }, void 0, __WEBPACK_IMPORTED_MODULE_5_desktop_constants_navigation__["a" /* default */].PROFILE.map(function (link) {
    return ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownLink,
      to: link.route
    }, link.route, ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
      id: link.title
    }));
  }), ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    onClick: props.logout,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownLink, __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.logout),
    to: '/login/'
  }, void 0, ProfileButton__ref))));
}

ProfileButton.defaultProps = {
  logout: function logout() {}
};


/* harmony default export */ var ProfileButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a)(ProfileButton));
// CONCATENATED MODULE: ./src/desktop/components/Navigation/Navigation.js
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Navigation___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Navigation_css__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Navigation_css__);
var Navigation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Navigation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Navigation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Navigation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Navigation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var _ref2 = Navigation__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg___default.a,
  width: '16',
  height: '16',
  alt: '\u041F\u0440\u043E\u0434\u0430\u0442\u044C'
});

var _ref3 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u043E\u0434\u0430\u0442\u044C'
});

var _ref4 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u043E\u0439\u0442\u0438'
});

var Navigation_Navigation = function (_React$Component) {
  Navigation__inherits(Navigation, _React$Component);

  function Navigation() {
    var _ref;

    var _temp, _this, _ret;

    Navigation__classCallCheck(this, Navigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Navigation__possibleConstructorReturn(this, (_ref = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      addLink: '/add/avto/',
      addRel: ''
    }, _this.componentDidMount = function () {
      initOptimizeExperiment('AddFormAB', function (value) {
        var addLinks = {
          '0': { link: '/add/avto/', rel: '' },
          '1': { link: '/addv2/avto/', rel: 'nofollow' }
        };
        if (value && addLinks[value]) {
          _this.setState({
            addLink: addLinks[value].link,
            addRel: addLinks[value].rel
          });
        }
      });
    }, _this.handleSellClick = function () {
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_9_shared_constants_gtmEvents__["a" /* EVENTS */].sellCarButtonClick);
    }, _temp), Navigation__possibleConstructorReturn(_this, _ret);
  }

  Navigation__createClass(Navigation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          history = _props.history,
          current = _props.current,
          shouldSetNoIndex = _props.shouldSetNoIndex;

      var token = user && user.token;

      var currentPath = history.currentPath;

      var currentRoute = current || __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__["a" /* default */].HEADER.filter(function (a) {
        var route = typeof a.route === 'string' && a.route || '';
        currentPath = typeof currentPath === 'string' && currentPath || '';
        return new RegExp('^' + route, 'mi').test(currentPath);
      })[0];

      return Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.root,
        role: 'navigation'
      }, void 0, Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.left
      }, void 0, Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.flexRow
      }, void 0, __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__["a" /* default */].HEADER.map(function (item, i) {
        return Navigation__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.navItem)
        }, i, Navigation__jsx(NavigationItem_defaultExport, {
          item: item,
          isActive: item === currentRoute,
          eventPrefix: 'headerNavigation'
        }));
      }))), Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.right
      }, void 0, Navigation__jsx(Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        onClick: this.handleSellClick,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.link, __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.sell),
        to: this.state.addLink,
        rel: this.state.addRel
      }, void 0, _ref2, '\xA0', _ref3), token && user ? Navigation__jsx(ProfileButton_defaultExport, {
        logout: this.props.userLogout,
        user: user.user
      }) : Navigation__jsx(Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.link, __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.highlight),
        shouldSetNoIndex: shouldSetNoIndex,
        to: '/login',
        rel: 'nofollow'
      }, void 0, _ref4)));
    }
  }]);

  return Navigation;
}(Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Navigation_Navigation.defaultProps = {
  user: {},
  history: {},
  current: null,
  shouldSetNoIndex: true
};


var Navigation_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userLogout: function userLogout() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8_shared_actions_user__["t" /* userLogout */]());
    },
    setDataLayer: __WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_10_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user,
    history: state.history
  };
};

/* harmony default export */ var Navigation_defaultExport = (__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps, Navigation_mapDispatchToProps)(Navigation_Navigation)));
// CONCATENATED MODULE: ./src/desktop/components/Header/Header.js
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_nprogress__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header_css__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Header_css__);
var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var NProgresStart = false;
var NProgresTimeoutStart = void 0;
var NProgresTimeoutDone = void 0;

var Header__ref = Header__jsx(Logo_defaultExport, {});

var Header__ref2 = Header__jsx(Navigation_defaultExport, {});

var Header = function (_React$Component) {
  Header__inherits(Header, _React$Component);

  function Header() {
    Header__classCallCheck(this, Header);

    return Header__possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  Header__createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.configure({
        showSpinner: false
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var loading = this.props.loading;

      if (loading.start && !NProgresStart) {
        NProgresStart = true;
        NProgresTimeoutStart = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.start();
        }, 300);
      }

      if (!loading.start) {
        clearTimeout(NProgresTimeoutDone);
        NProgresTimeoutDone = setTimeout(function () {
          clearTimeout(NProgresTimeoutStart);
          NProgresStart = false;
          __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.done();
        }, 500);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return Header__jsx('div', {
        className: Header___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.root, __WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.fixed)
      }, void 0, Header__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.container
      }, void 0, Header__ref, Header__ref2));
    }
  }]);

  return Header;
}(Header___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Header.defaultProps = {
  location: null,
  locations: null
};


var Header_mapStateToProps = function mapStateToProps(_ref3) {
  var loading = _ref3.loading;
  return {
    loading: loading
  };
};

/* harmony default export */ var Header_defaultExport = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Header_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](Header_mapStateToProps)(Header)));
// CONCATENATED MODULE: ./src/desktop/components/Balance/Balance.js
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Balance___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Balance___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_onclickoutside__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_desktop_components_BalanceRefill_BalanceRefill__ = __webpack_require__(1288);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withBalance__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balance_css__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balance_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Balance_css__);
var Balance__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Balance__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Balance__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Balance__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Balance__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Balance = function (_React$Component) {
  Balance__inherits(Balance, _React$Component);

  function Balance() {
    var _ref;

    var _temp, _this, _ret;

    Balance__classCallCheck(this, Balance);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Balance__possibleConstructorReturn(this, (_ref = Balance.__proto__ || Object.getPrototypeOf(Balance)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isPopupOpened: false,
      shouldFreeze: false
    }, _this.togglePopup = function (e) {
      e.preventDefault();
      _this.setState(function (_ref2) {
        var isPopupOpened = _ref2.isPopupOpened;
        return { isPopupOpened: !isPopupOpened };
      });
    }, _this.handleClickOutside = function () {
      if (!_this.state.shouldFreeze) {
        _this.setState({ isPopupOpened: false });
      }
    }, _this.handleModalOpen = function () {
      _this.setState({ shouldFreeze: true });
    }, _this.handleModalClose = function () {
      _this.setState({ shouldFreeze: false });
    }, _temp), Balance__possibleConstructorReturn(_this, _ret);
  }

  Balance__createClass(Balance, [{
    key: 'render',
    value: function render() {
      var balance = this.props.balance;
      var isPopupOpened = this.state.isPopupOpened;


      if (balance === null) {
        return null;
      }

      return Balance__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.root
      }, void 0, Balance__jsx(Balance___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        to: '/billing/',
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.content,
        onClick: this.togglePopup
      }, void 0, Balance__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.icon,
        src: __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg___default.a,
        alt: '',
        height: 22
      }), '  ', ' ', Balance__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.title
      }, void 0, balance, ' \u0433\u0440\u043D')), Balance__jsx(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a, {
        transitionName: 'fadeUp',
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 100
      }, void 0, isPopupOpened && Balance__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.popup
      }, void 0, Balance__jsx(__WEBPACK_IMPORTED_MODULE_5_desktop_components_BalanceRefill_BalanceRefill__["a" /* default */], {
        onModalOpen: this.handleModalOpen,
        onModalClose: this.handleModalClose
      }))));
    }
  }]);

  return Balance;
}(Balance___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Balance.defaultProps = {
  balance: null
};


/* harmony default export */ var Balance_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withBalance__["a" /* default */]()(__WEBPACK_IMPORTED_MODULE_2_react_onclickoutside__["a" /* default */](Balance))));
// CONCATENATED MODULE: ./src/desktop/components/SubHeader/SubHeader.js
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InlineNav_InlineNav__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubHeader_css__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css__);
var SubHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SubHeader__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SubHeader__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SubHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SubHeader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SubHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SubHeader__ref2 = SubHeader__jsx(Balance_defaultExport, {});

var SubHeader = function (_React$Component) {
  SubHeader__inherits(SubHeader, _React$Component);

  function SubHeader() {
    var _ref;

    var _temp, _this, _ret;

    SubHeader__classCallCheck(this, SubHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SubHeader__possibleConstructorReturn(this, (_ref = SubHeader.__proto__ || Object.getPrototypeOf(SubHeader)).call.apply(_ref, [this].concat(args))), _this), _this.isActive = function (tariff) {
      var expireDate = tariff && tariff.expire_date && new Date(tariff.expire_date);
      var today = new Date();

      return expireDate > today;
    }, _temp), SubHeader__possibleConstructorReturn(_this, _ret);
  }

  SubHeader__createClass(SubHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          navLinks = _props.navLinks,
          currentRoute = _props.currentRoute,
          personalSubheader = _props.personalSubheader,
          user = _props.user,
          including = _props.including,
          intl = _props.intl;

      var sparePartsTariff = user && user.spareparts_tariff;

      return SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.root,
        role: 'navigation'
      }, void 0, SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.container
      }, void 0, SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.left
      }, void 0, SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_7__InlineNav_InlineNav__["a" /* default */], {
        navLinks: navLinks,
        currentRoute: currentRoute,
        including: including,
        eventPrefix: 'subHeader'
      })), SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.right
      }, void 0, personalSubheader && SubHeader__jsx('div', {}, void 0, sparePartsTariff && sparePartsTariff.slug && SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: '/profile/',
        className: SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.tariff, SubHeader__defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.nonActiveTariff, !this.isActive(sparePartsTariff))),
        title: this.isActive(sparePartsTariff) ? undefined : intl.formatMessage({ id: 'Действие пакета закончилось' })
      }, void 0, SubHeader__jsx(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: sparePartsTariff.title
      })), user.tariff && user.tariff.is_business && SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: '/profile/',
        className: SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.tariff, SubHeader__defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.nonActiveTariff, !this.isActive(user.tariff))),
        title: this.isActive(user.tariff) ? undefined : intl.formatMessage({ id: 'Действие пакета закончилось' })
      }, void 0, SubHeader__jsx(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: user.tariff.title
      })), SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.balance
      }, void 0, SubHeader__ref2)))));
    }
  }]);

  return SubHeader;
}(SubHeader___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SubHeader.defaultProps = {
  currentRoute: ''
};


var SubHeader_mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    user: user.user
  };
};

/* harmony default export */ var SubHeader_defaultExport = (SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a)(SubHeader___WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](SubHeader_mapStateToProps, {})(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](SubHeader))));
// CONCATENATED MODULE: ./src/shared/hocs/withFooterLocations.js
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_urls__ = __webpack_require__(312);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withFooterLocations__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withFooterLocations__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withFooterLocations__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withFooterLocations__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var withFooterLocations = function withFooterLocations(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    withFooterLocations__inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      withFooterLocations__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withFooterLocations__possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.getPath = function (routeName, state, location) {
        var transport = state.transport || _this.props.seoSearchUrlResponse && _this.props.seoSearchUrlResponse.transport;
        var make = state.make && state.make.slug || _this.props.seoSearchUrlResponse && _this.props.seoSearchUrlResponse.make;

        var params = _extends({}, state, { make: make, transport: transport, location: location });

        switch (routeName) {
          case 'search':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["e" /* generateSearchUrl */](params);
          case 'moto':
            return '/moto/' + (location ? location.slug : '') + '/';
          case 'commercial':
            return '/commercial/' + (location ? location.slug : '') + '/';
          case 'dealers':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["a" /* generateDealersSearchUrl */](params);
          case 'firms':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["b" /* generateFirmsSearchUrl */](params);
          case 'auto-parts':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["f" /* generateSparesSearchUrl */](params);

          default:
            if (transport && transport.slug) {
              return '/' + transport.slug + '/' + (location ? location.slug : '') + '/';
            }

            return location ? location.slug : '';
        }
      }, _this.handleLinkClick = function (e, location) {
        var routeName = _this.props.routeName;

        e.preventDefault();
        _this.props.onLocationChange(location);

        if (routeName) {
          __WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].push(_this.updateUrl(location));
        } else {
          __WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].push();
        }
      }, _this.updateUrl = function (location, url) {
        var _this$props = _this.props,
            formState = _this$props.formState,
            locale = _this$props.locale,
            routeName = _this$props.routeName;

        var state = _extends({}, formState, { location: location });
        var pathname = _this.getPath(routeName, state, location);

        if (url) {
          return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */](url), locale);
        }

        if (routeName === 'home' && typeof pathname === 'string' && pathname.includes('avto/')) {
          return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */](pathname), locale);
        }

        return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */]('/' + (routeName === 'home' ? 'avto/' : '') + pathname + '/'), locale);
      }, _temp), withFooterLocations__possibleConstructorReturn(_this, _ret);
    }

    withFooterLocations__createClass(_class, [{
      key: 'render',
      value: function render() {
        return withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, {
          getPath: this.getPath,
          updateUrl: this.updateUrl,
          handleLinkClick: this.handleLinkClick
        }));
      }
    }]);

    return _class;
  }(withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withFooterLocations(' + __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    list: [],
    className: '',
    historyStore: {},
    locationLinkBuilder: null,
    routeName: null,
    resetHeader: null,
    seoSearchUrlResponse: {}
  }, _temp2;
};

var withFooterLocations_mapStateToProps = function mapStateToProps(_ref2) {
  var globals = _ref2.globals,
      historyState = _ref2.history,
      searchForm = _ref2.searchForm;
  return {
    locale: globals.locale,
    location: globals.location,
    routeName: historyState && historyState.currentRouteName,
    formState: searchForm && searchForm.selected,
    currentPath: historyState.currentPath,
    seoSearchUrlResponse: globals.seoSearchUrlResponse
  };
};
var withFooterLocations_mapDispatchToProps = {
  onLocationChange: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["r" /* setLocation */]
};

/* harmony default export */ var withFooterLocations_defaultExport = (function (component) {
  return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](withFooterLocations_mapStateToProps, withFooterLocations_mapDispatchToProps)(withFooterLocations(component));
});
// CONCATENATED MODULE: ./src/desktop/components/Footer/ColumnList/ColumnList.js
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColumnList_css__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css__);
var ColumnList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ColumnList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ColumnList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ColumnList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ColumnList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ColumnList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ColumnList__ref2 = ColumnList__jsx('span', {}, void 0, '> ');

var ColumnList = function (_React$Component) {
  ColumnList__inherits(ColumnList, _React$Component);

  function ColumnList() {
    var _ref;

    var _temp, _this, _ret;

    ColumnList__classCallCheck(this, ColumnList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ColumnList__possibleConstructorReturn(this, (_ref = ColumnList.__proto__ || Object.getPrototypeOf(ColumnList)).call.apply(_ref, [this].concat(args))), _this), _this.buildBreadCrumbs = function (selectedLocation, titleKey) {
      if (selectedLocation.is_admin_center) {
        var region = selectedLocation.parents.find(function (item) {
          return item.is_region;
        });
        return ColumnList__jsx(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
          to: _this.props.updateUrl(region),
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.cursorPointer)
        }, void 0, ColumnList__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.hideHover
        }, void 0, '> '), region[titleKey]), ColumnList__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs)
        }, void 0, ColumnList__ref2, selectedLocation[titleKey]));
      }
      return ColumnList__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs)
      }, void 0, '> ', selectedLocation[titleKey]);
    }, _temp), ColumnList__possibleConstructorReturn(_this, _ret);
  }

  ColumnList__createClass(ColumnList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          className = _props.className,
          resetHeader = _props.resetHeader,
          updateUrl = _props.updateUrl,
          search = _props.search,
          selectedLocation = _props.selectedLocation,
          isRegion = _props.isRegion,
          titleKey = _props.titleKey;


      return ColumnList__jsx('div', {
        className: !isRegion ? __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.root : ''
      }, void 0, ColumnList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.breadCrumbsBlock
      }, void 0, search ? ColumnList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationText
      }, void 0, resetHeader) : isRegion && ColumnList__jsx(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
        to: updateUrl(null),
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink
      }, void 0, resetHeader), selectedLocation && this.buildBreadCrumbs(selectedLocation, titleKey))), ColumnList__jsx('div', {
        className: className
      }, void 0, list.map(function (columnItems) {
        return ColumnList__jsx('ul', {
          className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.column
        }, columnItems[0].id, columnItems.map(function (columnItem) {
          if ((columnItem.disabled || columnItem.selectedLocation) && !search) {
            return ColumnList__jsx('p', {
              className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.disabledCity, ColumnList__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.selLocation, columnItem.selectedLocation))
            }, columnItem.id, columnItem[titleKey]);
          }
          return ColumnList__jsx('li', {
            className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.item
          }, columnItem.id + '-link', ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
            to: search ? updateUrl(null, columnItem.url) : updateUrl(columnItem),
            className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.link,
            title: columnItem.hint
          }, void 0, columnItem[titleKey]));
        }));
      })));
    }
  }]);

  return ColumnList;
}(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ColumnList.defaultProps = {
  list: [],
  className: '',
  titleKey: 'title',
  locationLinkBuilder: null,
  routeName: null,
  resetHeader: null,
  search: false,
  isRegion: false,
  selectedLocation: undefined
};


/* harmony default export */ var ColumnList_defaultExport = (withFooterLocations_defaultExport(ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a)(ColumnList___WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](ColumnList))));
// CONCATENATED MODULE: ./src/desktop/components/Footer/LocationList/LocationList.js
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationList_css__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LocationList_css__);
var LocationList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LocationList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function LocationList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocationList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LocationList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var isMobile = "desktop" === 'mobile';

var LocationList_LocationList = function (_Component) {
  LocationList__inherits(LocationList, _Component);

  function LocationList() {
    var _ref;

    var _temp, _this, _ret;

    LocationList__classCallCheck(this, LocationList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LocationList__possibleConstructorReturn(this, (_ref = LocationList.__proto__ || Object.getPrototypeOf(LocationList)).call.apply(_ref, [this].concat(args))), _this), _this.createColumns = function (arr, columnCount) {
      var maxColumnLength = Math.ceil(arr.length / columnCount);

      return arr.reduce(function (result, item, i) {
        return i % (maxColumnLength > 6 ? 6 : maxColumnLength) === 0 ? [].concat(_toConsumableArray(result), [[item]]) : [].concat(_toConsumableArray(result.slice(0, result.length - 1)), [[].concat(_toConsumableArray(result[result.length - 1]), [item])]);
      }, []);
    }, _temp), LocationList__possibleConstructorReturn(_this, _ret);
  }

  LocationList__createClass(LocationList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cities = _props.cities,
          columnCount = _props.columnCount,
          search = _props.search,
          selectedLocation = _props.selectedLocation,
          isRegion = _props.isRegion,
          titleKey = _props.titleKey,
          title = _props.title;

      var citiesColumns = this.createColumns(cities, columnCount);
      var rooClass = isMobile ? __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.root;
      return LocationList__jsx('div', {
        className: rooClass
      }, void 0, title && LocationList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.title
      }, void 0, title), LocationList__jsx('div', {}, void 0, LocationList__jsx(ColumnList_defaultExport, {
        selectedLocation: selectedLocation,
        search: search,
        isRegion: isRegion,
        resetHeader: isRegion ? LocationList__jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
          id: search ? 'Популярные запросы' : 'Вся Украина'
        }) : '',
        list: citiesColumns,
        className: __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.citiesList,
        titleKey: titleKey
      })));
    }
  }]);

  return LocationList;
}(LocationList___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LocationList_LocationList.defaultProps = {
  countries: [],
  cities: [],
  columnCount: 5,
  search: false,
  isRegion: false,
  selectedLocation: undefined,
  titleKey: 'title',
  title: ''
};


/* harmony default export */ var LocationList_defaultExport = (LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a)(LocationList_LocationList));
// CONCATENATED MODULE: ./src/desktop/components/Footer/Footer.js
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_navigation__ = __webpack_require__(1248);
var Footer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
















var Footer__ref4 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438'
});

var _ref5 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439'
});

var _ref6 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440'
});

var _ref7 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u2122'
});

var _ref8 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u2013 \u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u0430\u0442\u044C \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435'
});

function Footer(props) {
  var languages = props.languages,
      currentPath = props.currentPath,
      intl = props.intl,
      locale = props.locale,
      hideLocations = props.hideLocations,
      _props$seoSearchUrlRe = props.seoSearchUrlResponse,
      make = _props$seoSearchUrlRe.make,
      trends = _props$seoSearchUrlRe.trends,
      seoLocations = _props$seoSearchUrlRe.locations,
      selectedLocation = _props$seoSearchUrlRe.location;


  var socialLinks = [{ icon: 'twitter', link: 'https://twitter.com/avtobazar' }, { icon: 'facebook', link: 'https://www.facebook.com/AvtoBazar' }, { icon: 'instagram', link: 'https://www.instagram.com/avtobazar_ua/' }, { icon: 'youtube-play', link: 'https://www.youtube.com/avtobazar' }];
  var allLocations = Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["b" /* getAllLocations */]().map(Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["g" /* setActiveLocations */](seoLocations, selectedLocation));
  var cities = allLocations.filter(function (item) {
    return item.is_admin_center;
  }).sort(__WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["b" /* compareByTitle */]);
  var regions = allLocations.filter(function (item) {
    return item.is_region;
  }).sort(__WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["b" /* compareByTitle */]);

  var hideRegLocValues = ['/add/', '/zhurnal/', '/service/'];
  var hideRegLocations = hideRegLocValues.some(function (item) {
    return currentPath.includes(item);
  });

  var formattedTrends = [];
  if (trends) {
    formattedTrends = trends.map(function (a, b) {
      return {
        id: b,
        slug: '',
        title: a['title_' + intl.locale],
        hint: a['text_' + intl.locale],
        url: a.url
      };
    }).filter(function (a, b) {
      return b < 30;
    });
  }
  var titleKey = locale === 'uk' ? 'uk_title' : 'title';

  return Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.root
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.container
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.flexContainer
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.left
  }, void 0, Footer__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.nav
  }, void 0, __WEBPACK_IMPORTED_MODULE_10__constants_navigation__["a" /* default */].FOOTER.map(function (item) {
    return Footer__jsx('li', {}, item.title, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.link,
      to: item.route,
      rel: 'nofollow'
    }, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: item.title
    })));
  }))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.right
  }, void 0, Footer__jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.tel
  }, void 0, '+380 44 206-56-06'), Footer__jsx('div', {}, void 0, languages.map(function (item) {
    return Footer__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.lang
    }, item.slug, locale === item.slug ? Footer__jsx('span', {}, void 0, item.title) : Footer__jsx('a', {
      href: Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["e" /* removeLocaleFromHref */](currentPath), item.slug),
      'data-lang-code': item.slug
    }, void 0, item.title));
  })))), trends && trends[0] ? Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide,
    style: { margin: '8px 0 8px 0' }
  }), Footer__jsx(LocationList_defaultExport, {
    countries: undefined,
    cities: formattedTrends,
    search: true
  })) : '', !hideLocations && Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide,
    style: { margin: '8px 0 0px 0' }
  }), !hideRegLocations && !hideLocations && Footer__jsx(LocationList_defaultExport, {
    cities: regions,
    search: false,
    selectedLocation: selectedLocation,
    isRegion: true,
    titleKey: titleKey
  }), !hideLocations && Footer__jsx(LocationList_defaultExport, {
    cities: cities,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey,
    isRegion: hideRegLocations
  }), Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide
  }), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.flexContainer
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.left
  }, void 0, Footer__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.nav
  }, void 0, Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/law/',
    rel: 'nofollow'
  }, void 0, Footer__ref4)), Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/advertising-conditions/',
    rel: 'nofollow'
  }, void 0, _ref5)), Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/public-contract/',
    rel: 'nofollow'
  }, void 0, _ref6)))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.right
  }, void 0, Footer__jsx('a', {
    href: 'mailto:support@ab.ua',
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.tel,
    rel: 'nofollow'
  }, void 0, 'support@ab.ua'), Footer__jsx(SocialLinks, {
    socialLinks: socialLinks
  })))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.footerCopyRight
  }, void 0, Footer__jsx('p', {}, void 0, '\xA9 ', new Date().getFullYear(), '\xA0', Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/'
  }, void 0, _ref7), _ref8)));
}

Footer.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }],
  routeName: null,
  seoSearchUrlResponse: {},
  hideLocations: false
};


function SocialLinks(_ref) {
  var socialLinks = _ref.socialLinks;

  return Footer__jsx('div', {}, void 0, socialLinks.map(function (_ref2) {
    var link = _ref2.link,
        icon = _ref2.icon;
    return Footer__jsx('a', {
      href: link,
      target: '_blank',
      rel: 'nofollow noopener noreferrer',
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.socialLink
    }, icon, Footer__jsx('i', {
      className: 'fa fa-' + icon
    }));
  }));
}


var Footer_mapStateToProps = function mapStateToProps(_ref3) {
  var history = _ref3.history,
      searchForm = _ref3.searchForm,
      globals = _ref3.globals;
  return {
    currentPath: history.currentPath,
    routeName: history && history.currentRouteName,
    countries: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default.a,
    formState: searchForm && searchForm.selected,
    seoSearchUrlResponse: globals.seoSearchUrlResponse,
    locale: globals.locale
  };
};

/* harmony default export */ var Footer_defaultExport = (Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a)(Footer___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](Footer_mapStateToProps)(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](Footer))));
// CONCATENATED MODULE: ./src/desktop/components/Footer/LanguageList/LanguageList.js
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageList_css__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LanguageList_css__);
var LanguageList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// / import withFooterLocations from 'shared/hocs/withFooterLocations';
// import Link from 'shared/components/Link/Link';
// import { injectIntl } from 'react-intl';



function LanguageList(props) {
  var languages = props.languages,
      locale = props.locale,
      currentPath = props.currentPath;


  return LanguageList__jsx('div', {}, void 0, languages.map(function (item) {
    return LanguageList__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default.a.lang
    }, item.slug, locale === item.slug ? LanguageList__jsx('span', {}, void 0, item.title) : LanguageList__jsx('a', {
      href: __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["e" /* removeLocaleFromHref */](currentPath), item.slug),
      'data-lang-code': item.slug
    }, void 0, item.title));
  }));
}

LanguageList.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }]
};


var LanguageList_mapStateToProps = function mapStateToProps(_ref) {
  var globals = _ref.globals,
      history = _ref.history;
  return {
    currentPath: history.currentPath,
    locale: globals.locale
  };
};

/* harmony default export */ var LanguageList_defaultExport = (LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default.a)(LanguageList___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](LanguageList_mapStateToProps)(LanguageList)));
// CONCATENATED MODULE: ./src/desktop/components/Footer/FooterLeasing.js
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Footer_css__);
var FooterLeasing__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







// import {
//   removeLocaleFromHref,
//   toLocalized,
//   setActiveLocations,
//   getAllLocations,
// } from 'shared/helpers/locale';

// import { compareByTitle } from 'shared/helpers/arrays';







// import LINKS from '../../constants/navigation';




var FooterLeasing__ref4 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438'
});

var FooterLeasing__ref5 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439'
});

var FooterLeasing__ref6 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440'
});

var FooterLeasing__ref7 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u2122'
});

var FooterLeasing__ref8 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u2013 \u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u0430\u0442\u044C \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435'
});

function LeasingFooter(props) {
  var languages = props.languages,
      currentPath = props.currentPath,
      intl = props.intl,
      locale = props.locale,
      hideLocations = props.hideLocations,
      _props$seoSearchUrlRe = props.seoSearchUrlResponse,
      make = _props$seoSearchUrlRe.make,
      trends = _props$seoSearchUrlRe.trends,
      seoLocations = _props$seoSearchUrlRe.locations,
      selectedLocation = _props$seoSearchUrlRe.location;


  var socialLinks = [{ icon: 'twitter', link: 'https://twitter.com/avtobazar' }, { icon: 'facebook', link: 'https://www.facebook.com/AvtoBazar' }, { icon: 'instagram', link: 'https://www.instagram.com/avtobazar_ua/' }, { icon: 'youtube-play', link: 'https://www.youtube.com/avtobazar' }];
  // const allLocations = getAllLocations().map(setActiveLocations(seoLocations, selectedLocation));
  // const cities = allLocations.filter(item => item.is_admin_center).sort(compareByTitle);
  // const regions = allLocations.filter(item => item.is_region).sort(compareByTitle);

  // const hideRegLocValues = ['/add/', '/zhurnal/', '/service/'];
  // const hideRegLocations = hideRegLocValues.some(item => currentPath.includes(item));

  // let formattedTrends = [];
  // if (trends) {
  //   formattedTrends = trends
  //     .map((a, b) => ({
  //       id: b,
  //       slug: '',
  //       title: a[`title_${intl.locale}`],
  //       hint: a[`text_${intl.locale}`],
  //       url: a.url,
  //     }))
  //     .filter((a, b) => b < 30);
  // }
  var titleKey = locale === 'uk' ? 'uk_title' : 'title';
  var listBav = [{
    titleHeader: 'Информация по телефону',
    title: '+380 44 206-56-06'
  }, {
    titleHeader: 'Адрес',
    title: intl.formatMessage({ id: 'Украина, г. Киев, ул. Лейпцигская 15а' })
  }, {
    titleHeader: 'Почта',
    title: 'support@ab.ua'
  }];
  return FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.root
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.container
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.flexContainer
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.left
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasing
  }, void 0, listBav.map(function (item) {
    return FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingItem
    }, item.title, FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingTitleHeader
    }, void 0, FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: item.titleHeader
    })), FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingTitle
    }, void 0, item.title));
  }))), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.right
  }, void 0, FooterLeasing__jsx(LanguageList_defaultExport, {
    languages: languages
  }), FooterLeasing__jsx(FooterLeasing_SocialLinks, {
    socialLinks: socialLinks
  }))), FooterLeasing__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.divide
  }), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.leasingList
  }, void 0, FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  }), FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  }), FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  })), FooterLeasing__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.divide
  }), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.flexContainer
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.left
  }, void 0, FooterLeasing__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.nav
  }, void 0, FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/law/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref4)), FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/advertising-conditions/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref5)), FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/public-contract/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref6)))))), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.footerCopyRight
  }, void 0, FooterLeasing__jsx('p', {}, void 0, '\xA9 ', new Date().getFullYear(), '\xA0', FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/'
  }, void 0, FooterLeasing__ref7), FooterLeasing__ref8)));
}

LeasingFooter.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }],
  routeName: null,
  seoSearchUrlResponse: {},
  hideLocations: false
};


function FooterLeasing_SocialLinks(_ref) {
  var socialLinks = _ref.socialLinks;

  return FooterLeasing__jsx('div', {}, void 0, socialLinks.map(function (_ref2) {
    var link = _ref2.link,
        icon = _ref2.icon;
    return FooterLeasing__jsx('a', {
      href: link,
      target: '_blank',
      rel: 'nofollow noopener noreferrer',
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.socialLink
    }, icon, FooterLeasing__jsx('i', {
      className: 'fa fa-' + icon
    }));
  }));
}


var FooterLeasing_mapStateToProps = function mapStateToProps(_ref3) {
  var history = _ref3.history,
      searchForm = _ref3.searchForm,
      globals = _ref3.globals;
  return {
    currentPath: history.currentPath,
    routeName: history && history.currentRouteName,
    countries: __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json___default.a,
    formState: searchForm && searchForm.selected,
    seoSearchUrlResponse: globals.seoSearchUrlResponse,
    locale: globals.locale
  };
};

/* harmony default export */ var FooterLeasing_defaultExport = (FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a)(FooterLeasing___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](FooterLeasing_mapStateToProps)(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](LeasingFooter))));
// CONCATENATED MODULE: ./src/shared/hocs/withNotifications.js
/* harmony import */ var withNotifications___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withNotifications___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var withNotifications__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withNotifications__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withNotifications__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withNotifications__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withNotifications__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var withNotifications_mapStateToProps = function mapStateToProps(_ref) {
  var notifications = _ref.notifications;
  return { messageQueue: notifications };
};
var withNotifications_mapDispatchToProps = { shift: __WEBPACK_IMPORTED_MODULE_2_shared_actions_notifications__["b" /* shiftNotification */] };

var withNotifications = function withNotifications(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](withNotifications_mapStateToProps, withNotifications_mapDispatchToProps)((_temp2 = _class = function (_React$Component) {
    withNotifications__inherits(_class, _React$Component);

    function _class() {
      var _ref2;

      var _temp, _this, _ret;

      withNotifications__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withNotifications__possibleConstructorReturn(this, (_ref2 = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
        activeMessage: null
      }, _this.tick = function () {
        var _this$props = _this.props,
            duration = _this$props.duration,
            shift = _this$props.shift;

        var lastMessage = _this.props.messageQueue[0];

        if (lastMessage) {
          _this.setState({ activeMessage: lastMessage }, function () {
            delay(duration).then(function () {
              shift();
              _this.setState({ activeMessage: null }, function () {
                delay(duration / 4).then(function () {
                  return _this.tick();
                });
              });
            });
          });
        }
      }, _temp), withNotifications__possibleConstructorReturn(_this, _ret);
    }

    withNotifications__createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.state.activeMessage) {
          this.tick();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.messageQueue.length < this.props.messageQueue.length && !this.state.activeMessage) {
          this.tick();
        }
      }
    }, {
      key: 'render',
      value: function render() {

        return withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, withNotifications__extends({ activeMessage: this.state.activeMessage }, this.props));
      }
    }]);

    return _class;
  }(withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withNotifications(' + __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    duration: 4000
  }, _temp2));
};

/* harmony default export */ var withNotifications_defaultExport = (withNotifications);
// CONCATENATED MODULE: ./src/desktop/components/Layout/NotificationBar/NotificationBar.js
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css__);
var NotificationBar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function NotificationBar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function NotificationBar(props) {
  var activeMessage = props.activeMessage;

  var type = activeMessage && activeMessage.type;

  return NotificationBar__jsx('div', {
    className: NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.root, NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.active, activeMessage),
    //
    NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.error, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].ERROR), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.success, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].SUCCESS), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.warning, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].WARNING), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.info, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].INFO))
  }, void 0, activeMessage && NotificationBar__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.label
  }, void 0, activeMessage.text));
}

NotificationBar.defaultProps = {
  activeMessage: null
};


/* harmony default export */ var NotificationBar_defaultExport = (NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a)(withNotifications_defaultExport(NotificationBar)));
// CONCATENATED MODULE: ./src/desktop/components/Layout/Layout.js
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_lazyload__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Layout_css__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Layout_css__);
var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Layout__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { updateBranding } from 'shared/helpers/adsAndMetrics';




















// eslint-disable-next-line css-modules/no-unused-class


var isClient = true;
var localCurrentPage = '';

var Layout__ref = Layout__jsx(NotificationBar_defaultExport, {});

var Layout__ref2 = Layout__jsx(Header_defaultExport, {});

var Layout__ref3 = Layout__jsx(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a, {}, void 0, Layout__jsx(Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1514298874616-0'
}));

var Layout__ref4 = Layout__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_BannerAll__["a" /* BannersBuffer */], {});

var Layout__ref5 = Layout__jsx(ChooseLanguageDialog_defaultExport, {});

var Layout_Layout = function (_React$Component) {
  Layout__inherits(Layout, _React$Component);

  function Layout() {
    Layout__classCallCheck(this, Layout);

    return Layout__possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
  }

  Layout__createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!isClient) return;
      var targetNode = window.document.body;
      var bannerTopAB = window.document.getElementById('banner-top-AB');
      var changeObserver = function changeObserver() {
        if (targetNode.style.backgroundImage) {
          window.document.getElementById('bodyABIdBlock').style.margin = '68px auto 0  auto';
        } else if (bannerTopAB && Number(bannerTopAB.clientHeight) > 30) {
          // bannerTopAB.style.marginTop = '20px';
          bannerTopAB.style.display = 'flex';
        }
      };

      var observer = new MutationObserver(changeObserver);
      var observerTop = new MutationObserver(changeObserver);
      observer.observe(targetNode, { attributes: true, childList: true });
      if (bannerTopAB) {
        observerTop.observe(bannerTopAB, { attributes: true, childList: true });
      }
      // updateBranding();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var currentPath = this.props.history.currentPath;

      if (true && '' + location.pathname + location.search !== currentPath && currentPath !== localCurrentPage) {
        // updateBranding();
        localCurrentPage = currentPath;
      }
    }
  }, {
    key: 'getFooter',
    value: function getFooter() {
      var _props = this.props,
          hideLocations = _props.hideLocations,
          footer = _props.footer;

      if (footer === 'leasing') return Layout__jsx(FooterLeasing_defaultExport, {
        hideLocations: hideLocations
      });
      return Layout__jsx(Footer_defaultExport, {
        hideLocations: hideLocations
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          navLinks = _props2.navLinks,
          currentRoute = _props2.currentRoute,
          including = _props2.including,
          personalSubheader = _props2.personalSubheader,
          currentPath = _props2.history.currentPath;


      return Layout__jsx('div', {
        id: !navLinks ? 'fakeSubHeader' : '',
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.root
      }, void 0, Layout__ref, Layout__ref2, navLinks && !!navLinks.length && Layout__jsx(SubHeader_defaultExport, {
        including: including,
        navLinks: navLinks,
        currentRoute: currentRoute,
        personalSubheader: personalSubheader
      }), !new Set(Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__["g" /* ignoreTopBanner */]).has(currentPath) && !/\/edit\//.test(currentPath) ? Layout__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.brandingAdv,
        id: 'banner-top-AB'
      }, void 0, Layout__ref3) : '', Layout__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.layout,
        id: 'bodyABIdBlock'
      }, void 0, this.props.children), Layout__jsx('main', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.mainFooter
      }, void 0, this.getFooter()), Layout__ref4, isClient && Layout__ref5);
    }
  }]);

  return Layout;
}(Layout___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Layout_Layout.defaultProps = {
  history: {},
  currentRoute: null,
  navLinks: null,
  withBranding: false,
  personalSubheader: false,
  including: true,
  targetingArguments: {},
  shouldInitAds: true,
  hideLocations: false,
  string: '',
  footer: ''
};


/* harmony default export */ __webpack_exports__["a"] = (Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */](function (_ref6) {
  var history = _ref6.history;
  return {
    history: history
  };
})(Layout_Layout)));

/***/ }),

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DecimalInput = function (_React$Component) {
  _inherits(DecimalInput, _React$Component);

  function DecimalInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DecimalInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DecimalInput.__proto__ || Object.getPrototypeOf(DecimalInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      tempValue: _this.props.value,
      isInDotMode: false
    }, _this.handleChange = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          delimiters = _this$props.delimiters;


      value = value.replace(new RegExp('[' + delimiters + ']', 'g'), '.');

      if (value && value.startsWith('.')) {
        value = '';
      }

      if (value === '' || value.match(/^\d+(\.\d+)?$/)) {
        _this.setState({ isInDotMode: false });
        onChange(value);
      } else if (value.match(/^\d+\.$/)) {
        _this.setState({
          tempValue: value,
          isInDotMode: true
        });
      }
    }, _this.handleBlur = function () {
      if (_this.state.isInDotMode) {
        _this.setState(function (_ref2) {
          var tempValue = _ref2.tempValue;

          var newValue = '' + parseInt(tempValue, 10);
          _this.props.onChange(newValue);
          return { tempValue: newValue };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DecimalInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var value = this.props.value;
      var _state = this.state,
          isInDotMode = _state.isInDotMode,
          tempValue = _state.tempValue;


      if (!isInDotMode && '' + tempValue !== '' + value) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ tempValue: value ? '' + value : value });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inputRef = _props.inputRef,
          props = _objectWithoutProperties(_props, ['inputRef']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, props, {
        type: 'tel',
        ref: inputRef,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        value: this.state.tempValue || ''
      }));
    }
  }]);

  return DecimalInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DecimalInput.defaultProps = {
  value: undefined,
  inputRef: undefined,
  onChange: function onChange() {},
  delimiters: '.,'
};


/* harmony default export */ __webpack_exports__["a"] = (DecimalInput);

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_NavigationLink_NavigationLink__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InlineNav_css__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InlineNav_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function InlineNav(props) {
  var navLinks = props.navLinks,
      including = props.including,
      currentRoute = props.currentRoute;

  var route = (currentRoute + '/').replace('//', '/');
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.root,
    role: 'navigation'
  }, void 0, _jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.list
  }, void 0, navLinks.map(function (item) {
    return _jsx('li', {
      className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.item
    }, item.route, _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
      link: item,
      currentRoute: route,
      including: including,
      className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.link,
      activeClassName: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.active,
      eventPrefix: props.eventPrefix
    }));
  })));
}

InlineNav.defaultProps = {
  including: true,
  currentRoute: null,
  count: null,
  withCount: false,
  eventPrefix: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a)(InlineNav));

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(1358);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1361);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(1264);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';

CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentRollAdsense; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var isDev = false;

var _ref = _jsx('div', {}, void 0, '________________slot_________________');

var _ref2 = _jsx('div', {}, void 0, '_________ContentRollAdsense__________');

var _ref3 = _jsx('div', {}, void 0, '________________STYLE_________________');

var _ref4 = _jsx('div', {}, void 0, '________________end_block_________________');

function ContentRollAdsenseClass(props) {
  var adClient = props.adClient,
      adSlot = props.adSlot,
      other = _objectWithoutProperties(props, ['adClient', 'adSlot']);

  var devStyle = {
    width: '100%',
    minHeight: '200px',
    backgroundColor: '#ffb900',
    border: '3px solid #a73c3c'
  };
  if (isDev) {
    return _jsx('div', {
      style: devStyle
    }, void 0, _ref, _ref2, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, adSlot), _ref3, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, JSON.stringify(other.style)), _ref4);
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ins', _extends({}, other, { className: 'adsbygoogle', 'data-ad-client': adClient, 'data-ad-slot': adSlot }));
}

ContentRollAdsenseClass.defaultProps = {
  adClient: 'ca-pub-8183181871645898',
  adSlot: '7650493142'
};


var ContentRollAdsense = ContentRollAdsenseClass;

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var ButtonGeneral = function ButtonGeneral(_ref) {
  var _cx;

  var text = _ref.text,
      type = _ref.type,
      theme = _ref.theme,
      clickHandler = _ref.clickHandler,
      Icon = _ref.Icon,
      className = _ref.className,
      isProcessing = _ref.isProcessing,
      disabled = _ref.disabled,
      userTranslate = _ref.userTranslate,
      iconAfterText = _ref.iconAfterText,
      inputParams = _objectWithoutProperties(_ref, ['text', 'type', 'theme', 'clickHandler', 'Icon', 'className', 'isProcessing', 'disabled', 'userTranslate', 'iconAfterText']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    _extends({
      disabled: disabled || isProcessing,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonGeneral"], (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonTransparent"], theme === 'Transparent'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonTransparentYellow"], theme === 'TransparentYellow'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonYellow"], theme === 'Yellow'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonWhite"], theme === 'White'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonYellowFlat"], theme === 'YellowFlat'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonDisabledStyle"], theme === 'DisabledStyle'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonProcessing"], isProcessing), _defineProperty(_cx, className, !!className), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["iconAfterText"], iconAfterText), _cx)),
      type: type,
      onClick: clickHandler
    }, inputParams),
    _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__["a" /* default */], {
      isLoading: isProcessing,
      className: __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonLoader"]
    }),
    Icon && !iconAfterText ? _jsx(Icon, {}) : null,
    userTranslate ? _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: text
    }) : text,
    Icon && iconAfterText ? _jsx(Icon, {}) : null
  );
};

ButtonGeneral.defaultProps = {
  type: 'submit',
  theme: 'Yellow',
  className: '',
  Icon: null,
  disabled: false,
  clickHandler: function clickHandler() {},
  isProcessing: false,
  userTranslate: true,
  iconAfterText: false
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__)(ButtonGeneral));

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/hocs/withMonoPayment.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__history__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var throwIfResponseNotOkay = function throwIfResponseNotOkay() {
  return function (response) {
    if (!response.ok) {
      throw new Error('Произошла ошибка');
    }

    return response;
  };
};

var getMonoOrderData = function getMonoOrderData(fetch, token, data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.MONO_ORDER_CHECKOUT, {
    method: 'POST',
    headers: {
      Authorization: 'JWT ' + token
    },
    body: JSON.stringify(data)
  });
};

var updateAdvertParams = function updateAdvertParams(advertParams, fetch, token, advertID, promoteInSocial) {
  if (advertParams.kind && advertParams.kind === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["d" /* PACKAGES */].C2C_TURBO && promoteInSocial) {
    fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].ADVERT.ITEM(advertID), {
      method: 'PATCH',
      headers: {
        Authorization: 'JWT ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ promote_in_social: promoteInSocial })
    });
  }
};

var withMonoPayment = function withMonoPayment(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        fondyFrameUrl: '',
        fondyCb: null,
        showModal: false,
        showInvoiceModal: false,
        billAmount: null,
        accountNumber: null,
        eventCounter: 1
      }, _this.setGtmEvent = function (gtmId) {
        if (!gtmId) return;

        var eventCounter = _this.state.eventCounter;

        var dataLayer = window && Array.isArray(window.dataLayer) && window.dataLayer;
        var gtmDataLayerValue = dataLayer && dataLayer.find(function (el) {
          return el.event === gtmId.event;
        });

        if (gtmDataLayerValue) {
          var newCounter = eventCounter + 1;
          _this.setState({ eventCounter: newCounter });
          _this.props.setDataLayer(_extends({}, gtmId, { event: '' + gtmId.event + newCounter + '/' }));
        } else {
          _this.props.setDataLayer(gtmId);
        }
      }, _this.getGtmEvent = function (gtmType) {
        var user = _this.props.user;

        var isBusiness = user.user.tariff && user.user.tariff.is_business;
        var isDealership = user.user.tariff && user.user.tariff.slug === 'b2c-plus';

        if (isDealership) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.dealership[gtmType];
        } else if (isBusiness) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.business[gtmType];
        }
        return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert[gtmType];
      }, _this.sendGtmMetrics = function (params) {
        if (params.kind === 'subscription') _this.setGtmEvent(_this.getGtmEvent(params.details.tariff));else if (params.kind === 'c2c-free' && params.details && params.details.promos) {
          params.details.promos.map(function (item) {
            return _this.setGtmEvent(_this.getGtmEvent(item));
          });
        } else _this.setGtmEvent(_this.getGtmEvent(params.kind));
      }, _this.openMonoOrderWindow = function (token, params, redirectUrl, paymentMethod, cb) {
        var _this$props = _this.props,
            fetch = _this$props.fetch,
            intl = _this$props.intl,
            promoteInSocial = _this$props.promoteInSocial;
        var locale = intl.locale;

        var redirectUrlLocalized = __WEBPACK_IMPORTED_MODULE_10__helpers_locale__["h" /* toLocalized */](redirectUrl, locale);
        var advertId = params.details && params.details.advert_id;

        __WEBPACK_IMPORTED_MODULE_9__helpers_common__["j" /* iniRedirectToCheckout */]();
        return function () {
          return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.orders(), {
            method: 'POST',
            headers: {
              Authorization: 'JWT ' + token
            },
            body: JSON.stringify(params)
          }).then(throwIfResponseNotOkay()).then(function (r) {
            return r.json();
          }).then(function (_ref2) {
            var number = _ref2.number,
                status = _ref2.status;

            if (status === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["c" /* ORDER_STATUSES */].PAID || paymentMethod === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE) {
              _this.sendGtmMetrics(params);
              _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
              _this.props.enqueueNotification({
                text: intl.formatMessage({ id: 'Оплата прошла успешно' }),
                type: __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__["a" /* default */].SUCCESS
              });
              updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
              if (cb) cb({ number: number, status: status });else __WEBPACK_IMPORTED_MODULE_13__history__["a" /* default */].push(redirectUrlLocalized);
            } else {
              var handlerUrl = __WEBPACK_IMPORTED_MODULE_11__constants_payment__["j" /* URLS */].HANDLER_URL_FULL + '?redirectUrl=' + redirectUrlLocalized;
              return getMonoOrderData(fetch, token, {
                order_number: number,
                response_url: handlerUrl,
                lang: locale
              }).then(throwIfResponseNotOkay()).then(function (r) {
                return r.json();
              }).then(function (data) {
                _this.sendGtmMetrics(params);
                _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
                var url = data.checkout_url;
                updateAdvertParams(params, fetch, token, advertId, promoteInSocial);

                __WEBPACK_IMPORTED_MODULE_9__helpers_common__["d" /* doRedirectToCheckout */](url);
              });
            }

            return Promise.resolve();
          });
        }().catch(function (e) {
          _this.props.enqueueNotification(intl.formatMessage({ id: e.message ? e.message : e }));
          if (cb) cb(null, e.message ? e.message : e);
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { openMonoOrderWindow: this.openMonoOrderWindow }));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withOrders(' + __WEBPACK_IMPORTED_MODULE_9__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2);

  var mapDispatchToProps = {
    enqueueNotification: __WEBPACK_IMPORTED_MODULE_12__actions_notifications__["a" /* enqueueNotification */],
    setDataLayer: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["j" /* setDataLayer */]
  };

  var mapStateToProps = function mapStateToProps(_ref3) {
    var globals = _ref3.globals,
        user = _ref3.user;
    return {
      promoteInSocial: globals.promoteInSocial,
      user: user
    };
  };

  return __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__["a" /* withFetch */](Component)));
};

/* harmony default export */ var withMonoPayment_defaultExport = (withMonoPayment);
// CONCATENATED MODULE: ./src/desktop/components/BalanceRefill/BalanceRefill.js
/* harmony import */ var BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_PaymentModal__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var BalanceRefill__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function BalanceRefill__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BalanceRefill__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BalanceRefill__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C'
});

var BalanceRefill = function (_React$Component) {
  BalanceRefill__inherits(BalanceRefill, _React$Component);

  function BalanceRefill() {
    var _ref;

    var _temp, _this, _ret;

    BalanceRefill__classCallCheck(this, BalanceRefill);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = BalanceRefill__possibleConstructorReturn(this, (_ref = BalanceRefill.__proto__ || Object.getPrototypeOf(BalanceRefill)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      refillAmount: 99,
      showModal: false
    }, _this.handleChange = function (e) {
      var value = e.target.value;


      if (value === '') {
        _this.setState({ refillAmount: null });
      } else {
        var intValue = parseInt(value, 10);

        if (intValue) {
          _this.setState({ refillAmount: intValue });
        }
      }
    }, _this.handleShow = function () {
      // this.props.onModalOpen();
      // this.setState({ showModal: true });
      var _this$props = _this.props,
          token = _this$props.token,
          openMonoOrderWindow = _this$props.openMonoOrderWindow;
      var refillAmount = _this.state.refillAmount;


      openMonoOrderWindow(token, {
        kind: __WEBPACK_IMPORTED_MODULE_8_shared_constants_payment__["b" /* KINDS */].BALANCE_REFILL,
        details: {
          refill_amount: refillAmount
        }
      }, '' + window.location.pathname + window.location.search, // return to where we are
      'mono');
    }, _this.handleHide = function () {
      _this.props.onModalClose();
      _this.setState({ showModal: false });
    }, _this.renderModal = function () {
      return _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Modal__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_PaymentModal__["a" /* default */], {
        title: _this.props.intl.formatMessage({ id: 'Пополнение баланса' }),
        description: _this.props.intl.formatMessage({
          id: 'Пополнение внутреннего баланса в аккаунте avtobazar.ua'
        }),
        closeHandler: _this.handleHide,
        amount: _this.state.refillAmount,
        balanceRefillMode: true
      }));
    }, _temp), BalanceRefill__possibleConstructorReturn(_this, _ret);
  }

  // handlePaymentMethodChosen = paymentMethodInfo => {
  //   const { token, openMonoOrderWindow } = this.props;
  //   const { refillAmount } = this.state;

  //   openMonoOrderWindow(
  //     token,
  //     {
  //       kind: KINDS.BALANCE_REFILL,
  //       details: {
  //         refill_amount: refillAmount,
  //       },
  //     },
  //     `${window.location.pathname}${window.location.search}`, // return to where we are
  //     paymentMethodInfo.slug,
  //   );
  // };

  BalanceRefill__createClass(BalanceRefill, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          refillAmount = _state.refillAmount,
          showModal = _state.showModal;


      return _jsx('div', {}, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.inputContainer
      }, void 0, _jsx('input', {
        type: 'text',
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.input),
        value: refillAmount || '',
        onChange: this.handleChange
      }), _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.hrn
      }, void 0, '\u0433\u0440\u043D'), _jsx('button', {
        onClick: this.handleShow,
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.inlineButton,
        disabled: !refillAmount
      }, void 0, _ref2)), showModal && this.renderModal());
    }
  }]);

  return BalanceRefill;
}(BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BalanceRefill.defaultProps = {
  onModalOpen: function onModalOpen() {},
  onModalClose: function onModalClose() {}
};


var mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    token: user.token
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps)(withMonoPayment_defaultExport(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](BalanceRefill)))));

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1290)();
}

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1291);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1293);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1296);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1294), __esModule: true };

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
__webpack_require__(478);
module.exports = __webpack_require__(1295);

/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1260);
var ITERATOR = __webpack_require__(86)('iterator');
var Iterators = __webpack_require__(187);
module.exports = __webpack_require__(30).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined || '@@iterator' in O
  // eslint-disable-next-line no-prototype-builtins
  || Iterators.hasOwnProperty(classof(O));
};

/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1297), __esModule: true };

/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
__webpack_require__(478);
module.exports = __webpack_require__(1298);

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(105);
var get = __webpack_require__(1279);
module.exports = __webpack_require__(30).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1300);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BannerAll.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BannerAll.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2I0F2{margin-bottom:20px}._3DEYy{position:relative}.K2GWo{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}._1VCyV,.K2GWo{display:-webkit-box;display:-ms-flexbox;display:flex}._1VCyV{-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px;margin-bottom:20px}._1VCyV>div{margin-bottom:10px;margin-top:10px}._3coG7{height:100%}", ""]);

// exports
exports.locals = {
	"gptPremium": "_2I0F2",
	"flexCell": "_3DEYy",
	"sideBar": "K2GWo",
	"advertContainerButoon": "_1VCyV",
	"homeSideBar": "_3coG7"
};

/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1302);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalContainer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalContainer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1302:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3ubq_{position:fixed;z-index:3005;background-color:rgba(50,50,50,.5);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._8Koz-{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3006;backdrop-filter:blur(4px)}.NhUO6{background-color:#fff;border:1px solid #bfbfbf;-ms-flex-item-align:center;align-self:center;z-index:3007}._2Ncf4{max-width:600px;width:90%;min-height:300px;padding:15px 20px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
exports.locals = {
	"root": "_3ubq_",
	"background": "_8Koz-",
	"content": "NhUO6",
	"contentParams": "_2Ncf4"
};

/***/ }),

/***/ 1303:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1304);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalWrapper.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalWrapper.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1304:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._cLKp{padding:20px 15px}._21JFC{overflow-y:auto;max-height:100vh;margin:0 auto}._2lSzg{position:relative;border-radius:10px;max-width:330px}._1BONa,._18jW-{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}._18jW-:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"rootModalContainer": "_cLKp",
	"rootModal": "_21JFC",
	"modal": "_2lSzg",
	"closeBtnIcon": "_1BONa",
	"closeBtn": "_18jW-"
};

/***/ }),

/***/ 1305:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1306);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CircleTimer.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CircleTimer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3B1TS{font-size:32px;color:#000}._1H7x_{-webkit-transform-origin:center center;transform-origin:center center;-webkit-transform:rotate(-92deg);transform:rotate(-92deg)}", ""]);

// exports
exports.locals = {
	"circleTimerText": "_3B1TS",
	"circleTimerProgress": "_1H7x_"
};

/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1308);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Loader.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Loader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._23UJ_{text-align:center;padding:10px 0}", ""]);

// exports
exports.locals = {
	"root": "_23UJ_"
};

/***/ }),

/***/ 1309:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1s4zB{position:relative;padding:7px 8px;border-radius:2px;height:42px;line-height:30px;border:1px solid #c4c4c4;outline:none;font-size:13px;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._1s4zB::-webkit-input-placeholder{color:gray}._1s4zB::-moz-placeholder{color:gray}._1s4zB:-ms-input-placeholder{color:gray}._1s4zB::placeholder{color:gray}.vJnum{position:relative;margin:0 auto 10px;width:100%;padding:10px 0;font-size:14px;color:#000;font-weight:700;border-width:1px;border-style:solid;outline:none;cursor:pointer;line-height:1.1;border-radius:3px;white-space:nowrap}.vJnum:disabled,.vJnum:disabled>.hX4eV{color:rgba(0,0,0,.25);pointer-events:none}._1F-aN{color:rgba(0,0,0,.25)}._2YtbV,._3bKRW{background-color:#ffd906;border-color:#ffd906}._2YtbV,._3bKRW:hover{background-color:#ffc107;border-color:#ffc107}._2YtbV{border:none}._2YtbV:disabled{background-color:#f5f5f5}._1AWF-{background-color:#fff;border-color:#c4c4c4}._1AWF-:hover{background-color:#fffceb}._2DyKI{background-color:transparent}._2DyKI:hover,._38ptx:hover{background-color:#ffc10744}._38ptx{background-color:transparent;border:1px solid #ffc107}.vJnum.aO6AT>:not(._289M5){visibility:hidden}._15Egm{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding:0;font-size:11px}.zoFvb>svg{margin-left:6px}.vJnum:not(.zoFvb)>svg{margin-right:6px}", ""]);

// exports
exports.locals = {
	"inputGeneral": "_1s4zB",
	"ButtonGeneral": "vJnum",
	"btnInfo": "hX4eV",
	"ButtonDisabledStyle": "_1F-aN",
	"ButtonYellowFlat": "_2YtbV",
	"ButtonYellow": "_3bKRW",
	"ButtonWhite": "_1AWF-",
	"ButtonTransparent": "_2DyKI",
	"ButtonTransparentYellow": "_38ptx",
	"buttonLoader": "aO6AT",
	"ButtonProcessing": "_289M5",
	"ButtonLoader": "_15Egm",
	"iconAfterText": "zoFvb"
};

/***/ }),

/***/ 1310:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1311);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ContactButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ContactButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1311:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3z1Cv{min-height:60px;width:190px;background-color:#ffd906;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:auto;text-align:center}._3z1Cv,._3z1Cv a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3z1Cv a{padding:7px 16px 4px;font-weight:600;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1D5tw{min-height:60px;width:190px}._1D5tw,.a06XJ{font-size:14px;background-color:#ffd906;border-radius:2px;border:1px solid #ffd906;padding:7px 16px 4px;color:#000;cursor:pointer;text-align:center;line-height:1.52;outline:none;font-weight:600;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:auto}._1D5tw a,._3YwyV a,._3z1Cv a,.a06XJ a{color:#000}._3z1Cv{cursor:default;background-color:#f5f5f5;border:1px solid transparent}._1D5tw:hover,._3z1Cv:hover{background-color:#ffc107;border:1px solid #ffc107}._31u6D{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3T3i5,._31u6D{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._254Zh{padding-bottom:2px;padding-left:4px}._3vtyf,._254Zh{line-height:12px;font-size:14px}._3YwyV,.a06XJ{width:100%;min-height:42px}._3YwyV>._31u6D{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.a06XJ{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"showedContainerDesktop": "_3z1Cv",
	"hided": "_1D5tw",
	"showedPhoneMobile": "a06XJ",
	"hidedMobile": "_3YwyV",
	"hidedContent": "_31u6D",
	"hiddenPhone": "_3T3i5",
	"Plus": "_254Zh",
	"Dots": "_3vtyf"
};

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1313);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckBox.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckBox.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Vsl7{position:relative;display:inline-block;cursor:pointer;font-weight:400;font-size:13px;color:#000;padding-left:20px;white-space:nowrap}._3Vsl7:hover{color:#ff5a5f}._3Vsl7 input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px;cursor:pointer}._3Vsl7 input,._3Vsl7 input:checked{-webkit-appearance:none;width:15px;height:15px;outline:none}._3Vsl7 input:checked{border:1px solid #ffd906;background-color:#ffd906;border-radius:2px}._3Vsl7 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:2;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}", ""]);

// exports
exports.locals = {
	"checkbox": "_3Vsl7"
};

/***/ }),

/***/ 1314:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1315);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1315:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1hjln{white-space:nowrap;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:6px 6px 6px 0;height:32px;padding:0 8px;font-size:12px;color:#333;min-width:90px;border-radius:2px;border:1px solid #ffd906;cursor:pointer}._1hjln>svg{margin-right:8px}._1hjln:hover{background-color:#ffd906;-webkit-transition:.3s;-o-transition:.3s;transition:.3s}._1hjln:last-child{margin-right:0}._1SOx4{border:1px solid #c4c4c4;border-radius:2px;pointer-events:none;color:#c4c4c4}._1SOx4 path{fill:#c4c4c4}", ""]);

// exports
exports.locals = {
	"tag": "_1hjln",
	"disabled": "_1SOx4"
};

/***/ }),

/***/ 1316:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1317);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Select.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1pNgY .Select-control{height:42px}._1pNgY .Select-placeholder,._1pNgY .Select-value{line-height:42px;height:42px;font-weight:400}._1dne7 .Select-control{border:none}", ""]);

// exports
exports.locals = {
	"root": "_1pNgY",
	"theme-flat": "_1dne7"
};

/***/ }),

/***/ 1318:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1319);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SelectInput.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SelectInput.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3hl6h{min-width:65px;font-weight:400}._3hl6h,._3Y3JC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._3Y3JC{position:relative}._3Y3JC:hover ._1ZTEB{background-color:#f1f1f18c}._1ZTEB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#000;font-size:16px;border-radius:4px;font-weight:400;cursor:pointer;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._1ZTEB .fa{margin-left:8px}._3yfgi{width:100%;opacity:0;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "_3hl6h",
	"selectContainer": "_3Y3JC",
	"hint": "_1ZTEB",
	"select": "_3yfgi stretched"
};

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1321);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSelect.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSelect.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2CTZv{width:100%;position:relative}._2CTZv,._3nhOc{display:-webkit-box;display:-ms-flexbox;display:flex}._3nhOc{margin:0;margin-right:2px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.DRK7t{width:16px;height:16px;position:absolute;left:15px;top:8px}.jWUNC{width:100%;height:42px}._3Imj3>.jWUNC{padding-left:36px}._2byyi{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;height:42px;position:relative}._2byyi input[type=number]{-moz-appearance:textfield}._2byyi input[type=number]::-webkit-inner-spin-button,._2byyi input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}._3nGhT{color:#000;font-size:16px;margin-left:5px;position:absolute;right:0;height:42px;display:-webkit-box;display:-ms-flexbox;display:flex}._-5BW7{border-right:1px solid rgba(0,0,0,.15);width:0;margin:4px 0}.J0LiY{padding-left:8px}._11n11 .input{border:none}", ""]);

// exports
exports.locals = {
	"root": "_2CTZv",
	"title": "_3nhOc questionTitle",
	"icon": "DRK7t",
	"input": "jWUNC input",
	"hasIcon": "_3Imj3",
	"inline": "_2byyi",
	"switch": "_3nGhT",
	"switchDivider": "_-5BW7",
	"singleOptionLabel": "J0LiY",
	"required": "_1_Rl_ required",
	"theme-flat": "_11n11"
};

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1323);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ChooseLanguageDialog.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ChooseLanguageDialog.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2zlxK{font-weight:700}._2zlxK,._22XDT{margin-bottom:13px}._22XDT{text-align:justify}._2rIjY{font-weight:700;margin-bottom:13px}._17hGk{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"title": "_2zlxK",
	"text": "_22XDT",
	"timer": "_2rIjY",
	"buttons": "_17hGk"
};

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1325);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css", function() {
        content = require("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1327);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./font-awesome.min.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./font-awesome.min.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1327:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1329);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-select.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1331);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-datepicker.min.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-datepicker.min.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1333);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./nprogress.css", function() {
        content = require("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./nprogress.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1335);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./slick.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./slick.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1337);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../node_modules/extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../node_modules/css-loader/index.js??ref--1-rules-1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./desktop.css", function() {
        content = require("!!../../node_modules/extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../node_modules/css-loader/index.js??ref--1-rules-1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./desktop.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function (root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }
})(this, function () {
  var NProgress = {};

  NProgress.version = '0.1.6';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function (options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function (n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = n === 1 ? null : n;

    var progress = NProgress.render(!started),
        bar = progress.querySelector(Settings.barSelector),
        speed = Settings.speed,
        ease = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function (next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, {
          transition: 'none',
          opacity: 1
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function () {
          css(progress, {
            transition: 'all ' + speed + 'ms linear',
            opacity: 0
          });
          setTimeout(function () {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function () {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function () {
    if (!NProgress.status) NProgress.set(0);

    var work = function work() {
      setTimeout(function () {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function (force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function (amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function () {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   * 
   * @param $promise jQUery Promise
   */
  (function () {
    var initial = 0,
        current = 0;

    NProgress.promise = function ($promise) {
      if (!$promise || $promise.state() == "resolved") {
        return this;
      }

      if (current == 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function () {
        current--;
        if (current == 0) {
          initial = 0;
          NProgress.done();
        } else {
          NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };
  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function (fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');

    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar = progress.querySelector(Settings.barSelector),
        perc = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent = document.querySelector(Settings.parent),
        spinner;

    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function () {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function () {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function () {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = 'WebkitTransform' in bodyStyle ? 'Webkit' : 'MozTransform' in bodyStyle ? 'Moz' : 'msTransform' in bodyStyle ? 'ms' : 'OTransform' in bodyStyle ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }

  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d(' + toBarPerc(n) + '%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate(' + toBarPerc(n) + '%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n) + '%' };
    }

    barCSS.transition = 'all ' + speed + 'ms ' + ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = function () {
    var pending = [];

    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function (fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  }();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = function () {
    var cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'],
        cssProps = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function (match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function (element, properties) {
      var args = arguments,
          prop,
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    };
  }();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return;

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3de37e7e.svg";

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e968b6a0.svg";

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1342);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Logo.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Logo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2DdTy{text-decoration:none!important;font-size:10px;font-weight:600;color:#ffd906;padding-bottom:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:48px}._2DdTy:active,._2DdTy:focus,._2DdTy:hover{color:#ffd906;text-decoration:none}", ""]);

// exports
exports.locals = {
	"brandLogo": "_2DdTy"
};

/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1344);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".CjTMX{position:relative;background-color:#fff;color:#000;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.12);box-shadow:0 2px 8px rgba(0,0,0,.12);z-index:99}._3v0wi{position:fixed;left:0;right:0;top:0;z-index:100}._1KXxC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding:0 15px;height:60px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media print{.CjTMX{display:none}}", ""]);

// exports
exports.locals = {
	"root": "CjTMX",
	"fixed": "_3v0wi",
	"container": "_1KXxC container"
};

/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f33d7fc5.svg";

/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1347);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationLink.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationLink.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1h7t-{padding:0 4px;font-weight:400;margin-left:-2px;background-color:#ededed;border-radius:10rem}", ""]);

// exports
exports.locals = {
	"count": "_1h7t-"
};

/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1349);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationItem.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._34VVu{position:relative;font-size:13px;border-bottom:2px solid transparent;border-top:2px solid transparent;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.m5hBM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#000;font-weight:700;text-decoration:none;padding:13px 12px;height:100%}._1ojmC{display:none;position:absolute;top:100%;left:0;z-index:101;background-color:#fff;border-bottom:1px solid #ddd;border-right:1px solid #ddd;border-left:1px solid #ddd;-webkit-box-shadow:0 12px 16px rgba(0,0,0,.08);box-shadow:0 12px 16px rgba(0,0,0,.08)}._34VVu:hover{background-color:#f5f5f5;color:#e73232}._34VVu._2Rphr,._34VVu:hover{border-top:2px solid #ffd906}._34VVu:hover .m5hBM{color:#e73232}._34VVu:hover ._1ojmC,.BOSU4{display:block}.BOSU4{color:#000;font-weight:400;font-size:14px;text-decoration:none;padding:12px;white-space:nowrap}.BOSU4:hover{background-color:#f5f5f5;color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_34VVu",
	"link": "m5hBM",
	"dropdown": "_1ojmC",
	"active": "_2Rphr",
	"dLink": "BOSU4"
};

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1351);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ProfileButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ProfileButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".cSaip{position:relative;font-size:13px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;padding:0 12px;min-width:150px}._2vqlh{color:#000;max-width:150px;font-weight:700;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0 -12px;padding:0 11px;border-top:0 solid transparent}.cSaip:hover ._2vqlh{background-color:#f5f5f5;border-top:0 solid #ffd906;color:#e73232}.MEvex{max-width:150px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}._2Esyq{display:none;position:absolute;width:100%;top:100%;left:0;z-index:101;background-color:#fff;border-bottom:1px solid #ddd;border-right:1px solid #ddd;border-left:1px solid #ddd;-webkit-box-shadow:0 12px 16px rgba(0,0,0,.08);box-shadow:0 12px 16px rgba(0,0,0,.08);-webkit-box-sizing:border-box;box-sizing:border-box}.cSaip:hover ._2Esyq{display:block}.r6XJg{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.cdK6z>span{white-space:pre-wrap}.cdK6z{display:block;color:#000;font-weight:400;font-size:14px;text-decoration:none;padding:12px;white-space:nowrap;text-align:left}.cdK6z:hover{background-color:#f5f5f5;color:#000}._1-5lQ{border-top:1px solid #ededed;font-weight:700;padding:12px}._2ST8r{height:35px;width:35px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:50%;overflow:hidden;margin-right:10px}._1JQVF{width:100%}", ""]);

// exports
exports.locals = {
	"root": "cSaip",
	"link": "_2vqlh",
	"btnTitle": "MEvex",
	"dropdown": "_2Esyq",
	"dropdownList": "r6XJg",
	"dropdownLink": "cdK6z",
	"logout": "_1-5lQ",
	"avatarContainer": "_2ST8r",
	"avatar": "_1JQVF"
};

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1353);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".s3Ylh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;min-width:935px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-item-align:stretch;align-self:stretch}._3BN4_{margin-right:8px;margin-left:8px;border-radius:3px;color:#000}._3BN4_:hover{color:#e73232}._29C-n{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.BZPWi{position:relative;height:100%}.BZPWi,.dmyLG{display:-webkit-box;display:-ms-flexbox;display:flex}.dmyLG{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-left:10px}._1XlLA{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;height:100%}._3L2yd{display:inline-block;text-decoration:none;font-weight:700;font-size:13px;padding:15px 20px 15px 18px}._3PRKw{background-color:#ffd906;color:#000;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3PRKw:hover{background-color:#ffc107;color:#000}._3PRKw img{margin-right:10px}", ""]);

// exports
exports.locals = {
	"root": "s3Ylh",
	"highlight": "_3BN4_",
	"left": "_29C-n",
	"navItem": "BZPWi",
	"right": "dmyLG",
	"flexRow": "_1XlLA",
	"link": "_3L2yd",
	"sell": "_3PRKw"
};

/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1355);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineNav.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineNav.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3ALPP{z-index:1}._3ALPP,.mCAa6{position:relative;margin:0;padding:0}.mCAa6{list-style:none}._3PRCE{position:relative}._3PRCE,._HsNd{display:inline-block}._HsNd{text-decoration:none;font-weight:400;font-size:12px;padding:15px 10px 9px;border-bottom:4px solid transparent;cursor:pointer;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;text-transform:uppercase;letter-spacing:.1em}._HsNd:hover{color:#e73232}._HsNd:hover,.A7cFq{border-bottom:4px solid #ffd906}.A7cFq{position:relative;color:#000;font-weight:700}", ""]);

// exports
exports.locals = {
	"root": "_3ALPP",
	"list": "mCAa6",
	"item": "_3PRCE",
	"link": "_HsNd",
	"active": "A7cFq"
};

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1357);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _chainFunction = __webpack_require__(1359);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(318);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1360);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';

TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ 1359:
/***/ (function(module, exports) {


module.exports = function chain() {
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++) {
    args[i] = arguments[i];
  }args = args.filter(function (fn) {
    return fn != null;
  });

  if (args.length === 0) return undefined;
  if (args.length === 1) return args[0];

  return args.reduce(function (current, next) {
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  });
};

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(11);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _addClass = __webpack_require__(1362);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1364);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1365);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(1366);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(38);

var _PropTypes = __webpack_require__(1264);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';

CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1363));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1263));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */

var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1263));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1368);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PaymentModal.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PaymentModal.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2aYHp{position:fixed;z-index:3005;background-color:rgba(50,50,50,.2);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:400}.Qt1yN{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3006}._8VETH{position:relative;background-color:#fff;width:600px;min-height:400px;padding:10px 20px 18px;margin:5px;-ms-flex-item-align:center;align-self:center;z-index:3007}._2ux5J{font-size:21px;font-weight:400;padding-bottom:15px;margin-bottom:11px;border-bottom:1px solid #eee}._1DP-n{margin-bottom:5px}.pu5sx{position:relative;-ms-flex-line-pack:stretch;align-content:stretch;margin:20px 0 35px}.pu5sx,.sMEF2{display:-webkit-box;display:-ms-flexbox;display:flex}.sMEF2{width:100%;max-width:50%;padding:20px 15px;margin:0 20px 0 auto;border:2px solid #eee;border-radius:2px;text-align:center;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;background:transparent;outline:none}.sMEF2:last-of-type{margin-right:auto}._2zCrj{margin:auto}._3ZjNy{padding-top:7px}._3o5Yq{height:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3o5Yq,._3v-gG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column wrap;flex-flow:column wrap}._3v-gG{position:relative}.sMEF2:not(._2FvZr):hover{color:#000;border-color:#ffd906;background-color:#fffbd3;cursor:pointer;outline:none}.VjrcA{text-align:right}._3gU1v,.VjrcA{position:relative}._3gU1v{margin-left:10px;border:1px solid #d0d0d0;background-color:#fff;color:#000;padding:8px 16px;overflow:hidden}._3gU1v:hover{cursor:pointer;border-color:#ffd906}._3gU1v._2FvZr>:not(._2si0B){visibility:hidden}._1EHnC{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._1ofkJ{padding-top:21px;padding-left:18px;font-size:13px;font-weight:400;color:#aaa;margin:0 0 6px}._3_uNl{margin:5px;bottom:21px;position:absolute;left:-4px}@media screen and (max-width:380px){.pu5sx{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0}.sMEF2{margin:10px auto}}._2FvZr{opacity:.6}._3s_hN{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;position:relative;font-weight:400;color:#000;padding-left:20px}._3s_hN:hover{color:#ff5a5f}._3s_hN input{cursor:pointer;position:absolute;left:4px;border:1px solid #aaa;border-radius:2px}._3s_hN input,._3s_hN input:checked{margin-left:-4px;top:1px;-webkit-appearance:none;width:15px;height:15px;outline:none}._3s_hN input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._3s_hN input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}._3ZsMo input,._3ZsMo input:checked{margin-top:-8px;margin-left:-4px}", ""]);

// exports
exports.locals = {
	"root": "_2aYHp",
	"bg": "Qt1yN",
	"container": "_8VETH",
	"h3": "_2ux5J",
	"balance": "_1DP-n",
	"list": "pu5sx",
	"payment": "sMEF2",
	"paymentContents": "_2zCrj",
	"paymentTitle": "_3ZjNy",
	"column": "_3o5Yq",
	"columnWrapper": "_3v-gG",
	"disabled": "_2FvZr",
	"actions": "VjrcA",
	"button": "_3gU1v",
	"buttonLoader": "_2si0B",
	"loader": "_1EHnC",
	"contractOffer": "_1ofkJ",
	"contractCheckbox": "_3_uNl",
	"checkbox": "_3s_hN",
	"mobile": "_3ZsMo"
};

/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1370);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BalanceRefill.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BalanceRefill.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".DmOcI{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;min-height:44px;line-height:44px;font-size:16px;font-weight:400}._3ZFf5{height:44px;background-color:#ffd906;border:1px solid #ffd906;color:#000;padding:10px 12px;border-radius:0 2px 2px 0;cursor:pointer;font-weight:600;outline:none}._3ZFf5:hover{background:#ffc107;border:1px solid #ffc107}._30C05{position:absolute;top:1px;left:110px}.LY1XA{border:1px solid #e0e0e0;font-size:16px;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;outline:none;width:150px;padding:12px 43px 12px 12px;text-align:right;max-height:44px}.LY1XA:active,.LY1XA:focus{outline:none;-webkit-box-shadow:none;box-shadow:none;border:1px solid #ffd906}", ""]);

// exports
exports.locals = {
	"inputContainer": "DmOcI",
	"inlineButton": "_3ZFf5",
	"hrn": "_30C05",
	"input": "LY1XA"
};

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1372);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Balance.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Balance.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1uFAv{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-right:8px}._2B6Dt{font-weight:600;color:inherit;text-decoration:none}._2O5JS{position:absolute;top:100%;right:0;padding:10px 8px 8px;background:#fff;-webkit-box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75);box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75)}._3iQnl{vertical-align:text-bottom}._2xW05{vertical-align:top}", ""]);

// exports
exports.locals = {
	"root": "_1uFAv",
	"content": "_2B6Dt",
	"popup": "_2O5JS",
	"icon": "_3iQnl",
	"title": "_2xW05"
};

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1374);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SubHeader.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SubHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1D_Nn{position:relative;background-color:#fff;z-index:7;padding:0 15px}._1ediK{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._1ediK,._2cKE_,.TpfX0{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.TpfX0{display:-webkit-box;display:-ms-flexbox;display:flex;text-align:right;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:10px;height:44px;line-height:42px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._3YhcH{border:0;background:none}._3c7Db,._3YhcH,.vuYGG{display:inline-block}.vuYGG{font-weight:600;color:inherit;text-decoration:none}.vuYGG+.vuYGG{margin-left:30px}._3c7Db{margin-left:28px}._1dKSE{color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_1D_Nn",
	"container": "_1ediK container",
	"left": "_2cKE_",
	"right": "TpfX0",
	"locationSelect": "_3YhcH",
	"tariff": "vuYGG",
	"balance": "_3c7Db",
	"nonActiveTariff": "_1dKSE"
};

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".zDFkx{position:relative;font-size:13px;line-height:18px;min-width:920px;padding:15px 0 30px;color:hsla(0,0%,100%,.5);background:#212121;z-index:3;min-height:200px}._3RtQ6{padding:0 20px;margin:0 auto}.fb9ID{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._20qxe{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.NYfbf{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:265px;text-align:right;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._35XCD{list-style:none;margin:10px 0;padding:0;min-width:790px}._35XCD li{display:inline-block;margin-right:20px}._19Cat{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0}._2Rxe3{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;margin-bottom:8px}._3EfAE{font-weight:500;font-size:18px;line-height:120%;color:#fff}._2-_Wn{font-size:12px}._2Dlbx{font-weight:400;text-decoration:none;font-size:14px;color:hsla(0,0%,100%,.85);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}._2xcDA{font-weight:400}._2xcDA,.Oogak{text-decoration:none;font-size:13px;color:hsla(0,0%,100%,.5);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.Oogak{position:relative;margin:10px 0;font-weight:700;display:inline-block;letter-spacing:.05em}._2Dlbx:hover,._2xcDA:hover,.Oogak:hover{color:#fff;cursor:pointer}._2-8Mr{border-top:1px solid #4e4e4e;margin:16px 0}._2rdKT{font-size:22px;color:#fff;text-decoration:none;opacity:.8;padding-left:14px}._2rdKT:hover{opacity:1}._1AipK a,span{color:inherit;text-decoration:none}._1AipK:after{content:\" | \";margin:0 10px}._1AipK:last-child:after{content:none}._3pz-l{text-align:center;margin-top:20px}@media print{.zDFkx{display:none}}._3rXoJ ul{padding:0}", ""]);

// exports
exports.locals = {
	"root": "zDFkx",
	"container": "_3RtQ6 container",
	"flexContainer": "fb9ID",
	"left": "_20qxe",
	"right": "NYfbf",
	"nav": "_35XCD",
	"navLeasing": "_19Cat",
	"navLeasingItem": "_2Rxe3",
	"navLeasingTitle": "_3EfAE",
	"navLeasingTitleHeader": "_2-_Wn",
	"link": "_2Dlbx",
	"smallLink": "_2xcDA",
	"tel": "Oogak",
	"divide": "_2-8Mr",
	"socialLink": "_2rdKT",
	"lang": "_1AipK",
	"footerCopyRight": "_3pz-l",
	"leasingList": "_3rXoJ"
};

/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1377);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColumnList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColumnList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".JoFQz{margin-top:20px}._3QNtp{width:200px}._2iDdE{list-style:none}._2fQe9{font-size:11px;color:inherit;text-decoration:none;margin-top:0;margin-bottom:1em;white-space:nowrap;overflow:hidden;display:block}._1LE5p{cursor:pointer;text-decoration:none}._1LE5p,._2XVd2{padding:10px;font-size:14px;font-weight:700;display:inline-block;color:hsla(0,0%,100%,.5)}.wcDf5{color:#dedede!important;font-size:12px}._3oo16{color:rgba(64,64,64,.98);font-size:12px;font-weight:700}._35FVL{display:block;padding-left:0;margin-left:-6px;font-size:12px;cursor:auto}.r4Dcm{cursor:pointer}._1gtiU{color:hsla(0,0%,100%,.5)!important}._1mQCi{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}", ""]);

// exports
exports.locals = {
	"root": "JoFQz",
	"column": "_3QNtp",
	"item": "_2iDdE",
	"link": "_2fQe9",
	"resetLocationLink": "_1LE5p",
	"resetLocationText": "_2XVd2",
	"selLocation": "wcDf5",
	"disabledCity": "_3oo16",
	"curentBreadCrumbs": "_35FVL",
	"cursorPointer": "r4Dcm",
	"hideHover": "_1gtiU",
	"breadCrumbsBlock": "_1mQCi"
};

/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1379);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1PNMZ,._3G2DH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1PNMZ ._3Lg2h{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._1PNMZ ._3Lg2h,._3G2DH ._3Lg2h{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;list-style:none;margin:0}._3G2DH ._3Lg2h{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._3Lg2h{font-weight:400}.f2F2C{font-size:14px;color:#c4c4c4}", ""]);

// exports
exports.locals = {
	"root": "_1PNMZ",
	"rootMobile": "_3G2DH",
	"citiesList": "_3Lg2h",
	"title": "f2F2C"
};

/***/ }),

/***/ 1380:
/***/ (function(module, exports) {

module.exports = {"title":"Популярные разделы","uk_title":"Популярні розділи","items":[{"id":1,"title":"Б/у авто в лизинг","uk_title":"Б/у авто в лізинг","slug":"/leasing/used-avto/"},{"id":2,"title":"Новые авто в лизинг","uk_title":"Нові авто в лізинг","slug":"/leasing/novyye-avto/"},{"id":3,"title":"Легковые авто в лизинг","uk_title":"Легкові авто в лізинг","slug":"/leasing/leasing-legkovykh-avto/"},{"id":4,"title":"Лизинг авто для физических лиц","uk_title":"Лізинг авто для фізичних осіб","slug":"/leasing/leasing-avto-fizicheskikh-lits/"}]}

/***/ }),

/***/ 1381:
/***/ (function(module, exports) {

module.exports = {"title":"Популярные Марки авто в лизинг","uk_title":"Популярні Марки авто в лізинг","items":[{"id":1,"title":"bmw в лизинг","uk_title":"bmw у лізинг","slug":"/leasing/bmw/"},{"id":2,"title":"peugeot в лизинг","uk_title":"peugeot у лізинг","slug":"/leasing/peugeot/"},{"id":3,"title":"volvo в лизинг","uk_title":"volvo у лізинг","slug":"/leasing/volvo/"},{"id":4,"title":"toyota в лизинг","uk_title":"toyota у лізинг","slug":"/leasing/toyota/"},{"id":5,"title":"mazda в лизинг","uk_title":"mazda у лізинг","slug":"/leasing/mazda/"},{"id":6,"title":"skoda в лизинг","uk_title":"skoda у лізинг","slug":"/leasing/skoda/"},{"id":7,"title":"газель в лизинг","uk_title":"газель у лізинг","slug":"/leasing/gaz/"},{"id":8,"title":"volkswagen в лизинг","uk_title":"volkswagen у лізинг","slug":"/leasing/volkswagen/"},{"id":9,"title":"порше в лизинг","uk_title":"порше у лізинг","slug":"/leasing/porsche/"},{"id":10,"title":"ауди в лизинг","uk_title":"ауди у лізинг","slug":"/leasing/audi/"},{"id":11,"title":"citroen в лизинг","uk_title":"citroen у лізинг","slug":"/leasing/citroen/"},{"id":12,"title":"mercedes benz в лизинг","uk_title":"mercedes benz у лізинг","slug":"/leasing/mercedes-benz/"},{"id":13,"title":"ford в лизинг","uk_title":"ford у лізинг","slug":"/leasing/ford/"},{"id":14,"title":"nissan в лизинг","uk_title":"nissan у лізинг","slug":"/leasing/nissan/"},{"id":15,"title":"hyundai в лизинг","uk_title":"hyundai у лізинг","slug":"/leasing/hyundai/"},{"id":16,"title":"renault в лизинг","uk_title":"renault у лізинг","slug":"/leasing/renault/"}]}

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1383);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LanguageList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LanguageList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._11JjB a,span{color:inherit;text-decoration:none}._11JjB:after{content:\" | \";margin:0 10px}._11JjB:last-child:after{content:none}", ""]);

// exports
exports.locals = {
	"lang": "_11JjB"
};

/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1385);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotificationBar.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotificationBar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".KSaKz{position:fixed;top:0;left:0;width:100%;background:rgba(0,0,0,.8);padding:13px 20px;-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-transition:-webkit-transform .1s linear;transition:-webkit-transform .1s linear;-o-transition:transform .1s linear;transition:transform .1s linear;transition:transform .1s linear,-webkit-transform .1s linear;z-index:10000}._2sO61{background:#e73232;color:#fff}._2A3gx{background:#ffd906;color:#000}._1aLfe{background:#4caf10;color:#fff}._2pXnf{background:#2196f3;color:#fff}.bzlx8{-webkit-transform:translateY(0);transform:translateY(0)}._1WJlP{color:#fff;text-align:center;max-width:800px;margin:0 auto}@media print{.KSaKz{display:none}}", ""]);

// exports
exports.locals = {
	"root": "KSaKz",
	"error": "_2sO61",
	"warning": "_2A3gx",
	"success": "_1aLfe",
	"info": "_2pXnf",
	"active": "bzlx8",
	"label": "_1WJlP"
};

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1387);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".-lRLO{position:relative;padding-top:10px;padding-bottom:10px;margin:0 auto;text-align:center}._35_nZ{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}._3aSLj,._35_nZ{display:-webkit-box;display:-ms-flexbox;display:flex}._3aSLj{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1I3Gw{font-size:14px;font-weight:400;text-align:center;color:#000}._1I3Gw,.iXl6a{margin-bottom:20px}.iXl6a{float:right}._3w_FE{color:#2196f3;display:inline-block;cursor:pointer}._3w_FE:hover{color:#154088;border-bottom:.07em solid}._3w_FE:active{color:#497ddd;border-bottom:1px dashed}._18Fb4{display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;font-weight:400;font-size:15px;color:#000}._18Fb4 input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._18Fb4 input,._18Fb4 input:checked{top:3px;-webkit-appearance:none;width:15px;height:15px;outline:none}._18Fb4 input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._18Fb4 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:0;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}._3IYbg input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._3IYbg input,._3IYbg input:checked{top:0;-webkit-appearance:none;width:15px;height:15px;outline:none}._3IYbg input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._3IYbg input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:-3px;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}body{font-family:OpenSans,sans-serif;padding:0 2px 0 0;color:#000;font-weight:400}a:focus{text-decoration:none}:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}.ant-form-item{margin:0}.ant-btn,button,input,optgroup,select,textarea{line-height:normal}._1ONYX{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;padding:17px 16px;width:100%;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;font-size:18px;line-height:1.3333333;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;margin:10px 0}._1ONYX::-webkit-input-placeholder{color:#6c6868cf;opacity:1}._1ONYX::-moz-placeholder{color:#6c6868cf;opacity:1}._1ONYX:-ms-input-placeholder{color:#6c6868cf;opacity:1}._1ONYX::placeholder{color:#6c6868cf;opacity:1}._3oObU::-webkit-input-placeholder{color:#6c6868cf;opacity:1}._3oObU::-moz-placeholder{color:#6c6868cf;opacity:1}._3oObU:-ms-input-placeholder{color:#6c6868cf;opacity:1}._3oObU::placeholder{color:#6c6868cf;opacity:1}._3oObU{padding:17px 16px;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}._2RHEP,._3oObU{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;font-size:16px;line-height:1.3333333;margin-top:10px}._2RHEP{position:relative;margin-bottom:20px;height:46px;border:0;border-radius:3px;background:#ffd906;text-align:center;text-decoration:none;cursor:pointer;outline:none}._2RHEP>p{margin:0}._2RHEP:hover{background:#ffc1076b}._2RHEP:disabled,._2RHEP[disabled]{background:#ffc1077c;cursor:auto;color:rgba(0,0,0,.5)}.has-error>span>input{border-color:#f5222d}.ant-form-explain{color:#f5222d;padding:0 8px}.czsUy{text-align:center;padding:15px 0 40px}.ant-form-item{margin-bottom:5px}.eTG0E{font-size:13px;line-height:18px;margin:25px 0 20px;color:#555;letter-spacing:.34px;font-weight:400}.Nmq1p{text-decoration:none;font-size:15px;cursor:pointer}._2gUqb{cursor:pointer;float:right}._1SYqv{width:100%;text-align:right;margin:10px 0}._37Srk{font-size:14px;font-weight:400;text-align:center;color:#000;margin-top:20px;font-weight:600}._1frkA{position:relative;background-color:#fff}._1frkA,._1gBiv{margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1gBiv{max-width:740px}._1gBiv>div>div>iframe,._1gBiv>div>iframe,._1gBiv>iframe{max-width:100%}._1frkA>div{margin-bottom:0}._1frkA>div>div{padding-top:10px}._1frkA>div>div,._3lJEn,._31HIU{margin-bottom:20px}._3lJEn{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px}._3lJEn>div{margin-bottom:10px;margin-top:10px}#banner{display:none}._2s_Y4{position:relative;margin-top:-18px;padding-left:15px;max-width:1100px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:10px;-webkit-box-sizing:border-box;box-sizing:border-box;margin-bottom:20px}._2s_Y4,._30-Va>div{display:-webkit-box;display:-ms-flexbox;display:flex}._30-Va>div{width:100vw;-ms-flex-pack:distribute;justify-content:space-around}.is-focused:not(.is-open)>.Select-control{border-color:#ff5a5f;-webkit-box-shadow:none;box-shadow:none}.Select-control{border-radius:0;border:1px solid #e0e0e0}.Select-placeholder{color:#777}.d-advertSlot{margin-bottom:20px}.adunitContainer,.d-advertSlot{position:relative;text-align:center}.adunitContainer>:last-child{margin-bottom:20px}#app{position:relative;z-index:2;padding-top:63px;height:100%}.ap-script-wrapper>div{padding:20px}.F0IVy{min-width:1100px;position:relative;z-index:auto}._2azA2{margin-top:30px}html{color:#222;font-weight:100;font-size:1em;line-height:1.375}button,html{font-family:OpenSans,sans-serif}body{margin:0;background-color:#f5f5f5}a{color:#0074c2}a[class=meta-title-link-next],a[class=meta-title-link]{text-decoration:none}a[class=meta-title-link]+a[class=meta-title-link]:before,span[class=meta-title-link]+span[class=meta-title-link]:before{content:\"\";background-image:url(" + __webpack_require__(1267) + ");background-size:contain;background-repeat:no-repeat;display:inline-block;cursor:default;height:8px;width:10px}a[class=meta-title-link-next]:before,span[class=meta-title-link-next]:before{content:\"\";background-image:url(" + __webpack_require__(1267) + ");background-size:contain;background-repeat:no-repeat;display:inline-block;cursor:default;height:8px;width:10px}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}._3RoS6{min-width:1070px;max-width:1100px;background:#f5f5f5;margin:8px auto 0;z-index:4;position:relative}._1agwl>div>iframe{margin-top:25px}._1HUfQ{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-sizing:border-box;box-sizing:border-box}.imgCover{position:absolute;top:50%;left:50%;width:100%;height:auto;max-width:none;max-height:none;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@supports ((-o-object-fit:cover) or (object-fit:cover)){.imgCover{position:static;top:auto;left:auto;width:100%;height:100%;-webkit-transform:none;transform:none;-o-object-fit:cover;object-fit:cover}}.page{padding:0;position:relative}.container{min-width:1070px;max-width:1100px;margin:0 auto}.card{background-color:#fff;z-index:1;padding:10px 20px}.flexRow{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.questionTitle{font-size:21px;font-weight:700;margin-bottom:10px}.required:after{content:\"*\";display:inline-block;margin-left:2px;color:#c00}.input:active,.input:focus{outline:none;border:1px solid #ffc107}", ""]);

// exports
exports.locals = {
	"sbsGL": "-lRLO",
	"flexCenterGl": "_35_nZ",
	"flexCenterAlignGl": "_3aSLj",
	"titleNellGl": "_1I3Gw",
	"linkLeahs": "iXl6a",
	"linkLeah": "_3w_FE",
	"checkboxGl": "_18Fb4",
	"checkboxMobileGl": "_3IYbg",
	"inputFormGl": "_1ONYX",
	"inputFormMobilGl": "_3oObU",
	"buttonFormGl": "_2RHEP",
	"submitSectionGl": "czsUy",
	"agreementGl": "eTG0E",
	"urlGl": "Nmq1p",
	"linkTextGl": "_2gUqb",
	"linkBlockGl": "_1SYqv",
	"titleGl": "_37Srk",
	"advertContainerGl": "_1frkA",
	"banerAllStyleGl": "_1gBiv",
	"gptPremium": "_31HIU",
	"advertContainerButoonGl": "_3lJEn",
	"brandingAdvGl": "_2s_Y4",
	"mobileWebTop": "_30-Va",
	"root": "F0IVy",
	"mainFooter": "_2azA2",
	"layout": "_3RoS6",
	"banerTop": "_1agwl",
	"brandingAdv": "_1HUfQ"
};

/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoDescription.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var buildFirmsSeoDescription = function buildFirmsSeoDescription(data, t) {
  var cityTitle = data.cityTitle,
      section = data.section,
      regLocation = data.regLocation,
      location = data.location;
  // if (section === 'СТО') {
  //   if (isRegion)
  //     return t(
  //       'Каталог СТО {locationAccusative}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //       { locationAccusative },
  //     );
  //   else if (cityTitle)
  //     return t(
  //       'Каталог СТО в {cityTitle}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //       { cityTitle },
  //     );
  //   return t(
  //     'Каталог СТО, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто  ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //   );
  // }
  // if (section && cityDescriptions) {
  //   return t(
  //     '{section} в {cityDescriptions}: Полный список организаций ✅ Адреса ✅ Контактные данные {section} в {cityDescriptions}',
  //     data,
  //   );
  // }
  // if (section) {
  //   return t(
  //     '{section} в Украине: Полный список организаций ✅ Адреса ✅ Контактные данные {section} в вашем городе',
  //     data,
  //   );
  // }
  // if (cityDescriptions) {
  //   return t(
  //     'Каталог СТО в {cityDescriptions}, ближайшие шиномонтажи, сервисы по диагностики и ремонту авто ✅ адреса ☎️ телефоны на АвтоБазар™.',
  //     data,
  //   );
  // }

  if (section === 'СТО' && cityTitle) {
    return t('Каталог СТО {cityTitle} с адресами компаний, телефонами и картой проезда. Связаться с автосервисом и записаться на СТО можно на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t('Авторазборка {cityTitle}. Каталог компаний по разбору авто. Адреса, телефоны, карта проезда на сайте Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t('Автовыкуп {cityTitle}. Каталог компаний по выкупу авто с адресами, телефонами и картой проезда на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t('Дилеры по продаже автозапчастей {cityTitle}. Адреса, телефоны компаний на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Поставщики автотоваров {cityTitle}. Адреса, телефоны компаний на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t('Территориальные сервисные центры {cityTitle}. Адреса, телефоны ТСЦ для регистрации авто, оформления справок, замены водительского удостоверения', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if (cityTitle) {
    return t('Автосервисы {cityTitle} с адресами компаний, телефонами и картой проезда. Связаться с автосервисом и записаться на обслуживание можно на Автобазаре', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  return t('Автомобильные организации в Украине: СТО ✅ Авторазборки ✅ Мойки ✅ Шиномонтаж и другие фирмы для владельцев авто');
};

var buildFirmPageSeoDescription = function buildFirmPageSeoDescription(title, tab, t) {
  var car_drive_countries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var tags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var firm = arguments[5];

  if (tab === 'blog') {
    return t('Актуальные новости и действующие акции компании {title} смотрите на Автобазаре', {
      title: title
    });
  }

  var countries = Array.isArray(car_drive_countries) ? car_drive_countries.map(function (item) {
    return item.title;
  }).join(', ') : car_drive_countries;

  if (car_drive_countries.length > 0) {
    return t('Компания {title} по доставке авто из {countries}. Условия выкупа с аукциона и пригона авто под ключ. Стоимость услуг и преимущества сотрудничества с компанией {title}', {
      title: title,
      countries: countries
    });
  }

  if (Array.isArray(tags)) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].slug && tags[i].slug === 'sto') {
        return t('СТО {title}. Адрес, телефон, график работы, услуги СТО, последние новости и акции. Связаться с автосервисом и записаться на СТО можно на Автобазаре', {
          title: title,
          tags: tags
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtorazborka') {
        return t('Авторазборка {title}. Компания по разбору авто. Адреса, телефоны, карта проезда, график работы, услуги компании, новости и акции смотрите на сайте Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtovykup') {
        return t('{title}. Услуги, новости, акции компании по выкупу авто. Адрес, телефоны, карта проезда и график работы смотрите на сайте Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtotovary') {
        return t('Поставщик автотоваров {title}. Адреса, телефоны, график работы компаний на Автобазаре. Самые актуальные предложения по автотоварам от компании', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'teritorialni-servisni-centri') {
        return t('{title}. Адрес, телефон, график работы ТСЦ для регистрации авто, оформления справок, замены водительского удостоверения указаны на сайте Автобазар', {
          title: title
        });
      }
    }
  }

  return t('METATEGS_DESCRIPTION_FIRM_ZAPCHASTI', { title: title });
};

var buildSearchAvtoSeoDescription = function buildSearchAvtoSeoDescription(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.description) return seoData.description;

  var _data$make = data.make,
      make = _data$make === undefined ? '' : _data$make,
      _data$model = data.model,
      model = _data$model === undefined ? '' : _data$model,
      _data$location = data.location,
      location = _data$location === undefined ? '' : _data$location,
      _data$generation = data.generation,
      generation = _data$generation === undefined ? '' : _data$generation,
      _data$gearbox = data.gearbox,
      gearbox = _data$gearbox === undefined ? '' : _data$gearbox,
      _data$engine = data.engine,
      engine = _data$engine === undefined ? '' : _data$engine,
      _data$body = data.body,
      body = _data$body === undefined ? '' : _data$body,
      _data$drive = data.drive,
      driveSelected = _data$drive === undefined ? '' : _data$drive,
      _data$isNew = data.isNew,
      isNew = _data$isNew === undefined ? false : _data$isNew,
      _data$makeTranslate = data.makeTranslate,
      makeTranslate = _data$makeTranslate === undefined ? make : _data$makeTranslate,
      _data$modelTranslate = data.modelTranslate,
      modelTranslate = _data$modelTranslate === undefined ? model : _data$modelTranslate,
      yearSelected = data.year,
      _data$country = data.country,
      country = _data$country === undefined ? null : _data$country,
      _data$city = data.city,
      city = _data$city === undefined ? null : _data$city;


  var drive = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["b" /* buildDriveValue */](driveSelected, t);
  var locale = t('locale');
  var inGenitiveLocation = location && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location] ? __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location][locale].genitive) : city && city.title && ' ' + __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](city[locale + '_title'] || city.title) || '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */]['Украина'][locale].genitive;

  var yearVsSpace = yearSelected ? ' ' + yearSelected + ' ' + t('года') : '';
  var yearDotVsSpace = yearSelected ? ' ' + yearSelected + ' ' + t('г.') : '';
  var customGearboxAlt = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].altTitle : gearbox;
  var customGearbox = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title : gearbox;
  var customEngineAlt = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle : engine;
  var customEngine = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title : engine;
  var countryTitle = country && t(country.title);
  var countryFromTitle = country && country.from && country.from[locale];

  var params = _extends({}, data, {
    countryFromTitle: countryFromTitle,
    countryTitle: countryTitle,
    inGenitiveLocation: inGenitiveLocation,
    makeTranslate: makeTranslate,
    modelTranslate: modelTranslate,
    generation: generation ? ' ' + generation : '',
    drive: drive,
    year: yearVsSpace,
    yearDot: yearDotVsSpace
  });

  // {locale}*/avto/{country}/
  if (country && !make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t('SEO_META_DESCRIPTION_AVTO_COUNTRY', { countryFromTitle: countryFromTitle });
  }

  if (make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Купить легковой автомобиль {make}{year} 🚗 {inGenitiveLocation}. Большой выбор новых {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make}{year} б/у 🚗 {inGenitiveLocation}. Удобный поиск по объявлениям поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Купить легковой автомобиль {make} {model}{year} 🚗 {inGenitiveLocation}. Большой выбор новых {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make} {model}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && body && !generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Купить {body} {make} {model}{year} 🚗 {inGenitiveLocation}. Выбрать новый {makeTranslate} {body}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа {body} {make} {model}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Купить {make} {model}{generation}{year} 🚗 {inGenitiveLocation}. Выбрать новый {makeTranslate}{yearDot} без посредников по выгодной цене на АвтоБазар.' : 'Продажа {make} {model}{generation}{year} б/у 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && gearbox && !engine && !drive) {
    return t(isNew ? 'Новые легковые автомобили {gearbox} {make} {model}{generation}{year} 🚗 {inGenitiveLocation}. Удобный поиск по предложениям поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make} {model}{generation} {gearbox}{year} 🚗 {inGenitiveLocation}. Поможем купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && gearbox && drive && !engine) {
    return t(isNew ? 'Купить новый легковой автомобиль {make} {model}{generation} {gearbox} {drive}{year} 🚗 {inGenitiveLocation}. Удобный поиск предложений продажи {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей {make} {model}{generation} {gearbox} {drive}{year} 🚗. Подбор предложений {inGenitiveLocation} поможет купить {makeTranslate}{yearDot} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (make && model && gearbox && drive && engine) {
    return t(isNew ? 'Купить легковой автомобиль 🚗 {make} {model} {engine} {gearbox} {drive}{generation}{year}. Предложения {inGenitiveLocation} по продаже {makeTranslate} {modelTranslate}{yearDot} по выгодной цене на АвтоБазар.' : 'Легковые автомобили 🚗б/у {make} {model}{generation} {engine} {gearbox} {drive}{year}. Предложения по продаже {makeTranslate}{yearDot} {inGenitiveLocation} по выгодной цене на АвтоБазар.', _extends({}, params));
  }
  if (!make && !model && !gearbox && !drive && engine && !body) {
    return t(isNew ? '{customEngineAlt} новые {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.' : '{customEngineAlt} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params, {
      customEngineAlt: customEngineAlt
    }));
  }
  if (make && !model && gearbox && !drive && !engine && !body) {
    return t(isNew ? 'Продажа новых {make} {customGearboxAlt} {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.' : 'Продажа {make} {customGearboxAlt} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params, {
      customGearboxAlt: customGearboxAlt
    }));
  }
  if (!make && !model && !gearbox && !drive && !engine && body) {
    return t(isNew ? 'Продажа новых автомобилей {body} {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.' : 'Продажа автомобилей {body} б/у {inGenitiveLocation} 🚗 Удобный поиск по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params));
  }
  if (make && !model && !gearbox && !drive && engine && !body) {
    return t(isNew ? 'Продажа {customEngineAlt} {makeTranslate}{year} 🚗 Найти новый {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.' : 'Продажа {customEngineAlt} {makeTranslate}{year} 🚗 Найти б/у {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.', _extends({}, params, {
      customEngineAlt: customEngineAlt,
      customEngine: customEngine
    }));
  }
  if (make && model && !gearbox && !drive && engine && !body) {
    return t(isNew ? 'Продажа {customEngineAlt} {makeTranslate} {model}{year} 🚗 Найти новый {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.' : 'Продажа {customEngineAlt} {makeTranslate} {model}{year} 🚗 Найти б/у {customEngine} по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.', _extends({}, params, {
      customEngineAlt: customEngineAlt,
      customEngine: customEngine
    }));
  }
  if (!make && !model && gearbox && !drive && !engine && !body) {
    return t(isNew ? 'Продажа новых автомобилей {customGearbox}{year} {inGenitiveLocation} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™.' : 'Продажа автомобилей {customGearbox}{year} б/у {inGenitiveLocation} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™.', _extends({}, params, {
      customGearbox: customGearbox
    }));
  }
  if (make && !model && !gearbox && !drive && !engine && body) {
    return t(isNew ? 'Продажа новых {body} {make}{year} 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.' : 'Продажа {body} {make}{year} б/у 🚗 Удобный поиск авто по объявлениям – выгодные цены на АвтоБазар™ {inGenitiveLocation}.', _extends({}, params, {
      customGearbox: customGearbox
    }));
  }
  return t(isNew ? 'Купить легковой автомобиль 🚗 {inGenitiveLocation}. Большой выбор авто без посредников по выгодной цене на АвтоБазар.' : 'Продажа легковых автомобилей б/у 🚗 {inGenitiveLocation}. Удобный поиск по объявлениям поможет купить авто по выгодной цене на АвтоБазар.', {
    inGenitiveLocation: inGenitiveLocation
  });
};

var buildDealersSeoDescription = function buildDealersSeoDescription(data, slug, t) {
  var _data$make2 = data.make,
      make = _data$make2 === undefined ? '' : _data$make2,
      _data$model2 = data.model,
      model = _data$model2 === undefined ? '' : _data$model2,
      _data$makeTranslate2 = data.makeTranslate,
      makeTranslate = _data$makeTranslate2 === undefined ? make : _data$makeTranslate2,
      _data$modelTranslate2 = data.modelTranslate,
      modelTranslate = _data$modelTranslate2 === undefined ? model : _data$modelTranslate2,
      _data$location2 = data.location,
      locationRu = _data$location2 === undefined ? '' : _data$location2;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](_extends({}, data, { transport: data.transport || slug }), t, 'avtosalony');
  if (seoData && seoData.description) return seoData.description;

  var locale = t('locale');

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);
  var accusativeCityHeader = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].accusative;
  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  if (slug === 'avto') {
    if (location && !make && !model) {
      return t('Лучшие предложения автосалонов {inGenitiveCityHeader} – скидки автодилеров на новые автомобили. Запишитесь на тестдрайв ✅ адреса и телефоны ☎️ на сайте  АвтоБазар™.', { location: location, inGenitiveCityHeader: inGenitiveCityHeader });
    }
    if (make && !location && !model) {
      return t('Надежная ✅ покупка {makeTranslate} в автосалонах {make} – запишитесь на тестдрайв. Адреса ☎️ телефоны автодилеров на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location && !model) {
      return t('Предложения автосалонов {makeTranslate} {inGenitiveCityHeader}  ✅ покупка {make} в автосалонах – запишитесь на тестдрайв. Адреса ☎️ телефоны автодилеров на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model && !location) {
      return t('Предложения автосалонов {make} {model} ✅ купить {makeTranslate} {modelTranslate}  у автодилеров – запишитесь на тестдрайв. Адреса и ☎️ телефоны на сайте АвтоБазар™.', {
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }
    if (make && model && location) {
      return t('Предложения автосалонов {accusativeCityHeader} на {make} {model} ✅ покупка {makeTranslate} {modelTranslate} у автодилера {inGenitiveCityHeader}. Адреса и ☎️ телефоны на сайте АвтоБазар™.', {
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        accusativeCityHeader: accusativeCityHeader,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
  }
  if (slug === 'mototsikl') {
    if (location && !make) {
      return t('Лучшие предложения на покупку мототехники в мотосалонах {inGenitiveCityHeader}. Мотоциклы, скутеры, квадроциклы, электробайки, мопеды и мотоэкипировка. Адреса и ☎️ на сайте АвтоБазар™.', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    if (make && !location) {
      return t('Лучшие цены на мототехнику {make} и акции мотосалонов. Мотоциклы, скутеры, квадроциклы, электробайки, мопеды  {makeTranslate} и мотоэкипировка. Адреса и ☎️ на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Лучшие цены на мототехнику {makeTranslate} и акции в мотосалонах {accusativeCityHeader}. Мотоцикли, скутери, квадроцикли, электробайки, мопеди {make} и мотоекипировка. Адреса и ☎️ на сайте АвтоБазар™.', {
        make: make,
        makeTranslate: makeTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Каталог мотосалонов – лучшие цены мотомагазинов в вашем городе на мототехнику и с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны.', {});
  }
  if (slug === 'avtobus') {
    if (location && !make && !model) {
      return t('Надежная ✅ покупка автобуса автосалонов {inGenitiveCityHeader} – запишитесь на тестдрайв буса. Адреса и ☎️ на АвтоБазар™', {
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && !location && !model) {
      return t('Надежная ✅ покупка автобуса {makeTranslate} в автосалонах {make} – запишитесь на тестдрайв буса. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Автобусы {makeTranslate} {inGenitiveCityHeader}  ✅ покупка буса {make} в салонах {accusativeCityHeader}. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Дилеры автобусов Украины – выберите автодилера в своем городе. Бус с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны', {});
  }
  if (slug === 'gruzovye') {
    if (location && !make && !model) {
      return t('Надежная ✅ покупка грузовых автомобилей в автосалонах {accusativeCityHeader} – запишитесь на тестдрайв грузовика. Адреса и ☎️ на АвтоБазар™', { accusativeCityHeader: accusativeCityHeader });
    }
    if (make && !location && !model) {
      return t('Надежная ✅ покупка грузового {makeTranslate} в официальных автосалонах {make} – кредит, лизинг. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Грузовик {makeTranslate} {inGenitiveCityHeader} ✅ покупка грузового {make} в салонах {accusativeCityHeader}. Адреса и ☎️ на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Автосалоны грузовиков Украины – выберите автодилера в своем городе. Грузовой автомобиль с гарантией от салона. Сайт АвтоБазар™ ✅ адреса ☎️ телефоны салонов', {});
  }
  if (slug === 'spetstehnika') {
    if (make && !location) {
      return t('Продажа спецтехники {make} и услуги от официальных и проверенных дилеров Украины. Актуальные предложения, цены и акции на технику – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (location && !make) {
      return t('Продажа спецтехники и услуги от официальных и проверенных дилеров {inGenitiveCityHeader}. Актуальные предложения, цены и акции на технику – АвтоБазар™', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    return t('Продажа спецтехники и услуги от официальных и проверенных дилеров Украины. Актуальные предложения, цены и акции на технику – АвтоБазар™', {});
  }
  if (slug === 'vodnyi-transport') {
    if (make && !location) {
      return t('Продажа водного транспорта {make} и услуги от официальных и проверенных салонов Украины. Актуальные предложения, цены и акции – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (location && !make) {
      return t('Продажа водного транспорта и услуги от официальных и проверенных салонов {inGenitiveCityHeader}. Актуальные предложения, цены и акции – АвтоБазар™', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    return t('Продажа водного транспорта и услуги от официальных и проверенных салонов Украины. Актуальные предложения, цены и акции – АвтоБазар™', {});
  }
  if (slug === 'pritsepy') {
    if (make && !location) {
      return t('Продажа прицепов {make} и услуги от надежных компаний Украины. Актуальные предложения, цены и акции – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (location && !make) {
      return t('Продажа прицепов и услуги от надежных компаний {inGenitiveCityHeader}. Актуальные предложения, цены и акции – АвтоБазар™', { inGenitiveCityHeader: inGenitiveCityHeader });
    }
    return t('Продажа прицепов и услуги от надежных компаний Украины. Актуальные предложения, цены и акции – АвтоБазар™', {});
  }

  return t('Все автосалоны Украины – актуальные цены и скидки на новые авто ✅ адреса и телефоны дилеров ☎️ каталог АвтоБазар™.', {});
};

var buildSparePartsSeoDescription = function buildSparePartsSeoDescription(data, rubricSlug, t, isRegion) {
  var _data$location3 = data.location,
      locationRu = _data$location3 === undefined ? '' : _data$location3,
      _data$make3 = data.make,
      make = _data$make3 === undefined ? '' : _data$make3,
      _data$model3 = data.model,
      model = _data$model3 === undefined ? '' : _data$model3,
      selectedTransport = data.transport,
      rubricTitle = data.rubric,
      partTypeRu = data.partType,
      partTypeUk = data.partTypeUk;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'zapchasti');
  if (seoData && seoData.description) {
    return seoData.description;
  }
  var locale = t('locale');

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);
  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  var rubric = rubricTitle;
  var partType = partTypeRu;
  var transport = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["o" /* replaceTransport */](selectedTransport);

  var inCityOrRegion = t('в городе') + ' ' + t(location);
  if (isRegion && locationRu) {
    inCityOrRegion = '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu][locale].genitive;
  }

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!location && !rubric && !partType && !rubricSlug) {
    if (make && !model && !location) {
      return t('Продажа запчастей на {make} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.', {
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей на {make} {model} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.', {
        make: make,
        model: model,
        transport: transport
      });
    }
  }
  if (location && !rubric && !partType && !rubricSlug) {
    if (!make && !model) {
      return t('Продажа запчастей на {transport} {inGenitiveCityHeader} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро найти автозапчасти на {transport} по лучшей цене {inCityOrRegion}.', {
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader,
        inCityOrRegion: inCityOrRegion
      });
    }
    if (make && !model) {
      return t('Продажа автозапчастей {make} на {transport} {inGenitiveCityHeader} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти для {make}.', {
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader,
        location: location
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей на {make} {model} {inCityOrRegion} ✅ Сравните цены и купите запчасти на {transport} по лучшей цене на АвтоБазар™.', {
        make: make,
        model: model,
        transport: transport,
        inCityOrRegion: inCityOrRegion
      });
    }
  }

  if (__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].accusative;
  } else if (__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].nominative;
  }

  /* ______________________FIRST TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Продажа автозапчастей {rubric} на {transport} {make} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям в Украине.', {
        rubric: rubric,
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей {rubric} на {make} {model} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям в Украине.', {
        rubric: rubric,
        make: make,
        model: model
      });
    }

    return t('Продажа автозапчастей {rubric} на {transport} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям – сравните предложения в Украине.', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Продажа автозапчастей {rubric} на {transport} {make} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.', {
        rubric: rubric,
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('Продажа автозапчастей {rubric} на {transport} {make} {model} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('Продажа автозапчастей {rubric} на {transport} на сайте АвтоБазар™ ✅ Большой выбор и удобный поиск по объявлениям {inGenitiveCityHeader}.', {
      rubric: rubric,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} по выгодной цене на сайте АвтоБазар™ ✅ Большой выбор автозапчастей {rubric}.', {
        rubric: rubric,
        partType: partType,
        transport: transport,
        make: make
      });
    }
    if (make && model) {
      return t('{partType} на {transport} {make} {model} по выгодной цене на АвтоБазар™ ✅ Большой выбор автозапчастей для {rubric}.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        transport: transport
      });
    }

    return t('{partType} на {transport} по выгодной цене на сайте АвтоБазар™ ✅ Большой выбор автозапчастей {rubric}.', {
      rubric: rubric,
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('{partType} на {transport} {make} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор запчастей для {rubric} – АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('{partType} на {make} {model} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор запчастей для {rubric} – АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('{partType} на {transport} по выгодной цене {inGenitiveCityHeader} ✅ Большой выбор автозапчастей для {rubric} – АвтоБазар™.', {
      rubric: rubric,
      partType: partType,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} по выгодной цене на {transport} {make} ✅ Найдите нужную деталь в Украине на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('{rubric} по лучшей цене на {transport} {make} {model} ✅ Найдите нужную деталь в Украине на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport
      });
    }

    return t('{rubric} по выгодной цене на {transport} ✅ Найдите нужную деталь в Украине на АвтоБазар™.', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} по выгодной цене на {transport} {make} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('{rubric} по выгодной цене на {transport} {make} {model} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('{rubric} по выгодной цене на {transport} ✅ Найдите нужную деталь {inGenitiveCityHeader} на АвтоБазар™.', {
      rubric: rubric,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.', {
        rubric: rubric,
        partType: partType,
        transport: transport,
        make: make
      });
    }
    if (make && model) {
      return t('{partType} на {transport} {make} {model} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        transport: transport
      });
    }

    return t('{partType} на {transport} по выгодной цене на сайте АвтоБазар™ ✅ {rubric} – большой выбор запчастей.', {
      rubric: rubric,
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('Выбирайте {partType} на {transport} {make} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        inGenitiveCityHeader: inGenitiveCityHeader,
        transport: transport
      });
    }
    if (make && model) {
      return t('Выбирайте {partType} на {transport} {make} {model} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на сайте АвтоБазар™.', {
        rubric: rubric,
        partType: partType,
        make: make,
        model: model,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('Выбирайте {partType} на {transport} по выгодной цене {inGenitiveCityHeader} ✅ {rubric} на АвтоБазар™.', {
      rubric: rubric,
      partType: partType,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  return t('Продажа автозапчастей на {transport} на сайте АвтоБазар™. ✅ Удобный поиск по объявлениям поможет Вам быстро и легко купить запчасти на {transport} по выгодной цене.', {
    transport: transport
  });
};

var buildSearchMotoSeoDescription = function buildSearchMotoSeoDescription(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.description) return seoData.description;

  var category = data.category,
      type = data.type,
      make = data.make,
      model = data.model,
      location = data.location,
      motoTitle = data.motoTitle,
      yearTitle = data.yearTitle;

  var condition = t('бу и новой');
  var icon = '🏍️';
  var transportWho = t('мототехники');
  var transportWhat = t('мототранспорт');
  return [t('Продажа'), condition, category || type || motoTitle ? (motoTitle || (type && type.title ? type.title.toLowerCase() : '')) + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWho, icon, make && make.title, model && model.title, (location || t('в Украине')) + '.', t('Удобный поиск по объявлениям поможет Вам быстро и легко купить'), category || type ? (type && type.title ? type.title.toLowerCase() : '') + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWhat || '', '' + (yearTitle || '') + t('по выгодной цене на Автобазаре™.')].filter(function (i) {
    return !!i;
  }).join(' ');
};

var buildSearchCommercialSeoDescription = function buildSearchCommercialSeoDescription(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'commercial');
  if (seoData && seoData.description) return seoData.description;

  var isUkraine = ['Україні', 'Украине'].includes(data.cityDescriptions);

  if (!isUkraine) {
    // eslint-disable-next-line no-param-reassign
    data.cityDescriptions = t('в') + ' ' + t(data.cityDescriptions);
    // eslint-disable-next-line no-param-reassign
  } else data.cityDescriptions = '\u0432 ' + t('Украине');

  var transportDescriptions = data.transportDescriptions,
      transportNextDescriptions = data.transportNextDescriptions,
      transportCategoryTitle = data.transportCategoryTitle,
      make = data.make,
      model = data.model,
      isNew = data.isNew,
      transportType = data.transportType;


  if (transportType === 'avtobus' && transportCategoryTitle) {
    return t('Купить бу и новые {transportCategoryTitle} автобусы {cityDescriptions}. Удобный поиск объявлений - сравните предложения и покупайте автобусы по лучшей цене на АвтоБазар™.', data);
  }
  if (transportType === 'moto' && transportCategoryTitle) {
    return t('Купить бу мототехнику {cityDescriptions} 🏍️ Объявления о продаже мотоциклов, скутеров, мопедов по лучшей цене на АвтоБазар™.', data);
  }
  if (transportType === 'pritsepy' && transportCategoryTitle) {
    return t('Купить бу или новый {transportCategoryTitle} {cityDescriptions} 🏍️ Объявления о продаже прицепного оборудования по лучшей цене на АвтоБазар™.', data);
  }
  if (transportType === 'spetstehnika' && transportCategoryTitle) {
    return t('{transportCategoryTitle} по лучшей цене купить на АвтоБазар™. Все объявления о продаже бу или новой спецтехники {cityDescriptions}.', data);
  }
  if (transportType === 'vodnyi-transport' && transportCategoryTitle) {
    return t('Купить {transportHeader} по лучшей цене {cityDescriptions}. Все объявления о продаже спецтехники на АвтоБазар™.', data);
  }
  if (transportDescriptions && transportType === 'avtobus' && make) {
    return t('Купить бу или новый автобус {makeTranslit} {cityDescriptions}. Удобный поиск объявлений - сравните предложения и покупайте автобусы {make} по лучшей цене на АвтоБазар™.', data);
  }
  if (transportDescriptions && make && !model && isNew) {
    return t('Купить новые {transportDescriptions} {make} 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && model && !isNew) {
    return t('Купить {transportDescriptions} {make} {model} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && !model && !isNew) {
    return t('Купить {transportDescriptions} {make} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && !make && !model && isNew) {
    return t('Купить новые {transportDescriptions} 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && model && isNew) {
    return t('Новые {transportDescriptions} {make} {model} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && model && !isNew) {
    return t('Купить {transportDescriptions} {make} {model} бу 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {makeTranslit} {modelTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && make && !model && isNew) {
    return t('Купить новые {transportDescriptions} {make} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {makeTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && !make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t('Купить новые {transportDescriptions} 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить новую {transportDescriptions} 🚜 {cityDescriptions}. {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    return t('Продажа новых {transportDescriptions} 🚛 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  if (transportDescriptions && !make && !model && !isNew) {
    if (transportType === 'gruzovye') {
      return t('Продажа {transportDescriptions} бу 🚚 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре™.', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить {transportDescriptions} бу 🚜 {cityDescriptions}. {transportNextDescriptions} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
        transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
        transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
      }));
    }
    return t('Купить {transportDescriptions} бу 🚌 {cityDescriptions}. Удобный поиск по объявлениям поможет купить {reductionTranslit} {yearDescriptions}по выгодной цене на Автобазаре', _extends({}, data, {
      transportDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportDescriptions),
      transportNextDescriptions: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextDescriptions)
    }));
  }
  return t('Купить бу 🚚 в Украине. Удобный поиск по объявлениям поможет купить {yearDescriptions}по выгодной цене на Автобазаре');
};
// CONCATENATED MODULE: ./src/shared/constants/seoDescriptions.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_moment__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_seoTextFinder_seoDataFinder__ = __webpack_require__(1252);




/*
my test

*/
var buildSearchDescription = function buildSearchDescription(_ref, condition, icon, transportWho, transportWhat, t) {
  var category = _ref.category,
      type = _ref.type,
      make = _ref.make,
      model = _ref.model,
      location = _ref.location,
      motoTitle = _ref.motoTitle,
      yearTitle = _ref.yearTitle;
  return [t('Продажа'), condition, category || type || motoTitle ? (motoTitle || (type && type.title ? type.title.toLowerCase() : '')) + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWho, icon, make && make.title, model && model.title, (location || t('в Украине')) + '.', t('Удобный поиск по объявлениям поможет Вам быстро и легко купить'), category || type ? (type && type.title ? type.title.toLowerCase() : '') + ' ' + (category && category.title ? category.title.toLowerCase() : '') : transportWhat || '', '' + (yearTitle || '') + t('по выгодной цене на Автобазаре™.')].filter(function (i) {
    return !!i;
  }).join(' ');
};

var getLocationString = function getLocationString(location, t) {
  return location && location.title ? t('в ') + ' ' + location.title : t('в Украине');
};

var buildAddDescriptionByTransportSlug = function buildAddDescriptionByTransportSlug(slug, t) {
  var firstSlug = 'автомобилей';
  var secondSlug = 'свое авто';
  switch (slug) {
    case 'avto':
      {
        firstSlug = 'машину';
        secondSlug = 'авто';
        break;
      }
    case 'moto':
      {
        firstSlug = 'мотоцикл';
        secondSlug = 'мототехники';
        break;
      }
    case 'avtobus':
      {
        firstSlug = 'бус';
        secondSlug = 'автобуса';
        break;
      }
    case 'gruzovye':
      {
        firstSlug = 'грузовик_а';
        secondSlug = 'грузового авто';
        break;
      }
    case 'spetstehnika':
      {
        firstSlug = 'спецтехнику';
        secondSlug = 'спецтехники';
        break;
      }
    case 'pritsepy':
      {
        firstSlug = 'прицеп';
        secondSlug = 'прицепа';
        break;
      }
    case 'vodnyi-transport':
      {
        firstSlug = 'водный транспорт';
        secondSlug = 'водного транспорта';
        break;
      }
    case 'zapchasti':
      {
        firstSlug = 'запчасти';
        secondSlug = 'автозапчастей';
        break;
      }

    default:
      {
        break;
      }
  }

  return t('Быстро продать') + ' ' + t(firstSlug).toLowerCase() + '\n  ' + t('через интернет на сайте') + ' \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122.\n  ' + t('Бесплатно разместите объявление о продаже') + '\n  ' + t(secondSlug).toLowerCase() + '\n  ' + t('и его увидят тысячи покупателей со всей Украины') + '.';
};

var getAdvertDate = function getAdvertDate(hotDate, dateCreated, datePublicated, t) {
  var date = hotDate || dateCreated || datePublicated;
  return date ? t('от') + ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_helpers_moment__["a" /* createdDate */](date, t('от') === 'від' ? 'uk' : 'ru').slice(0, -3) : '';
};

var getBodyAltAvtoAdvert = function getBodyAltAvtoAdvert(isNew, modification, body, category, t) {
  // const result =
  //   modification && modification.series && modification.series.title
  //     ? isNew
  //       ? t(modification.series.title).charAt(0).toUpperCase() +
  //         t(modification.series.title).slice(1)
  //       : t(modification.series.title).toLowerCase()
  //     : body && body.title
  //       ? isNew
  //         ? t(body.title).charAt(0).toUpperCase() + t(body.title).slice(1)
  //         : t(body.title).toLowerCase()
  //       : isNew
  //         ? t(category.title).charAt(0).toUpperCase() + category.title.slice(1)
  //         : category && category.title && t(category.title).toLowerCase();

  var result = '';
  if (modification && modification.series && modification.series.title) {
    result = isNew ? t(modification.series.title).charAt(0).toUpperCase() + t(modification.series.title).slice(1) : t(modification.series.title).toLowerCase();
  } else if (body && body.title) {
    result = isNew ? t(body.title).charAt(0).toUpperCase() + t(body.title).slice(1) : t(body.title).toLowerCase();
  } else if (category && category.title) {
    result = isNew ? t(category.title).charAt(0).toUpperCase() + category.title.slice(1) : category && category.title && t(category.title).toLowerCase();
  }
  return result;
};

var DESCRIPTION = {
  HOME: function HOME(props, t) {
    return t('SEO_HOME_DESCRIPTION');
  },

  ADVERT: function ADVERT(_ref2) {
    var id = _ref2.id,
        make = _ref2.make,
        model = _ref2.model,
        category = _ref2.category,
        year = _ref2.year,
        mileage = _ref2.mileage,
        capacity = _ref2.capacity,
        capacityUnit = _ref2.capacityUnit,
        engine = _ref2.engine,
        gearbox = _ref2.gearbox,
        location = _ref2.location,
        color = _ref2.color,
        body = _ref2.body,
        drive = _ref2.drive,
        price = _ref2.price,
        _ref2$isNew = _ref2.isNew,
        isNew = _ref2$isNew === undefined ? false : _ref2$isNew,
        _ref2$dealer = _ref2.dealer,
        dealer = _ref2$dealer === undefined ? false : _ref2$dealer,
        date_created = _ref2.date_created,
        hot_date = _ref2.hot_date,
        date_publicated = _ref2.date_publicated,
        modification = _ref2.modification,
        capacityAlt = _ref2.capacityAlt,
        characteristics = _ref2.characteristics;
    var transportDescriptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var t = arguments[2];

    if (transportDescriptions == 'авто') {
      var _getCustomParams = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_seoTextFinder_seoDataFinder__["a" /* getCustomParams */]({ city: location && location.title }, t),
          inCity = _getCustomParams.inCity;

      var advertDate = getAdvertDate(hot_date, date_created, date_publicated, t);
      var bodyAltAdvert = getBodyAltAvtoAdvert(isNew, modification, body, category, t);
      var bodyAdvert = characteristics && characteristics.category && characteristics.category.title && t(characteristics.category.title);
      var capacityAvto = capacity || (capacityAlt && capacityAlt.title ? capacityAlt.title : '');

      return [!isNew ? 'Продам' : t('Купить'), isNew && t('новое'), t(transportDescriptions), !isNew && 'бу', make && make.title, model && model.title, modification && modification.title, year && year, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + t('тыс км'), [location && location.title && inCity, isNew && dealer && dealer.title && t('в салоне') + ' ' + dealer.title].filter(function (i) {
        return !!i;
      }).join(', ').replace(',', '').concat('.'), isNew && price && t('Цена') + ' ' + price + '.', isNew ? '' : 'Продаю', [[(!isNew ? bodyAdvert && bodyAdvert.toLowerCase() || bodyAltAdvert : bodyAdvert || bodyAltAdvert) || (isNew ? t('Легковые') : t('легковые')), color && color.title && t(color.title).toLowerCase()].filter(function (i) {
        return !!i;
      }).join(', ').replace(',', '').concat(''), [engine && engine.title && t(engine.title).toLowerCase(), capacityAvto + (capacityAvto && capacityUnit && '' + (' ' + t(capacityUnit)))].filter(function (i) {
        return !!i;
      }).join(', ').replace(/,\s*/g, ' / ').concat(''), gearbox && gearbox.title && t('коробка') + ' ' + t(gearbox.title).toLowerCase(), drive && drive.title && t(drive.title).toLowerCase() + ' ' + t('привод')].filter(function (i) {
        return !!i;
      }).join(', ').replace(/$(, )/, '').concat('.'), !isNew && price && t('Цена') + ' ' + price + '.', id && t('Объявление') + ' ' + id, [!isNew && advertDate].filter(function (i) {
        return !!i;
      }).join(', ').replace(/$(, )/, '').concat(' ')].filter(function (i) {
        return !!i;
      }).join(' ');
    } else if (transportDescriptions === 'Водный транспорт' && !isNew && dealer && dealer.title || transportDescriptions === 'Водный транспорт' && !isNew && dealer && dealer.title) {
      return [t('Купить'), t(transportDescriptions), make && make.title, model && model.title, modification && modification.title, year, '\u0432 ' + t(location.title), dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + (t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'), price && t('цена') + ' ' + price, t('на Автобазаре'), id && t('Объявление') + ' ' + id].filter(function (i) {
        return !!i;
      }).join(' ');
    }

    return [t('Продажа'), make && make.title, model && model.title, dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, '' + t('характеристики'), transportDescriptions && t(transportDescriptions) + ':', [category && category.title && t('кузов') + '- ' + t(category.title).toLowerCase(), year && t('год выпуска') + ' - ' + year, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + (t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'), capacity && capacityUnit && t('объем двигателя') + ' - ' + capacity + ' ' + (t(capacityUnit) || capacityUnit), engine && engine.title && t('тип топлива') + ' - ' + t(engine.title).toLowerCase(), gearbox && gearbox.title && t('КПП') + ' - ' + t(gearbox.title).toLowerCase(), color && color.title && t('цвет') + ' - ' + t(color.title).toLowerCase()].filter(function (i) {
      return !!i;
    }).join(', ').replace(/$(, )/, '').concat('.'), [id && t('Объявление') + ' ' + id].filter(function (i) {
      return !!i;
    }).join(', ').replace(/$(, )/, '').concat(' ')].filter(function (i) {
      return !!i;
    }).join(' ');

    // // old
    // [
    // t('Продажа'),
    // make && make.title,
    // model && model.title,
    // dealer && `${t('в автосалоне')} ${dealer}`,
    // `, ${t('характеристики')}`,
    // `${transportDescriptions}:`,
    // [
    //   category && category.title && `${t('кузов')}- ${category.title.toLowerCase()}`,
    //   year && `${t('год выпуска')} - ${year}`,
    //   mileage && `${t('с пробегом')} ${mileage}`,
    //   capacity &&
    //     capacityUnit &&
    //     `${t('объем двигателя')} - ${capacity} ${t(capacityUnit) || capacityUnit}`,
    //   engine && engine.title && `${t('тип топлива')} - ${engine.title.toLowerCase()}`,
    //   gearbox && gearbox.title && `${t('КПП')} - ${gearbox.title.toLowerCase()}`,
    //   color && color.title && `${t('цвет')} - ${color.title.toLowerCase()}`,

    // ]
    //   .filter(i => !!i)
    //   .join(' ')
  },

  //

  SPARE_ADVERT: function SPARE_ADVERT(_ref3, t) {
    var rubric = _ref3.rubric,
        sparetype = _ref3.sparetype,
        type = _ref3.type,
        make = _ref3.make,
        model = _ref3.model,
        location = _ref3.location,
        id = _ref3.id;
    return [t('Продажа'), rubric && rubric.title, sparetype && (sparetype.title || '').toLowerCase(), (type || make || model) && t('на'), type && (type.title || '').toLowerCase(), make && make.title, model && model.title, getLocationString(location, t), t('на Автобазаре'), [id && t('Объявление') + ' ' + id].filter(function (i) {
      return !!i;
    }).join(', ').replace(/$(, )/, '').concat(' ')].filter(function (i) {
      return !!i;
    }).join(' ');
  },
  //

  SEARCH: {
    avto: function avto(data, translate) {
      return buildSearchAvtoSeoDescription(data, translate);
    },
    moto: function moto(data, translate) {
      return buildSearchMotoSeoDescription(data, translate);
    },
    mototsikl: function mototsikl(props, t) {
      return buildSearchDescription(props, t('бу и новых'), '🏍️', t('мотоциклов'), t('мотоцикл'), t);
    },
    commercial: function commercial(data, translate) {
      return buildSearchCommercialSeoDescription(data, translate);
    }
  },
  SPARE_PARTS: function SPARE_PARTS(data, rubricSlug, t, isRegion) {
    return buildSparePartsSeoDescription(data, rubricSlug, t, isRegion);
  },
  FIRM: function FIRM(data, t) {
    return buildFirmsSeoDescription(data, t);
  },
  FIRM_PAGE: function FIRM_PAGE(title, tab, t, car_drive_countries, transportType, tags, firm) {
    return buildFirmPageSeoDescription(title, tab, t, car_drive_countries, transportType, tags, firm);
  },
  DEALERS: function DEALERS(data, slug, t) {
    return buildDealersSeoDescription(data, slug, t);
  },

  DEALER_PAGE: {
    ADVERTS: function ADVERTS(_ref4, t) {
      var dealer = _ref4.dealer,
          _ref4$isOfficial = _ref4.isOfficial,
          isOfficial = _ref4$isOfficial === undefined ? false : _ref4$isOfficial,
          _ref4$makes = _ref4.makes,
          makes = _ref4$makes === undefined ? [] : _ref4$makes;
      return [t('Купить автомобиль вы можете у'), isOfficial && t('официального'), t('дилера'), makes.map(function (_ref5, i, _ref6) {
        var make = _ref5.title;
        var count = _ref6.length;
        return '' + make + (i !== count - 1 ? ', ' : '');
      }).join(''), t('в Украине') + ' -', dealer || '', t('Все предложения автосалона на Автобазаре')].filter(function (i) {
        return !!i;
      }).join(' ');
    },

    NEWS: function NEWS() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Самые свежие и актуальные предложения автосалона') + ' ' + dealer + ' ' + t('читайте на АвтоБазаре') + '.';
    },

    ABOUT: function ABOUT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Узнать актуальную информацию об автосалоне') + ' ' + dealer + ' ' + t('на АвтоБазаре');
    },

    CONTACT: function CONTACT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Узнать контактную информацию автосалона') + ' ' + dealer + ': ' + t('адрес, месторасположения на карте, контактные номера телефонов, режим работы - все контакты на АвтоБазаре');
    }
  },

  //

  INVOICE: function INVOICE(t) {
    return t('Квитанция за оплату на АвтоБазаре');
  },

  //

  JOURNAL: {
    ALL: function ALL(t) {
      return t('Все новости и статьи на Автобазар') + '\u2122';
    },
    NEWS: function NEWS(t, rubric) {
      return t('Все') + ' ' + t(rubric || 'Новости').toLowerCase() + ' ' + t('на Автобазаре');
    }
  },

  //

  SERVICE: {
    CAR_COST_ESTIMATE: function CAR_COST_ESTIMATE(t) {
      return t('Оценка стоимости авто') + ' ' + t('на Автобазаре');
    },
    CAR_DRIVE: function CAR_DRIVE(t) {
      return t('Пригон авто') + ' ' + t('на Автобазаре');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поиск') + ' ' + t('на Автобазаре');
    }
  },

  //

  LOGIN: function LOGIN(t) {
    return t('Авторизация на Автобазар') + '\u2122';
  },

  //

  NOT_FOUND: function NOT_FOUND(t) {
    return t('Страница не найдена');
  },

  //

  ADVERT_FORM: {
    ADD: function ADD(slug, t) {
      return buildAddDescriptionByTransportSlug(slug, t);
    },
    EDIT: function EDIT(t) {
      return t('Форма редактирования объявления на Автобазар');
    }
  },

  //

  PROFILE: {
    PROFILE: function PROFILE(t) {
      return t('Профиль пользователя');
    },
    DIALOGS: function DIALOGS(t) {
      return t('Сообщения пользователя');
    },
    FAVORITES: function FAVORITES(t) {
      return t('Избранные пользователя');
    },
    BILLING: function BILLING(t) {
      return t('Баланс пользователя');
    },
    SEARCHES: function SEARCHES(t) {
      return t('Поиски пользователя');
    },
    ADVERTS: function ADVERTS(t) {
      return t('Объявления пользователя');
    },
    INSURANCE: function INSURANCE(t) {
      return t('Страховка');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поис');
    }
  },

  //

  MOBILE_FORM: {
    GEO: function GEO(t) {
      return t('Выбор местоположения');
    },
    FILTERS: function FILTERS(t) {
      return t('Выбор по параметрам');
    }
  },

  STATIC_PAGE: {
    LAW: function LAW(t) {
      return t('Политика конфиденциальности – полезная информация от Автобазар');
    },
    PUBLIC_CONTRACT: function PUBLIC_CONTRACT(t) {
      return t('Публичный договор – полезная информация от Автобазар');
    },
    INFO_ZAPCHASTI: function INFO_ZAPCHASTI(t) {
      return t('Запчасти – полезная информация от Автобазар');
    },
    HELP: function HELP(t) {
      return t('Помощь – полезная информация от Автобазар');
    },
    FOR_SERVICES: function FOR_SERVICES(t) {
      return t('Автосервисам – полезная информация от Автобазар');
    },
    FOR_PRIVATES: function FOR_PRIVATES(t) {
      return t('Размещение объявлений – полезная информация от Автобазар');
    },
    FOR_DEALERS: function FOR_DEALERS(t) {
      return t('Пакет “Бизнес Плюс” – полезная информация от Автобазар');
    },
    BIZNES_PAKET: function BIZNES_PAKET(t) {
      return t('Пакет “Бизнес” – полезная информация от Автобазар');
    },
    ADVERTISING: function ADVERTISING(t) {
      return t('Разместить рекламу – полезная информация от Автобазар');
    },
    ABOUT: function ABOUT(t) {
      return t('Что такое автобазар – полезная информация от Автобазар');
    },
    FAQ: function FAQ(t) {
      return t('Часто задаваемые вопросы – полезная информация от Автобазар');
    },
    ENTRANCE: function ENTRANCE(t) {
      return t('Регистрация на avtobazar.ua – полезная информация от Автобазар');
    },
    TRANSPORT_ADS_RULES: function TRANSPORT_ADS_RULES(t) {
      return t('Правила составления объявлений – полезная информация от Автобазар');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (DESCRIPTION);

/***/ }),

/***/ 1389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/seoTitles.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var buildSearchAvtoSeoTitle = function buildSearchAvtoSeoTitle(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.title) return seoData.title;

  var _data$make = data.make,
      make = _data$make === undefined ? '' : _data$make,
      _data$model = data.model,
      model = _data$model === undefined ? '' : _data$model,
      _data$location = data.location,
      location = _data$location === undefined ? '' : _data$location,
      _data$generation = data.generation,
      generation = _data$generation === undefined ? '' : _data$generation,
      _data$gearbox = data.gearbox,
      gearbox = _data$gearbox === undefined ? '' : _data$gearbox,
      _data$engine = data.engine,
      engine = _data$engine === undefined ? '' : _data$engine,
      _data$body = data.body,
      body = _data$body === undefined ? '' : _data$body,
      _data$drive = data.drive,
      driveSelected = _data$drive === undefined ? '' : _data$drive,
      _data$isNew = data.isNew,
      isNew = _data$isNew === undefined ? false : _data$isNew,
      _data$year = data.year,
      yearSelected = _data$year === undefined ? '' : _data$year,
      _data$country = data.country,
      country = _data$country === undefined ? null : _data$country,
      _data$city = data.city,
      city = _data$city === undefined ? null : _data$city;


  var drive = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["b" /* buildDriveValue */](driveSelected, t);
  var locale = t('locale');
  var inGenitiveLocation = location && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location] ? __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][location][locale].genitive) : city && city.title && ' ' + __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](city[locale + '_title'] || city.title) || '\u0432 ' + __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */]['Украина'][locale].genitive;

  var yearVsSpace = yearSelected ? ' ' + yearSelected + ' ' + t('года') : '';
  var customGearbox = gearbox in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["c" /* gearboxes */][gearbox][locale].title : gearbox;
  var customEngine = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].title : engine;
  var customEngineAlt = engine in __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */] ? __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["b" /* engines */][engine][locale].altTitle : engine;

  var countryTitle = country && t(country.title);
  var countryFromTitle = country && country.from && country.from[locale];

  // {locale}*/avto/{country}/
  if (country && !make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t('SEO_META_TITLE_AVTO_COUNTRY', { countryTitle: countryTitle, countryFromTitle: countryFromTitle });
  }

  if (make && !model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Продажа {make}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа {make}{year} б/у на АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && !generation && !gearbox && !engine && !body && !drive) {
    return t(isNew ? 'Продажа {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа б/у {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && body && !generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Продажа {make} {model} {body}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа б/у {body} {make} {model}{year} на АвтоБазар™ {inGenitiveLocation} – купить автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && generation && !gearbox && !engine && !drive) {
    return t(isNew ? 'Продажа {make} {model} {generation}{year} на АвтоБазар™ {inGenitiveLocation} – купить новый автомобиль, сравнение цен в каталоге' : 'Продажа б/у {make} {model} {generation}{year} на АвтоБазар™ {inGenitiveLocation} – купить автомобиль по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && gearbox && !engine && !drive) {
    return t(isNew ? 'Новый {make} {model}{generation} {gearbox}{year} купить {inGenitiveLocation} на АвтоБазар™' : '{make} {model} б/у{generation} {gearbox}{year} купить {inGenitiveLocation} на АвтоБазар™', _extends({}, data, {
      generation: ' ' + generation || '',
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }
  if (make && model && gearbox && drive && !engine) {
    return t(isNew ? 'Новый {make} {model}{generation} {gearbox} {drive}{year} купить {inGenitiveLocation} на АвтоБазар™' : 'Купить {make} {model}{generation} {gearbox} {drive}{year} {inGenitiveLocation} на АвтоБазар™', _extends({}, data, {
      generation: ' ' + generation || '',
      inGenitiveLocation: inGenitiveLocation,
      drive: drive,
      year: yearVsSpace
    }));
  }
  if (make && model && gearbox && drive && engine) {
    return t(isNew ? 'Новый {make} {model} {engine} {gearbox}{generation} {drive}{year} купить {inGenitiveLocation} на АвтоБазар™' : '{make} {model} {engine} {gearbox} {drive}{generation}{year} б/у купить {inGenitiveLocation} на АвтоБазар™', _extends({}, data, {
      generation: ' ' + generation || '',
      inGenitiveLocation: inGenitiveLocation,
      drive: drive,
      year: yearVsSpace
    }));
  }

  if (make && !model && gearbox && !engine && !drive) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить новое авто {makeTranslate} {customGearbox}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} – купить авто {makeTranslate} {customGearbox}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customGearbox: customGearbox
    }));
  }

  if (!make && !model && !gearbox && engine && !drive) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить новый {customEngine}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} – купить {customEngine}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customEngine: customEngine
    }));
  }

  if (!make && !model && !gearbox && !engine && !drive && body) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить новый авто {body}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} – купить авто {body}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }

  if (make && !model && !gearbox && engine && !drive && !body) {
    return t(isNew ? 'Новые {customEngineAlt} {make}{year} купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}' : '{customEngineAlt} {make}{year} б/у купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customEngineAlt: customEngineAlt
    }));
  }

  if (make && model && !gearbox && engine && !drive && !body) {
    return t(isNew ? 'Новые {customEngineAlt} {make} {model}{year} купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}' : '{customEngineAlt} {make} {model}{year} б/у купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customEngineAlt: customEngineAlt
    }));
  }

  if (!make && !model && gearbox && !engine && !drive && !body) {
    return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} - купить новый авто {customGearbox}{year} по лучшей цене' : 'АвтоБазар™ {inGenitiveLocation} - купить авто {customGearbox}{year} б/у по лучшей цене', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace,
      customGearbox: customGearbox
    }));
  }
  if (make && !model && !gearbox && !engine && !drive && body) {
    return t(isNew ? 'Новый {body} {make}{year} - купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}' : '{body} {make}{year} б/у - купить по лучшей цене на АвтоБазар™ {inGenitiveLocation}', _extends({}, data, {
      inGenitiveLocation: inGenitiveLocation,
      year: yearVsSpace
    }));
  }

  return t(isNew ? 'АвтоБазар™ {inGenitiveLocation} – купить легковой автомобиль новый, сравнение цен в каталоге' : 'Автобазар {inGenitiveLocation}. Купить авто бу {inGenitiveLocation} с пробегом на авторынке', {
    inGenitiveLocation: inGenitiveLocation,
    location: location
  });
};

var buildDealersSeoTitle = function buildDealersSeoTitle(data, slug, t) {
  var _data$make2 = data.make,
      make = _data$make2 === undefined ? '' : _data$make2,
      _data$model2 = data.model,
      model = _data$model2 === undefined ? '' : _data$model2,
      _data$makeTranslate = data.makeTranslate,
      makeTranslate = _data$makeTranslate === undefined ? make : _data$makeTranslate,
      _data$modelTranslate = data.modelTranslate,
      modelTranslate = _data$modelTranslate === undefined ? model : _data$modelTranslate,
      _data$location2 = data.location,
      locationRu = _data$location2 === undefined ? '' : _data$location2;


  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](_extends({}, data, { transport: data.transport || slug }), t, 'avtosalony');
  if (seoData && seoData.title) return seoData.title;

  var locale = t('locale');

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);
  var accusativeCityHeader = __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].accusative;
  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  if (slug === 'avto') {
    if (location && !make && !model) {
      return t('Автосалоны {location} – надежные автодилеры, цены, акции на авто из салона – АвтоБазар™', { location: location });
    }
    if (make && !location && !model) {
      return t('Автосалоны {make} – официальные дилеры {makeTranslate} на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location && !model) {
      return t('Автосалоны {make} – цены салонов {makeTranslate} {inGenitiveCityHeader} на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model && !location) {
      return t('{make} {model} купить в автосалонах – цены на {makeTranslate} {modelTranslate} – АвтоБазар™', {
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }
    if (make && model && location) {
      return t('Продажа {make} {model} в автосалонах {accusativeCityHeader}. Сравнение цен авто дилеров на {modelTranslate} – АвтоБазар™', {
        make: make,
        model: model,
        modelTranslate: modelTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
  }
  if (slug === 'mototsikl') {
    if (location && !make) {
      return t('Мотосалоны {location} – лучшие цены мото магазинов: мотоциклы, скутеры, квадроциклы – АвтоБазар™', { location: location });
    }
    if (make && !location) {
      return t('Мотосалоны {make} – все официальные мото магазины {makeTranslate} на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Мотосалоны {make} {location} – все официальные мото магазини на сайте АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        location: location
      });
    }
    return t('Мотосалоны Украины – цены мото магазинов на мотоциклы, скутеры, квадроциклы – АвтоБазар™', {});
  }
  if (slug === 'avtobus') {
    if (location && !make && !model) {
      return t('Автосалоны автобусов {location} – надежные дилеры бусов на сайте АвтоБазар™', {
        location: location
      });
    }
    if (make && !location && !model) {
      return t('Автосалоны автобусов {make} – цены дилеров на бусы {makeTranslate} – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Автобусы {make} в автосалонах {accusativeCityHeader} – проверенные бусы {makeTranslate} на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Автосалоны автобусов Украины – все автодилеры по продаже бусов на сайте АвтоБазар™', {});
  }
  if (slug === 'gruzovye') {
    if (location && !make && !model) {
      return t('Автосалоны грузовых автомобилей {location} – надежные автодилеры грузовиков на сайте АвтоБазар™', { location: location });
    }
    if (make && !location && !model) {
      return t('Автосалоны грузовых {make} – проверенные грузовики {makeTranslate} на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && location) {
      return t('Грузовые {make} в автосалонах {accusativeCityHeader} – проверенные грузовики {makeTranslate} на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        accusativeCityHeader: accusativeCityHeader
      });
    }
    return t('Автосалоны грузовых автомобилей Украины – все автодилеры по продаже грузовиков на АвтоБазар™', {});
  }
  if (slug === 'spetstehnika') {
    if (!make && location) {
      return t('Дилеры спецтехники {inGenitiveCityHeader} – каталог компаний АвтоБазар™', {
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && !location) {
      return t('Дилеры спецтехники {make} Украины в каталоге компаний АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    return t('Дилеры спецтехники Украины в каталоге компаний АвтоБазар™', {});
  }
  if (slug === 'vodnyi-transport') {
    if (!make && location) {
      return t('Дилеры водного транспорта {location} в каталоге компаний АвтоБазар™', {
        location: location
      });
    }
    if (make && !location) {
      return t('Дилеры водного транспорта {make} Украины в каталоге компаний АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    return t('Дилеры водного транспорта Украины в каталоге компаний АвтоБазар™', {});
  }
  if (slug === 'pritsepy') {
    if (!make && location) {
      return t('Производители прицепов и проверенные дилеры {inGenitiveCityHeader} – каталог компаний АвтоБазар™', {
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && !location) {
      return t('Проверенные дилеры прицепов {make} в Украине – каталог компаний на АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate
      });
    }
    return t('Производители прицепов и проверенные дилеры Украины в каталоге компаний АвтоБазар™', {});
  }

  return t('Автосалоны Украины – все автодилеры, цены, акции на авто из салона – АвтоБазар™', {});
};

var buildFirmsSeoTitle = function buildFirmsSeoTitle(data, t) {
  var cityTitle = data.cityTitle,
      section = data.section,
      regLocation = data.regLocation,
      location = data.location;
  // if (section === 'СТО') {
  //   if (regLocation)
  //     return t('СТО {location} - автосервис по ремонту авто на сайте Автобазар', {
  //       location: regLocation,
  //     });
  //   return t('Все СТО Украины, автосервисы и шиномонтажи на АвтоБазар™');
  // }
  // if (section && cityTitle) {
  //   return t('{section} в {cityTitle} на Автобазаре - Полный каталог фирм в вашем городе', {
  //     ...data,
  //     section: replaceToUpperCase(section),
  //   });
  // }
  // if (section) {
  //   return t('{section} в Украине на Автобазаре - Полный каталог фирм в вашем городе', {
  //     ...data,
  //     section: replaceToUpperCase(section),
  //   });
  // }
  // if (cityTitle) {
  //   return t('СТО {cityTitle} - автосервис по ремонту авто на сайте Автобазар', {
  //     ...data,
  //     cityTitle: t(location),
  //   });
  // }

  if (section === 'СТО' && cityTitle) {
    return t('СТО {cityTitle}. Адреса, телефоны, карта проезда - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t('Авторазборка {cityTitle}. Каталог компаний по разбору авто (адреса, телефоны) - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t('Автовыкуп {cityTitle}. Каталог компаний по выкупу авто - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t('Дилеры по продаже автозапчастей {cityTitle}. Телефоны, адреса компаний - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Дистрибьютеры автотоваров {cityTitle}. Каталог поставщиков автотоваров - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t('ТСЦ {cityTitle}. Телефоны, адреса сервисных центров авто - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  if (cityTitle) {
    return t('Автосервисы {cityTitle}. Каталог компаний с адресами и телефонами - Автобазар', _extends({}, data, {
      cityTitle: t(regLocation) || t(location)
    }));
  }

  return t('Каталог фирм в Украине на Автобазаре - Полный каталог фирм в вашем городе');
};

var buildSparePartsSeoTitles = function buildSparePartsSeoTitles(data, rubricSlug, t) {
  var locale = t('locale');
  var _data$location3 = data.location,
      locationRu = _data$location3 === undefined ? '' : _data$location3,
      _data$make3 = data.make,
      make = _data$make3 === undefined ? '' : _data$make3,
      _data$model3 = data.model,
      model = _data$model3 === undefined ? '' : _data$model3,
      _data$makeTranslate2 = data.makeTranslate,
      makeTranslate = _data$makeTranslate2 === undefined ? make : _data$makeTranslate2,
      _data$modelTranslate2 = data.modelTranslate,
      modelTranslate = _data$modelTranslate2 === undefined ? model : _data$modelTranslate2,
      selectedTransport = data.transport,
      rubricTitle = data.rubric,
      partTypeRu = data.partType,
      partTypeUk = data.partTypeUk;

  var cityHeader = locationRu && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][locationRu] ? locationRu : 'Украина';
  var location = locationRu && t(locationRu);

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'zapchasti');
  if (seoData && seoData.title) {
    return seoData.title;
  }

  var inGenitiveCityHeader = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["c" /* buildInGenitiveCityHeader */](__WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["g" /* sity */][cityHeader][locale].genitive);

  var transport = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["o" /* replaceTransport */](selectedTransport);

  var rubric = rubricTitle;
  var partType = partTypeRu;

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!location && !rubric && !partType && !rubricSlug) {
    if (make && !model && !location) {
      return t('Запчасти для {make} – Купить запчасти на {transport} в Украине - АвтоБазар', {
        make: make,
        transport: transport
      });
    }
    if (make && model) {
      return t('Запчасти для {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине - АвтоБазар', {
        make: make,
        makeTranslate: makeTranslate,
        model: model,
        modelTranslate: modelTranslate
      });
    }
  }
  if (location && !rubric && !partType && !rubricSlug) {
    if (!make && !model) {
      return t('Запчасти на {transport} {location} – купить по лучшей цене на АвтоБазар™', {
        transport: transport,
        location: location
      });
    }
    if (make && !model) {
      return t('Запчасти на {transport} {make} ({makeTranslate}) {location} - лучшие цены на АвтоБазар™', {
        make: make,
        transport: transport,
        location: location,
        makeTranslate: makeTranslate
      });
    }
    if (make && model) {
      return t('Запчасти для {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        make: make,
        makeTranslate: makeTranslate,
        model: model,
        modelTranslate: modelTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
  }

  if (__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug) && rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric]) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].accusative;
  } else if (__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug) && rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric]) {
    rubric = rubric && __WEBPACK_IMPORTED_MODULE_0_shared_modules_subjectiveText_allText__["f" /* rubrics */][rubric][locale].nominative;
  }

  /* ______________________FIRST TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Запчасти {rubric} на {transport} {make} ({makeTranslate}) купить по лучшей цене - АвтоБазар™', {
        rubric: rubric,
        make: make,
        makeTranslate: makeTranslate,
        transport: transport
      });
    }
    if (make && model) {
      return t('Запчасти {rubric} {make} {model} ({makeTranslate} {modelTranslate}) купить по лучшей цене - АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('Запчасти {rubric} на {transport} – купить по лучшей цене - АвтоБазар™', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('Запчасти {rubric} на {transport} {make} ({makeTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        makeTranslate: makeTranslate,
        transport: transport,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('Запчасти {rubric} {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('Запчасти {rubric} на {transport} {location} – купить по лучшей цене - АвтоБазар™', {
      rubric: rubric,
      transport: transport,
      location: location
    });
  }

  /* ______________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить в Украине – АвтоБазар™', {
        partType: partType,
        transport: transport,
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && model) {
      return t('{partType} на {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('{partType} на {transport} – купить в Украине – АвтоБазар™', {
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_firstSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('{partType} на {make} ({makeTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        partType: partType,
        make: make,
        makeTranslate: makeTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }
    if (make && model) {
      return t('{partType} {make} {model} ({makeTranslate} {modelTranslate}) купить {inGenitiveCityHeader} – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        inGenitiveCityHeader: inGenitiveCityHeader
      });
    }

    return t('{partType} на {transport} – купить {inGenitiveCityHeader} – АвтоБазар™', {
      partType: partType,
      transport: transport,
      inGenitiveCityHeader: inGenitiveCityHeader
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC_______________________ */

  if (!location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} на {transport} {make} ({makeTranslate}) купить запчасти - АвтоБазар™', {
        rubric: rubric,
        make: make,
        makeTranslate: makeTranslate,
        transport: transport
      });
    }
    if (make && model) {
      return t('{rubric} на {make} {model} ({makeTranslate} {modelTranslate}) купить на АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('{rubric} на {transport} – купить запчастини - АвтоБазар™', {
      rubric: rubric,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && !partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    if (make && !model) {
      return t('{rubric} на {transport} {make} - купить {location} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        transport: transport,
        location: location
      });
    }
    if (make && model) {
      return t('{rubric} {make} {model} – купить запчасти на {transport} {location} – АвтоБазар™', {
        rubric: rubric,
        make: make,
        model: model,
        transport: transport,
        location: location
      });
    }

    return t('{rubric} на {transport} купить {location} – АвтоБазар™', {
      rubric: rubric,
      transport: transport,
      location: location
    });
  }

  /* ______________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (!location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);
    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить – АвтоБазар™', {
        partType: partType,
        transport: transport,
        make: make,
        makeTranslate: makeTranslate
      });
    }
    if (make && model) {
      return t('{partType} {make} {model} ({makeTranslate} {modelTranslate}) купить в Украине – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate
      });
    }

    return t('{partType} на {transport} купить в Украине – АвтоБазар™', {
      partType: partType,
      transport: transport
    });
  }

  if (location && rubricSlug && rubric && partType && __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_secondSeoRubricsTypes_json___default.a.includes(rubricSlug)) {
    partType = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](partType);

    if (make && !model) {
      return t('{partType} на {transport} {make} ({makeTranslate}) купить {location} – АвтоБазар™', {
        partType: partType,
        make: make,
        makeTranslate: makeTranslate,
        location: location,
        transport: transport
      });
    }
    if (make && model) {
      return t('{partType} на {make} {model} ({makeTranslate} {modelTranslate}) купить {location} – АвтоБазар™', {
        partType: partType,
        make: make,
        model: model,
        makeTranslate: makeTranslate,
        modelTranslate: modelTranslate,
        location: location
      });
    }

    return t('{partType} на {transport} – купить {location} – АвтоБазар™', {
      partType: partType,
      transport: transport,
      location: location
    });
  }

  return t('Запчасти на {transport} купить в Украине – АвтоБазар™', {
    transport: transport
  });
};

var buildFirmPageSeoTitle = function buildFirmPageSeoTitle(title, tab, t) {
  var car_drive_countries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var tags = arguments[4];

  if (tab === 'blog') {
    return t('{title} – Новости и акции компании на сайте Автобазар™', {
      title: title
    });
  }

  var countries = car_drive_countries.map(function (item) {
    return item.title;
  }).join(', ');

  if (car_drive_countries.length > 0) {
    return t('Компания {title} по пригону авто из {countries} - Автобазар', {
      title: title,
      countries: countries
    });
  }

  if (Array.isArray(tags)) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].slug && tags[i].slug === 'sto') {
        return t('СТО {title}. Адрес, телефоны, график работы - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtorazborka') {
        return t('Авторазборка {title}. Адрес, телефоны, график работы - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtovykup') {
        return t('{title}. Адрес, телефон, график работы компании - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'avtotovary') {
        return t('Дистрибьютер автотоваров {title}. Адрес, телефон, график работы компании - Автобазар', {
          title: title
        });
      }

      if (tags[i].slug && tags[i].slug === 'teritorialni-servisni-centri') {
        return t('{title}. Адрес, телефон сервисного центра - Автобазар', {
          title: title
        });
      }
    }
  }

  return t('METATEGS_TITLE_FIRM_ZAPCHASTI', { title: title });
};

var buildSearchMotoSeoTitle = function buildSearchMotoSeoTitle(data, t) {
  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t);
  if (seoData && seoData.title) {
    return seoData.title;
  }

  var _data$category = data.category,
      category = _data$category === undefined ? '' : _data$category,
      _data$type = data.type,
      type = _data$type === undefined ? '' : _data$type,
      _data$make4 = data.make,
      make = _data$make4 === undefined ? '' : _data$make4,
      _data$model4 = data.model,
      model = _data$model4 === undefined ? '' : _data$model4,
      locationWhere = data.locationWhere,
      motoTitle = data.motoTitle,
      yearTitle = data.yearTitle;

  return [t('Купить'), motoTitle || category || type ? (motoTitle || (type && type.title ? type.title.toLowerCase() : '')) + ' ' + (category && category.title ? category.title.toLowerCase() : '') + ' ' : t('мототехнику'), make && make.title, model && model.title, '' + (yearTitle || '') + (locationWhere || t('в Украине')) + ':', t('б/у и новая мототехника на АвтоБазар™')].filter(function (i) {
    return !!i;
  }).join(' ');
};

var buildSearchCommercialSeoTitle = function buildSearchCommercialSeoTitle(params, t) {
  var data = params;

  var seoData = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder__["a" /* getSeoDataByParams */](data, t, 'commercial');
  if (seoData && seoData.title) {
    return seoData.title;
  }

  var isUkraine = ['Україні', 'Украине'].includes(data.cityTitle);
  if (!isUkraine) {
    data.cityTitle = t('в') + ' ' + t(data.cityTitle);
  } else data.cityTitle = '\u0432 ' + t('Украине');

  var transportTitle = data.transportTitle,
      transportNextTitle = data.transportNextTitle,
      make = data.make,
      model = data.model,
      isNew = data.isNew,
      transportType = data.transportType,
      transportCategoryTitle = data.transportCategoryTitle;


  if (transportType === 'avtobus' && transportCategoryTitle) {
    return t('Автобусы {transportCategoryTitle} б/у {cityTitle} купить на АвтоБазар™', data);
  }
  if (transportType === 'moto' && transportCategoryTitle) {
    return t('Мототехника б/у {cityTitle} купить на АвтоБазар™', data);
  }
  if (transportType === 'pritsepy' && transportCategoryTitle) {
    return t('{transportCategoryTitle} б/у и новые купить {cityTitle} на АвтоБазар™', data);
  }
  if (transportType === 'spetstehnika' && transportCategoryTitle) {
    return t('{transportCategoryTitle} - купить б/у и новую спецтехнику {cityTitle} на АвтоБазар™', data);
  }
  if (transportType === 'vodnyi-transport' && transportCategoryTitle) {
    return t('{transportCategoryTitle} - купить водный транспорт б/у и новый {cityTitle} на АвтоБазар™', data);
  }
  if (transportTitle && make && model && isNew) {
    return t('Новый {make} {model} {yearTitle}купить {cityTitle}: {makeTranslit} {modelTranslit} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }

  if (transportTitle && make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t('Купить новую {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить новую {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить новый {transportTitle} {make} {yearTitle}{cityTitle}: {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  if (transportTitle && make && model && !isNew) {
    return t('{make} {model} {yearTitle}купить {cityTitle}: б/у и новые {makeTranslit} {modelTranslit} на Автобазаре', data);
  }
  if (transportTitle && make && !model && !isNew) {
    if (transportType === 'spetstehnika') {
      return t('Купить {transportTitle} {make} {yearTitle}{cityTitle}: б/у и новый {reductionTranslit} {makeTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'avtobus') {
      return t('Автобусы {make} {makeTranslit} б/у {yearTitle}{cityTitle} купить на АвтоБазар™',
      // 'Купить новый {transportTitle} {yearTitle}{cityTitle}: {reductionTranslit} на Автобазаре',
      _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить {transportTitle} {make} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} {makeTranslit} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  if (transportTitle && !make && !model && isNew) {
    if (transportType === 'gruzovye') {
      return t('Купить новый {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} авто на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'avtobus') {
      return t('Купить новый {transportTitle} {yearTitle}{cityTitle}: {reductionTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить новую {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить новый {transportTitle} {yearTitle}{cityTitle}: {transportNextTitle} на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  if (transportTitle && !make && !model && !isNew) {
    if (transportTitle === t('коммерческий транспорт')) {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новая техника на Автобазар™', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle)
      }));
    }
    if (transportType === 'gruzovye') {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} авто на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'avtobus') {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новый {reductionTranslit} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    if (transportType === 'spetstehnika') {
      return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новая {transportNextTitle} на Автобазаре', _extends({}, data, {
        transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
        transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
      }));
    }
    return t('Купить {transportTitle} {yearTitle}{cityTitle}: б/у и новые {transportNextTitle} авто на Автобазаре', _extends({}, data, {
      transportTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportTitle),
      transportNextTitle: __WEBPACK_IMPORTED_MODULE_4_shared_modules__["m" /* replaceToLowerCase */](transportNextTitle)
    }));
  }
  return t('Купить {cityTitle}: б/у и новые авто на Автобазаре');
};
// CONCATENATED MODULE: ./src/shared/constants/seoTitles.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder_seoDataFinder__ = __webpack_require__(1252);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var getLocationString = function getLocationString(location, t) {
  return location && location.title ? t('в ') + ' ' + location.title : t('в Украине');
};

var buildAddTitleByTransportSlug = function buildAddTitleByTransportSlug(slug, t) {
  var transportTitle = 'авто';
  var transportSecondTitle = 'автомобиля';
  switch (slug) {
    case 'avto':
      {
        transportTitle = 'авто';
        transportSecondTitle = 'автомобиля';
        break;
      }
    case 'moto':
      {
        transportTitle = 'мототехнику';
        transportSecondTitle = 'мототехники';
        break;
      }
    case 'avtobus':
      {
        transportTitle = 'автобус';
        transportSecondTitle = 'автобуса';
        break;
      }
    case 'gruzovye':
      {
        transportTitle = 'грузовое авто';
        transportSecondTitle = 'грузового автомобиля';
        break;
      }
    case 'spetstehnika':
      {
        transportTitle = 'спецтехнику';
        transportSecondTitle = 'спецтехники';
        break;
      }
    case 'pritsepy':
      {
        transportTitle = 'прицеп';
        transportSecondTitle = 'прицепа';
        break;
      }
    case 'vodnyi-transport':
      {
        transportTitle = 'водный транспорт';
        transportSecondTitle = 'водного транспорта';
        break;
      }
    case 'zapchasti':
      {
        transportTitle = 'запчасти';
        transportSecondTitle = 'автозапчастей';
        break;
      }

    default:
      {
        break;
      }
  }

  return t('Продать') + ' ' + t(transportTitle).toLowerCase() + ' \u043D\u0430 \u0410\u0432\u0442\u043E\u0411\u0430\u0437\u0430\u0440\u2122 - ' + t('подать объявление о продаже') + ' ' + t(transportSecondTitle).toLowerCase() + ' \u043D\u0430 avtobazar.ua';
};

var TITLE = {
  HOME: function HOME(props, t) {
    return t('SEO_HOME_TITLE');
  },

  ADVERT: function ADVERT(_ref) {
    var id = _ref.id,
        make = _ref.make,
        model = _ref.model,
        modification = _ref.modification,
        year = _ref.year,
        price = _ref.price,
        mileage = _ref.mileage,
        location = _ref.location,
        _ref$isNew = _ref.isNew,
        isNew = _ref$isNew === undefined ? false : _ref$isNew,
        _ref$dealer = _ref.dealer,
        dealer = _ref$dealer === undefined ? false : _ref$dealer;
    var transportTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var t = arguments[2];

    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_seoTextFinder_seoDataFinder__["a" /* getCustomParams */]({ city: location.title }, t) || '',
        inCity = _ref2.inCity;

    var transportTitles = ['Мотоцикл', 'Скутер', 'Квадроцикл', 'Мопед', 'Баггі', 'Багги', 'Трицикл', 'Грузовые', 'Автобусы', 'Прицепы', 'Водный транспорт', 'Спецтехника'];

    if (transportTitles.includes(transportTitle)) {
      return [t('Купить'), t(transportTitle), make && make.title, model && model.title, modification && modification.title, year, '\u0432 ' + t(location.title), dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + (t('с пробегом') === 'с пробегом' ? 'тыс км' : 'тис км'), price && t('цена') + ' ' + price, t('на Автобазаре'), isNew && ' - ' + t('Новый').toLowerCase(), id && '(' + id + ')'].filter(function (i) {
        return !!i;
      }).join(' ');
    }

    return [t('Купить'), !isNew && transportTitle,
    /* transportNextTitle, */
    make && make.title, model && model.title, modification && modification.title, year, inCity, isNew && dealer && dealer.title && t('в автосалоне') + ' ' + dealer.title, mileage && t('с пробегом') + ' ' + t(mileage).slice(0, -7) + ' ' + t('тыс км'), price && t('цена') + ' ' + price, id && '(' + id + ')', t('- Автобазар')].filter(function (i) {
      return !!i;
    }).join(' ');
  },
  // ...

  SPARE_ADVERT: function SPARE_ADVERT(_ref3, t) {
    var id = _ref3.id,
        rubric = _ref3.rubric,
        sparetype = _ref3.sparetype,
        type = _ref3.type,
        make = _ref3.make,
        model = _ref3.model,
        price = _ref3.price,
        location = _ref3.location;
    return [t('Купить'), rubric && rubric.title, sparetype && (sparetype.title || '').toLowerCase(), (type || make || model) && t('на'), type && (type.title || '').toLowerCase(), make && make.title, model && model.title, getLocationString(location, t), price && t('цена') + ' ' + price, t('на Автобазаре'), id && '- ' + id].filter(function (i) {
      return !!i;
    }).join(' ');
  },
  //

  SEARCH: {
    avto: function avto(data, t) {
      return buildSearchAvtoSeoTitle(data, t);
    },
    moto: function moto(data, t) {
      return buildSearchMotoSeoTitle(data, t);
    },
    mototsikl: function mototsikl(_ref4, t) {
      var _ref4$make = _ref4.make,
          make = _ref4$make === undefined ? '' : _ref4$make,
          _ref4$model = _ref4.model,
          model = _ref4$model === undefined ? '' : _ref4$model,
          category = _ref4.category,
          type = _ref4.type,
          location = _ref4.location,
          motoTitle = _ref4.motoTitle,
          yearTitle = _ref4.yearTitle;
      return [t('Купить')].concat(_toConsumableArray(make ? [motoTitle || t('мотоцикл'), make && make.title, model && model.title] : ['' + (type && type.title ? type.title.toLowerCase() : '')]), [category && category.title ? category.title.toLowerCase() : '', '' + yearTitle + (location || t('в Украине')) + ':', t('б/у и новая мототехника на АвтоБазар™')]).filter(function (i) {
        return !!i;
      }).join(' ');
    },
    commercial: function commercial(params, t) {
      return buildSearchCommercialSeoTitle(params, t);
    }
  },
  //

  SPARE_PARTS: function SPARE_PARTS(data, rubricSlug, t) {
    return buildSparePartsSeoTitles(data, rubricSlug, t);
  },

  FIRM: function FIRM(data, t) {
    return buildFirmsSeoTitle(data, t);
  },

  FIRM_PAGE: function FIRM_PAGE(title, tab, t, car_drive_countries, tags) {
    return buildFirmPageSeoTitle(title, tab, t, car_drive_countries, tags);
  },

  //

  DEALERS: function DEALERS(data, slug, t) {
    return buildDealersSeoTitle(data, slug, t);
  },

  DEALER_PAGE: {
    ADVERTS: function ADVERTS() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return dealer + ' - ' + t('все предложения автосалона с ценами и фото на сайте Автобазар');
    },

    NEWS: function NEWS() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Новости и акции автосалона') + ' ' + dealer + ' ' + t('на сайте Автобазар');
    },

    ABOUT: function ABOUT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Информация об автосалоне') + ' ' + dealer + ': ' + t('все о компании на АвтоБазаре');
    },

    CONTACT: function CONTACT() {
      var dealer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var t = arguments[1];
      return t('Контакты автосалона') + ' ' + dealer + ': ' + t('адреса, контактный номер телефона, официальный сайт');
    }
  },

  //

  INVOICE: function INVOICE(t) {
    return t('Квитанция за оплату');
  },

  //

  JOURNAL: {
    ALL: function ALL(t) {
      return t('Все новости и статьи на Автобазар');
    },
    NEWS: function NEWS(t, rubric) {
      return t('Все') + ' ' + t(rubric || 'Новости').toLowerCase() + ' ' + t('на Автобазаре');
    }
  },

  //

  SERVICE: {
    CAR_COST_ESTIMATE: function CAR_COST_ESTIMATE(t) {
      return t('Оценка стоимости авто') + ' ' + t('на Автобазаре');
    },
    CAR_DRIVE: function CAR_DRIVE(t) {
      return t('Пригон авто') + ' ' + t('на Автобазаре');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поиск') + ' ' + t('на Автобазаре');
    }
  },

  //

  LOGIN: function LOGIN(t) {
    return t('Войти в Автобазар');
  },

  //

  NOT_FOUND: function NOT_FOUND(t) {
    return t('Страница не найдена');
  },

  //

  ADVERT_FORM: {
    ADD: function ADD(slug, t) {
      return buildAddTitleByTransportSlug(slug, t);
    },
    EDIT: function EDIT(t) {
      return t('Редактировать объявление');
    }
  },

  //

  PROFILE: {
    PROFILE: function PROFILE(t) {
      return t('Мой профиль');
    },
    DIALOGS: function DIALOGS(t) {
      return t('Мои сообщения');
    },
    FAVORITES: function FAVORITES(t) {
      return t('Мои избранные');
    },
    BILLING: function BILLING(t) {
      return t('Мой баланс');
    },
    SEARCHES: function SEARCHES(t) {
      return t('Мои поиски');
    },
    ADVERTS: function ADVERTS(t) {
      return t('Мои объявления');
    },
    INSURANCE: function INSURANCE(t) {
      return t('Страховка');
    },
    SEARCH_SUBSCRIPTIONS: function SEARCH_SUBSCRIPTIONS(t) {
      return t('Подписка на поиск');
    }
  },

  //

  MOBILE_FORM: {
    GEO: function GEO(t) {
      return t('Выбор местоположения');
    },
    FILTERS: function FILTERS(t) {
      return t('Выбор по параметрам');
    }
  },

  STATIC_PAGE: {
    LAW: function LAW(t) {
      return t('Справка Автобазар:') + ' ' + t('Политика конфиденциальности');
    },
    INFO_ZAPCHASTI: function INFO_ZAPCHASTI(t) {
      return t('Справка Автобазар:') + ' ' + t('Запчасти');
    },
    HELP: function HELP(t) {
      return t('Справка Автобазар:') + ' ' + t('Помощь');
    },
    FOR_SERVICES: function FOR_SERVICES(t) {
      return t('Справка Автобазар:') + ' ' + t('Автосервисам');
    },
    FOR_PRIVATES: function FOR_PRIVATES(t) {
      return t('Справка Автобазар:') + ' ' + t('Размещение объявлений');
    },
    FOR_DEALERS: function FOR_DEALERS(t) {
      return t('Справка Автобазар:') + ' ' + t('Пакет “Бизнес Плюс”');
    },
    BIZNES_PAKET: function BIZNES_PAKET(t) {
      return t('Справка Автобазар:') + ' ' + t('Пакет “Бизнес”');
    },
    ADVERTISING: function ADVERTISING(t) {
      return t('Справка Автобазар:') + ' ' + t('Разместить рекламу');
    },
    ABOUT: function ABOUT(t) {
      return t('Справка Автобазар:') + ' ' + t('Что такое автобазар');
    },
    FAQ: function FAQ(t) {
      return t('Справка Автобазар:') + ' ' + t('Часто задаваемые вопросы');
    },
    ENTRANCE: function ENTRANCE(t) {
      return t('Справка Автобазар:') + ' ' + t('Регистрация на avtobazar.ua');
    },
    TRANSPORT_ADS_RULES: function TRANSPORT_ADS_RULES(t) {
      return t('Справка Автобазар:') + ' ' + t('Правила составления объявлений');
    },
    PUBLIC_CONTRACT: function PUBLIC_CONTRACT(t) {
      return t('Справка Автобазар:') + ' ' + t('Публичный договор');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TITLE);

/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import PropTypes from 'prop-types';

// import { setRatio } from 'shared/actions/globals';


var setRatioImage = function setRatioImage(image, ratio, width, height) {
  var fit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'cover';

  if (!image) {
    return image;
  }

  var aS3Regexp = /^(https:\/\/a[\d].s3.ua)/;
  var cndRegexp = /^(https:\/\/cdn.+(ab|s3).ua)/;
  var awsWithoutIRHRegexp = /^((https:\/\/d2wkv3iadoqiil.cloudfront.net\/)(\w*\/)?(\w*\/)?(.{32})(\..*)?)/;
  var awsWithIRHRegexp = /^((https:\/\/d1672trkrgk4ug.cloudfront.net\/)(.*))/;
  var dimensions = [width, height].map(function (x) {
    return x ? Math.round(x * ratio) : '';
  }).join('x');
  var httpsImage = image.replace('http:', 'https:');

  if (width || height) {
    if (httpsImage.match(cndRegexp)) {
      return httpsImage.replace('/image/', '/unsafe/' + dimensions + '/');
    }

    if (httpsImage.match(aS3Regexp)) {
      return httpsImage.replace(aS3Regexp, '$1/' + dimensions);
    }

    if (httpsImage.match(awsWithoutIRHRegexp)) {
      var groups = httpsImage.match(awsWithoutIRHRegexp);
      var size = 'large';
      if (width) {
        if (width * ratio <= 600) {
          size = 'small';
        } else if (width * ratio <= 900) {
          size = 'medium';
        }
      }

      var root = groups[3] && groups[3] === 'original/' ? '' : groups[3];
      return '' + (groups[2] + (root || '')) + size + '/' + (groups[5] + (groups[6] || ''));
    }

    if (httpsImage.match(awsWithIRHRegexp)) {
      var _groups = httpsImage.match(awsWithIRHRegexp);
      var imageRequest = JSON.stringify({
        key: '' + _groups[3],
        edits: {
          resize: {
            width: width ? Math.round(width * ratio) : null,
            height: height ? Math.round(height * ratio) : null,
            fit: fit
          }
        }
      });

      return '' + _groups[2] + Buffer.from(imageRequest).toString('base64');
    }
  }

  return httpsImage;
};

/*
const mapStateToProps = ({ globals }) => ({ ratio: globals.ratio });
const mapDispatchToProps = { setRatio };
*/
var mapStateToProps = function mapStateToProps() {
  return {};
};
var mapDispatchToProps = {};

// TODO: Commented code can be removed after testing, and be sure this code do not have some side effects.

var withPixelRatio = function withPixelRatio(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.setRatioImage = function (image) {
        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 240;
        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var fit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cover';
        return setRatioImage(image, 1, width, height, fit);
      }, _this.setRatioAlbum = function (images, width, height) {
        return images.map(function (_ref2) {
          var image = _ref2.image,
              rest = _objectWithoutProperties(_ref2, ['image']);

          return _extends({}, rest, {
            image: _this.setRatioImage(image, width, height)
          });
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /*
    static propTypes = {
      // setRatio: PropTypes.func.isRequired,
      ratio: PropTypes.number,
    };
    static defaultProps = {
      ratio: null,
    }; */

    /*
    componentDidMount() {
      if (!this.props.ratio) {
        this.props.setRatio();
      }
    }
    */

    /*
    setRatioImage = (image, width = 240, height = null) =>
      setRatioImage(image, this.props.ratio, width, height);
    */


    _createClass(_class, [{
      key: 'render',
      value: function render() {
        // const { ratio, ...props } = this.props;
        var ratio = 1;

        var props = _objectWithoutProperties(this.props, []);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
          setRatioAlbum: this.setRatioAlbum,
          setRatioImage: this.setRatioImage,
          ratio: ratio
        }, props));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withPixelRatio(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2));
};

/* harmony default export */ __webpack_exports__["a"] = (withPixelRatio);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(492).Buffer))

/***/ }),

/***/ 1392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getVehicleMicroMarkingJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductMicroMarkingJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBreadcrumbsListData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isVIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDrivenFromTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_countries_json__);




var AB_PATH = 'https://avtobazar.ua';

var getVehicleMicroMarkingJson = function getVehicleMicroMarkingJson(advertInfo) {
  var title = advertInfo.title,
      make = advertInfo.make,
      year = advertInfo.year,
      model = advertInfo.model,
      permalink = advertInfo.permalink,
      body = advertInfo.body,
      price = advertInfo.price,
      description = advertInfo.description,
      color = advertInfo.color,
      engine = advertInfo.engine,
      gearbox = advertInfo.gearbox,
      mileage = advertInfo.mileage,
      active = advertInfo.active,
      sold = advertInfo.sold,
      transport = advertInfo.transport;


  var discontinued = active === -2 || !active;
  var availabilityKey = 'InStock';

  if (sold) availabilityKey = 'SoldOut';else if (discontinued) availabilityKey = 'Discontinued';

  var _model$model_class = model.model_class,
      modelClass = _model$model_class === undefined ? null : _model$model_class;

  var modelTitle = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](model) + ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](modelClass);
  var usdPrice = price.find(function (item) {
    return item.currency === 'usd';
  }).value || '';

  var MAIN_TYPES = {
    avto: 'Car',
    mototsikl: 'Motorcycle',
    moped: 'MotorizedBicycle',
    skuter: 'MotorizedBicycle'
  };

  return {
    '@context': 'https://schema.org/',
    '@type': MAIN_TYPES[transport.slug] || 'Vehicle',
    name: title,
    model: modelTitle,
    productionDate: year,
    description: description,
    color: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](color),
    fuelType: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](engine),
    vehicleTransmission: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](gearbox),
    bodyType: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](body),
    mileageFromOdometer: {
      '@type': 'QuantitativeValue',
      value: mileage && mileage + ' 000'
    },
    brand: {
      '@type': 'Brand',
      name: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](make)
    },
    offers: {
      '@type': 'Offer',
      name: title,
      url: '' + AB_PATH + permalink,
      priceCurrency: 'USD',
      price: usdPrice,
      availability: 'http://schema.org/' + availabilityKey
    }
  };
};

var getProductMicroMarkingJson = function getProductMicroMarkingJson(advertInfo) {
  var make = advertInfo.make,
      model = advertInfo.model,
      permalink = advertInfo.permalink,
      price = advertInfo.price,
      title = advertInfo.title;
  var _model$model_class2 = model.model_class,
      modelClass = _model$model_class2 === undefined ? null : _model$model_class2;


  var modelTitle = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](model) + ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](modelClass);
  var usdPrice = price.find(function (item) {
    return item.currency === 'usd';
  }).value || '';

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: modelTitle.replace(/\s/g, '') ? modelTitle : title,
    description: '',
    brand: {
      '@type': 'Thing',
      name: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](make)
    },
    offers: {
      '@type': 'Offer',
      url: '' + AB_PATH + permalink,
      priceCurrency: 'USD',
      price: usdPrice
    }
  };
};

var getBreadcrumbsListData = function getBreadcrumbsListData(searchData, breadcrumbLinks) {
  var paramArr = ['transport', 'make', 'model', 'year', 'location'];

  var breadcrumbItemListEl = paramArr.map(function (itemName, index) {
    if (breadcrumbLinks[itemName]) {
      var name = itemName === 'year' ? searchData[itemName] : searchData[itemName].title;
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': breadcrumbLinks[itemName],
          name: index === 0 ? __WEBPACK_IMPORTED_MODULE_0_shared_modules__["n" /* replaceToUpperCase */](name) : name
        }
      };
    }
    return false;
  });

  return {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItemListEl
  };
};

var getPrice = function getPrice(prices) {
  var currenncy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['uah', 'uah', 'грн', 'грн.'];

  var price = (Array.isArray(prices) && prices || []).find(function (p) {
    return currenncy.includes(p.currency);
  });
  return price && price.value;
};

var isTop = function isTop(advert) {
  return advert && advert.top_date && new Date() < new Date(advert.top_date);
};
var isVIP = function isVIP(advert) {
  return advert && advert.vip_date && new Date() < new Date(advert.vip_date);
};

var getDrivenFromTitle = function getDrivenFromTitle(drivenFrom, t) {
  var drivenFromCoutry = null;
  if (drivenFrom && drivenFrom.id) drivenFromCoutry = __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_countries_json___default.a.find(function (country) {
    return country.id === drivenFrom.id;
  });

  return drivenFromCoutry && t('пригнан') + ' ' + drivenFromCoutry.from[t('locale')];
};

/***/ }),

/***/ 1394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addBitrixLead */
/* unused harmony export addFinupLead */
/* unused harmony export addAFinanceLead */
/* unused harmony export fetchFinupVerification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isLeasingProposalAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isCreditmarketProposalAvailable; });
/* unused harmony export isAutoMoneyProposalAvailable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isCreditmarketNotClearedProposalAvailable; });
/* unused harmony export isMicroCreditProposalAvailable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isUlf24LeasingProposalAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isUlfSomeDealersLeasingProposalAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCommonLeasingProposalAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFinupVerification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchRequestId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return sendCodeVerification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return prepareParamsForLeasingLeadRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createMyAutoLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAFinanceLeda; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createAutoMoneyLead; });
/* unused harmony export getRate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_advertForm__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1277);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








// import { fetchUsersTemperature } from './finup';

// TODO: Should be removed;
var addBitrixLead = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(props, fetch) {
    var userStorageId, title, userName, permalink, make, model, year, capacity, engine, gearbox, price, term, phone, isMobile, popularity, liquidityDays, comment, temperature, recommendedPrice, bkiApproved, prepaid, isBkiApproved, commentWithAddData, crmData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            userStorageId = props.userStorageId, title = props.title, userName = props.userName, permalink = props.permalink, make = props.make, model = props.model, year = props.year, capacity = props.capacity, engine = props.engine, gearbox = props.gearbox, price = props.price, term = props.term, phone = props.phone, isMobile = props.isMobile, popularity = props.popularity, liquidityDays = props.liquidityDays, comment = props.comment, temperature = props.temperature, recommendedPrice = props.recommendedPrice, bkiApproved = props.bkiApproved, prepaid = props.prepaid;
            isBkiApproved = '';

            if (typeof bkiApproved === 'boolean') {
              isBkiApproved = bkiApproved ? 'Одобрено' : 'Не Одобрено';
            }
            commentWithAddData = [comment, 'https://api.finup.lv/view/profile/' + userStorageId].join('\n');
            crmData = {
              FIELDS: {
                ID_EXTERNAL: userStorageId,
                TITLE: title,
                NAME: userName, // Имя пользо`вателя:
                LAST_NAME: '',
                UF_CRM_1627546218: userStorageId, // device id
                UF_CRM_1614238143: '', // Название финансового продукта:
                UF_CRM_1614238195: make.title, // Марка: Renault (вынести в заголовок)
                UF_CRM_1614238206: model.title, // Модель: Logan (вынести в заголовок)
                UF_CRM_1614238220: year, // Год: 2018 (вынести в заголовок)
                UF_CRM_1614238276: capacity, // Объём двигателя: 1.6 ERROR Значение поля "Объём двигателя" должно быть числом
                UF_CRM_1614238356: engine && engine.title || '-', // Топливо: бензин (метан)
                UF_CRM_1614238365: gearbox && gearbox.title || '-', // КПП: механика
                OPPORTUNITY: price, // Сумма финансирования: 5950 usd
                UF_CRM_1614238293: term || 0, //  Срок финансирования: 36
                PHONE: [{ VALUE: phone, VALUE_TYPE: 'WORK' }], // Номер телефона пользователя: +375298335599
                SOURCE_DESCRIPTION: isMobile ? 'мобильная версия' : 'десктопная версия', // Источник: мобильная версияUF_CRM_1614238143
                COMMENTS: '<a href="https://avtobazar.ua' + permalink + '" > avtobazar.ua' + permalink + '</a>', // URL объявления, с которого отправлена заявка: https://cars.av.by/renault/logan/100203304
                UF_CRM_1614238619: '',
                UF_CRM_1614238771: '',
                UF_CRM_1614238633: '',
                UF_CRM_1614238795: '',
                CURRENCY_ID: 'USD',
                UF_CRM_1624343369: temperature || 0, //  темперетура, тип: число
                UF_CRM_1624957919: popularity || 0, // Популярность  double - popularity
                UF_CRM_1624957948: liquidityDays || 0, // Ликвидность (дней) double
                UF_CRM_1624958095: recommendedPrice || 0, // Оптимальная цена по модели  money  - recommendedPrice
                UF_CRM_1624559672749: isBkiApproved, // / Результат скоринга
                UF_CRM_1626182545: prepaid, // / Рекомендованный аванс %
                UF_CRM_1624958123: commentWithAddData // Комментарий string - comment
                // UF_CRM_1624957985: 'test', // Падение цены в следующие 12 месяцев, (%)  double   - deflation
                // UF_CRM_1624958019: 'test', // Отклонение от рыночной цены. (%)  double   - marketPriceDeviation
                // UF_CRM_1624958062: 'test', // Медиана по рынку  money  - medianPrice
              }
            };
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.ADD_BITRIX_LEAD, crmData, fetch, {}, 'addlead'));

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function addBitrixLead(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// "annualRate": 0,
// "bkiRequestId": "string",
// "comment": "string",
// "currency": "USD",
// "deviceId": "string",
// "email": "string",
// "fullName": "string",
// "localId": "string",
// "phone": "string",
// "prepaid": 0,
// "sum": 0,
// "term": 0,
// "verificationId": "string"

// accepted: true
// additional: {showLeasingForm: true}
// annualRate: 40
// comment: ""
// currency: "USD"
// dailyPayment: 12.11
// id: "0c777818-659b-4f88-abc4-5de8809ffd2e"
// liquidityDays: 12
// maxPrepaid: 50
// maxTerm: 84
// minPrepaid: 43
// minTerm: 84
// monthlyPayment: 363.22
// popularity: 0.97
// prepaid: 43
// prepaidCommission: 895
// prepaidSum: 8592
// pricePrediction: {0: {price: 14627, max: 17900, min: 11900}, 1: {price: 12854, max: 16400, min: 10500},…}
// shapResponse: null
// sum: 17900
// term: 84

var addFinupLead = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params, verifyParams, fetch) {
    var userName, permalink, price, phone, crmData;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // const { userStorageId, userName, permalink, price, term, phone, prepaid, localId } = params;
            userName = params.userName, permalink = params.permalink, price = params.price, phone = params.phone;
            crmData = {
              // "annualRate": 0,
              // "bkiRequestId": "string",
              // comment: `<a href="https://ab.ua${permalink}" > ab.ua${permalink}</a>`,
              // // currency: "USD",
              // deviceId: userStorageId,
              // // "email": "string",
              // fullName: userName,
              // localId,
              // phone,
              // prepaid,
              // sum: price,
              // term,
              // verificationId: verifyParams.id,

              date: new Date(),
              name: userName,
              phone: phone,
              price: price,
              currency: 'USD',
              comments: '',
              link: 'https://ab.ua' + permalink
            };
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.ADD_FINUP_LEAD, crmData, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function addFinupLead(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var addAFinanceLead = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params, fetch) {
    var userName, permalink, price, term, phone, prepaid, localId, crmData;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            userName = params.userName, permalink = params.permalink, price = params.price, term = params.term, phone = params.phone, prepaid = params.prepaid, localId = params.localId;
            crmData = {
              comment: params.title,
              fullName: userName,
              link: 'http://avtobazar.ua' + permalink,
              localId: localId,
              phone: phone,
              prepaid: prepaid,
              sum: price,
              term: term
            };
            return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.ADD_AFINANCE_LEAD, crmData, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function addAFinanceLead(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var addAutoMoneyLead = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params, fetch) {
    var userName, permalink, price, term, phone, prepaid, localId, crmData;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            userName = params.userName, permalink = params.permalink, price = params.price, term = params.term, phone = params.phone, prepaid = params.prepaid, localId = params.localId;
            crmData = {
              comment: params.title,
              fullName: userName,
              link: 'http://avtobazar.ua' + permalink,
              localId: localId,
              phone: phone,
              prepaid: prepaid,
              sum: price,
              term: term
            };
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.ADD_AUTOMONEY_LEAD, crmData, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function addAutoMoneyLead(_x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Finup /v1/verification
  * @param {Object} paramCar  {
    "brand": "string",
    "description": "string",
    "engineType": "D",
    "engineVolumeMl": 0,
    "features": [
      "ABS"
    ],
    "generation": "string",
    "mileageKm": 0,
    "model": "string",
    "transmission": "A",
    "year": 0
  }
 * @param {Object} paramOptions { "currency": "USD",  "sum": 0,  "url": "string" }
 * @param {Function} fetch 
 */
var fetchFinupVerification = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(paramCar, paramOptions, fetch) {
    var car, options, body;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            car = _extends({
              brand: '',
              description: '',
              engineType: '',
              engineVolumeMl: 0,
              features: [],
              generation: '',
              mileageKm: 0,
              model: '',
              transmission: '',
              year: 0
            }, paramCar);
            options = _extends({
              currency: 'USD',
              sum: 0,
              url: ''
            }, paramOptions);
            body = _extends({}, options, {
              car: car
            });
            return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.GET_PARAMS, body, fetch, {}, 'verification'));

          case 4:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function fetchFinupVerification(_x10, _x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Checks is it advert available for leasing.
 * @param {Object} advertData
 * @returns {Boolean}
 */
var isLeasingProposalAvailable = function isLeasingProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      price = advertData.price,
      year = advertData.year,
      isNotCleared = advertData.is_not_cleared,
      isNew = advertData.is_new;


  if (__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* getLeasingParms */](advertData)) return true;

  var isAvto = (transport || category || {}).slug === 'avto';
  var usd = price.find(function (p) {
    return p.currency === 'usd';
  }) || {};
  var isAvailable = active === 1 && isAvto && !isNew && isNotCleared === false && usd.value >= 3000 && year >= 2001;
  return isAvailable;
};

var isCreditmarketProposalAvailable = function isCreditmarketProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      price = advertData.price,
      isNotCleared = advertData.is_not_cleared;


  var isAvto = (transport || category || {}).slug === 'avto';
  var usd = price.find(function (p) {
    return p.currency === 'usd';
  }) || {};
  var isAvailable = active === 1 && isAvto && isNotCleared === false && usd.value < 3000;
  return isAvailable;
};

var isAutoMoneyProposalAvailable = function isAutoMoneyProposalAvailable(advertData) {
  var available = isLeasingProposalAvailable(advertData);
  if (!available) return false;

  var disabledRegions = ['odeska-oblast', 'mykolaivska-oblast', 'cherkaska-oblast', 'sumska-oblast', 'zaporizka-oblast', 'kharkivska-oblast', 'luhanska-oblast', 'donetska-oblast'];

  var disabledCities = ['odessa'];

  if (advertData.location && advertData.location.slug && disabledCities.includes(advertData.location.slug)) {
    return false;
  }

  if (advertData.location && Array.isArray(advertData.location.parents)) {
    var inDisabledRegion = advertData.location.parents.find(function (region) {
      return region && region.slug && disabledRegions.includes(region.slug);
    });
    return !inDisabledRegion;
  }
  return available;
};

var isCreditmarketNotClearedProposalAvailable = function isCreditmarketNotClearedProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      isNotCleared = advertData.is_not_cleared;


  var isAvto = (transport || category || {}).slug === 'avto';
  var isAvailable = active === 1 && isAvto && isNotCleared === true;
  return isAvailable;
};

var isMicroCreditProposalAvailable = function isMicroCreditProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      price = advertData.price,
      isNotCleared = advertData.is_not_cleared;


  var isAvto = (transport || category || {}).slug === 'avto';
  var usd = price.find(function (p) {
    return p.currency === 'usd';
  }) || {};
  var isAvailable = active === 1 && isAvto && isNotCleared === false && usd.value < 3000;
  return isAvailable;
};

var isUlf24LeasingProposalAvailable = function isUlf24LeasingProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      isNotCleared = advertData.is_not_cleared,
      isNew = advertData.is_new;


  var isAvto = (transport || category || {}).slug === 'avto';
  var isAvailable = active === 1 && isAvto && isNotCleared === false && isNew;
  return isAvailable;
};

var isUlfSomeDealersLeasingProposalAvailable = function isUlfSomeDealersLeasingProposalAvailable(advertData) {
  // const available = isLeasingProposalAvailable(advertData);
  // if (!available) return false;
  var availableDealers = ['kij-avto-nissan', 'kij-avto-renault'];
  var slug = advertData && advertData.agency && advertData.agency.slug || '';
  return availableDealers.includes(slug);
};

var isCommonLeasingProposalAvailable = function isCommonLeasingProposalAvailable(advertData) {
  var agency = advertData.agency;
  // TODO: should be change to some flag from Admin area.

  if (agency && agency.slug === '1-j-avtocentr-skoda') return false;
  return true;
};

var getFinupVerification = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(adv, fetch) {
    var lp, _getLeasingArgumentsB, params, options, reult;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(!adv || !adv.modification)) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt('return', {});

          case 2:
            lp = __WEBPACK_IMPORTED_MODULE_4__utils__["g" /* getLeasingParms */](adv);

            if (!lp) {
              _context6.next = 5;
              break;
            }

            return _context6.abrupt('return', lp);

          case 5:
            _getLeasingArgumentsB = __WEBPACK_IMPORTED_MODULE_4__utils__["f" /* getLeasingArgumentsByAdv */](adv), params = _getLeasingArgumentsB.params, options = _getLeasingArgumentsB.options;
            _context6.next = 8;
            return fetchFinupVerification(params, options, fetch);

          case 8:
            reult = _context6.sent;
            return _context6.abrupt('return', reult);

          case 10:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function getFinupVerification(_x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();

var fetchRequestId = function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(params, fetch) {
    var body;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            body = {
              bdate: __WEBPACK_IMPORTED_MODULE_3_shared_helpers_locale__["c" /* getFormattedDateFns */](params.birthday, 'yyyy-MM-dd'),
              deviceId: __WEBPACK_IMPORTED_MODULE_4__utils__["e" /* getCleanDeviceId */](params.deviceId),
              phone: (params.phone || '').replace(/\s/g, '')
            };
            return _context7.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.REQUEST_ID, body, fetch, {}, ''));

          case 2:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function fetchRequestId(_x15, _x16) {
    return _ref7.apply(this, arguments);
  };
}();

var sendCodeVerification = function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(params, fetch) {
    var body;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            body = params || {
              otp: params.otp,
              requestId: params.requestId
            };
            return _context8.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.SCORING, body, fetch, {}, ''));

          case 2:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function sendCodeVerification(_x17, _x18) {
    return _ref8.apply(this, arguments);
  };
}();

var prepareParamsForLeasingLeadRequest = function prepareParamsForLeasingLeadRequest(params, advert, leasingParams, moreLeasingParams) {
  var phone = params.phone,
      userName = params.userName;

  var _leasingParams$moreLe = _extends({}, leasingParams, moreLeasingParams),
      term = _leasingParams$moreLe.term,
      popularity = _leasingParams$moreLe.popularity,
      liquidityDays = _leasingParams$moreLe.liquidityDays,
      comment = _leasingParams$moreLe.comment,
      pricePrediction = _leasingParams$moreLe.pricePrediction,
      prepaid = _leasingParams$moreLe.prepaid,
      bkiApproved = _leasingParams$moreLe.bkiApproved;

  var decimalLength = 2;
  var intLength = 1;

  var make = advert.make,
      model = advert.model,
      title = advert.title,
      year = advert.year,
      permalink = advert.permalink,
      price = advert.price,
      vehregCapacity = advert.vehreg_info.capacity,
      characterCapacity = advert.characteristics.capacity,
      simpleCapacity = advert.capacity;


  var userStorageId = localStorage.getItem('applensDeviceId') || '';
  var engine = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('engine', advert);
  var gearbox = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('gearbox', advert);
  var capacity = characterCapacity && characterCapacity.title || simpleCapacity || __WEBPACK_IMPORTED_MODULE_2_shared_helpers_advertForm__["k" /* parseDecimal */](vehregCapacity / 1000, intLength, decimalLength);
  var usaPrice = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["n" /* getPriceValueBySlug */](price, 'usd');
  var recommendedPrice = pricePrediction && pricePrediction[0] && pricePrediction[0].price;

  return {
    userStorageId: userStorageId,
    title: title,
    userName: userName,
    permalink: permalink,
    make: make,
    model: model,
    year: year,
    capacity: capacity,
    engine: engine,
    gearbox: gearbox,
    price: usaPrice,
    term: term,
    phone: phone,
    isMobile: "desktop" === 'mobile',
    popularity: popularity,
    liquidityDays: liquidityDays,
    comment: comment,
    recommendedPrice: recommendedPrice,
    prepaid: prepaid,
    bkiApproved: bkiApproved
  };
};

var createMyAutoLead = function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(params, advert, fetch) {
    var result, verifyParams, finupParams;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            result = null;
            _context9.prev = 1;
            _context9.next = 4;
            return getFinupVerification(advert, fetch);

          case 4:
            verifyParams = _context9.sent;
            finupParams = _extends({}, params, { localId: advert.id });
            _context9.next = 8;
            return addFinupLead(finupParams, verifyParams, fetch);

          case 8:
            result = _context9.sent;

            if (!(!result || !result.id)) {
              _context9.next = 11;
              break;
            }

            throw Error('getFinupVerification error');

          case 11:
            _context9.next = 15;
            break;

          case 13:
            _context9.prev = 13;
            _context9.t0 = _context9['catch'](1);

          case 15:
            return _context9.abrupt('return', result);

          case 16:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this, [[1, 13]]);
  }));

  return function createMyAutoLead(_x19, _x20, _x21) {
    return _ref9.apply(this, arguments);
  };
}();

var createAFinanceLeda = function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(params, advert, fetch) {
    var result, finupParams;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            result = null;
            _context10.prev = 1;
            finupParams = _extends({}, params, { localId: advert.id });
            _context10.next = 5;
            return addAFinanceLead(finupParams, fetch);

          case 5:
            result = _context10.sent;

            if (!(!result || !result.id)) {
              _context10.next = 8;
              break;
            }

            throw Error('getFinupVerification error');

          case 8:
            _context10.next = 12;
            break;

          case 10:
            _context10.prev = 10;
            _context10.t0 = _context10['catch'](1);

          case 12:
            return _context10.abrupt('return', result);

          case 13:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this, [[1, 10]]);
  }));

  return function createAFinanceLeda(_x22, _x23, _x24) {
    return _ref10.apply(this, arguments);
  };
}();

var createAutoMoneyLead = function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(params, advert, fetch) {
    var result, finupParams;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            result = null;
            _context11.prev = 1;
            finupParams = _extends({}, params, { localId: advert.id });
            _context11.next = 5;
            return addAutoMoneyLead(finupParams, fetch);

          case 5:
            result = _context11.sent;

            if (!(!result || !result.id)) {
              _context11.next = 8;
              break;
            }

            throw Error('addAutoMoneyLead error');

          case 8:
            _context11.next = 12;
            break;

          case 10:
            _context11.prev = 10;
            _context11.t0 = _context11['catch'](1);

          case 12:
            return _context11.abrupt('return', result);

          case 13:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this, [[1, 10]]);
  }));

  return function createAutoMoneyLead(_x25, _x26, _x27) {
    return _ref11.apply(this, arguments);
  };
}();

var getRate = function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(params, fetch) {
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.GET_RATE, params, fetch, {}, 'rate'));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this);
  }));

  return function getRate(_x28, _x29) {
    return _ref12.apply(this, arguments);
  };
}();

/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1554);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingOnlineBanner.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingOnlineBanner.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/Icons/ExchangeIcon.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, _jsx("path", {
  d: "M2.06917 13.2835C1.19201 11.1658 1.19196 8.83324 2.06917 6.71555C2.80615 4.93637 4.08826 3.48803 5.73515 2.55018V6.09019H7.15107V0.709961H1.77079V2.12587H3.8359C0.390508 4.82385 -0.993499 9.58957 0.761005 13.8253C1.42965 15.4396 2.5106 16.8534 3.88706 17.9142C5.22151 18.9426 6.80728 19.6228 8.47282 19.8812L8.68997 18.482C5.70037 18.0181 3.22535 16.0747 2.06917 13.2835Z",
  fill: "#FFC107"
}), _jsx("path", {
  d: "M19.2337 13.8257C20.2555 11.3586 20.2555 8.64115 19.2337 6.17407C18.565 4.55983 17.4841 3.14595 16.1076 2.08524C14.7731 1.05682 13.1873 0.376615 11.5218 0.118164L11.3047 1.51737C14.2942 1.98127 16.7693 3.92466 17.9254 6.71594C18.8026 8.83362 18.8026 11.1662 17.9254 13.2838C17.1885 15.063 15.9064 16.5114 14.2595 17.4492V13.9092H12.8436V19.2894H18.2238V17.8735H16.1649C17.5078 16.8249 18.5639 15.4425 19.2337 13.8257Z",
  fill: "#FFC107"
}));

var ExchangeIcon = function ExchangeIcon() {
  return _ref;
};

/* harmony default export */ var ExchangeIcon_defaultExport = (ExchangeIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/IncomminCallIcon.js
/* harmony import */ var IncomminCallIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var IncomminCallIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(IncomminCallIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var IncomminCallIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var IncomminCallIcon__ref = IncomminCallIcon__jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, IncomminCallIcon__jsx("g", {}, void 0, IncomminCallIcon__jsx("path", {
  d: "M17.2248 15.2125C17.2247 15.2125 17.2247 15.2125 17.2248 15.2125L14.1958 13.222C13.4747 12.7482 12.5387 12.7894 11.8665 13.3242C11.2777 13.7928 10.4326 13.7449 9.90057 13.2128L6.82514 10.1374C6.29321 9.60545 6.2453 8.76026 6.71375 8.17158C7.24872 7.49927 7.28977 6.56314 6.81598 5.84215L4.82546 2.81311C4.47741 2.28347 3.93755 1.96654 3.30522 1.92061C2.67289 1.87499 2.09306 2.11059 1.67237 2.58453C-0.659189 5.20998 -0.539712 9.21223 1.94428 11.6961L8.34187 18.0938C9.6343 19.3863 11.3376 20.0384 13.0445 20.0384C14.6178 20.0384 16.1941 19.4841 17.4536 18.3657C17.9273 17.9449 18.1631 17.3649 18.1173 16.7327C18.0714 16.1006 17.7545 15.5607 17.2248 15.2125ZM16.6754 17.4896C14.513 19.4099 11.2163 19.3113 9.17027 17.2653L2.77269 10.8677C0.726622 8.82161 0.62805 5.52492 2.54838 3.36258C2.71104 3.17932 2.91352 3.0867 3.15141 3.0867C3.17399 3.0867 3.19703 3.08761 3.22053 3.08929C3.48817 3.10867 3.69875 3.23227 3.84615 3.45673L5.83667 6.48562C6.03473 6.78714 6.01901 7.1625 5.79684 7.4419C4.95699 8.49735 5.0429 10.0123 5.99658 10.9659L9.07201 14.0414C10.0257 14.9951 11.5406 15.081 12.596 14.2411C12.8754 14.0188 13.2508 14.0032 13.5522 14.2013L16.5812 16.1918C16.8055 16.3392 16.9291 16.5498 16.9485 16.8174C16.968 17.0852 16.876 17.3114 16.6754 17.4896Z",
  fill: "#FFC107"
}), IncomminCallIcon__jsx("path", {
  d: "M19.8277 0.210115C19.7134 0.0959781 19.5637 0.0390625 19.414 0.0390625C19.2639 0.0390625 19.1136 0.0964359 18.9991 0.211183L12.4618 6.76533L12.4619 4.64785C12.4619 4.32437 12.1996 4.06207 11.8761 4.06207C11.5525 4.06207 11.2902 4.32437 11.2902 4.64785L11.29 8.18242C11.29 8.33776 11.3517 8.48684 11.4617 8.5967C11.5716 8.70656 11.7205 8.76836 11.8758 8.76836H15.4105C15.7342 8.76836 15.9965 8.50606 15.9965 8.18242C15.9965 7.85893 15.7342 7.59663 15.4105 7.59663H13.2877L19.8287 1.03867C20.0573 0.809483 20.0569 0.43854 19.8277 0.210115Z",
  fill: "#FFC107"
})));

var IncomminCallIcon = function IncomminCallIcon() {
  return IncomminCallIcon__ref;
};

/* harmony default export */ var IncomminCallIcon_defaultExport = (IncomminCallIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/VerifiedIcon.js
/* harmony import */ var VerifiedIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VerifiedIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VerifiedIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var VerifiedIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var VerifiedIcon__ref = VerifiedIcon__jsx("svg", {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, VerifiedIcon__jsx("path", {
  d: "M13.5896 2.49984C10.8594 2.49984 8.76785 1.71982 6.99919 0C5.23072 1.71982 3.13924 2.49984 0.409309 2.49984C0.409309 6.9786 -0.517435 13.3944 6.99915 16C14.5163 13.3944 13.5896 6.97865 13.5896 2.49984ZM6.45326 10.3812L4.25772 8.18537L5.24075 7.20239L6.45326 8.41518L8.75787 6.11053L9.74085 7.09351L6.45326 10.3812Z",
  fill: "#6CBE00"
}));

var VerifiedIcon = function VerifiedIcon() {
  return VerifiedIcon__ref;
};

/* harmony default export */ var VerifiedIcon_defaultExport = (VerifiedIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/GuaranteedIcon.js
/* harmony import */ var GuaranteedIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var GuaranteedIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(GuaranteedIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var GuaranteedIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var GuaranteedIcon__ref = GuaranteedIcon__jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, GuaranteedIcon__jsx("g", {}, void 0, GuaranteedIcon__jsx("path", {
  d: "M13.7933 9.95967C13.4067 10.1997 13.04 10.3863 12.7133 10.5197C12.4867 10.6197 12.24 10.6663 12 10.6663C11.76 10.6663 11.5133 10.6197 11.2867 10.5197C10.7067 10.2797 10 9.87967 9.31333 9.33301H2.94667L3.93333 7.06634C4.04 6.82634 4.28 6.66634 4.54 6.66634H7.16667C6.98 6.25301 6.83333 5.80634 6.75333 5.33301H4.54C3.74667 5.33301 3.02667 5.80634 2.70667 6.53301L1.38667 9.56634C1.38 9.57968 1.38667 9.59301 1.38 9.61301C0.566667 10.0263 0 10.8597 0 11.833V14.333C0 15.253 0.746667 15.9997 1.66667 15.9997C2.58667 15.9997 3.33333 15.253 3.33333 14.333V13.9997H11.3333V14.333C11.3333 15.253 12.08 15.9997 13 15.9997C13.92 15.9997 14.6667 15.253 14.6667 14.333V11.833C14.6667 11.0797 14.3267 10.4063 13.7933 9.95967ZM4 12.6663H2.66667C2.3 12.6663 2 12.3663 2 11.9997C2 11.633 2.3 11.333 2.66667 11.333H4C4.36667 11.333 4.66667 11.633 4.66667 11.9997C4.66667 12.3663 4.36667 12.6663 4 12.6663ZM12 12.6663H10.6667C10.3 12.6663 10 12.3663 10 11.9997C10 11.633 10.3 11.333 10.6667 11.333H12C12.3667 11.333 12.6667 11.633 12.6667 11.9997C12.6667 12.3663 12.3667 12.6663 12 12.6663Z",
  fill: "#7F46CA"
}), GuaranteedIcon__jsx("path", {
  d: "M15.6607 1.21767L12.1607 0.027C12.0567 -0.009 11.9433 -0.009 11.8393 0.027L8.33933 1.21767C8.136 1.28633 8 1.477 8 1.691V4.36967C8 7.639 11.6493 9.22833 11.8047 9.29433C11.93 9.347 12.07 9.347 12.1953 9.29433C12.3507 9.22833 16 7.639 16 4.36967V1.691C16 1.477 15.864 1.28633 15.6607 1.21767ZM14.1907 3.74567L12.3573 6.079C12.124 6.377 11.6867 6.42033 11.4 6.17367L10.2333 5.17367C9.95333 4.93433 9.92067 4.513 10.1613 4.23367C10.4007 3.95433 10.822 3.92233 11.1007 4.16167L11.7393 4.709L13.1427 2.923C13.37 2.63367 13.7887 2.58233 14.0787 2.811C14.368 3.037 14.4187 3.45633 14.1907 3.74567Z",
  fill: "#7F46CA"
})));

var GuaranteedIcon = function GuaranteedIcon() {
  return GuaranteedIcon__ref;
};

/* harmony default export */ var GuaranteedIcon_defaultExport = (GuaranteedIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/TestDriveIcon.js
/* harmony import */ var TestDriveIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TestDriveIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TestDriveIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var TestDriveIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var TestDriveIcon__ref = TestDriveIcon__jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, TestDriveIcon__jsx("path", {
  d: "M10 0C4.4934 0 0 4.4941 0 10C0 15.5066 4.4941 20 10 20C15.5066 20 20 15.5059 20 10C20 4.49336 15.5059 0 10 0ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z",
  fill: "#FFC107"
}), TestDriveIcon__jsx("path", {
  d: "M10 2.34375C5.80715 2.34375 2.34375 5.78238 2.34375 10C2.34375 14.2004 5.7909 17.6562 10 17.6562C14.2051 17.6562 17.6562 14.2054 17.6562 10C17.6562 5.77773 14.1885 2.34375 10 2.34375ZM10 3.51562C12.4918 3.51562 14.6594 4.92859 15.7447 6.9952C14.2962 6.45676 12.2516 5.89844 10 5.89844C7.74836 5.89844 5.70383 6.45676 4.25531 6.9952C5.34062 4.92859 7.50824 3.51562 10 3.51562ZM3.85215 12.063L4.34699 12.1337C6.16012 12.3927 7.60734 13.8399 7.86633 15.653L7.93703 16.1479C6.01813 15.5022 4.49773 13.9818 3.85215 12.063ZM12.063 16.1479L12.1337 15.653C12.3927 13.8399 13.8399 12.3927 15.653 12.1337L16.1479 12.063C15.5023 13.9818 13.9819 15.5022 12.063 16.1479ZM15.4873 10.9736C13.1619 11.3057 11.3057 13.1619 10.9736 15.4873L10.8388 16.4302C10.5641 16.4658 10.2842 16.4844 10 16.4844C9.71578 16.4844 9.43586 16.4658 9.16117 16.4302L9.02645 15.4873C8.69426 13.1618 6.83813 11.3057 4.5127 10.9736L3.5698 10.8389C3.53418 10.5642 3.51562 10.2842 3.51562 10C3.51562 9.47914 3.57777 8.97254 3.6943 8.48691C4.99598 7.91113 7.35094 7.07031 10 7.07031C12.6491 7.07031 15.004 7.91113 16.3057 8.48691C16.4222 8.97254 16.4844 9.47914 16.4844 10C16.4844 10.2842 16.4658 10.5642 16.4302 10.8389L15.4873 10.9736Z",
  fill: "#FFC107"
}), TestDriveIcon__jsx("path", {
  d: "M10 8.24219C9.03074 8.24219 8.24219 9.03074 8.24219 10C8.24219 10.9693 9.03074 11.7578 10 11.7578C10.9693 11.7578 11.7578 10.9693 11.7578 10C11.7578 9.03074 10.9693 8.24219 10 8.24219ZM10 10.5859C9.67691 10.5859 9.41406 10.3231 9.41406 10C9.41406 9.67691 9.67691 9.41406 10 9.41406C10.3231 9.41406 10.5859 9.67691 10.5859 10C10.5859 10.3231 10.3231 10.5859 10 10.5859Z",
  fill: "#FFC107"
}));

var TestDriveIcon = function TestDriveIcon() {
  return TestDriveIcon__ref;
};
/* harmony default export */ var TestDriveIcon_defaultExport = (TestDriveIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/InfoIcon.js
/* harmony import */ var InfoIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InfoIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InfoIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var InfoIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var InfoIcon__ref = InfoIcon__jsx("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, InfoIcon__jsx("circle", {
  cx: "7",
  cy: "7",
  r: "6",
  stroke: "#1575C3"
}), InfoIcon__jsx("path", {
  d: "M6.32935 4.30514C6.32935 3.87954 6.55157 3.66675 6.99601 3.66675C7.44046 3.66675 7.66268 3.87954 7.66268 4.30514C7.66268 4.50794 7.60645 4.66646 7.494 4.78072C7.38423 4.89211 7.21823 4.94781 6.99601 4.94781C6.55157 4.94781 6.32935 4.73359 6.32935 4.30514ZM7.60645 10.3334H6.38155V5.54335H7.60645V10.3334Z",
  fill: "#1575C3"
}));

var InfoIcon = function InfoIcon() {
  return InfoIcon__ref;
};

/* harmony default export */ var InfoIcon_defaultExport = (InfoIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/CalendarIcon.js
/* harmony import */ var CalendarIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CalendarIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CalendarIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var CalendarIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var CalendarIcon = function CalendarIcon() {
  return CalendarIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, CalendarIcon__jsx('use', {
    xlinkHref: __WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#calendar'
  }));
};

/* harmony default export */ var CalendarIcon_defaultExport = (CalendarIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/GearboxIcon.js
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(GearboxIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var GearboxIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var GearboxIcon = function GearboxIcon() {
  return GearboxIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, GearboxIcon__jsx('use', {
    xlinkHref: GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#gearbox'
  }));
};

/* harmony default export */ var GearboxIcon_defaultExport = (GearboxIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/EngineIcon.js
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(EngineIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var EngineIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var EngineIcon = function EngineIcon() {
  return EngineIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, EngineIcon__jsx('use', {
    xlinkHref: EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#engine'
  }));
};

/* harmony default export */ var EngineIcon_defaultExport = (EngineIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SpeedIcon.js
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SpeedIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var SpeedIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SpeedIcon = function SpeedIcon() {
  return SpeedIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, SpeedIcon__jsx('use', {
    xlinkHref: SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#speed'
  }));
};

/* harmony default export */ var SpeedIcon_defaultExport = (SpeedIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/ChassisIcon.js
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ChassisIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var ChassisIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var ChassisIcon = function ChassisIcon() {
  return ChassisIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, ChassisIcon__jsx('use', {
    xlinkHref: ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#chassis'
  }));
};

/* harmony default export */ var ChassisIcon_defaultExport = (ChassisIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/LocationIcon.js
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LocationIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var LocationIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var LocationIcon = function LocationIcon() {
  return LocationIcon__jsx('svg', {
    width: '8',
    height: '10'
  }, void 0, LocationIcon__jsx('use', {
    xlinkHref: LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#location'
  }));
};

/* harmony default export */ var LocationIcon_defaultExport = (LocationIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/CarIcon.js
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CarIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var CarIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var CarIcon = function CarIcon() {
  return CarIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, CarIcon__jsx('use', {
    xlinkHref: CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#car'
  }));
};

/* harmony default export */ var CarIcon_defaultExport = (CarIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/ColorIcon.js
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ColorIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var ColorIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var ColorIcon = function ColorIcon() {
  return ColorIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, ColorIcon__jsx('use', {
    xlinkHref: ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#color'
  }));
};

/* harmony default export */ var ColorIcon_defaultExport = (ColorIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/VinIcon.js
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VinIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var VinIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var VinIcon = function VinIcon() {
  return VinIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, VinIcon__jsx('use', {
    xlinkHref: VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#vin'
  }));
};

/* harmony default export */ var VinIcon_defaultExport = (VinIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/VipIcon.js
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VipIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var VipIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var VipIcon = function VipIcon() {
  return VipIcon__jsx('svg', {
    width: '12',
    height: '11'
  }, void 0, VipIcon__jsx('use', {
    xlinkHref: VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#vip'
  }));
};

/* harmony default export */ var VipIcon_defaultExport = (VipIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SubscribeSearch.js
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SubscribeSearch___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var SubscribeSearch__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SubscribeSearch = function SubscribeSearch() {
  return SubscribeSearch__jsx('svg', {
    width: '18',
    height: '18'
  }, void 0, SubscribeSearch__jsx('use', {
    xlinkHref: SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#save-search'
  }));
};

/* harmony default export */ var SubscribeSearch_defaultExport = (SubscribeSearch);
// CONCATENATED MODULE: ./src/shared/components/Icons/AvatarIcon.js
/* harmony import */ var AvatarIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AvatarIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AvatarIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var AvatarIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var AvatarIcon__ref = AvatarIcon__jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, AvatarIcon__jsx("g", {
  clipPath: "url(#clip0_2232:2596)"
}, void 0, AvatarIcon__jsx("path", {
  d: "M9.99957 0C7.22547 0 4.96875 2.25672 4.96875 5.03082C4.96875 7.80492 7.22547 10.0616 9.99957 10.0616C12.7737 10.0616 15.0304 7.80492 15.0304 5.03082C15.0304 2.25672 12.7737 0 9.99957 0ZM9.99957 8.58199C8.04148 8.58199 6.4484 6.98891 6.4484 5.03082C6.4484 3.07273 8.04148 1.47965 9.99957 1.47965C11.9577 1.47965 13.5507 3.07273 13.5507 5.03082C13.5507 6.98891 11.9577 8.58199 9.99957 8.58199Z",
  fill: "#808080"
}), AvatarIcon__jsx("path", {
  d: "M9.99988 11.8398C5.57473 11.8398 2.1084 15.4253 2.1084 20.0026H3.58805C3.58805 16.1925 6.34465 13.3195 9.99988 13.3195C13.6551 13.3195 16.4117 16.1927 16.4117 20.0026H17.8914C17.8914 15.4253 14.425 11.8398 9.99988 11.8398Z",
  fill: "#808080"
})), AvatarIcon__jsx("defs", {}, void 0, AvatarIcon__jsx("clipPath", {
  id: "clip0_2232:2596"
}, void 0, AvatarIcon__jsx("rect", {
  width: "20",
  height: "20",
  fill: "white"
}))));

var AvatarIcon = function AvatarIcon() {
  return AvatarIcon__ref;
};

/* harmony default export */ var AvatarIcon_defaultExport = (AvatarIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SettingsIcon.js
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SettingsIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var SettingsIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SettingsIcon = function SettingsIcon() {
  return SettingsIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, SettingsIcon__jsx('use', {
    xlinkHref: SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#settings'
  }));
};

/* harmony default export */ var SettingsIcon_defaultExport = (SettingsIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/MoneyIcon.js
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MoneyIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var MoneyIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var MoneyIcon = function MoneyIcon() {
  return MoneyIcon__jsx('svg', {
    width: '16',
    height: '16'
  }, void 0, MoneyIcon__jsx('use', {
    xlinkHref: MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#money'
  }));
};

/* harmony default export */ var MoneyIcon_defaultExport = (MoneyIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SpriteIcon.js
/* harmony import */ var SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SpriteIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var SpriteIcon = function SpriteIcon(params) {
  var width = params.width,
      height = params.height,
      className = params.className,
      id = params.id,
      otherParams = _objectWithoutProperties(params, ['width', 'height', 'className', 'id']);

  return SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({ width: width || 10, height: height || 10, className: className || '' }, otherParams),
    SpriteIcon__jsx('use', {
      xlinkHref: __WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg___default.a + '#' + id
    })
  );
};

SpriteIcon.defaultProps = {
  width: '',
  height: '',
  className: '',
  id: ''
};

/* harmony default export */ var SpriteIcon_defaultExport = (SpriteIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return ExchangeIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return IncomminCallIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return VerifiedIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return GuaranteedIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return TestDriveIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return InfoIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return CalendarIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return GearboxIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return EngineIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return SpeedIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return ChassisIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return LocationIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return CarIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return ColorIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return VinIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return VipIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return SubscribeSearch_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return AvatarIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return SettingsIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return MoneyIcon_defaultExport; });
/* unused concated harmony import SpriteIcon */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return SpriteIcon_defaultExport; });



























/***/ }),

/***/ 1398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDefaultImageByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSpareDefaultImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg__);








var defaultImages = {
  avto: __WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg___default.a,
  moto: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  mototsikl: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  skuter: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  baggi: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  moped: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  kvadrotsikl: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  tritsikl: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  gruzovye: __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg___default.a,
  avtobus: __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg___default.a,
  pritsepy: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg___default.a,
  spetstehnika: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg___default.a,
  zapchasti: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg___default.a
};

var getDefaultImageByType = function getDefaultImageByType(transport) {
  if (!transport) {
    return undefined;
  } else if (transport.slug && defaultImages[transport.slug]) {
    return defaultImages[transport.slug];
  } else if (transport.parents && transport.parents.length > 0 && defaultImages[transport.parents[0].slug]) {
    return defaultImages[transport.parents[0].slug];
  }

  return undefined;
};

var getSpareDefaultImage = function getSpareDefaultImage() {
  return defaultImages.zapchasti;
};

/* harmony default export */ __webpack_exports__["a"] = (defaultImages);

/***/ }),

/***/ 1402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export emailRegexp */
/* unused harmony export itnRegex */
/* unused harmony export vinRegex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isValidEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isValidPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isValidITN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isValidVIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isValidDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_isDate__ = __webpack_require__(321);


/* eslint-disable no-useless-escape */

var emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var itnRegex = /^\d{10}$/;
var vinRegex = /^[\d\w]{17}$/;

var isValidEmail = function isValidEmail(email) {
  return email && !!email.match(emailRegexp);
};

var isValidPhone = function isValidPhone(phoneNumber) {
  var regexp = '^(\\+[0-9]{2}\\(([0-9]{3})\\)[0-9]{3}-[0-9]{2}-[0-9]{2}|(\\+38|38|8)?([0-9]{3})[0-9]{7})$';
  return !!phoneNumber.match(regexp);
};

var isUrl = function isUrl(str) {
  var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  return regexp.test(str);
};

// Individual Tax Number
var isValidITN = function isValidITN(itn) {
  return itn && itnRegex.test(itn);
};

// Vehicle Identification Number
var isValidVIN = function isValidVIN(vin) {
  return vin && vinRegex.test(vin);
};

var isValidDate = function isValidDate(date) {
  return __WEBPACK_IMPORTED_MODULE_0_date_fns_isDate__["default"](date);
};

/***/ }),

/***/ 1408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */




var AVAILABLE_JUSTIFY = ['start', 'center', 'end', 'space-between', 'space-around'];
var AVAILABLE_ALIGN = ['top', 'middle', 'bottom'];
var AVAILABLE_TYPE = ['flex'];

var Row = function (_React$Component) {
  _inherits(Row, _React$Component);

  function Row() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Row);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Row.__proto__ || Object.getPrototypeOf(Row)).call.apply(_ref, [this].concat(args))), _this), _this.makeClassesByParams = function (props) {
      var resultClasses = {};
      if (props.type && AVAILABLE_TYPE.includes(props.type)) {
        resultClasses['ant-row-' + props.type] = true;
      }
      if (props.justify && AVAILABLE_JUSTIFY.includes(props.justify)) {
        resultClasses['ant-row-flex-' + props.justify] = true;
      }
      if (props.align && AVAILABLE_ALIGN.includes(props.align)) {
        resultClasses['ant-row-flex-' + props.align] = true;
      }
      return resultClasses;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Row, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          style = _props.style,
          otherProps = _objectWithoutProperties(_props, ['children', 'className', 'style']);

      var classes = this.makeClassesByParams(otherProps);
      return _jsx('div', {
        style: style,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a('ant-row', className, classes)
      }, void 0, children);
    }
  }]);

  return Row;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Row.defaultProps = {
  data: function data() {
    return 'not text';
  },
  style: {},
  type: '',
  justify: '',
  className: ''
};


/* harmony default export */ __webpack_exports__["a"] = (Row);

/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "864d7492.svg";

/***/ }),

/***/ 1436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/ThumbCarousel/ThumbCarousel.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ThumbCarousel = function (_React$Component) {
  _inherits(ThumbCarousel, _React$Component);

  function ThumbCarousel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ThumbCarousel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThumbCarousel.__proto__ || Object.getPrototypeOf(ThumbCarousel)).call.apply(_ref, [this].concat(args))), _this), _this.handleSlideMouseOver = function (index) {
      _this.props.onMouseOver(index);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ThumbCarousel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          album = _props.album,
          index = _props.index;


      if (!Array.isArray(album) || album.length < 2) {
        return null;
      }

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.thumbCarousel
      }, void 0, album.map(function (imageObj, i) {
        return _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.slide, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.currentSlide, index === i)),
          onMouseOver: function onMouseOver() {
            return _this2.handleSlideMouseOver(i);
          }
        }, imageObj.id + '-' + i, _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.slideButton
        }));
      }));
    }
  }]);

  return ThumbCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ThumbCarousel.defaultProps = {
  album: []
};


/* harmony default export */ var ThumbCarousel_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a)(ThumbCarousel));
// CONCATENATED MODULE: ./src/desktop/components/Thumb/Thumb.js
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Thumb___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Thumb___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Thumb_css__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Thumb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Thumb_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Thumb__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Thumb__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Thumb__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Thumb__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Thumb__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Thumb__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import LazyLoad from 'react-lazyload';



var DEFAULT_HEIGHT = 170;

var Thumb_Thumb = function (_React$Component) {
  Thumb__inherits(Thumb, _React$Component);

  function Thumb() {
    var _ref;

    var _temp, _this, _ret;

    Thumb__classCallCheck(this, Thumb);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Thumb__possibleConstructorReturn(this, (_ref = Thumb.__proto__ || Object.getPrototypeOf(Thumb)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      index: 0
    }, _this.getResizedImages = function () {
      var _this$props = _this.props,
          photos = _this$props.photos,
          width = _this$props.width,
          style = _this$props.style,
          setRatioAlbum = _this$props.setRatioAlbum;

      var height = parseInt(style.height, 10);

      return setRatioAlbum(photos, width, height || DEFAULT_HEIGHT);
    }, _this.handleSlideMouseOver = function (index) {
      var photos = _this.getResizedImages();
      var image = new Image();

      image.src = photos[index] && photos[index].image;
      image.onload = function () {
        _this.setState({ index: index });
      };
    }, _temp), Thumb__possibleConstructorReturn(_this, _ret);
  }

  Thumb__createClass(Thumb, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          maxCount = _props.maxCount,
          link = _props.link,
          style = _props.style,
          className = _props.className,
          defaultImg = _props.defaultImg,
          lensEvent = _props.lensEvent,
          alt = _props.alt,
          isLazy = _props.isLazy;


      var photos = this.getResizedImages();
      var index = this.state.index;

      var album = photos.length && photos.length > maxCount ? photos.slice(0, maxCount) : photos;

      var hasPhotos = photos.length > 0 && photos[index].image;
      var thumbnail = hasPhotos && photos[index].image ? photos[index].image : defaultImg || __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg___default.a;

      return Thumb__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a.tmb, className, Thumb__defineProperty({}, __WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a.placeholderImg, !hasPhotos)),
        style: style
      }, void 0, link ? Thumb__jsx(__WEBPACK_IMPORTED_MODULE_2_shared_components_Link__["a" /* default */], {
        to: link,
        'data-lens-event': lensEvent
      }, void 0, Thumb__jsx(ThumbCarousel_defaultExport, {
        index: index,
        album: album,
        onMouseOver: this.handleSlideMouseOver
      })) : Thumb__jsx(ThumbCarousel_defaultExport, {
        index: index,
        album: album,
        onMouseOver: this.handleSlideMouseOver
      }), Thumb___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({}, isLazy ? { loading: 'lazy' } : {}, {
        className: __WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a.img,
        src: thumbnail.image || thumbnail,
        alt: alt,
        width: '230',
        height: '194'
      })));
    }
  }]);

  return Thumb;
}(Thumb___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Thumb_Thumb.defaultProps = {
  photos: [],
  maxCount: 5,
  link: '',
  lensEvent: '',
  style: {},
  defaultImg: null,
  className: '',
  alt: '',
  width: 240,
  isLazy: true
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withPixelRatio__["a" /* default */](Thumb_Thumb)));

/***/ }),

/***/ 1437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */




var Col = function (_React$Component) {
  _inherits(Col, _React$Component);

  function Col() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Col);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Col.__proto__ || Object.getPrototypeOf(Col)).call.apply(_ref, [this].concat(args))), _this), _this.makeClassesByParams = function (props) {
      var resultClasses = {};
      if (props.span) {
        resultClasses['ant-col-' + props.span] = true;
      }
      return resultClasses;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Col, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          style = _props.style,
          otherProps = _objectWithoutProperties(_props, ['children', 'className', 'style']);

      var classes = this.makeClassesByParams(otherProps);
      return _jsx('div', {
        style: style,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(className, classes)
      }, void 0, children);
    }
  }]);

  return Col;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Col.defaultProps = {
  data: function data() {
    return 'not text';
  },
  style: {},
  className: '',
  span: null
};


/* harmony default export */ __webpack_exports__["a"] = (Col);

/***/ }),

/***/ 1439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__withFetch__ = __webpack_require__(1244);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var dispatchEvent = function dispatchEvent(fetch, _ref) {
  var _ref$event = _ref.event,
      event = _ref$event === undefined ? __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].VIEW : _ref$event,
      _ref$objectType = _ref.objectType,
      objectType = _ref$objectType === undefined ? __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].ADVERT : _ref$objectType,
      objectId = _ref.objectId,
      transport = _ref.transport,
      agency = _ref.agency,
      author = _ref.author,
      userId = _ref.userId,
      fingerprint = _ref.fingerprint,
      button = _ref.button;
  return fetch(__WEBPACK_IMPORTED_MODULE_6_shared_constants_api__["a" /* default */].STATS.BASE, {
    method: 'POST',
    body: JSON.stringify(__WEBPACK_IMPORTED_MODULE_4_snakecase_keys___default.a(_extends({
      event: event,
      button: button,
      objectType: objectType,
      objectId: objectId
    }, author ? { author: author } : {}, userId ? { userId: userId } : {}, transport ? { transport: transport } : {}, fingerprint ? { fingerprint: fingerprint } : {}, agency ? { agency: agency } : {})))
  });
};

var withStatsEvents = function withStatsEvents(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref2, [this].concat(args))), _this), _this.events = {
        dispatchAdvertViewEvent: function dispatchAdvertViewEvent(id, authorID, transportId, agencyId) {
          var isSpare = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
          var _this$props = _this.props,
              userId = _this$props.userId,
              fingerprint = _this$props.fingerprint,
              isBot = _this$props.isBot;


          if (authorID !== userId && !isBot) {
            dispatchEvent(_this.props.fetch, {
              objectType: isSpare ? __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].SPARE_PART : __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].ADVERT,
              objectId: id,
              author: authorID,
              transport: transportId,
              agency: agencyId,
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchPhoneViewEvent: function dispatchPhoneViewEvent(id, authorID, transportId, agencyId) {
          var isSpare = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
          var _this$props2 = _this.props,
              userId = _this$props2.userId,
              fingerprint = _this$props2.fingerprint;


          if (authorID !== userId) {
            dispatchEvent(_this.props.fetch, {
              objectType: isSpare ? __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].SPARE_PART : __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["d" /* OBJECT_TYPES */].ADVERT,
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].PHONE_CLICK,
              objectId: id,
              author: authorID,
              transport: transportId,
              agency: agencyId,
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchDealerViewEvent: function dispatchDealerViewEvent(id) {
          var _this$props3 = _this.props,
              userId = _this$props3.userId,
              fingerprint = _this$props3.fingerprint,
              isBot = _this$props3.isBot;


          if (id && !isBot) {
            dispatchEvent(_this.props.fetch, {
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].VIEW,
              objectId: id,
              objectType: 'agency',
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchDealerRedirectEvent: function dispatchDealerRedirectEvent(id) {
          var _this$props4 = _this.props,
              userId = _this$props4.userId,
              fingerprint = _this$props4.fingerprint;


          if (id) {
            dispatchEvent(_this.props.fetch, {
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].REDIRECT,
              objectId: id,
              objectType: 'agency',
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchDealerShowPhoneEvent: function dispatchDealerShowPhoneEvent(id) {
          var _this$props5 = _this.props,
              userId = _this$props5.userId,
              fingerprint = _this$props5.fingerprint;


          if (id) {
            dispatchEvent(_this.props.fetch, {
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].PHONE_CLICK,
              objectId: id,
              objectType: 'agency',
              userId: userId,
              fingerprint: fingerprint
            });
          }
        },

        dispatchDealerSignUp: function dispatchDealerSignUp(id) {
          var _this$props6 = _this.props,
              userId = _this$props6.userId,
              fingerprint = _this$props6.fingerprint;


          if (id) {
            dispatchEvent(_this.props.fetch, {
              event: __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats__["b" /* EVENT_TYPES */].VIEW,
              objectId: id,
              objectType: 'agency',
              button: 'appointment',
              userId: userId,
              fingerprint: fingerprint
            });
          }
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({ events: this.events }, this.props));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withStatsEvents(' + __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    userId: null,
    fingerprint: null
  }, _temp2);

  var mapStateToProps = function mapStateToProps(_ref3) {
    var user = _ref3.user,
        globals = _ref3.globals,
        searchForm = _ref3.searchForm;
    return {
      userId: user.user.id,
      fingerprint: globals.fingerprint,
      isBot: globals.isBot,
      formVocabulary: searchForm.vocabulary,
      formData: searchForm.data,
      formState: searchForm.selected,
      formResults: searchForm && searchForm.results
    };
  };

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](mapStateToProps)(__WEBPACK_IMPORTED_MODULE_7__withFetch__["a" /* withFetch */](Component));
};

/* harmony default export */ __webpack_exports__["a"] = (withStatsEvents);

/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4502f606.svg";

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a7b38a8e.svg";

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1e0c590.svg";

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a07b27d5.svg";

/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f233450.svg";

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "113bf7af.svg";

/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "428c5185.svg";

/***/ }),

/***/ 1454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









// eslint-disable-next-line css-modules/no-unused-class


function UserDataForm(props) {
  var userName = props.userName,
      phone = props.phone,
      errorMessage = props.errorMessage,
      successMessage = props.successMessage,
      t = props.t,
      changeHandler = props.changeHandler,
      onSubmitHandler = props.onSubmitHandler,
      disableBtnLeasing = props.disableBtnLeasing;


  var disabledBtn = disableBtnLeasing || !userName || !phone;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.containerCenter
  }, void 0, _jsx('form', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.requestForm
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_UI__["c" /* InputPhoneNumber */], {
    name: 'phone',
    value: phone,
    changeHandler: changeHandler
  }), _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_UI__["e" /* InputText */], {
    name: 'userName',
    value: userName,
    placeholder: userName || t('Ваше имя'),
    changeHandler: changeHandler
  }), (errorMessage || successMessage) && _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.errorMessage, errorMessage), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.successMessage, successMessage))
  }, void 0, t(errorMessage || successMessage)), _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_UI__["a" /* Button */], {
    disabled: disabledBtn,
    type: 'button',
    onClick: function onClick(e) {
      return onSubmitHandler(e, 'call');
    },
    text: '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E'
  })));
}

UserDataForm.defaultProps = {
  toggleLeasingModal: function toggleLeasingModal() {},
  disableBtnLeasing: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](UserDataForm)));

/***/ }),

/***/ 1455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/Title/Title.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Title_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var Title = function Title(_ref) {
  var title = _ref.title;
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.titleContainer
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.title
  }, void 0, title));
};

/* harmony default export */ var Title_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__Title_css___default.a)(Title));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/UserDataForm/UserDataFormWithPhotoDialogWrapper.js
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__);
var UserDataFormWithPhotoDialogWrapper__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








// eslint-disable-next-line css-modules/no-unused-class


var _ref = UserDataFormWithPhotoDialogWrapper__jsx('br', {});

function UserDataFormWithPhotoDialogWrapper(props) {
  var t = props.t,
      children = props.children,
      advertInfo = props.advertInfo,
      showTitle = props.showTitle,
      showAgreemant = props.showAgreemant;
  var photos = advertInfo.photos,
      transport = advertInfo.transport;


  var advertImage = photos && photos[0] && photos[0].image || __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__["b" /* getDefaultImageByType */](transport);
  var locale = t('locale') === 'ru' ? '' : t('locale') + '_';
  var agreementLink = '/pdf/' + locale + 'terms-of-use.pdf';

  var header = props.header;
  var titleHTML = props.titleHTML;


  if (!header) header = t('avtobazar.ua лизинг');

  return UserDataFormWithPhotoDialogWrapper__jsx('div', {}, void 0, showTitle && UserDataFormWithPhotoDialogWrapper__jsx(Title_defaultExport, {
    title: header
  }), UserDataFormWithPhotoDialogWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.LeasingContainerContent
  }, void 0, UserDataFormWithPhotoDialogWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.headBlock
  }, void 0, UserDataFormWithPhotoDialogWrapper__jsx('img', {
    src: advertImage,
    alt: ''
  }), UserDataFormWithPhotoDialogWrapper__jsx('span', {
    dangerouslySetInnerHTML: { __html: titleHTML }
  }, void 0)), children, showAgreemant && UserDataFormWithPhotoDialogWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.agreeInfo
  }, void 0, t('USER_AGREEMENT_DLG_TITLE_1'), _ref, UserDataFormWithPhotoDialogWrapper__jsx('a', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.modalTextLink,
    href: agreementLink,
    rel: 'noopener noreferrer nofollow',
    target: '_blank'
  }, void 0, t('USER_AGREEMENT_DLG_TITLE_2')))));
}

UserDataFormWithPhotoDialogWrapper.defaultProps = {
  showTitle: true,
  showAgreemant: true,
  monthlyPayment: 0,
  header: '',
  titleHTML: ''
};


/* harmony default export */ __webpack_exports__["a"] = (UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](UserDataFormWithPhotoDialogWrapper)));

/***/ }),

/***/ 1463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return uppercaseFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stripMultipleSpaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stripHTML; });
var uppercaseFirst = function uppercaseFirst(str) {
  var safeStr = str || '';
  return safeStr.charAt(0).toUpperCase() + safeStr.substr(1);
};
var stripMultipleSpaces = function stripMultipleSpaces(str) {
  return (str || '').replace(/\s+/g, ' ');
};
var stripHTML = function stripHTML(maybeString) {
  return (maybeString || '').replace(/<(?:.|\n)*?>/gm, '');
};

/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1465);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThumbCarousel.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThumbCarousel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1G-BW{width:100%;height:100%;padding:0 3px;position:absolute;top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;opacity:0;z-index:5;-webkit-transition:opacity .1s ease-in;-o-transition:opacity .1s ease-in;transition:opacity .1s ease-in;cursor:pointer}._1G-BW:hover{opacity:1}._2cmDv{-webkit-box-flex:1;-ms-flex:1 1 1px;flex:1 1 1px;position:relative}._2cmDv,._3rlOs{-webkit-box-sizing:border-box;box-sizing:border-box}._3rlOs{position:absolute;bottom:3px;left:0;right:0;width:98%;height:3px;background-color:#ffffffa1;margin:auto}.GK0g0 ._3rlOs{background-color:#ffd906}", ""]);

// exports
exports.locals = {
	"thumbCarousel": "_1G-BW",
	"slide": "_2cmDv",
	"slideButton": "_3rlOs",
	"currentSlide": "GK0g0"
};

/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1467);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Thumb.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Thumb.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1467:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Dkcgo{position:relative;width:100%;height:170px;overflow:hidden;padding:0}._3w_xQ{background-color:#f1f1f1}._3w_xQ ._21viN{position:absolute;top:50%;left:50%;width:60%;height:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports
exports.locals = {
	"tmb": "Dkcgo",
	"img": "_21viN imgCover",
	"placeholderImg": "_3w_xQ"
};

/***/ }),

/***/ 1492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function CommonLeasingButton(props) {
  var title = props.title,
      showInfoIcon = props.showInfoIcon,
      onClick = props.onClick,
      prefix = props.prefix,
      className = props.className,
      children = props.children;

  return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, !children && _jsx('div', {
    onClick: onClick,
    className: 'leasing-btn ' + className + ' ' + __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a.root
  }, void 0, prefix && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a.prefix
  }, void 0, prefix), !children && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a.title
  }, void 0, title), showInfoIcon && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a.icon
  }, void 0, _jsx('i', {
    className: 'fa fa-info'
  }))), children && _jsx('div', {
    onClick: onClick,
    className: 'leasing-btn ' + className
  }, void 0, children));
}

CommonLeasingButton.defaultProps = {
  className: '',
  onClick: function onClick() {},
  title: '',
  prefix: '',
  showInfoIcon: true,
  children: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a)(CommonLeasingButton));

/***/ }),

/***/ 1493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/leasing/ulfCalculate.js
/* eslint-disable camelcase */

var PREPAYMENT_PERCENT = 30;
var TIME_MONTH = 60;
var ONCE_COMMISSION_PERCENT = 2.5;

var m_summ = 10000;
var m_gps = 0;
var m_registration = 0;
var m_osago = 0;
var m_bonus_manager = 0;
var m_bonus_marketing = 0;
var m_stavka_do = 50 / 100;
var m_stavka_posle = 50 / 100;

function ulfCalculate() {
  var calcSumm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
  var calcAvans = arguments[1];
  var calcTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TIME_MONTH;

  var m_kurs = 10;
  var raz_koms = ONCE_COMMISSION_PERCENT;
  var sum = calcSumm + calcSumm * (raz_koms / 100);
  var avans = calcAvans || calcSumm / 100 * PREPAYMENT_PERCENT;

  var m_stavka = m_stavka_do;
  if (m_summ >= 14000) {
    m_stavka = m_stavka_posle;
  }

  var m_obyazatelnui_rashod = (m_gps + m_registration + m_osago * calcTime / 12) / m_kurs + (sum - avans) / 100 * m_bonus_manager + sum / 100 * m_bonus_marketing;

  var summa_finansirovania = sum - avans + m_obyazatelnui_rashod;
  var calc_procent = m_stavka / 12 * Math.pow(1 + m_stavka / 12, calcTime) / (Math.pow(1 + m_stavka / 12, calcTime) - 1);

  var platej_per_mesec = summa_finansirovania * calc_procent;

  var monthly = Math.round(platej_per_mesec);

  return { monthly: monthly, avans: Math.round(avans) };
}
// CONCATENATED MODULE: ./src/shared/hocs/withLeasingParams.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withLeasingParams_withLeasingParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__withFetch__ = __webpack_require__(1244);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import { autoMoneyCalculate } from 'shared/helpers/leasing/autoMoneyCalculate';






var withLeasingParams_withLeasingParams = function withLeasingParams(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        leasingParams: {}
      }, _this.componentWillMount = function () {
        var _this$props = _this.props,
            advert = _this$props.advert,
            existsLeasingParams = _this$props.leasingParams;

        var leasingParams = void 0;
        if (!advert || !advert.id) return;

        if (existsLeasingParams && existsLeasingParams.monthlyPayment) {
          leasingParams = existsLeasingParams;
        } else if (__WEBPACK_IMPORTED_MODULE_5_shared_helpers_leasing_myAuto__["k" /* isUlfSomeDealersLeasingProposalAvailable */](advert)) {
          leasingParams = _this.addUlfParams(advert);
        } else {
          //  else if (isUlf24LeasingProposalAvailable(advert)) {
          leasingParams = _this.addUlfParams(advert, true);
        }
        // } else {
        //   leasingParams = this.addAutoMoneyParams(advert);
        // }

        if (leasingParams && leasingParams.monthlyPayment) {
          _this.setState({ leasingParams: _this.addExtendedParams(leasingParams) });
        }
      }, _this.addExtendedParams = function (leasingParams) {
        var advert = _this.props.advert;

        var newLP = _extends({}, leasingParams);

        if (newLP.extendedParams) return newLP;

        var monthlyPaymentUAH = __WEBPACK_IMPORTED_MODULE_3_shared_helpers_leasing_utils__["h" /* getMonthlyPrice */](_this.props.advert, newLP.monthlyPayment, // USD as default
        'uah', false);
        var monthlyPaymentUAHFormatted = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__["k" /* numberWithSpaces */](monthlyPaymentUAH);
        var priceUAH = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_advert__["c" /* getPrice */](advert.price, ['uah']);
        var prepaidUAH = __WEBPACK_IMPORTED_MODULE_3_shared_helpers_leasing_utils__["a" /* calculateExchange */](advert.price, leasingParams.prepaidSum, 'uah');

        newLP.extendedParams = {
          monthlyPaymentUAH: monthlyPaymentUAH,
          monthlyPaymentUAHFormatted: monthlyPaymentUAHFormatted,
          priceUAH: priceUAH,
          prepaidUAH: prepaidUAH
        };
        return newLP;
      }, _this.addUlfParams = function (advert) {
        var isUlf24Calculated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var priceUSD = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_advert__["c" /* getPrice */](advert.price, ['usd']);

        var _ulfCalculate = ulfCalculate(priceUSD),
            monthly = _ulfCalculate.monthly,
            avans = _ulfCalculate.avans;

        var leasingParams = {
          monthlyPayment: monthly,
          prepaidSum: avans,
          isUlfCalculated: !isUlf24Calculated,
          isUlf24Calculated: isUlf24Calculated
        };
        _this.setState({ leasingParams: leasingParams });
        return leasingParams;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * Default currency is USD
     */
    // addAutoMoneyParams = advert => {
    //   const priceUSD = getPrice(advert.price, ['usd']);
    //   const { monthly, avans } = autoMoneyCalculate(priceUSD);
    //   const leasingParams = {
    //     monthlyPayment: monthly,
    //     prepaidSum: avans,
    //     isAutoMoneyCalculated: true,
    //   };
    //   this.setState({ leasingParams });
    //   return leasingParams;
    // };

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { leasingParams: this.state.leasingParams }));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withLeasingParams(' + __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    index: 0,
    partner: '',
    leasingParams: null
  }, _temp2);

  return __WEBPACK_IMPORTED_MODULE_7__withFetch__["a" /* withFetch */](Component);
};

/***/ }),

/***/ 1494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addUlfLead */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUlfLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUlfParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1277);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var addUlfLead = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, fetch) {
    var advert, userName, price, term, phone, prepaid, comment, temperature, popularity, liquidityDays, commentWithAddData, userStorageId, type, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            advert = params.advert, userName = params.userName, price = params.price, term = params.term, phone = params.phone, prepaid = params.prepaid, comment = params.comment, temperature = params.temperature, popularity = params.popularity, liquidityDays = params.liquidityDays, commentWithAddData = params.commentWithAddData, userStorageId = params.userStorageId, type = params.type;
            data = {
              type: type,
              vehicle: {
                // manufacturerId: 1, // Необязательный ID марки авто в справочниках AutoRia
                // modelId: 1, // Необязательный ID марки авто в справочниках AutoRia
                manufacturedYear: advert.year, // Необязательный год выпуска
                engineVolume: __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getCapacity */](advert) // Необязательный объем двигателя в см₃
                // bodyId: 1, // Необязательный ID типа кузова в справочниках AutoRia
                // fuelTypeId: 1, // Необязательный ID типа топлива в справочниках AutoRia
                // transmissionTypeId: 1, // Необязательный ID типа трансмисии в справочниках AutoRia
              },
              contact: {
                name: userName,
                // surname: 'Иванов',
                // inn: '1234567890',
                phoneNumber: phone
              },
              productFrontId: 249, // Вид лизинга
              period: term, // Срок лизинга
              amount: price, // Стоимость авто, грн
              prepayment: prepaid, // Предоплата, грн
              comment: comment,
              utm_source: 'partner',
              utm_medium: 'avtobazar',
              // utm_campaign: 'utm_campaign ', // Необязательный utm-метка
              // utm_term: 'utm_term ', // Необязательный utm-метка
              // utm_content: 'utm_content' // Необязательный utm-метка

              UF_CRM_1639391109039: temperature || 0, // Температура (вероятность покупки)
              UF_CRM_1639391200032: popularity || 0, // Популярность
              UF_CRM_1639391221982: liquidityDays || 0, // Ликвидность (дней)
              UF_CRM_1639391239836: prepaid, // Рекомендованный аванс %
              UF_CRM_1639391264973: commentWithAddData, // Комментарий
              UF_CRM_1639391283416: userStorageId // device id
              // UF_CRM_1639391301711: '', // Результат скоринга
            };
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING_ULF.ADD_LEAD, data, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function addUlfLead(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var createUlfLead = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params, fetch) {
    var result, comment, ulfParams;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = null;
            _context2.prev = 1;
            comment = 'https://avtobazar.ua' + params.advert.permalink;
            ulfParams = _extends({}, params, {
              comment: comment,
              commentWithAddData: '',
              temperature: '',
              type: 'ulf'
            });
            _context2.next = 6;
            return addUlfLead(ulfParams, fetch);

          case 6:
            result = _context2.sent;

            if (!(!result || !result.id)) {
              _context2.next = 9;
              break;
            }

            throw Error('createUlf24Lead error');

          case 9:
            _context2.next = 13;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2['catch'](1);

          case 13:
            return _context2.abrupt('return', result);

          case 14:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 11]]);
  }));

  return function createUlfLead(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var getUlfParams = function getUlfParams(_ref3) {
  var phone = _ref3.phone,
      userName = _ref3.userName,
      leasingParams = _ref3.leasingParams,
      advert = _ref3.advert;
  return {
    phone: phone,
    userName: userName,
    advert: advert,
    leasingParams: leasingParams,
    term: leasingParams.term,
    prepaid: leasingParams && leasingParams.prepayment || leasingParams.extendedParams && leasingParams.extendedParams.prepaidUAH,
    price: leasingParams.extendedParams && leasingParams.extendedParams.priceUAH,
    userStorageId: localStorage.getItem('applensDeviceId') || ''
  };
};

/***/ }),

/***/ 1495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/leasing/finup.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1277);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




/**
 * Fetch car's temperature
 * @param {Number} deviceId 
 * @param {Function} fetch 
 * @returns 
 */
var fetchUsersTemperature = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(deviceId, fetch) {
    var body, temperature, temperatureData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            body = { deviceId: __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* getCleanDeviceId */](deviceId) };
            temperature = 0;
            temperatureData = {};
            _context.prev = 3;
            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_1__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.GET_TEMPERATURE, body, fetch, {}, '');

          case 6:
            temperatureData = _context.sent;

            temperature = temperatureData && temperatureData.temperature ? temperatureData.temperature : 0;
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](3);

          case 12:

            // temperature: 0.35
            if (temperature) {} else {}
            return _context.abrupt('return', temperature);

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[3, 10]]);
  }));

  return function fetchUsersTemperature(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/shared/helpers/leasing/ulf24.js
/* unused harmony export getUlf24LeasingParms */
/* unused harmony export addUlf24Lead */
/* unused harmony export monthlyHapaiCalculate */
/* unused harmony export createHapaiLead */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUlf24Lead; });
/* unused harmony export getCalcualations */
/* harmony import */ var ulf24___WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__myAuto__ = __webpack_require__(1394);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ulf24__this = this;

function ulf24__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var getUlf24LeasingParms = function getUlf24LeasingParms(advert) {
  var ulf = advert.ulf_data;

  return ulf && ulf.calcInfo || null;
};

var addUlf24Lead = function () {
  var _ref = ulf24__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, fetch) {
    var advert, userName, price, term, phone, prepaid, comment, temperature, popularity, liquidityDays, commentWithAddData, userStorageId, type, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            advert = params.advert, userName = params.userName, price = params.price, term = params.term, phone = params.phone, prepaid = params.prepaid, comment = params.comment, temperature = params.temperature, popularity = params.popularity, liquidityDays = params.liquidityDays, commentWithAddData = params.commentWithAddData, userStorageId = params.userStorageId, type = params.type;
            data = {
              type: type,
              vehicle: {
                // manufacturerId: 1, // Необязательный ID марки авто в справочниках AutoRia
                // modelId: 1, // Необязательный ID марки авто в справочниках AutoRia
                manufacturedYear: advert.year, // Необязательный год выпуска
                engineVolume: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getCapacity */](advert) // Необязательный объем двигателя в см₃
                // bodyId: 1, // Необязательный ID типа кузова в справочниках AutoRia
                // fuelTypeId: 1, // Необязательный ID типа топлива в справочниках AutoRia
                // transmissionTypeId: 1, // Необязательный ID типа трансмисии в справочниках AutoRia
              },
              contact: {
                name: userName,
                // surname: 'Иванов',
                // inn: '1234567890',
                phoneNumber: phone
              },
              productFrontId: 249, // Вид лизинга
              period: term, // Срок лизинга
              amount: price, // Стоимость авто, грн
              prepayment: prepaid, // Предоплата, грн
              comment: comment,
              utm_source: 'partner',
              utm_medium: 'avtobazar',
              // utm_campaign: 'utm_campaign ', // Необязательный utm-метка
              // utm_term: 'utm_term ', // Необязательный utm-метка
              // utm_content: 'utm_content' // Необязательный utm-метка

              UF_CRM_1639391109039: temperature || 0, // Температура (вероятность покупки)
              UF_CRM_1639391200032: popularity || 0, // Популярность
              UF_CRM_1639391221982: liquidityDays || 0, // Ликвидность (дней)
              UF_CRM_1639391239836: prepaid, // Рекомендованный аванс %
              UF_CRM_1639391264973: commentWithAddData, // Комментарий
              UF_CRM_1639391283416: userStorageId // device id
              // UF_CRM_1639391301711: '', // Результат скоринга
            };
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* execPostRequest */](ulf24___WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING_ULF24.ADD_LEAD, data, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, ulf24__this);
  }));

  return function addUlf24Lead(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var monthlyHapaiCalculate = function monthlyHapaiCalculate(carPrice, prepaid, term) {
  return typeof window !== 'undefined' && window.getAnnual ? window.getAnnual(carPrice, prepaid, term) : 0;
};

var createHapaiLead = function () {
  var _ref2 = ulf24__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params, fetch) {
    var result, userStorageId, advert, _ref3, popularity, liquidityDays, comment, verifyParamsId, temperature, finupVerificationUrl, commentWithAddData, hapaiParams;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = null;
            _context2.prev = 1;
            userStorageId = params.userStorageId, advert = params.advert;
            _context2.next = 5;
            return __WEBPACK_IMPORTED_MODULE_3__myAuto__["e" /* getFinupVerification */](advert, fetch);

          case 5:
            _ref3 = _context2.sent;
            popularity = _ref3.popularity;
            liquidityDays = _ref3.liquidityDays;
            comment = _ref3.comment;
            verifyParamsId = _ref3.id;
            _context2.next = 12;
            return fetchUsersTemperature(userStorageId, fetch);

          case 12:
            temperature = _context2.sent;
            finupVerificationUrl = 'https://api.finup.lv/view/verification';
            commentWithAddData = ['https://avtobazar.ua' + advert.permalink, finupVerificationUrl + '/' + verifyParamsId, 'https://api.finup.lv/view/profile/' + userStorageId].join('\n');
            hapaiParams = _extends({}, params, {
              comment: comment,
              popularity: popularity,
              liquidityDays: liquidityDays,
              commentWithAddData: commentWithAddData,
              temperature: temperature,
              type: 'hapai'
            });
            _context2.next = 18;
            return addUlf24Lead(hapaiParams, fetch);

          case 18:
            result = _context2.sent;

            if (!(!result || !result.success)) {
              _context2.next = 21;
              break;
            }

            throw Error('createHapaiLead error ' + JSON.stringify(result));

          case 21:
            _context2.next = 25;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2['catch'](1);

          case 25:
            return _context2.abrupt('return', result);

          case 26:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, ulf24__this, [[1, 23]]);
  }));

  return function createHapaiLead(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var createUlf24Lead = function () {
  var _ref4 = ulf24__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params, fetch) {
    var result, comment, ulfParams;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            result = null;
            _context3.prev = 1;
            comment = 'https://avtobazar.ua' + params.advert.permalink;
            ulfParams = _extends({}, params, {
              comment: comment,
              commentWithAddData: '',
              temperature: '',
              type: 'ulf24'
            });
            _context3.next = 6;
            return addUlf24Lead(ulfParams, fetch);

          case 6:
            result = _context3.sent;

            if (!(!result || !result.id)) {
              _context3.next = 9;
              break;
            }

            throw Error('createUlf24Lead error');

          case 9:
            _context3.next = 13;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3['catch'](1);

          case 13:
            return _context3.abrupt('return', result);

          case 14:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, ulf24__this, [[1, 11]]);
  }));

  return function createUlf24Lead(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

var getCalcualations = function () {
  var _ref5 = ulf24__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(advert, leasing, fetch) {
    var result, costUAH, data;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!advert || !advert.make)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt('return', {});

          case 2:
            result = {};
            costUAH = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_advert__["c" /* getPrice */](advert.price, ['uah']);
            _context4.prev = 4;
            data = {
              category: '_ЛЕГКОВЫЕ',
              subcategory: 'ЛЕГКОВЫЕ',
              brand: advert.make.title,
              model: advert.model.title,
              year: advert.year,
              volume: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getCapacity */](advert),
              cnt: 1,
              cost: '' + costUAH,
              prepayment: '' + leasing.prepayment,
              term: leasing.term,
              ccy: 'UAH',
              repayment: 'КЛАССИКА',
              franchise: 0,
              customer: 'ЮЛ',
              format: 1,
              url: 'https://avtobazar.ua' + advert.permalink
            };
            _context4.next = 8;
            return __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* execPostRequest */](ulf24___WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING_ULF24.CALCULATE, data, fetch);

          case 8:
            result = _context4.sent;
            _context4.next = 14;
            break;

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4['catch'](4);

            result = { error: _context4.t0.message, serviceInfo: { errorCode: 1, errorMessage: _context4.t0.message } };

          case 14:
            return _context4.abrupt('return', result);

          case 15:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, ulf24__this, [[4, 11]]);
  }));

  return function getCalcualations(_x7, _x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();

/***/ }),

/***/ 1526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/CreditMarketButton/CreditMarketButton.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreditMarketBanner__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CommonLeasingButton_CommonLeasingButton__ = __webpack_require__(1492);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// import withStyles from 'isomorphic-style-loader/lib/withStyles';






var CreditMarketButton = function (_React$Component) {
  _inherits(CreditMarketButton, _React$Component);

  function CreditMarketButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CreditMarketButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreditMarketButton.__proto__ || Object.getPrototypeOf(CreditMarketButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModal: false
    }, _this.toggleLeasingModal = function (event) {
      event.stopPropagation();
      var eventPostfix = _this.props.eventPostfix;

      var showModal = !_this.state.showModal;
      _this.setState({ showModal: showModal });
      var eventName = 'creditmarket-consultation-show-form-click' + (eventPostfix ? '-' + eventPostfix : '');
      if (showModal && __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[eventName]) _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[eventName]);
    }, _this.closeModal = function () {
      _this.setState({ showModal: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CreditMarketButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          advert = _props.advert,
          intl = _props.intl,
          eventPostfix = _props.eventPostfix,
          children = _props.children;

      var PRICE_UAH = advert.is_not_cleared ? '300 000' : '140 000';
      var prefix = intl.formatMessage({ id: 'Профинансируем это авто' });
      var title = PRICE_UAH + ' \u0433\u0440\u043D.';
      return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__CommonLeasingButton_CommonLeasingButton__["a" /* default */], {
        className: 'creditmarket',
        onClick: this.toggleLeasingModal,
        prefix: prefix,
        title: title
      }, void 0, children), this.state.showModal && _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: this.toggleLeasingModal,
        show: this.state.showModal
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__CreditMarketBanner__["a" /* default */], {
        advert: advert,
        modalMode: true,
        onSubmited: this.closeModal,
        eventPostfix: eventPostfix
      })));
    }
  }]);

  return CreditMarketButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CreditMarketButton.defaultProps = {
  eventPostfix: '',
  leasingParams: null,
  isNotCleared: false,
  children: null
};


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDataLayer: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_5_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ var CreditMarketButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](CreditMarketButton)));
// CONCATENATED MODULE: ./src/shared/components/DialogContainer/DialogContainer.js
/* harmony import */ var DialogContainer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var DialogContainer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(DialogContainer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DialogContainer_css__);
var DialogContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function DialogContainer(props) {
  return DialogContainer__jsx(DialogContainer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, props.show && DialogContainer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default.a.root,
    style: props.style
  }, void 0, DialogContainer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default.a.container
  }, void 0, props.children, DialogContainer__jsx('i', {
    className: 'fa fa-times ' + __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default.a.closeBtnIcon,
    onClick: props.toggleModal
  }))));
}

DialogContainer.defaultProps = {
  children: null,
  style: {}
};


/* harmony default export */ var DialogContainer_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default.a)(DialogContainer));
// CONCATENATED MODULE: ./src/shared/components/ToolTipWrapper/ToolTipWrapper.js
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ToolTipWrapper___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ToolTipWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ToolTipWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css__);
var ToolTipWrapper__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function ToolTipWrapper(props) {
  return ToolTipWrapper__jsx(ToolTipWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, props.show && ToolTipWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css___default.a.root
  }, void 0, ToolTipWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css___default.a.corner
  }), ToolTipWrapper__jsx(DialogContainer_defaultExport, {
    toggleModal: props.toggleModal,
    show: props.show
  }, void 0, props.children)));
}

ToolTipWrapper.defaultProps = {
  children: null
};


/* harmony default export */ var ToolTipWrapper_defaultExport = (ToolTipWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css___default.a)(ToolTipWrapper));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingWithCalculatorBanner.js
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_helpers_leasing_ulf24__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__UserDataForm_UserDataForm__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__UserDataForm_UserDataFormWithPhotoDialogWrapper__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css__);
var LeasingWithCalculatorBanner__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeasingWithCalculatorBanner__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function LeasingWithCalculatorBanner__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingWithCalculatorBanner__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingWithCalculatorBanner__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import * as Cookies from 'js-cookie';




// import Loader from 'shared/components/Loader/Loader';











// import FormInput from './Inputs/FormInput';





// import { monthlyHapaiCalculate, createHapaiLead } from 'shared/helpers/leasing/ulf24';


// import LeasingCalculateForm from './UserDataForm/LeasingCalculateForm';
// import UserDataFormExtended from './UserDataForm/UserDataFormExtended';


// eslint-disable-next-line css-modules/no-unused-class


var LeasingWithCalculatorBanner = function (_React$Component) {
  LeasingWithCalculatorBanner__inherits(LeasingWithCalculatorBanner, _React$Component);

  function LeasingWithCalculatorBanner(props) {
    LeasingWithCalculatorBanner__classCallCheck(this, LeasingWithCalculatorBanner);

    var _this = LeasingWithCalculatorBanner__possibleConstructorReturn(this, (LeasingWithCalculatorBanner.__proto__ || Object.getPrototypeOf(LeasingWithCalculatorBanner)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        leasingParams = _this$props.leasingParams,
        advertInfo = _this$props.advertInfo,
        user = _this$props.user;

    var userName = user && user.name || '';
    var phone = user && user.phones && user.phones[0].number || '';
    var priceUah = __WEBPACK_IMPORTED_MODULE_13_shared_helpers_advert__["c" /* getPrice */](advertInfo.price, ['uah']);
    var prepaidUah = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["a" /* calculateExchange */](advertInfo.price, leasingParams.prepaidSum, 'uah');
    var comission = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["a" /* calculateExchange */](advertInfo.price, leasingParams.prepaidCommission, 'uah');
    var rate = leasingParams.annualRate;

    _this.state = {
      price: priceUah,
      prepaid: prepaidUah,
      term: leasingParams.term,
      rate: rate,
      comission: comission,
      terms: [12, 24, 36, 48, 60, 72, 84],
      userName: userName,
      birthday: '',
      phone: phone,
      errorMessage: '',
      successMessage: '',
      // step: 'periods',
      step: 'userform',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false,
      //
      loading: false
    };
    return _this;
  }

  LeasingWithCalculatorBanner__createClass(LeasingWithCalculatorBanner, [{
    key: 'fireEvent',


    // submitHapaiLeasingLead = cb => {
    //   const { phone, userName, term, prepaid, price } = this.state;
    //   const { advertInfo, leasingParams, fetch } = this.props;

    //   const leadParams = {
    //     phone,
    //     userName,
    //     advert: advertInfo,
    //     leasingParams,
    //     term,
    //     prepaid,
    //     price,
    //     userStorageId: localStorage.getItem('applensDeviceId') || '',
    //   };
    //   console.log('Create Hapai Lead');
    //   createHapaiLead(leadParams, fetch)
    //     .then(data => cb(data && data.success))
    //     .catch(() => cb(false));

    //   return false;
    // };

    value: function fireEvent() {
      __WEBPACK_IMPORTED_MODULE_15_shared_helpers_rtbHouse__["a" /* fireRTBEvent */]('leasingOld', {
        value: this.props.advertInfo.price && __WEBPACK_IMPORTED_MODULE_13_shared_helpers_advert__["c" /* getPrice */](this.props.advertInfo.price),
        ids: [this.props.advertInfo.id]
      });
      this.pushEvent('monthly-consultation-form-sumbit');
    }
  }, {
    key: 'render',
    value: function render() {
      var _cs;

      var _props = this.props,
          t = _props.t,
          advertInfo = _props.advertInfo,
          leasingParams = _props.leasingParams;
      var _state = this.state,
          step = _state.step,
          term = _state.term,
          prepaid = _state.prepaid,
          price = _state.price,
          rate = _state.rate,
          comission = _state.comission;

      var monthlyPriceUah = void 0;

      // if (isHapaiLeasing(leasingParams)) {
      //   const prePaidPrecent = (prepaid - comission) * 100 / price * 0.01;
      //   monthlyPriceUah = monthlyHapaiCalculate(price, prePaidPrecent, term);
      // } else
      if (leasingParams && leasingParams.extendedParams && leasingParams.extendedParams.monthlyPaymentUAH) {
        monthlyPriceUah = leasingParams.extendedParams.monthlyPaymentUAH;
      } else {
        monthlyPriceUah = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["b" /* calculateMonthlyPaymentV2 */]({
          year: advertInfo.year,
          term: term,
          price: price,
          prepaid: prepaid,
          comission: comission,
          rate: rate
        });
      }

      var symbol = __WEBPACK_IMPORTED_MODULE_12_shared_helpers_transportInfo__["p" /* getSymbolTitleBySlug */]('uah');
      var monthlySum = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_common__["k" /* numberWithSpaces */](monthlyPriceUah);
      var titleHTML = t('Ежемесячный платеж') + ' <br /> <b>' + monthlySum + ' ' + symbol + '</b>';

      return LeasingWithCalculatorBanner__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cs = {}, _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default.a.container, true), _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default.a.LeasingContainerContentSidebar, !this.props.modalMode), _cs))
      }, void 0, LeasingWithCalculatorBanner__jsx(__WEBPACK_IMPORTED_MODULE_20__UserDataForm_UserDataFormWithPhotoDialogWrapper__["a" /* default */], {
        advertInfo: this.props.advertInfo,
        showTitle: !this.props.modalMode,
        titleHTML: titleHTML,
        showAgreemant: step === 'userform'
      }, void 0, LeasingWithCalculatorBanner__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default.a.LeasingMyAutoBanner
      }, void 0, LeasingWithCalculatorBanner__jsx(__WEBPACK_IMPORTED_MODULE_19__UserDataForm_UserDataForm__["a" /* default */], {
        disableBtnLeasing: this.state.disableBtnLeasing,
        userName: this.state.userName,
        phone: this.state.phone,
        birthday: this.state.birthday,
        errorMessage: this.state.errorMessage,
        successMessage: this.state.successMessage,
        monthlyPayment: this.state.monthlyPayment,
        changeHandler: this.changeHandler,
        onSubmitHandler: this.onSubmitUesrDataForm,
        toggleLeasingModal: this.state.toggleLeasingModal
      }))));
    }
  }]);

  return LeasingWithCalculatorBanner;
}(LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingWithCalculatorBanner.defaultProps = {
  user: null,
  modalMode: true,
  leasingParams: null,
  onSubmited: function onSubmited() {},
  eventPostfix: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onLeadCreated = function (success) {
    _this2.pushEvent('lead-create-' + (success ? 'success' : 'fail'));
  };

  this.onSubmitExtendedDataForm = function () {
    _this2.pushEvent('monthly-calculation-form-sumbit');
    _this2.setState({ step: 'userform' });
  };

  this.onSubmitUesrDataForm = function (e) {
    var _props2 = _this2.props,
        onSubmited = _props2.onSubmited,
        enqueueNotif = _props2.enqueueNotif,
        t = _props2.t,
        leasingParams = _props2.leasingParams;

    e.preventDefault();
    var _state2 = _this2.state,
        phone = _state2.phone,
        userName = _state2.userName;

    var errorMsg = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["l" /* userFormValidation */]({ phone: phone, userName: userName });

    if (errorMsg) {
      _this2.setState({ errorMessage: errorMsg });
      return;
    }

    _this2.fireEvent();
    _this2.setState({ disableBtnLeasing: true });
    var submit = void 0;

    // if (isAutoMoneyLeasing(leasingParams) && Cookies.get('leasing_partner') % 2) {
    //   submit = this.submitAutomoneyLeasingLead;
    // // } else if (isAutoMoneyLeasing(leasingParams)) {
    // //   submit = this.submitMyAutoLeasingLead;
    // } else
    if (__WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["j" /* isUlf24Leasing */](leasingParams)) {
      submit = _this2.submitUlf24LeasingLead;
    } else if (__WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["k" /* isUlfLeasing */](leasingParams)) {
      submit = _this2.submitUlfLeasingLead;
    } else {
      submit = _this2.submitAFinanceLeasingLead;
    }

    submit(function (isSUccess) {
      _this2.setState({ disableBtnLeasing: false });
      var errorMessage = !isSUccess ? 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже' : '';
      _this2.setState({
        userName: '',
        phone: '',
        errorMessage: errorMessage,
        successMessage: ''
      });
      if (isSUccess) {
        onSubmited();
        enqueueNotif(t('Ваша заявка отправлена!'));
        _this2.onLeadCreated(true);
      } else {
        _this2.onLeadCreated(false);
      }
    });
  };

  this.submitAFinanceLeasingLead = function (cb, moreLeasingParams) {
    var _state3 = _this2.state,
        phone = _state3.phone,
        userName = _state3.userName,
        term = _state3.term,
        prepaid = _state3.prepaid,
        price = _state3.price;
    var _props3 = _this2.props,
        advertInfo = _props3.advertInfo,
        leasingParams = _props3.leasingParams,
        fetch = _props3.fetch;


    var prepaidPercent = prepaid * 100 / price;

    var leadsParams = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */]({ phone: phone, userName: userName }, advertInfo, leasingParams, { term: term, prepaid: prepaidPercent }, moreLeasingParams);

    __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["a" /* createAFinanceLeda */](leadsParams, advertInfo, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function () {
      return cb(false);
    });

    return false;
  };

  this.submitMyAutoLeasingLead = function (cb, moreLeasingParams) {
    var _state4 = _this2.state,
        phone = _state4.phone,
        userName = _state4.userName,
        term = _state4.term,
        prepaid = _state4.prepaid,
        price = _state4.price;
    var _props4 = _this2.props,
        advertInfo = _props4.advertInfo,
        leasingParams = _props4.leasingParams,
        fetch = _props4.fetch;


    var prepaidPercent = prepaid * 100 / price;

    var leadsParams = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */]({ phone: phone, userName: userName }, advertInfo, leasingParams, { term: term, prepaid: prepaidPercent }, moreLeasingParams);

    __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["c" /* createMyAutoLead */](leadsParams, advertInfo, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function () {
      return cb(false);
    });

    return false;
  };

  this.submitAutomoneyLeasingLead = function (cb, moreLeasingParams) {
    var _state5 = _this2.state,
        phone = _state5.phone,
        userName = _state5.userName,
        term = _state5.term,
        prepaid = _state5.prepaid,
        price = _state5.price;
    var _props5 = _this2.props,
        advertInfo = _props5.advertInfo,
        leasingParams = _props5.leasingParams,
        fetch = _props5.fetch;


    var prepaidPercent = prepaid * 100 / price;
    // TODO: sould be refactord for AutomoneyLeasingLead
    var leadsParams = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */]({ phone: phone, userName: userName }, advertInfo, leasingParams, { term: term, prepaid: prepaidPercent }, moreLeasingParams);

    __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["b" /* createAutoMoneyLead */](leadsParams, advertInfo, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function () {
      return cb(false);
    });

    return false;
  };

  this.submitUlfLeasingLead = function (cb) {
    var _state6 = _this2.state,
        phone = _state6.phone,
        userName = _state6.userName;
    var _props6 = _this2.props,
        advertInfo = _props6.advertInfo,
        leasingParams = _props6.leasingParams,
        fetch = _props6.fetch;


    var leadParams = __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({
      phone: phone,
      userName: userName,
      leasingParams: leasingParams,
      advert: advertInfo
    });

    __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__["a" /* createUlfLead */](leadParams, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function (e) {
      cb(false);
    });

    return false;
  };

  this.submitUlf24LeasingLead = function (cb) {
    var _state7 = _this2.state,
        phone = _state7.phone,
        userName = _state7.userName;
    var _props7 = _this2.props,
        advertInfo = _props7.advertInfo,
        leasingParams = _props7.leasingParams,
        fetch = _props7.fetch;


    var leadParams = __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({
      phone: phone,
      userName: userName,
      leasingParams: leasingParams,
      advert: advertInfo
    });

    __WEBPACK_IMPORTED_MODULE_18_shared_helpers_leasing_ulf24__["a" /* createUlf24Lead */](leadParams, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function (e) {
      cb(false);
    });

    return false;
  };

  this.changeHandler = function (field, value) {
    var _this2$setState;

    _this2.setState((_this2$setState = {}, _defineProperty(_this2$setState, field, value), _defineProperty(_this2$setState, 'errorMessage', ''), _this2$setState));
  };

  this.pushEvent = function (eventName) {
    var _props8 = _this2.props,
        eventPostfix = _props8.eventPostfix,
        leasingParams = _props8.leasingParams;

    var partnert = ''; // isAutoMoneyLeasing(leasingParams) ? 'automoney-' : '';
    var event = '' + partnert + eventName + (eventPostfix ? '-' + eventPostfix : '');
    if (LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]) _this2.props.setDataLayer(LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]);else {}
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user && state.user.user
  };
};

var LeasingWithCalculatorBanner_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    enqueueNotif: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__["a" /* enqueueNotification */], dispatch),
    setDataLayer: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ var LeasingWithCalculatorBanner_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, LeasingWithCalculatorBanner_mapDispatchToProps)(LeasingWithCalculatorBanner)))));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton.js
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withLeasingParams__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CommonLeasingButton_CommonLeasingButton__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LeasingWithCalculatorButton_css__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LeasingWithCalculatorButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__LeasingWithCalculatorButton_css__);
var LeasingWithCalculatorButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeasingWithCalculatorButton__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeasingWithCalculatorButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingWithCalculatorButton__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingWithCalculatorButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import withHapai from 'shared/hocs/withHapai';





// import { toggleHalfScreen } from 'shared/helpers/adsAndMetrics';

// import { getSymbolTitleBySlug } from 'shared/helpers/transportInfo';

// import { isHapaiLeasing } from 'shared/helpers/leasing/utils';
// import { getMonthlyPrice } from 'shared/helpers/leasing/utils';


// eslint-disable-next-line css-modules/no-unused-class


// const isMobile = __APP__ === 'mobile';

var LeasingWithCalculatorButton_LeasingWithCalculatorButton = function (_React$Component) {
  LeasingWithCalculatorButton__inherits(LeasingWithCalculatorButton, _React$Component);

  function LeasingWithCalculatorButton() {
    var _ref;

    var _temp, _this, _ret;

    LeasingWithCalculatorButton__classCallCheck(this, LeasingWithCalculatorButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LeasingWithCalculatorButton__possibleConstructorReturn(this, (_ref = LeasingWithCalculatorButton.__proto__ || Object.getPrototypeOf(LeasingWithCalculatorButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showDialog: false
    }, _this.getTitle = function () {
      var _this$props = _this.props,
          intl = _this$props.intl,
          leasingParams = _this$props.leasingParams;

      var price = 0;
      // if (leasingParams && leasingParams.extendedParams && leasingParams.extendedParams.hapai) {
      //   price = leasingParams.extendedParams.hapai.monthlyPaymentUAHFormatted;
      // } else
      if (leasingParams && leasingParams.extendedParams) {
        price = leasingParams.extendedParams.monthlyPaymentUAHFormatted;
      }

      var symbol = 'грн'; // getSymbolTitleBySlug(currencySlug);
      var moth = intl.formatMessage({ id: 'мес' });
      return price + ' ' + symbol + '/' + moth;
    }, _this.toggleLeasingModal = function (event) {
      if (event) event.stopPropagation();
      var show = _this.props.useToolTip ? _this.props.showDialog : _this.state.showDialog;
      var showDialog = !show;

      if (!_this.props.useToolTip) _this.setState({ showDialog: showDialog });

      if (showDialog) {
        _this.pushEvent('monthly-calculation-show-form-click');
      }

      _this.props.toggleLeasingModal();
      // if (isMobile) toggleHalfScreen(!showDialog);
    }, _this.pushEvent = function (eventName) {
      var eventPostfix = _this.props.eventPostfix;
      // const { eventPostfix, leasingParams } = this.props;

      var partnert = ''; // isHapaiLeasing(leasingParams) ? 'hapai-' : '';
      var event = '' + partnert + eventName + (eventPostfix ? '-' + eventPostfix : '');
      if (__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]) _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]);else {}
    }, _temp), LeasingWithCalculatorButton__possibleConstructorReturn(_this, _ret);
  }

  LeasingWithCalculatorButton__createClass(LeasingWithCalculatorButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          advert = _props.advert,
          leasingParams = _props.leasingParams,
          useToolTip = _props.useToolTip,
          children = _props.children;

      var ComponentWrapper = useToolTip ? ToolTipWrapper_defaultExport : __WEBPACK_IMPORTED_MODULE_11_shared_components_ModalWrapper_ModalWrapper__["a" /* default */];
      var show = useToolTip ? this.props.showDialog : this.state.showDialog;
      return LeasingWithCalculatorButton__jsx(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, LeasingWithCalculatorButton__jsx(__WEBPACK_IMPORTED_MODULE_12__CommonLeasingButton_CommonLeasingButton__["a" /* default */], {
        title: this.getTitle(),
        onClick: this.toggleLeasingModal,
        className: 'leasing-with-calculator'
      }, void 0, children), LeasingWithCalculatorButton__jsx(ComponentWrapper, {
        toggleModal: this.toggleLeasingModal,
        show: show
      }, void 0, LeasingWithCalculatorButton__jsx(LeasingWithCalculatorBanner_defaultExport, {
        eventPostfix: this.props.eventPostfix,
        advertInfo: advert,
        modalMode: true,
        onSubmited: this.toggleLeasingModal,
        leasingParams: leasingParams
      })));
    }
  }]);

  return LeasingWithCalculatorButton;
}(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingWithCalculatorButton_LeasingWithCalculatorButton.defaultProps = {
  useToolTip: false,
  toggleLeasingModal: function toggleLeasingModal() {},
  showDialog: false,
  leasingParams: null,
  // currencySlug: 'uah',
  eventPostfix: '',
  children: null
};


var LeasingWithCalculatorButton_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDataLayer: __WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ var LeasingWithCalculatorButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_13__LeasingWithCalculatorButton_css___default.a)(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](null, LeasingWithCalculatorButton_mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withLeasingParams__["a" /* withLeasingParams */](__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](LeasingWithCalculatorButton_LeasingWithCalculatorButton)))));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingButtonWrapper/LeasingButtonWrapper.js
/* harmony import */ var LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_PriceUah_PriceUah__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
var LeasingButtonWrapper__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var LeasingButtonWrapper__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeasingButtonWrapper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingButtonWrapper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingButtonWrapper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var LeasingButtonWrapper_LeasingButtonWrapper = function (_React$Component) {
  LeasingButtonWrapper__inherits(LeasingButtonWrapper, _React$Component);

  function LeasingButtonWrapper() {
    LeasingButtonWrapper__classCallCheck(this, LeasingButtonWrapper);

    return LeasingButtonWrapper__possibleConstructorReturn(this, (LeasingButtonWrapper.__proto__ || Object.getPrototypeOf(LeasingButtonWrapper)).apply(this, arguments));
  }

  LeasingButtonWrapper__createClass(LeasingButtonWrapper, [{
    key: 'checkDefaultButton',
    value: function checkDefaultButton(name) {
      var defaultButtonName = this.props.defaultButtonName;

      if (defaultButtonName === '') return true;
      return name === defaultButtonName;
    }
  }, {
    key: 'renderComponent',
    value: function renderComponent() {
      var _props = this.props,
          advert = _props.advert,
          theme = _props.theme;

      var isCommonLeasingAvailable = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_leasing_myAuto__["f" /* isCommonLeasingProposalAvailable */](advert);
      var isMyAutoOrHapaiAvailable = true; // isLeasingProposalAvailable(advert);
      // const isUlf24Available = false; isUlf24LeasingProposalAvailable(advert);
      var isCreditMarketAvailable = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_leasing_myAuto__["h" /* isCreditmarketProposalAvailable */](advert);
      var isCreditmarketNotClearedAvailable = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_leasing_myAuto__["g" /* isCreditmarketNotClearedProposalAvailable */](advert);

      if (isCommonLeasingAvailable) {
        // if (isUlf24Available && this.checkDefaultButton('LeasingUlfButton'))
        //   return <LeasingUlfButton {...this.props} />;

        if (isCreditMarketAvailable && this.checkDefaultButton('CreditMarketButton')) return LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LeasingWithCalculatorButton_defaultExport, this.props);
        // return <CreditMarketButton {...this.props} />;

        if (isCreditmarketNotClearedAvailable && this.checkDefaultButton('CreditMarketButton')) return LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LeasingWithCalculatorButton_defaultExport, _extends({}, this.props, { isNotCleared: true }));
        // return <CreditMarketButton {...this.props} isNotCleared />;

        if (isMyAutoOrHapaiAvailable && this.checkDefaultButton('LeasingWithCalculatorButton')) return LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LeasingWithCalculatorButton_defaultExport, this.props);

        // if (isMyAutoOrHapaiAvailable && this.checkDefaultButton('LeasingButton'))
        //   return <LeasingButton {...this.props} />;
      }
      return LeasingButtonWrapper__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_PriceUah_PriceUah__["a" /* default */], {
        uah: __WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'uah'),
        theme: theme
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return LeasingButtonWrapper__jsx(LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, this.renderComponent());
    }
  }]);

  return LeasingButtonWrapper;
}(LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingButtonWrapper_LeasingButtonWrapper.defaultProps = {
  index: 0,
  theme: 'yellow',
  defaultButtonName: '',
  eventPostfix: ''
};


/* harmony default export */ __webpack_exports__["a"] = (LeasingButtonWrapper_LeasingButtonWrapper);

/***/ }),

/***/ 1527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceUah_css__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceUah_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PriceUah_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






function PriceUah(props) {
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__PriceUah_css___default.a[props.theme]
  }, void 0, props.uah);
}

PriceUah.defaultProps = {
  theme: 'small'
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__PriceUah_css___default.a)(PriceUah));

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3uigL{padding:0}._2V0fu ._2hPtr,._3uigL{position:relative;background-color:#fff}._2V0fu ._2hPtr{padding:10px}._31vki{max-width:160px;font-size:22px;font-weight:800;line-height:24px;margin-top:10px}._2nW-B{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2nW-B img{width:64px;height:64px;border:3px solid #fff;border-radius:50%;-o-object-fit:cover;object-fit:cover;pointer-events:none}._2nW-B span{font-weight:700;font-size:18px;line-height:140%;padding-left:5px}._2nW-B span b{background:#ffd906}._1-vS1{position:absolute;top:20px;right:10px;display:block;width:64px;height:64px;border:3px solid #fff;border-radius:50%;-o-object-fit:cover;object-fit:cover;pointer-events:none}._1qHDk{margin:0 0 3px;padding-top:10px}._1qHDk,._1qWrk{font-size:14px;line-height:19px}._1qWrk{margin:0;color:#777d82;word-break:break-word;overflow-wrap:break-word}._3EMMJ .Select-control{height:36px;border-radius:3px;right:auto}._3EMMJ .Select-input>input{width:100%!important}.BKsqV{padding:5px;display:block;color:#91979c;line-height:18px;text-align:center}.BKsqV,.Tfqvq{font-size:12px}.Tfqvq{color:#505050}._1qWrk{margin-right:0!important}._2AE8r,._2DQFS{position:relative;color:#d7433d;font-weight:400;font-size:13px;text-align:center;display:block;line-height:1.2;min-height:20px}._2AE8r{color:#2c7e07;font-size:15px;font-weight:500}._3Ckx8>button,._3Ckx8>input{margin:5px 0}._1DHJU{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1593o{margin:5px 20px;text-align:center}.ONa-X>h3{font-weight:700;font-size:18px;margin:0!important}._1ZvgC{padding:15px 0}._1gT3Z{text-align:center;margin:8px 15px}._3I-OT{width:177px}._24rTc{margin:20px}._2jPCK{font-size:18px;font-weight:700;margin:10px 0}._1Sx3L{font-size:12px;color:gray}._1Sx3L>p{text-align:center;margin:0}._10w5A{text-decoration:none;color:#1575c3;font-size:12px;line-height:16px;display:inline-block}._10w5A:hover{color:#2196f3}._2dBrw{height:42px;width:100%;border-radius:3px}._1E2EV,._381a_{padding-top:20px}._1E2EV ._2dBrw,._381a_ ._2dBrw{margin-bottom:20px}._1E2EV ._1T6Ek,._381a_ ._1T6Ek{margin-bottom:9px}.MvwRd{margin-bottom:40px}.MvwRd input{margin:0 0 20px}.MvwRd button{margin:0 auto 10px}._1aqjF{margin-top:-20px;height:20px}", ""]);

// exports
exports.locals = {
	"container": "_3uigL",
	"LeasingContainerContentSidebar": "_2V0fu",
	"LeasingContainerContent": "_2hPtr",
	"title": "_31vki",
	"headBlock": "_2nW-B",
	"carImg": "_1-vS1",
	"price": "_1qHDk",
	"period": "_1qWrk",
	"root": "_3EMMJ",
	"agreeInfo": "BKsqV",
	"btnInfo": "Tfqvq",
	"errorMessage": "_2DQFS",
	"successMessage": "_2AE8r",
	"requestForm": "_3Ckx8",
	"containerCenter": "_1DHJU",
	"containerTextBlock": "_1593o",
	"containerUserDataDialog": "ONa-X",
	"formUserDataDialog": "_1ZvgC",
	"containerVerifyText": "_1gT3Z",
	"containerVerifyForm": "_3I-OT",
	"containerCircleTimer": "_24rTc",
	"containerResultTitle": "_2jPCK",
	"userAgreement": "_1Sx3L",
	"modalTextLink": "_10w5A",
	"input": "_2dBrw input",
	"LeasingUlfBanner": "_381a_",
	"LeasingMyAutoBanner": "_1E2EV",
	"label": "_1T6Ek",
	"userDataFormExtended": "MvwRd",
	"errorMessageBlock": "_1aqjF"
};

/***/ }),

/***/ 1555:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1556);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1eCUR{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border-bottom:3px solid #ffeb3b;padding:10px}._2O4va{text-align:center;font-size:18px;font-weight:700;line-height:24px;margin:0;color:#000}", ""]);

// exports
exports.locals = {
	"titleContainer": "_1eCUR",
	"title": "_2O4va"
};

/***/ }),

/***/ 1647:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1648);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CommonLeasingButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CommonLeasingButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1648:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Jpsyr{display:inline-block;font-weight:700;padding:5px;border-radius:2px;color:#000;font-weight:600;font-size:16px;background:#ffd906;z-index:10;position:relative;cursor:pointer}.Jpsyr:hover{text-decoration:underline}._1n4yU{font-weight:500;font-size:10px;display:table-cell;vertical-align:middle}._1E6SP{font-weight:600;font-size:14px}._1E6SP,.o83ON{display:table-cell;vertical-align:middle;padding-left:4px}.o83ON{text-align:center}.o83ON>i{font-size:8px;border:1px solid #000;height:14px;width:14px;border-radius:14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-indent:5px}", ""]);

// exports
exports.locals = {
	"root": "Jpsyr",
	"prefix": "_1n4yU",
	"title": "_1E6SP",
	"icon": "o83ON"
};

/***/ }),

/***/ 1649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAnyLeasingAvailable; });
/* unused harmony export getLeasingTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__myAuto__ = __webpack_require__(1394);
/* unused harmony reexport isLeasingProposalAvailable */
/* unused harmony reexport isUlf24LeasingProposalAvailable */
/* unused harmony reexport isCreditmarketProposalAvailable */
/* unused harmony reexport isCreditmarketNotClearedProposalAvailable */
/* unused harmony reexport isCommonLeasingProposalAvailable */




var isAnyLeasingAvailable = function isAnyLeasingAvailable(advertData) {
  var isAvailable = __WEBPACK_IMPORTED_MODULE_0__myAuto__["f" /* isCommonLeasingProposalAvailable */](advertData);
  return isAvailable && (__WEBPACK_IMPORTED_MODULE_0__myAuto__["i" /* isLeasingProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["j" /* isUlf24LeasingProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["g" /* isCreditmarketNotClearedProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["h" /* isCreditmarketProposalAvailable */](advertData));
};

function getLeasingCreditmarketTitle(advertData, t) {
  var PRICE_UAH = advertData.is_not_cleared ? '300 000' : '140 000';
  var prefix = t('Профинансируем это авто');
  var title = PRICE_UAH + ' \u0433\u0440\u043D.';
  return { title: title, prefix: prefix };
}

function getLeasingRegularTitle(leasingParams, t) {
  var price = 0;
  if (leasingParams && leasingParams.extendedParams && leasingParams.extendedParams.hapai) {
    price = leasingParams.extendedParams.hapai.monthlyPaymentUAHFormatted;
  } else if (leasingParams && leasingParams.extendedParams) {
    price = leasingParams.extendedParams.monthlyPaymentUAHFormatted;
  }

  var symbol = 'грн'; // getSymbolTitleBySlug(currencySlug);
  var moth = t('мес');
  var title = price + ' ' + symbol + '/' + moth;
  return { title: title, prefix: '' };
}

var getLeasingTitle = function getLeasingTitle(advertData, leasingParams, t) {
  if (__WEBPACK_IMPORTED_MODULE_0__myAuto__["g" /* isCreditmarketNotClearedProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["h" /* isCreditmarketProposalAvailable */](advertData)) {
    return getLeasingCreditmarketTitle(advertData, t);
  }
  if (__WEBPACK_IMPORTED_MODULE_0__myAuto__["j" /* isUlf24LeasingProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["i" /* isLeasingProposalAvailable */](advertData)) {
    return getLeasingRegularTitle(leasingParams, t);
  }
  return '';
};

/***/ }),

/***/ 1657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Icons__["t" /* VipIcon */], {});

function AdvertLabel(props) {
  var advert = props.advert,
      positin = props.positin;

  if (!advert.top_date && !advert.vip_date) return null;
  var posName = 'position-' + positin;
  var posClass = __WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a[posName] && _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a[posName], true) || {};
  if (__WEBPACK_IMPORTED_MODULE_5_shared_helpers_advert__["g" /* isVIP */](advert)) return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a.vip, posClass)
  }, void 0, _ref2, 'VIP');
  if (__WEBPACK_IMPORTED_MODULE_5_shared_helpers_advert__["f" /* isTop */](advert)) return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a.top, posClass)
  }, void 0, '\u0422\u041E\u041F');
  return null;
}

AdvertLabel.defaultProps = {
  positin: 'topRight'
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a)(AdvertLabel));

/***/ }),

/***/ 1658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






function PriceUsdEuro(props) {
  var prices = [];
  ['uah', 'usd', 'eur'].forEach(function (key) {
    if (props[key]) prices.push(key);
  });

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css___default.a.root
  }, void 0, prices.map(function (key, idx) {
    return _jsx('span', {
      'data-currency': key,
      className: __WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css___default.a.currency
    }, key, props[key], ' ', idx !== prices.length - 1 ? ' • ' : '');
  }));
}

PriceUsdEuro.defaultProps = {
  uah: '',
  usd: '',
  eur: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css___default.a)(PriceUsdEuro));

/***/ }),

/***/ 1663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildJournalListingUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildJournalItemUrl; });
/* unused harmony export buildStoVoteLink */
/* JOURNAL */

var genericJournalUrlBuilder = function genericJournalUrlBuilder(slug, tagSlug) {
  return '/zhurnal/' + (slug ? slug + '/' : '') + (tagSlug ? '?tag=' + tagSlug : '');
};

var buildJournalListingUrl = function buildJournalListingUrl(rubrics, rubric, tagSlug) {
  var rubricOrDefault = rubric || rubrics[0];

  return genericJournalUrlBuilder(rubricOrDefault.id === rubrics[0].id ? null : rubricOrDefault.seo_slug, tagSlug);
};

var buildJournalItemUrl = function buildJournalItemUrl(itemSlug, tagSlug) {
  return genericJournalUrlBuilder(itemSlug, tagSlug);
};

/* HOME */

var buildStoVoteLink = function buildStoVoteLink(companyID) {
  return 'https://sto.avtobazar.ua/vote/' + companyID + '/';
};

/***/ }),

/***/ 1666:
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1910),
    isObjectLike = __webpack_require__(88);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),

/***/ 1669:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d78c1e45.png";

/***/ }),

/***/ 1670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WarrantyLogo_css__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WarrantyLogo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WarrantyLogo_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var IS_MOBILE = "desktop" === 'mobile';
var LENGTH = IS_MOBILE ? 8 : 12;

function WarrantyLogo(props) {
  var warranty = props.warranty,
      tooltipTitle = props.tooltipTitle,
      tooltipIcon = props.tooltipIcon;

  var lessFontSize = warranty.title.length > LENGTH ? { fontSize: 12 } : {};

  return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, _jsx('img', {
    alt: '',
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__WarrantyLogo_css___default.a.tooltipIcon, tooltipIcon),
    src: warranty.logo
  }), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__WarrantyLogo_css___default.a.tooltipTitle, tooltipTitle),
    style: lessFontSize
  }, void 0, warranty.title));
}

WarrantyLogo.defaultProps = {
  tooltipTitle: '',
  tooltipIcon: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__WarrantyLogo_css___default.a)(WarrantyLogo));

/***/ }),

/***/ 1699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_creditmarket__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UserDataForm_UserDataForm__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__UserDataForm_UserDataFormWithPhotoDialogWrapper__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















// import FormInput from './Inputs/FormInput';





// eslint-disable-next-line css-modules/no-unused-class


var CreditMarketBanner = function (_React$Component) {
  _inherits(CreditMarketBanner, _React$Component);

  function CreditMarketBanner(props) {
    _classCallCheck(this, CreditMarketBanner);

    var _this = _possibleConstructorReturn(this, (CreditMarketBanner.__proto__ || Object.getPrototypeOf(CreditMarketBanner)).call(this, props));

    _initialiseProps.call(_this);

    var user = _this.props.user;

    var userName = user && user.name || '';
    var phone = user && user.phones && user.phones[0].number || '';

    _this.state = {
      userName: userName,
      birthday: '',
      phone: phone,
      errorMessage: '',
      successMessage: '',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false
    };
    return _this;
  }

  _createClass(CreditMarketBanner, [{
    key: 'render',
    value: function render() {
      var _cs;

      var _props = this.props,
          t = _props.t,
          advert = _props.advert;

      var PRICE_UAH = advert.is_not_cleared ? '300 000' : '140 000';

      var titleHTML = t('Финансируем') + '<br /> \u0434\u043E <b> ' + PRICE_UAH + ' \u0433\u0440\u043D. </b><br /> ' + t('на этот автомобиль');
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cs = {}, _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css___default.a.container, true), _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css___default.a.LeasingContainerContentSidebar, !this.props.modalMode), _cs))
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__UserDataForm_UserDataFormWithPhotoDialogWrapper__["a" /* default */], {
        advertInfo: this.props.advert,
        showTitle: !this.props.modalMode,
        titleHTML: titleHTML
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__UserDataForm_UserDataForm__["a" /* default */], {
        disableBtnLeasing: this.state.disableSubmit,
        userName: this.state.userName,
        phone: this.state.phone,
        birthday: this.state.birthday,
        errorMessage: this.state.errorMessage,
        successMessage: this.state.successMessage,
        changeHandler: this.changeHandler,
        onSubmitHandler: this.onSubmitUesrDataForm
      })));
    }
  }]);

  return CreditMarketBanner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CreditMarketBanner.defaultProps = {
  eventPostfix: '',
  modalMode: true,
  onSubmited: function onSubmited() {},
  user: null
  // isNotCleared: false,
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSubmitUesrDataForm = function (e) {
    e.preventDefault();
    var _props2 = _this2.props,
        enqueueNotif = _props2.enqueueNotif,
        t = _props2.t;
    var _state = _this2.state,
        phone = _state.phone,
        userName = _state.userName;

    var errorMsg = __WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_utils__["l" /* userFormValidation */]({ phone: phone, userName: userName });
    if (errorMsg) {
      _this2.setState({ errorMessage: errorMsg });
      return;
    }

    _this2.pushEvent('consultation-form-sumbit');
    _this2.setState({ disableSubmit: true });
    _this2.Submit(function (data) {
      _this2.setState({ disableSubmit: false });
      var toState = {
        userName: '',
        phone: '',
        errorMessage: !data || data.result !== 'ok' ? 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже' : '',
        successMessage: ''
      };

      _this2.setState(toState);
      if (data && data.result === 'ok') {
        enqueueNotif(t('Заявка отправлена'));
        _this2.pushEvent('lead-create-success');
      } else {
        enqueueNotif(t('Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'));
        _this2.pushEvent('lead-create-fail');
      }
      _this2.props.onSubmited();
    });
  };

  this.Submit = function (cb) {
    var _state2 = _this2.state,
        phone = _state2.phone,
        userName = _state2.userName;
    var _props3 = _this2.props,
        advert = _props3.advert,
        fetch = _props3.fetch;


    var params = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_creditmarket__["a" /* prepareParamsForCreditMarketRequest */](_extends({}, advert, { phone: phone, userName: userName }));
    __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_creditmarket__["b" /* sendCreditMarket */](params, fetch).then(function (data) {
      return cb(data);
    }).catch(function () {
      return cb(false);
    });
  };

  this.changeHandler = function (field, value) {
    var _this2$setState;

    _this2.setState((_this2$setState = {}, _defineProperty(_this2$setState, field, value), _defineProperty(_this2$setState, 'errorMessage', ''), _this2$setState));
  };

  this.pushEvent = function (eventName) {
    if (eventName === 'lead-create-success') {
      __WEBPACK_IMPORTED_MODULE_11_shared_helpers_rtbHouse__["a" /* fireRTBEvent */]('leasingOld', {
        value: _this2.props.advert.price && __WEBPACK_IMPORTED_MODULE_12_shared_helpers_advert__["c" /* getPrice */](_this2.props.advert.price),
        ids: [_this2.props.advert.id]
      });
    }

    var eventPostfix = _this2.props.eventPostfix;

    var event = 'creditmarket-' + eventName + (eventPostfix ? '-' + eventPostfix : '');
    if (__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]) _this2.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]);else {}
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user && state.user.user
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    enqueueNotif: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__["a" /* enqueueNotification */], dispatch),
    setDataLayer: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(CreditMarketBanner)))));

/***/ }),

/***/ 1700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prepareParamsForCreditMarketRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendCreditMarket; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1277);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var prepareParamsForCreditMarketRequest = function prepareParamsForCreditMarketRequest(params) {
  return {
    advertId: params.id,
    city: params.location && params.location.title,
    year: params.year,
    name: params.userName,
    make: params.make && params.make.title,
    model: params.model && params.model.title,
    phone: params.phone,
    sum: Math.round(__WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportInfo__["n" /* getPriceValueBySlug */](params.price, 'uah')),
    url: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_urls__["g" /* generateUrl */](params)
  };
};

var sendCreditMarket = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, fetch) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.CREDIT_MARKET.ADD, params, fetch));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function sendCreditMarket(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 1703:
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(518),
    arraySome = __webpack_require__(1911),
    cacheHas = __webpack_require__(519);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),

/***/ 1704:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(71);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;

/***/ }),

/***/ 1705:
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

module.exports = matchesStrictComparable;

/***/ }),

/***/ 1709:
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(323);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/***/ }),

/***/ 1710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/SimpleLeasingCard/SimpleLeasingCard.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function SimpleLeasingCard(props) {
  var fullPrice = props.fullPrice,
      year = props.year,
      mileageText = props.mileageText,
      engineTitle = props.engineTitle,
      gearboxTitle = props.gearboxTitle,
      make = props.make,
      maker = props.maker,
      model = props.model,
      advert = props.advert;


  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.root
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.info
  }, void 0, year && _jsx('span', {}, void 0, year), mileageText && _jsx('span', {}, void 0, mileageText)), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.info
  }, void 0, engineTitle && _jsx('span', {}, void 0, engineTitle || ''), gearboxTitle && _jsx('span', {}, void 0, gearboxTitle || '')), fullPrice && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.price
  }, void 0, fullPrice));
}

SimpleLeasingCard.defaultProps = {
  fullPrice: null,
  engineTitle: null,
  gearboxTitle: null,
  year: null,
  maker: null,
  mileageText: null
};


/* harmony default export */ var SimpleLeasingCard_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a)(SimpleLeasingCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/SimilarLeasingCard/SimilarLeasingCard.js
/* harmony import */ var SimilarLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SimilarLeasingCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SimilarLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css__);
var SimilarLeasingCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






// import LeasingButton from 'shared/components/LeasingOnlineBanner/LeasingButton/LeasingButton';




function SimilarLeasingCard(props) {
  var advert = props.advert,
      year = props.year,
      make = props.make,
      maker = props.maker,
      model = props.model,
      shouldEmphasizePrice = props.shouldEmphasizePrice,
      isNegotiablePrice = props.isNegotiablePrice,
      intl = props.intl,
      index = props.index;


  return SimilarLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a.root
  }, void 0, SimilarLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title, ' '), advert && !isNegotiablePrice && SimilarLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a.leasingButton
  }, void 0, SimilarLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__["a" /* default */], {
    advert: advert,
    index: index
  })), isNegotiablePrice && SimilarLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a.contractPrice)
  }, void 0, intl.formatMessage({ id: 'договорная' })));
}

SimilarLeasingCard.defaultProps = {
  fullPrice: null,
  year: null,
  shouldEmphasizePrice: false,
  isNegotiablePrice: false,
  index: 0
};


/* harmony default export */ var SimilarLeasingCard_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a)(SimilarLeasingCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/DealerAdsLeasingCard/DealerAdsLeasingCard.js
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css__);
var DealerAdsLeasingCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function DealerAdsLeasingCard(props) {
  var fullPrice = props.fullPrice,
      year = props.year,
      make = props.make,
      maker = props.maker,
      model = props.model;


  return DealerAdsLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a.root
  }, void 0, DealerAdsLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title, ' ', DealerAdsLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a.similarYear
  }, void 0, year)), fullPrice && DealerAdsLeasingCard__jsx('div', {
    className: DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a.similarPrice)
  }, void 0, fullPrice));
}

DealerAdsLeasingCard.defaultProps = {
  year: null,
  fullPrice: null
};


/* harmony default export */ var DealerAdsLeasingCard_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a)(DealerAdsLeasingCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/PromoutedLeasingCard/PromoutedLeasingCard.js
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_PriceUah_PriceUah__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_PriceUsdEuro_PriceUsdEuro__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_leasing_leasing__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css__);
var PromoutedLeasingCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












// import LeasingWithCalculatorButton from 'shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton';
// import MicroCreditButton from 'shared/components/LeasingOnlineBanner/MicroCreditButton/MicroCreditButton';






var _ref = PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["b" /* CalendarIcon */], {});

var PromoutedLeasingCard__ref2 = PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["o" /* SpeedIcon */], {});

var _ref3 = PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["f" /* EngineIcon */], {});

var _ref4 = PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["h" /* GearboxIcon */], {});

function PromoutedLeasingCard(props) {
  var advert = props.advert,
      fullPrice = props.fullPrice,
      year = props.year,
      mileageText = props.mileageText,
      engineTitle = props.engineTitle,
      gearboxTitle = props.gearboxTitle,
      make = props.make,
      maker = props.maker,
      model = props.model,
      shouldEmphasizePrice = props.shouldEmphasizePrice,
      isNegotiablePrice = props.isNegotiablePrice,
      intl = props.intl,
      priceUAH = props.priceUAH,
      priceUSD = props.priceUSD,
      priceEUR = props.priceEUR,
      index = props.index;


  var isLeasing = __WEBPACK_IMPORTED_MODULE_10_shared_helpers_leasing_leasing__["a" /* isAnyLeasingAvailable */](advert);

  var priceTheme = isLeasing ? 'small' : 'yellow';

  return PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.root
  }, void 0, PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.container
  }, void 0, PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title), PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.info
  }, void 0, year && PromoutedLeasingCard__jsx('span', {}, void 0, _ref, year), mileageText && PromoutedLeasingCard__jsx('span', {}, void 0, PromoutedLeasingCard__ref2, mileageText)), PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.info
  }, void 0, engineTitle && PromoutedLeasingCard__jsx('span', {}, void 0, _ref3, engineTitle || ''), gearboxTitle && PromoutedLeasingCard__jsx('span', {}, void 0, _ref4, gearboxTitle || ''))), isLeasing && !isNegotiablePrice && PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.leasingButton
  }, void 0, PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__["a" /* default */], {
    advert: advert,
    index: index
  })), PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_PriceUah_PriceUah__["a" /* default */], {
    uah: __WEBPACK_IMPORTED_MODULE_8_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'uah'),
    theme: priceTheme
  }), !isNegotiablePrice && PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_PriceUsdEuro_PriceUsdEuro__["a" /* default */], {
    usd: __WEBPACK_IMPORTED_MODULE_8_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'usd'),
    eur: __WEBPACK_IMPORTED_MODULE_8_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'eur')
  }), isNegotiablePrice && PromoutedLeasingCard__jsx('div', {
    className: PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.price)
  }, void 0, intl.formatMessage({ id: 'договорная' })));
}

PromoutedLeasingCard.defaultProps = {
  fullPrice: null,
  mileageText: null,
  engineTitle: '',
  gearboxTitle: '',
  abroadTitle: '',
  drivenFromTitle: '',
  shouldEmphasizePrice: false,
  isNegotiablePrice: false,
  priceUAH: '0',
  priceUSD: '0',
  priceEUR: '0',
  index: 0
};


/* harmony default export */ var PromoutedLeasingCard_defaultExport = (PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a)(PromoutedLeasingCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/AdvertCarCard.js
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(AdvertCarCard___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertCarCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_mileageUnits_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_mileageUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_constants_json_mileageUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_defaultImages__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_components_AdvertLabel_AdvertLabel__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Thumb_Thumb__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var AdvertCarCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























// eslint-disable-next-line css-modules/no-unused-class


var UAH_CURRENCY = __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default.a.find(function (currency) {
  return currency.slug === 'uah';
});
var USD_CURRENCY = __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default.a.find(function (currency) {
  return currency.slug === 'usd';
});
var EUR_CURRENCY = __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default.a.find(function (currency) {
  return currency.slug === 'eur';
});

var AdvertCarCard_AdvertCarCard = function (_React$Component) {
  _inherits(AdvertCarCard, _React$Component);

  function AdvertCarCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AdvertCarCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdvertCarCard.__proto__ || Object.getPrototypeOf(AdvertCarCard)).call.apply(_ref, [this].concat(args))), _this), _this.buildCarPrice = function (prices, currency) {
      if (!Array.isArray(prices)) {
        return null;
      }

      var priceObj = prices.find(function (price) {
        return price.currency === currency.slug;
      });
      return AdvertCarCard__jsx('span', {}, void 0, priceObj && __WEBPACK_IMPORTED_MODULE_8_shared_helpers_common__["k" /* numberWithSpaces */](priceObj.value), ' ', AdvertCarCard__jsx('small', {}, void 0, currency && currency.title));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdvertCarCard, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          advertClassName = _props.advertClassName,
          advertThumbClassName = _props.advertThumbClassName,
          advertStyle = _props.advertStyle,
          imageStyle = _props.imageStyle,
          currency = _props.currency,
          advert = _props.advert,
          cardType = _props.cardType,
          width = _props.width,
          _props$advert = _props.advert,
          _props$advert$maker = _props$advert.maker,
          maker = _props$advert$maker === undefined ? '' : _props$advert$maker,
          _props$advert$make = _props$advert.make,
          make = _props$advert$make === undefined ? '' : _props$advert$make,
          _props$advert$model = _props$advert.model,
          model = _props$advert$model === undefined ? '' : _props$advert$model,
          _props$advert$year = _props$advert.year,
          year = _props$advert$year === undefined ? '' : _props$advert$year,
          _props$advert$mileage = _props$advert.mileage,
          mileage = _props$advert$mileage === undefined ? '' : _props$advert$mileage,
          _props$advert$mileage2 = _props$advert.mileage_unit,
          mileageUnitTempId = _props$advert$mileage2 === undefined ? 0 : _props$advert$mileage2,
          _props$advert$engine = _props$advert.engine,
          engine = _props$advert$engine === undefined ? '' : _props$advert$engine,
          _props$advert$gearbox = _props$advert.gearbox,
          gearbox = _props$advert$gearbox === undefined ? '' : _props$advert$gearbox,
          _props$advert$price = _props$advert.price,
          price = _props$advert$price === undefined ? '' : _props$advert$price,
          _props$advert$charact = _props$advert.characteristics,
          characteristics = _props$advert$charact === undefined ? '' : _props$advert$charact,
          transport = _props$advert.transport,
          colorDate = _props$advert.color_date,
          isNew = _props$advert.is_new,
          clarifyPriceLink = _props$advert.clarify_price_link,
          isNegotiablePrice = _props$advert.is_negotiable_price,
          linkFromProps = _props.link,
          intl = _props.intl,
          lensEvent = _props.lensEvent,
          index = _props.index;


      var link = linkFromProps || '/' + __WEBPACK_IMPORTED_MODULE_6_shared_helpers_urls__["g" /* generateUrl */](advert);
      var fullPrice = clarifyPriceLink ? null : this.buildCarPrice(price, currency) || __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["a" /* carPrice */](price, currency.slug);

      var mileageUnitId = mileageUnitTempId || 0;
      var engineTitle = engine ? engine.title : characteristics && characteristics.engine && characteristics.engine.title;
      var gearboxTitle = gearbox ? gearbox.title : characteristics && characteristics.gearbox && characteristics.gearbox.title;

      var mileageUnit = __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_mileageUnits_json___default.a.find(function (unit) {
        return unit.id === mileageUnitId;
      });

      var defaultImage = this.props.defaultImage || __WEBPACK_IMPORTED_MODULE_12_shared_constants_defaultImages__["b" /* getDefaultImageByType */](transport);
      var shouldEmphasizePrice = colorDate ? new Date(colorDate) > new Date() : false;

      var mileageUnitTitle = mileageUnit && mileageUnit.title && intl.formatMessage({ id: mileageUnit.title }) || '';

      var mileageText = mileage > 0 ? mileage + ' ' + mileageUnitTitle : null;

      var priceUAH = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["b" /* carPriceBySlug */](price, UAH_CURRENCY);
      var priceUSD = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["b" /* carPriceBySlug */](price, USD_CURRENCY);
      var priceEUR = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["b" /* carPriceBySlug */](price, EUR_CURRENCY);

      if (isNew) {
        mileageText = intl.formatMessage({ id: 'Новый' });
      }

      var sharedProps = {
        advert: advert,
        maker: maker,
        make: make,
        model: model,
        year: year,
        fullPrice: fullPrice,
        shouldEmphasizePrice: shouldEmphasizePrice,
        isNegotiablePrice: isNegotiablePrice,
        intl: intl,
        priceUAH: priceUAH,
        priceUSD: priceUSD,
        priceEUR: priceEUR
      };

      var _ref2 = AdvertCarCard__jsx(SimpleLeasingCard_defaultExport, {
        make: make,
        model: model
      });

      var renderSwitchParams = function renderSwitchParams() {
        switch (cardType && cardType.toLowerCase()) {
          case 'similar':
            {
              return AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimilarLeasingCard_defaultExport, _extends({}, sharedProps, { index: index }));
            }
          case 'dealerads':
            {
              return AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DealerAdsLeasingCard_defaultExport, sharedProps);
            }
          case 'simple':
            {
              return AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleLeasingCard_defaultExport, _extends({}, sharedProps, {
                mileageText: mileageText,
                engineTitle: engineTitle || '',
                gearboxTitle: gearboxTitle || ''
              }));
            }
          case 'brick':
            {
              return _ref2;
            }
          default:
            {
              return AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PromoutedLeasingCard_defaultExport, _extends({}, sharedProps, {
                index: index,
                mileageText: mileageText,
                engineTitle: engineTitle || '',
                gearboxTitle: gearboxTitle || ''
              }));
            }
        }
      };
      var carTypeStyle = cardType.toLowerCase() || 'promoutedcard';
      return AdvertCarCard__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.root,
        style: advertStyle
      }, void 0, AdvertCarCard__jsx('div', {
        className: AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(advertClassName, (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a[carTypeStyle], !!__WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a[carTypeStyle]), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.isVip, __WEBPACK_IMPORTED_MODULE_9_shared_helpers_advert__["g" /* isVIP */](advert)), _cx))
      }, void 0, AdvertCarCard__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.thumb
      }, void 0, AdvertCarCard__jsx(__WEBPACK_IMPORTED_MODULE_18__Thumb_Thumb__["a" /* default */], {
        photos: advert.photos,
        link: link,
        style: imageStyle,
        className: advertThumbClassName,
        width: width,
        defaultImg: defaultImage,
        lensEvent: lensEvent
      }, Math.random())), AdvertCarCard__jsx('div', {
        className: AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.subInfo, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.brick, cardType && cardType.toLowerCase() === 'brick'))
      }, void 0, renderSwitchParams()), AdvertCarCard__jsx(__WEBPACK_IMPORTED_MODULE_13_shared_components_AdvertLabel_AdvertLabel__["a" /* default */], {
        advert: advert
      }), link && AdvertCarCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
        to: link,
        className: __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.link,
        'data-lens-event': lensEvent
      })));
    }
  }]);

  return AdvertCarCard;
}(AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AdvertCarCard_AdvertCarCard.defaultProps = {
  advertStyle: {},
  imageStyle: {},
  currency: UAH_CURRENCY,
  lensEvent: '',
  advertClassName: '',
  advertThumbClassName: '',
  cardType: '',
  width: 240,
  link: null,
  leasingParams: null,
  defaultImage: null,
  index: 0
};


/* harmony default export */ __webpack_exports__["a"] = (AdvertCarCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a)(AdvertCarCard___WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](AdvertCarCard_AdvertCarCard)));

/***/ }),

/***/ 1711:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1712);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertLabel.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertLabel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1712:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2vLk7,._GdKl{height:18px;border-radius:2px;font-size:10px;line-height:12px;text-align:center;text-transform:uppercase;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#000!important}._1UkdP{position:absolute;right:5px;top:5px}._2vLk7:hover,._GdKl:hover{color:#000!important}._GdKl{width:35px;background:-webkit-gradient(linear,left bottom,left top,from(rgba(255,217,6,.6)),to(rgba(255,217,6,.6))),#fff;background:-o-linear-gradient(bottom,rgba(255,217,6,.6),rgba(255,217,6,.6)),#fff;background:linear-gradient(0deg,rgba(255,217,6,.6),rgba(255,217,6,.6)),#fff;font-weight:600}._2vLk7{width:38px;background:#ffd906;padding:3px}._2vLk7 svg{margin-right:3px}", ""]);

// exports
exports.locals = {
	"vip": "_2vLk7",
	"top": "_GdKl",
	"position-topRight": "_1UkdP",
	"position-none": "_1UCZh"
};

/***/ }),

/***/ 1713:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1714);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PriceUah.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PriceUah.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2izCF{font-size:14px;line-height:17px;color:#000;margin-bottom:5px}._3TQ81{font-weight:700;padding:5px;border-radius:2px;color:#000;font-weight:600;font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:111px;background:#ffd906}", ""]);

// exports
exports.locals = {
	"small": "_2izCF",
	"yellow": "_3TQ81"
};

/***/ }),

/***/ 1715:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1716);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DialogContainer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DialogContainer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1716:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1F-fD{background-color:#fff;-ms-flex-item-align:center;align-self:center;position:relative;-webkit-box-shadow:0 0 30px rgba(0,0,0,.15);box-shadow:0 0 30px rgba(0,0,0,.15);border-radius:3px;max-width:320px;overflow-y:auto;max-height:100vh;margin:0 auto}._1xv5j{padding:20px 15px}._-5-3g{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}", ""]);

// exports
exports.locals = {
	"root": "_1F-fD",
	"container": "_1xv5j",
	"closeBtnIcon": "_-5-3g"
};

/***/ }),

/***/ 1717:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1718);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ToolTipWrapper.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ToolTipWrapper.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1718:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1hlHK{z-index:122;right:-333px;top:0}._1hlHK,.e3SJp{position:absolute}.e3SJp{width:0;height:0;border-style:solid;border-color:transparent #fff transparent transparent;top:20px;border-width:12px 12px 12px 0;left:-12px}", ""]);

// exports
exports.locals = {
	"root": "_1hlHK",
	"corner": "e3SJp"
};

/***/ }),

/***/ 1719:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1720);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingWithCalculatorButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingWithCalculatorButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1720:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2XcG5{display:inline-block;font-weight:700;padding:5px;border-radius:2px;color:#000;font-weight:600;font-size:16px;background:#ffd906;cursor:pointer;z-index:6;position:relative}._2XcG5:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"priceMonthly": "_2XcG5"
};

/***/ }),

/***/ 1721:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1722);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PriceUsdEuro.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PriceUsdEuro.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1722:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3jTcs{margin-bottom:5px}._3TnWH{font-size:12px;font-weight:400;line-height:14px;color:gray}", ""]);

// exports
exports.locals = {
	"root": "_3jTcs",
	"currency": "_3TnWH"
};

/***/ }),

/***/ 1739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/actions/favorites.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_api__ = __webpack_require__(29);






/* Common action creators */

var L = {
  ru: {
    'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.': 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.',
    'Чтобы добавлять объявления в избранное, выполните вход.': 'Чтобы добавлять объявления в избранное, выполните вход.'
  },
  uk: {
    'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.': 'Вибачте, сталася помилка на сервері, спробуйте повторити операцію пізніше.',
    'Чтобы добавлять объявления в избранное, выполните вход.': 'Щоб додавати оголошення в обране, виконайте вхід.'
  }
};

var setFavorites = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["c" /* FAVORITES */].SET);
var addToFavorites = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["c" /* FAVORITES */].ADD);
var removeFromFavorites = __WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */](__WEBPACK_IMPORTED_MODULE_3__constants_actionTypes__["c" /* FAVORITES */].REMOVE);
/* Fetch functions */

var requestAddToFavorites = function requestAddToFavorites(fetch, id, token) {
  var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ru';
  return fetch(__WEBPACK_IMPORTED_MODULE_4__constants_api__["a" /* default */].ADVERT.FAVORITES, {
    method: 'POST',
    headers: {
      Authorization: 'JWT ' + token
    },
    body: JSON.stringify({ adverts: [id] })
  }).then(function (response) {
    if (!response.ok) {
      throw new Error(L[locale]['Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.']);
    }
    return response.json();
  });
};

var requestDeleteFromFavorites = function requestDeleteFromFavorites(fetch, id, token) {
  var locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ru';
  return fetch(__WEBPACK_IMPORTED_MODULE_4__constants_api__["a" /* default */].ADVERT.FAVORITES, {
    method: 'DELETE',
    headers: { Authorization: 'JWT ' + token },
    body: JSON.stringify({ adverts: [id] })
  }).then(function (response) {
    if (!response.ok) {
      throw new Error(L[locale]['Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.']);
    }
    return response.json();
  });
};

/* Thunks */

var isFetching = false;
var fetchingPromise = null;

var fetchFavorites = function fetchFavorites() {
  return function (dispatch, getState, _ref) {
    var fetch = _ref.fetch;

    if (!isFetching) {
      var token = getState().user.token;


      if (token) {
        fetchingPromise = fetch(__WEBPACK_IMPORTED_MODULE_4__constants_api__["a" /* default */].ADVERT.FAVORITES, {
          headers: { Authorization: 'JWT ' + token }
        }).then(function (r) {
          return r.json();
        }).then(function (r) {
          return r && r.adverts;
        }).then(function (favorites) {
          return favorites && dispatch(setFavorites(favorites));
        }).then(function (r) {
          isFetching = false;
          return r;
        }, function (r) {
          isFetching = false;
          return r;
        });

        isFetching = true;
        return fetchingPromise;
      }

      return Promise.resolve(null);
    }

    return fetchingPromise;
  };
};

var toggleFavorite = function toggleFavorite(id) {
  return function (dispatch, getState, _ref2) {
    var fetch = _ref2.fetch;

    var state = getState();
    var favoritesState = state.favorites;
    var isInFavorites = !!favoritesState && favoritesState.includes(id);
    var token = state.user.token;

    var isUserLoggedIn = !!state.user.token;
    var locale = state.globals.locale;

    if (!isUserLoggedIn) {
      return Promise.reject(new Error(L[locale]['Чтобы добавлять объявления в избранное, выполните вход.']));
    }

    if (id) {
      if (isInFavorites) {
        dispatch(removeFromFavorites(id));
        return requestDeleteFromFavorites(fetch, id, token, locale).catch(function (e) {
          dispatch(addToFavorites(id));
          throw e;
        });
      }

      // Netpeack events
      dispatch(__WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__["j" /* setDataLayer */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_gtmEvents__["a" /* EVENTS */].addToFavorites));
      //
      dispatch(addToFavorites(id));
      return requestAddToFavorites(fetch, id, token, locale).catch(function (e) {
        dispatch(removeFromFavorites(id));
        throw e;
      });
    }

    return Promise.reject(new Error(L[locale]['Извините, произошла ошибка на сервере, попробуйте повторить операцию позже.']));
  };
};
// CONCATENATED MODULE: ./src/shared/hocs/withFavorite.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isFavorite: state.favorites && state.favorites.includes(ownProps.id)
  };
};
var mapDispatchToProps = {
  toggleFavorite: toggleFavorite,
  enqueueNotification: __WEBPACK_IMPORTED_MODULE_4__actions_notifications__["a" /* enqueueNotification */]
};

var withFavorite = function withFavorite(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isLoading: false
      }, _this.handleToggleFavorite = function (id) {
        _this.setState({ isLoading: true });

        _this.props.toggleFavorite(id).then(function () {}).catch(function (error) {
          return _this.props.enqueueNotification(error.message);
        }).then(function () {
          return _this.setState({ isLoading: false });
        }, function () {
          return _this.setState({ isLoading: false });
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            isFavorite = _props.isFavorite,
            props = _objectWithoutProperties(_props, ['isFavorite']);

        return _jsx('div', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, props, {
          isLoading: this.state.isLoading,
          toggleFavorite: this.handleToggleFavorite,
          isFavorite: isFavorite
        })));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withFavorite(' + __WEBPACK_IMPORTED_MODULE_5__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    isFavorite: false
  }, _temp2));
};

/* harmony default export */ var withFavorite_defaultExport = (withFavorite);
// CONCATENATED MODULE: ./src/shared/hocs/withFavoritesFetch.js
/* harmony import */ var withFavoritesFetch___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withFavoritesFetch___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withFavoritesFetch___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var withFavoritesFetch___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var withFavoritesFetch___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(withFavoritesFetch___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var withFavoritesFetch___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_common__ = __webpack_require__(184);
var withFavoritesFetch__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var withFavoritesFetch__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withFavoritesFetch__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function withFavoritesFetch__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withFavoritesFetch__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withFavoritesFetch__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var withFavoritesFetch_mapDispatchToProps = {
  fetchFavorites: fetchFavorites
};

var withFavoritesFetch = function withFavoritesFetch(WrappedComponent) {
  var _class, _temp;

  return withFavoritesFetch___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](null, withFavoritesFetch_mapDispatchToProps)((_temp = _class = function (_React$Component) {
    withFavoritesFetch__inherits(_class, _React$Component);

    function _class() {
      withFavoritesFetch__classCallCheck(this, _class);

      return withFavoritesFetch__possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    withFavoritesFetch__createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.fetchFavorites();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            _ = _props.fetchFavorites,
            props = withFavoritesFetch__objectWithoutProperties(_props, ['fetchFavorites']);

        return withFavoritesFetch__jsx('div', {}, void 0, withFavoritesFetch___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props));
      }
    }]);

    return _class;
  }(withFavoritesFetch___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withFavoritesFetch(' + __WEBPACK_IMPORTED_MODULE_4__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp));
};

/* harmony default export */ var withFavoritesFetch_defaultExport = (withFavoritesFetch);
// CONCATENATED MODULE: ./src/desktop/components/Favourite/Favourite.js
/* harmony import */ var Favourite___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Favourite___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Favourite___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Favourite___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Favourite___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Favourite___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__heart_red_svg__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__heart_red_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__heart_red_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__heart_fill_red_svg__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__heart_fill_red_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__heart_fill_red_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Favourite_css__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Favourite_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Favourite_css__);
var Favourite__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Favourite__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Favourite__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Favourite__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Favourite__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Favourite = function (_React$Component) {
  Favourite__inherits(Favourite, _React$Component);

  function Favourite() {
    var _ref;

    var _temp, _this, _ret;

    Favourite__classCallCheck(this, Favourite);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Favourite__possibleConstructorReturn(this, (_ref = Favourite.__proto__ || Object.getPrototypeOf(Favourite)).call.apply(_ref, [this].concat(args))), _this), _this.handleToggleClick = function () {
      _this.props.toggleFavorite(_this.props.id);
    }, _temp), Favourite__possibleConstructorReturn(_this, _ret);
  }

  Favourite__createClass(Favourite, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          imgWidth = _props.imgWidth,
          isFavorite = _props.isFavorite,
          className = _props.className,
          isCompact = _props.isCompact;


      return Favourite__jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__Favourite_css___default.a.favourite, className, (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__Favourite_css___default.a.compact, isCompact), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__Favourite_css___default.a.isFavorite, isFavorite), _cx)),
        'data-lens-event': 'addBookmark',
        onClick: this.handleToggleClick
      }, void 0, Favourite__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_9__Favourite_css___default.a.img,
        src: isFavorite ? __WEBPACK_IMPORTED_MODULE_8__heart_fill_red_svg___default.a : __WEBPACK_IMPORTED_MODULE_7__heart_red_svg___default.a,
        width: imgWidth,
        height: imgWidth,
        alt: ''
      }), Favourite__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_9__Favourite_css___default.a.text
      }, void 0, Favourite__jsx(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], {
        id: isFavorite ? 'В избранном' : 'В избранное'
      })));
    }
  }]);

  return Favourite;
}(Favourite___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Favourite.defaultProps = {
  imgWidth: 22,
  isFavorite: false,
  isCompact: false,
  className: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Favourite_css___default.a)(withFavoritesFetch_defaultExport(withFavorite_defaultExport(Favourite))));

/***/ }),

/***/ 1740:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0ecf0020.svg";

/***/ }),

/***/ 1741:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e2b1398.svg";

/***/ }),

/***/ 1742:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1743);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Favourite.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Favourite.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1743:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".ZnWXo{cursor:pointer;background:transparent;border-radius:2px;outline:none;border:1px solid #dedede;height:30px;padding:0 12px;font-size:14px;z-index:10;position:relative}.ZnWXo:hover{background-color:#f3f3f3}._2L0Uv{margin-right:6px}.tVLP0{padding:0 7px;opacity:.6;border:0;height:32px;width:32px;line-height:32px;border-radius:16px}.tVLP0 .grTcg{display:none}.tVLP0 ._2L0Uv{margin-right:0}._2748g.tVLP0,.tVLP0:hover{opacity:1;background-color:#ffd906}", ""]);

// exports
exports.locals = {
	"favourite": "ZnWXo",
	"img": "_2L0Uv",
	"compact": "tVLP0",
	"text": "grTcg",
	"isFavorite": "_2748g"
};

/***/ }),

/***/ 1753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var JsonLdApplication = function JsonLdApplication(data) {
  return _jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: { __html: JSON.stringify(data) }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (JsonLdApplication);

/***/ }),

/***/ 1754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/Carousel/SlideList.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SlideList = function SlideList(_ref) {
  var items = _ref.items,
      marginLeft = _ref.marginLeft,
      sliderCN = _ref.sliderCN,
      containerCN = _ref.containerCN,
      inputRef = _ref.inputRef;
  return _jsx('div', {
    className: containerCN
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { ref: inputRef, style: { transform: 'translateX(-' + marginLeft + 'px)' }, className: sliderCN },
    items
  ));
};

SlideList.defaultProps = {
  items: [],
  marginLeft: 0,
  sliderCN: '',
  containerCN: ''
};

/* harmony default export */ var SlideList_defaultExport = (SlideList);
// CONCATENATED MODULE: ./src/desktop/components/Carousel/Carousel.js
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Carousel_css__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Carousel_css__);
var Carousel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Carousel_Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Carousel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      index: 0,
      slidesInfo: []
    }, _this.getChildrenArray = function (item) {
      if (!item.children || item.children.length === 0) {
        return [];
      } else if (item.children.length === 1) {
        return _this.getChildrenArray(item.children[0]);
      }

      return [].concat(_toConsumableArray(item.children));
    }, _this.getFullWidth = function (elem) {
      var _getComputedStyle = getComputedStyle(elem),
          marginLeft = _getComputedStyle.marginLeft,
          marginRight = _getComputedStyle.marginRight;

      return [elem.offsetWidth, marginLeft, marginRight].map(function (i) {
        return parseFloat(i);
      }).reduce(function (result, current) {
        return result + current;
      }, 0);
    }, _this.getSlidesWidth = function (arr) {
      return arr.reduce(function (width, slide) {
        return width + slide.fullWidth;
      }, 0);
    }, _this.setSlidesInfo = function (slidesInfo) {
      _this.setState({ slidesInfo: slidesInfo });
    }, _this.handleNextClick = function () {
      var _this$props = _this.props,
          step = _this$props.step,
          loop = _this$props.loop,
          itemsInRow = _this$props.itemsInRow,
          slideCount = _this$props.items.length;


      _this.setState(function (_ref2) {
        var index = _ref2.index;

        var nextIndex = index + step > slideCount ? slideCount : index + step;
        return {
          index: loop && index >= slideCount - itemsInRow ? 0 : nextIndex
        };
      });
    }, _this.handlePrevClick = function () {
      var _this$props2 = _this.props,
          step = _this$props2.step,
          loop = _this$props2.loop,
          itemsInRow = _this$props2.itemsInRow,
          slideCount = _this$props2.items.length;


      _this.setState(function (_ref3) {
        var index = _ref3.index;

        var nextIndex = index - step < 0 ? 0 : index - step;
        return {
          index: loop && index === 0 ? slideCount - itemsInRow : nextIndex
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var slidesInfo = this.getChildrenArray(this.carousel).map(function (slide) {
        return {
          fullWidth: _this2.getFullWidth(slide)
        };
      });

      this.setSlidesInfo(slidesInfo);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.items !== nextProps.items) {
        this.setState({ index: 0 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          index = _state.index,
          slidesInfo = _state.slidesInfo;
      var _props = this.props,
          loop = _props.loop,
          items = _props.items,
          itemsInRow = _props.itemsInRow,
          itemsPosition = _props.itemsPosition,
          header = _props.header,
          _props$classNames = _props.classNames,
          _props$classNames$mai = _props$classNames.main,
          mainCN = _props$classNames$mai === undefined ? '' : _props$classNames$mai,
          _props$classNames$hea = _props$classNames.header,
          headerCN = _props$classNames$hea === undefined ? '' : _props$classNames$hea,
          bodyCN = _props$classNames.body,
          _props$classNames$sli = _props$classNames.slider,
          sliderCN = _props$classNames$sli === undefined ? '' : _props$classNames$sli;


      var maxLeft = this.carousel && this.getSlidesWidth(slidesInfo) - this.carousel.parentNode.offsetWidth;
      var left = this.getSlidesWidth(slidesInfo.slice(0, index));
      var marginLeft = Math.min(maxLeft, left);
      var roundMarginLeft = maxLeft - marginLeft < 20 ? maxLeft : marginLeft;

      return Carousel__jsx('div', {
        className: mainCN || __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carousel
      }, void 0, Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(headerCN && headerCN, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselHeader)
      }, void 0, header, Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselHeaderContent
      }, void 0, itemsPosition === 'header' && Carousel__jsx(SlideList_defaultExport, {
        items: items,
        marginLeft: roundMarginLeft,
        containerCN: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselContainer,
        sliderCN: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselSlider,
        inputRef: function inputRef(item) {
          _this3.carousel = item;
        }
      })), itemsInRow < items.length && Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselNav
      }, void 0, Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselNavButton, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.disabled, marginLeft === 0 && !loop)),
        onClick: marginLeft > 0 || loop ? this.handlePrevClick : null
      }, void 0, Carousel__jsx('i', {
        className: 'fa fa-angle-left ' + __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.icon
      })), Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselNavButton, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.disabled, marginLeft >= maxLeft && !loop)),
        onClick: marginLeft < maxLeft || loop ? this.handleNextClick : null
      }, void 0, Carousel__jsx('i', {
        className: 'fa fa-angle-right ' + __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.icon
      })))), Carousel__jsx('div', {
        className: bodyCN || __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselBody
      }, void 0, itemsPosition === 'body' && Carousel__jsx(SlideList_defaultExport, {
        items: items,
        marginLeft: marginLeft,
        containerCN: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselContainer,
        sliderCN: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(sliderCN && sliderCN, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselSlider),
        inputRef: function inputRef(item) {
          _this3.carousel = item;
        }
      })));
    }
  }]);

  return Carousel;
}(Carousel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel_Carousel.defaultProps = {
  step: 1,
  itemsInRow: 1,
  itemsPosition: 'body',
  header: '',
  items: [],
  classNames: {},
  loop: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a)(Carousel_Carousel));

/***/ }),

/***/ 1755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_stats_withStatsEvents__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421\u0430\u0439\u0442 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430'
});

var DealerWebsiteLink = function (_React$Component) {
  _inherits(DealerWebsiteLink, _React$Component);

  function DealerWebsiteLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DealerWebsiteLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DealerWebsiteLink.__proto__ || Object.getPrototypeOf(DealerWebsiteLink)).call.apply(_ref, [this].concat(args))), _this), _this.setRedirectStats = function () {
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].dealerSiteRedirect);
      _this.props.onClickHandle();
      var _this$props = _this.props,
          dealer = _this$props.dealer,
          events = _this$props.events;
      var id = dealer.id,
          title = dealer.title,
          gaAccount = dealer.ga_account;

      if (id) {
        events.dispatchDealerRedirectEvent(id);
      }

      var ga = window && window.ga;
      if (ga && gaAccount) {
        ga('send', 'redirect', 'AB_avtosalon', title);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DealerWebsiteLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ClassName = _props.ClassName,
          dealer = _props.dealer,
          children = _props.children;


      if (!dealer) {
        return null;
      }

      var website = dealer && dealer.website ? dealer.website : null;

      return _jsx('a', {
        className: ClassName,
        onClick: this.setRedirectStats,
        href: '' + website,
        target: '_blank',
        rel: 'nofollow noopener noreferrer'
      }, void 0, children || _ref2);
    }
  }]);

  return DealerWebsiteLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DealerWebsiteLink.defaultProps = {
  children: null,
  onClickHandle: function onClickHandle() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](null, { setDataLayer: __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__["j" /* setDataLayer */] })(__WEBPACK_IMPORTED_MODULE_5_shared_hocs_stats_withStatsEvents__["a" /* default */](DealerWebsiteLink)));

/***/ }),

/***/ 1756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setJournalNews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setVideoTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setOrderingField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setVideoFilters; });
/* unused harmony export setSelectedVideoParams */
/* unused harmony export setSelectedVideoData */
/* unused harmony export videoCounter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__(17);


var defaultVideoFilters = {
  make: null,
  model: null,
  generation: null,
  topic: null
};

var setJournalNews = function setJournalNews(news) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_NEWS,
    payload: news
  };
};

var setVideoTopics = function setVideoTopics(topics) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_TOPICS,
    payload: topics
  };
};

var setOrderingField = function setOrderingField(selectedHeadFilter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_HEAD_FILTER,
    payload: selectedHeadFilter
  };
};

var setVideoFilters = function setVideoFilters() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultVideoFilters;
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_FILTERS,
    payload: filters
  };
};

var setSelectedVideoParams = function setSelectedVideoParams(params) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_SELECTED_VIDEO_PARAMS,
    payload: params
  };
};

var setSelectedVideoData = function setSelectedVideoData(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_SELECTED_VIDEO_DATA,
    payload: data
  };
};

var videoCounter = function videoCounter(postId) {
  return function (dispatch, getState, _ref) {
    var fetch = _ref.fetch;

    var userId = getState().user.user.id;
    var counterRequest = {
      event: 'view',
      fingerprint: getState().globals.fingerprint,
      object_id: postId,
      object_type: 'post'
    };

    if (userId) counterRequest.user_id = userId;

    fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.SET_STATS(), {
      method: 'POST',
      body: JSON.stringify(counterRequest)
    }).then(function (packages) {
      if (packages.status === 200) {
        return packages.json();
      }
      return null;
    });
    return Promise.resolve();
  };
};

var getVideoContent = function getVideoContent(fetch, dispatch, videoId) {
  return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.ITEM(videoId)).then(function (r) {
    return r.json();
  }).then(function (results) {
    var content = Array.isArray(results) && results[0].content;
    dispatch(setSelectedVideoData(content));
    dispatch(videoCounter(results[0].id));
  });
};

var getVideoById = function getVideoById() {
  var videoParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (dispatch, getState, _ref2) {
    var fetch = _ref2.fetch;

    dispatch(setSelectedVideoParams(videoParams));

    if (videoParams) {
      getVideoContent(fetch, dispatch, videoParams.id);
    } else {
      dispatch(setSelectedVideoData(videoParams));
      dispatch(setSelectedVideoParams(videoParams));
    }
    return Promise.resolve();
  };
};

/***/ }),

/***/ 1759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CircleTimer_CircleTimer__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







// eslint-disable-next-line css-modules/no-unused-class


function RecallForm(props) {
  var t = props.t,
      recallTime = props.recallTime,
      timeUp = props.timeUp;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerCenter
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerCircleTimer
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CircleTimer_CircleTimer__["a" /* default */], {
    time: recallTime,
    timeUp: timeUp
  })), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerTextBlock
  }, void 0, t('LEASING_FORM_RRECALL_5_MIN')));
}

RecallForm.defaultProps = {
  recallTime: 300,
  timeUp: function timeUp() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](RecallForm)));

/***/ }),

/***/ 1763:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1764);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Carousel.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Carousel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1764:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Tw7dU{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;background:#fff;width:100%}._2iLsW{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2iLsW,._12NOM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._12NOM{overflow:hidden}._20c36{padding:25px}._29nEX{display:block;width:100%;overflow:hidden}._7v6xR{display:-webkit-box;display:-ms-flexbox;display:flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;-webkit-transition:-webkit-transform .6s ease;transition:-webkit-transform .6s ease;-o-transition:transform .6s ease;transition:transform .6s ease;transition:transform .6s ease,-webkit-transform .6s ease}._3GXX0{padding-left:20px}._3GXX0,.TPhLD{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.TPhLD{cursor:pointer;border:1px solid #d0d0d0;width:30px;height:28px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:25px;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.TPhLD:hover{border:1px solid #999;z-index:2}.TPhLD:first-of-type{border-radius:2px 0 0 2px}.TPhLD:last-of-type{border-radius:0 2px 2px 0;margin-left:-1px}._3etcP{position:relative;top:-1px;font-size:21px}._3ylzU{opacity:.5;cursor:default}", ""]);

// exports
exports.locals = {
	"carousel": "Tw7dU",
	"carouselHeader": "_2iLsW",
	"carouselHeaderContent": "_12NOM",
	"carouselBody": "_20c36",
	"carouselContainer": "_29nEX",
	"carouselSlider": "_7v6xR",
	"carouselNav": "_3GXX0",
	"carouselNavButton": "TPhLD",
	"icon": "_3etcP",
	"disabled": "_3ylzU"
};

/***/ }),

/***/ 1765:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1766);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimpleLeasingCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimpleLeasingCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1766:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._37pT9 span{margin-right:30px}._37pT9{position:relative;display:block;margin-bottom:4px;font-size:14px;color:#888;font-weight:400}._1lZf7{font-weight:700;margin-top:5px;display:inline-block;font-size:17px;padding:2px 0;border-radius:2px;color:#000}._2FUJ6:hover ._31Sad{color:#e73232}._31Sad{font-size:15px;font-weight:700;margin-bottom:4px}", ""]);

// exports
exports.locals = {
	"info": "_37pT9",
	"price": "_1lZf7",
	"root": "_2FUJ6",
	"title": "_31Sad"
};

/***/ }),

/***/ 1767:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1768);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimilarLeasingCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimilarLeasingCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1768:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3-CzP{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%;background:#f5f5f5}._3yx4B{font-size:14px;line-height:17px;margin-bottom:7px}._2ZnAI{font-weight:400;padding-top:4px}._3q_pQ{font-weight:400;margin-top:5px;display:inline-block;font-size:14px;color:#000}._1VLp2 small{font-size:70%;font-weight:400}.kn8hp{background-color:#ffeb3b}._3-CzP ._34aet>div{font-size:14px!important;line-height:14px!important;height:24px}._35cTu .microcredits{height:24px}._35cTu .microcredits>div{font-size:10px!important;line-height:10px!important}._35cTu .creditmarket>div:first-child{display:table-row;text-align:right}", ""]);

// exports
exports.locals = {
	"root": "_3-CzP",
	"title": "_3yx4B",
	"similarYear": "_2ZnAI",
	"contractPrice": "_3q_pQ",
	"similarPrice": "_1VLp2",
	"emphasizePrice": "kn8hp",
	"leasing": "_34aet",
	"leasingButton": "_35cTu"
};

/***/ }),

/***/ 1769:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1770);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerAdsLeasingCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerAdsLeasingCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1770:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".wauWL{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%}._3iV59{font-size:14px;font-weight:700;margin-bottom:7px}._1IIwC,._2LeaN{font-weight:400}._2LeaN{display:inline-block;font-size:16px;color:#000}._2LeaN small{font-size:70%;font-weight:400}", ""]);

// exports
exports.locals = {
	"root": "wauWL",
	"title": "_3iV59",
	"similarYear": "_1IIwC",
	"similarPrice": "_2LeaN"
};

/***/ }),

/***/ 1771:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1772);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PromoutedLeasingCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PromoutedLeasingCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1772:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3AdoX{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%}.CV9pu{width:100%;height:90px}._2QZ8G span{-webkit-box-flex:50%;-ms-flex:50% 1 0%;flex:50% 1 0%}._2QZ8G span svg{margin-right:5px}._2QZ8G{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:6px;font-size:12px;line-height:14px;color:gray}._3F7m7{font-style:normal;font-weight:500;font-size:16px;line-height:19px;color:#000;margin-bottom:8px;height:40px}._34z4P{background-color:#ffeb3b}._23cey{margin-top:5px;margin-bottom:5px;max-height:33px}", ""]);

// exports
exports.locals = {
	"root": "_3AdoX",
	"container": "CV9pu",
	"info": "_2QZ8G",
	"title": "_3F7m7",
	"emphasizePrice": "_34z4P",
	"leasingButton": "_23cey"
};

/***/ }),

/***/ 1773:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1774);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertCarCard.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertCarCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1774:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2Oodu{padding:0 5px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1t-By,._2zWWe{border-radius:3px;background:#f5f5f5}._2zWWe{height:360px;position:relative}._1t-By{width:173px}._2zWWe._1RQRQ{background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.2)),to(rgba(253,191,0,.2))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff}._2zWWe:hover{-webkit-box-shadow:0 0 30px rgba(0,0,0,.15);box-shadow:0 0 30px rgba(0,0,0,.15);background:#fff}._1WT0N{text-align:center;vertical-align:middle;overflow:hidden;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;height:170px}._1t-By ._1WT0N{height:125px}._1t-By .XgIVu{height:85px}._2f8em{position:absolute;height:100%;width:100%;top:0;left:0}.XgIVu{position:relative;padding:10px}.VAwNC{position:absolute;top:0;left:0;right:0;width:100%;height:100%;color:#fff;padding:10px;background:#0004}._1WT0N:hover+.VAwNC{opacity:0}", ""]);

// exports
exports.locals = {
	"root": "_2Oodu",
	"isVip": "_1RQRQ",
	"similar": "_1t-By",
	"promoutedcard": "_2zWWe",
	"thumb": "_1WT0N",
	"subInfo": "XgIVu",
	"link": "_2f8em",
	"brick": "VAwNC"
};

/***/ }),

/***/ 1790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/SpareImg/SpareImg.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpareImg_css__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpareImg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SpareImg_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var IMAGE_WIDTH = 70;

function SpareImg(props) {
  var photos = props.photos,
      defaultImg = props.defaultImg,
      setRatioAlbum = props.setRatioAlbum;

  var resizedPhotos = setRatioAlbum(photos, IMAGE_WIDTH);
  return _jsx('div', {
    style: { padding: '0 15px 0 0' }
  }, void 0, _jsx('img', {
    className: __WEBPACK_IMPORTED_MODULE_5__SpareImg_css___default.a.spareImage,
    src: resizedPhotos && resizedPhotos.length > 0 ? resizedPhotos[0].image : defaultImg,
    alt: ''
  }));
}

SpareImg.defaultProps = {
  photos: null,
  defaultImg: __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__["c" /* getSpareDefaultImage */]()
};


/* harmony default export */ var SpareImg_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__SpareImg_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__["a" /* default */](SpareImg)));
// CONCATENATED MODULE: ./src/shared/components/SpareImg/index.js


/* harmony default export */ __webpack_exports__["a"] = (SpareImg_defaultExport);

/***/ }),

/***/ 1791:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1792);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SpareImg.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SpareImg.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1792:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2-UeN{height:auto;-webkit-box-sizing:initial;box-sizing:initial;width:70px}", ""]);

// exports
exports.locals = {
	"spareImage": "_2-UeN"
};

/***/ }),

/***/ 1793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPES; });
/* unused harmony export itemPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_moment__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_newspaper_svg__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_newspaper_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_newspaper_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NewsItem_css__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__NewsItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hocs_withPixelRatio__ = __webpack_require__(1391);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













var TYPES = {
  TABLE: 'table',
  LIST: 'list'
};
var isMobile = "desktop" === 'mobile';

var itemPropType = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    caption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  // not required
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  author: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(),
  publication_date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  imgHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isPrimary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getSelVideo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var _ref = _jsx('span', {});

function NewsItem(props) {
  var _cx, _cx2, _cx3;

  var isActive = props.isActive,
      title = props.title,
      titleUk = props.title_uk,
      link = props.link,
      image = props.image,
      className = props.className,
      imgHeight = props.imgHeight,
      date = props.publication_date,
      type = props.type,
      author = props.author,
      isPrimary = props.isPrimary,
      setRatioImage = props.setRatioImage,
      intl = props.intl,
      getSelVideo = props.getSelVideo,
      lensEvent = props.lensEvent;
  var _author$first_name = author.first_name,
      firstName = _author$first_name === undefined ? null : _author$first_name,
      _author$last_name = author.last_name,
      lastName = _author$last_name === undefined ? null : _author$last_name;
  var locale = intl.locale;

  var fullDate = __WEBPACK_IMPORTED_MODULE_5_shared_helpers_moment__["b" /* getFullDate */](date, locale);
  var authorName = [firstName, lastName].filter(function (x) {
    return x;
  }).join(' ');
  //
  var isList = type === TYPES.LIST;
  var hasImage = !!image.url;
  var imageSrc = image && setRatioImage.apply(undefined, [image.url].concat(_toConsumableArray(isPrimary ? [750, null] : [240, 200]), ['contain']));
  var localizedTitle = locale === 'ru' ? title || titleUk : titleUk || title;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(className, (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listNews, isList), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.tableNews, !isList), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.primary, isPrimary), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.active, isActive), _cx)),
    onClick: function onClick() {
      return getSelVideo();
    }
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cx2 = {}, _defineProperty(_cx2, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listThumb, isList), _defineProperty(_cx2, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.tableThumb, !isList), _defineProperty(_cx2, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.placeholderThumb, !hasImage), _defineProperty(_cx2, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.imageTabletHeight, isMobile), _cx2)),
    style: imgHeight ? { backgroundImage: 'url(' + __WEBPACK_IMPORTED_MODULE_7_shared_modules__["u" /* urlReplace */](imageSrc || __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_newspaper_svg___default.a) + ')', height: imgHeight } : {}
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.stretchedLink,
    to: link,
    'data-lens-event': lensEvent
  }, void 0, _ref)), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cx3 = {}, _defineProperty(_cx3, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listText, isList), _defineProperty(_cx3, __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.tableText, !isList), _cx3))
  }, void 0, _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
    to: link,
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.link,
    'data-lens-event': lensEvent
  }, void 0, localizedTitle), fullDate && !isList && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.tableDate
  }, void 0, fullDate)), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listBottom
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listBottomCard
  }, void 0, author.avatar && _jsx('img', {
    src: author.avatar,
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.avatar,
    alt: ''
  }), _jsx('div', {}, void 0, author && author.id && authorName && _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.author
  }, void 0, authorName), fullDate && isList && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a.listDate
  }, void 0, fullDate))))));
}

NewsItem.defaultProps = {
  getSelVideo: function getSelVideo() {},
  lensEvent: '',
  className: '',
  author: null,
  date: null,
  isPrimary: false,
  isActive: false,
  imgHeight: 200,
  type: TYPES.TABLE
};


/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__NewsItem_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_10__hocs_withPixelRatio__["a" /* default */](NewsItem))));

/***/ }),

/***/ 1802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/CodeVerificationForm/CodeVerificationForm.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







// eslint-disable-next-line css-modules/no-unused-class


function CodeVerificationForm(props) {
  var codeVerification = props.codeVerification,
      t = props.t,
      changeHandler = props.changeHandler,
      onSubmitHandler = props.onSubmitHandler,
      errorMessage = props.errorMessage,
      successMessage = props.successMessage;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.containerCenter
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.containerVerifyText
  }, void 0, t('LEASING_FORM_CODE_VERIF_RQ_CODE')), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.containerVerifyForm
  }, void 0, _jsx('form', {
    onSubmit: onSubmitHandler,
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.requestForm
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__UI__["e" /* InputText */], {
    name: 'codeVerification',
    value: codeVerification,
    placeholder: codeVerification || t('Введите пароль'),
    changeHandler: changeHandler
  }), (errorMessage || successMessage) && _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.errorMessage, errorMessage), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.successMessage, successMessage))
  }, void 0, t(errorMessage || successMessage)), _jsx(__WEBPACK_IMPORTED_MODULE_5__UI__["a" /* Button */], {
    type: 'submit',
    text: t('Отправить')
  }))));
}

/* harmony default export */ var CodeVerificationForm_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](CodeVerificationForm)));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/ResultForm/ResultForm.js
/* harmony import */ var ResultForm___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ResultForm___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ResultForm___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CircleTimer_CircleTimer__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css__);
var ResultForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







// eslint-disable-next-line css-modules/no-unused-class


var _ref = ResultForm__jsx('br', {});

function ResultForm(props) {
  var t = props.t,
      approved = props.approved,
      timeUp = props.timeUp,
      time = props.time;

  return ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerCenter
  }, void 0, ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerResultTitle
  }, void 0, t('Спасибо!')), approved && ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerTextBlock
  }, void 0, t('Ваша заявка одобрена!'), ' ', _ref), !approved && ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerTextBlock
  }, void 0, t('LEASING_FORM_RESULT_RQ_QUIESTINS')), ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerCircleTimer
  }, void 0, ResultForm__jsx(__WEBPACK_IMPORTED_MODULE_4__CircleTimer_CircleTimer__["a" /* default */], {
    time: time,
    timeUp: timeUp
  })), ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerTextBlock
  }, void 0, t('В течении'), ' ', ResultForm__jsx('b', {}, void 0, ' 5 ', t('минут')), ' ', t('с Вами свяжется менеджер')));
}

ResultForm.defaultProps = {
  time: 300,
  timeUp: function timeUp() {}
};


/* harmony default export */ var ResultForm_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](ResultForm)));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingOnlineBanner.js
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_validations_validations__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_ulf__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_ulf24__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_hocs_withLeasingParams__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__UserDataForm_UserDataForm__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RecallForm_RecallForm__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__UserDataForm_UserDataFormWithPhotoDialogWrapper__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css__);
var LeasingOnlineBanner__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function LeasingOnlineBanner__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: Refactoring needed. file to big.









// import { parseDecimal } from 'shared/helpers/advertForm';





// import FormInput from './Inputs/FormInput';







// import withHapai from 'shared/hocs/withHapai';







// import UserDataFormDialogWrapper from './UserDataForm/UserDataFormDialogWrapper';
// import UserDataFormSideBarWrapper from './UserDataForm/UserDataFormSideBarWrapper';


// eslint-disable-next-line css-modules/no-unused-class


// const isMobile = __APP__ === 'mobile';

var LeasingOnlineBanner_LeasingOnlineBanner = function (_React$Component) {
  _inherits(LeasingOnlineBanner, _React$Component);

  function LeasingOnlineBanner(props) {
    _classCallCheck(this, LeasingOnlineBanner);

    var _this = _possibleConstructorReturn(this, (LeasingOnlineBanner.__proto__ || Object.getPrototypeOf(LeasingOnlineBanner)).call(this, props));

    _initialiseProps.call(_this);

    var user = _this.props.user;

    var userName = user && user.name || '';
    var phone = user && user.phones && user.phones[0].number || '';

    _this.state = {
      userName: userName,
      birthday: '',
      phone: phone,
      errorMessage: '',
      successMessage: '',
      step: 'user',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false
    };
    return _this;
  }

  // submitAutoMoneyLeasingLead = (cb, moreLeasingParams) => {
  //   const { phone, userName } = this.state;
  //   const { advert, leasingParams, fetch } = this.props;

  //   const leadsParams = prepareParamsForLeasingLeadRequest(
  //     { phone, userName },
  //     advert,
  //     leasingParams,
  //     moreLeasingParams,
  //   );
  //   console.log('Create AutoMoney Lead');
  //   createAutoMoneyLead(leadsParams, advert, fetch)
  //     .then(data => {
  //       cb(!!data);
  //       this.onLeadCreated(!!data);
  //     })
  //     .catch(() => {
  //       cb(false);
  //       this.onLeadCreated(false);
  //     });

  //   return false;
  // };

  // submitHapaiLeasingLead = cb => {
  //   const { phone, userName } = this.state;
  //   const { advert, leasingParams, fetch } = this.props;

  //   const leadParams = {
  //     phone,
  //     userName,
  //     advert,
  //     leasingParams,
  //     term: leasingParams.term,
  //     prepaid: leasingParams.extendedParams && leasingParams.extendedParams.prepaidUAH,
  //     price: leasingParams.extendedParams && leasingParams.extendedParams.priceUAH,
  //     userStorageId: localStorage.getItem('applensDeviceId') || '',
  //   };
  //   console.log('Create Hapai Lead');
  //   createHapaiLead(leadParams, fetch)
  //     .then(data => {
  //       cb(data && data.success);
  //       this.onLeadCreated(data && data.success);
  //     })
  //     .catch(() => {
  //       cb(false);
  //       this.onLeadCreated(false);
  //     });

  //   return false;
  // };

  _createClass(LeasingOnlineBanner, [{
    key: 'fireEvent',
    value: function fireEvent(source) {
      // const { leasingParams, modalMode, advert } = this.props;
      var _props = this.props,
          modalMode = _props.modalMode,
          advert = _props.advert;

      if (source === 'consultation' || source === 'online') {
        __WEBPACK_IMPORTED_MODULE_9_shared_helpers_rtbHouse__["a" /* fireRTBEvent */]('leasingOld', {
          value: advert.price && __WEBPACK_IMPORTED_MODULE_10_shared_helpers_advert__["c" /* getPrice */](advert.price),
          ids: [advert.id]
        });
      }

      if (!__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[source]) return;
      var lesingBlockType = '';
      // if (isHapaiLeasing(leasingParams)) lesingBlockType += 'Hapai-';
      lesingBlockType += modalMode ? 'Popup' : 'Sidebar';
      lesingBlockType += advert.mileage > 0 ? '-Used-Click' : '-New-Click';

      if (!__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[source][lesingBlockType]) return;
      this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[source][lesingBlockType]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _cs;

      var _props2 = this.props,
          leasingParams = _props2.leasingParams,
          t = _props2.t; // term

      var price = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__["i" /* getMothlyPaymentFormatted */](leasingParams);
      var symbol = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_transportInfo__["p" /* getSymbolTitleBySlug */]('uah');
      var titleHTML = '<b>' + price + ' ' + symbol + ' ' + t('в месяц') + '</b><br />' + t('за этот автомобиль');

      return LeasingOnlineBanner__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cs = {}, LeasingOnlineBanner__defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default.a.container, true), LeasingOnlineBanner__defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default.a.LeasingContainerContentSidebar, !this.props.modalMode), _cs))
      }, void 0, this.state.step === 'user' && LeasingOnlineBanner__jsx(__WEBPACK_IMPORTED_MODULE_22__UserDataForm_UserDataFormWithPhotoDialogWrapper__["a" /* default */], {
        advertInfo: this.props.advert,
        titleHTML: titleHTML,
        showTitle: !this.props.modalMode
      }, void 0, LeasingOnlineBanner__jsx(__WEBPACK_IMPORTED_MODULE_18__UserDataForm_UserDataForm__["a" /* default */], {
        disableBtnLeasing: this.state.disableBtnLeasing,
        disableBtnLeasingOnline: this.state.disableBtnLeasingOnline,
        userName: this.state.userName,
        phone: this.state.phone,
        birthday: this.state.birthday,
        errorMessage: this.state.errorMessage,
        successMessage: this.state.successMessage,
        monthlyPayment: this.state.monthlyPayment,
        changeHandler: this.changeHandler,
        onSubmitHandler: this.onSubmitUesrDataForm,
        toggleLeasingModal: this.state.toggleLeasingModal
      })), LeasingOnlineBanner__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default.a.LeasingContainerContent
      }, void 0, this.state.step === 'verify' && LeasingOnlineBanner__jsx(CodeVerificationForm_defaultExport, {
        codeVerification: this.state.codeVerification,
        errorMessage: this.state.errorMessage,
        successMessage: this.state.successMessage,
        changeHandler: this.changeHandler,
        onSubmitHandler: this.onSubmitCodeVerificationForm,
        disablBtn: this.state.disableBtnCodeVerification
      }), this.state.step === 'recall' && LeasingOnlineBanner__jsx(__WEBPACK_IMPORTED_MODULE_21__RecallForm_RecallForm__["a" /* default */], {
        timeUp: this.props.toggleLeasingModal
      }), this.state.step === 'result' && LeasingOnlineBanner__jsx(ResultForm_defaultExport, {
        approved: this.state.isLeasingApproved,
        timeUp: this.props.toggleLeasingModal
      })));
    }
  }]);

  return LeasingOnlineBanner;
}(LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingOnlineBanner_LeasingOnlineBanner.defaultProps = {
  user: null,
  modalMode: false,
  toggleLeasingModal: function toggleLeasingModal() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSubmitCodeVerificationForm = function (e) {
    e.preventDefault();
    _this2.fireEvent('codeVerification');
    var _state = _this2.state,
        codeVerification = _state.codeVerification,
        requestId = _state.requestId,
        userName = _state.userName,
        phone = _state.phone,
        birthday = _state.birthday,
        step = _state.step;


    var addLead = function addLead(result) {
      var moreLeasingParams = {
        bkiApproved: result.approved,
        comment: _this2.props.leasingParams.comment + ' | ' + ('API \u043E\u0442\u0432\u0435\u0442 \u043E\u0442 finup: "' + result.message + '" \u0417\u0430\u043F\u0440\u043E\u0441: ' + userName + '|' + phone + '|' + birthday)
      };
      _this2.submitLeasingLead(function (isSUccess) {
        _this2.setState({ disableBtnLeasing: false });
        var toState = {
          disableBtnCodeVerification: false,
          userName: '',
          phone: '',
          step: isSUccess ? 'result' : step,
          errorMessage: !isSUccess && 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
          successMessage: '',
          isLeasingApproved: result && result.approved
        };
        _this2.setState(toState);
      }, moreLeasingParams);
    };

    var submitCodeVerificationForm = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.setState({ disableBtnCodeVerification: true });
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__["m" /* sendCodeVerification */]({
                  otp: codeVerification,
                  requestId: requestId
                }, fetch);

              case 3:
                result = _context.sent;

                if (!(!result || result.error)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', _this2.setState({
                  errorMessage: 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
                }));

              case 6:

                addLead(result);
                return _context.abrupt('return', result);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function submitCodeVerificationForm() {
        return _ref.apply(this, arguments);
      };
    }();

    submitCodeVerificationForm();
  };

  this.onSubmitUesrDataForm = function (e, serviceType) {
    e.preventDefault();

    var _state2 = _this2.state,
        phone = _state2.phone,
        userName = _state2.userName;

    var errorMsg = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__["l" /* userFormValidation */]({ phone: phone, userName: userName });

    if (errorMsg) {
      _this2.setState({ errorMessage: errorMsg });
      return;
    }

    if (serviceType === 'call') {
      _this2.fireEvent('consultation');
      _this2.setState({ disableBtnLeasing: true });
      _this2.submitLeasingLead(function (isSUccess) {
        _this2.setState({ disableBtnLeasing: false });
        var toState = {
          userName: '',
          phone: '',
          errorMessage: !isSUccess && 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
          successMessage: '',
          step: isSUccess ? 'recall' : _this2.state.step
        };
        _this2.setState(toState);
      });
    } else {
      _this2.fireEvent('online');
      _this2.setState({ disableBtnLeasingOnline: true });
      _this2.onSubmitLeasingOnline(function (isSUccess) {
        _this2.setState({ disableBtnLeasingOnline: false });
        if (isSUccess) _this2.setState({ step: 'verify' });
      });
    }
  };

  this.onSubmitLeasingOnline = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(cb) {
      var _state3, userName, phone, birthday, deviceId, fetch, success;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _state3 = _this2.state, userName = _state3.userName, phone = _state3.phone, birthday = _state3.birthday;
              deviceId = localStorage.getItem('applensDeviceId') || '';
              fetch = _this2.props.fetch;

              if (_this2.validateForm({ phone: phone, birthday: birthday })) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt('return', cb(false));

            case 5:
              success = function success(data) {
                if (!data.valid) {
                  var message = data.message || data.error && data.error.message;
                  var moreLeasingParams = {
                    comment: _this2.props.leasingParams.comment + ' | ' + ('"\u041E\u043D\u043B\u0430\u0439\u043D \u0420\u0435\u0448\u0435\u043D\u0438\u0435" - API \u043E\u0442\u0432\u0435\u0442 \u043E\u0442 finup: "' + message + '" \u0417\u0430\u043F\u0440\u043E\u0441: ' + userName + '|' + phone + '|' + birthday)
                  };
                  _this2.submitLeasingLead(function (isSUccess) {
                    _this2.setState({ disableBtnLeasing: false });
                    var toState = {
                      userName: '',
                      phone: '',
                      errorMessage: !isSUccess && 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
                      successMessage: '',
                      step: isSUccess ? 'recall' : _this2.state.step,
                      isLeasingApproved: false
                    };
                    _this2.setState(toState);
                    cb(false);
                  }, moreLeasingParams);
                } else {
                  _this2.setState({ requestId: data.requestId, errorMessage: '' });
                  cb(true);
                }
                return true;
              };

              __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__["d" /* fetchRequestId */]({ phone: phone, birthday: birthday, deviceId: deviceId }, fetch).then(success).catch(success);
              return _context2.abrupt('return', null);

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.onLeadCreated = function (success) {
    // const { leasingParams, modalMode } = this.props;
    var modalMode = _this2.props.modalMode;

    var partner = '';
    // const partner = isHapaiLeasing(leasingParams) ? 'hapai-' : '';
    var successFlag = success ? '-success' : '-fail';
    var postfix = modalMode ? '' : '-advertcard-sidebar';
    var event = partner + 'lead-create' + successFlag + postfix;
    _this2.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]);
  };

  this.submitAFinanceLeasingLead = function (cb, moreLeasingParams) {
    var _state4 = _this2.state,
        phone = _state4.phone,
        userName = _state4.userName;
    var _props3 = _this2.props,
        advert = _props3.advert,
        leasingParams = _props3.leasingParams,
        fetch = _props3.fetch;


    var leadsParams = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */]({ phone: phone, userName: userName }, advert, leasingParams, moreLeasingParams);

    __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__["a" /* createAFinanceLeda */](leadsParams, advert, fetch).then(function (data) {
      cb(!!data);
      _this2.onLeadCreated(!!data);
    }).catch(function () {
      cb(false);
      _this2.onLeadCreated(false);
    });

    return false;
  };

  this.submitUlfLeasingLead = function (cb) {
    var _state5 = _this2.state,
        phone = _state5.phone,
        userName = _state5.userName;
    var _props4 = _this2.props,
        advert = _props4.advert,
        leasingParams = _props4.leasingParams,
        fetch = _props4.fetch;


    var leadParams = __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({ phone: phone, userName: userName, leasingParams: leasingParams, advert: advert });

    __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_ulf__["a" /* createUlfLead */](leadParams, fetch).then(function (data) {
      cb(!!data);
      _this2.onLeadCreated(!!data);
    }).catch(function () {
      cb(false);
      _this2.onLeadCreated(false);
    });

    return false;
  };

  this.submitUlf24LeasingLead = function (cb) {
    var _state6 = _this2.state,
        phone = _state6.phone,
        userName = _state6.userName;
    var _props5 = _this2.props,
        advert = _props5.advert,
        leasingParams = _props5.leasingParams,
        fetch = _props5.fetch;


    var leadParams = __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({ phone: phone, userName: userName, leasingParams: leasingParams, advert: advert });

    __WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_ulf24__["a" /* createUlf24Lead */](leadParams, fetch).then(function (data) {
      cb(!!data);
      _this2.onLeadCreated(!!data);
    }).catch(function () {
      cb(false);
      _this2.onLeadCreated(false);
    });

    return false;
  };

  this.submitLeasingLead = function (cb, moreLeasingParams) {
    if (__WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__["k" /* isUlfLeasing */](_this2.props.leasingParams)) {
      _this2.submitUlfLeasingLead(cb);
    } else if (__WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__["j" /* isUlf24Leasing */](_this2.props.leasingParams)) {
      _this2.submitUlf24LeasingLead(cb);
      // } else if (isAutoMoneyLeasing(this.props.leasingParams)) {
      //   this.submitAutoMoneyLeasingLead(cb);
    } else {
      _this2.submitAFinanceLeasingLead(cb, moreLeasingParams);
    }
  };

  this.changeHandler = function (field, value) {
    var _this2$setState;

    _this2.setState((_this2$setState = {}, LeasingOnlineBanner__defineProperty(_this2$setState, field, value), LeasingOnlineBanner__defineProperty(_this2$setState, 'errorMessage', ''), _this2$setState));
  };

  this.validateForm = function (params) {
    var phone = params.phone,
        birthday = params.birthday;

    if (phone && !__WEBPACK_IMPORTED_MODULE_7_shared_validations_validations__["e" /* isValidPhone */](phone.replace(/\s/g, ''))) {
      _this2.setState({ errorMessage: 'Некорректный номер телефона' });
      return false;
    }

    if (birthday && !__WEBPACK_IMPORTED_MODULE_7_shared_validations_validations__["b" /* isValidDate */](birthday)) {
      _this2.setState({ errorMessage: 'Некорректная дата рождения' });
      return false;
    }
    return true;
  };
};

var mapDispatchToProps = { setDataLayer: __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */] };
var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user && state.user.user
  };
};

/* harmony default export */ __webpack_exports__["a"] = (LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_15_shared_hocs_withLeasingParams__["a" /* withLeasingParams */](__WEBPACK_IMPORTED_MODULE_17_shared_hocs_withTranslate__["a" /* withTranslate */](LeasingOnlineBanner_LeasingOnlineBanner))))));

/***/ }),

/***/ 1852:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_hocs_stats_withStatsEvents__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withFetch__ = __webpack_require__(1244);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var withAdvertPhoneView = function withAdvertPhoneView(WrappedComponent) {
  var _class, _temp2;

  var Component = __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](null, { setDataLayer: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["j" /* setDataLayer */] })((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        phones: null,
        hasDispatchedEvent: false,
        isFetching: false
      }, _this.fetchPhones = function (fetch, advertId) {
        _this.setState({ isFetching: true });

        return fetch((_this.props.isSpare ? __WEBPACK_IMPORTED_MODULE_7__constants_api__["a" /* default */].SPARE_PARTS.PHONES : __WEBPACK_IMPORTED_MODULE_7__constants_api__["a" /* default */].ADVERT.PHONES)(advertId)).then(function (r) {
          return r.json();
        }).then(function (phones) {
          _this.setState({ isFetching: false });

          return phones || [];
        }).catch(function () {
          _this.setState({ isFetching: false });

          return [];
        });
      }, _this.handleShowPhoneClick = function (advertID) {
        var shouldSendEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var cb = arguments[2];

        if (shouldSendEvent) {
          _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].showPhoneClick);
        }

        var _this$props = _this.props,
            fetch = _this$props.fetch,
            events = _this$props.events,
            authorID = _this$props.authorID,
            transport = _this$props.transport,
            agency = _this$props.agency,
            isSpare = _this$props.isSpare;

        var agencyId = agency && agency.id;
        var transportId = transport && transport.id;

        if (!_this.state.hasDispatchedEvent) {
          events.dispatchPhoneViewEvent(advertID, authorID, transportId, agencyId, isSpare);
          _this.setState({ hasDispatchedEvent: true });
        }

        if (_this.state.phones) {
          if (typeof cb === 'function') cb(_this.state.phones);
          return;
        }
        if (_this.state.isFetching) {
          return;
        }

        _this.fetchPhones(fetch, advertID).then(function (phones) {
          _this.setState({ phones: phones });
          if (typeof cb === 'function') cb(phones);
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            events = _props.events,
            props = _objectWithoutProperties(_props, ['events']);

        var isFetching = this.state.isFetching;


        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
          phones: this.state.phones,
          requestShowPhones: this.handleShowPhoneClick,
          isFetching: isFetching
        }, props));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withAdvertPhoneView(' + __WEBPACK_IMPORTED_MODULE_6__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    advertID: null,
    authorID: null,
    isSpare: false,
    transport: null,
    agency: null
  }, _temp2));

  return __WEBPACK_IMPORTED_MODULE_2_shared_hocs_stats_withStatsEvents__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8__withFetch__["a" /* withFetch */](Component));
};

/* harmony default export */ __webpack_exports__["a"] = (withAdvertPhoneView);

/***/ }),

/***/ 1854:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "da0cfcef.svg";

/***/ }),

/***/ 1877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/DealerServiceForm/service.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var sandEmail = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, fetch) {
    var service, slug, phone, name, advertId, formData, options, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            service = data.service, slug = data.slug, phone = data.phone, name = data.name, advertId = data.advertId;
            formData = JSON.stringify({
              service: service,
              slug: slug,
              phone: phone.replace(/\s/g, ''),
              name: name,
              advertId: advertId
            });
            options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            };
            _context.prev = 3;
            _context.next = 6;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].DEALERS.REQUEST_SERVICE, options).then(function (r) {
              return r.json();
            });

          case 6:
            result = _context.sent;

            if (!(!result || result.err)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return', false);

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](3);
            return _context.abrupt('return', false);

          case 14:
            return _context.abrupt('return', true);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[3, 11]]);
  }));

  return function sandEmail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/shared/components/DealerServiceForm/DealerServiceForm.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_validations_validations__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var DealerServiceForm = function (_React$Component) {
  _inherits(DealerServiceForm, _React$Component);

  function DealerServiceForm(props) {
    _classCallCheck(this, DealerServiceForm);

    var _this = _possibleConstructorReturn(this, (DealerServiceForm.__proto__ || Object.getPrototypeOf(DealerServiceForm)).call(this, props));

    DealerServiceForm__initialiseProps.call(_this);

    var user = _this.props.user;

    var userName = user && user.name || '';
    var phone = user && user.phones && user.phones[0].number || '';

    _this.state = {
      phone: phone,
      name: userName,
      errorMessage: '',
      successMessage: '',
      disabled: !(phone && phone.length && userName && userName.length)
    };
    return _this;
  }

  _createClass(DealerServiceForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          errorMessage = _state.errorMessage,
          successMessage = _state.successMessage,
          name = _state.name,
          phone = _state.phone,
          disabled = _state.disabled;
      var t = this.props.t;


      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a.root
      }, void 0, _jsx('form', {
        className: __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a.requestForm
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_UI__["c" /* InputPhoneNumber */], {
        name: 'phone',
        value: phone,
        changeHandler: function changeHandler(field, value) {
          return _this2.handleInput(field, value);
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_UI__["e" /* InputText */], {
        name: 'name',
        value: name,
        placeholder: name || t('Введите имя'),
        changeHandler: function changeHandler(field, value) {
          return _this2.handleInput(field, value);
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_UI__["a" /* Button */], {
        type: 'button',
        text: t('Подтвердить номер'),
        disabled: disabled,
        onClick: function onClick(e) {
          _this2.handleSubmit(e);
        }
      })), (errorMessage || successMessage) && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a.errorMessage, errorMessage), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a.successMessage, successMessage))
      }, void 0, t(errorMessage || successMessage)));
    }
  }]);

  return DealerServiceForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DealerServiceForm.defaultProps = {
  onSent: function onSent() {},
  advertInfo: null,
  user: null
};

var DealerServiceForm__initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.validateForm = function () {
    var phone = _this3.state.phone;

    if (phone && !__WEBPACK_IMPORTED_MODULE_8_shared_validations_validations__["e" /* isValidPhone */](phone.replace(/\s/g, ''))) {
      _this3.setState({
        errorMessage: _this3.props.t('Некорректный номер телефона')
      });
      return false;
    }
    return !!phone;
  };

  this.handleInput = function (field, value) {
    var _this3$setState;

    _this3.setState((_this3$setState = {}, _defineProperty(_this3$setState, field, value), _defineProperty(_this3$setState, 'errorMessage', ''), _defineProperty(_this3$setState, 'disabled', !_this3.state.phone || !_this3.state.name), _this3$setState));
  };

  this.handleSubmit = function () {
    if (!_this3.validateForm()) return;
    var _props = _this3.props,
        dealerSlug = _props.dealerSlug,
        service = _props.service,
        advertInfo = _props.advertInfo;
    var _state2 = _this3.state,
        phone = _state2.phone,
        name = _state2.name;

    var dataToEmail = {
      slug: dealerSlug,
      service: service,
      phone: phone,
      name: name
    };

    if (advertInfo && advertInfo.advertId) {
      dataToEmail.advertId = advertInfo.advertId;
    }

    _this3.setState({ disabled: true });
    var errMsg = 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже';
    sandEmail(dataToEmail, _this3.props.fetch).then(function (data) {
      _this3.setState({ disabled: false });
      if (data) _this3.props.onSent();else if (!data) _this3.setState({ errorMessage: errMsg });
    }).catch(function () {
      _this3.setState({
        disabled: false,
        errorMessage: errMsg
      });
    });
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user && state.user.user
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__DealerServiceForm_css___default.a)(__WEBPACK_IMPORTED_MODULE_6_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_5_shared_hocs_withTranslate__["a" /* withTranslate */](DealerServiceForm)))));

/***/ }),

/***/ 1878:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1879);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerServiceForm.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerServiceForm.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1879:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".TfW5D,.VV23o{position:relative;color:#d7433d;font-weight:400;font-size:13px;text-align:center;display:block;line-height:1.2;min-height:20px}.VV23o{color:#2c7e07;font-size:15px;font-weight:500}.wZg14>button,.wZg14>input{margin:5px 0}", ""]);

// exports
exports.locals = {
	"root": "_2fxs3",
	"errorMessage": "TfW5D",
	"successMessage": "VV23o",
	"requestForm": "wZg14"
};

/***/ }),

/***/ 1880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var _ref2 = _jsx('h2', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421\u043F\u0430\u0441\u0438\u0431\u043E!'
}));

var _ref3 = _jsx('p', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430!'
}));

var _ref4 = _jsx('p', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441 \u0432\u0430\u043C\u0438 \u0441\u0432\u044F\u0436\u0435\u0442\u0441\u044F \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 \u0430\u0432\u0442\u043E\u0441\u0430\u043B\u043E\u043D\u0430'
}));

var ThanksBlock = function ThanksBlock(_ref) {
  var ClassName = _ref.ClassName;
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css___default.a.thanksBlock, _defineProperty({}, ClassName, !!ClassName))
  }, void 0, _ref2, _ref3, _ref4);
};

ThanksBlock.defaultProps = {
  ClassName: ''
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__ThanksBlock_css___default.a)(ThanksBlock));

/***/ }),

/***/ 1881:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1882);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThanksBlock.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThanksBlock.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1882:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2fRVv{text-align:center;min-height:248px;padding-top:45px}", ""]);

// exports
exports.locals = {
	"thanksBlock": "_2fRVv"
};

/***/ }),

/***/ 1902:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1903);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsItem.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1903:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._18KxE{font-size:17px;color:#000;display:inline;font-weight:700;text-decoration:none;cursor:pointer;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out}._18KxE:hover{-webkit-box-shadow:inset 0 -6px 0 #ffeb39;box-shadow:inset 0 -6px 0 #ffeb39}._2ayW3{opacity:0}._2ayW3 a:hover{color:#000}._4-E00{position:relative;-webkit-box-flex:0;-ms-flex:0 0 32%;flex:0 0 32%;cursor:pointer;background-color:#fff;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.04);box-shadow:0 2px 8px rgba(0,0,0,.04);border-radius:2px}._4-E00 ._18KxE{font-weight:400;font-size:16px;line-height:1.68}._2DsrD ._18KxE{font-weight:700}._18Uq7{height:217px}._3FbYi{font-weight:400;padding:15px 25px}._1EOKH,._3FbYi{position:relative}._1EOKH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:100%;padding:0;margin-bottom:12px}._1EOKH ._18KxE{font-size:18px;line-height:1.54}._2Eymc{left:0;top:0;height:217px;-webkit-box-flex:0;-ms-flex:0 0 340px;flex:0 0 340px}._2Eymc,._3bmRD{position:relative}._3bmRD{font-weight:400;padding:20px 20px 15px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;background-color:#fff;width:100%}._2CbHG,.tKfJi{color:#a0a0a0;font-size:12px;padding-top:4px}.tKfJi{padding-top:10px}.l76L_{height:45px;border-radius:50%;width:auto;margin-right:10px}.OH5km{-ms-flex-line-pack:center;align-content:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-top:0}._1EKt4,.OH5km{display:-webkit-box;display:-ms-flexbox;display:flex}._1EKt4{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1NJCk{font-size:14px;color:#444}._2Eymc,._18Uq7{position:relative;background:#f1f1f1 no-repeat 50%/cover}._3Xo7U{background-size:60%}._2oeBk{opacity:.7;pointer-events:none}@media screen and (max-width:768px){._2Eymc{-webkit-box-flex:0;-ms-flex:0 0 180px;flex:0 0 180px}._1EOKH{padding:10px 0;margin-bottom:10px}._3bmRD{padding:0 0 0 20px}._1NJCk,.l76L_{display:none}}@media screen and (max-width:400px){._2Eymc{-webkit-box-flex:0;-ms-flex:0 0 145px;flex:0 0 145px}._1EOKH ._18KxE{font-size:13px}._1EOKH{padding:10px 0;margin-bottom:10px}._2CbHG{font-size:11px}._3bmRD{padding:0 0 0 12px}._1NJCk,.l76L_{display:none}}@media screen and (min-width:769px){._2DLNp{height:170px!important}}", ""]);

// exports
exports.locals = {
	"link": "_18KxE",
	"stretchedLink": "_2ayW3 stretched",
	"tableNews": "_4-E00",
	"primary": "_2DsrD",
	"tableThumb": "_18Uq7",
	"tableText": "_3FbYi",
	"listNews": "_1EOKH",
	"listThumb": "_2Eymc",
	"listText": "_3bmRD",
	"tableDate": "tKfJi",
	"listDate": "_2CbHG",
	"avatar": "l76L_",
	"listBottom": "OH5km",
	"listBottomCard": "_1EKt4",
	"author": "_1NJCk",
	"placeholderThumb": "_3Xo7U",
	"active": "_2oeBk",
	"imageTabletHeight": "_2DLNp"
};

/***/ }),

/***/ 1907:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseMatches = __webpack_require__(1908),
    baseMatchesProperty = __webpack_require__(1915),
    identity = __webpack_require__(327),
    isArray = __webpack_require__(39),
    property = __webpack_require__(1916);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;

/***/ }),

/***/ 1908:
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1909),
    getMatchData = __webpack_require__(1914),
    matchesStrictComparable = __webpack_require__(1705);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;

/***/ }),

/***/ 1909:
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(509),
    baseIsEqual = __webpack_require__(1666);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;

/***/ }),

/***/ 1910:
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(509),
    equalArrays = __webpack_require__(1703),
    equalByTag = __webpack_require__(1912),
    equalObjects = __webpack_require__(1913),
    getTag = __webpack_require__(330),
    isArray = __webpack_require__(39),
    isBuffer = __webpack_require__(195),
    isTypedArray = __webpack_require__(331);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),

/***/ 1911:
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

/***/ }),

/***/ 1912:
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(108),
    Uint8Array = __webpack_require__(524),
    eq = __webpack_require__(324),
    equalArrays = __webpack_require__(1703),
    mapToArray = __webpack_require__(525),
    setToArray = __webpack_require__(512);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

/***/ }),

/***/ 1913:
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(523);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),

/***/ 1914:
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(1704),
    keys = __webpack_require__(193);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
}

module.exports = getMatchData;

/***/ }),

/***/ 1915:
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1666),
    get = __webpack_require__(1709),
    hasIn = __webpack_require__(522),
    isKey = __webpack_require__(508),
    isStrictComparable = __webpack_require__(1704),
    matchesStrictComparable = __webpack_require__(1705),
    toKey = __webpack_require__(138);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;

/***/ }),

/***/ 1916:
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1917),
    basePropertyDeep = __webpack_require__(1918),
    isKey = __webpack_require__(508),
    toKey = __webpack_require__(138);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;

/***/ }),

/***/ 1917:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;

/***/ }),

/***/ 1918:
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(323);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;

/***/ }),

/***/ 1919:
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1920),
    createBaseEach = __webpack_require__(1923);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

/***/ }),

/***/ 1920:
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1921),
    keys = __webpack_require__(193);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

/***/ }),

/***/ 1921:
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1922);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

/***/ }),

/***/ 1922:
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

/***/ }),

/***/ 1923:
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(137);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

/***/ }),

/***/ 1924:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee1983dc.png";

/***/ }),

/***/ 1925:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1926);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./WarrantyLogo.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./WarrantyLogo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1926:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2Reoz{color:#000;display:inline-block;font-size:14px;padding-left:5px;text-transform:uppercase;font-weight:700;text-align:center;line-height:14px}.ZYuco{height:100%;max-height:30px;width:auto}", ""]);

// exports
exports.locals = {
	"tooltipTitle": "_2Reoz",
	"tooltipIcon": "ZYuco"
};

/***/ }),

/***/ 1927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/Discount/InfoModal/InfoModal.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfoModal_css__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InfoModal_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var infoList = ['Выбирайте модель автомобиля', 'Заполняйте онлайн-форму на сайте продавца', 'Получайте телефонную консультацию', 'Оформляйте заказ онлайн', 'Финальный шаг – безопасная передача автомобиля'];

function InfoModal(props) {
  var showModal = props.showModal,
      switchModal = props.switchModal,
      isMobile = props.isMobile,
      t = props.t;


  return _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
    modalCN: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.modal, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.mobileModal, isMobile)),
    onClose: switchModal,
    isOpen: showModal
  }, void 0, _jsx('div', {
    onClick: switchModal,
    className: isMobile ? __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.mobileRoot : __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.desktopRoot
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.mainInfoText, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.mobileMainInfoTex, isMobile))
  }, void 0, t('Для обеспечения безопасности клиентов вы можете купить автомобиль в онлайн режиме. При покупке в онлайн режиме действует указанная скидка от заявленной цены.')), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.optionSection
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.optionTitle
  }, void 0, t('Как купить онлайн:')), infoList.map(function (item, index) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.modalOptions
    }, item, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.optionItemTitle
    }, void 0, index + 1, '.'), _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.optionItemText
    }, void 0, t(item)));
  }))), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a.closeBtn,
    onClick: switchModal
  }));
}

/* harmony default export */ var InfoModal_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__InfoModal_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](InfoModal)));
// CONCATENATED MODULE: ./src/shared/components/Discount/Discount.js
/* harmony import */ var Discount___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Discount___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Discount___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Discount___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var Discount___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(Discount___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var Discount___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var Discount___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(Discount___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Discount_css__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Discount_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Discount_css__);
var Discount__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Discount__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var isMobile = "desktop" === 'mobile';

var Discount_Discount = function (_React$Component) {
  _inherits(Discount, _React$Component);

  function Discount() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Discount);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Discount.__proto__ || Object.getPrototypeOf(Discount)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModal: false
    }, _this.switchModal = function (e) {
      e.preventDefault();
      _this.setState({ showModal: !_this.state.showModal });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Discount, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          discount = _props.discount,
          t = _props.t;
      var showModal = this.state.showModal;


      return Discount__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__Discount_css___default.a.root,
        onClick: this.switchModal
      }, void 0, Discount__jsx('span', {
        className: Discount___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__Discount_css___default.a.info, Discount__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__Discount_css___default.a.desktopInfo, !isMobile))
      }, void 0, t('При покупке онлайн')), Discount__jsx('span', {
        className: Discount___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__Discount_css___default.a.info, __WEBPACK_IMPORTED_MODULE_6__Discount_css___default.a.infoPercent)
      }, void 0, '-', discount, '%'), Discount__jsx(InfoModal_defaultExport, {
        isMobile: isMobile,
        showModal: showModal,
        switchModal: this.switchModal
      }));
    }
  }]);

  return Discount;
}(Discount___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__Discount_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](Discount_Discount)));

/***/ }),

/***/ 1928:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1929);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InfoModal.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InfoModal.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1929:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2xpKS{position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;border-radius:4px;width:700px;display:-webkit-box;display:-ms-flexbox;display:flex;padding:25px 25px 35px}._3VfFh{padding:25px 0;width:95%}.UzjYO{min-width:400px;height:auto}.ySG2w{width:90%;max-height:350px;overflow-y:auto}._2vdvi{font-weight:700;margin:0 10px 10px;text-transform:uppercase}._3fr06{font-weight:700;padding:2px 10px}.LMvVJ{padding:10px 20px;font-size:16px}._3ea1a{padding:10px 0}._3pNi2{text-align:left}._276tr{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:end;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:15px;margin-bottom:5px}._2q7a2{line-height:16px}._1SEoY{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px}._1SEoY:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"modal": "_2xpKS",
	"mobileModal": "_3VfFh",
	"desktopRoot": "UzjYO",
	"mobileRoot": "ySG2w",
	"optionTitle": "_2vdvi",
	"optionItemTitle": "_3fr06",
	"mainInfoText": "LMvVJ",
	"mobileMainInfoTex": "_3ea1a",
	"optionSection": "_3pNi2",
	"modalOptions": "_276tr",
	"optionItemText": "_2q7a2",
	"closeBtn": "_1SEoY"
};

/***/ }),

/***/ 1930:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1931);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Discount.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Discount.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1931:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3jsho{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:5px 0;font-weight:600;font-size:13px;z-index:100}._12AGs{padding:5px 10px;border:1px solid #ffc107;border-bottom-left-radius:2px;border-top-left-radius:2px}._3-yjN{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:center}._2VNG9{background-color:#fbd60b;border-bottom-right-radius:2px;border-top-right-radius:2px}", ""]);

// exports
exports.locals = {
	"root": "_3jsho",
	"info": "_12AGs",
	"desktopInfo": "_3-yjN",
	"infoPercent": "_2VNG9"
};

/***/ }),

/***/ 1932:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "607da9c4.svg";

/***/ }),

/***/ 1933:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0706bed3.svg";

/***/ }),

/***/ 1934:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fde6b7e4.svg";

/***/ }),

/***/ 1960:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8b795ba6.png";

/***/ }),

/***/ 1962:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_fb_icon_png__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_fb_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_fb_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_viber_icon_png__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_viber_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_viber_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_whatsapp_icon_png__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_whatsapp_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_whatsapp_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_telegram_icon_png__ = __webpack_require__(2073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_telegram_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_assets_images_telegram_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DealerSocials_css__ = __webpack_require__(2074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DealerSocials_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DealerSocials_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var isMobile = "desktop" === 'mobile';

function DealerSocials(props) {
  var messengers = props.messengers;

  var messengersIcons = {
    telegram: __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_telegram_icon_png___default.a,
    viber: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_viber_icon_png___default.a,
    'facebook-messenger': __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_fb_icon_png___default.a,
    whatsapp: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_whatsapp_icon_png___default.a
  };
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__DealerSocials_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_8__DealerSocials_css___default.a.mobileRoot, isMobile))
  }, void 0, messengers.map(function (item) {
    return _jsx('a', {
      href: item.link,
      target: '_blank'
    }, item.link, _jsx('img', {
      src: messengersIcons[item.messenger],
      alt: '',
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__DealerSocials_css___default.a.socialIcon, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_8__DealerSocials_css___default.a.mobileSocIcon, isMobile))
    }));
  }));
}

DealerSocials.defaultProps = {};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__DealerSocials_css___default.a)(DealerSocials));

/***/ }),

/***/ 2008:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var eq = __webpack_require__(324),
    isArrayLike = __webpack_require__(137),
    isIndex = __webpack_require__(197),
    isObject = __webpack_require__(71);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

/***/ }),

/***/ 2055:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4ad5dbc2.png";

/***/ }),

/***/ 2056:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_WarrantyLogo_WarrantyLogo__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_GreenCheckbox_png__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_GreenCheckbox_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_GreenCheckbox_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var isMobile = "desktop" === 'mobile';

function WarrantyModal(props) {
  var warranty = props.warranty,
      showModal = props.showModal,
      switchModal = props.switchModal;


  return _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
    modalCN: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.modal, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.mobileModal, isMobile)),
    onClose: switchModal,
    isOpen: showModal
  }, void 0, _jsx('div', {
    onClick: switchModal,
    className: isMobile ? __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.mobileRoot : __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.desktopRoot
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.modalWarrantyBlock
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_WarrantyLogo_WarrantyLogo__["a" /* default */], {
    warranty: warranty,
    tooltipTitle: __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.tooltipTitle
  })), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.description
  }, void 0, warranty.description), _jsx('div', {}, void 0, warranty.options.map(function (item) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.modalOptions
    }, item.title, _jsx('img', {
      src: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_GreenCheckbox_png___default.a,
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.checkboxIcon, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.mobileCheckboxIcon, isMobile)),
      alt: ''
    }), _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.optionTitles, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.mobileOptionTitles, isMobile))
    }, void 0, item.title), _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.optionDescription, __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.description)
    }, void 0, item.description));
  }))), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a.closeBtn,
    onClick: switchModal
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__WarrantyModal_css___default.a)(WarrantyModal));

/***/ }),

/***/ 2057:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2058);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./WarrantyModal.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./WarrantyModal.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2058:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1T90C{position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;border-radius:4px;width:700px;display:-webkit-box;display:-ms-flexbox;display:flex;padding:25px 25px 35px}._1KLV3{padding:25px 0;width:95%}._10bvs{min-width:400px;height:auto}._1kzLV{width:90%;max-height:350px;overflow-y:auto}.c3MdG{font-weight:700;font-size:15px;padding:20px 15px 5px;text-align:left}._363Qw{padding:20px 25px 5px}._3S9mt{text-align:justify;font-size:13px}.xI3LP{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;padding-bottom:15px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3Y8Tw{font-size:16px!important}._2N4d3{position:relative}._1p_Tp{position:absolute;width:12px;height:auto;top:25px;left:-2px}._2u9wZ{top:24px;left:5px}._1fhY0{line-height:16px;font-size:13px;padding:0 25px}._1-J7S{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px}._1-J7S:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"modal": "_1T90C",
	"mobileModal": "_1KLV3",
	"desktopRoot": "_10bvs",
	"mobileRoot": "_1kzLV",
	"optionTitles": "c3MdG",
	"mobileOptionTitles": "_363Qw",
	"description": "_3S9mt",
	"modalWarrantyBlock": "xI3LP",
	"tooltipTitle": "_3Y8Tw",
	"modalOptions": "_2N4d3",
	"checkboxIcon": "_1p_Tp",
	"mobileCheckboxIcon": "_2u9wZ",
	"optionDescription": "_1fhY0",
	"closeBtn": "_1-J7S"
};

/***/ }),

/***/ 2071:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a0bf970f.png";

/***/ }),

/***/ 2072:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "007f905e.png";

/***/ }),

/***/ 2073:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee4472d5.png";

/***/ }),

/***/ 2074:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2075);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerSocials.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerSocials.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2075:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._12cYb{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._2L3Oy,._12cYb{display:-webkit-box;display:-ms-flexbox;display:flex}._2L3Oy{padding:4px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:10px;background:#fff;text-align:center;color:#000;border:1px solid #ffd906;border-radius:3px}.Eybs_{width:26px;margin:5px 2px 2px}._2-cmO{width:32px;margin:0 13px}", ""]);

// exports
exports.locals = {
	"root": "_12cYb",
	"mobileRoot": "_2L3Oy",
	"socialIcon": "Eybs_",
	"mobileSocIcon": "_2-cmO"
};

/***/ }),

/***/ 2076:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var HEIGHT_TO_WIDTH_RATIO = 1.15;

var withSliderLogic = function withSliderLogic(Slider) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        id: null,
        index: 0,
        left: 0,
        fullScreenSlideWidth: 800
      }, _this.setNextId = function (e) {
        if (e) {
          e.stopPropagation();
        }
        var photos = _this.props.photos;
        var id = _this.state.id;

        var index = photos.findIndex(function (photo) {
          return photo.id === id;
        });

        _this.setState({ id: photos[(photos.length + index + 1) % photos.length].id });
        _this.setSliderPosition();
      }, _this.setPrevId = function () {
        var photos = _this.props.photos;
        var id = _this.state.id;

        var index = photos.findIndex(function (photo) {
          return photo.id === id;
        });

        _this.setState({ id: photos[(photos.length + index - 1) % photos.length].id });
        _this.setSliderPosition();
      }, _this.setImageId = function (id) {
        _this.setState({ id: id });
      }, _this.setSliderPosition = function () {
        var id = _this.state.id;
        var _this$props = _this.props,
            photos = _this$props.photos,
            sliderImageOptions = _this$props.sliderImageOptions;
        var width = sliderImageOptions.width,
            marginRight = sliderImageOptions.marginRight;

        var fullImageWidth = width + marginRight;
        var windowWidth = window.innerWidth;
        var sliderWidth = photos.length * fullImageWidth;

        if (sliderWidth > windowWidth) {
          var maxLeft = sliderWidth - windowWidth;
          var currentImageIndex = photos.findIndex(function (photo) {
            return photo.id === id;
          });
          var imageLeft = currentImageIndex * fullImageWidth;
          var left = imageLeft - windowWidth / 2 < maxLeft ? imageLeft - windowWidth / 2 : maxLeft;

          _this.setState({ left: left > 0 ? left : 0 });
        }
      }, _this.setFullscreenImage = function (e) {
        var id = parseFloat(e.target.id);
        _this.setState({ id: id });
        _this.setSliderPosition();
      }, _this.setPreviewImage = function (index) {
        _this.setState({ index: parseFloat(index) });
      }, _this.decrementIndex = function () {
        var photos = _this.props.photos;
        var index = _this.state.index;


        _this.setState({ index: (photos.length + index - 1) % photos.length });
      }, _this.incrementIndex = function () {
        var photos = _this.props.photos;
        var index = _this.state.index;


        _this.setState({ index: (photos.length + index + 1) % photos.length });
      }, _this.closeSlider = function () {
        _this.setState({ id: null });
      }, _this.handleKeyboardClick = function (e) {
        var id = _this.state.id;
        var key = e.key;


        if (key === 'ArrowLeft') {
          if (id) {
            _this.setPrevId();
          } else {
            _this.decrementIndex();
          }
        } else if (key === 'ArrowRight') {
          if (id) {
            _this.setNextId();
          } else {
            _this.incrementIndex();
          }
        } else if (key === 'Escape') {
          _this.closeSlider();
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('keyup', this.handleKeyboardClick);
        /* eslint-disable react/no-did-mount-set-state */
        this.setState({
          fullScreenSlideWidth: Math.round(window.innerHeight * HEIGHT_TO_WIDTH_RATIO)
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('keyup', this.handleKeyboardClick);
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            id = _state.id,
            index = _state.index,
            left = _state.left,
            fullScreenSlideWidth = _state.fullScreenSlideWidth;

        var newProps = {
          id: id,
          index: index,
          left: left,
          fullScreenSlideWidth: fullScreenSlideWidth,
          setFullscreenImage: this.setFullscreenImage,
          closeSlider: this.closeSlider,
          setPrevId: this.setPrevId,
          setNextId: this.setNextId,
          setPreviewImage: this.setPreviewImage,
          incrementIndex: this.incrementIndex,
          decrementIndex: this.decrementIndex,
          setImageId: this.setImageId
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Slider, _extends({}, this.props, newProps));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.defaultProps = {
    photos: [],
    sliderImageOptions: {
      height: 70,
      width: 100,
      marginRight: 10
    }
  }, _temp2;
};

/* harmony default export */ __webpack_exports__["a"] = (withSliderLogic);

/***/ }),

/***/ 2235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var withDialogs = function withDialogs(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref,
          _this2 = this;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.getVerifiedPhone = function () {
        var stateUser = _this.props.user;
        var user = stateUser.user;


        return user && user.phones && user.phones.find(function (phone) {
          return !!phone.is_verified;
        }) || null;
      }, _this.handleSendMessage = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(textareaMsg, advertId) {
          var _this$props, fetch, _this$props$user, token, user, phone, data;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$props = _this.props, fetch = _this$props.fetch, _this$props$user = _this$props.user, token = _this$props$user.token, user = _this$props$user.user;
                  phone = _this.getVerifiedPhone();

                  if (!(user && token)) {
                    _context.next = 6;
                    break;
                  }

                  data = {
                    sender_name: user.name || user.email,
                    sender_phone: phone && phone.number,
                    text: textareaMsg,
                    message_type: 'question',
                    details: {}
                  };
                  _context.next = 6;
                  return _this.sendMsg(fetch, advertId, token, data);

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }(), _this.sendMsg = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fetch, advertId, token, data) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return fetch(__WEBPACK_IMPORTED_MODULE_7_shared_constants_api__["a" /* default */].SEND_MESSAGES(advertId), {
                    method: 'POST',
                    headers: {
                      Authorization: 'JWT ' + token
                    },
                    body: JSON.stringify(data)
                  }).then(function (r) {
                    if (r.status) {
                      _this.props.enqueueNotification({
                        text: _this.props.t('Сообщение отправлено'),
                        type: __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__["a" /* default */].SUCCESS
                      });
                      r.json();
                    }
                  });

                case 2:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x3, _x4, _x5, _x6) {
          return _ref3.apply(this, arguments);
        };
      }(), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
          handleSendMessage: this.handleSendMessage,
          verifiedPhone: this.getVerifiedPhone()
        }, this.props));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withDialogs(' + __WEBPACK_IMPORTED_MODULE_8_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.contextTypes = {
    store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape()
  }, _temp2);

  var mapStateToProps = function mapStateToProps(_ref4) {
    var user = _ref4.user;
    return { user: user };
  };
  var mapDispatchToProps = { enqueueNotification: __WEBPACK_IMPORTED_MODULE_5_shared_actions_notifications__["a" /* enqueueNotification */] };

  return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](Component)));
};

/* harmony default export */ __webpack_exports__["a"] = (withDialogs);

/***/ }),

/***/ 2236:
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(2332),
    baseAggregator = __webpack_require__(2333),
    baseIteratee = __webpack_require__(1907),
    isArray = __webpack_require__(39);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
    return function (collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}

module.exports = createAggregator;

/***/ }),

/***/ 2253:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "61c2d140.svg";

/***/ }),

/***/ 2273:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (root, factory) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object') {
    module.exports = factory();
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    root.getYouTubeID = factory();
  }
})(this, function (exports) {

  return function (url, opts) {
    if (opts == undefined) {
      opts = { fuzzy: true };
    }

    if (/youtu\.?be/.test(url)) {

      // Look first for known patterns
      var i;
      var patterns = [/youtu\.be\/([^#\&\?]{11})/, // youtu.be/<id>
      /\?v=([^#\&\?]{11})/, // ?v=<id>
      /\&v=([^#\&\?]{11})/, // &v=<id>
      /embed\/([^#\&\?]{11})/, // embed/<id>
      /\/v\/([^#\&\?]{11})/ // /v/<id>
      ];

      // If any pattern matches, return the ID
      for (i = 0; i < patterns.length; ++i) {
        if (patterns[i].test(url)) {
          return patterns[i].exec(url)[1];
        }
      }

      if (opts.fuzzy) {
        // If that fails, break it apart by certain characters and look 
        // for the 11 character key
        var tokens = url.split(/[\/\&\?=#\.\s]/g);
        for (i = 0; i < tokens.length; ++i) {
          if (/^[^#\&\?]{11}$/.test(tokens[i])) {
            return tokens[i];
          }
        }
      }
    }

    return null;
  };
});

/***/ }),

/***/ 2285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var withDealerGAEvent = function withDealerGAEvent(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _window = window,
            ga = _window.ga;
        var dealerInfo = this.props.dealerInfo;

        var gaAccount = dealerInfo && dealerInfo.ga_account;

        if (ga && gaAccount) {
          ga('create', gaAccount, 'avtobazar.ua', { name: 'cTracker' });
          ga('cTracker.send', {
            hitType: 'event',
            eventCategory: 'Avtobazar',
            eventAction: 'pageview',
            eventLabel: window.location.href
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props);
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withDealerGAEvent(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp;
};

/* harmony default export */ __webpack_exports__["a"] = (withDealerGAEvent);

/***/ }),

/***/ 2324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/Elements/IsGuaranteedElement/IsGuaranteedElement.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IsGuaranteedElement_css__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IsGuaranteedElement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__IsGuaranteedElement_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["i" /* GuaranteedIcon */], {});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u044F \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u0443\u0435\u0442'
});

var IsGuaranteedElement = function IsGuaranteedElement(_ref) {
  var _cx;

  var type = _ref.type,
      intl = _ref.intl;
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__IsGuaranteedElement_css___default.a.root, (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__IsGuaranteedElement_css___default.a.iconType, type === 'icon'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__IsGuaranteedElement_css___default.a.textType, type === 'text'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__IsGuaranteedElement_css___default.a.iconWithText, type === 'iconWithText'), _cx)),
    title: intl.formatMessage({ id: 'Ассоциация гарантирует' })
  }, void 0, _ref2, type !== 'icon' && _ref3);
};

IsGuaranteedElement.defaultProps = {
  type: 'text'
};
/* harmony default export */ var IsGuaranteedElement_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__IsGuaranteedElement_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](IsGuaranteedElement)));
// CONCATENATED MODULE: ./src/shared/components/Elements/IsVerifiedElement/IsVerifiedElement.js
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(IsVerifiedElement___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(IsVerifiedElement___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(IsVerifiedElement___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(IsVerifiedElement___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var IsVerifiedElement___WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IsVerifiedElement_css__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IsVerifiedElement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__IsVerifiedElement_css__);
var IsVerifiedElement__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function IsVerifiedElement__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable prettier/prettier */









var IsVerifiedElement__ref2 = IsVerifiedElement__jsx(IsVerifiedElement___WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["r" /* VerifiedIcon */], {});

var IsVerifiedElement__ref3 = IsVerifiedElement__jsx(IsVerifiedElement___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u0442\u043D\u0451\u0440'
});

var IsVerifiedElement = function IsVerifiedElement(_ref) {
  var _cx;

  var type = _ref.type,
      intl = _ref.intl;
  return IsVerifiedElement__jsx('div', {
    className: IsVerifiedElement___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__IsVerifiedElement_css___default.a.root, (_cx = {}, IsVerifiedElement__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__IsVerifiedElement_css___default.a.iconType, type === 'icon'), IsVerifiedElement__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__IsVerifiedElement_css___default.a.textType, type === 'text'), IsVerifiedElement__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__IsVerifiedElement_css___default.a.iconWithText, type === 'iconWithText'), _cx)),
    title: intl.formatMessage({ id: 'Проверенный партнёр' })
  }, void 0, IsVerifiedElement__ref2, type !== 'icon' && IsVerifiedElement__ref3);
};

IsVerifiedElement.defaultProps = {
  type: 'text'
};

/* harmony default export */ var IsVerifiedElement_defaultExport = (IsVerifiedElement___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__IsVerifiedElement_css___default.a)(IsVerifiedElement___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](IsVerifiedElement)));
// CONCATENATED MODULE: ./src/shared/components/Elements/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return IsGuaranteedElement_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return IsVerifiedElement_defaultExport; });



/***/ }),

/***/ 2325:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2326);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./IsGuaranteedElement.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./IsGuaranteedElement.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2326:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2DT4g{color:#7f46ca;font-weight:600;font-size:14px;padding:2px 0}._1ikT5,._3nFg1{width:42px;height:42px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:rgba(127,70,202,.1);border-radius:2px}._1ikT5{width:auto}._3nFg1>svg{width:20px;height:20px}._1ikT5>svg,._2GexU>svg{margin-right:6px}", ""]);

// exports
exports.locals = {
	"root": "_2DT4g",
	"iconWithText": "_1ikT5",
	"iconType": "_3nFg1",
	"textType": "_2GexU"
};

/***/ }),

/***/ 2327:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2328);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./IsVerifiedElement.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./IsVerifiedElement.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2328:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2b_yS{color:#6cbe00;font-weight:600;font-size:14px;padding:2px 0}._2O_si,._473v2{width:42px;height:42px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:rgba(108,190,0,.1);border-radius:2px}._473v2{width:auto}._2O_si>svg{width:16px;height:20px}._36dcy>svg,._473v2>svg{margin-right:6px}", ""]);

// exports
exports.locals = {
	"root": "_2b_yS",
	"iconWithText": "_473v2",
	"iconType": "_2O_si",
	"textType": "_36dcy"
};

/***/ }),

/***/ 2330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchStats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__ = __webpack_require__(2331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_subDays__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_stats__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_api__ = __webpack_require__(29);







var fetchStats = function fetchStats(fetch, identifiers) {
  var isSpare = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return fetch(__WEBPACK_IMPORTED_MODULE_4__constants_api__["a" /* default */].STATS.AGGS(identifiers, __WEBPACK_IMPORTED_MODULE_2_shared_helpers_locale__["c" /* getFormattedDateFns */](__WEBPACK_IMPORTED_MODULE_1_date_fns_subDays__["default"](new Date(), 30), 'yyyy-MM-dd'), isSpare ? [__WEBPACK_IMPORTED_MODULE_3__constants_stats__["d" /* OBJECT_TYPES */].SPARE_PART] : [__WEBPACK_IMPORTED_MODULE_3__constants_stats__["d" /* OBJECT_TYPES */].ADVERT])).then(function (response) {
    if (!response.ok) {
      throw new Error('Не удалось загрузить статистику');
    }

    return response;
  }).then(function (r) {
    return r.json();
  }).then(function (stats) {
    return stats.map(function (_ref) {
      var id = _ref.id,
          dates = _ref.dates;
      return {
        id: id,
        phoneViews: dates.map(function (_ref2) {
          var objectTypes = _ref2.object_types;
          return (objectTypes.find(function (type) {
            return type.object_type === isSpare ? __WEBPACK_IMPORTED_MODULE_3__constants_stats__["d" /* OBJECT_TYPES */].SPARE_PART : __WEBPACK_IMPORTED_MODULE_3__constants_stats__["d" /* OBJECT_TYPES */].ADVERT;
          }).events.find(function (event) {
            return event.event === __WEBPACK_IMPORTED_MODULE_3__constants_stats__["b" /* EVENT_TYPES */].PHONE_CLICK;
          }) || {}).count;
        }).reduce(function (sum, count) {
          return sum + (count || 0);
        }, 0),
        dates: __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default.a(dates.map(function (_ref3) {
          var date = _ref3.date,
              objectTypes = _ref3.object_types;
          return {
            date: date,
            count: (objectTypes.find(function (type) {
              return type.object_type === isSpare ? __WEBPACK_IMPORTED_MODULE_3__constants_stats__["d" /* OBJECT_TYPES */].SPARE_PART : __WEBPACK_IMPORTED_MODULE_3__constants_stats__["d" /* OBJECT_TYPES */].ADVERT;
            }).events.find(function (event) {
              return event.event === __WEBPACK_IMPORTED_MODULE_3__constants_stats__["b" /* EVENT_TYPES */].VIEW;
            }) || {}).count
          };
        }), function (obj) {
          return obj.date;
        })
      };
    });
  });
};

/***/ }),

/***/ 2331:
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(333),
    createAggregator = __webpack_require__(2236);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function (result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;

/***/ }),

/***/ 2332:
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;

/***/ }),

/***/ 2333:
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1919);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function (value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;

/***/ }),

/***/ 2370:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ada41ade.svg";

/***/ }),

/***/ 2371:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de309d3c.svg";

/***/ }),

/***/ 2462:
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(560),
    isIterateeCall = __webpack_require__(2008),
    toInteger = __webpack_require__(561);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, index += size);
  }
  return result;
}

module.exports = chunk;

/***/ }),

/***/ 2463:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2464);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsBlock.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsBlock.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2464:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".wAN2u{position:relative}._20geN{font-size:24px;font-weight:700}._3ogaN{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._2agIP{margin-bottom:20px}._3Yh2P{display:-webkit-box;display:-ms-flexbox;display:flex}._304SK{width:calc(33% - 20px)}._15uJv,._304SK{margin-right:20px;margin-bottom:20px}._15uJv{width:calc(50% - 10px)!important;-ms-flex-preferred-size:auto!important;flex-basis:auto!important}._1qxzH{margin-right:18px;width:calc(50% - 18px)!important}._304SK:last-of-type{margin-right:0}@media screen and (max-width:768px){._20geN{font-size:18px;margin:14px 0}}._2-zdu{font-size:17px;font-weight:700}.wAN2u a{text-decoration:none;color:#000}._2stqR{padding:15px 0 40px}.nEg7E{font-size:15px;text-align:end;color:#0074c2;display:block}", ""]);

// exports
exports.locals = {
	"root": "wAN2u",
	"title": "_20geN",
	"newsContainer": "_3ogaN",
	"primary": "_2agIP",
	"row": "_3Yh2P",
	"newsItem": "_304SK",
	"newsItem2Col": "_15uJv",
	"videoItem2Col": "_1qxzH",
	"videoTitle": "_2-zdu",
	"videoBLock": "_2stqR",
	"showAllTitle": "nEg7E"
};

/***/ }),

/***/ 2711:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withDialogs__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DialogForm_css__ = __webpack_require__(2712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DialogForm_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var isMobile = "desktop" === 'mobile';

var DialogForm = function (_React$Component) {
  _inherits(DialogForm, _React$Component);

  function DialogForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DialogForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DialogForm.__proto__ || Object.getPrototypeOf(DialogForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      textareaMsg: ''
    }, _this.onEnterPress = function (e) {
      if (e.keyCode === 13 && e.shiftKey === false) {
        e.preventDefault();
        _this.submitForm();
      }
    }, _this.submitForm = function () {
      var onSubmit = _this.props.onSubmit;
      var textareaMsg = _this.state.textareaMsg;


      if (textareaMsg) {
        _this.setState({ textareaMsg: '' });
        onSubmit(textareaMsg);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DialogForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          classForScroll = _props.classForScroll,
          verifiedPhone = _props.verifiedPhone,
          customStyle = _props.customStyle,
          token = _props.user.token,
          children = _props.children;
      var textareaMsg = this.state.textareaMsg;

      var disabled = !textareaMsg || !verifiedPhone;
      var rootClass = isMobile ? __WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default.a.root;
      return _jsx('form', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(rootClass, customStyle)
      }, void 0, _jsx('textarea', {
        placeholder: t('Напишите сообщение...'),
        className: __WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default.a.textareaMsg,
        value: textareaMsg,
        onChange: function onChange(e) {
          return _this2.setState({ textareaMsg: e.target.value });
        },
        onKeyDown: disabled ? function () {} : this.onEnterPress
      }), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default.a.infoBlock
      }, void 0, _jsx('div', {}, void 0, !verifiedPhone && !!token && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default.a.verifyInfoMsg
      }, void 0, t('Для активации сообщений, нужно'), ' ', _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_Link_Link__["a" /* default */], {
        to: '/profile/'
      }, void 0, t('указать и подтвердить')), ' ', t('номер телефона')), !token && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default.a.verifyInfoMsg
      }, void 0, t('Для активации сообщений, нужно'), ' ', _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_Link_Link__["a" /* default */], {
        to: '/login/'
      }, void 0, t('авторизоваться'))), children), _jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default.a.btnSend + ' ' + classForScroll + ' ' + (disabled ? __WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default.a.disabledBtn : ''),
        onClick: this.submitForm,
        disabled: disabled,
        'data-lens-event': 'contactSellerClick'
      }, void 0, t('Отправить'))));
    }
  }]);

  return DialogForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DialogForm.defaultProps = {
  classForScroll: '',
  customStyle: '',
  verifiedPhone: null,
  children: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__DialogForm_css___default.a)(__WEBPACK_IMPORTED_MODULE_5_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withDialogs__["a" /* default */](DialogForm))));

/***/ }),

/***/ 2712:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2713);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DialogForm.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DialogForm.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2713:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._27L1Y,.hJjGW{padding:20px 20px 0;width:100%;text-align:right}._3V-1D{resize:none;border:none;padding:10px 20px;min-height:150px;background-color:#f5f5f5;width:100%;border-radius:4px}._3V-1D:focus,.Z9EkR{outline:none}.Z9EkR{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;padding:10px 35px;font-size:14px;line-height:24px;color:#000;font-weight:700;background-color:#ffd903;border:none;cursor:pointer}.hJjGW .Z9EkR{width:auto}.Z9EkR:hover{color:#111;opacity:1;background-color:#ffc107}.XvxhI,.Z9EkR:disabled:hover{background-color:#dcdcdc;color:#4e4d4d}._2QStj{font-size:12px;color:#6b6b6b;margin-bottom:4px;text-align:left;line-height:1.2}@media screen and (max-width:480px){.Z9EkR{border-radius:4px;padding:6px 30px}}._1gtfy,.hJjGW ._1gtfy{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.hJjGW ._1gtfy{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}", ""]);

// exports
exports.locals = {
	"root": "_27L1Y",
	"rootMobile": "hJjGW",
	"textareaMsg": "_3V-1D",
	"btnSend": "Z9EkR",
	"disabledBtn": "XvxhI",
	"verifyInfoMsg": "_2QStj",
	"infoBlock": "_1gtfy"
};

/***/ }),

/***/ 2748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/adwordsEvents.js
var adWordsSendAdvertPageView = function adWordsSendAdvertPageView(_ref, setDataLayer) {
  var id = _ref.id,
      make = _ref.make,
      model = _ref.model,
      price = _ref.price;

  try {
    var uahPrice = price.find(function (_ref2) {
      var currency = _ref2.currency;
      return currency === 'uah';
    });

    (function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return setDataLayer(args);
    })('event', 'page_view', {
      send_to: 'AW-855742650',
      dynx_itemid: id,
      dynx_itemid2: model && model.slug ? model.slug : '',
      dynx_itemid3: make && make.slug ? make.slug : '',
      dynx_itemid4: model && model.model_class && model.model_class.slug ? model.model_class.slug : '',
      dynx_pagetype: 'advert_page',
      dynx_totalvalue: uahPrice || '',
      user_id: 'replace with value'
    });
  } catch (e) {}
};
// CONCATENATED MODULE: ./src/shared/helpers/gtmEvents.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(184);



var sendAdvertViewEvent = function sendAdvertViewEvent(_ref) {
  var make = _ref.make,
      model = _ref.model,
      year = _ref.year,
      title = _ref.title,
      price = _ref.price,
      id = _ref.id,
      location = _ref.location,
      category = _ref.category,
      isNew = _ref.is_new,
      isSaleOnCredit = _ref.is_sale_on_credit,
      hotDate = _ref.hot_date;
  var isSpare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var setDataLayer = arguments[2];

  try {
    var priceUSD = price.find(function (priceObj) {
      return priceObj.currency === 'usd';
    }).value;
    var priceUAH = price.find(function (priceObj) {
      return priceObj.currency === 'uah';
    }).value;

    setDataLayer({
      pageType: 'Ad_card',
      adwId: id,
      car_price_usd: priceUSD,
      car_price_uah: priceUAH,
      car_name: title || '',
      car_brand: __WEBPACK_IMPORTED_MODULE_1__common__["h" /* getTitleOrEmpty */](make),
      car_model: __WEBPACK_IMPORTED_MODULE_1__common__["h" /* getTitleOrEmpty */](model),
      car_year: year,
      city: location && location.slug ? location.slug : '',
      price_category: '',
      type_car: __WEBPACK_IMPORTED_MODULE_1__common__["h" /* getTitleOrEmpty */](category),
      Condition_car: isNew ? 'новая' : 'с пробегом',
      payments_type: isSaleOnCredit ? 'кредит' : '',
      paymentState: hotDate ? 'paid' : 'free',
      adCategory: isSpare ? 'spares' : 'vehicle'
    });
  } catch (e) {
    //
  }
};
// CONCATENATED MODULE: ./src/shared/hocs/stats/withAdvertViewEvent.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_stats_withStatsEvents__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;
  return { userID: user.user.id };
};

var withAdvertViewEvent_withAdvertViewEvent = function withAdvertViewEvent(WrappedComponent) {
  var _class, _temp;

  return __WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps, { setDataLayer: __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */] })(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_stats_withStatsEvents__["a" /* default */]((_temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            events = _props.events,
            advertInfo = _props.advertInfo,
            isSpare = _props.isSpare;


        var transport = isSpare ? advertInfo.vehicle_type : advertInfo.transport;
        var transportId = transport && transport.id;
        var agency = advertInfo.agency;
        var agencyId = agency && agency.id;

        events.dispatchAdvertViewEvent(advertInfo.id, advertInfo.author.id, transportId, agencyId, isSpare);

        if (!isSpare) {
          sendAdvertViewEvent(advertInfo, null, this.props.setDataLayer);
          adWordsSendAdvertPageView(advertInfo, this.props.setDataLayer);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            events = _props2.events,
            props = _objectWithoutProperties(_props2, ['events']);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withAdvertViewEvent(' + __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    isSpare: false
  }, _temp)));
};

/* harmony default export */ var withAdvertViewEvent_defaultExport = (withAdvertViewEvent_withAdvertViewEvent);
// CONCATENATED MODULE: ./src/shared/hocs/withAdvert.js
/* harmony import */ var withAdvert___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withAdvert___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withAdvert___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_stats__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_stats__ = __webpack_require__(2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stats_withDealerGAEvent__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withFetch__ = __webpack_require__(1244);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var withAdvert__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withAdvert__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withAdvert__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withAdvert__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var DealerGAEventEmitter = __WEBPACK_IMPORTED_MODULE_8__stats_withDealerGAEvent__["a" /* default */](function () {
  return null;
});

var fetchCount = function fetchCount(fetch, advertID) {
  var isSpare = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].STATS.COUNT([advertID], undefined, isSpare ? [__WEBPACK_IMPORTED_MODULE_3_shared_constants_stats__["d" /* OBJECT_TYPES */].SPARE_PART] : [__WEBPACK_IMPORTED_MODULE_3_shared_constants_stats__["d" /* OBJECT_TYPES */].ADVERT])).then(function (r) {
    return r.json();
  }).then(function (_ref) {
    var count = _ref.count;
    return count;
  });
};

var withAdvert_withAdvert = function withAdvert(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    withAdvert__inherits(Component, _React$Component);

    function Component() {
      var _ref2;

      var _temp, _this, _ret;

      withAdvert__classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withAdvert__possibleConstructorReturn(this, (_ref2 = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
        // Count
        count: null,
        countToday: null,
        // Short view
        advertInfo: _this.props.advertInfo,
        isShortView: _this.props.isShortView
      }, _temp), withAdvert__possibleConstructorReturn(_this, _ret);
    }

    withAdvert__createClass(Component, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var fetch = this.props.fetch;
        var id = this.props.advertInfo.id;


        var fullAdvertReq = this.state.isShortView ? fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].ADVERT.ITEM(this.state.advertInfo.id)).then(function (r) {
          return r.json();
        }).then(function (advertInfo) {
          return _this2.setState({ advertInfo: advertInfo, isShortView: false });
        }) : Promise.resolve();

        fullAdvertReq.then(function () {
          return fetchCount(fetch, id, _this2.props.isSpare).then(function (count) {
            _this2.setState({ count: count });
          }).then(function () {
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_6_shared_helpers_stats__["a" /* fetchStats */](fetch, [id], _this2.props.isSpare).then(function (data) {
                var today = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy-MM-dd');
                var countToday = data[0].dates[today].count;
                _this2.setState({
                  countToday: Math.min(countToday, _this2.state.count)
                });
              }).catch(function () {});
            }, 3000);
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
            countToday = _state.countToday,
            count = _state.count,
            advertInfo = _state.advertInfo,
            isShortView = _state.isShortView;


        return _jsx('div', {}, void 0, withAdvert___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, {
          isShortView: isShortView,
          advertInfo: advertInfo,
          count: count,
          countToday: countToday
        })), advertInfo.agency && _jsx(DealerGAEventEmitter, {
          dealerInfo: advertInfo.agency
        }));
      }
    }]);

    return Component;
  }(withAdvert___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withAdvert(' + __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    isSpare: false,
    isShortView: false
  }, _temp2);

  return withAdvertViewEvent_defaultExport(__WEBPACK_IMPORTED_MODULE_9__withFetch__["a" /* withFetch */](Component));
};

/* harmony default export */ __webpack_exports__["a"] = (withAdvert_withAdvert);

/***/ }),

/***/ 2749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InfoMessages_css__ = __webpack_require__(2750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InfoMessages_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InfoMessages_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var InfoMessages = function (_React$Component) {
  _inherits(InfoMessages, _React$Component);

  function InfoMessages() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InfoMessages);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InfoMessages.__proto__ || Object.getPrototypeOf(InfoMessages)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      messages: []
    }, _this.enqueueMessage = function (text) {
      var message = { text: text };
      _this.setState(function (_ref2) {
        var messages = _ref2.messages;
        return { messages: [].concat(_toConsumableArray(messages), [message]) };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InfoMessages, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          countToday = _props.countToday,
          threshold = _props.threshold,
          intl = _props.intl;


      if (!prevProps.countToday && countToday && countToday > threshold) {
        this.enqueueMessage(intl.formatMessage({
          id: 'Сегодня это объявление было просмотрено {count} {count, plural, one {раз} few {раза} many {раз}}'
        }, { count: countToday }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__InfoMessages_css___default.a.root
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a, {
        transitionName: 'fadeUp',
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 100
      }, void 0, this.state.messages.map(function (_ref3) {
        var text = _ref3.text;
        return (
          // eslint-disable-next-line react/no-array-index-key
          _jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_5__InfoMessages_css___default.a.message
          }, text, text)
        );
      })));
    }
  }]);

  return InfoMessages;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InfoMessages.defaultProps = {
  threshold: 2,
  countToday: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__InfoMessages_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](InfoMessages)));

/***/ }),

/***/ 2750:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2751);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InfoMessages.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InfoMessages.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2751:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2E6CQ{position:fixed;left:30px;bottom:30px}._1tAQI{width:300px;padding:10px;color:#fff;font-size:15px;background-color:rgba(0,0,0,.6)}@media (max-width:1780px){._2E6CQ{left:10px}}@media (max-width:1680px){._2E6CQ{display:none}}", ""]);

// exports
exports.locals = {
	"root": "_2E6CQ",
	"message": "_1tAQI"
};

/***/ }),

/***/ 2752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IrrelevantMessage_css__ = __webpack_require__(2753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IrrelevantMessage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__IrrelevantMessage_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function IrrelevantMessage(props) {
  var title = props.title,
      indentDown = props.indentDown;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__IrrelevantMessage_css___default.a.root, !indentDown && __WEBPACK_IMPORTED_MODULE_5__IrrelevantMessage_css___default.a.indentDown)
  }, void 0, _jsx('div', {}, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__IrrelevantMessage_css___default.a.title
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
    id: title
  }))));
}

IrrelevantMessage.defaultProps = {
  indentDown: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__IrrelevantMessage_css___default.a)(IrrelevantMessage));

/***/ }),

/***/ 2753:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2754);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./IrrelevantMessage.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./IrrelevantMessage.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2754:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._19uL7{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:auto;font-weight:400}._2CPzg{margin-bottom:20px}.iIGMt{margin:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:red;font-size:20px;line-height:24px;font-weight:700;margin-bottom:3px;text-align:center}@media screen and (max-width:768px){._2CPzg{margin-bottom:5px;margin-top:5px}}", ""]);

// exports
exports.locals = {
	"root": "_19uL7",
	"indentDown": "_2CPzg",
	"title": "iIGMt"
};

/***/ }),

/***/ 2755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/CheckedVinBlock/CheckedVinBlock.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_moment__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css__ = __webpack_require__(2757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







// import uaFlag from 'shared/assets/images/ua_flag.png';



var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'Проверено avtobazar.ua по реестрам МВД Украины'
});

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'Проверенный VIN-код'
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'Марка, модель, год'
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'двигатель'
});

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'Цвет'
});

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'Последняя операция'
});

function CheckedVinBlock(props) {
  var advert = props.advert,
      intl = props.intl,
      isMobile = props.isMobile;
  var locale = intl.locale;
  var vehregInfo = advert.vehreg_info,
      makeId = advert.make.id,
      modeleId = advert.model.id,
      year = advert.year,
      adverEngine = advert.engine,
      colorId = advert.color.id,
      advertCapacity = advert.capacity,
      characteristics = advert.characteristics;
  var charCapacity = characteristics.capacity,
      charEngine = characteristics.engine;

  var capacity = advertCapacity || charCapacity && charCapacity.title;
  var engineId = adverEngine.id || charEngine && charEngine.id;

  if (capacity && capacity.toString().includes(',')) capacity = capacity.split(',').join('.');

  var _vehregInfo$make = vehregInfo.make,
      makeVehregId = _vehregInfo$make.id,
      makeTitle = _vehregInfo$make.title,
      _vehregInfo$model = vehregInfo.model,
      modelVehregId = _vehregInfo$model.id,
      modelTitle = _vehregInfo$model.title,
      yearVehreg = vehregInfo.year,
      _vehregInfo$engine = vehregInfo.engine,
      engineVehregId = _vehregInfo$engine.id,
      engineTitle = _vehregInfo$engine.title,
      _vehregInfo$color = vehregInfo.color,
      colorVehregId = _vehregInfo$color.id,
      colorTitle = _vehregInfo$color.title,
      colorSlug = _vehregInfo$color.slug,
      capacitySmVehreg = vehregInfo.capacity,
      operationDate = vehregInfo.operation_date,
      vinMatch = vehregInfo.vin_match;

  var capacityVehreg = capacitySmVehreg ? (capacitySmVehreg / 1000).toFixed(1) : null;
  var hasCapacity = !!capacityVehreg || !!capacity;

  var isCheckedCapacity = engineId && engineVehregId === engineId && (!hasCapacity || +capacityVehreg === +capacity);

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.root
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.title
  }, void 0, _ref), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.carNumberBlock
  }, void 0, vinMatch && _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.numberInfo
  }, void 0, _ref2)), _jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.infoList
  }, void 0, _jsx('li', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.checkbox, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.checkboxTop, isMobile))
  }, void 0, _jsx('input', {
    type: 'checkbox',
    checked: makeVehregId === makeId && modelVehregId === modeleId && year === yearVehreg,
    onChange: function onChange() {}
  }), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.itemTitle
  }, void 0, _ref3), _jsx('span', {}, void 0, makeTitle + ' ' + modelTitle + ' ' + yearVehreg)), _jsx('li', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.checkbox, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.checkboxTop, isMobile))
  }, void 0, _jsx('input', {
    type: 'checkbox',
    checked: isCheckedCapacity,
    onChange: function onChange() {}
  }), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.itemTitle
  }, void 0, _ref4), _jsx('span', {}, void 0, (engineTitle ? intl.formatMessage({ id: engineTitle }) : '') + ' ' + (hasCapacity ? capacityVehreg + ' \u043B' : ''))), _jsx('li', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.checkbox, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.checkboxTop, isMobile))
  }, void 0, _jsx('input', {
    type: 'checkbox',
    checked: colorVehregId === colorId,
    onChange: function onChange() {}
  }), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.itemTitle
  }, void 0, _ref5), _jsx('span', {}, void 0, _jsx('span', {
    style: { backgroundColor: '#' + colorSlug },
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.colorSquare
  }), __WEBPACK_IMPORTED_MODULE_4_shared_modules__["n" /* replaceToUpperCase */](intl.formatMessage({ id: colorTitle })))), _jsx('li', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.checkbox, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.checkboxTop, isMobile))
  }, void 0, _jsx('input', {
    type: 'checkbox',
    checked: operationDate,
    onChange: function onChange() {}
  }), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a.itemTitle
  }, void 0, _ref6), _jsx('span', {}, void 0, __WEBPACK_IMPORTED_MODULE_5_shared_helpers_moment__["c" /* posted */](operationDate, locale)))));
}

CheckedVinBlock.defaultProps = {
  isMobile: false
};


/* harmony default export */ var CheckedVinBlock_defaultExport = (__WEBPACK_IMPORTED_MODULE_6_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__CheckedVinBlock_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](CheckedVinBlock)));
// CONCATENATED MODULE: ./src/shared/components/AdvertStatusList/AdvertStatusList.js
/* harmony import */ var AdvertStatusList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertStatusList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertStatusList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdvertStatusList_css__ = __webpack_require__(2759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdvertStatusList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AdvertStatusList_css__);
var AdvertStatusList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






function AdvertStatusList(props) {
  var statuses = props.statuses,
      className = props.className;


  return statuses.length > 0 && AdvertStatusList__jsx('div', {
    className: className
  }, void 0, AdvertStatusList__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__AdvertStatusList_css___default.a.statusList
  }, void 0, statuses.map(function (status) {
    return AdvertStatusList__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3__AdvertStatusList_css___default.a.statusItem
    }, status.id || status.title, status.title);
  })));
}

AdvertStatusList.defaultProps = {
  statuses: [],
  className: ''
};


/* harmony default export */ var AdvertStatusList_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__AdvertStatusList_css___default.a)(AdvertStatusList));
// CONCATENATED MODULE: ./src/shared/components/AdvertDescription/AdvertDescription.js
/* harmony import */ var AdvertDescription___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertDescription___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertDescription___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertDescription___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertDescription___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(AdvertDescription___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var AdvertDescription___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertDescription___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertDescription___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var AdvertDescription___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_strings__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statusColors_json__ = __webpack_require__(2756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statusColors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statusColors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AdvertDescription_css__ = __webpack_require__(2761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AdvertDescription_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AdvertDescription_css__);
var AdvertDescription__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();













function AdvertDescription(props) {
  var intl = props.intl,
      advert = props.advert;
  var title = props.title,
      _props$description = props.description,
      description = _props$description === undefined ? intl.formatMessage({ id: 'Нет описания' }) : _props$description,
      statuses = props.statuses,
      isDealer = props.isDealer;

  var titleResult = intl.formatMessage({ id: 'Описание' }) + ' ' + title + ' ' + (!isDealer ? intl.formatMessage({ id: 'от владельца' }) : '');
  return AdvertDescription__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__AdvertDescription_css___default.a.root
  }, void 0, advert.vehreg_info && !!advert.vehreg_info.transport.id && AdvertDescription__jsx(CheckedVinBlock_defaultExport, {
    advert: advert
  }), AdvertDescription__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__AdvertDescription_css___default.a.description
  }, void 0, AdvertDescription__jsx('h2', {
    className: __WEBPACK_IMPORTED_MODULE_8__AdvertDescription_css___default.a.title
  }, void 0, titleResult), AdvertDescription__jsx(AdvertStatusList_defaultExport, {
    statuses: statuses,
    colors: __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statusColors_json___default.a
  }), AdvertDescription__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__AdvertDescription_css___default.a.text,
    dangerouslySetInnerHTML: {
      __html: __WEBPACK_IMPORTED_MODULE_4_shared_helpers_strings__["a" /* stripHTML */](description).replace(/\n{3,}/g, '\n\n').replace(/\n/g, '<br />') || intl.formatMessage({ id: 'Нет описания' })
    }
  })));
}

AdvertDescription.defaultProps = {
  title: '',
  advert: {},
  description: undefined,
  isDealer: false,
  options: [],
  statuses: []
};


/* harmony default export */ __webpack_exports__["a"] = (AdvertDescription___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__AdvertDescription_css___default.a)(AdvertDescription___WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](AdvertDescription)));

/***/ }),

/***/ 2756:
/***/ (function(module, exports) {

module.exports = {"after-dtp":"#b70101","credited":"#6e0fad","pod-zakaz":"#029ca9","not-used-in-ua":"#0b03ba","not-custom":"#159753","credit":"#baa000","rassrochka":"#38b193"}

/***/ }),

/***/ 2757:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2758);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckedVinBlock.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckedVinBlock.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2758:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".GK09J{border:1px solid #256799;border-radius:2px;margin:10px 0;position:relative;padding:10px}._3aJhH{font-weight:700}._2-r1v{position:relative;padding:0 10px 10px;margin-bottom:0}._2-r1v li{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;margin-top:10px}._2-r1v li>span{width:50%}._2-r1v input{position:absolute;left:10px}._2kMQA{width:14px;height:14px;border-radius:2px;margin:0 4px -2px 0}._2kMQA,._3VnIw{display:inline-block}._3VnIw{position:relative;font-weight:400;font-size:14px;color:#000;padding-left:23px}._3VnIw input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._3VnIw input,._3VnIw input:checked{top:3px;-webkit-appearance:none;width:15px;height:15px;outline:none}._3VnIw input:checked{background-color:#ffd906;border:1px solid #ffd906;border-radius:2px;-moz-appearance:none;appearance:none}._3VnIw input:checked:after{-webkit-appearance:none;-moz-appearance:none;appearance:none;position:absolute;font:0/0 a;z-index:15;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}.YktZm{color:#888}.Sr4mY{border:1px solid #256799;padding:0 5px;margin-right:5px;display:inline-block;margin-bottom:5px}._1gk9D{margin-top:5px}._3_FGx{padding-left:25px;position:relative}._2CEhk:before{content:\"UA\";background-color:#07499d;font-size:8px;color:#fff;text-align:center;top:0;left:0;bottom:0;width:19px;padding-top:10px;position:absolute}._3_FGx img{position:absolute;height:10px;left:2px}._29EIh input,._29EIh input:checked{top:0}@media screen and (max-width:380px){._2-r1v{padding:0 0 10px}}", ""]);

// exports
exports.locals = {
	"root": "GK09J",
	"title": "_3aJhH",
	"infoList": "_2-r1v",
	"colorSquare": "_2kMQA",
	"checkbox": "_3VnIw",
	"itemTitle": "YktZm",
	"numberInfo": "Sr4mY",
	"carNumberBlock": "_1gk9D",
	"regNumber": "_3_FGx",
	"uaCarNum": "_2CEhk",
	"checkboxTop": "_29EIh"
};

/***/ }),

/***/ 2759:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2760);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertStatusList.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertStatusList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2760:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._27xjp{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;padding:0 0 15px}._2IouA{display:inline-block;height:20px;line-height:19px;border-radius:2px;margin-right:6px;margin-bottom:10px;font-weight:400;font-size:12px;padding:0 5px;border:1px solid #c4c4c4;color:gray}@media screen and (max-width:768px){._27xjp{padding:10px 0 0}}", ""]);

// exports
exports.locals = {
	"statusList": "_27xjp",
	"statusItem": "_2IouA"
};

/***/ }),

/***/ 2761:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2762);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertDescription.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertDescription.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2762:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".-KZpu{position:relative;margin-bottom:36px;font-size:14px;font-weight:400;padding-right:8px}._3Cu2e{font-size:17px;font-weight:700;margin-bottom:15px}._1d01p{line-height:1.75;padding-right:20px}.xlFIb{font-size:12px}.PV9iD{display:inline-block;margin-right:20px;width:calc(50% - 20px);vertical-align:top}", ""]);

// exports
exports.locals = {
	"root": "_11SHK",
	"description": "-KZpu",
	"title": "_3Cu2e",
	"text": "_1d01p",
	"list": "xlFIb",
	"col": "PV9iD"
};

/***/ }),

/***/ 2763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_insta_icon_png__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_insta_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_assets_images_insta_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_fb_icon_png__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_fb_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_fb_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SocialLinks_css__ = __webpack_require__(2764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SocialLinks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SocialLinks_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SocialLinks = function (_React$PureComponent) {
  _inherits(SocialLinks, _React$PureComponent);

  function SocialLinks() {
    _classCallCheck(this, SocialLinks);

    return _possibleConstructorReturn(this, (SocialLinks.__proto__ || Object.getPrototypeOf(SocialLinks)).apply(this, arguments));
  }

  _createClass(SocialLinks, [{
    key: 'render',
    value: function render() {
      var _props$advert = this.props.advert,
          _props$advert$instagr = _props$advert.instagram_link,
          instaLink = _props$advert$instagr === undefined ? '' : _props$advert$instagr,
          _props$advert$faceboo = _props$advert.facebook_link,
          fbLink = _props$advert$faceboo === undefined ? '' : _props$advert$faceboo;

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__SocialLinks_css___default.a.root
      }, void 0, instaLink && _jsx('a', {
        href: instaLink,
        target: '_blank',
        rel: 'nofollow noopener noreferrer'
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_insta_icon_png___default.a,
        alt: '',
        className: __WEBPACK_IMPORTED_MODULE_5__SocialLinks_css___default.a.instaIcon
      })), fbLink && _jsx('a', {
        href: fbLink,
        target: '_blank',
        rel: 'nofollow noopener noreferrer'
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_fb_icon_png___default.a,
        alt: '',
        className: __WEBPACK_IMPORTED_MODULE_5__SocialLinks_css___default.a.fbIcon
      })));
    }
  }]);

  return SocialLinks;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

SocialLinks.defaultProps = {
  advert: {}
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__SocialLinks_css___default.a)(SocialLinks));

/***/ }),

/***/ 2764:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2765);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SocialLinks.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SocialLinks.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2765:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1C-4H{margin-top:5px}._2KPcF{width:20px;margin-right:5px}._1eD9-,._2KPcF{padding-bottom:2px;margin-left:2px}._1eD9-{width:18px}", ""]);

// exports
exports.locals = {
	"root": "_1C-4H",
	"instaIcon": "_2KPcF",
	"fbIcon": "_1eD9-"
};

/***/ }),

/***/ 2766:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2767);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertSeller.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertSeller.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2767:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2hrYU,.Fqf94{position:relative;background-color:#f5f5f5;border-radius:3px;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:15px}.Fqf94{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.rgYK-{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start}.Fqf94 .rgYK-{margin-bottom:15px}._1KoN4{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.Fqf94 ._1KoN4>div{width:100%}._2pCU1{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._3UYcf{padding-right:30px}.NzeyN{padding:3px 0 8px;font-size:14px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._16c3g{padding-right:30px}._3ssHT,._16c3g{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:230px;-ms-flex-item-align:center;align-self:center;text-align:right}._3ssHT{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex}.WQD1w a{color:#000;text-decoration:none}._3_ffh{border-radius:2px;font-size:15px;padding:7px 16px 4px;background-color:#ffd906;border:1px solid #ffd906;color:#000;cursor:pointer;min-height:60px;width:190px;text-align:center;line-height:1.52;outline:none;font-weight:600;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column wrap;flex-flow:column wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:10px 0 10px 10px}._3_ffh:hover{background-color:#ffc107;border:1px solid #ffc107}._34-B5{position:relative;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:120px;color:#888}._2rFKs{font-size:12px;line-height:14px;color:gray}._12LuZ{position:relative;font-weight:700;-ms-flex-align:center;color:#000}._12LuZ,.zdf6Z{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center}.zdf6Z{-ms-flex-item-align:center;align-self:center;text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:center;height:60px}._3elE5{-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #d8d8d8}._3elE5,._112gx{width:40px;margin-right:10px}._112gx{height:40px;background:#e1e1e1;border-radius:2px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._3-_Ep{color:#2196f3;font-weight:700}._3-_Ep,._288lU{text-decoration:none}._288lU{border-radius:2px;font-size:15px;padding:4px 16px;width:190px;height:60px;margin-left:10px;background-color:#fff;border:1px solid #e0e0e0;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#000}._288lU:hover{border:1px solid #2196f3;background-color:#f8f8f8;color:#000}._2m4e_{display:block;padding-top:5px;font-weight:400}", ""]);

// exports
exports.locals = {
	"rootMobile": "Fqf94",
	"root": "_2hrYU",
	"rowContainer": "rgYK-",
	"flexRowBlock": "_1KoN4",
	"flexColumnBlock": "_2pCU1",
	"messengersBlock": "_3UYcf",
	"row": "NzeyN",
	"contact": "_16c3g",
	"contactParts": "_3ssHT",
	"phone": "WQD1w",
	"contactBtn": "_3_ffh",
	"col": "_34-B5",
	"sallerTitle": "_2rFKs",
	"colAuto": "_12LuZ",
	"write": "zdf6Z",
	"avatar": "_3elE5",
	"avatarPlaceholder": "_112gx",
	"authorLink": "_3-_Ep",
	"writeBtn": "_288lU",
	"authorExtraText": "_2m4e_"
};

/***/ }),

/***/ 2768:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/AdvertPhotos/MainImage/MainImage.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_modules__ = __webpack_require__(103);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






function MainImage(_ref) {
  var mainImage = _ref.mainImage,
      sliderClassName = _ref.sliderClassName,
      onClick = _ref.onClick,
      appear = _ref.appear,
      appearActive = _ref.appearActive;

  return _jsx('span', {
    className: sliderClassName
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group___default.a, {
    transitionName: {
      appear: appear,
      appearActive: appearActive
    },
    transitionAppear: true,
    transitionAppearTimeout: 200,
    transitionEnter: false,
    transitionLeave: false
  }, mainImage && mainImage.id, _jsx('img', {
    className: sliderClassName,
    style: { width: 'auto' },
    id: mainImage && mainImage.id,
    src: __WEBPACK_IMPORTED_MODULE_3_shared_modules__["u" /* urlReplace */](mainImage && mainImage.image),
    onClick: onClick,
    'data-lens-event': 'showPhoto',
    alt: ''
  })));
}
// CONCATENATED MODULE: ./src/desktop/components/AdvertPhotos/AdvertPhotos.js
/* harmony import */ var AdvertPhotos___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertPhotos___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertPhotos___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertPhotos___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertPhotos___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(AdvertPhotos___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withSliderLogic__ = __webpack_require__(2076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__car_svg__ = __webpack_require__(2769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__car_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__car_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css__ = __webpack_require__(2770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var AdvertPhotos__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var _ref3 = AdvertPhotos__jsx('div', {
  id: 'main-block'
});

var _ref4 = AdvertPhotos__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0415\u0449\u0435'
});

var AdvertPhotos_AdvertPhotos = function (_React$Component) {
  _inherits(AdvertPhotos, _React$Component);

  function AdvertPhotos() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AdvertPhotos);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdvertPhotos.__proto__ || Object.getPrototypeOf(AdvertPhotos)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      index: 0,
      id: null,
      left: 0,
      fullScreenSlideWidth: 800,
      photos: _this.props.setRatioAlbum(_this.props.photos, 490)
    }, _this.onSetPrevId = function (e) {
      e.stopPropagation();
      _this.props.setPrevId();
    }, _this.onSetNextId = function (e) {
      e.stopPropagation();
      _this.props.setNextId();
    }, _this.renderEmptyPhotos = function () {
      return AdvertPhotos__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.root
      }, void 0, AdvertPhotos__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.empty
      }, void 0, AdvertPhotos__jsx('img', {
        src: _this.props.defaultImg,
        alt: ''
      })));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdvertPhotos, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var photos = this.state.photos;
      var _props = this.props,
          id = _props.id,
          index = _props.index,
          left = _props.left,
          alt = _props.alt,
          setRatioImage = _props.setRatioImage,
          isDealerPage = _props.isDealerPage,
          isDealerInfoPage = _props.isDealerInfoPage;


      if (!photos || !photos.length) {
        return this.renderEmptyPhotos();
      }

      var rootImage = photos && photos[index];

      var sliderImages = this.props.photos.map(function (_ref2) {
        var image = _ref2.image,
            rest = _objectWithoutProperties(_ref2, ['image']);

        return _extends({}, rest, {
          image: setRatioImage(image, 960, null)
        });
      });
      var sliderImage = sliderImages && sliderImages.find(function (photo) {
        return photo.id === id;
      });

      return AdvertPhotos__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.root
      }, void 0, AdvertPhotos__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.main
      }, void 0, photos.length > 1 && AdvertPhotos__jsx('i', {
        className: 'fa fa-angle-left ' + __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.rootPrev,
        onClick: this.props.decrementIndex,
        'data-lens-event': 'showPhoto'
      }), AdvertPhotos__jsx(MainImage, {
        mainImage: rootImage,
        sliderClassName: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.imgRoot, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.dealerPageImg, isDealerPage), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.dealerPageImg, isDealerInfoPage)),
        onClick: this.props.setFullscreenImage,
        appear: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.animAppear,
        appearActive: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.animAppearActive
      }), photos.length > 1 && AdvertPhotos__jsx('i', {
        className: 'fa fa-angle-right ' + __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.rootNext,
        onClick: this.props.incrementIndex,
        'data-lens-event': 'showPhoto'
      })), isDealerInfoPage && _ref3, AdvertPhotos__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.gallery
      }, void 0, photos.length > 1 && !isDealerInfoPage && photos.map(function (item, i) {
        return AdvertPhotos__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.active, id === item.id), __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.thumb),
          style: {
            display: '' + (i >= 12 ? 'none' : undefined)
          }
        }, item.id, i === 12 - 1 && AdvertPhotos__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.lastImg
        }, void 0, ' ', _ref4, ' ', ' ' + (photos.length - (12 - 1))), AdvertPhotos__jsx('img', {
          src: item && item.image || item,
          id: item.id,
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.active, index === i), __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.img),
          onMouseOver: function onMouseOver() {
            return _this2.props.setPreviewImage(i);
          },
          onClick: function onClick() {
            return _this2.props.setImageId(item.id);
          },
          alt: alt + ' - \u0444\u043E\u0442\u043E ' + (i + 1),
          title: alt + ' - \u0444\u043E\u0442\u043E ' + (i + 1),
          'data-lens-event': 'showPhoto'
        }));
      })), id && AdvertPhotos__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Modal__["a" /* default */], {}, void 0, AdvertPhotos__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.fullscreenSlider,
        onClick: this.props.closeSlider
      }, void 0, sliderImages.length > 1 && AdvertPhotos__jsx('i', {
        className: 'fa fa-angle-left ' + __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.sliderPrev,
        onClick: this.onSetPrevId
      }), AdvertPhotos__jsx(MainImage, {
        mainImage: sliderImage,
        sliderClassName: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.sliderMainImg,
        onClick: this.onSetNextId,
        appear: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.animAppear,
        appearActive: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.animAppearActive
      }), sliderImages.length > 1 && AdvertPhotos__jsx('i', {
        className: 'fa fa-angle-right ' + __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.sliderNext,
        onClick: this.onSetNextId,
        'data-lens-event': 'showPhoto'
      }), AdvertPhotos__jsx('i', {
        className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.sliderClose,
        onClick: this.props.closeSlider,
        'data-lens-event': 'showPhoto'
      }), AdvertPhotos__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.sliderGalleryContainer
      }, void 0, AdvertPhotos__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.sliderGallery,
        style: {
          transform: 'translateX(-' + left + 'px)',
          width: 110 * sliderImages.length + 'px'
        }
      }, void 0, sliderImages.length > 1 && sliderImages.map(function (photo) {
        return AdvertPhotos__jsx('div', {
          style: {
            flex: '1 0 100px',
            height: '70px',
            margin: '10px 5px',
            maxWidth: '100px'
          },
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.active, id === photo.id), __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.sliderThumb)
        }, photo.id, AdvertPhotos__jsx('span', {
          id: photo.id,
          className: __WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a.sliderImg,
          onMouseOver: _this2.props.setFullscreenImage,
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          style: {
            backgroundImage: 'url(' + __WEBPACK_IMPORTED_MODULE_8_shared_modules__["u" /* urlReplace */](photo && photo.image || photo) + ')'
          },
          'data-lens-event': 'showPhoto'
        }));
      }))))));
    }
  }]);

  return AdvertPhotos;
}(AdvertPhotos___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AdvertPhotos_AdvertPhotos.defaultProps = {
  isDealerInfoPage: false,
  isDealerPage: false,
  photos: [],
  index: 0,
  id: null,
  defaultImg: __WEBPACK_IMPORTED_MODULE_9__car_svg___default.a,
  alt: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_11__AdvertPhotos_css___default.a)(__WEBPACK_IMPORTED_MODULE_6_shared_hocs_withPixelRatio__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withSliderLogic__["a" /* default */](AdvertPhotos_AdvertPhotos))));

/***/ }),

/***/ 2769:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "29b478b7.svg";

/***/ }),

/***/ 2770:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2771);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertPhotos.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertPhotos.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2771:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2ZqYm,.Ipqez{position:relative}.Ipqez{width:100%;overflow:hidden;margin-bottom:2px}._1rmn1{border-right:1px solid #0000001c}._1rmn1 img{width:100%;height:267px;display:block;padding:20px;background-color:#f2f2f2;margin-bottom:10px}._3-faW{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%;cursor:pointer;height:280px;background:50% no-repeat;background-size:contain}.Rq_3R{height:395px}._2nz1i{height:350px}._2NuXj{margin:0 0 20px -5px;font-size:0;line-height:0;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}._1fHpQ,._2NuXj{position:relative}._1fHpQ{overflow:hidden;width:15.49%;height:58px;margin:5px 0 0 1.15%;display:inline-block;vertical-align:middle;outline:0;z-index:1}._1Sghg{position:absolute;top:50%;left:50%;width:auto;height:100%;max-width:none;max-height:none;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);cursor:pointer}._1Sghg._18yNB,._1Sghg:hover{opacity:.5}._32lMS{position:absolute;height:100%;background:#00000078;color:#fff;font-size:16px;line-height:21px;font-weight:600;-webkit-box-align:center;-ms-flex-align:center;align-items:center;white-space:pre-wrap}._32lMS,._35D5H{top:0;left:0;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._35D5H{position:fixed;background:#000000bf;height:100vh;z-index:101;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.t-4gZ{position:relative;display:block;cursor:pointer;background:50% no-repeat #000;background-size:contain;height:85vh;max-width:90vw;max-height:70vw;margin:auto}._2x_6B{margin-bottom:15px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2MY_i,._2x_6B{display:-webkit-box;display:-ms-flexbox;display:flex}._2MY_i{-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-transition:all .5s ease-in;-o-transition:all .5s ease-in;transition:all .5s ease-in}._2MY_i,._2Xe1U{position:relative}._2Xe1U{overflow:hidden;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle;background:#fff}._2Xe1U._18yNB ._2ecPt{opacity:.5}._2ecPt{display:inline-block;width:100%;height:100%;background:50% no-repeat;background-size:contain;cursor:pointer;-webkit-transition:opacity .2s ease-in;-o-transition:opacity .2s ease-in;transition:opacity .2s ease-in}._2Tffv{opacity:.5}._2Tffv._2ApQ6{opacity:1;-webkit-transition:opacity .2s ease-in-out;-o-transition:opacity .2s ease-in-out;transition:opacity .2s ease-in-out}._1hwlq,._2lnvR,.EXtqB,.SDrMt,.YUwie{position:absolute;top:0;bottom:0;margin:auto;z-index:1;color:#fff;cursor:pointer;opacity:0;-webkit-transition:opacity .1s ease-in-out;-o-transition:opacity .1s ease-in-out;transition:opacity .1s ease-in-out}._1hwlq,.EXtqB{font-size:50px;height:50px;width:22px}._1hwlq{left:5px;text-shadow:1px 0 2px #0000008a}.EXtqB{right:5px;text-shadow:-1px 0 2px #0000008a}._2lnvR,.SDrMt{height:70px;width:25px;font-size:70px}.SDrMt{left:20px;text-shadow:1px 0 2px #0000008a}._2lnvR{right:20px;text-shadow:-1px 0 2px #0000008a}.YUwie{height:40px;width:40px;top:20px;bottom:auto;right:20px;font-size:70px;line-height:40px}.YUwie:after{content:\"\\D7\"}._35D5H:hover ._2lnvR,._35D5H:hover .SDrMt,._35D5H:hover .YUwie,.Ipqez:hover ._1hwlq,.Ipqez:hover .EXtqB{opacity:1}", ""]);

// exports
exports.locals = {
	"root": "_2ZqYm",
	"main": "Ipqez",
	"empty": "_1rmn1",
	"imgRoot": "_3-faW",
	"dealerPageImg": "Rq_3R",
	"dealerInfoPageImg": "_2nz1i",
	"gallery": "_2NuXj",
	"thumb": "_1fHpQ",
	"img": "_1Sghg",
	"active": "_18yNB",
	"lastImg": "_32lMS",
	"fullscreenSlider": "_35D5H",
	"sliderMainImg": "t-4gZ",
	"sliderGalleryContainer": "_2x_6B",
	"sliderGallery": "_2MY_i",
	"sliderThumb": "_2Xe1U",
	"sliderImg": "_2ecPt",
	"animAppear": "_2Tffv",
	"animAppearActive": "_2ApQ6",
	"rootPrev": "_1hwlq",
	"rootNext": "EXtqB",
	"sliderPrev": "SDrMt",
	"sliderNext": "_2lnvR",
	"sliderClose": "YUwie"
};

/***/ }),

/***/ 2793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_urlBuilder__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg__ = __webpack_require__(2370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NewsList_css__ = __webpack_require__(2794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__NewsList_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var typesToClassNames = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE, __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.tableItem);

var _ref2 = _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_two_rows_sq_list_svg___default.a,
  width: '20',
  alt: ''
});

var _ref3 = _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_two_rows_line_list_svg___default.a,
  width: '20',
  alt: ''
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'По Вашему запросу ничего не найдено'
});

var NewsList = function (_React$Component) {
  _inherits(NewsList, _React$Component);

  function NewsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsList.__proto__ || Object.getPrototypeOf(NewsList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentType: __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE
    }, _this.handleSetTypeClick = function (type) {
      _this.setState({ currentType: type });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewsList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          news = _props.news,
          tag = _props.tag,
          currentRubric = _props.currentRubric,
          shortView = _props.shortView,
          intl = _props.intl;

      var currentType = shortView ? __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].LIST : this.state.currentType;

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.root
      }, void 0, !shortView && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.header
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.title
      }, void 0, _jsx('h1', {}, void 0, intl.formatMessage({ id: __WEBPACK_IMPORTED_MODULE_9_shared_helpers_common__["h" /* getTitleOrEmpty */](currentRubric) || 'Новости' }))), _jsx('div', {}, void 0, Object.values(__WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */]).map(function (type) {
        return _jsx('button', {
          className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.headerButton,
          onClick: function onClick() {
            return _this2.handleSetTypeClick(type);
          },
          disabled: type === currentType
        }, type, type === __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE && _ref2, type === __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].LIST && _ref3);
      }))), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.table, currentType === __WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["a" /* TYPES */].TABLE))
      }, void 0, news.length !== 0 ? news.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_components_NewsItem_NewsItem__["b" /* default */], _extends({
          key: item.id
        }, item, {
          className: typesToClassNames[currentType],
          type: currentType,
          link: __WEBPACK_IMPORTED_MODULE_5_shared_helpers_urlBuilder__["a" /* buildJournalItemUrl */](item.slug, tag)
        }));
      }) : _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a.emptyBlock
      }, void 0, _ref4)));
    }
  }]);

  return NewsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NewsList.defaultProps = {
  videoTopics: [],
  videoOrderBy: '',
  tag: null,
  shortView: false,
  currentRubric: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__NewsList_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](NewsList)));

/***/ }),

/***/ 2794:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2795);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsList.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2795:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1iljp{position:relative;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:20px}._1iljp,._250Dn{display:-webkit-box;display:-ms-flexbox;display:flex}._250Dn{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:10px 0}._2WPWo h1{font-size:20px;font-weight:700}._1SyMc{position:relative;background:transparent;font-size:20px;height:30px;cursor:pointer;width:40px;text-align:center;outline:none;font-weight:400;margin:0 0 0 -1px;border:0;border-bottom:2px solid transparent}._1SyMc img{opacity:.5}._1SyMc:first-of-type{margin:0}._1SyMc:disabled{cursor:auto;border-bottom:3px solid #ffd906}._1SyMc:disabled img{opacity:1}._1SyMc:focus img,._1SyMc:hover img{z-index:1;opacity:1}._3BInd{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:5px 0;background:#f5f5f5}._1o4gT{margin:10px 15px 10px 0;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:calc(33.33333% - 10px);flex-basis:calc(33.33333% - 10px)}._1o4gT:nth-of-type(3n){margin-right:0}._3Zfhz{margin-bottom:10px}._3Zfhz,.h7LQs{background:#fff;width:100%}.h7LQs{padding:20px 0;text-align:center}", ""]);

// exports
exports.locals = {
	"root": "_1iljp",
	"header": "_250Dn",
	"title": "_2WPWo",
	"headerButton": "_1SyMc",
	"table": "_3BInd",
	"tableItem": "_1o4gT",
	"ads": "_3Zfhz",
	"emptyBlock": "h7LQs"
};

/***/ }),

/***/ 2796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_desktop_components_AdvertCarCard_AdvertCarCard__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_desktop_components_Carousel_Carousel__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css__ = __webpack_require__(2797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AnotherCars_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// import AdvertCard from 'desktop/components/AdvertCard/AdvertCard';



var IMAGE_WIDTH = 170;

function AnotherCars(props) {
  var cars = props.cars,
      title = props.title,
      containerClassName = props.containerClassName;

  var imageStyles = { height: '125px' };

  if (!(cars && cars.length)) {
    return null;
  }

  return _jsx('div', {
    className: containerClassName || __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.root
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4_desktop_components_Carousel_Carousel__["a" /* default */], {
    step: 4,
    itemsInRow: 4,
    loop: true,
    classNames: {
      header: __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.header,
      body: __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.carouselBody
    },
    header: _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.title
    }, void 0, title),
    items: cars.map(function (car, idx) {
      return _jsx(__WEBPACK_IMPORTED_MODULE_3_desktop_components_AdvertCarCard_AdvertCarCard__["a" /* default */], {
        index: idx,
        advert: car,
        imageStyle: imageStyles,
        advertClassName: __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.advertItem,
        cardType: 'similar',
        width: IMAGE_WIDTH,
        lensEvent: 'similarCarClick'
      }, car.id);
    })
  }));
}

AnotherCars.defaultProps = {
  cars: [],
  containerClassName: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a)(AnotherCars));

/***/ }),

/***/ 2797:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2798);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AnotherCars.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AnotherCars.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2798:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Q55Q{position:relative;background-color:#fff;padding:10px 10px 0;min-height:288px;border-bottom:1px solid #d8d8d8;z-index:1;margin:10px 0}._1B4xP{font-size:20px;font-weight:700;color:#000}.WahFN{padding:5px 0 15px 5px}._2Ibj6{padding-bottom:0}", ""]);

// exports
exports.locals = {
	"root": "_3Q55Q",
	"title": "_1B4xP",
	"header": "WahFN",
	"carouselBody": "_2Ibj6"
};

/***/ }),

/***/ 3269:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "446fcb4c.png";

/***/ }),

/***/ 3270:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3271);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SuccessBlock.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SuccessBlock.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3271:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2Lr7I{display:-webkit-box;display:-ms-flexbox;display:flex;background-color:#bbe2b687;padding:12px;margin-top:-5px;margin-bottom:15px}._1UKg2{margin-top:15px}._2PL4m{height:27px;width:auto;padding-left:20px;margin:auto 0;opacity:.8}._3irrr{font-size:15px;font-weight:600;color:#525252;padding-left:13px;padding-top:3px}", ""]);

// exports
exports.locals = {
	"root": "_2Lr7I",
	"mobileRoot": "_1UKg2",
	"icon": "_2PL4m",
	"title": "_3irrr"
};

/***/ }),

/***/ 3272:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3273);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SoldMessage.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SoldMessage.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3273:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Vipz{width:100%;margin:auto;font-weight:400;margin-bottom:20px}._2PZQ0,._3Vipz{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2PZQ0{margin:auto;color:red;font-size:21px;line-height:24px;font-weight:700;margin-bottom:3px}", ""]);

// exports
exports.locals = {
	"root": "_3Vipz",
	"title": "_2PZQ0"
};

/***/ }),

/***/ 3274:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3275);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InfoBlock.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InfoBlock.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3275:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1qmZb{display:-webkit-box;display:-ms-flexbox;display:flex;background-color:#dededa;padding:12px;margin-top:-5px;margin-bottom:15px}._1ujbb{margin-top:15px}._3VxE4{height:27px;width:auto;padding-left:20px;margin:auto 0;opacity:.8}.vyvSa{font-size:15px;font-weight:600;color:#525252;padding-left:13px;padding-top:3px}", ""]);

// exports
exports.locals = {
	"root": "_1qmZb",
	"mobileRoot": "_1ujbb",
	"icon": "_3VxE4",
	"title": "vyvSa"
};

/***/ }),

/***/ 3276:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3277);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SparesForAdvert.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SparesForAdvert.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3277:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2URks,.bkV4f{position:relative;font-weight:400;background:#fff;border-radius:5px;padding:20px 15px}._288rU{font-size:17px;font-weight:700;margin:0 0 12px}._1XxNp{border-top:1px solid #ededed;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:55px;padding:8px 0}.bkV4f ._1XxNp{background:#f5f5f5;border-radius:3px;border:none;margin-right:10px;padding:5px 10px}._1XxNp:first-of-type{border:none}._1B-mB{font-size:14px;font-weight:700;padding-bottom:6px;color:#000;text-decoration:none;display:block}._34vg0{font-size:13px;font-weight:400;color:#888}._3vgbj{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:1px solid #ccc;border-radius:2px;font-size:12px;font-weight:400;text-decoration:none;color:#000;text-align:center;padding:6px 10px;margin-top:15px;cursor:pointer}._3vgbj:hover{border:1px solid #2196f3}._1XxNp:hover ._1B-mB{color:#e73232}.bkV4f ._7kVV2{position:relative;overflow-x:auto;white-space:nowrap;-webkit-overflow-scrolling:touch}.bkV4f ._1XxNp,.bkV4f ._7kVV2{display:-webkit-box;display:-ms-flexbox;display:flex}.bkV4f ._1XxNp{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.bkV4f .AXxPZ{width:175px}", ""]);

// exports
exports.locals = {
	"rootMobile": "bkV4f",
	"root": "_2URks",
	"title": "_288rU",
	"spare": "_1XxNp",
	"spareTitle": "_1B-mB",
	"sparePrice": "_34vg0",
	"allSpares": "_3vgbj",
	"wrapper": "_7kVV2",
	"spareInfo": "AXxPZ"
};

/***/ }),

/***/ 3278:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3279);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SpecialAdvertCars.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SpecialAdvertCars.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3279:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2ytT8{position:relative;padding:10px 10px 0;margin:40px 0 23px;background-color:#fff}._2xpjr{font-size:17px;font-weight:700;padding-top:0;margin:0 0 9px}._2pbGq{margin-bottom:5px;overflow:hidden;border-bottom:1px solid #eee}._1TaR7{position:absolute;right:5px;top:5px;z-index:1}._2pbGq img{width:100%}._2kd8k{position:absolute;bottom:0;top:0;left:0;right:0;background-color:rgba(0,0,0,.3)}._2pbGq:hover ._2kd8k{display:none}._2Ezrb{position:relative;overflow:hidden;margin:-1px -10px 0}._3JBhn,.ANbuH{border-radius:0;position:relative;display:block;width:50%;font-size:13px;margin:0;padding:14px 20px;background-color:#fff;outline:none;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0}.ANbuH{float:left;padding-right:10px;border-right:1px solid #f1f1f1}._3JBhn{float:right;padding-left:10px}._2Ezrb button:hover{color:#e73232}._2DKQe{font-size:20px;height:22px;position:absolute;top:0;bottom:0;margin:auto}.ANbuH ._2DKQe{left:15px}._3JBhn ._2DKQe{right:15px}.FsBWy{background-position:50%;background-size:cover}._3lZiG{position:absolute;bottom:0;padding:5px 10px 15px;left:0;right:0;color:#fff}._2pbGq{position:relative;cursor:pointer;display:block}._2pbGq ._2xpjr{font-weight:600;font-size:16px;line-height:19px;margin-bottom:5px}._381re{font-size:14px}._381re span{line-height:14px;margin-right:10px}._381re svg{margin-right:5px}._381re svg path{fill:#fff}._1qjk5{margin-top:10px}._1VINi{margin-top:5px;display:inline-block;font-size:14px;background-color:#ffd906;padding:2px 5px;border-radius:1px;color:#000}", ""]);

// exports
exports.locals = {
	"root": "_2ytT8",
	"title": "_2xpjr",
	"car": "_2pbGq",
	"label": "_1TaR7",
	"subInfo": "_2kd8k",
	"btns": "_2Ezrb",
	"btnPrev": "ANbuH",
	"btnNext": "_3JBhn",
	"btnIcon": "_2DKQe",
	"img": "FsBWy",
	"text": "_3lZiG",
	"info": "_381re",
	"priceWrapper": "_1qjk5",
	"contractPrice": "_1VINi"
};

/***/ }),

/***/ 3280:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3281);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchBar.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SearchBar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3281:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2RGyj{background-color:#fff;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.12);box-shadow:0 2px 4px rgba(0,0,0,.12);padding:0 15px;margin-bottom:20px;font-size:13px;font-weight:400}._2D7gy,._2RGyj{position:relative}._2D7gy{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:nowrap;flex-wrap:nowrap}._3lixl{position:relative;color:#2196f3;text-decoration:none;padding-right:10px;white-space:nowrap}._3lixl:after{content:\" \";width:14px;height:40px;display:inline-block;position:absolute;top:-1px;right:0}._1PnBY img,._3lixl img{position:relative;top:-2px;margin-right:.2em}._1PnBY img{margin-right:0;margin-left:.2em}._1PnBY{color:#2196f3;text-decoration:none}._1Xbec{position:relative;display:inline-block;margin:0 4px}._3D7Hi{width:calc(100% - 185px);vertical-align:baseline;line-height:38px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._28B9W{position:relative;display:inline-block;color:#000;padding:0 4px;text-decoration:none;white-space:nowrap;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}._28B9W:hover{color:#2196f3}._1YPBx{text-align:right;width:185px;white-space:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;line-height:38px;vertical-align:baseline}._2KeiV{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._12lwS:first-letter{text-transform:uppercase}._3c9DX{display:none}", ""]);

// exports
exports.locals = {
	"root": "_2RGyj",
	"flexRow": "_2D7gy flexRow",
	"back": "_3lixl",
	"next": "_1PnBY",
	"divider": "_1Xbec",
	"left": "_3D7Hi",
	"select": "_28B9W",
	"right": "_1YPBx",
	"breadcrumbsItem": "_2KeiV",
	"firstLetterUppercase": "_12lwS",
	"displayNone": "_3c9DX"
};

/***/ }),

/***/ 3282:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3283);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./withTransportInfo.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./withTransportInfo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3283:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3sJWs{text-decoration:none}._3sJWs:hover{text-decoration:underline}._3wFsu{color:#000;cursor:default}", ""]);

// exports
exports.locals = {
	"infoLink": "_3sJWs",
	"notLink": "_3wFsu"
};

/***/ }),

/***/ 3284:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3285);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertLeasingTitle.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertLeasingTitle.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3285:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Og13d{position:relative;padding:0 18px 16px;font-weight:400;cursor:default;min-height:100px}._32c5u{font-size:21px;margin-bottom:4px;font-weight:700;max-width:500px}.ZyAI2{font-size:12px;color:#aaa;font-weight:400;margin:0}._2d7ou,._3Ik3K,._TY4k{color:#999;font-size:12px;display:inline-block;margin-right:20px}._2d7ou>i{font-size:14px;margin-right:.2em}._3-gGk{font-size:22px;text-align:right;width:100%}._3-gGk._3A3Wy{font-size:16px}._28jGj{margin-bottom:2px}._3xUuW{font-size:22px;font-weight:700;white-space:nowrap}._3xUuW:not(:first-of-type){font-weight:400;font-size:14px}._11gFs{margin-left:-7px}._1qNLx,._11gFs{display:inline-block}._1qNLx{vertical-align:top;font-weight:600;padding:5px 10px;font-size:14px;background:#ffd906;border-radius:2px;color:#000;text-decoration:none;margin:1px 0 27px}._1qNLx:hover{background:#ffc107}._1I-8t{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:end;align-items:end}._1I-8t,._144Vd{-webkit-box-align:end;-ms-flex-align:end}._144Vd{display:-webkit-box;display:-ms-flexbox;display:flex;align-items:flex-end}.LBbJt{margin-bottom:5px}", ""]);

// exports
exports.locals = {
	"root": "Og13d",
	"title": "_32c5u",
	"h1": "ZyAI2",
	"id": "_TY4k",
	"date": "_3Ik3K",
	"views": "_2d7ou",
	"price": "_3-gGk",
	"contractPrice": "_3A3Wy",
	"priceList": "_28jGj",
	"priceItem": "_3xUuW",
	"favoriteContainer": "_11gFs",
	"clarifyPrice": "_1qNLx",
	"blockRightFlex": "_1I-8t",
	"yearSection": "_144Vd",
	"LeasingButton": "LBbJt"
};

/***/ }),

/***/ 3286:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3287);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VideosItem.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./VideosItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3287:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1iMnr{width:250px;padding:0 0 10px;cursor:pointer}._20-nl{padding:0 5px 10px}._3rzxl{opacity:0}._1oXxa,._2hH1E{height:217px}._1oXxa{margin-right:5%;position:relative;left:0;top:0;-webkit-box-flex:0;-ms-flex:0 0 340px;flex:0 0 340px;width:240px}._1Xi9Q{display:block;color:#fff;font-size:15px;max-height:45px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;padding:0 5px}._1oXxa,._2hH1E{position:relative;background:#f1f1f1 no-repeat 50%/cover}._1mXiS{background-size:60%}@media screen and (max-width:768px){._1oXxa{-webkit-box-flex:0;-ms-flex:0 0 180px;flex:0 0 180px}}@media screen and (max-width:400px){._1oXxa{-webkit-box-flex:0;-ms-flex:0 0 145px;flex:0 0 145px}}", ""]);

// exports
exports.locals = {
	"root": "_1iMnr",
	"mobileRoot": "_20-nl",
	"stretchedLink": "_3rzxl stretched",
	"tableThumb": "_2hH1E",
	"listThumb": "_1oXxa",
	"tableDate": "_1Xi9Q",
	"placeholderThumb": "_1mXiS"
};

/***/ }),

/***/ 3288:
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(333),
    createAggregator = __webpack_require__(2236);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function (result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;

/***/ }),

/***/ 3289:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3290);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertOptions.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertOptions.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3290:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2Z3Qh{font-size:17px;font-weight:700;margin-bottom:15px}._21lJs{font-size:12px}._1iifk{display:inline-block;margin-right:20px;width:calc(50% - 20px);vertical-align:top}._1__c2{list-style:none;margin-left:0;padding-left:0}._32IH-{margin-bottom:30px}._1TEn2{padding-bottom:10px;font-size:16px;font-weight:700;margin:0}._1MfaW{margin:0;padding:0;padding-left:20px}._1MfaW,._3sZGk{list-style:initial}._3sZGk{font-size:14px;font-weight:300;line-height:150%}", ""]);

// exports
exports.locals = {
	"root": "_3CBXc",
	"title": "_2Z3Qh",
	"list": "_21lJs",
	"col": "_1iifk",
	"group": "_1__c2",
	"optionGroup": "_32IH-",
	"optionGroupTitle": "_1TEn2",
	"optionList": "_1MfaW",
	"option": "_3sZGk"
};

/***/ }),

/***/ 3291:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3292);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertMessage.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertMessage.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3292:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".M87yJ{color:red;font-size:10px;font-weight:400;padding-bottom:10px;display:inline-block;padding-right:20px;text-align:left;width:420px}._2c786 .M87yJ{width:100%}._2oCzq{padding-bottom:10px;font-size:16px;font-weight:700;margin:0}._2voSq .HPHKI{padding:0 20px 0 0!important}._2c786 .HPHKI{padding:0}", ""]);

// exports
exports.locals = {
	"root": "_2voSq",
	"rootMobile": "_2c786",
	"warningBlock": "M87yJ",
	"messageTitle": "_2oCzq",
	"dialogForm": "HPHKI"
};

/***/ }),

/***/ 3293:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3294);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertInfo.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertInfo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3294:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2Gupx{padding:15px 0 0 15px}.RyC3G{padding:3px 0 8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._1mJ7B{width:20px;color:#888}._1mJ7B>svg{width:12px;height:12px}.heJ1W{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1hnlw{font-size:10px;line-height:12px;color:#888;margin-bottom:4px}._27p5n{font-size:14px;line-height:17px;color:#000}", ""]);

// exports
exports.locals = {
	"root": "_2Gupx",
	"row": "RyC3G",
	"icon": "_1mJ7B",
	"info": "heJ1W",
	"title": "_1hnlw",
	"value": "_27p5n"
};

/***/ }),

/***/ 3295:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7ead35e3.svg";

/***/ }),

/***/ 3296:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3297);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerServiceExchangeForm.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerServiceExchangeForm.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3297:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1t6XA,.IJnx_{position:relative;color:#d7433d;font-weight:400;font-size:13px;text-align:center;display:block;line-height:1.2;min-height:20px}._1t6XA{color:#2c7e07;font-size:15px;font-weight:500}._2QEGm>button,._2QEGm>input{margin:5px 0}.IHnnB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;font-size:12px;padding-bottom:15px}.O9Wp2{position:relative;width:9px;height:148px}.KDg6H{height:148px;border-radius:5px;margin-bottom:10px;background-size:cover;background-position:50%}._1Gz_O,.KDg6H,.l3Ltp{width:148px}.l3Ltp .KDg6H{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#f5f5f5}._1D8Fe{font-weight:700;font-size:12px;line-height:16px;margin-top:4px}._34u5R{position:absolute;width:60px;height:60px;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border-radius:60px;background:#fff;-webkit-box-shadow:0 5px 20px rgba(0,0,0,.1);box-shadow:0 5px 20px rgba(0,0,0,.1);-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._34u5R>svg{width:30px;height:30px}._3VLNd{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:5px 0;font-weight:400;font-size:12px;line-height:16px;color:gray}", ""]);

// exports
exports.locals = {
	"errorMessage": "IJnx_",
	"successMessage": "_1t6XA",
	"requestForm": "_2QEGm",
	"carBlock": "IHnnB",
	"circleExchangeBlock": "O9Wp2",
	"carBlockImage": "KDg6H",
	"carBlockRight": "l3Ltp",
	"carBlockLeft": "_1Gz_O",
	"carBlockPrice": "_1D8Fe",
	"circleExchange": "_34u5R",
	"agreeCheckbox": "_3VLNd"
};

/***/ }),

/***/ 3298:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3299);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertSellerDealer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertSellerDealer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3299:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".ZOfhX{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:horizontal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._9XqAD,.ZOfhX{position:relative;background-color:#f5f5f5;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-direction:normal}._9XqAD{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}.ZOfhX .p5A6s{padding:20px 18px 12px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:330px;-webkit-box-align:end;-ms-flex-align:end;align-items:end;flex-direction:column}._9XqAD .p5A6s,.ZOfhX .p5A6s{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column}._9XqAD .p5A6s{flex-direction:column;padding:15px}.ZOfhX ._7RxAa{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}._7RxAa,.ZOfhX ._7RxAa{display:-webkit-box;display:-ms-flexbox;display:flex}._7RxAa{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}._7RxAa button{width:100%!important;margin-bottom:10px!important;height:auto}.ZOfhX ._2-cM5{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start;padding:15px 15px 0 0;width:390px}._9XqAD ._2-cM5,.ZOfhX ._2-cM5{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._9XqAD ._2-cM5{padding:0 15px 5px}.DSBvd{padding:3px 0 8px;font-size:14px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.dh-Ps{position:relative;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}._3EYAJ{font-size:12px;line-height:14px;color:gray}._2L220{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;position:relative;font-weight:700;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#000}._25ps5{-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #d8d8d8;width:40px;margin-right:5px}._29N6G{min-width:45px}._9XqAD ._29N6G{width:60px}._35gKx{color:gray;text-decoration:none;font-weight:700}._1ZYPd{display:block;padding-top:5px;font-weight:400}.v1Pvu{height:42px}._3eonc,.v1Pvu{font-size:14px!important}._3eonc{width:190px!important;height:60px;margin:0 10px 0 0!important}._2CJMk svg,._3eonc svg,.v1Pvu svg{margin-right:8px}._2aYnH a{font-weight:600;font-size:14px;line-height:17px;color:#000}._33SKx{display:block;text-align:center}._33SKx,.by_2F{font-size:12px;line-height:16px}.by_2F{text-decoration:none;color:#1575c3;display:inline-block}.by_2F:hover{color:#2196f3}.nwLQ8{font-weight:700;font-size:18px}._1jXyE{max-width:335px}._17HoL{text-align:center;min-height:248px;padding-top:45px}._3kWgx{font-size:14px;padding-top:14px;color:gray}._3kWgx>img{margin-right:10px}._1RkRp,.ZOfhX ._22cLh{margin-bottom:4px}._9XqAD ._22cLh{text-align:center;display:block;padding-top:10px}.ZOfhX ._36P2R{margin-top:10px}._1yQHp{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ZOfhX ._1yQHp{width:calc(100% - 45px)}.ZOfhX ._2YKHP{margin:10px 0}._9XqAD ._2YKHP,.ZOfhX ._2YKHP{display:-webkit-box;display:-ms-flexbox;display:flex}._9XqAD ._2YKHP{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._9XqAD ._2YKHP>div{margin-bottom:5px}.ZOfhX ._2YKHP>div{margin-right:8px}", ""]);

// exports
exports.locals = {
	"root": "ZOfhX",
	"rootMobile": "_9XqAD",
	"rowContainer": "p5A6s",
	"flexRowBlock": "_7RxAa",
	"flexColumnBlock": "_2-cM5",
	"messengersBlock": "_2bW7O",
	"titleBlock": "DSBvd",
	"col": "dh-Ps",
	"greyText": "_3EYAJ",
	"colAuto": "_2L220",
	"avatar": "_25ps5",
	"avatarBlock": "_29N6G",
	"authorLink": "_35gKx",
	"authorExtraText": "_1ZYPd",
	"exchangeButton": "v1Pvu",
	"incomminCall": "_3eonc",
	"testDriveButton": "_2CJMk",
	"dealerInfo": "_2aYnH",
	"modalText": "_33SKx",
	"modalTextLink": "by_2F",
	"rootModalTitle": "nwLQ8",
	"modal": "_1jXyE _1jXyE",
	"thanksDialog": "_17HoL",
	"locationBlock": "_3kWgx",
	"authorName": "_1RkRp",
	"moreAdvsText": "_22cLh",
	"buttonsWrapper": "_36P2R",
	"statusesBlock": "_1yQHp",
	"statusesIcons": "_2YKHP"
};

/***/ }),

/***/ 3300:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3301);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./YoutubeVideo.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./YoutubeVideo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3301:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2KCMq{position:relative;height:auto;padding-bottom:62.5%}._3MzAc{height:100%;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_2KCMq",
	"iframe": "_3MzAc stretched"
};

/***/ }),

/***/ 3302:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3303);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingQuestions.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingQuestions.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3303:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2JOHN,._14-Ye{padding:20px 20px 0;background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.2)),to(rgba(253,191,0,.2))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff;border-radius:3px}._31N9F{margin-bottom:15px}._14-Ye ._31N9F{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3uu31{font-size:18px;font-weight:600;line-height:21px;color:#000;margin:0;padding:0}._31N9F>p{font-size:14px;line-height:150%;color:#000}._2JOHN ._9o68z{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._2JOHN ._9o68z,._14-Ye ._9o68z{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}._14-Ye ._9o68z{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._2JOHN ._9o68z>input{width:240px;margin-right:10px}._14-Ye ._9o68z>input{margin-bottom:10px}._2JOHN ._9o68z>button{width:170px;height:42px;margin:0}._14-Ye ._9o68z>button{height:42px;margin:0}._2biT5,._9n_FM{position:relative;color:#d7433d;font-weight:400;font-size:13px;text-align:center;display:block;line-height:1.2;min-height:20px}._9n_FM{color:#2c7e07;font-size:15px;font-weight:500}._3sayR{height:20px}", ""]);

// exports
exports.locals = {
	"root": "_2JOHN",
	"rootMobile": "_14-Ye",
	"info": "_31N9F",
	"infoTitle": "_3uu31",
	"form": "_9o68z",
	"errorMessage": "_2biT5",
	"successMessage": "_9n_FM",
	"messageBlock": "_3sayR"
};

/***/ }),

/***/ 3304:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3305);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TestDrives.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TestDrives.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3305:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._31PpZ{padding:10px 0}._1MvqR{text-align:center;font-size:24px;font-weight:300;padding:50px 10px 90px}", ""]);

// exports
exports.locals = {
	"root": "_31PpZ",
	"emptyMessage": "_1MvqR"
};

/***/ }),

/***/ 3306:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3307);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Warranty.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Warranty.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3307:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3oLPz{position:relative;border-bottom:1px solid #d8d8d8;z-index:1;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding:20px}._3oLPz,._3tM0G{display:-webkit-box;display:-ms-flexbox;display:flex}._3tM0G{-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 15px 0 0;height:40px;margin-top:5px}.zrYJb{max-height:40px}.rac-v{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0;max-width:500px}._20fFl{position:relative;padding:5px 20px 0 10px;width:50%}._3uQ3g{line-height:16px;font-size:13px}.CVPWS{width:12px;top:7px;height:auto;left:-10px}._2bta8,.CVPWS{position:absolute}._2bta8{right:10px;top:10px;color:#999;font-size:22px;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "_3oLPz",
	"warrantyBlock": "_3tM0G",
	"tooltipIcon": "zrYJb",
	"warrantyList": "rac-v",
	"option": "_20fFl",
	"optionTitles": "_3uQ3g",
	"checkBoxIcon": "CVPWS",
	"topInfoIcon": "_2bta8"
};

/***/ }),

/***/ 3308:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3309);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Nav.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Nav.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3309:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3yOFe{background-color:#fff}.dV7w4{position:relative;overflow:hidden;list-style:none;font-size:14px;font-weight:600;margin:0;padding-left:18px}.dV7w4 li{float:left;padding:8px 0;margin-right:26px;border-top:2px solid #fff;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out}.dV7w4 li._11lCu,.dV7w4 li:hover{border-top:2px solid #ffd906}._1Qw5O{color:#000;text-decoration:none;cursor:pointer;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out}.dV7w4 li:hover ._1Qw5O{color:#e73232;text-decoration:none}.dV7w4 li._1v2uJ ._1Qw5O{color:#ccc;text-decoration:none;cursor:default;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out}.dV7w4 li._1v2uJ ._1Qw5O,.dV7w4 li._1v2uJ:hover{border-top:2px solid transparent}", ""]);

// exports
exports.locals = {
	"root": "_3yOFe",
	"nav": "dV7w4",
	"active": "_11lCu",
	"link": "_1Qw5O",
	"disabled": "_1v2uJ"
};

/***/ }),

/***/ 3310:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3311);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CarInfo.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CarInfo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3311:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2WBLh{background-color:#fff;margin-top:20px;margin-bottom:20px;z-index:1}._1BJXD,._2WBLh{position:relative}._1BJXD{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:nowrap;flex-wrap:nowrap;padding-bottom:15px}._3yFbM{height:1px;background-color:rgba(0,0,0,.15)}._3ERQW{padding:0 15px 15px}._38b_4{width:300px}._3s_xP{width:calc(100% - 330px);padding:15px 15px 0 0}.axr90{margin-bottom:20px}._1SrTv{position:absolute;display:inline-block;border:1px solid #ccc;border-radius:2px;font-size:12px;font-weight:400;text-decoration:none;color:#000;text-align:center;padding:6px 25px;right:15px;bottom:15px;cursor:pointer}._1SrTv:hover{border:1px solid #2196f3;color:#2196f3}._1F7nj{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"root": "_2WBLh",
	"flexRow": "_1BJXD flexRow",
	"divider": "_3yFbM",
	"infoBlock": "_3ERQW",
	"left": "_38b_4",
	"right": "_3s_xP",
	"youtubeVideo": "axr90",
	"allVideos": "_1SrTv",
	"vinLeasingBlock": "_1F7nj"
};

/***/ }),

/***/ 3312:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3313);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Advert.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Advert.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3313:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".RjJ-L{margin:0 auto}._1N1iB{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2xu7G{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._2OiFB{width:300px}._2OiFB,.nFKD3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.nFKD3{width:calc(100% - 300px);padding-right:20px;position:relative}._2bKrm,._1770o{margin-bottom:20px}._2bKrm{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 45px}._2bKrm .adunitContainer>*{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"page": "_1pw5C page",
	"container": "RjJ-L container",
	"flexRow": "_1N1iB flexRow",
	"flexGrow1": "_2xu7G",
	"sideBar": "_2OiFB",
	"mainCell": "nFKD3",
	"gptPremium": "_1770o",
	"mainCellAds": "_2bKrm"
};

/***/ }),

/***/ 3354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/actions/advertTopCars.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(17);


/* Common action creators */

var setAdvertTopCars = function setAdvertTopCars(obj) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["b" /* ADVERT_TOP_CARS */].SET,
    payload: obj
  };
};


// CONCATENATED MODULE: ./src/shared/helpers/searchResultsRetrievement.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flatten__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



var isUnprefixedKey = function isUnprefixedKey(str) {
  return !str.match(/^[a-z]+-/);
};

var getAdvertFromStoreById = function getAdvertFromStoreById(id, store) {
  var storedAdverts = __WEBPACK_IMPORTED_MODULE_0_lodash_flatten___default.a(Object.entries(store.getState().searchForm.results).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return isUnprefixedKey(key);
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        value = _ref4[1];

    return value && value.results ? value.results : value;
  }));

  return storedAdverts.find(function (advert) {
    return advert && advert.id === id;
  });
};
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingUlfBanner.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_hocs_withLeasingParams__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_ulf24__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__UserDataForm_UserDataForm__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__UserDataForm_UserDataFormWithPhotoDialogWrapper__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__LeasingOnlineBanner_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import Loader from 'shared/components/Loader/Loader';






// import withUlf24 from 'shared/hocs/withUlf24';


// import {
//   calculateMonthlyPaymentV2,
//   calculateExchange,
//   getMonthlyPrice,
// } from 'shared/helpers/leasing/utils';



// import { numberWithSpaces } from 'shared/helpers/common';


// import FormInput from './Inputs/FormInput';
// import {
//   prepareParamsForLeasingLeadRequest,
//   createMyAutoLead,
// } from 'shared/helpers/leasing/myAuto';




// import FormInput from './Inputs/FormInput';
// import { monthlyHapaiCalculate } from 'shared/helpers/leasing/ulf24';


// import LeasingCalculateFixedPrepaymentForm from './UserDataForm/LeasingCalculateFixedPrepaymentForm';
// import UserDataFormExtended from './UserDataForm/UserDataFormExtended';


// eslint-disable-next-line css-modules/no-unused-class


// const TERMS = [12, 24, 36, 48, 60, 72, 84];
// const PREPAYMENT_PERCENTS = [20, 25, 30, 35, 40];

var LeasingUlfBanner = function (_React$Component) {
  _inherits(LeasingUlfBanner, _React$Component);

  function LeasingUlfBanner(props) {
    _classCallCheck(this, LeasingUlfBanner);

    var _this = _possibleConstructorReturn(this, (LeasingUlfBanner.__proto__ || Object.getPrototypeOf(LeasingUlfBanner)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        leasingParams = _this$props.leasingParams,
        advert = _this$props.advert,
        user = _this$props.user;

    var userName = user && user.name || '';
    var phone = user && user.phones && user.phones[0].number || '';
    var priceUah = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_advert__["c" /* getPrice */](advert.price, ['uah']);
    // const prepaidUah = calculateExchange(advert.price, leasingParams.prepaidSum, 'uah');
    // const comission = calculateExchange(advert.price, leasingParams.prepaidCommission, 'uah');
    // const rate = leasingParams.annualRate;

    _this.state = {
      price: priceUah,
      prepaid: leasingParams && leasingParams.prepayment,
      term: leasingParams && leasingParams.term,
      // rate,
      // comission,
      // terms: [12, 24, 36, 48, 60, 72, 84],
      // prepaidPercent: this.getPrepaymentPercent(),
      // prepaidPercents: [20, 25, 30, 35, 40],
      userName: userName,
      birthday: '',
      phone: phone,
      errorMessage: '',
      successMessage: '',
      // step: 'periods',
      step: 'userform',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false,
      //
      loading: false
    };
    return _this;
  }

  _createClass(LeasingUlfBanner, [{
    key: 'render',
    value: function render() {
      var _cs;

      var _props = this.props,
          t = _props.t,
          leasingParams = _props.leasingParams,
          lodaingPlaceholder = _props.lodaingPlaceholder;
      var step = this.state.step;

      var symbol = __WEBPACK_IMPORTED_MODULE_13_shared_helpers_transportInfo__["p" /* getSymbolTitleBySlug */]('uah');

      var monthlySum = lodaingPlaceholder || leasingParams.extendedParams && leasingParams.extendedParams.monthlyPaymentUAHFormatted;
      var titleHTML = t('Ежемесячный платеж') + '<br /> <b>' + monthlySum + ' ' + symbol + '</b>';

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cs = {}, _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_20__LeasingOnlineBanner_css___default.a.container, true), _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_20__LeasingOnlineBanner_css___default.a.LeasingContainerContentSidebar, !this.props.modalMode), _cs))
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_19__UserDataForm_UserDataFormWithPhotoDialogWrapper__["a" /* default */], {
        advertInfo: this.props.advert,
        showTitle: !this.props.modalMode,
        titleHTML: titleHTML,
        showAgreemant: step === 'userform'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__LeasingOnlineBanner_css___default.a.LeasingUlfBanner
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_18__UserDataForm_UserDataForm__["a" /* default */], {
        disableBtnLeasing: this.state.disableBtnLeasing,
        userName: this.state.userName,
        phone: this.state.phone,
        birthday: this.state.birthday,
        errorMessage: this.state.errorMessage,
        successMessage: this.state.successMessage,
        monthlyPayment: this.state.monthlyPayment,
        changeHandler: this.changeHandler,
        onSubmitHandler: this.onSubmitUesrDataForm,
        toggleLeasingModal: this.state.toggleLeasingModal
      }))));
    }
  }]);

  return LeasingUlfBanner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingUlfBanner.defaultProps = {
  eventPostfix: '',
  user: null,
  modalMode: false,
  leasingParams: null,
  onSubmited: function onSubmited() {},
  onLeasingParamsChanged: function onLeasingParamsChanged() {},
  lodaingPlaceholder: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSubmitCalcDataForm = function () {
    _this2.pushEvent('monthly-calculation-form-sumbit');
    _this2.setState({ step: 'userform' });
  };

  this.onSubmitUesrDataForm = function (e) {
    var _props2 = _this2.props,
        onSubmited = _props2.onSubmited,
        enqueueNotif = _props2.enqueueNotif,
        t = _props2.t;

    e.preventDefault();
    var _state = _this2.state,
        phone = _state.phone,
        userName = _state.userName;

    var errorMsg = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["l" /* userFormValidation */]({ phone: phone, userName: userName });
    if (errorMsg) {
      _this2.setState({ errorMessage: errorMsg });
      return;
    }

    _this2.fireEvent();
    _this2.setState({ disableBtnLeasing: true });

    _this2.submitLeasingLead(function (isSUccess) {
      _this2.setState({ disableBtnLeasing: false });
      var errorMessage = !isSUccess ? 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже' : '';
      _this2.setState({
        userName: '',
        phone: '',
        errorMessage: errorMessage,
        successMessage: ''
      });
      if (isSUccess) {
        onSubmited();
        enqueueNotif(t('Ваша заявка отправлена!'));
      }
    });
  };

  this.onLeadCreated = function (success) {
    _this2.pushEvent('lead-create-' + (success ? 'success' : 'fail'));
  };

  this.getPrepaymentPercent = function (prepayment) {
    var _props3 = _this2.props,
        advert = _props3.advert,
        leasingParams = _props3.leasingParams;

    var priceUah = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_advert__["c" /* getPrice */](advert.price, ['uah']);
    return Math.round((prepayment || leasingParams.prepayment) * 100 / priceUah);
  };

  this.pushEvent = function (eventName) {
    var eventPostfix = _this2.props.eventPostfix;

    var event = 'ulf24-' + eventName + (eventPostfix ? '-' + eventPostfix : '');
    if (__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]) _this2.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]);else {}
  };

  this.submitLeasingLead = function (cb) {
    var _state2 = _this2.state,
        phone = _state2.phone,
        userName = _state2.userName;
    var _props4 = _this2.props,
        advert = _props4.advert,
        leasingParams = _props4.leasingParams,
        fetch = _props4.fetch;


    var leadParams = __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({ phone: phone, userName: userName, leasingParams: leasingParams, advert: advert });
    var createLead = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_ulf24__["a" /* createUlf24Lead */];
    if (__WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["k" /* isUlfLeasing */](leasingParams)) {
      createLead = __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__["a" /* createUlfLead */];
    }
    createLead(leadParams, fetch).then(function (data) {
      cb(data && data.success);
      _this2.onLeadCreated(data && data.success);
    }).catch(function () {
      cb(false);
      _this2.onLeadCreated(false);
    });

    return false;
  };

  this.fireEvent = function () {
    __WEBPACK_IMPORTED_MODULE_15_shared_helpers_rtbHouse__["a" /* fireRTBEvent */]('leasingNew', {
      value: _this2.props.advert.price && __WEBPACK_IMPORTED_MODULE_14_shared_helpers_advert__["c" /* getPrice */](_this2.props.advert.price),
      ids: [_this2.props.advert.id]
    });

    _this2.pushEvent('monthly-consultation-form-sumbit');
  };

  this.changeHandler = function (field, value) {
    var _this2$setState;

    if (field === 'prepaidPercent') _this2.props.onLeasingParamsChanged(_this2.props.leasingParams.term, value);else if (field === 'term') _this2.props.onLeasingParamsChanged(value, _this2.getPrepaymentPercent());else _this2.setState((_this2$setState = {}, _defineProperty(_this2$setState, field, value), _defineProperty(_this2$setState, 'errorMessage', ''), _this2$setState));
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user && state.user.user
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    enqueueNotif: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__["a" /* enqueueNotification */], dispatch),
    setDataLayer: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ var LeasingUlfBanner_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_20__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_12_shared_hocs_withLeasingParams__["a" /* withLeasingParams */](LeasingUlfBanner))))));
// CONCATENATED MODULE: ./src/shared/components/SuccessBlock/SuccessBlock.js
/* harmony import */ var SuccessBlock___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SuccessBlock___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SuccessBlock___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_success_png__ = __webpack_require__(3269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_success_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_success_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SuccessBlock_css__ = __webpack_require__(3270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SuccessBlock_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SuccessBlock_css__);
var SuccessBlock__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SuccessBlock__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SuccessBlock__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SuccessBlock__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SuccessBlock__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SuccessBlock__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SuccessBlock = function (_React$PureComponent) {
  SuccessBlock__inherits(SuccessBlock, _React$PureComponent);

  function SuccessBlock() {
    SuccessBlock__classCallCheck(this, SuccessBlock);

    return SuccessBlock__possibleConstructorReturn(this, (SuccessBlock.__proto__ || Object.getPrototypeOf(SuccessBlock)).apply(this, arguments));
  }

  SuccessBlock__createClass(SuccessBlock, [{
    key: 'render',
    value: function render() {
      var title = this.props.title;

      var isMobile = "desktop" === 'mobile';

      return SuccessBlock__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__SuccessBlock_css___default.a.root, SuccessBlock__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__SuccessBlock_css___default.a.mobileRoot, isMobile))
      }, void 0, SuccessBlock__jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_success_png___default.a,
        className: __WEBPACK_IMPORTED_MODULE_6__SuccessBlock_css___default.a.icon,
        alt: ''
      }), SuccessBlock__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__SuccessBlock_css___default.a.title
      }, void 0, SuccessBlock__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
        id: title
      })));
    }
  }]);

  return SuccessBlock;
}(SuccessBlock___WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/* harmony default export */ var SuccessBlock_defaultExport = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__SuccessBlock_css___default.a)(SuccessBlock));
// CONCATENATED MODULE: ./src/shared/components/SoldMessage/SoldMessage.js
/* harmony import */ var SoldMessage___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SoldMessage___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SoldMessage___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SoldMessage_css__ = __webpack_require__(3272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SoldMessage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SoldMessage_css__);
var SoldMessage__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();


// import PropTypes from 'prop-types';
// import cx from 'classnames';




var SoldMessage__ref = SoldMessage__jsx(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
  id: '\u042D\u0442\u043E\u0442 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0443\u0436\u0435 \u043F\u0440\u043E\u0434\u0430\u043D'
});

function SoldMessage(props) {
  return SoldMessage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SoldMessage_css___default.a.root
  }, void 0, SoldMessage__jsx('div', {}, void 0, SoldMessage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SoldMessage_css___default.a.title
  }, void 0, SoldMessage__ref)));
}

/* harmony default export */ var SoldMessage_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__SoldMessage_css___default.a)(SoldMessage));
// CONCATENATED MODULE: ./src/shared/components/InfoBlock/InfoBlock.js
/* harmony import */ var InfoBlock___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InfoBlock___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InfoBlock___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InfoBlock___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var InfoBlock___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(InfoBlock___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var InfoBlock___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var InfoBlock___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(InfoBlock___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var InfoBlock___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_alert_png__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_alert_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_alert_png__);
/* harmony import */ var InfoBlock___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var InfoBlock___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(InfoBlock___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfoBlock_css__ = __webpack_require__(3274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfoBlock_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InfoBlock_css__);
var InfoBlock__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var InfoBlock__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function InfoBlock__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function InfoBlock__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function InfoBlock__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function InfoBlock__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var InfoBlock = function (_React$PureComponent) {
  InfoBlock__inherits(InfoBlock, _React$PureComponent);

  function InfoBlock() {
    InfoBlock__classCallCheck(this, InfoBlock);

    return InfoBlock__possibleConstructorReturn(this, (InfoBlock.__proto__ || Object.getPrototypeOf(InfoBlock)).apply(this, arguments));
  }

  InfoBlock__createClass(InfoBlock, [{
    key: 'render',
    value: function render() {
      var title = this.props.title;

      var isMobile = "desktop" === 'mobile';

      return InfoBlock__jsx('div', {
        className: InfoBlock___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__InfoBlock_css___default.a.root, InfoBlock__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__InfoBlock_css___default.a.mobileRoot, isMobile))
      }, void 0, InfoBlock__jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_alert_png___default.a,
        className: __WEBPACK_IMPORTED_MODULE_6__InfoBlock_css___default.a.icon,
        alt: ''
      }), InfoBlock__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__InfoBlock_css___default.a.title
      }, void 0, InfoBlock__jsx(InfoBlock___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
        id: title
      })));
    }
  }]);

  return InfoBlock;
}(InfoBlock___WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/* harmony default export */ var InfoBlock_defaultExport = (InfoBlock___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__InfoBlock_css___default.a)(InfoBlock));
// CONCATENATED MODULE: ./src/shared/components/SparesForAdvert/SparesForAdvert.js
/* harmony import */ var SparesForAdvert___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SparesForAdvert___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SparesForAdvert___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SparesForAdvert___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SparesForAdvert___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SparesForAdvert___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var SparesForAdvert___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SparesForAdvert___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SparesForAdvert___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_SpareImg__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css__ = __webpack_require__(3276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css__);
var SparesForAdvert__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SparesForAdvert__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SparesForAdvert__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SparesForAdvert__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SparesForAdvert__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var isMobile = "desktop" === 'mobile';

var _ref2 = SparesForAdvert__jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F'
});

var SparesForAdvert__ref4 = SparesForAdvert__jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u0441\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438 \u0434\u043B\u044F'
});

var SparesForAdvert = function (_React$Component) {
  SparesForAdvert__inherits(SparesForAdvert, _React$Component);

  function SparesForAdvert() {
    var _ref;

    var _temp, _this, _ret;

    SparesForAdvert__classCallCheck(this, SparesForAdvert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SparesForAdvert__possibleConstructorReturn(this, (_ref = SparesForAdvert.__proto__ || Object.getPrototypeOf(SparesForAdvert)).call.apply(_ref, [this].concat(args))), _this), _this.generateUrl = function (slug) {
      return ('/' + __WEBPACK_IMPORTED_MODULE_5_shared_helpers_urls__["f" /* generateSparesSearchUrl */]({}) + '/' + slug).replace(/\/\//g, '/');
    }, _temp), SparesForAdvert__possibleConstructorReturn(_this, _ret);
  }

  SparesForAdvert__createClass(SparesForAdvert, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          intl = _props.intl,
          sparesLink = _props.sparesLink;
      var _props2 = this.props,
          spares = _props2.spares,
          make = _props2.make,
          model = _props2.model;

      var title = make || model ? (make.title || '') + ' ' + (model.title || '') : intl.formatMessage({ id: 'данной модели' });

      var rootClass = isMobile ? __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a.root;

      return SparesForAdvert__jsx('div', {
        className: rootClass
      }, void 0, SparesForAdvert__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a.title
      }, void 0, _ref2, ' ', ' ' + title), SparesForAdvert__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a.wrapper
      }, void 0, spares.map(function (_ref3) {
        var id = _ref3.id,
            permalink = _ref3.permalink,
            rubric = _ref3.rubric,
            price = _ref3.price,
            photos = _ref3.photos,
            currency = _ref3.currency;

        var link = permalink || _this2.generateUrl(id);
        return SparesForAdvert__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a.spare
        }, id, SparesForAdvert__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
          to: link
        }, void 0, SparesForAdvert__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_SpareImg__["a" /* default */], {
          photos: photos
        })), SparesForAdvert__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a.spareInfo
        }, void 0, rubric && SparesForAdvert__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
          className: __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a.spareTitle,
          to: link
        }, void 0, rubric.title), price && SparesForAdvert__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a.sparePrice
        }, void 0, price.some(function (p) {
          return p.value;
        }) && __WEBPACK_IMPORTED_MODULE_4_shared_helpers_transportInfo__["o" /* getPriceWithCurrency */](price, currency.slug) || intl.formatMessage({ id: 'договорная' }))));
      })), SparesForAdvert__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a.allSpares,
        to: sparesLink
      }, void 0, SparesForAdvert__ref4, ' ', ' ' + title));
    }
  }]);

  return SparesForAdvert;
}(SparesForAdvert___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SparesForAdvert.defaultProps = {
  make: null,
  model: null
};


/* harmony default export */ var SparesForAdvert_defaultExport = (SparesForAdvert___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__SparesForAdvert_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](SparesForAdvert)));
// CONCATENATED MODULE: ./src/desktop/components/SpecialAdvertCars/SpecialAdvertCars.js
/* harmony import */ var SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_crown_svg__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_crown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_crown_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_AdvertLabel_AdvertLabel__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Thumb_Thumb__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css__ = __webpack_require__(3278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css__);
var SpecialAdvertCars__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SpecialAdvertCars__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SpecialAdvertCars__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SpecialAdvertCars__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SpecialAdvertCars__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import LeasingButton from 'shared/components/LeasingOnlineBanner/LeasingButton/LeasingButton';







var IMAGE_WIDTH = 280;

var SpecialAdvertCars__ref4 = SpecialAdvertCars__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_crown_svg___default.a,
  width: '26',
  height: '32',
  alt: ''
});

var SpecialAdvertCars__ref5 = SpecialAdvertCars__jsx(SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u041B\u0443\u0447\u0448\u0438\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F'
});

var _ref6 = SpecialAdvertCars__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_Icons__["b" /* CalendarIcon */], {});

var _ref7 = SpecialAdvertCars__jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_Icons__["o" /* SpeedIcon */], {});

var _ref8 = SpecialAdvertCars__jsx(SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435'
});

var _ref9 = SpecialAdvertCars__jsx(SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435'
});

var SpecialAdvertCars = function (_React$Component) {
  SpecialAdvertCars__inherits(SpecialAdvertCars, _React$Component);

  function SpecialAdvertCars() {
    var _ref;

    var _temp, _this, _ret;

    SpecialAdvertCars__classCallCheck(this, SpecialAdvertCars);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SpecialAdvertCars__possibleConstructorReturn(this, (_ref = SpecialAdvertCars.__proto__ || Object.getPrototypeOf(SpecialAdvertCars)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      index: 0
    }, _this.getMileage = function (car) {
      var intl = _this.props.intl;
      var isNew = car.isNew,
          mileage = car.mileage;


      if (isNew) {
        return intl.formatMessage({ id: 'Новый' });
      } else if (mileage) {
        return mileage.split(' ').map(function (item, i) {
          return i !== 0 ? intl.formatMessage({ id: item }) : item;
        }).join(' ');
      }

      return null;
    }, _this.slideCount = function () {
      return Math.ceil(_this.props.cars.length / _this.props.itemsInSlide);
    }, _this.handlePrevClick = function (e) {
      e.preventDefault();
      _this.setState(function (_ref2) {
        var index = _ref2.index;
        return { index: (index - 1 + _this.slideCount()) % _this.slideCount() };
      });
    }, _this.handleNextClick = function (e) {
      e.preventDefault();
      _this.setState(function (_ref3) {
        var index = _ref3.index;
        return { index: (index + 1) % _this.slideCount() };
      });
    }, _temp), SpecialAdvertCars__possibleConstructorReturn(_this, _ret);
  }

  SpecialAdvertCars__createClass(SpecialAdvertCars, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var index = this.state.index;
      var _props = this.props,
          cars = _props.cars,
          itemsInSlide = _props.itemsInSlide,
          intl = _props.intl;

      var firstSlideIndex = index * itemsInSlide;

      var currentCars = cars.slice(cars.length - firstSlideIndex > itemsInSlide || cars.length < itemsInSlide ? firstSlideIndex : cars.length - itemsInSlide, firstSlideIndex + itemsInSlide);
      var imageStyle = { height: 190 };

      return SpecialAdvertCars__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.root
      }, void 0, SpecialAdvertCars__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.title
      }, void 0, SpecialAdvertCars__ref4, '\xA0', ' ', SpecialAdvertCars__ref5), SpecialAdvertCars__jsx('div', {}, void 0, currentCars.map(function (car) {
        return SpecialAdvertCars__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
          to: car.link || '',
          className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.car
        }, car.id + '_best_offers', SpecialAdvertCars__jsx(__WEBPACK_IMPORTED_MODULE_10__Thumb_Thumb__["a" /* default */], {
          defaultImg: __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__["b" /* getDefaultImageByType */](car.transport),
          width: IMAGE_WIDTH,
          photos: car.images,
          style: imageStyle,
          className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.img
        }, Math.random()), SpecialAdvertCars__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.subInfo
        }, void 0, SpecialAdvertCars__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.text
        }, void 0, SpecialAdvertCars__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.title
        }, void 0, car.title), SpecialAdvertCars__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.info
        }, void 0, SpecialAdvertCars__jsx('span', {}, void 0, _ref6, ' ', car.year), SpecialAdvertCars__jsx('span', {}, void 0, _ref7, ' ', _this2.getMileage(car))), !car.isNegotiablePrice && SpecialAdvertCars__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.priceWrapper
        }, void 0, SpecialAdvertCars__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__["a" /* default */], {
          advert: car.fullData
        })), car.isNegotiablePrice && SpecialAdvertCars__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.contractPrice
        }, void 0, intl.formatMessage({ id: 'договорная' })))), SpecialAdvertCars__jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_AdvertLabel_AdvertLabel__["a" /* default */], {
          advert: car.fullData
        }));
      })), SpecialAdvertCars__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.btns
      }, void 0, SpecialAdvertCars__jsx('button', {
        className: 'btn ' + __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.btnPrev,
        onClick: this.handlePrevClick
      }, void 0, SpecialAdvertCars__jsx('i', {
        className: 'fa fa-angle-left ' + __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.btnIcon,
        'aria-hidden': 'true'
      }), ' ', _ref8), SpecialAdvertCars__jsx('button', {
        className: 'btn ' + __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.btnNext,
        onClick: this.handleNextClick
      }, void 0, _ref9, ' ', SpecialAdvertCars__jsx('i', {
        className: 'fa fa-angle-right ' + __WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a.btnIcon,
        'aria-hidden': 'true'
      }))));
    }
  }]);

  return SpecialAdvertCars;
}(SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SpecialAdvertCars.defaultProps = {
  cars: [],
  itemsInSlide: 3
};


/* harmony default export */ var SpecialAdvertCars_defaultExport = (SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_11__SpecialAdvertCars_css___default.a)(SpecialAdvertCars___WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](SpecialAdvertCars)));
// CONCATENATED MODULE: ./src/desktop/routes/advert/components/SearchBar/SearchBar.js
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SearchBar___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var SearchBar___WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_actions_history__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_JsonLdApplication_JsonLdApplication__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_assets_images_right_arrow_line_svg__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_assets_images_right_arrow_line_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_shared_assets_images_right_arrow_line_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_assets_images_left_arrow_line_svg__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_assets_images_left_arrow_line_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_shared_assets_images_left_arrow_line_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_assets_images_angle_gray_svg__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_assets_images_angle_gray_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_shared_assets_images_angle_gray_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SearchBar_css__ = __webpack_require__(3280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css__);
var SearchBar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SearchBar__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SearchBar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchBar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SearchBar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var PER_PAGE = 20;

var SearchBar__ref2 = SearchBar__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_14_shared_assets_images_left_arrow_line_svg___default.a,
  width: 12,
  alt: ''
});

var _ref3 = SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043F\u043E\u0438\u0441\u043A\u0430'
});

var SearchBar__ref4 = SearchBar__jsx('span', {
  itemProp: 'title'
}, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], {
  id: 'Автобазар'
}));

var SearchBar__ref5 = SearchBar__jsx('span', {}, void 0, ' ', SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], {
  id: 'б/у'
}));

var SearchBar__ref6 = SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], {
  id: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435'
});

var SearchBar__ref7 = SearchBar__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_13_shared_assets_images_right_arrow_line_svg___default.a,
  width: 12,
  alt: ''
});

var SearchBar = function (_React$Component) {
  SearchBar__inherits(SearchBar, _React$Component);

  function SearchBar() {
    var _ref;

    var _temp, _this, _ret;

    SearchBar__classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SearchBar__possibleConstructorReturn(this, (_ref = SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call.apply(_ref, [this].concat(args))), _this), _this.getCorrectTransport = function (transport) {
      if (!transport) {
        return null;
      } else if (__WEBPACK_IMPORTED_MODULE_16_desktop_constants_navigation__["a" /* default */].SEARCH[transport.slug]) {
        return transport;
      } else if (transport.parents && transport.parents.length > 0 && __WEBPACK_IMPORTED_MODULE_16_desktop_constants_navigation__["a" /* default */].SEARCH[transport.parents[0].slug]) {
        return transport.parents[0];
      }

      return null;
    }, _this.handleNextAdvertClick = function () {
      _this.props.setNextSearchItemIndex(_this.props.nextSearchItemIndex + 1);
    }, _temp), SearchBar__possibleConstructorReturn(_this, _ret);
  }

  SearchBar__createClass(SearchBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          searchData = _props.searchData,
          nextItemLink = _props.nextItemLink,
          searchFormState = _props.searchFormState,
          nextSearchItemIndex = _props.nextSearchItemIndex;
      var make = searchData.make,
          model = searchData.model,
          transport = searchData.transport,
          location = searchData.location,
          year = searchData.year,
          isNew = searchData.isNew;

      var correctTransport = this.getCorrectTransport(transport);
      var q = { transport: correctTransport, make: make };
      var rootPath = '/';
      var firstLevelLink = '/' + __WEBPACK_IMPORTED_MODULE_11_shared_helpers_urls__["e" /* generateSearchUrl */]({ transport: correctTransport, isNew: isNew });
      var makeLink = '/' + __WEBPACK_IMPORTED_MODULE_11_shared_helpers_urls__["e" /* generateSearchUrl */](_extends({}, q, { make: make, transport: correctTransport, isNew: isNew }));
      var modelLink = '/' + __WEBPACK_IMPORTED_MODULE_11_shared_helpers_urls__["e" /* generateSearchUrl */](_extends({}, q, { model: model, transport: correctTransport, isNew: isNew }));
      var isCountry = __WEBPACK_IMPORTED_MODULE_10_shared_helpers_transportInfo__["s" /* isLocationCountry */](location);
      var yearLink = '/' + __WEBPACK_IMPORTED_MODULE_11_shared_helpers_urls__["e" /* generateSearchUrl */](_extends({}, q, {
        model: model,
        year: year,
        transport: correctTransport,
        isNew: isNew
      }));
      var locationLink = '/' + __WEBPACK_IMPORTED_MODULE_11_shared_helpers_urls__["e" /* generateSearchUrl */](_extends({}, q, {
        model: model,
        transport: correctTransport,
        isNew: isNew
      }, transport && transport.slug === 'avto' && !isCountry ? { year: year } : {}, {
        location: location
      }));

      // Back
      var page = nextSearchItemIndex ? Math.ceil((nextSearchItemIndex - 1) / PER_PAGE) : null;
      var backUrl = page ? '/' + __WEBPACK_IMPORTED_MODULE_11_shared_helpers_urls__["e" /* generateSearchUrl */](searchFormState) + '?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(__WEBPACK_IMPORTED_MODULE_11_shared_helpers_urls__["d" /* generateSearchQuery */](_extends({}, searchFormState, { page: page }))) : null;

      var breadcrumbLinks = {
        transport: firstLevelLink,
        make: makeLink,
        model: modelLink,
        year: yearLink,
        location: locationLink
      };

      var breadcrumbsListData = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_advert__["a" /* getBreadcrumbsListData */](searchData, breadcrumbLinks);

      var transportTitle = '';
      if (transport.slug === 'avto') {
        transportTitle = isNew ? 'Новые авто' : 'БУ авто';
      } else if (correctTransport) {
        transportTitle = correctTransport.title;
      }

      return SearchBar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.root
      }, void 0, SearchBar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.flexRow
      }, void 0, SearchBar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.left, 'breadcrumb')
      }, void 0, backUrl && SearchBar__jsx('li', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.breadcrumbsItem,
        itemScope: true,
        itemType: 'https://schema.org/ListItem',
        itemProp: 'itemListElement'
      }, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Link__["a" /* default */], {
        to: backUrl,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.back, 'meta-title-link'),
        itemProp: 'url'
      }, void 0, SearchBar__ref2, '\xA0', _ref3), SearchBar__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.divider,
        src: __WEBPACK_IMPORTED_MODULE_15_shared_assets_images_angle_gray_svg___default.a,
        width: '14',
        height: '40',
        alt: ''
      })), !backUrl && SearchBar__jsx('li', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.breadcrumbsItem,
        itemScope: true,
        itemType: 'https://schema.org/ListItem',
        itemProp: 'itemListElement'
      }, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Link__["a" /* default */], {
        to: rootPath,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.select, __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.firstLetterUppercase, 'meta-title-link'),
        itemProp: 'url'
      }, void 0, SearchBar__ref4), SearchBar__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.divider,
        src: __WEBPACK_IMPORTED_MODULE_15_shared_assets_images_angle_gray_svg___default.a,
        width: '14',
        height: '40',
        alt: ''
      })), correctTransport && SearchBar__jsx('li', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.breadcrumbsItem,
        itemScope: true,
        itemType: 'https://schema.org/ListItem',
        itemProp: 'itemListElement'
      }, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Link__["a" /* default */], {
        to: firstLevelLink,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.select, __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.firstLetterUppercase, 'meta-title-link'),
        itemProp: 'url'
      }, void 0, SearchBar__jsx('span', {
        itemProp: 'title'
      }, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], {
        id: transportTitle
      }), !isNew && transport.slug !== 'avto' && SearchBar__ref5)), SearchBar__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.divider,
        src: __WEBPACK_IMPORTED_MODULE_15_shared_assets_images_angle_gray_svg___default.a,
        width: '14',
        height: '40',
        alt: ''
      })), make && SearchBar__jsx('li', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.breadcrumbsItem,
        itemScope: true,
        itemType: 'https://schema.org/ListItem',
        itemProp: 'itemListElement'
      }, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Link__["a" /* default */], {
        title: make.title,
        to: makeLink,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.select, 'meta-title-link-next'),
        itemProp: 'url'
      }, void 0, SearchBar__jsx('span', {
        itemProp: 'title'
      }, void 0, make.title)), SearchBar__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.divider,
        src: __WEBPACK_IMPORTED_MODULE_15_shared_assets_images_angle_gray_svg___default.a,
        width: '14',
        height: '40',
        alt: ''
      })), model && model.title && SearchBar__jsx('li', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.breadcrumbsItem,
        itemScope: true,
        itemType: 'https://schema.org/ListItem',
        itemProp: 'itemListElement'
      }, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Link__["a" /* default */], {
        title: model.title,
        to: modelLink,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.select, 'meta-title-link-next'),
        itemProp: 'url'
      }, void 0, SearchBar__jsx('span', {
        itemProp: 'title'
      }, void 0, model.title)), SearchBar__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.divider,
        src: __WEBPACK_IMPORTED_MODULE_15_shared_assets_images_angle_gray_svg___default.a,
        width: '14',
        height: '40',
        alt: ''
      })), year && yearLink && SearchBar__jsx('li', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.breadcrumbsItem,
        itemScope: true,
        itemType: 'https://schema.org/ListItem',
        itemProp: 'itemListElement'
      }, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Link__["a" /* default */], {
        title: year,
        to: yearLink,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.select, 'meta-title-link-next'),
        itemProp: 'url'
      }, void 0, SearchBar__jsx('span', {
        itemProp: 'title'
      }, void 0, year)), SearchBar__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.divider,
        src: __WEBPACK_IMPORTED_MODULE_15_shared_assets_images_angle_gray_svg___default.a,
        width: '14',
        height: '40',
        alt: ''
      })), location && SearchBar__jsx('li', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.select, __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.breadcrumbsItem),
        itemScope: true,
        itemType: 'https://schema.org/ListItem',
        itemProp: 'itemListElement'
      }, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Link__["a" /* default */], {
        title: location.title,
        to: locationLink,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.select, 'meta-title-link-next'),
        itemProp: 'url'
      }, void 0, SearchBar__jsx('span', {
        itemProp: 'title'
      }, void 0, SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], {
        id: location.title
      }))))), SearchBar___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_shared_components_JsonLdApplication_JsonLdApplication__["a" /* default */], breadcrumbsListData), SearchBar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.right
      }, void 0, nextItemLink && SearchBar__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Link__["a" /* default */], {
        to: nextItemLink,
        className: __WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a.next,
        onClick: this.handleNextAdvertClick
      }, void 0, SearchBar__ref6, '\xA0', SearchBar__ref7))));
    }
  }]);

  return SearchBar;
}(SearchBar___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SearchBar.defaultProps = {
  nextItemLink: null,
  nextSearchItemIndex: null,
  locale: '',
  title: ''
};


/* harmony default export */ var SearchBar_defaultExport = (__WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_18__SearchBar_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](function (_ref8) {
  var nextSearchItemIndex = _ref8.history.nextSearchItemIndex,
      searchFormState = _ref8.searchForm.selected;
  return {
    nextSearchItemIndex: nextSearchItemIndex,
    searchFormState: searchFormState
  };
}, function (dispatch) {
  return SearchBar___WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */]({ setNextSearchItemIndex: __WEBPACK_IMPORTED_MODULE_9_shared_actions_history__["c" /* setNextSearchItemIndex */] }, dispatch);
})(SearchBar)));
// CONCATENATED MODULE: ./src/shared/hocs/withTransportInfo/withTransportInfo.js
/* harmony import */ var withTransportInfo___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withTransportInfo___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withTransportInfo___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var withTransportInfo___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var withTransportInfo___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(withTransportInfo___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var withTransportInfo___WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var withTransportInfo___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var withTransportInfo___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(withTransportInfo___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var withTransportInfo___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var withTransportInfo___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(withTransportInfo___WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_users__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_powerUnits_json__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_powerUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_shared_constants_json_powerUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_constants_json_mileageUnits_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_constants_json_mileageUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_shared_constants_json_mileageUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_constants_json_capacityUnits_json__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_constants_json_capacityUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_shared_constants_json_capacityUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_constants_defaultImages__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__withTransportInfo_css__ = __webpack_require__(3282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__withTransportInfo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__withTransportInfo_css__);
var withTransportInfo__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var withTransportInfo__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withTransportInfo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var withTransportInfo__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withTransportInfo__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function withTransportInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withTransportInfo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withTransportInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var UAH_CURRENCY = __WEBPACK_IMPORTED_MODULE_16_shared_constants_json_currency_json___default.a.find(function (item) {
  return item.slug === 'uah';
});
var USD_CURRENCY = __WEBPACK_IMPORTED_MODULE_16_shared_constants_json_currency_json___default.a.find(function (item) {
  return item.slug === 'usd';
});
var EUR_CURRENCY = __WEBPACK_IMPORTED_MODULE_16_shared_constants_json_currency_json___default.a.find(function (item) {
  return item.slug === 'eur';
});
var euroAgencyId = [336, 7261, 9828];

var withTransportInfo__ref2 = withTransportInfo__jsx('div', {}, void 0, '\u0413\u0411\u041E');

var withTransportInfo__ref7 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["l" /* LocationIcon */], {});

var withTransportInfo__ref8 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["b" /* CalendarIcon */], {});

var withTransportInfo__ref9 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["o" /* SpeedIcon */], {});

var _ref10 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["c" /* CarIcon */], {});

var _ref11 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["c" /* CarIcon */], {});

var _ref12 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["e" /* ColorIcon */], {});

var _ref13 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["f" /* EngineIcon */], {});

var _ref14 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["h" /* GearboxIcon */], {});

var _ref15 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["d" /* ChassisIcon */], {});

var _ref16 = withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["s" /* VinIcon */], {});

var withTransportInfo = function withTransportInfo(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    withTransportInfo__inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      withTransportInfo__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withTransportInfo__possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.getCorrectTransport = function (transport) {
        if (!transport) {
          return null;
        } else if (__WEBPACK_IMPORTED_MODULE_18_desktop_constants_navigation__["a" /* default */].SEARCH[transport.slug]) {
          return transport;
        } else if (transport.parents && transport.parents.length > 0 && __WEBPACK_IMPORTED_MODULE_18_desktop_constants_navigation__["a" /* default */].SEARCH[transport.parents[0].slug]) {
          return transport.parents[0];
        }

        return null;
      }, _this.generateEngineTitle = function (engine, capacity, capacityUnit, gasEquipment, power, powerUnit) {
        return withTransportInfo__jsx('span', {}, void 0, [engine && engine.title, capacity && capacityUnit && capacityUnit.title ? capacity + ' ' + _this.props.intl.formatMessage({ id: capacityUnit.title }) : null, power && powerUnit && powerUnit.title ? power + ' ' + (powerUnit && _this.props.intl.formatMessage({ id: powerUnit.title })) : null].filter(function (x) {
          return x;
        }).join(' / '), gasEquipment && withTransportInfo__ref2);
      }, _this.buildInfoLink = function (prefix, obj) {
        if (!prefix || !obj) {
          return null;
        }

        var link = obj && obj.slug ? (prefix + '/' + obj.slug + '/').replace(/\/\//g, '/') : null;

        return link && obj.title && withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_12_shared_components_Link_Link__["a" /* default */], {
          className: withTransportInfo___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_19__withTransportInfo_css___default.a.infoLink, withTransportInfo__defineProperty({}, __WEBPACK_IMPORTED_MODULE_19__withTransportInfo_css___default.a.notLink, !link)),
          to: link || undefined
        }, void 0, _this.props.intl.formatMessage({ id: obj.title }));
      }, _this.buildTransportInfoString = function (link, correctTransport) {
        var _this$props = _this.props,
            intl = _this$props.intl,
            carInfo = _this$props.carInfo;
        var transport = carInfo.transport;


        var isAuto = transport && transport.slug === 'avto';
        var innerText = (correctTransport || transport || {}).title || null;

        return !isAuto && link && correctTransport ? withTransportInfo__jsx(__WEBPACK_IMPORTED_MODULE_12_shared_components_Link_Link__["a" /* default */], {
          className: withTransportInfo___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_19__withTransportInfo_css___default.a.infoLink, withTransportInfo__defineProperty({}, __WEBPACK_IMPORTED_MODULE_19__withTransportInfo_css___default.a.notLink, !link)),
          to: link || undefined
        }, void 0, correctTransport ? intl.formatMessage({ id: transport.title }) : null) : intl.formatMessage({ id: innerText });
      }, _temp), withTransportInfo__possibleConstructorReturn(_this, _ret);
    }

    withTransportInfo__createClass(_class, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            _carInfo = _props.carInfo,
            intl = _props.intl;


        var carInfo = withTransportInfo__extends({}, _carInfo);
        carInfo.author = carInfo.author || {};
        carInfo.make = carInfo.make || {};
        carInfo.model = carInfo.model || {};
        carInfo.modification = carInfo.modification || {};
        carInfo.location = carInfo.location || {};
        carInfo.characteristics = carInfo.characteristics || {};
        var make = carInfo.make,
            model = carInfo.model,
            transport = carInfo.transport,
            prices = carInfo.price,
            modification = carInfo.modification,
            location = carInfo.location,
            year = carInfo.year,
            mileage = carInfo.mileage,
            mileageUnit = carInfo.mileage_unit,
            color = carInfo.color,
            ecotype = carInfo.ecotype,
            power = carInfo.power,
            powerUnitId = carInfo.power_unit,
            capacityUnitId = carInfo.capacity_unit,
            oldAdvertCapacity = carInfo.capacity,
            author = carInfo.author,
            newAdvertCapacity = carInfo.characteristics.capacity,
            isCashless = carInfo.is_cashless,
            isNotCleared = carInfo.is_not_cleared,
            isHot = carInfo.is_hot,
            isNew = carInfo.is_new,
            isRent = carInfo.is_rent,
            isSwap = carInfo.is_swap,
            gasEquipment = carInfo.gas_equipment,
            vin = carInfo.vin,
            equipment = carInfo.equipment,
            capacityBody = carInfo.capacity_body,
            axises = carInfo.axises,
            dimensionWeight = carInfo.dimension_weight,
            admissionHeight = carInfo.admission_height,
            armBoom = carInfo.arm_boom,
            productivity = carInfo.productivity,
            tonnage = carInfo.tonnage,
            dimensionWidth = carInfo.dimension_width,
            dimensionHeight = carInfo.dimension_height,
            dimensionLength = carInfo.dimension_length,
            capacityBucket = carInfo.capacity_bucket,
            liftHeight = carInfo.lift_height,
            layingWidth = carInfo.laying_width,
            depBig = carInfo.dep_big,
            seats = carInfo.seats,
            overallLength = carInfo.overall_length,
            dryWeight = carInfo.dry_weight,
            draft = carInfo.draft,
            displacement = carInfo.displacement,
            fuelTank = carInfo.fuel_tank,
            drivenFrom = carInfo.driven_from,
            abroad = carInfo.abroad,
            waterTank = carInfo.water_tank,
            seaworthinessClass = carInfo.seaworthiness_class,
            _carInfo$category$par = carInfo.category.parents,
            parents = _carInfo$category$par === undefined ? [] : _carInfo$category$par,
            characteristics = carInfo.characteristics,
            body = carInfo.body,
            currency = carInfo.currency,
            usedWarranty = carInfo.used_warranty;


        var engine = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('engine', carInfo);
        var gearbox = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('gearbox', carInfo);
        var drive = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('drive', carInfo);
        var category = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('category', carInfo);
        var brakes = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('brakes', carInfo);
        var suspension = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('suspension', carInfo);
        var unloading = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('unloading', carInfo);
        var cabin = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('cabin', carInfo);
        var chassisSuspension = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('chassis_suspension', carInfo);
        var cabinSuspension = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('cabin_suspension', carInfo);
        var engineOrder = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('engine_order', carInfo);
        var countTacts = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('tacts', carInfo);

        var capacity = newAdvertCapacity && newAdvertCapacity.title ? newAdvertCapacity.title : oldAdvertCapacity;

        var agency = carInfo.agency && carInfo.agency.id ? carInfo.agency : null;
        var secondCurrency = USD_CURRENCY;

        if (agency && euroAgencyId.includes(agency.id) && currency && currency.slug === 'eur') secondCurrency = EUR_CURRENCY;

        var priceList = [UAH_CURRENCY, secondCurrency] // todo duplicate
        .map(function (currencyItem) {
          return [prices.find(function (priceObj) {
            return priceObj.currency === currencyItem.slug;
          }), currencyItem];
        }).filter(function (_ref3) {
          var _ref4 = withTransportInfo__slicedToArray(_ref3, 1),
              priceObj = _ref4[0];

          return priceObj;
        }).map(function (_ref5) {
          var _ref6 = withTransportInfo__slicedToArray(_ref5, 2),
              value = _ref6[0].value,
              currencyItem = _ref6[1];

          return {
            value: __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["k" /* numberWithSpaces */](value),
            currency: __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](currencyItem)
          };
        });

        var title = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_arrays__["a" /* cleanArray */]([__WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](make) || carInfo.make_title, __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](model) || carInfo.model_title, __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](modification), __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](equipment), year]).join(' ');
        var locTitle = __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](location);
        var translateLocTitle = locTitle ? intl.formatMessage({ id: locTitle }) : '';

        var seoTitle = intl.formatMessage({ id: 'Купить' }) + ' ' + title + ' ' + (translateLocTitle ? '\u0432 ' + __WEBPACK_IMPORTED_MODULE_10_shared_modules__["e" /* cityLocale */](location.title, intl.locale, 'genitive') : '');

        var alt = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_arrays__["a" /* cleanArray */]([__WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](make) || carInfo.make_title, __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](model) || carInfo.model_title, year, __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](color)]).join(' ');

        var mileageUnitTitle = (__WEBPACK_IMPORTED_MODULE_14_shared_constants_json_mileageUnits_json___default.a.find(function (unit) {
          return unit.id === mileageUnit;
        }) || {}).title;
        var powerUnit = __WEBPACK_IMPORTED_MODULE_13_shared_constants_json_powerUnits_json___default.a.find(function (item) {
          return item.id === powerUnitId;
        }) || {};
        var capacityUnit = __WEBPACK_IMPORTED_MODULE_15_shared_constants_json_capacityUnits_json___default.a.find(function (item) {
          return item.id === capacityUnitId;
        }) || {};
        var mileageStatus = mileage > 0 ? mileage + ' ' + intl.formatMessage({ id: mileageUnitTitle }) : null;

        if (isNew) {
          mileageStatus = intl.formatMessage({ id: 'новый' });
        }

        var customStatus = isNotCleared ? intl.formatMessage({ id: 'нерастаможен' }) : intl.formatMessage({ id: 'растаможен' });

        var correctTransport = this.getCorrectTransport(transport);
        var q = '/' + __WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__["e" /* generateSearchUrl */]({ isNew: isNew, transport: correctTransport, make: make, model: model });

        var isAuto = transport && transport.slug === 'avto';
        var isUsedAuto = isAuto && !isNew;
        var isNewAuto = isAuto && isNew;

        var gearboxLink = isUsedAuto ? this.buildInfoLink(q, gearbox) : gearbox && gearbox.title;
        var engineLink = isUsedAuto ? this.buildInfoLink(q, engine, !isUsedAuto) : engine && engine.title;

        var categoryLink = !isNewAuto ? this.buildInfoLink(q, category) : category && category.title;

        var carSeriesLink = isAuto && this.buildInfoLink(q, characteristics.category);
        var carBodyLink = isAuto && this.buildInfoLink(q, body);

        var transportLink = this.buildTransportInfoString(q, correctTransport);

        var tempInfoList = [{
          key: 'location',
          title: intl.formatMessage({ id: 'Город' }),
          value: location && location.title || null,
          Icon: withTransportInfo__ref7
        }, {
          key: 'year',
          title: intl.formatMessage({ id: 'Год выпуска' }),
          value: year || null,
          decorationClassName: 'b',
          Icon: withTransportInfo__ref8
        }, {
          key: 'mileage',
          title: intl.formatMessage({ id: 'Пробег' }),
          value: mileageStatus || null,
          decorationClassName: 'b',
          Icon: withTransportInfo__ref9
        }, {
          key: 'modification',
          title: intl.formatMessage({ id: 'Модификация' }),
          value: __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](modification),
          Icon: _ref10
        }, {
          key: 'equipment',
          title: intl.formatMessage({ id: 'Комплектация' }),
          value: __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](equipment)
        }, {
          key: 'body',
          title: intl.formatMessage({ id: 'Кузов' }),
          value: carSeriesLink || carBodyLink || ((transport && transport.title) !== (category && category.title) ? categoryLink : null),
          Icon: _ref11
        },
        // {
        //   title: intl.formatMessage({ id: 'Тип транспорта' }),
        //   value:
        //     (transport && transport.title) === (category && category.title)
        //       ? transportLink
        //       : (transport && intl.formatMessage({ id: transport.title })) || null,
        // },
        {
          key: 'parents',
          title: intl.formatMessage({ id: 'Тип' }),
          value: parents && parents.length === 2 && intl.formatMessage({ id: parents[1].title }) || null
        }, {
          key: 'color',
          title: intl.formatMessage({ id: 'Цвет' }),
          value: color && color.title ? intl.formatMessage({ id: color.title }) : null,
          Icon: _ref12
        }, {
          key: 'engine',
          title: intl.formatMessage({ id: 'двигатель' }),
          value: engine && engine.title && (engineLink ? withTransportInfo__jsx('span', {}, void 0, engineLink, ' / ', this.generateEngineTitle(null, capacity, capacityUnit, gasEquipment, power, powerUnit)) : this.generateEngineTitle(engine, capacity, capacityUnit, gasEquipment, power, powerUnit)),
          Icon: _ref13
        }, {
          key: 'power',
          title: intl.formatMessage({ id: 'Мощность' }),
          value: power ? power + ' ' + (powerUnit && intl.formatMessage({ id: powerUnit.title })) : null
        }, {
          key: 'gearbox',
          title: intl.formatMessage({ id: 'Коробка' }),
          value: gearboxLink || null,
          Icon: _ref14
        }, {
          key: 'drive',
          title: intl.formatMessage({ id: 'Привод' }),
          value: drive && drive.title ? intl.formatMessage({ id: drive.title }) : null,
          Icon: _ref15
        }, {
          key: 'vin',
          title: 'VIN',
          value: vin,
          Icon: _ref16
        }, {
          key: 'customStatus',
          title: intl.formatMessage({ id: 'Таможня' }),
          value: customStatus || null
        }, {
          key: 'ecotype',
          title: intl.formatMessage({ id: 'Эконормы' }),
          value: __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["h" /* getTitleOrEmpty */](ecotype)
        }, {
          key: 'isSwap',
          title: intl.formatMessage({ id: 'Обмен' }),
          value: isSwap ? intl.formatMessage({ id: 'Возможен' }) : null,
          decorationClassName: 'a'
        }, {
          key: 'isHot',
          title: intl.formatMessage({ id: 'Срочность' }),
          value: isHot ? intl.formatMessage({ id: 'Горячее' }) : null,
          decorationClassName: 'a'
        }, {
          key: 'isRent',
          title: intl.formatMessage({ id: 'Предложение' }),
          value: isRent ? intl.formatMessage({ id: 'Аренда' }) : null
        }, {
          key: 'isCashless',
          title: intl.formatMessage({ id: 'Безналичная оплата' }),
          value: isCashless ? intl.formatMessage({ id: 'Возможна' }) : null
        }, {
          key: 'capacity_body',
          title: intl.formatMessage({ id: 'Объем кузова' }),
          value: capacityBody ? capacityBody + ' \u043C3' : null
        }, {
          key: 'axises',
          title: intl.formatMessage({ id: 'Кол-во осей' }),
          value: axises ? axises + ' \u0448\u0442.' : null
        }, {
          key: 'dimension_weight',
          title: intl.formatMessage({ id: 'Масса' }),
          value: dimensionWeight ? dimensionWeight + ' \u0442.' : null
        }, {
          key: 'admission_height',
          title: intl.formatMessage({ id: 'Высота подачи' }),
          value: admissionHeight ? admissionHeight + ' \u043C' : null
        }, {
          key: 'arm_boom',
          title: intl.formatMessage({ id: 'Вылет стрелы' }),
          value: armBoom ? armBoom + ' \u043C' : null
        }, {
          key: 'productivity',
          title: intl.formatMessage({ id: 'Наработка' }),
          value: productivity ? productivity + ' \u043C\\\u0447' : null
        }, {
          key: 'tonnage',
          title: intl.formatMessage({ id: 'Грузоподъемность' }),
          value: tonnage ? tonnage + ' \u0442.' : null
        }, {
          key: 'dimension_width',
          title: intl.formatMessage({ id: 'Ширина' }),
          value: dimensionWidth ? dimensionWidth + ' \u043C' : null
        }, {
          key: 'dimension_height',
          title: intl.formatMessage({ id: 'Высота' }),
          value: dimensionHeight ? dimensionHeight + ' \u043C' : null
        }, {
          key: 'dimension_length',
          title: intl.formatMessage({ id: 'Длина' }),
          value: dimensionLength ? dimensionLength + ' \u043C' : null
        }, {
          key: 'capacity_bucket',
          title: intl.formatMessage({ id: 'Объем ковша' }),
          value: capacityBucket ? capacityBucket + ' \u043C3' : null
        }, {
          key: 'lift_height',
          title: intl.formatMessage({ id: 'Высота подъема' }),
          value: liftHeight ? liftHeight + ' \u043C' : null
        }, {
          key: 'laying_width',
          title: intl.formatMessage({ id: 'Ширина укладки' }),
          value: layingWidth ? layingWidth + ' \u043C' : null
        }, {
          key: 'dep_big',
          title: intl.formatMessage({ id: 'Глубина копания' }),
          value: depBig ? depBig + ' \u043C' : null
        }, {
          key: 'brakes',
          title: intl.formatMessage({ id: 'Тип тормозов' }),
          value: brakes && brakes.title ? brakes.title : null
        }, {
          key: 'suspension',
          title: intl.formatMessage({ id: 'Тип подвески' }),
          value: suspension && suspension.title ? suspension.title : null
        }, {
          key: 'unloading',
          title: intl.formatMessage({ id: 'Выгрузка' }),
          value: unloading && unloading.title ? unloading.title : null
        }, {
          key: 'cabin',
          title: intl.formatMessage({ id: 'Кабина' }),
          value: cabin && cabin.title ? cabin.title : null
        }, {
          key: 'chassis_suspension',
          title: intl.formatMessage({ id: 'Подвеска шасси' }),
          value: chassisSuspension && chassisSuspension.title ? chassisSuspension.title : null
        }, {
          key: 'cabin_suspension',
          title: intl.formatMessage({ id: 'Подвеска кабины' }),
          value: cabinSuspension && cabinSuspension.title ? cabinSuspension.title : null
        }, {
          key: 'seats',
          title: intl.formatMessage({ id: 'Количество мест' }),
          value: seats || null
        }, {
          key: 'engine_order',
          title: intl.formatMessage({ id: 'Расположение цилиндров' }),
          value: engineOrder && engineOrder.title ? engineOrder.title : null
        }, {
          key: 'count_tacts',
          title: intl.formatMessage({ id: 'Число тактов' }),
          value: countTacts && countTacts.title ? countTacts.title : null
        }, {
          key: 'overall_length',
          title: intl.formatMessage({ id: 'Габаритная длина'.toLowerCase() }),
          value: overallLength ? overallLength + ' \u043C' : null
        }, {
          key: 'dry_weight',
          title: intl.formatMessage({ id: 'Сухой вес'.toLowerCase() }),
          value: dryWeight ? dryWeight + ' \u0442' : null
        }, {
          key: 'draft',
          title: intl.formatMessage({ id: 'Осадка'.toLowerCase() }),
          value: draft ? draft + ' \u043C' : null
        }, {
          key: 'displacement',
          title: intl.formatMessage({ id: 'Водоизмещение'.toLowerCase() }),
          value: displacement ? displacement + ' \u0442' : null
        }, {
          key: 'fuel_tank',
          title: intl.formatMessage({ id: 'Топливный бак'.toLowerCase() }),
          value: fuelTank ? fuelTank + ' \u043B' : null
        }, {
          key: 'water_tank',
          title: intl.formatMessage({ id: 'Бак для воды'.toLowerCase() }),
          value: waterTank ? waterTank + ' \u043B' : null
        }, {
          key: 'seaworthiness_class',
          title: intl.formatMessage({ id: 'СЕ категория (класс мореходности)'.toLowerCase() }),
          value: seaworthinessClass ? seaworthinessClass.toUpperCase() : null
        }, {
          key: 'driven_from',
          title: intl.formatMessage({ id: 'Пригнан' }),
          value: drivenFrom && drivenFrom.id ? __WEBPACK_IMPORTED_MODULE_6_shared_helpers_transportInfo__["i" /* getCountryById */](drivenFrom.id).from[intl.locale] : null
        }, {
          key: 'abroad',
          title: intl.formatMessage({ id: 'Cостояние' }),
          value: abroad ? intl.formatMessage({ id: 'авто не в Украине' }) : null
        }].filter(function (item) {
          return item.value;
        });

        var carInfoFilter = this.props.carInfoFilter;

        var infoList = Array.isArray(carInfoFilter) && carInfoFilter.length ? tempInfoList.filter(function (item) {
          return item.key && carInfoFilter.includes(item.key);
        }) : tempInfoList;

        // Seller info
        var authorName = agency && agency.title ? agency.title : __WEBPACK_IMPORTED_MODULE_9_shared_helpers_users__["c" /* getUserName */](author);
        var sellerLocation = location && location.title || agency && agency.address;

        var sellerLink = agency && agency.slug ? __WEBPACK_IMPORTED_MODULE_8_shared_helpers_urls__["h" /* getDealerLink */](agency) : null;

        var sellerExtraText = agency && agency.adverts_count ? agency.adverts_count + ' ' + intl.formatMessage({ id: 'объявлений' }) + ' ' : null;

        var warranty = usedWarranty && agency && agency.warranty_active && agency.warranty;

        var defaultImage = __WEBPACK_IMPORTED_MODULE_17_shared_constants_defaultImages__["b" /* getDefaultImageByType */](transport);
        var transformedData = {
          title: title,
          seoTitle: seoTitle,
          alt: alt,
          agency: agency,
          defaultImage: defaultImage,
          priceList: priceList,
          infoList: infoList,
          authorName: authorName,
          sellerExtraText: sellerExtraText,
          sellerLink: sellerLink,
          sellerLocation: sellerLocation,
          warranty: warranty
        };
        return withTransportInfo__jsx('div', {}, void 0, withTransportInfo___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, withTransportInfo__extends({}, this.props, { transformedData: transformedData })));
      }
    }]);

    return _class;
  }(withTransportInfo___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withTransportInfo(' + __WEBPACK_IMPORTED_MODULE_5_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    style: null,
    count: null,
    spares: [],
    carInfoFilter: []
  }, _temp2;
};

/* harmony default export */ var withTransportInfo_defaultExport = (function (component) {
  return withTransportInfo___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_19__withTransportInfo_css___default.a)(withTransportInfo___WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](withTransportInfo(component)));
});
// CONCATENATED MODULE: ./src/desktop/components/AdvertLeasingTitle/AdvertLeasingTitle.js
/* harmony import */ var AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Discount_Discount__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_moment__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_AntdComponents_Grid_Row_Row__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_AntdComponents_Grid_Col_Col__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_desktop_components_Favourite_Favourite__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_components_PriceUsdEuro_PriceUsdEuro__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_components_PriceUah_PriceUah__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_leasing__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css__ = __webpack_require__(3284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css__);
var AdvertLeasingTitle__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var AdvertLeasingTitle__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AdvertLeasingTitle__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function AdvertLeasingTitle__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AdvertLeasingTitle__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AdvertLeasingTitle__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import cx from 'classnames';











// import LeasingButton from 'shared/components/LeasingOnlineBanner/LeasingButton/LeasingButton';
// import LeasingWithCalculatorButton from 'shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton';
// import MicroCreditButton from 'shared/components/LeasingOnlineBanner/MicroCreditButton/MicroCreditButton';


// import {
//   isLeasingProposalAvailable,
//   isMicroCreditProposalAvailable,
// } from 'shared/helpers/leasing/myAuto';




// eslint-disable-next-line css-modules/no-unused-class


var AdvertLeasingTitle__ref2 = AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0423\u0442\u043E\u0447\u043D\u0438\u0442\u044C \u0446\u0435\u043D\u0443 \u0443 \u0434\u0438\u043B\u0435\u0440\u0430'
});

var AdvertLeasingTitle__ref5 = AdvertLeasingTitle__jsx('i', {
  className: 'fa fa-eye'
});

var AdvertLeasingTitle = function (_React$Component) {
  AdvertLeasingTitle__inherits(AdvertLeasingTitle, _React$Component);

  function AdvertLeasingTitle() {
    var _ref;

    var _temp, _this, _ret;

    AdvertLeasingTitle__classCallCheck(this, AdvertLeasingTitle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = AdvertLeasingTitle__possibleConstructorReturn(this, (_ref = AdvertLeasingTitle.__proto__ || Object.getPrototypeOf(AdvertLeasingTitle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showLeasingOnlineModal: false
    }, _this.toggleLeasingModal = function () {
      _this.setState({ showLeasingOnlineModal: !_this.state.showLeasingOnlineModal });
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].leasing.online.LinkUnderThePrice);
    }, _temp), AdvertLeasingTitle__possibleConstructorReturn(_this, _ret);
  }

  AdvertLeasingTitle__createClass(AdvertLeasingTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          views = _props.views,
          title = _props.title,
          seoTitle = _props.seoTitle,
          dateCreated = _props.dateCreated,
          prices = _props.prices,
          intl = _props.intl,
          isSpare = _props.isSpare,
          clarifyPriceLink = _props.clarifyPriceLink,
          isNegotiablePrice = _props.isNegotiablePrice,
          advert = _props.advert,
          leasingParams = _props.leasingParams;

      // const { active, discount: mainDiscount, agency, sold = false } = advert;

      var mainDiscount = advert.discount,
          agency = advert.agency,
          carId = advert.carId;
      var locale = intl.locale;

      var date = dateCreated && __WEBPACK_IMPORTED_MODULE_6_shared_helpers_moment__["a" /* createdDate */](dateCreated, locale);
      var isContractPrice = !(prices.length > 0 && prices.some(function (p) {
        return p.value && p.value !== '0';
      }));
      // const hideCreditForm = active === -2 || !active || sold || isSpare;

      var discount = agency && agency.id && (mainDiscount || agency.discount);
      var isLeasing = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_leasing__["a" /* isAnyLeasingAvailable */](advert);
      var priceTheme = isLeasing ? 'small' : 'yellow';
      var titleH1 = seoTitle + ' (' + id + ')';
      return AdvertLeasingTitle__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.root
      }, void 0, AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_AntdComponents_Grid_Row_Row__["a" /* default */], {}, void 0, AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_AntdComponents_Grid_Col_Col__["a" /* default */], {
        span: 16
      }, void 0, AdvertLeasingTitle__jsx('h1', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.h1
      }, void 0, titleH1), AdvertLeasingTitle__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.title
      }, void 0, title)), AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_AntdComponents_Grid_Col_Col__["a" /* default */], {
        span: 8
      }, void 0, AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_AntdComponents_Grid_Row_Row__["a" /* default */], {
        type: 'flex',
        justify: 'end'
      }, void 0, AdvertLeasingTitle__jsx(AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, !isSpare && isLeasing && !isNegotiablePrice && AdvertLeasingTitle__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.LeasingButton
      }, void 0, AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_15_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__["a" /* default */], {
        advert: advert,
        eventPostfix: 'advertcard'
      })), !isSpare && isNegotiablePrice && AdvertLeasingTitle__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.contractPrice
      }, void 0, intl.formatMessage({ id: 'договорная' })), !isSpare && !isNegotiablePrice && AdvertLeasingTitle__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.price
      }, void 0, clarifyPriceLink ? AdvertLeasingTitle__jsx('a', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.clarifyPrice,
        href: clarifyPriceLink,
        target: '_blank',
        rel: 'noopener noreferrer'
      }, void 0, AdvertLeasingTitle__ref2) : prices.length > 0 && AdvertLeasingTitle__jsx(AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_14_shared_components_PriceUah_PriceUah__["a" /* default */], {
        uah: __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'uah'),
        theme: priceTheme
      }), AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_13_shared_components_PriceUsdEuro_PriceUsdEuro__["a" /* default */], {
        usd: __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'usd'),
        eur: __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'eur')
      }), discount && AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Discount_Discount__["a" /* default */], {
        discount: discount
      }))
      // <div className={s.priceList}>
      //   {prices.map(({ currency, value }) =>
      //     <div className={s.priceItem} key={value + currency}>
      //       {value}&nbsp;
      //       <small>{currency}</small>
      //     </div>,
      //   )}
      //   {discount && <Discount discount={discount} />}
      // </div>
      ), isSpare && AdvertLeasingTitle__jsx('div', {
        className: (__WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.price, AdvertLeasingTitle__defineProperty({}, __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.contractPrice, isContractPrice))
      }, void 0, prices.length > 0 && prices.some(function (p) {
        return p.value && p.value !== '0';
      }) ? AdvertLeasingTitle__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.priceList
      }, void 0, prices.map(function (_ref4) {
        var currency = _ref4.currency,
            value = _ref4.value;
        return AdvertLeasingTitle__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.priceItem
        }, value + currency, value, '\xA0', AdvertLeasingTitle__jsx('small', {}, void 0, currency));
      })) : intl.formatMessage({ id: 'договорная' })))))), AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_AntdComponents_Grid_Row_Row__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.yearSection
      }, void 0, AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_AntdComponents_Grid_Col_Col__["a" /* default */], {
        span: 16
      }, void 0, AdvertLeasingTitle__jsx('div', {}, void 0, AdvertLeasingTitle__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.id
      }, void 0, '\u2116 ', id), AdvertLeasingTitle__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.date
      }, void 0, date), AdvertLeasingTitle__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.views
      }, void 0, AdvertLeasingTitle__ref5, views || 0))), AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_AntdComponents_Grid_Col_Col__["a" /* default */], {
        span: 8,
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.blockRightFlex
      }, void 0, AdvertLeasingTitle__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a.favoriteContainer
      }, void 0, AdvertLeasingTitle__jsx(__WEBPACK_IMPORTED_MODULE_12_desktop_components_Favourite_Favourite__["a" /* default */], {
        id: id,
        imgWidth: 18,
        isCompact: true
      })))));
    }
  }]);

  return AdvertLeasingTitle;
}(AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AdvertLeasingTitle.defaultProps = {
  views: 0,
  advert: {},
  price: 0,
  dateCreated: '',
  isSpare: false,
  clarifyPriceLink: null,
  isNegotiablePrice: false,
  leasingParams: {}
};


var AdvertLeasingTitle_mapDispatchToProps = { setDataLayer: __WEBPACK_IMPORTED_MODULE_9_shared_actions_globals__["j" /* setDataLayer */] };

/* harmony default export */ var AdvertLeasingTitle_defaultExport = (AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_18__AdvertLeasingTitle_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_17_shared_hocs_withTranslate__["a" /* withTranslate */](AdvertLeasingTitle___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](null, AdvertLeasingTitle_mapDispatchToProps)(AdvertLeasingTitle)))));
// CONCATENATED MODULE: ./src/shared/components/VideosItem/VideosItem.js
/* harmony import */ var VideosItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VideosItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VideosItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var VideosItem___WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var VideosItem___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var VideosItem___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(VideosItem___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var VideosItem___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var VideosItem___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(VideosItem___WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_newspaper_svg__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_newspaper_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_newspaper_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VideosItem_css__ = __webpack_require__(3286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VideosItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__VideosItem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hocs_withPixelRatio__ = __webpack_require__(1391);
var VideosItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function VideosItem__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var TYPES = {
  TABLE: 'table',
  LIST: 'list'
};

var itemPropType = {
  handleShowVideo: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  title: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  image: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    url: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    caption: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  imgHeight: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  imgWidth: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  type: VideosItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

function VideosItem(props) {
  var _cx;

  var index = props.index,
      title = props.title,
      titleUk = props.title_uk,
      slug = props.slug,
      image = props.image,
      imgHeight = props.imgHeight,
      type = props.type,
      setRatioImage = props.setRatioImage,
      imgWidth = props.imgWidth,
      handleShowVideo = props.handleShowVideo,
      intl = props.intl;
  //

  var isList = type === TYPES.LIST;
  var hasImage = !!image.url;
  var imageSrc = image && setRatioImage(image.url, 240, 200, 'contain');
  var isMobile = "desktop" === 'mobile';
  var locale = intl.locale;

  var localizedTitle = locale === 'ru' ? title || titleUk : titleUk || title;

  return VideosItem__jsx('div', {
    className: VideosItem___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__VideosItem_css___default.a.root, [isMobile && __WEBPACK_IMPORTED_MODULE_7__VideosItem_css___default.a.mobileRoot]),
    onClick: function onClick() {
      return handleShowVideo({ id: slug, index: index });
    }
  }, void 0, VideosItem__jsx('div', {
    className: VideosItem___WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cx = {}, VideosItem__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_7__VideosItem_css___default.a.listThumb, isList), VideosItem__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_7__VideosItem_css___default.a.tableThumb, !isList), VideosItem__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_7__VideosItem_css___default.a.placeholderThumb, !hasImage), _cx)),
    style: imgHeight ? VideosItem__defineProperty({
      backgroundImage: 'url(' + __WEBPACK_IMPORTED_MODULE_5_shared_modules__["u" /* urlReplace */](imageSrc || __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_newspaper_svg___default.a) + ')',
      height: imgHeight
    }, imgWidth && 'width', imgWidth && imgWidth) : {}
  }, void 0, VideosItem__jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_7__VideosItem_css___default.a.tableDate
  }, void 0, localizedTitle)));
}

VideosItem.defaultProps = {
  imgHeight: 200,
  imgWidth: null,
  type: TYPES.TABLE
};


/* harmony default export */ var VideosItem_defaultExport = (VideosItem___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__VideosItem_css___default.a)(VideosItem___WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_8__hocs_withPixelRatio__["a" /* default */](VideosItem))));
// CONCATENATED MODULE: ./src/desktop/components/NewsBlock/VideoBlock.js
/* harmony import */ var VideoBlock___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VideoBlock___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VideoBlock___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var VideoBlock___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var VideoBlock___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(VideoBlock___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var VideoBlock___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var VideoBlock___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(VideoBlock___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_chunk__ = __webpack_require__(2462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NewsBlock_css__ = __webpack_require__(2463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NewsBlock_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NewsBlock_css__);
var VideoBlock__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var VideoBlock__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var VideoBlock__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function VideoBlock__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VideoBlock__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function VideoBlock__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var DEFAULT_CONTAINER_WIDTH = 820;
var MAX_MOBILE_WIDTH = 560;

var VideoBlock_VideoBlock = function (_React$Component) {
  VideoBlock__inherits(VideoBlock, _React$Component);

  function VideoBlock() {
    var _ref;

    var _temp, _this, _ret;

    VideoBlock__classCallCheck(this, VideoBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = VideoBlock__possibleConstructorReturn(this, (_ref = VideoBlock.__proto__ || Object.getPrototypeOf(VideoBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      containerWidth: DEFAULT_CONTAINER_WIDTH,
      maxMobileWidth: _this.props.maxMobileWidth
    }, _this.setContainerWidth = function (containerWidth) {
      _this.setState({ containerWidth: containerWidth });
    }, _temp), VideoBlock__possibleConstructorReturn(_this, _ret);
  }

  VideoBlock__createClass(VideoBlock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var containerWidth = this.root && this.root.parentNode && this.root.parentNode.offsetWidth;

      if (containerWidth) {
        this.setContainerWidth(containerWidth);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          news = _props.news,
          defaultColumns = _props.columns,
          children = _props.children,
          handleShowVideo = _props.handleShowVideo;
      var _state = this.state,
          containerWidth = _state.containerWidth,
          maxMobileWidth = _state.maxMobileWidth;


      var columns = containerWidth < maxMobileWidth ? 1 : defaultColumns;

      var rows = __WEBPACK_IMPORTED_MODULE_3_lodash_chunk___default.a(news, columns);

      return VideoBlock___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: VideoBlock___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NewsBlock_css___default.a.root, __WEBPACK_IMPORTED_MODULE_7__NewsBlock_css___default.a.videoBLock),
          ref: function ref(el) {
            _this2.root = el;
          }
        },
        title && VideoBlock__jsx('h3', {
          className: __WEBPACK_IMPORTED_MODULE_7__NewsBlock_css___default.a.videoTitle
        }, void 0, title),
        VideoBlock__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_7__NewsBlock_css___default.a.newsContainer
        }, void 0, rows.map(function (newsItems) {
          return VideoBlock__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_7__NewsBlock_css___default.a.row
          }, newsItems[0].id, newsItems.map(function (item, index) {
            return VideoBlock___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideosItem_defaultExport, VideoBlock__extends({
              handleShowVideo: handleShowVideo,
              type: TYPES.LIST,
              key: item.id,
              imgHeight: 130,
              imgWidth: 200,
              index: index
            }, item));
          }));
        })),
        children
      );
    }
  }]);

  return VideoBlock;
}(VideoBlock___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

VideoBlock_VideoBlock.defaultProps = {
  title: null,
  maxMobileWidth: MAX_MOBILE_WIDTH,
  columns: 3,
  children: null
};


/* harmony default export */ var VideoBlock_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__NewsBlock_css___default.a)(__WEBPACK_IMPORTED_MODULE_6_shared_hocs_withPixelRatio__["a" /* default */](VideoBlock_VideoBlock)));
// CONCATENATED MODULE: ./src/desktop/components/AdvertOptions/AdvertOptions.js
/* harmony import */ var AdvertOptions___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertOptions___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertOptions___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertOptions___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertOptions___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(AdvertOptions___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy__ = __webpack_require__(3288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_groupBy__);
/* harmony import */ var AdvertOptions___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertOptions___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertOptions___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var AdvertOptions___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css__ = __webpack_require__(3289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css__);
var AdvertOptions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var AdvertOptions__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var AdvertOptions__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







// import { stripHTML } from 'shared/helpers/strings';
// // import LeasingAndVin from 'shared/components/LeasingAndVin';
// import statusColors from 'shared/constants/json/statusColors.json';
// import CheckedVinBlock from 'shared/components/CheckedVinBlock/CheckedVinBlock';
// import AdvertStatusList from 'shared/components/AdvertStatusList/AdvertStatusList';



function AdvertOptions(props) {
  var options = props.options,
      title = props.title,
      intl = props.intl;


  var transformedOptions = options.map(function (option) {
    var parents = option.parents;

    if (parents.length === 2) {
      var optionTitle = option.title,
          _option$parents = AdvertOptions__slicedToArray(option.parents, 2),
          mainParent = _option$parents[0],
          optionParent = _option$parents[1],
          rest = _objectWithoutProperties(option, ['title', 'parents']);

      return AdvertOptions__extends({}, rest, {
        title: optionTitle + ' ' + (optionParent && optionParent.title ? optionParent.title.toLowerCase() : ''),
        parents: [mainParent]
      });
    }

    return option;
  });

  var groupedOption = Object.entries(__WEBPACK_IMPORTED_MODULE_2_lodash_groupBy___default.a(transformedOptions, 'parents[0].title')).sort(function (a, b) {
    return a[1].length < b[1].length ? 1 : -1;
  });
  var groupCount = groupedOption.length;
  var titleH2 = intl.formatMessage({ id: 'Комплектация' }) + ' ' + intl.formatMessage({ id: 'авто' }) + ' ' + title;
  return AdvertOptions__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.root
  }, void 0, groupCount > 0 && AdvertOptions__jsx('div', {}, void 0, AdvertOptions__jsx('h2', {
    className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.title
  }, void 0, titleH2), AdvertOptions__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.list
  }, void 0, groupCount > 1 && AdvertOptions__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.col
  }, void 0, AdvertOptions__jsx(PackageColumn, {
    column: groupedOption.slice(0, Math.floor(groupCount / 2))
  })), AdvertOptions__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.col
  }, void 0, AdvertOptions__jsx(PackageColumn, {
    column: groupedOption.slice(Math.floor(groupCount / 2))
  })))));
}

AdvertOptions.defaultProps = {
  options: []
};


function PackageColumn(_ref) {
  var column = _ref.column;

  return AdvertOptions__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.group
  }, void 0, column.filter(function (_ref2) {
    var _ref3 = AdvertOptions__slicedToArray(_ref2, 2),
        group = _ref3[0],
        options = _ref3[1];

    return group && options;
  }).map(function (_ref4) {
    var _ref5 = AdvertOptions__slicedToArray(_ref4, 2),
        group = _ref5[0],
        options = _ref5[1];

    return AdvertOptions__jsx('li', {
      className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.optionGroup
    }, group, AdvertOptions__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.optionGroupTitle
    }, void 0, AdvertOptions__jsx(AdvertOptions___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: group
    })), AdvertOptions__jsx('ul', {
      className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.optionList
    }, void 0, options.map(function (_ref6) {
      var title = _ref6.title,
          id = _ref6.id;
      return AdvertOptions__jsx('li', {
        className: __WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a.option
      }, id, AdvertOptions__jsx(AdvertOptions___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
        id: title
      }));
    })));
  }));
}


/* harmony default export */ var AdvertOptions_defaultExport = (AdvertOptions___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__AdvertOptions_css___default.a)(AdvertOptions___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](AdvertOptions)));
// CONCATENATED MODULE: ./src/shared/components/AdvertMessage/AdvertMessage.js
/* harmony import */ var AdvertMessage___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertMessage___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertMessage___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertMessage___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertMessage___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(AdvertMessage___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var AdvertMessage___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertMessage___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertMessage___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var AdvertMessage___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_DialogForm_DialogForm__ = __webpack_require__(2711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdvertMessage_css__ = __webpack_require__(3291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AdvertMessage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AdvertMessage_css__);
var AdvertMessage__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



// import groupBy from 'lodash/groupBy';






var AdvertMessage_isMobile = "desktop" === 'mobile';

var AdvertMessage__ref = AdvertMessage__jsx(AdvertMessage___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u0432\u0438\u0434\u0443 \u043D\u0430\u043B\u0438\u0447\u0438\u044F \u043D\u0430 \u0440\u044B\u043D\u043A\u0435 \u043C\u043E\u0448\u0435\u043D\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0441\u0445\u0435\u043C \u043D\u0438 \u0432 \u043A\u043E\u0435\u043C \u0441\u043B\u0443\u0447\u0430\u0435 \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u0442\u0435 \u043F\u043E\u043B\u043D\u0443\u044E \u0438\u043B\u0438 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u0443\u044E \u043E\u043F\u043B\u0430\u0442\u0443 \u0431\u0435\u0437 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0430'
});

function AdvertMessage(props) {
  var intl = props.intl,
      carInfo = props.carInfo,
      user = props.user,
      handleSendMessage = props.handleSendMessage;

  var userId = user && user.user && user.user.id;
  var isMyAdvert = false; // +carInfo.author.id === +userId;
  var rootClass = AdvertMessage_isMobile ? __WEBPACK_IMPORTED_MODULE_5__AdvertMessage_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_5__AdvertMessage_css___default.a.root;
  return AdvertMessage__jsx('div', {
    className: rootClass
  }, void 0, !isMyAdvert && AdvertMessage__jsx('div', {}, void 0, AdvertMessage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__AdvertMessage_css___default.a.messageTitle
  }, void 0, intl.formatMessage({ id: 'Оставить сообщение владельцу' })), AdvertMessage__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_DialogForm_DialogForm__["a" /* default */], {
    onSubmit: function onSubmit(textareaMsg) {
      return handleSendMessage(textareaMsg, carInfo.id);
    },
    customStyle: __WEBPACK_IMPORTED_MODULE_5__AdvertMessage_css___default.a.dialogForm
  }, void 0, !(carInfo.agency.is_official || carInfo.author.id === userId) && AdvertMessage__jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_5__AdvertMessage_css___default.a.warningBlock
  }, void 0, AdvertMessage__ref))));
}

/* harmony default export */ var AdvertMessage_defaultExport = (AdvertMessage___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__AdvertMessage_css___default.a)(AdvertMessage___WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](AdvertMessage)));
// CONCATENATED MODULE: ./src/desktop/components/AdvertInfo/AdvertInfo.js
/* harmony import */ var AdvertInfo___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertInfo___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertInfo___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertInfo___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertInfo___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(AdvertInfo___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var AdvertInfo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertInfo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertInfo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_SocialLinks_SocialLinks__ = __webpack_require__(2763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css__ = __webpack_require__(3293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css__);
var AdvertInfo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







// export { default as LocationIcon } from './LocationIcon';

function AdvertInfo(props) {
  var infoList = props.infoList,
      advert = props.advert;


  return infoList.length > 0 && AdvertInfo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css___default.a.root
  }, void 0, infoList.map(function (item) {
    return AdvertInfo__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css___default.a.row
    }, item.title + '-' + item.value, AdvertInfo__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css___default.a.icon
    }, void 0, item.Icon || null), AdvertInfo__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css___default.a.info
    }, void 0, AdvertInfo__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css___default.a.title
    }, void 0, item.title), AdvertInfo__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css___default.a.value
    }, void 0, item.value)));
  }), advert.posted_in_social && AdvertInfo__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_SocialLinks_SocialLinks__["a" /* default */], {
    advert: advert
  }));
}

AdvertInfo.defaultProps = {
  infoList: [],
  advert: {}
};


/* harmony default export */ var AdvertInfo_defaultExport = (AdvertInfo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__AdvertInfo_css___default.a)(AdvertInfo));
// CONCATENATED MODULE: ./src/desktop/components/AdvertSeller/AdvertSeller.js
/* harmony import */ var AdvertSeller___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertSeller___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertSeller___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertSeller___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertSeller___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(AdvertSeller___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var AdvertSeller___WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var AdvertSeller___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertSeller___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertSeller___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_DealerWebsiteLink_DealerWebsiteLink__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_DealerSocials_DealerSocials__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withAdvertPhoneView__ = __webpack_require__(1852);
/* harmony import */ var AdvertSeller___WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css__ = __webpack_require__(2766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css__);
var AdvertSeller__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var AdvertSeller__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AdvertSeller__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AdvertSeller__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AdvertSeller__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import cx from 'classnames';
// import { phoneNormalize } from 'shared/modules';












var AdvertSeller_isMobile = "desktop" === 'mobile';

var AdvertSeller__ref2 = AdvertSeller__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Icons__["a" /* AvatarIcon */], {});

var AdvertSeller__ref3 = AdvertSeller__jsx(AdvertSeller___WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u043E\u0434\u0430\u0432\u0435\u0446'
});

var AdvertSeller = function (_React$Component) {
  AdvertSeller__inherits(AdvertSeller, _React$Component);

  function AdvertSeller() {
    var _ref;

    var _temp, _this, _ret;

    AdvertSeller__classCallCheck(this, AdvertSeller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = AdvertSeller__possibleConstructorReturn(this, (_ref = AdvertSeller.__proto__ || Object.getPrototypeOf(AdvertSeller)).call.apply(_ref, [this].concat(args))), _this), _this.handleShowPhoneClick = function (cb) {
      var _this$props = _this.props,
          advertID = _this$props.advertID,
          requestShowPhones = _this$props.requestShowPhones;

      if (advertID) {
        requestShowPhones(advertID, true, function (phones) {
          return cb(phones);
        });
      }
    }, _temp), AdvertSeller__possibleConstructorReturn(_this, _ret);
  }

  AdvertSeller__createClass(AdvertSeller, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          authorName = _props.authorName,
          location = _props.location,
          avatar = _props.avatar,
          link = _props.link,
          extraText = _props.extraText,
          phones = _props.phones,
          agency = _props.agency,
          sold = _props.sold,
          setRatioImage = _props.setRatioImage,
          active = _props.active,
          isApprovePub = _props.isApprovePub,
          t = _props.t;

      var website = agency && agency.website ? agency.website : null;
      var avatarImg = 'https://img.freepik.com/free-photo/horizontal-shot-handsome-charismatic-young-man-with-black-hair-stubble-posing-isolated-pointing-fore-fingers-having-confident-flirty-facial-expression-choosing-you-body-language_343059-4555.jpg?size=626&ext=jpg'; // avatar && setRatioImage(avatar.replace('http:', 'https:'), 40);
      var isDeactivated = (active === -2 || !active || sold) && !isApprovePub;
      var messengers = agency && agency.messengers && !!agency.messengers.length && agency.messengers;
      var rootClass = AdvertSeller_isMobile ? __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.root;
      return AdvertSeller__jsx('div', {
        className: rootClass
      }, void 0, AdvertSeller__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.rowContainer
      }, void 0, avatar && AdvertSeller__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.avatar,
        alt: '',
        src: avatarImg
      }), !avatar && AdvertSeller__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.avatarPlaceholder
      }, void 0, AdvertSeller__ref2), authorName && AdvertSeller__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.nameContainer
      }, void 0, AdvertSeller__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.sallerTitle
      }, void 0, AdvertSeller__ref3), AdvertSeller__jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_Link_Link__["a" /* default */], {
        to: link || null,
        className: link ? __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.authorLink : __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.colAuto
      }, void 0, authorName, extraText && AdvertSeller__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.authorExtraText
      }, void 0, extraText)))), AdvertSeller__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.flexColumnBlock
      }, void 0, AdvertSeller__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.flexRowBlock
      }, void 0, website && AdvertSeller__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.write
      }, void 0, AdvertSeller__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_DealerWebsiteLink_DealerWebsiteLink__["a" /* default */], {
        dealer: agency,
        ClassName: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.writeBtn
      })), !isDeactivated && AdvertSeller__jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_UI__["b" /* ContactPhoneButton */], {
        loadPhones: this.handleShowPhoneClick
      })), messengers && AdvertSeller__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a.messengersBlock
      }, void 0, AdvertSeller__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_DealerSocials_DealerSocials__["a" /* default */], {
        messengers: messengers
      }))));
    }
  }]);

  return AdvertSeller;
}(AdvertSeller___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AdvertSeller.defaultProps = {
  authorName: '',
  advertID: null,
  agency: null,
  avatar: null,
  link: null,
  extraText: null,
  phones: null,
  messengers: null,
  sold: false,
  active: 1,
  advert: null,
  isApprovePub: false
};


/* harmony default export */ var AdvertSeller_defaultExport = (AdvertSeller___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_12__AdvertSeller_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withAdvertPhoneView__["a" /* default */](__WEBPACK_IMPORTED_MODULE_9_shared_hocs_withPixelRatio__["a" /* default */](AdvertSeller___WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__["a" /* withTranslate */](AdvertSeller)))));
// CONCATENATED MODULE: ./src/shared/components/DealerServiceExchangeForm/service.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
var service__this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var sandEmail = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data, fetch) {
    var service, slug, phone, name, advertId, formData, options, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            service = data.service, slug = data.slug, phone = data.phone, name = data.name, advertId = data.advertId;
            formData = JSON.stringify({
              service: service,
              slug: slug,
              phone: phone.replace(/\s/g, ''),
              name: name,
              advertId: advertId
            });
            options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            };
            _context.prev = 3;
            _context.next = 6;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].DEALERS.REQUEST_SERVICE, options).then(function (r) {
              return r.json();
            });

          case 6:
            result = _context.sent;

            if (!(!result || result.err)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return', false);

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](3);
            return _context.abrupt('return', false);

          case 14:
            return _context.abrupt('return', true);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, service__this, [[3, 11]]);
  }));

  return function sandEmail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/shared/components/DealerServiceExchangeForm/DealerServiceExchangeForm.js
/* harmony import */ var DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_validations_validations__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_icons_yourCarIcon_svg__ = __webpack_require__(3295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_icons_yourCarIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_icons_yourCarIcon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css__ = __webpack_require__(3296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css__);
var DealerServiceExchangeForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var DealerServiceExchangeForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function DealerServiceExchangeForm__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function DealerServiceExchangeForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DealerServiceExchangeForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function DealerServiceExchangeForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var DealerServiceExchangeForm__ref2 = DealerServiceExchangeForm__jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_Icons__["g" /* ExchangeIcon */], {});

var DealerServiceExchangeForm__ref3 = DealerServiceExchangeForm__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_8_shared_assets_icons_yourCarIcon_svg___default.a,
  alt: '\u041F\u0440\u043E\u0434\u0430\u0442\u044C',
  width: '90',
  height: '90'
});

var DealerServiceExchangeForm__ref4 = DealerServiceExchangeForm__jsx('div', {}, void 0, '\u0412\u0430\u0448 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u043B\u044C');

var DealerServiceExchangeForm_DealerServiceExchangeForm = function (_React$Component) {
  DealerServiceExchangeForm__inherits(DealerServiceExchangeForm, _React$Component);

  function DealerServiceExchangeForm() {
    var _ref;

    var _temp, _this, _ret;

    DealerServiceExchangeForm__classCallCheck(this, DealerServiceExchangeForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = DealerServiceExchangeForm__possibleConstructorReturn(this, (_ref = DealerServiceExchangeForm.__proto__ || Object.getPrototypeOf(DealerServiceExchangeForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      phone: '',
      name: '',
      errorMessage: '',
      successMessage: '',
      disabled: true
    }, _this.validateForm = function () {
      var phone = _this.state.phone;

      if (phone && !__WEBPACK_IMPORTED_MODULE_7_shared_validations_validations__["e" /* isValidPhone */](phone.replace(/\s/g, ''))) {
        _this.setState({ errorMessage: _this.props.t('Некорректный номер телефона') });
        return false;
      }
      return !!phone;
    }, _this.handleInput = function (field, value) {
      var _this$setState;

      _this.setState((_this$setState = {}, DealerServiceExchangeForm__defineProperty(_this$setState, field, value), DealerServiceExchangeForm__defineProperty(_this$setState, 'errorMessage', ''), DealerServiceExchangeForm__defineProperty(_this$setState, 'disabled', !_this.state.phone || !_this.state.name), _this$setState));
    }, _this.handleSubmit = function () {
      if (!_this.validateForm()) return;
      var _this$props = _this.props,
          dealerSlug = _this$props.dealerSlug,
          advertInfo = _this$props.advertInfo,
          service = _this$props.service;
      var _this$state = _this.state,
          phone = _this$state.phone,
          name = _this$state.name;

      var dataToEmail = {
        slug: dealerSlug,
        phone: phone,
        name: name,
        service: service,
        advertId: advertInfo.advertId
      };

      _this.setState({ disabled: true });
      var errMsg = 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже';
      sandEmail(dataToEmail, _this.props.fetch).then(function (data) {
        _this.setState({ disabled: false });
        if (data) _this.props.onSent();else if (!data) _this.setState({ errorMessage: errMsg });
      }).catch(function () {
        _this.setState({
          disabled: false,
          errorMessage: errMsg
        });
      });
    }, _temp), DealerServiceExchangeForm__possibleConstructorReturn(_this, _ret);
  }

  DealerServiceExchangeForm__createClass(DealerServiceExchangeForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          errorMessage = _state.errorMessage,
          successMessage = _state.successMessage,
          name = _state.name,
          phone = _state.phone,
          disabled = _state.disabled;
      var _props = this.props,
          t = _props.t,
          advertInfo = _props.advertInfo;


      var carPicStyle = {
        backgroundImage: 'url(' + advertInfo.photos[0].image + ')'
      };
      var currency = 'грн';
      var price = (advertInfo.prices || []).find(function (p) {
        return p.currency === currency;
      });

      return DealerServiceExchangeForm__jsx('div', {}, void 0, DealerServiceExchangeForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.carBlock
      }, void 0, DealerServiceExchangeForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.carBlockLeft
      }, void 0, DealerServiceExchangeForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.carBlockImage,
        style: carPicStyle
      }), DealerServiceExchangeForm__jsx('div', {}, void 0, advertInfo.title), DealerServiceExchangeForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.carBlockPrice
      }, void 0, price.value, ' ', currency)), DealerServiceExchangeForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.circleExchangeBlock
      }, void 0, DealerServiceExchangeForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.circleExchange
      }, void 0, DealerServiceExchangeForm__ref2)), DealerServiceExchangeForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.carBlockRight
      }, void 0, DealerServiceExchangeForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.carBlockImage
      }, void 0, DealerServiceExchangeForm__ref3), DealerServiceExchangeForm__ref4)), DealerServiceExchangeForm__jsx('form', {
        className: __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.requestForm
      }, void 0, DealerServiceExchangeForm__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_UI__["c" /* InputPhoneNumber */], {
        name: 'phone',
        value: phone,
        changeHandler: function changeHandler(name, value) {
          return _this2.handleInput(name, value);
        }
      }), DealerServiceExchangeForm__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_UI__["e" /* InputText */], {
        name: 'name',
        value: name,
        placeholder: name || t('Введите имя'),
        changeHandler: function changeHandler(name, value) {
          return _this2.handleInput(name, value);
        }
      }), DealerServiceExchangeForm__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_UI__["a" /* Button */], {
        type: 'button',
        text: t('Подтвердить номер'),
        disabled: disabled,
        onClick: function onClick(e) {
          _this2.handleSubmit(e);
        }
      })), (errorMessage || successMessage) && DealerServiceExchangeForm__jsx('span', {
        className: DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(DealerServiceExchangeForm__defineProperty({}, __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.errorMessage, errorMessage), DealerServiceExchangeForm__defineProperty({}, __WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a.successMessage, successMessage))
      }, void 0, t(errorMessage || successMessage)));
    }
  }]);

  return DealerServiceExchangeForm;
}(DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DealerServiceExchangeForm_DealerServiceExchangeForm.defaultProps = {
  onSent: function onSent() {}
};


/* harmony default export */ var DealerServiceExchangeForm_defaultExport = (DealerServiceExchangeForm___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_11__DealerServiceExchangeForm_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_5_shared_hocs_withFetch__["a" /* withFetch */](DealerServiceExchangeForm_DealerServiceExchangeForm))));
// CONCATENATED MODULE: ./src/desktop/components/AdvertSeller/AdvertSellerDealer.js
/* harmony import */ var AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_hocs_withAdvertPhoneView__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_components_DealerSocials_DealerSocials__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_components_DealerServiceForm_ThanksBlock__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_components_Elements__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_components_DealerServiceForm_DealerServiceForm__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css__ = __webpack_require__(3298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css__);
var AdvertSellerDealer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var AdvertSellerDealer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AdvertSellerDealer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AdvertSellerDealer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AdvertSellerDealer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// import { FormattedMessage } from 'react-intl';
// import { phoneNormalize } from 'shared/modules';
// import DealerWebsiteLink from 'shared/components/DealerWebsiteLink/DealerWebsiteLink';












// import ModalContainer from 'shared/components/ModalContainer/ModalContainer';







// import locationPointImg from 'shared/assets/images/placeholder-filled-point.svg';



var AdvertSellerDealer_isMobile = "desktop" === 'mobile';

var AdvertSellerDealer__ref2 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'Продавец'
});

var AdvertSellerDealer__ref3 = AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_15_shared_components_DealerServiceForm_ThanksBlock__["a" /* default */], {});

var AdvertSellerDealer__ref4 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A'
});

var AdvertSellerDealer__ref5 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'USER_AGREEMENT_DLG_TITLE_1'
});

var AdvertSellerDealer__ref6 = AdvertSellerDealer__jsx('br', {});

var AdvertSellerDealer__ref7 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'USER_AGREEMENT_DLG_TITLE_2'
});

var AdvertSellerDealer__ref8 = AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_15_shared_components_DealerServiceForm_ThanksBlock__["a" /* default */], {});

var AdvertSellerDealer__ref9 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0431\u043C\u0435\u043D \u043D\u0430 \u043C\u043E\u0451 \u0430\u0432\u0442\u043E'
});

var AdvertSellerDealer__ref10 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'USER_AGREEMENT_DLG_TITLE_1'
});

var AdvertSellerDealer__ref11 = AdvertSellerDealer__jsx('br', {});

var AdvertSellerDealer__ref12 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'USER_AGREEMENT_DLG_TITLE_2'
});

var AdvertSellerDealer__ref13 = AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_15_shared_components_DealerServiceForm_ThanksBlock__["a" /* default */], {});

var AdvertSellerDealer__ref14 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432'
});

var AdvertSellerDealer__ref15 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'USER_AGREEMENT_DLG_TITLE_1'
});

var AdvertSellerDealer__ref16 = AdvertSellerDealer__jsx('br', {});

var _ref17 = AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: 'USER_AGREEMENT_DLG_TITLE_2'
});

var AdvertSellerDealer_AdvertSellerDealer = function (_React$Component) {
  AdvertSellerDealer__inherits(AdvertSellerDealer, _React$Component);

  function AdvertSellerDealer() {
    var _ref;

    var _temp, _this, _ret;

    AdvertSellerDealer__classCallCheck(this, AdvertSellerDealer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = AdvertSellerDealer__possibleConstructorReturn(this, (_ref = AdvertSellerDealer.__proto__ || Object.getPrototypeOf(AdvertSellerDealer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showCallBackModal: false,
      showExchangeModal: false,
      showTestDriveModal: false
    }, _this.onEmailSent = function (serviceType) {
      _this.setState({ emailSent: true });
      setTimeout(function () {
        _this.closeServiceModal();
      }, 5000);

      var eventName = {
        'Trade-in': 'formTradeIn',
        'Обратный звонок': 'formCallback',
        'Test-drive': 'formTestDrive'
      };
      var gtmEvent = __WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__["a" /* EVENTS */].DEALER_ADV[eventName[serviceType]];
      if (gtmEvent) _this.props.setDataLayer(gtmEvent);
      __WEBPACK_IMPORTED_MODULE_9_shared_helpers_rtbHouse__["a" /* fireRTBEvent */](eventName[serviceType], {
        value: _this.props.prices && __WEBPACK_IMPORTED_MODULE_6_shared_helpers_advert__["c" /* getPrice */](_this.props.prices),
        ids: [_this.props.advertID]
      });
    }, _this.handleExchange = function () {
      _this.setState({ showExchangeModal: true });
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__["a" /* EVENTS */].DEALER_ADV.tradeIn);
    }, _this.handleTestDrive = function () {
      _this.setState({ showTestDriveModal: true });
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__["a" /* EVENTS */].DEALER_ADV.testDrive);
    }, _this.handleShowPhoneClick = function (cb) {
      var _this$props = _this.props,
          advertID = _this$props.advertID,
          requestShowPhones = _this$props.requestShowPhones;

      if (advertID) {
        requestShowPhones(advertID, true, function (phones) {
          return cb(phones);
        });
      }
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__["a" /* EVENTS */].DEALER_ADV.showNubmer);
    }, _this.handleIncommingCall = function () {
      _this.setState({ showCallBackModal: true });
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_7_shared_constants_gtmEvents__["a" /* EVENTS */].DEALER_ADV.callback);
    }, _this.closeServiceModal = function () {
      _this.setState({
        emailSent: false,
        showCallBackModal: false,
        showExchangeModal: false,
        showTestDriveModal: false
      });
    }, _temp), AdvertSellerDealer__possibleConstructorReturn(_this, _ret);
  }

  AdvertSellerDealer__createClass(AdvertSellerDealer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          authorName = _props.authorName,
          location = _props.location,
          avatar = _props.avatar,
          agency = _props.agency,
          link = _props.link,
          extraText = _props.extraText,
          sold = _props.sold,
          setRatioImage = _props.setRatioImage,
          active = _props.active,
          isApprovePub = _props.isApprovePub,
          title = _props.title,
          prices = _props.prices,
          advert = _props.advert,
          t = _props.t;


      var isTradeIn = agency && agency.trade_in;
      var isVerified = agency && agency.is_verified;
      var isTestDrive = agency && agency.test_drive;
      var IsGuaranteed = agency && agency.association_guarantees;

      var avatarImg = avatar && setRatioImage(avatar.replace('http:', 'https:'), 40);
      var isDeactivated = (active === -2 || !active || sold) && !isApprovePub;
      var messengers = agency && agency.messengers && !!agency.messengers.length && agency.messengers;

      var advertInfo = {
        title: title,
        prices: prices,
        photos: advert.photos,
        advertId: advert.id
      };

      /*
      const locale = t('locale') === 'ru' ? '' : `${t('locale')}_`;
      const agreementLink = `/pdf/${locale}terms-of-use.pdf`; */
      var moreAdvsText = agency.adverts_count ? t('Еще') + ' ' + agency.adverts_count + ' ' + t('предложений') : '';
      var rootClass = AdvertSellerDealer_isMobile ? __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.root;
      return AdvertSellerDealer__jsx('div', {
        className: rootClass
      }, void 0, AdvertSellerDealer__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.rowContainer
      }, void 0, authorName && AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, AdvertSellerDealer__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.titleBlock
      }, void 0, AdvertSellerDealer__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.avatarBlock
      }, void 0, avatar && AdvertSellerDealer__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.avatar,
        alt: '',
        src: avatarImg
      })), AdvertSellerDealer__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.dealerInfo
      }, void 0, AdvertSellerDealer__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.greyText
      }, void 0, AdvertSellerDealer__ref2), AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
        to: link || null,
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.authorName
      }, void 0, authorName))), AdvertSellerDealer__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.statusesBlock
      }, void 0, AdvertSellerDealer__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.statusesIcons
      }, void 0, AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Elements__["b" /* IsVerifiedElement */], {
        type: AdvertSellerDealer_isMobile ? 'iconWithText' : 'icon'
      }), AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_Elements__["a" /* IsGuaranteedElement */], {
        type: AdvertSellerDealer_isMobile ? 'iconWithText' : 'icon'
      })), moreAdvsText && AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
        to: link || null,
        className: link ? __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.moreAdvsText : __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.colAuto
      }, void 0, moreAdvsText)))), !isDeactivated && AdvertSellerDealer__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.flexColumnBlock
      }, void 0, AdvertSellerDealer__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.flexRowBlock
      }, void 0, AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_13_shared_components_UI__["a" /* Button */], {
        theme: 'Transparent',
        text: '\u041E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A',
        Icon: __WEBPACK_IMPORTED_MODULE_19_shared_components_Icons__["j" /* IncomminCallIcon */],
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.incomminCall,
        onClick: this.handleIncommingCall
      }), AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_13_shared_components_UI__["b" /* ContactPhoneButton */], {
        loadPhones: this.handleShowPhoneClick
      })), AdvertSellerDealer__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.buttonsWrapper
      }, void 0, isTradeIn && AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_13_shared_components_UI__["a" /* Button */], {
        theme: 'Transparent',
        text: '\u041E\u0431\u043C\u0435\u043D \u043D\u0430 \u043C\u043E\u0451 \u0430\u0432\u0442\u043E',
        Icon: __WEBPACK_IMPORTED_MODULE_19_shared_components_Icons__["g" /* ExchangeIcon */],
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.exchangeButton,
        onClick: this.handleExchange
      }), isTestDrive && AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_13_shared_components_UI__["a" /* Button */], {
        theme: 'Transparent',
        text: '\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0442\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432',
        Icon: __WEBPACK_IMPORTED_MODULE_19_shared_components_Icons__["q" /* TestDriveIcon */],
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.testDriveButton,
        onClick: this.handleTestDrive
      })), this.state.showCallBackModal && AdvertSellerDealer__jsx('div', {}, void 0, AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_16_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: this.closeServiceModal,
        show: this.state.showCallBackModal
      }, void 0, this.state.emailSent ? AdvertSellerDealer__ref3 : AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, AdvertSellerDealer__jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.rootModalTitle
      }, void 0, AdvertSellerDealer__ref4), AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_18_shared_components_DealerServiceForm_DealerServiceForm__["a" /* default */], {
        dealerSlug: agency.slug,
        service: '\u041E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A',
        advertInfo: advertInfo,
        onSent: function onSent() {
          return _this2.onEmailSent('Обратный звонок');
        }
      }), AdvertSellerDealer__jsx('p', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.modalText + ' ' + __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.rootModalPolicy
      }, void 0, AdvertSellerDealer__ref5, AdvertSellerDealer__ref6, AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.modalTextLink
      }, void 0, AdvertSellerDealer__ref7))))), this.state.showExchangeModal && AdvertSellerDealer__jsx('div', {}, void 0, AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_16_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: this.closeServiceModal,
        show: this.state.showExchangeModal
      }, void 0, this.state.emailSent ? AdvertSellerDealer__ref8 : AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, AdvertSellerDealer__jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.rootModalTitle
      }, void 0, AdvertSellerDealer__ref9), AdvertSellerDealer__jsx(DealerServiceExchangeForm_defaultExport, {
        dealerSlug: agency.slug,
        advertInfo: advertInfo,
        service: 'Trade-in',
        onSent: function onSent() {
          return _this2.onEmailSent('Trade-in');
        }
      }), AdvertSellerDealer__jsx('p', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.modalText + ' ' + __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.rootModalPolicy
      }, void 0, AdvertSellerDealer__ref10, AdvertSellerDealer__ref11, AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.modalTextLink
      }, void 0, '', AdvertSellerDealer__ref12))))), this.state.showTestDriveModal && AdvertSellerDealer__jsx('div', {}, void 0, AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_16_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: this.closeServiceModal,
        show: this.state.showTestDriveModal
      }, void 0, this.state.emailSent ? AdvertSellerDealer__ref13 : AdvertSellerDealer__jsx(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, AdvertSellerDealer__jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.rootModalTitle
      }, void 0, AdvertSellerDealer__ref14), AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_18_shared_components_DealerServiceForm_DealerServiceForm__["a" /* default */], {
        dealerSlug: agency.slug,
        service: '\u0422\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432',
        advertInfo: advertInfo,
        onSent: function onSent() {
          return _this2.onEmailSent('Тест драйв');
        }
      }), AdvertSellerDealer__jsx('p', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.modalText + ' ' + __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.rootModalPolicy
      }, void 0, AdvertSellerDealer__ref15, AdvertSellerDealer__ref16, AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.modalTextLink
      }, void 0, _ref17))))), messengers && AdvertSellerDealer__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a.messengersBlock
      }, void 0, AdvertSellerDealer__jsx(__WEBPACK_IMPORTED_MODULE_14_shared_components_DealerSocials_DealerSocials__["a" /* default */], {
        messengers: messengers
      }))));
    }
  }]);

  return AdvertSellerDealer;
}(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AdvertSellerDealer_AdvertSellerDealer.defaultProps = {
  authorName: '',
  advertID: null,
  agency: null,
  avatar: null,
  link: null,
  extraText: null,
  phones: null,
  messengers: null,
  sold: false,
  active: 1,
  showCallBackModal: false,
  isVerified: null
};


/* harmony default export */ var AdvertSellerDealer_defaultExport = (AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_21__AdvertSellerDealer_css___default.a)(AdvertSellerDealer___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](null, { setDataLayer: __WEBPACK_IMPORTED_MODULE_8_shared_actions_globals__["j" /* setDataLayer */] })(__WEBPACK_IMPORTED_MODULE_12_shared_hocs_withAdvertPhoneView__["a" /* default */](__WEBPACK_IMPORTED_MODULE_10_shared_hocs_withPixelRatio__["a" /* default */](__WEBPACK_IMPORTED_MODULE_11_shared_hocs_withTranslate__["a" /* withTranslate */](AdvertSellerDealer_AdvertSellerDealer))))));
// CONCATENATED MODULE: ./src/shared/components/YoutubeVideo/YoutubeVideo.js
/* harmony import */ var YoutubeVideo___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var YoutubeVideo___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(YoutubeVideo___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var YoutubeVideo___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var YoutubeVideo___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(YoutubeVideo___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var YoutubeVideo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var YoutubeVideo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(YoutubeVideo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_get_youtube_id__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_get_youtube_id___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_get_youtube_id__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__YoutubeVideo_css__ = __webpack_require__(3300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__YoutubeVideo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__YoutubeVideo_css__);
var YoutubeVideo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function YoutubeVideo(props) {
  var link = props.link,
      className = props.className;


  if (!link) {
    return null;
  }

  var id = __WEBPACK_IMPORTED_MODULE_4_get_youtube_id___default.a(link);

  if (!id) {
    return null;
  }

  return YoutubeVideo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__YoutubeVideo_css___default.a.root, className)
  }, void 0, YoutubeVideo__jsx('iframe', {
    className: __WEBPACK_IMPORTED_MODULE_5__YoutubeVideo_css___default.a.iframe,
    title: 'Youtube video',
    src: 'https://www.youtube.com/embed/' + id,
    frameBorder: '0',
    allow: 'autoplay; encrypted-media',
    allowFullScreen: true
  }));
}

YoutubeVideo.defaultProps = {
  link: null,
  className: ''
};


/* harmony default export */ var YoutubeVideo_defaultExport = (YoutubeVideo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__YoutubeVideo_css___default.a)(YoutubeVideo));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingQuestions/LeasingQuestions.js
/* harmony import */ var LeasingQuestions___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingQuestions___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingQuestions___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingQuestions___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var LeasingQuestions___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(LeasingQuestions___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var LeasingQuestions___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingQuestions___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(LeasingQuestions___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var LeasingQuestions___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingQuestions___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingQuestions___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_validations_validations__ = __webpack_require__(1402);
/* harmony import */ var LeasingQuestions___WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_creditmarket__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_ulf__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf24__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_hocs_withLeasingParams__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__RecallForm_RecallForm__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css__ = __webpack_require__(3302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css__);
var LeasingQuestions__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeasingQuestions__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var LeasingQuestions__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeasingQuestions__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function LeasingQuestions__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingQuestions__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingQuestions__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























// import withHapai from 'shared/hocs/withHapai';


// eslint-disable-next-line css-modules/no-unused-class


var LeasingQuestions_isMobile = "desktop" === 'mobile';

var LeasingQuestions = function (_React$Component) {
  LeasingQuestions__inherits(LeasingQuestions, _React$Component);

  function LeasingQuestions() {
    var _ref;

    var _temp, _this, _ret;

    LeasingQuestions__classCallCheck(this, LeasingQuestions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LeasingQuestions__possibleConstructorReturn(this, (_ref = LeasingQuestions.__proto__ || Object.getPrototypeOf(LeasingQuestions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      userName: '',
      phone: '',
      disableBtnLeasing: false,
      errorMessage: '',
      successMessage: '',
      showRecall: false
    }, _this.onLeadCreated = function (success, partner) {
      var eventName = (partner ? partner + '-' : '') + 'lead-create-' + (success ? 'success' : 'fail') + '-questions';
      if (__WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[eventName]) _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[eventName]);else {}
    }, _this.onSubmitHandler = function () {
      if (!_this.validateForm() || !_this.props.leasingParams) return false;
      _this.setState({ disableBtnLeasing: true });
      var partnerName = '';
      var isCreditMarket = __WEBPACK_IMPORTED_MODULE_15_shared_helpers_leasing_myAuto__["g" /* isCreditmarketNotClearedProposalAvailable */](_this.props.advert) || __WEBPACK_IMPORTED_MODULE_15_shared_helpers_leasing_myAuto__["h" /* isCreditmarketProposalAvailable */](_this.props.advert);

      // if (!isCreditMarket && isAutoMoneyLeasing(this.props.leasingParams)) {
      //   partnerName = 'automoney';
      // } else 
      if (__WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_utils__["j" /* isUlf24Leasing */](_this.props.leasingParams)) {
        partnerName = 'ulf24';
      } else if (__WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_utils__["k" /* isUlfLeasing */](_this.props.leasingParams)) {
        partnerName = 'ulf';
      } else if (isCreditMarket) {
        partnerName = 'creditmarket';
      }

      var submit = void 0;

      if (partnerName === 'automoney') {
        submit = _this.submitAutoMoneyLeasingLead;
      } else if (partnerName === 'creditmarket') {
        submit = _this.submitCreditmarketLeasingLead;
      } else if (partnerName === 'ulf24') {
        submit = _this.submitUlfLeasingLead;
      } else if (partnerName === 'ulf') {
        submit = _this.submitUlfLeasingLead;
      } else {
        submit = _this.submitAFinanceLeasingLead;
      }

      submit(function (success) {
        if (success) {
          _this.setState({ showRecall: true });
          _this.onLeadCreated(true, partnerName);
        } else {
          _this.setState({ errorMessage: 'Произошла ошибка' });
          _this.onLeadCreated(false, partnerName);
        }
        _this.setState({ disableBtnLeasing: false });
      });

      return true;
    }, _this.submitCreditmarketLeasingLead = function (cb) {
      var _this$props = _this.props,
          advert = _this$props.advert,
          fetch = _this$props.fetch;
      var _this$state = _this.state,
          phone = _this$state.phone,
          userName = _this$state.userName;

      var cmParams = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_creditmarket__["a" /* prepareParamsForCreditMarketRequest */](LeasingQuestions__extends({}, advert, { phone: phone, userName: userName }));
      __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_creditmarket__["b" /* sendCreditMarket */](cmParams, fetch).then(function (result) {
        cb(result && result.id);
      }).catch(function () {
        cb(false);
      });
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].leasing['creditmarket-questions-form-sumbit']);
    }, _this.submitAFinanceLeasingLead = function (cb) {
      var _this$props2 = _this.props,
          advert = _this$props2.advert,
          leasingParams = _this$props2.leasingParams,
          fetch = _this$props2.fetch;

      var leadsParams = __WEBPACK_IMPORTED_MODULE_15_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */](_this.state, advert, leasingParams, {});
      __WEBPACK_IMPORTED_MODULE_15_shared_helpers_leasing_myAuto__["a" /* createAFinanceLeda */](leadsParams, advert, fetch).then(function (result) {
        cb(result && result.id);
      }).catch(function () {
        cb(false);
      });
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].leasing['questions-form-sumbit']);
    }, _this.submitAutoMoneyLeasingLead = function (cb) {
      var _this$props3 = _this.props,
          advert = _this$props3.advert,
          leasingParams = _this$props3.leasingParams,
          fetch = _this$props3.fetch;

      var leadsParams = __WEBPACK_IMPORTED_MODULE_15_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */](_this.state, advert, leasingParams, {});
      __WEBPACK_IMPORTED_MODULE_15_shared_helpers_leasing_myAuto__["b" /* createAutoMoneyLead */](leadsParams, advert, fetch).then(function (result) {
        cb(result && result.id);
      }).catch(function () {
        cb(false);
      });
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].leasing['questions-form-sumbit']);
    }, _this.submitUlfLeasingLead = function (cb) {
      var _this$state2 = _this.state,
          phone = _this$state2.phone,
          userName = _this$state2.userName;
      var _this$props4 = _this.props,
          advert = _this$props4.advert,
          leasingParams = _this$props4.leasingParams,
          fetch = _this$props4.fetch;


      var leadParams = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({ phone: phone, userName: userName, leasingParams: leasingParams, advert: advert });
      __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_ulf__["a" /* createUlfLead */](leadParams, fetch).then(function (result) {
        cb(result && result.id);
      }).catch(function () {
        cb(false);
      });
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].leasing['questions-form-sumbit']);
    }, _this.submitUlf24LeasingLead = function (cb) {
      var _this$state3 = _this.state,
          phone = _this$state3.phone,
          userName = _this$state3.userName;
      var _this$props5 = _this.props,
          advert = _this$props5.advert,
          leasingParams = _this$props5.leasingParams,
          fetch = _this$props5.fetch;


      var leadParams = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({ phone: phone, userName: userName, leasingParams: leasingParams, advert: advert });
      __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf24__["a" /* createUlf24Lead */](leadParams, fetch).then(function (result) {
        cb(result && result.id);
      }).catch(function () {
        cb(false);
      });
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].leasing['questions-form-sumbit']);
    }, _this.changeHandler = function (field, value) {
      var _this$setState;

      _this.setState((_this$setState = {}, LeasingQuestions__defineProperty(_this$setState, field, value), LeasingQuestions__defineProperty(_this$setState, 'errorMessage', ''), _this$setState));
    }, _this.validateForm = function () {
      var _this$state4 = _this.state,
          phone = _this$state4.phone,
          userName = _this$state4.userName;

      if (!phone || !__WEBPACK_IMPORTED_MODULE_8_shared_validations_validations__["e" /* isValidPhone */](phone.replace(/\s/g, ''))) {
        _this.setState({ errorMessage: 'Некорректный номер телефона' });
        return false;
      }

      if (!userName) {
        _this.setState({ errorMessage: 'Некорректное имя' });
        return false;
      }

      return true;
    }, _temp), LeasingQuestions__possibleConstructorReturn(_this, _ret);
  }

  // submitHapaiLeasingLead = cb => {
  //   const { phone, userName } = this.state;
  //   const { advert, leasingParams, fetch } = this.props;

  //   const leadParams = {
  //     phone,
  //     userName,
  //     advert,
  //     leasingParams,
  //     term: leasingParams.term,
  //     prepaid: leasingParams.extendedParams && leasingParams.extendedParams.prepaidUAH,
  //     price: leasingParams.extendedParams && leasingParams.extendedParams.priceUAH,
  //     userStorageId: localStorage.getItem('applensDeviceId') || '',
  //   };
  //   console.log('Create Hapai Lead');
  //   createHapaiLead(leadParams, fetch)
  //     .then(data => cb(data && data.success))
  //     .catch(() => cb(false));
  //   this.props.setDataLayer(EVENTS.leasing['hapai-questions-form-sumbit']);
  //   return false;
  // };

  LeasingQuestions__createClass(LeasingQuestions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          userName = _state.userName,
          phone = _state.phone,
          errorMessage = _state.errorMessage,
          successMessage = _state.successMessage,
          disableBtnLeasing = _state.disableBtnLeasing;
      var t = this.props.t;

      var disabledBtn = disableBtnLeasing || !userName || !phone;

      var rootClass = LeasingQuestions_isMobile ? __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default.a.root;
      return LeasingQuestions__jsx('div', {
        className: rootClass
      }, void 0, LeasingQuestions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default.a.info
      }, void 0, LeasingQuestions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default.a.infoTitle
      }, void 0, t('Остались вопросы?')), LeasingQuestions__jsx('p', {}, void 0, t('Расскажем про “Ежемесячный платёж” за 3 минуты'))), LeasingQuestions__jsx('div', {}, void 0, LeasingQuestions__jsx('form', {
        className: __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default.a.form
      }, void 0, LeasingQuestions__jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_UI__["e" /* InputText */], {
        name: 'userName',
        value: userName,
        placeholder: userName || t('Имя'),
        changeHandler: this.changeHandler
      }), LeasingQuestions__jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_UI__["c" /* InputPhoneNumber */], {
        name: 'phone',
        value: phone,
        changeHandler: this.changeHandler
      }), LeasingQuestions__jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_UI__["a" /* Button */], {
        disabled: disabledBtn,
        type: 'button',
        onClick: this.onSubmitHandler,
        text: '\u041A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044F'
      })), LeasingQuestions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default.a.messageBlock
      }, void 0, (errorMessage || successMessage) && LeasingQuestions__jsx('span', {
        className: LeasingQuestions___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(LeasingQuestions__defineProperty({}, __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default.a.errorMessage, errorMessage), LeasingQuestions__defineProperty({}, __WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default.a.successMessage, successMessage))
      }, void 0, t(errorMessage || successMessage), ' '))), this.state.showRecall && LeasingQuestions__jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: function toggleModal() {
          return _this2.setState({ showRecall: false });
        },
        show: this.state.showRecall
      }, void 0, LeasingQuestions__jsx(__WEBPACK_IMPORTED_MODULE_19__RecallForm_RecallForm__["a" /* default */], {
        timeUp: function timeUp() {
          return _this2.setState({ showRecall: false });
        }
      })));
    }
  }]);

  return LeasingQuestions;
}(LeasingQuestions___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingQuestions.defaultProps = {
  leasingParams: null
};


var LeasingQuestions_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDataLayer: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ var LeasingQuestions_defaultExport = (LeasingQuestions___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_20__LeasingQuestions_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](null, LeasingQuestions_mapDispatchToProps)(LeasingQuestions___WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_18_shared_hocs_withLeasingParams__["a" /* withLeasingParams */](LeasingQuestions))))));
// CONCATENATED MODULE: ./src/desktop/routes/advert/components/TestDrives/TestDrives.js
/* harmony import */ var TestDrives___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TestDrives___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TestDrives___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TestDrives___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var TestDrives___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TestDrives___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var TestDrives___WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var TestDrives___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var TestDrives___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TestDrives___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_desktop_routes_journal_components_NewsList_NewsList__ = __webpack_require__(2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TestDrives_css__ = __webpack_require__(3304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TestDrives_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TestDrives_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_hocs_withFetch__ = __webpack_require__(1244);
var TestDrives__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var TestDrives__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function TestDrives__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TestDrives__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TestDrives__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TestDrives__ref2 = TestDrives__jsx(TestDrives___WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0422\u0435\u0441\u0442-\u0434\u0440\u0430\u0439\u0432\u044B \u0434\u043B\u044F \u0434\u0430\u043D\u043D\u043E\u0439 \u043C\u043E\u0434\u0435\u043B\u0438 \u0435\u0449\u0451 \u043D\u0435 \u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u044B'
});

var TestDrives = function (_React$Component) {
  TestDrives__inherits(TestDrives, _React$Component);

  function TestDrives() {
    var _ref;

    var _temp, _this, _ret;

    TestDrives__classCallCheck(this, TestDrives);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = TestDrives__possibleConstructorReturn(this, (_ref = TestDrives.__proto__ || Object.getPrototypeOf(TestDrives)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFetching: true,
      items: null
    }, _temp), TestDrives__possibleConstructorReturn(_this, _ret);
  }

  TestDrives__createClass(TestDrives, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          make = _props.make,
          model = _props.model,
          year = _props.year,
          generation = _props.generation;


      this.props.fetch(__WEBPACK_IMPORTED_MODULE_4_shared_constants_api__["a" /* default */].JOURNAL.TEST_DRIVES({
        make: make,
        model: model,
        year: year,
        generation: generation
      })).then(function (r) {
        return r.json();
      }).then(function (response) {
        _this2.setState({ isFetching: false, items: response.results });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          items = _state.items,
          isFetching = _state.isFetching;


      return TestDrives__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__TestDrives_css___default.a.root
      }, void 0, TestDrives__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__["a" /* default */], {
        isLoading: isFetching
      }, void 0, items && TestDrives__jsx(__WEBPACK_IMPORTED_MODULE_6_desktop_routes_journal_components_NewsList_NewsList__["a" /* default */], {
        news: items,
        shortView: true
      }), items && items.length === 0 && TestDrives__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__TestDrives_css___default.a.emptyMessage
      }, void 0, TestDrives__ref2)));
    }
  }]);

  return TestDrives;
}(TestDrives___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TestDrives.defaultProps = {
  make: undefined,
  model: undefined,
  year: undefined,
  generation: undefined
};


/* harmony default export */ var TestDrives_defaultExport = (TestDrives___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__TestDrives_css___default.a)(__WEBPACK_IMPORTED_MODULE_8__shared_hocs_withFetch__["a" /* withFetch */](TestDrives)));
// CONCATENATED MODULE: ./src/desktop/routes/advert/components/Warranty/Warranty.js
/* harmony import */ var Warranty___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Warranty___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Warranty___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Warranty___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Warranty___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Warranty___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Warranty___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Warranty___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Warranty___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_WarrantyLogo_WarrantyLogo__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_desktop_components_WarrantyModal_WarrantyModal__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_GreenCheckbox_png__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_GreenCheckbox_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_GreenCheckbox_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Warranty_css__ = __webpack_require__(3306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Warranty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Warranty_css__);
var Warranty__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Warranty__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Warranty__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Warranty__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Warranty__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Warranty = function (_React$Component) {
  Warranty__inherits(Warranty, _React$Component);

  function Warranty() {
    var _ref;

    var _temp, _this, _ret;

    Warranty__classCallCheck(this, Warranty);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Warranty__possibleConstructorReturn(this, (_ref = Warranty.__proto__ || Object.getPrototypeOf(Warranty)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModal: false
    }, _this.switchModal = function () {
      return _this.setState({ showModal: !_this.state.showModal });
    }, _temp), Warranty__possibleConstructorReturn(_this, _ret);
  }

  Warranty__createClass(Warranty, [{
    key: 'render',
    value: function render() {
      var warranty = this.props.warranty;
      var showModal = this.state.showModal;


      return Warranty__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__Warranty_css___default.a.root
      }, void 0, Warranty__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__Warranty_css___default.a.warrantyBlock
      }, void 0, Warranty__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_WarrantyLogo_WarrantyLogo__["a" /* default */], {
        warranty: warranty,
        tooltipIcon: __WEBPACK_IMPORTED_MODULE_6__Warranty_css___default.a.tooltipIcon
      })), Warranty__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__Warranty_css___default.a.warrantyList
      }, void 0, warranty.options.map(function (item) {
        return Warranty__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Warranty_css___default.a.option
        }, item.title, Warranty__jsx('img', {
          src: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_GreenCheckbox_png___default.a,
          alt: '',
          className: __WEBPACK_IMPORTED_MODULE_6__Warranty_css___default.a.checkBoxIcon
        }), Warranty__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_6__Warranty_css___default.a.optionTitles
        }, void 0, item.title));
      })), Warranty__jsx('i', {
        className: 'fa fa-info-circle ' + __WEBPACK_IMPORTED_MODULE_6__Warranty_css___default.a.topInfoIcon,
        onClick: this.switchModal
      }), Warranty__jsx(__WEBPACK_IMPORTED_MODULE_4_desktop_components_WarrantyModal_WarrantyModal__["a" /* default */], {
        showModal: showModal,
        switchModal: this.switchModal,
        warranty: warranty
      }));
    }
  }]);

  return Warranty;
}(Warranty___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var Warranty_defaultExport = (Warranty___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__Warranty_css___default.a)(Warranty));
// CONCATENATED MODULE: ./src/desktop/routes/advert/components/Nav/Nav.js
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Nav___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Nav___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(Nav___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Nav___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Nav___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Nav_css__ = __webpack_require__(3308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Nav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Nav_css__);
var Nav__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function Nav__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function Nav(props) {
  var tabs = props.tabs,
      activeTabSlug = props.activeTabSlug,
      onTabChange = props.onTabChange;


  return Nav__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__Nav_css___default.a.root
  }, void 0, Nav__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_6__Nav_css___default.a.nav
  }, void 0, tabs.map(function (tab) {
    var _cx3;

    return (
      // eslint-disable-next-line no-prototype-builtins
      tab.hasOwnProperty('href') ? Nav__jsx('li', {
        className: Nav___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(Nav__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__Nav_css___default.a.disabled, !tab.href))
      }, tab.title, Nav__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link__["a" /* default */], {
        className: Nav___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__Nav_css___default.a.link, Nav__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__Nav_css___default.a.active, !tab.href)),
        to: tab.href
      }, void 0, Nav__jsx(Nav___WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
        id: tab.title
      }))) : Nav__jsx('li', {
        className: Nav___WEBPACK_IMPORTED_MODULE_3_classnames___default.a((_cx3 = {}, Nav__defineProperty(_cx3, __WEBPACK_IMPORTED_MODULE_6__Nav_css___default.a.disabled, tab.disabled), Nav__defineProperty(_cx3, __WEBPACK_IMPORTED_MODULE_6__Nav_css___default.a.active, activeTabSlug === tab.slug), _cx3)),
        onClick: tab.disabled ? undefined : function () {
          return onTabChange(tab.slug);
        }
      }, tab.title, Nav__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6__Nav_css___default.a.link
      }, void 0, Nav__jsx(Nav___WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
        id: tab.title
      })))
    );
  })));

  // return (
  //   <div className={s.root}>
  //     <ul className={s.nav}>
  //       <li className={s.active} onClick={onBaseClick}>
  //         <FormattedMessage id="Объявление" />
  //       </li>
  //       <li className={s.disabled}>
  //         <Link className={cx(s.link)} to="#">
  //           <FormattedMessage id="Характеристики" />
  //         </Link>
  //       </li>
  //       <li className={s.disabled}>
  //         <Link className={cx(s.link)} to="#">
  //           <FormattedMessage id="Отзывы" />
  //         </Link>
  //       </li>
  //       <li className={s.active} onClick={onTestDrivesClick}>
  //         <FormattedMessage id="Тест-драйвы" className={s.link} />
  //       </li>
  //       <li className={cx({ [s.disabled]: !sparesLink })}>
  //         <Link className={cx(s.link, { [s.active]: !sparesLink })} to={sparesLink}>
  //           <FormattedMessage id="Запчасти" />
  //         </Link>
  //       </li>
  //     </ul>
  //   </div>
  // );
}

/* harmony default export */ var Nav_defaultExport = (Nav___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__Nav_css___default.a)(Nav));
// CONCATENATED MODULE: ./src/desktop/routes/advert/components/CarInfo/CarInfo.js
/* harmony import */ var CarInfo___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CarInfo___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CarInfo___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CarInfo___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var CarInfo___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CarInfo___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var CarInfo___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withDialogs__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var CarInfo___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var CarInfo___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(CarInfo___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_actions_journal__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_AdvertDescription_AdvertDescription__ = __webpack_require__(2755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_desktop_components_AdvertPhotos_AdvertPhotos__ = __webpack_require__(2768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_constants_adverts__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_shared_helpers_leasing_leasing__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__CarInfo_css__ = __webpack_require__(3310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__CarInfo_css__);
var CarInfo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var CarInfo__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CarInfo__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CarInfo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CarInfo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CarInfo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// import { AutobookingAdvert } from 'shared/components/AutobookingForm';











// import LeasingForm from 'shared/components/LeasingAndVin/LeasingForm';





// import DialogForm from 'shared/components/DialogForm/DialogForm';



// import SparesForAdvert from '../SparesForAdvert/SparesForAdvert';






var TABS = {
  ADVERT: 'advert',
  TEST_DRIVES: 'test-drives'
};

var CarInfo__ref2 = CarInfo__jsx(__WEBPACK_IMPORTED_MODULE_21_react_intl__["a" /* FormattedMessage */], {
  id: 'Все видео'
});

var CarInfo_CarInfo = function (_React$Component) {
  CarInfo__inherits(CarInfo, _React$Component);

  function CarInfo() {
    var _ref;

    var _temp, _this, _ret;

    CarInfo__classCallCheck(this, CarInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = CarInfo__possibleConstructorReturn(this, (_ref = CarInfo.__proto__ || Object.getPrototypeOf(CarInfo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeTab: TABS.ADVERT
    }, _this.handleTabChange = function (tabSlug) {
      _this.setState({ activeTab: tabSlug });
    }, _this.handleShowVideo = function () {
      var videoParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _this$props = _this.props,
          carInfo = _this$props.carInfo,
          locale = _this$props.intl.locale,
          getSelVideo = _this$props.getSelVideo,
          selVideoParams = _this$props.selVideoParams;

      var pathname = __WEBPACK_IMPORTED_MODULE_18_shared_helpers_urls__["c" /* generateJournalhUrl */](CarInfo__extends({}, carInfo, { location: location }), location && location.is_country);

      if (videoParams) {
        getSelVideo(videoParams);
      } else if (selVideoParams) {
        getSelVideo();
      }
      __WEBPACK_IMPORTED_MODULE_25__history__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["h" /* toLocalized */](('/' + pathname + '/').replace(/\/\//g, '/'), locale));
    }, _temp), CarInfo__possibleConstructorReturn(_this, _ret);
  }

  CarInfo__createClass(CarInfo, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          carInfo = _props.carInfo,
          style = _props.style,
          count = _props.count,
          spares = _props.spares,
          transformedData = _props.transformedData,
          videosAboutCar = _props.videosAboutCar,
          isApprovePub = _props.isApprovePub,
          handleSendMessage = _props.handleSendMessage,
          user = _props.user,
          intl = _props.intl,
          leasingParams = _props.leasingParams;
      var id = carInfo.id,
          make = carInfo.make,
          active = carInfo.active,
          model = carInfo.model,
          modification = carInfo.modification,
          year = carInfo.year,
          transport = carInfo.transport,
          dateCreated = carInfo.date_created,
          datePublicated = carInfo.date_publicated,
          hotDate = carInfo.hot_date,
          photos = carInfo.photos,
          description = carInfo.description,
          options = carInfo.options,
          author = carInfo.author,
          sold = carInfo.sold,
          clarifyPriceLink = carInfo.clarify_price_link,
          isNegotiablePrice = carInfo.is_negotiable_price,
          contactName = carInfo.contact_name;

      var isDealer = Boolean(carInfo.agency && carInfo.agency.id);
      var statuses = __WEBPACK_IMPORTED_MODULE_20_shared_helpers_transportInfo__["f" /* getAdvertStatuses */](carInfo, intl);
      var warranty = transformedData.warranty,
          priceList = transformedData.priceList,
          title = transformedData.title,
          seoTitle = transformedData.seoTitle,
          alt = transformedData.alt,
          agency = transformedData.agency,
          defaultImage = transformedData.defaultImage,
          infoList = transformedData.infoList,
          authorName = transformedData.authorName,
          sellerExtraText = transformedData.sellerExtraText,
          sellerLink = transformedData.sellerLink,
          sellerLocation = transformedData.sellerLocation;


      var sparesLink = '/' + __WEBPACK_IMPORTED_MODULE_18_shared_helpers_urls__["f" /* generateSparesSearchUrl */]({
        transport: transport,
        make: make,
        model: model
      });
      var isActive = active === __WEBPACK_IMPORTED_MODULE_17_shared_constants_adverts__["a" /* ACTIVE_STATUSES */].ACTIVE || isApprovePub;
      var tabs = [{
        title: 'Объявление',
        slug: TABS.ADVERT
      }, {
        title: 'Тест-драйвы',
        slug: TABS.TEST_DRIVES,
        disabled: transport.slug !== 'avto'
      }, {
        title: 'Запчасти',
        href: sparesLink
      }];
      var activeTab = this.state.activeTab;

      var isLeasing = __WEBPACK_IMPORTED_MODULE_23_shared_helpers_leasing_leasing__["a" /* isAnyLeasingAvailable */](carInfo);
      var AdvertSellerComponent = isDealer ? AdvertSellerDealer_defaultExport : AdvertSeller_defaultExport;
      return CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.root,
        style: style
      }, void 0, CarInfo__jsx(Nav_defaultExport, {
        tabs: tabs,
        onTabChange: this.handleTabChange,
        activeTabSlug: activeTab
      }), activeTab === TABS.ADVERT && CarInfo__jsx('div', {}, void 0, CarInfo__jsx(AdvertLeasingTitle_defaultExport, {
        id: id,
        views: count,
        title: title,
        seoTitle: seoTitle,
        prices: priceList,
        dateCreated: hotDate || datePublicated || dateCreated,
        clarifyPriceLink: clarifyPriceLink,
        isNegotiablePrice: isNegotiablePrice,
        advert: carInfo,
        leasingParams: leasingParams
      }), CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.infoBlock
      }, void 0, CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.divider
      })), warranty && warranty.title && CarInfo__jsx(Warranty_defaultExport, {
        warranty: warranty
      }), CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.flexRow
      }, void 0, CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.left
      }, void 0, CarInfo__jsx(AdvertInfo_defaultExport, {
        infoList: infoList,
        advert: carInfo
      })), CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.right
      }, void 0, CarInfo__jsx(__WEBPACK_IMPORTED_MODULE_16_desktop_components_AdvertPhotos_AdvertPhotos__["a" /* default */], {
        photos: isActive ? photos : [],
        defaultImg: defaultImage,
        alt: alt
      }), CarInfo__jsx(YoutubeVideo_defaultExport, {
        link: carInfo.video,
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.youtubeVideo
      }))), CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.infoBlock
      }, void 0, CarInfo__jsx(AdvertSellerComponent, {
        title: title,
        prices: priceList,
        advert: carInfo,
        advertID: id,
        agency: agency,
        avatar: agency ? agency.logo : '',
        authorName: contactName || authorName,
        authorID: author.id,
        location: sellerLocation,
        link: sellerLink,
        extraText: sellerExtraText,
        sold: sold,
        transport: transport,
        active: active,
        isApprovePub: isApprovePub
      }, id)), CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.infoBlock
      }, void 0, CarInfo__jsx(__WEBPACK_IMPORTED_MODULE_10_shared_components_AdvertDescription_AdvertDescription__["a" /* default */], {
        title: title,
        statuses: statuses,
        description: description,
        options: options,
        isDealer: isDealer,
        advert: carInfo
      }), isLeasing && leasingParams && leasingParams.monthlyPayment ? CarInfo__jsx(LeasingQuestions_defaultExport, {
        advert: carInfo,
        leasingParams: leasingParams
      }) : null), CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.infoBlock
      }, void 0, CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.divider
      })), CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.infoBlock
      }, void 0, CarInfo__jsx(AdvertOptions_defaultExport, {
        options: options,
        title: title
      }), videosAboutCar && videosAboutCar.length > 0 && CarInfo__jsx(VideoBlock_defaultExport, {
        maxMobileWidth: 380,
        columns: 2,
        handleShowVideo: this.handleShowVideo,
        news: videosAboutCar.slice(0, 2),
        title: intl.formatMessage({ id: 'Видео о модели' })
      }, void 0, videosAboutCar.length > 2 && CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.allVideos,
        onClick: function onClick() {
          return _this2.handleShowVideo();
        }
      }, void 0, CarInfo__ref2))), CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.infoBlock
      }, void 0, CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.divider
      })), CarInfo__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a.infoBlock
      }, void 0, CarInfo__jsx(AdvertMessage_defaultExport, {
        carInfo: carInfo,
        user: user,
        handleSendMessage: handleSendMessage
      }))), activeTab === TABS.TEST_DRIVES && CarInfo__jsx(TestDrives_defaultExport, {
        make: make.id || undefined,
        model: model.id || undefined,
        generation: modification.generation.id || undefined,
        year: year || undefined
      }));
    }
  }]);

  return CarInfo;
}(CarInfo___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CarInfo_CarInfo.defaultProps = {
  selVideoParams: null,
  style: null,
  count: null,
  spares: [],
  videosAboutCar: [],
  leasingParams: null
};


var CarInfo_mapDispatchToProps = {
  getSelVideo: __WEBPACK_IMPORTED_MODULE_9_shared_actions_journal__["a" /* getVideoById */]
};

var CarInfo_mapStateToProps = function mapStateToProps(state) {
  return {
    selVideoParams: state.globals.journal.selVideoParams
  };
};

/* harmony default export */ var CarInfo_defaultExport = (withTransportInfo_defaultExport(CarInfo___WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_28__CarInfo_css___default.a)(CarInfo___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](CarInfo_mapStateToProps, CarInfo_mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_21_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withDialogs__["a" /* default */](CarInfo_CarInfo))))));
// CONCATENATED MODULE: ./src/desktop/routes/advert/Advert.js
/* harmony import */ var Advert___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Advert___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Advert___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Advert___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Advert___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Advert___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Advert___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Advert___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Advert___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var Advert___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var Advert___WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var Advert___WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(Advert___WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withAdvert__ = __webpack_require__(2748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_components_JsonLdApplication_JsonLdApplication__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_components_LeasingOnlineBanner_LeasingOnlineBanner__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_components_LeasingOnlineBanner_CreditMarketBanner__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_desktop_components_InfoMessages_InfoMessages__ = __webpack_require__(2749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shared_components_IrrelevantMessage_IrrelevantMessage__ = __webpack_require__(2752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_desktop_components_AnotherCars_AnotherCars__ = __webpack_require__(2796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_shared_helpers_leasing_leasing__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Advert_css__ = __webpack_require__(3312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Advert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__Advert_css__);
var Advert__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Advert__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Advert__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Advert__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Advert__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Advert__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



































// eslint-disable-next-line css-modules/no-unused-class


var Advert__ref2 = Advert__jsx(SuccessBlock_defaultExport, {
  title: 'Ваше объявление активировано'
});

var Advert__ref3 = Advert__jsx(InfoBlock_defaultExport, {
  title: '\u042D\u0442\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E \u0438 \u043D\u0435 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u043F\u043E\u0438\u0441\u043A\u0435!'
});

var Advert__ref4 = Advert__jsx(SoldMessage_defaultExport, {});

var Advert__ref5 = Advert__jsx(__WEBPACK_IMPORTED_MODULE_24_shared_components_IrrelevantMessage_IrrelevantMessage__["a" /* default */], {
  title: '\u042D\u0442\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0436\u0435 \u043D\u0435\u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E'
});

var Advert__ref6 = Advert__jsx(__WEBPACK_IMPORTED_MODULE_14_shared_components_BannerAll__["b" /* DesktopButton */], {});

var Advert_Advert = function (_React$Component) {
  Advert__inherits(Advert, _React$Component);

  function Advert() {
    var _ref;

    var _temp, _this, _ret;

    Advert__classCallCheck(this, Advert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Advert__possibleConstructorReturn(this, (_ref = Advert.__proto__ || Object.getPrototypeOf(Advert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      nextItemLink: null
    }, _temp), Advert__possibleConstructorReturn(_this, _ret);
  }

  Advert__createClass(Advert, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var nextItemQueryString = this.props.nextItemQueryString;

      if (nextItemQueryString) fetch(__WEBPACK_IMPORTED_MODULE_9_shared_constants_api__["a" /* default */].ADVERT.ALL(nextItemQueryString)).then(function (r) {
        return r.json();
      }).then(function (r) {
        return r.results && r.results[0];
      }).then(function (advert) {
        if (advert) {
          _this2.setState({ nextItemLink: __WEBPACK_IMPORTED_MODULE_20_shared_helpers_urls__["g" /* generateUrl */](advert) });
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearIsApprovePub(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          userId = _props.userId,
          similarCars = _props.similarCars,
          agencyCars = _props.agencyCars,
          videosAboutCar = _props.videosAboutCar,
          bestOffers = _props.bestOffers,
          spares = _props.spares,
          count = _props.count,
          countToday = _props.countToday,
          advertInfo = _props.advertInfo,
          _props$advertInfo = _props.advertInfo,
          make = _props$advertInfo.make,
          model = _props$advertInfo.model,
          location = _props$advertInfo.location,
          power = _props$advertInfo.power,
          transport = _props$advertInfo.transport,
          powerUnit = _props$advertInfo.power_unit,
          title = _props$advertInfo.title,
          year = _props$advertInfo.year,
          activeKey = _props$advertInfo.active,
          _props$advertInfo$sol = _props$advertInfo.sold,
          sold = _props$advertInfo$sol === undefined ? false : _props$advertInfo$sol,
          isNew = _props$advertInfo.is_new,
          isNegotiablePrice = _props$advertInfo.is_negotiable_price,
          isShortView = _props.isShortView,
          intl = _props.intl,
          isApprovePub = _props.isApprovePub,
          leasingParams = _props.leasingParams;
      var nextItemLink = this.state.nextItemLink;


      var category = __WEBPACK_IMPORTED_MODULE_15_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('category', advertInfo);
      var searchData = {
        make: make,
        model: model,
        category: category,
        location: location,
        power: power,
        powerUnit: powerUnit,
        transport: transport,
        title: title,
        year: year,
        isNew: isNew,
        isNegotiablePrice: isNegotiablePrice
      };
      var microMarkingProductJson = __WEBPACK_IMPORTED_MODULE_13_shared_helpers_advert__["d" /* getProductMicroMarkingJson */](advertInfo);
      var microMarkingVehicleJson = __WEBPACK_IMPORTED_MODULE_13_shared_helpers_advert__["e" /* getVehicleMicroMarkingJson */](advertInfo);
      var deleted = activeKey === -2;
      var active = isApprovePub || !!activeKey;
      var isAuto = transport && transport.slug === 'avto';
      var carInfoFilter = __WEBPACK_IMPORTED_MODULE_15_shared_helpers_transportInfo__["r" /* getTransportInfoFiltered */](transport.slug);
      var sparesLink = '/' + __WEBPACK_IMPORTED_MODULE_20_shared_helpers_urls__["f" /* generateSparesSearchUrl */]({
        transport: transport,
        make: make,
        model: model
      });
      var isLeasing = __WEBPACK_IMPORTED_MODULE_28_shared_helpers_leasing_leasing__["a" /* isAnyLeasingAvailable */](advertInfo);
      var isCreditMarket = __WEBPACK_IMPORTED_MODULE_29_shared_helpers_leasing_myAuto__["g" /* isCreditmarketNotClearedProposalAvailable */](advertInfo) || __WEBPACK_IMPORTED_MODULE_29_shared_helpers_leasing_myAuto__["h" /* isCreditmarketProposalAvailable */](advertInfo);
      return Advert__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_33__Advert_css___default.a.page
      }, void 0, Advert__jsx(__WEBPACK_IMPORTED_MODULE_21_desktop_components_InfoMessages_InfoMessages__["a" /* default */], {
        countToday: countToday
      }), Advert__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_33__Advert_css___default.a.container
      }, void 0, Advert__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_33__Advert_css___default.a.flexRow
      }, void 0, Advert__jsx('div', {
        className: Advert___WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_33__Advert_css___default.a.mainCell)
      }, void 0, Advert__jsx(SearchBar_defaultExport, {
        searchData: searchData,
        nextItemLink: nextItemLink
      }), isApprovePub && Advert__ref2, (sold || deleted || !sold && !active) && Advert__jsx('div', {}, void 0, deleted && Advert__ref3, sold && !deleted && Advert__ref4, !sold && !active && !isApprovePub && Advert__ref5, agencyCars.length > 0 && Advert__jsx(__WEBPACK_IMPORTED_MODULE_26_desktop_components_AnotherCars_AnotherCars__["a" /* default */], {
        title: intl.formatMessage({ id: 'Объявления автосалона' }),
        cars: agencyCars
      }), similarCars.length > 0 && Advert__jsx(__WEBPACK_IMPORTED_MODULE_26_desktop_components_AnotherCars_AnotherCars__["a" /* default */], {
        title: intl.formatMessage({ id: 'Похожие объявления' }),
        cars: similarCars
      })), Advert__jsx(CarInfo_defaultExport, {
        carInfo: advertInfo,
        carInfoFilter: carInfoFilter,
        style: { order: sold || !active ? '1' : null },
        count: count,
        spares: spares,
        isShortView: isShortView,
        userId: userId,
        videosAboutCar: videosAboutCar,
        isApprovePub: isApprovePub,
        leasingParams: leasingParams
      }), Advert__ref6, !sold && !!active && Advert__jsx('div', {}, void 0, agencyCars.length > 0 && Advert__jsx(__WEBPACK_IMPORTED_MODULE_26_desktop_components_AnotherCars_AnotherCars__["a" /* default */], {
        title: intl.formatMessage({ id: 'Объявления автосалона' }),
        cars: agencyCars
      }), similarCars.length > 0 && Advert__jsx(__WEBPACK_IMPORTED_MODULE_26_desktop_components_AnotherCars_AnotherCars__["a" /* default */], {
        title: intl.formatMessage({ id: 'Похожие объявления' }),
        cars: similarCars
      }))), Advert___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_shared_components_JsonLdApplication_JsonLdApplication__["a" /* default */], microMarkingProductJson), Advert___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_shared_components_JsonLdApplication_JsonLdApplication__["a" /* default */], microMarkingVehicleJson), Advert__jsx(__WEBPACK_IMPORTED_MODULE_14_shared_components_BannerAll__["d" /* DesktopRightSidebar */], {
        fixedSecondBanner: true
      }, void 0, isLeasing && isCreditMarket && isAuto &&
      /* TODO: temporary CreditMarketBanner disabled */
      Advert__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_LeasingOnlineBanner_LeasingOnlineBanner__["a" /* default */], {
        advert: advertInfo,
        leasingParams: leasingParams
      }), isLeasing && !isCreditMarket && isAuto && leasingParams && advertInfo.is_new !== true && Advert__jsx(__WEBPACK_IMPORTED_MODULE_17_shared_components_LeasingOnlineBanner_LeasingOnlineBanner__["a" /* default */], {
        advert: advertInfo,
        leasingParams: leasingParams
      }), isLeasing && isAuto && advertInfo.is_new === true && Advert__jsx(LeasingUlfBanner_defaultExport, {
        eventPostfix: 'advertcard-sidebar',
        advert: advertInfo
      }), Advert__jsx(SpecialAdvertCars_defaultExport, {
        cars: bestOffers
      }), spares && spares.length > 0 && Advert__jsx(SparesForAdvert_defaultExport, {
        transport: transport,
        make: make,
        model: model,
        spares: spares,
        sparesLink: sparesLink
      })))));
    }
  }]);

  return Advert;
}(Advert___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Advert_Advert.defaultProps = {
  similarCars: [],
  agencyCars: [],
  videosAboutCar: [],
  spares: [],
  nextItemQueryString: null,
  count: null,
  countToday: null,
  userId: null,
  leasingParams: null
};


var Advert_mapStateToProps = function mapStateToProps(_ref7, _ref8) {
  var searchForm = _ref7.searchForm,
      isApprovePub = _ref7.globals.isApprovePub;
  var nextSearchItemIndex = _ref8.nextSearchItemIndex;
  return {
    nextItemQueryString: nextSearchItemIndex ? '?' + __WEBPACK_IMPORTED_MODULE_6_query_string___default.a.stringify(__WEBPACK_IMPORTED_MODULE_7_snakecase_keys___default.a(__WEBPACK_IMPORTED_MODULE_11_shared_helpers_common__["l" /* objectsToIDs */](Advert__extends({}, searchForm.selected, { page: nextSearchItemIndex, perPage: 1 })))) : null,
    isApprovePub: isApprovePub
  };
};

var Advert_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clearIsApprovePub: __WEBPACK_IMPORTED_MODULE_10_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_12_shared_actions_globals__["p" /* setIsApprovePub */], dispatch)
  };
};

/* harmony default export */ var Advert_defaultExport = (Advert___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_33__Advert_css___default.a)(__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withAdvert__["a" /* default */](Advert___WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */](Advert_mapStateToProps, Advert_mapDispatchToProps)(Advert_Advert)))));
// CONCATENATED MODULE: ./src/desktop/routes/advert/index.js
/* harmony import */ var advert___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var advert___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(advert___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snakecase_keys__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_snakecase_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_snakecase_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_seoDescriptions__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_seoTitles__ = __webpack_require__(1389);
/* harmony import */ var advert___WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_searchForm__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_actions_partsForm__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_adsAndMetrics__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Layout__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__constants_navigation__ = __webpack_require__(1248);
var advert__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var advert__slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var advert__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var action = function () {
  var _ref = advert__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
    var _this = this;

    var fetch, store, baseUrl, path, translate, params, query, stoRequest, stoUrl, id, _store$getState, nextSearchItemIndex, _store$getState$globa, language, isApprovePub, shortCarInfo, car, modification, make, model, year, location, capacityUnitId, capacity, transport, color, isNew, isCustomCleared, price, generation, characteristics, dateCreated, datePublicated, hotDate, dealer, videosAboutCarParams, hasMakeAndModel, _videosAboutCarParams, category, engine, gearbox, drive, body, capacityAlt, agencyId, vipParam, makeVipParams, dealerVipParams, dealerMakeVipParams, _map, _map2, vipParamsRequest, makeVipParamsRequest, dealerVipParamsRequest, dealerMakeVipParamsRequest, advertTopCars, _advertTopCars$dealer, storeDealerSpecialMakeVipCars, _advertTopCars$dealer2, storeDealerSpecialVipCars, _advertTopCars$makeVi, storeSpecialMakeVipCars, _advertTopCars$vipPar, storeSpecialVipCars, _ref4, _ref5, specialDealerMakeVipCars, specialDealerVipCars, specialMakeVipCars, specialVipCars, spares, agencyCars, similarCars, videosAboutCar, bestOffersCars, bestOffers, mileage, capacityUnit, transportSeoName, title, description, slug, url, seoQuery, contextPrice, targetingArguments, ogImage, queryObj, leasingParams;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            fetch = data.fetch, store = data.store, baseUrl = data.baseUrl, path = data.path, translate = data.translate, params = data.params, query = data.query;
            stoRequest = {};
            stoUrl = __WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].KATALOG_KOMPANIY_STO;
            id = params.id.match(/(-[0-9]-)([0-9])+(-[0-9].html)/g);

            if (id) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt('return', null);

          case 6:
            id = id[0].split('-')[2];

            _store$getState = store.getState(), nextSearchItemIndex = _store$getState.history.nextSearchItemIndex, _store$getState$globa = _store$getState.globals, language = _store$getState$globa.locale, isApprovePub = _store$getState$globa.isApprovePub;

            if (!(query.key && !isApprovePub)) {
              _context3.next = 13;
              break;
            }

            _context3.next = 11;
            return fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].ADVERT.APPROVE_PUB(id, query.key)).then(function () {
              var _ref2 = advert__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!response.ok) {
                          _context.next = 3;
                          break;
                        }

                        _context.next = 3;
                        return store.dispatch(advert___WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["p" /* setIsApprovePub */](true));

                      case 3:
                        return _context.abrupt('return', response.json());

                      case 4:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());

          case 11:
            _context3.next = 16;
            break;

          case 13:
            if (!(!query.key && isApprovePub)) {
              _context3.next = 16;
              break;
            }

            _context3.next = 16;
            return store.dispatch(advert___WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["p" /* setIsApprovePub */](false));

          case 16:
            shortCarInfo = getAdvertFromStoreById(parseInt(id, 10), store);
            _context3.next = 19;
            return shortCarInfo || fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].ADVERT.ITEM(id)).then(function () {
              var _ref3 = advert__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(response) {
                var err;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!response.ok) {
                          _context2.next = 2;
                          break;
                        }

                        return _context2.abrupt('return', response.json());

                      case 2:
                        if (!(response.status === 404)) {
                          _context2.next = 12;
                          break;
                        }

                        _context2.next = 5;
                        return response.json();

                      case 5:
                        _context2.t0 = _context2.sent;

                        if (_context2.t0) {
                          _context2.next = 8;
                          break;
                        }

                        _context2.t0 = {};

                      case 8:
                        err = _context2.t0;

                        if (!(err && err.transport && err.transport.slug)) {
                          _context2.next = 11;
                          break;
                        }

                        return _context2.abrupt('return', { redirect: '/' + err.transport.slug });

                      case 11:
                        return _context2.abrupt('return', err);

                      case 12:
                        return _context2.abrupt('return', {});

                      case 13:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, _this);
              }));

              return function (_x3) {
                return _ref3.apply(this, arguments);
              };
            }());

          case 19:
            car = _context3.sent;

            if (!car.redirect) {
              _context3.next = 22;
              break;
            }

            return _context3.abrupt('return', {
              status: 301,
              redirect: car.redirect
            });

          case 22:
            if (!car.blocked) {
              _context3.next = 26;
              break;
            }

            if (!(car.category && car.category.slug)) {
              _context3.next = 25;
              break;
            }

            return _context3.abrupt('return', {
              status: 301,
              redirect: '/' + car.category.slug
            });

          case 25:
            return _context3.abrupt('return', {
              status: 301,
              redirect: '/avto'
            });

          case 26:
            if (car && car.id) {
              _context3.next = 28;
              break;
            }

            return _context3.abrupt('return', null);

          case 28:
            modification = car.modification, make = car.make, model = car.model, year = car.year, location = car.location, capacityUnitId = car.capacity_unit, capacity = car.capacity, transport = car.transport, color = car.color, isNew = car.is_new, isCustomCleared = car.is_not_cleared, price = car.price, generation = car.generation, characteristics = car.characteristics, dateCreated = car.date_created, datePublicated = car.date_publicated, hotDate = car.hot_date;


            if (!car.agency) car.agency = {};
            dealer = car.agency;
            videosAboutCarParams = null;
            hasMakeAndModel = make && make.id && model && !!model.id;

            if (hasMakeAndModel) {
              videosAboutCarParams = (_videosAboutCarParams = {
                rubric: 'video',
                make: make.id,
                model: model.id
              }, advert__defineProperty(_videosAboutCarParams, year && 'year', year && year.id), advert__defineProperty(_videosAboutCarParams, generation && 'generation', generation && generation.id), advert__defineProperty(_videosAboutCarParams, 'showInAdvert', 1), advert__defineProperty(_videosAboutCarParams, 'language', language), _videosAboutCarParams);
            }

            category = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('category', car);
            engine = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('engine', car);
            gearbox = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('gearbox', car);
            drive = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('drive', car);
            body = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('body', car);
            capacityAlt = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('capacity', car);
            agencyId = dealer.id;
            vipParam = advert__extends({
              is_top: 1
            }, transport && transport.id ? { transport: transport.id } : {});
            makeVipParams = advert__extends({}, vipParam, make && make.id ? { make: make.id } : {});
            dealerVipParams = advert__extends({}, vipParam, agencyId ? { dealer: agencyId } : {});
            dealerMakeVipParams = advert__extends({}, makeVipParams, agencyId ? { dealer: agencyId } : {});
            _map = [vipParam, makeVipParams, dealerVipParams, dealerMakeVipParams].map(function (item) {
              return '?' + __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(item);
            }), _map2 = advert__slicedToArray(_map, 4), vipParamsRequest = _map2[0], makeVipParamsRequest = _map2[1], dealerVipParamsRequest = _map2[2], dealerMakeVipParamsRequest = _map2[3];
            advertTopCars = store.getState().advertTopCars || {};
            _advertTopCars$dealer = advertTopCars[dealerMakeVipParamsRequest], storeDealerSpecialMakeVipCars = _advertTopCars$dealer === undefined ? null : _advertTopCars$dealer, _advertTopCars$dealer2 = advertTopCars[dealerVipParamsRequest], storeDealerSpecialVipCars = _advertTopCars$dealer2 === undefined ? null : _advertTopCars$dealer2, _advertTopCars$makeVi = advertTopCars[makeVipParamsRequest], storeSpecialMakeVipCars = _advertTopCars$makeVi === undefined ? null : _advertTopCars$makeVi, _advertTopCars$vipPar = advertTopCars[vipParamsRequest], storeSpecialVipCars = _advertTopCars$vipPar === undefined ? null : _advertTopCars$vipPar;
            _context3.next = 50;
            return Promise.all([agencyId ? storeDealerSpecialMakeVipCars || fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].ADVERT.ALL(dealerMakeVipParamsRequest)).then(function (r) {
              return r.json();
            }) : [], agencyId ? storeDealerSpecialVipCars || fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].ADVERT.ALL(dealerVipParamsRequest)).then(function (r) {
              return r.json();
            }) : [], storeSpecialMakeVipCars || fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].ADVERT.ALL(makeVipParamsRequest)).then(function (r) {
              return r.json();
            }), storeSpecialVipCars || fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].ADVERT.ALL(vipParamsRequest)).then(function (r) {
              return r.json();
            }),
            // spares
            hasMakeAndModel ? fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].SPARE_PARTS.ALL('?' + __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(__WEBPACK_IMPORTED_MODULE_1_snakecase_keys___default.a({ make: make.id, photos: 1, model: model.id, perPage: 4 })))).then(function (r) {
              return r.json();
            }).then(function (r) {
              return r.results && r.results.length ? r.results : [];
            }) : [],
            // agencyCars
            agencyId ? fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].ADVERT.ALL('?dealer=' + agencyId + '&transport=' + car.transport.id)).then(function (r) {
              return r.json();
            }).then(function (response) {
              return response.results;
            }) : [],
            // similarCars
            fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].ADVERT.SIMILAR(id, similarities)).then(function (r) {
              return r.json();
            }).catch(function () {}),
            // videosAboutCar
            hasMakeAndModel ? fetch(__WEBPACK_IMPORTED_MODULE_3_shared_constants_api__["a" /* default */].JOURNAL.LIST(videosAboutCarParams)).then(function (r) {
              return r.json();
            }) : []]);

          case 50:
            _ref4 = _context3.sent;
            _ref5 = advert__slicedToArray(_ref4, 8);
            specialDealerMakeVipCars = _ref5[0];
            specialDealerVipCars = _ref5[1];
            specialMakeVipCars = _ref5[2];
            specialVipCars = _ref5[3];
            spares = _ref5[4];
            agencyCars = _ref5[5];
            similarCars = _ref5[6];
            videosAboutCar = _ref5[7];


            if (typeof window !== 'undefined') {
              if (!storeDealerSpecialMakeVipCars && specialDealerMakeVipCars) {
                store.dispatch(setAdvertTopCars(advert__defineProperty({}, dealerMakeVipParamsRequest, specialDealerMakeVipCars)));
              }

              if (!storeDealerSpecialVipCars && specialDealerVipCars) {
                store.dispatch(setAdvertTopCars(advert__defineProperty({}, dealerVipParamsRequest, specialDealerVipCars)));
              }

              if (!storeSpecialMakeVipCars && specialMakeVipCars) {
                store.dispatch(setAdvertTopCars(advert__defineProperty({}, makeVipParamsRequest, specialMakeVipCars)));
              }

              if (!storeSpecialVipCars && specialVipCars) {
                store.dispatch(setAdvertTopCars(advert__defineProperty({}, vipParamsRequest, specialVipCars)));
              }
            }

            bestOffersCars = [].concat(_toConsumableArray(specialDealerMakeVipCars), _toConsumableArray(specialDealerVipCars), _toConsumableArray(specialMakeVipCars), _toConsumableArray(specialVipCars));
            bestOffers = bestOffersCars.filter(function (item) {
              return item.id !== parseFloat(id);
            }).slice(0, 20).map(function (offerCar) {
              return {
                link: __WEBPACK_IMPORTED_MODULE_15_shared_helpers_urls__["g" /* generateUrl */](offerCar),
                id: offerCar.id,
                title: offerCar.title ? offerCar.title : (offerCar.make && offerCar.make.title ? offerCar.make.title : '') + ' ' + (offerCar.model && offerCar.model.title ? offerCar.model.title : ''),
                year: offerCar.year,
                images: offerCar.photos.length > 0 ? offerCar.photos : [],
                price: __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["o" /* getPriceWithCurrency */](offerCar.price, REQUIRED_CURRENCY),
                mileage: __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["k" /* getMileageString */](offerCar.mileage, offerCar.mileage_unit),
                isNew: offerCar.is_new,
                isNegotiablePrice: offerCar.is_negotiable_price,
                fullData: offerCar
              };
            });
            mileage = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["k" /* getMileageString */](car.mileage, car.mileage_unit);
            capacityUnit = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["h" /* getCapacityUnitTitleById */](capacityUnitId);
            transportSeoName = translate('авто');

            if (transport && transport.title && transport.id !== 1) {
              transportSeoName = transport.title;
            }

            title = __WEBPACK_IMPORTED_MODULE_5_shared_constants_seoTitles__["a" /* default */].ADVERT({
              id: id,

              make: make,
              model: model,
              modification: modification,
              location: location,
              year: year,
              price: __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["o" /* getPriceWithCurrency */](car.price, REQUIRED_CURRENCY),
              mileage: mileage,
              dealer: dealer,
              isNew: isNew
            }, transportSeoName, translate);
            description = __WEBPACK_IMPORTED_MODULE_4_shared_constants_seoDescriptions__["a" /* default */].ADVERT({
              id: id,

              dealer: dealer,
              isNew: isNew,
              dateCreated: dateCreated,
              datePublicated: datePublicated,
              hotDate: hotDate,
              body: body,
              drive: drive,
              modification: modification,
              price: __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["o" /* getPriceWithCurrency */](car.price, REQUIRED_CURRENCY),
              location: location,
              make: make,
              model: model,
              category: category,
              year: year,
              mileage: mileage,
              capacity: capacity,
              capacityUnit: capacityUnit,
              engine: engine,
              gearbox: gearbox,
              color: color,
              capacityAlt: capacityAlt,
              transport: transport,
              characteristics: characteristics
            }, transportSeoName, translate);
            slug = 'avto';

            if (transport && transport.slug && __WEBPACK_IMPORTED_MODULE_20__constants_navigation__["a" /* default */].SEARCH[transport.slug]) {
              slug = transport.slug;
            } else if (transport && transport.parents && transport.parents.length) {
              slug = transport.parents[0].slug;
            } else if (transport && transport.slug) {
              slug = transport.slug;
            }

            url = __WEBPACK_IMPORTED_MODULE_17_shared_helpers_locale__["e" /* removeLocaleFromHref */]((baseUrl + '/' + slug).replace('//', '/'));
            _context3.next = 74;
            return store.dispatch(advert___WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["i" /* seoRequest */]('' + url));

          case 74:
            seoQuery = _context3.sent;

            store.dispatch(advert___WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["A" /* setSeoSearchUrl */](advert__extends({}, seoQuery, { url: url })));

            contextPrice = Array.isArray(price) && price.filter(function (a) {
              return a.currency === 'uah';
            })[0] || {};
            targetingArguments = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_adsAndMetrics__["a" /* getAdsContext */]({
              transport: transport,
              make: make,
              model: model,
              category: category,
              isNew: isNew,
              engine: engine,
              location: location,
              isCustomCleared: typeof isCustomCleared === 'boolean' ? !isCustomCleared : undefined,
              dealer: dealer,
              id: id,
              isCountry: __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["s" /* isLocationCountry */](location),
              price: __WEBPACK_IMPORTED_MODULE_14_shared_helpers_adsAndMetrics__["b" /* getPriceValuation */]({ from: contextPrice.value }, contextPrice.currency)
            });

            store.dispatch(advert___WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["C" /* setTargetingArguments */](targetingArguments));
            ogImage = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_transportInfo__["e" /* getAdvertOgImage */](car);

            store.dispatch(advert___WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */](__WEBPACK_IMPORTED_MODULE_8_shared_modules__["p" /* stateDataLayer */].manipulation({ data: car, pagetype: 'offerdetail' })));
            if (location) {
              stoRequest.location = location.id;
              stoUrl = '' + stoUrl + location.slug;
            }
            if (make) {
              stoRequest.makes = make.id;
            }
            /* Autobooking data */
            queryObj = advert__extends({}, stoRequest, {
              per_page: 1,
              top_services: 2,
              shuffle: 1
            });
            _context3.next = 86;
            return store.dispatch(__WEBPACK_IMPORTED_MODULE_13_shared_actions_partsForm__["a" /* hrefSet */]({
              query: queryObj,
              url: stoUrl
            }));

          case 86:
            if (!hasMakeAndModel) {
              _context3.next = 89;
              break;
            }

            _context3.next = 89;
            return store.dispatch(__WEBPACK_IMPORTED_MODULE_10_shared_actions_searchForm__["l" /* resultsThunks */].searchFirmsResults(queryObj, { name: 'topFirms', topMakesFilter: false }));

          case 89:
            leasingParams = null;

            if (!__WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_myAuto__["i" /* isLeasingProposalAvailable */](car)) {
              _context3.next = 95;
              break;
            }

            _context3.next = 93;
            return __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_myAuto__["e" /* getFinupVerification */](advert__extends({}, car, { url: baseUrl + '/' + path }), fetch);

          case 93:
            leasingParams = _context3.sent;

            store.dispatch(advert___WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */](__WEBPACK_IMPORTED_MODULE_16_shared_constants_gtmEvents__["a" /* EVENTS */].leasing['page-view']));

          case 95:
            return _context3.abrupt('return', {
              chunks: ['advert'],
              title: title,
              ogImage: ogImage,
              description: description,
              routeName: 'advert',
              type: 'advert',
              shouldSetNoIndex: false,
              shouldSetIndex: true,
              component: advert__jsx(__WEBPACK_IMPORTED_MODULE_19__components_Layout__["a" /* default */], {
                withBranding: true,
                navLinks: __WEBPACK_IMPORTED_MODULE_20__constants_navigation__["a" /* default */].SEARCH[slug],
                currentRoute: '/' + slug
              }, void 0, advert__jsx(Advert_defaultExport, {
                advertInfo: car,
                isShortView: !!shortCarInfo,
                similarCars: similarCars && similarCars.results && similarCars.results.slice(0, 20),
                bestOffers: bestOffers,
                agencyCars: agencyCars,
                videosAboutCar: videosAboutCar && videosAboutCar.results,
                spares: spares,
                nextSearchItemIndex: nextSearchItemIndex,
                leasingParams: leasingParams,
                isApprovePub: isApprovePub
              }, car.id))
            });

          case 96:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function advert__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function advert__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
























// import { createdDate } from 'shared/helpers/moment';

var REQUIRED_CURRENCY = 'uah';
var similarities = ['transport', 'is_new', 'price', 'category'].join(',');

/* harmony default export */ __webpack_exports__["default"] = (action);

/***/ })

});


// WEBPACK FOOTER //
// 32-advert-2b30f1d1.chunk.js